/* eslint-disable */
/*************************************************************
 * This file is auto-generated by scripts/generate-schema.ts *
 * DO NOT EDIT THIS FILE DIRECTLY                            *
 *************************************************************/

import { z } from "zod";
import { Instant, LocalDate, LocalDateTime, LocalTime } from "@js-joda/core";


export const AdministrativePaymentRateId = z.number().brand('AdministrativePaymentRateId')
export type AdministrativePaymentRateId = number & z.BRAND<"AdministrativePaymentRateId">

export const AdministrativePaymentRateTierId = z.number().brand('AdministrativePaymentRateTierId')
export type AdministrativePaymentRateTierId = number & z.BRAND<"AdministrativePaymentRateTierId">

export const AgencyBranchId = z.number().brand('AgencyBranchId')
export type AgencyBranchId = number & z.BRAND<"AgencyBranchId">

export const AgencyCustomFieldId = z.number().brand('AgencyCustomFieldId')
export type AgencyCustomFieldId = number & z.BRAND<"AgencyCustomFieldId">

export const AgencyId = z.number().brand('AgencyId')
export type AgencyId = number & z.BRAND<"AgencyId">

export const AgencyMemberId = z.number().brand('AgencyMemberId')
export type AgencyMemberId = number & z.BRAND<"AgencyMemberId">

export const AgencyMemberLicenseId = z.number().brand('AgencyMemberLicenseId')
export type AgencyMemberLicenseId = number & z.BRAND<"AgencyMemberLicenseId">

export const AgencyMemberNotesMentionId = z.number().brand('AgencyMemberNotesMentionId')
export type AgencyMemberNotesMentionId = number & z.BRAND<"AgencyMemberNotesMentionId">

export const AgencyPhonebookContactId = z.number().brand('AgencyPhonebookContactId')
export type AgencyPhonebookContactId = number & z.BRAND<"AgencyPhonebookContactId">

export const AgencyRoleId = z.number().brand('AgencyRoleId')
export type AgencyRoleId = number & z.BRAND<"AgencyRoleId">

export const AgencyTeamId = z.number().brand('AgencyTeamId')
export type AgencyTeamId = number & z.BRAND<"AgencyTeamId">

export const AiWeeklyTemplateSuggestionId = z.number().brand('AiWeeklyTemplateSuggestionId')
export type AiWeeklyTemplateSuggestionId = number & z.BRAND<"AiWeeklyTemplateSuggestionId">

export const AllergyId = z.number().brand('AllergyId')
export type AllergyId = number & z.BRAND<"AllergyId">

export const AuthorizationId = z.number().brand('AuthorizationId')
export type AuthorizationId = number & z.BRAND<"AuthorizationId">

export const BillingRateCountyId = z.number().brand('BillingRateCountyId')
export type BillingRateCountyId = number & z.BRAND<"BillingRateCountyId">

export const CallSessionNotIdentifiedCallerCalleeId = z.number().brand('CallSessionNotIdentifiedCallerCalleeId')
export type CallSessionNotIdentifiedCallerCalleeId = number & z.BRAND<"CallSessionNotIdentifiedCallerCalleeId">

export const CaregiverAbsenceId = z.number().brand('CaregiverAbsenceId')
export type CaregiverAbsenceId = number & z.BRAND<"CaregiverAbsenceId">

export const CaregiverClusterEngagementId = z.number().brand('CaregiverClusterEngagementId')
export type CaregiverClusterEngagementId = number & z.BRAND<"CaregiverClusterEngagementId">

export const CaregiverComplianceInstanceId = z.number().brand('CaregiverComplianceInstanceId')
export type CaregiverComplianceInstanceId = number & z.BRAND<"CaregiverComplianceInstanceId">

export const CaregiverDocumentTypeAgencySettingId = z.number().brand('CaregiverDocumentTypeAgencySettingId')
export type CaregiverDocumentTypeAgencySettingId = number & z.BRAND<"CaregiverDocumentTypeAgencySettingId">

export const CaregiverDocumentTypeId = z.number().brand('CaregiverDocumentTypeId')
export type CaregiverDocumentTypeId = number & z.BRAND<"CaregiverDocumentTypeId">

export const CaregiverDocumentUploadId = z.number().brand('CaregiverDocumentUploadId')
export type CaregiverDocumentUploadId = number & z.BRAND<"CaregiverDocumentUploadId">

export const CaregiverExclusionId = z.number().brand('CaregiverExclusionId')
export type CaregiverExclusionId = number & z.BRAND<"CaregiverExclusionId">

export const CaregiverFBABenefitsTransactionId = z.number().brand('CaregiverFBABenefitsTransactionId')
export type CaregiverFBABenefitsTransactionId = number & z.BRAND<"CaregiverFBABenefitsTransactionId">

export const CaregiverId = z.number().brand('CaregiverId')
export type CaregiverId = number & z.BRAND<"CaregiverId">

export const CaregiverNotificationId = z.number().brand('CaregiverNotificationId')
export type CaregiverNotificationId = number & z.BRAND<"CaregiverNotificationId">

export const CaregiverPatientDocumentUploadsId = z.number().brand('CaregiverPatientDocumentUploadsId')
export type CaregiverPatientDocumentUploadsId = number & z.BRAND<"CaregiverPatientDocumentUploadsId">

export const CaregiverPayRateId = z.number().brand('CaregiverPayRateId')
export type CaregiverPayRateId = number & z.BRAND<"CaregiverPayRateId">

export const CaregiverPtoInstanceId = z.number().brand('CaregiverPtoInstanceId')
export type CaregiverPtoInstanceId = number & z.BRAND<"CaregiverPtoInstanceId">

export const CaregiverPtoLabelId = z.number().brand('CaregiverPtoLabelId')
export type CaregiverPtoLabelId = number & z.BRAND<"CaregiverPtoLabelId">

export const CaregiverStatusHistoryId = z.number().brand('CaregiverStatusHistoryId')
export type CaregiverStatusHistoryId = number & z.BRAND<"CaregiverStatusHistoryId">

export const CaregiverSuppliesShipmentId = z.number().brand('CaregiverSuppliesShipmentId')
export type CaregiverSuppliesShipmentId = number & z.BRAND<"CaregiverSuppliesShipmentId">

export const CareMomentsAdjustmentId = z.number().brand('CareMomentsAdjustmentId')
export type CareMomentsAdjustmentId = number & z.BRAND<"CareMomentsAdjustmentId">

export const CareMomentsRankId = z.number().brand('CareMomentsRankId')
export type CareMomentsRankId = number & z.BRAND<"CareMomentsRankId">

export const CertificationBroadcastSettingsId = z.number().brand('CertificationBroadcastSettingsId')
export type CertificationBroadcastSettingsId = number & z.BRAND<"CertificationBroadcastSettingsId">

export const CertificationPeriodId = z.number().brand('CertificationPeriodId')
export type CertificationPeriodId = number & z.BRAND<"CertificationPeriodId">

export const ChatRoomId = z.number().brand('ChatRoomId')
export type ChatRoomId = number & z.BRAND<"ChatRoomId">

export const CheckId = z.number().brand('CheckId')
export type CheckId = number & z.BRAND<"CheckId">

export const CheckLineId = z.number().brand('CheckLineId')
export type CheckLineId = number & z.BRAND<"CheckLineId">

export const CheckUnappliedLineId = z.number().brand('CheckUnappliedLineId')
export type CheckUnappliedLineId = number & z.BRAND<"CheckUnappliedLineId">

export const CityTaxCodeId = z.number().brand('CityTaxCodeId')
export type CityTaxCodeId = number & z.BRAND<"CityTaxCodeId">

export const ClockinClockoutRecordId = z.number().brand('ClockinClockoutRecordId')
export type ClockinClockoutRecordId = number & z.BRAND<"ClockinClockoutRecordId">

export const ClockinClockoutRecordIvrId = z.string().brand('ClockinClockoutRecordIvrId')
export type ClockinClockoutRecordIvrId = string & z.BRAND<"ClockinClockoutRecordIvrId">

export const ClusterId = z.number().brand('ClusterId')
export type ClusterId = number & z.BRAND<"ClusterId">

export const CommCenterEmailMessageAttachmentId = z.number().brand('CommCenterEmailMessageAttachmentId')
export type CommCenterEmailMessageAttachmentId = number & z.BRAND<"CommCenterEmailMessageAttachmentId">

export const CommCenterEmailMessageId = z.number().brand('CommCenterEmailMessageId')
export type CommCenterEmailMessageId = number & z.BRAND<"CommCenterEmailMessageId">

export const CommCenterEmailThreadId = z.number().brand('CommCenterEmailThreadId')
export type CommCenterEmailThreadId = number & z.BRAND<"CommCenterEmailThreadId">

export const CommCenterLabelId = z.number().brand('CommCenterLabelId')
export type CommCenterLabelId = number & z.BRAND<"CommCenterLabelId">

export const CommCenterMessageActionId = z.number().brand('CommCenterMessageActionId')
export type CommCenterMessageActionId = number & z.BRAND<"CommCenterMessageActionId">

export const CommCenterMessageId = z.number().brand('CommCenterMessageId')
export type CommCenterMessageId = number & z.BRAND<"CommCenterMessageId">

export const CommCenterTeamId = z.number().brand('CommCenterTeamId')
export type CommCenterTeamId = number & z.BRAND<"CommCenterTeamId">

export const CommCenterTeamMemberId = z.number().brand('CommCenterTeamMemberId')
export type CommCenterTeamMemberId = number & z.BRAND<"CommCenterTeamMemberId">

export const CommCenterTicketAssignChangeId = z.number().brand('CommCenterTicketAssignChangeId')
export type CommCenterTicketAssignChangeId = number & z.BRAND<"CommCenterTicketAssignChangeId">

export const CommCenterTicketId = z.number().brand('CommCenterTicketId')
export type CommCenterTicketId = number & z.BRAND<"CommCenterTicketId">

export const CommCenterTicketStatusChangeId = z.number().brand('CommCenterTicketStatusChangeId')
export type CommCenterTicketStatusChangeId = number & z.BRAND<"CommCenterTicketStatusChangeId">

export const ComplianceFormDocumentId = z.number().brand('ComplianceFormDocumentId')
export type ComplianceFormDocumentId = number & z.BRAND<"ComplianceFormDocumentId">

export const ComplianceFormQuestionId = z.number().brand('ComplianceFormQuestionId')
export type ComplianceFormQuestionId = number & z.BRAND<"ComplianceFormQuestionId">

export const ComplianceFormQuestionOptionId = z.number().brand('ComplianceFormQuestionOptionId')
export type ComplianceFormQuestionOptionId = number & z.BRAND<"ComplianceFormQuestionOptionId">

export const ComplianceReviewApprovalConditionId = z.number().brand('ComplianceReviewApprovalConditionId')
export type ComplianceReviewApprovalConditionId = number & z.BRAND<"ComplianceReviewApprovalConditionId">

export const ComplianceReviewDocumentId = z.number().brand('ComplianceReviewDocumentId')
export type ComplianceReviewDocumentId = number & z.BRAND<"ComplianceReviewDocumentId">

export const ComplianceReviewQuestionId = z.number().brand('ComplianceReviewQuestionId')
export type ComplianceReviewQuestionId = number & z.BRAND<"ComplianceReviewQuestionId">

export const ComplianceReviewQuestionOptionId = z.number().brand('ComplianceReviewQuestionOptionId')
export type ComplianceReviewQuestionOptionId = number & z.BRAND<"ComplianceReviewQuestionOptionId">

export const ComplianceReviewRecordId = z.number().brand('ComplianceReviewRecordId')
export type ComplianceReviewRecordId = number & z.BRAND<"ComplianceReviewRecordId">

export const ComplianceReviewRejectReasonId = z.number().brand('ComplianceReviewRejectReasonId')
export type ComplianceReviewRejectReasonId = number & z.BRAND<"ComplianceReviewRejectReasonId">

export const ComplianceV2ItemFieldId = z.number().brand('ComplianceV2ItemFieldId')
export type ComplianceV2ItemFieldId = number & z.BRAND<"ComplianceV2ItemFieldId">

export const ComplianceV2ItemFieldPossibleValueId = z.number().brand('ComplianceV2ItemFieldPossibleValueId')
export type ComplianceV2ItemFieldPossibleValueId = number & z.BRAND<"ComplianceV2ItemFieldPossibleValueId">

export const ContractTypeId = z.number().brand('ContractTypeId')
export type ContractTypeId = number & z.BRAND<"ContractTypeId">

export const DutySheetId = z.number().brand('DutySheetId')
export type DutySheetId = number & z.BRAND<"DutySheetId">

export const EntityChangeEventId = z.number().brand('EntityChangeEventId')
export type EntityChangeEventId = number & z.BRAND<"EntityChangeEventId">

export const EntityNoteSettingId = z.number().brand('EntityNoteSettingId')
export type EntityNoteSettingId = number & z.BRAND<"EntityNoteSettingId">

export const EvvDevHelpRequestId = z.number().brand('EvvDevHelpRequestId')
export type EvvDevHelpRequestId = number & z.BRAND<"EvvDevHelpRequestId">

export const ExportBatchId = z.number().brand('ExportBatchId')
export type ExportBatchId = number & z.BRAND<"ExportBatchId">

export const ExportVisitId = z.number().brand('ExportVisitId')
export type ExportVisitId = number & z.BRAND<"ExportVisitId">

export const ExternalPatientServicePlanId = z.number().brand('ExternalPatientServicePlanId')
export type ExternalPatientServicePlanId = number & z.BRAND<"ExternalPatientServicePlanId">

export const FaxDetailsId = z.number().brand('FaxDetailsId')
export type FaxDetailsId = number & z.BRAND<"FaxDetailsId">

export const HHAIntegrationBillingFileRecordId = z.number().brand('HHAIntegrationBillingFileRecordId')
export type HHAIntegrationBillingFileRecordId = number & z.BRAND<"HHAIntegrationBillingFileRecordId">

export const HHAIntegrationImportedFileId = z.number().brand('HHAIntegrationImportedFileId')
export type HHAIntegrationImportedFileId = number & z.BRAND<"HHAIntegrationImportedFileId">

export const HHAIntegrationNonBillingFileRecordId = z.number().brand('HHAIntegrationNonBillingFileRecordId')
export type HHAIntegrationNonBillingFileRecordId = number & z.BRAND<"HHAIntegrationNonBillingFileRecordId">

export const HHAXPocItemId = z.number().brand('HHAXPocItemId')
export type HHAXPocItemId = number & z.BRAND<"HHAXPocItemId">

export const HRQuestionGroupId = z.number().brand('HRQuestionGroupId')
export type HRQuestionGroupId = number & z.BRAND<"HRQuestionGroupId">

export const HRQuestionId = z.number().brand('HRQuestionId')
export type HRQuestionId = number & z.BRAND<"HRQuestionId">

export const HRQuestionTemplateId = z.string().brand('HRQuestionTemplateId')
export type HRQuestionTemplateId = string & z.BRAND<"HRQuestionTemplateId">

export const HRSectionId = z.number().brand('HRSectionId')
export type HRSectionId = number & z.BRAND<"HRSectionId">

export const HRSectionStageId = z.number().brand('HRSectionStageId')
export type HRSectionStageId = number & z.BRAND<"HRSectionStageId">

export const HRSubSectionId = z.number().brand('HRSubSectionId')
export type HRSubSectionId = number & z.BRAND<"HRSubSectionId">

export const ICD10CodeId = z.number().brand('ICD10CodeId')
export type ICD10CodeId = number & z.BRAND<"ICD10CodeId">

export const ICD9CodeId = z.number().brand('ICD9CodeId')
export type ICD9CodeId = number & z.BRAND<"ICD9CodeId">

export const ImportedVisitId = z.number().brand('ImportedVisitId')
export type ImportedVisitId = number & z.BRAND<"ImportedVisitId">

export const InstaPayBankAccountTypeId = z.number().brand('InstaPayBankAccountTypeId')
export type InstaPayBankAccountTypeId = number & z.BRAND<"InstaPayBankAccountTypeId">

export const InstaPayBankId = z.number().brand('InstaPayBankId')
export type InstaPayBankId = number & z.BRAND<"InstaPayBankId">

export const InsurerId = z.number().brand('InsurerId')
export type InsurerId = number & z.BRAND<"InsurerId">

export const IntakeChecklistItemId = z.number().brand('IntakeChecklistItemId')
export type IntakeChecklistItemId = number & z.BRAND<"IntakeChecklistItemId">

export const IntakeExternalFlowId = z.string().brand('IntakeExternalFlowId')
export type IntakeExternalFlowId = string & z.BRAND<"IntakeExternalFlowId">

export const IntakeStatusId = z.number().brand('IntakeStatusId')
export type IntakeStatusId = number & z.BRAND<"IntakeStatusId">

export const IntakeTeamId = z.number().brand('IntakeTeamId')
export type IntakeTeamId = number & z.BRAND<"IntakeTeamId">

export const IntakeTrackId = z.number().brand('IntakeTrackId')
export type IntakeTrackId = number & z.BRAND<"IntakeTrackId">

export const IntakeTrackNoteId = z.number().brand('IntakeTrackNoteId')
export type IntakeTrackNoteId = number & z.BRAND<"IntakeTrackNoteId">

export const IntakeTrackStepFieldId = z.number().brand('IntakeTrackStepFieldId')
export type IntakeTrackStepFieldId = number & z.BRAND<"IntakeTrackStepFieldId">

export const IntakeTrackStepFieldValueId = z.number().brand('IntakeTrackStepFieldValueId')
export type IntakeTrackStepFieldValueId = number & z.BRAND<"IntakeTrackStepFieldValueId">

export const IntakeTrackStepId = z.number().brand('IntakeTrackStepId')
export type IntakeTrackStepId = number & z.BRAND<"IntakeTrackStepId">

export const IntegrationPayerId = z.number().brand('IntegrationPayerId')
export type IntegrationPayerId = number & z.BRAND<"IntegrationPayerId">

export const InvoiceAdministrativePaymentId = z.number().brand('InvoiceAdministrativePaymentId')
export type InvoiceAdministrativePaymentId = number & z.BRAND<"InvoiceAdministrativePaymentId">

export const InvoiceBatchId = z.number().brand('InvoiceBatchId')
export type InvoiceBatchId = number & z.BRAND<"InvoiceBatchId">

export const InvoiceId = z.number().brand('InvoiceId')
export type InvoiceId = number & z.BRAND<"InvoiceId">

export const InvoiceVisitId = z.number().brand('InvoiceVisitId')
export type InvoiceVisitId = number & z.BRAND<"InvoiceVisitId">

export const MasterWeekId = z.number().brand('MasterWeekId')
export type MasterWeekId = number & z.BRAND<"MasterWeekId">

export const MedflytCHRCDataId = z.number().brand('MedflytCHRCDataId')
export type MedflytCHRCDataId = number & z.BRAND<"MedflytCHRCDataId">

export const MedflytEmailAddressId = z.number().brand('MedflytEmailAddressId')
export type MedflytEmailAddressId = number & z.BRAND<"MedflytEmailAddressId">

export const MedflytHCRDataId = z.number().brand('MedflytHCRDataId')
export type MedflytHCRDataId = number & z.BRAND<"MedflytHCRDataId">

export const MedicaidExceptionCodeId = z.number().brand('MedicaidExceptionCodeId')
export type MedicaidExceptionCodeId = number & z.BRAND<"MedicaidExceptionCodeId">

export const MedicaidStatusId = z.number().brand('MedicaidStatusId')
export type MedicaidStatusId = number & z.BRAND<"MedicaidStatusId">

export const MedicationId = z.number().brand('MedicationId')
export type MedicationId = number & z.BRAND<"MedicationId">

export const NoteCommentId = z.number().brand('NoteCommentId')
export type NoteCommentId = number & z.BRAND<"NoteCommentId">

export const NoteFileId = z.number().brand('NoteFileId')
export type NoteFileId = number & z.BRAND<"NoteFileId">

export const NoteId = z.number().brand('NoteId')
export type NoteId = number & z.BRAND<"NoteId">

export const NotePredefinedAnswerId = z.number().brand('NotePredefinedAnswerId')
export type NotePredefinedAnswerId = number & z.BRAND<"NotePredefinedAnswerId">

export const NoteSubjectId = z.number().brand('NoteSubjectId')
export type NoteSubjectId = number & z.BRAND<"NoteSubjectId">

export const NursingQuestionAnswerId = z.number().brand('NursingQuestionAnswerId')
export type NursingQuestionAnswerId = number & z.BRAND<"NursingQuestionAnswerId">

export const NursingQuestionId = z.number().brand('NursingQuestionId')
export type NursingQuestionId = number & z.BRAND<"NursingQuestionId">

export const OfficeBranchCountyId = z.number().brand('OfficeBranchCountyId')
export type OfficeBranchCountyId = number & z.BRAND<"OfficeBranchCountyId">

export const OfficeBranchId = z.number().brand('OfficeBranchId')
export type OfficeBranchId = number & z.BRAND<"OfficeBranchId">

export const OfficeCaregiverHoursRestrictionId = z.number().brand('OfficeCaregiverHoursRestrictionId')
export type OfficeCaregiverHoursRestrictionId = number & z.BRAND<"OfficeCaregiverHoursRestrictionId">

export const OfficeCaregiverHoursRestrictionOverrideId = z.number().brand('OfficeCaregiverHoursRestrictionOverrideId')
export type OfficeCaregiverHoursRestrictionOverrideId = number & z.BRAND<"OfficeCaregiverHoursRestrictionOverrideId">

export const OfficeId = z.number().brand('OfficeId')
export type OfficeId = number & z.BRAND<"OfficeId">

export const OnboardingVisitId = z.number().brand('OnboardingVisitId')
export type OnboardingVisitId = number & z.BRAND<"OnboardingVisitId">

export const OnboardingVisitInstanceId = z.number().brand('OnboardingVisitInstanceId')
export type OnboardingVisitInstanceId = number & z.BRAND<"OnboardingVisitInstanceId">

export const PatientAuthorizationFileId = z.number().brand('PatientAuthorizationFileId')
export type PatientAuthorizationFileId = number & z.BRAND<"PatientAuthorizationFileId">

export const PatientAvailabilityTimeframeId = z.number().brand('PatientAvailabilityTimeframeId')
export type PatientAvailabilityTimeframeId = number & z.BRAND<"PatientAvailabilityTimeframeId">

export const PatientBpHistoryId = z.number().brand('PatientBpHistoryId')
export type PatientBpHistoryId = number & z.BRAND<"PatientBpHistoryId">

export const PatientCaregiverRelationshipId = z.number().brand('PatientCaregiverRelationshipId')
export type PatientCaregiverRelationshipId = number & z.BRAND<"PatientCaregiverRelationshipId">

export const PatientCaregiverRelationshipTypeId = z.number().brand('PatientCaregiverRelationshipTypeId')
export type PatientCaregiverRelationshipTypeId = number & z.BRAND<"PatientCaregiverRelationshipTypeId">

export const PatientClinicalInfoId = z.number().brand('PatientClinicalInfoId')
export type PatientClinicalInfoId = number & z.BRAND<"PatientClinicalInfoId">

export const PatientContactId = z.number().brand('PatientContactId')
export type PatientContactId = number & z.BRAND<"PatientContactId">

export const PatientContractDiagnosisCodeId = z.number().brand('PatientContractDiagnosisCodeId')
export type PatientContractDiagnosisCodeId = number & z.BRAND<"PatientContractDiagnosisCodeId">

export const PatientContractId = z.number().brand('PatientContractId')
export type PatientContractId = number & z.BRAND<"PatientContractId">

export const PatientCostShareInvoiceAdjustmentId = z.number().brand('PatientCostShareInvoiceAdjustmentId')
export type PatientCostShareInvoiceAdjustmentId = number & z.BRAND<"PatientCostShareInvoiceAdjustmentId">

export const PatientCostShareInvoiceId = z.number().brand('PatientCostShareInvoiceId')
export type PatientCostShareInvoiceId = number & z.BRAND<"PatientCostShareInvoiceId">

export const PatientCostShareInvoiceNoteId = z.number().brand('PatientCostShareInvoiceNoteId')
export type PatientCostShareInvoiceNoteId = number & z.BRAND<"PatientCostShareInvoiceNoteId">

export const PatientCostShareNotificationId = z.number().brand('PatientCostShareNotificationId')
export type PatientCostShareNotificationId = number & z.BRAND<"PatientCostShareNotificationId">

export const PatientCostSharePaymentAllocationId = z.number().brand('PatientCostSharePaymentAllocationId')
export type PatientCostSharePaymentAllocationId = number & z.BRAND<"PatientCostSharePaymentAllocationId">

export const PatientCostSharePaymentId = z.number().brand('PatientCostSharePaymentId')
export type PatientCostSharePaymentId = number & z.BRAND<"PatientCostSharePaymentId">

export const PatientCostSharePaymentRequestId = z.number().brand('PatientCostSharePaymentRequestId')
export type PatientCostSharePaymentRequestId = number & z.BRAND<"PatientCostSharePaymentRequestId">

export const PatientCostShareScheduleId = z.number().brand('PatientCostShareScheduleId')
export type PatientCostShareScheduleId = number & z.BRAND<"PatientCostShareScheduleId">

export const PatientDocumentAIReviewId = z.number().brand('PatientDocumentAIReviewId')
export type PatientDocumentAIReviewId = number & z.BRAND<"PatientDocumentAIReviewId">

export const PatientDocumentAiReviewProcessQuestionRejectionId = z.number().brand('PatientDocumentAiReviewProcessQuestionRejectionId')
export type PatientDocumentAiReviewProcessQuestionRejectionId = number & z.BRAND<"PatientDocumentAiReviewProcessQuestionRejectionId">

export const PatientDocumentScheduleId = z.number().brand('PatientDocumentScheduleId')
export type PatientDocumentScheduleId = number & z.BRAND<"PatientDocumentScheduleId">

export const PatientDocumentTypeId = z.number().brand('PatientDocumentTypeId')
export type PatientDocumentTypeId = number & z.BRAND<"PatientDocumentTypeId">

export const PatientDocumentVersionId = z.number().brand('PatientDocumentVersionId')
export type PatientDocumentVersionId = number & z.BRAND<"PatientDocumentVersionId">

export const PatientDraftMedicationId = z.number().brand('PatientDraftMedicationId')
export type PatientDraftMedicationId = number & z.BRAND<"PatientDraftMedicationId">

export const PatientId = z.number().brand('PatientId')
export type PatientId = number & z.BRAND<"PatientId">

export const PatientIntakeAppointmentId = z.number().brand('PatientIntakeAppointmentId')
export type PatientIntakeAppointmentId = number & z.BRAND<"PatientIntakeAppointmentId">

export const PatientIntakeCallId = z.number().brand('PatientIntakeCallId')
export type PatientIntakeCallId = number & z.BRAND<"PatientIntakeCallId">

export const PatientIntakePlanId = z.number().brand('PatientIntakePlanId')
export type PatientIntakePlanId = number & z.BRAND<"PatientIntakePlanId">

export const PatientIssueId = z.number().brand('PatientIssueId')
export type PatientIssueId = number & z.BRAND<"PatientIssueId">

export const PatientMedicalDiagnosisCodeId = z.number().brand('PatientMedicalDiagnosisCodeId')
export type PatientMedicalDiagnosisCodeId = number & z.BRAND<"PatientMedicalDiagnosisCodeId">

export const PatientMedicationId = z.number().brand('PatientMedicationId')
export type PatientMedicationId = number & z.BRAND<"PatientMedicationId">

export const PatientMedicationProfileId = z.number().brand('PatientMedicationProfileId')
export type PatientMedicationProfileId = number & z.BRAND<"PatientMedicationProfileId">

export const PatientPayRateId = z.number().brand('PatientPayRateId')
export type PatientPayRateId = number & z.BRAND<"PatientPayRateId">

export const PatientPortalDocumentId = z.number().brand('PatientPortalDocumentId')
export type PatientPortalDocumentId = number & z.BRAND<"PatientPortalDocumentId">

export const PatientServicePlanId = z.number().brand('PatientServicePlanId')
export type PatientServicePlanId = number & z.BRAND<"PatientServicePlanId">

export const PatientServicePlanImportId = z.number().brand('PatientServicePlanImportId')
export type PatientServicePlanImportId = number & z.BRAND<"PatientServicePlanImportId">

export const PatientServicePlanSignatureClaimId = z.number().brand('PatientServicePlanSignatureClaimId')
export type PatientServicePlanSignatureClaimId = number & z.BRAND<"PatientServicePlanSignatureClaimId">

export const PatientServicePlanTaskId = z.number().brand('PatientServicePlanTaskId')
export type PatientServicePlanTaskId = number & z.BRAND<"PatientServicePlanTaskId">

export const PatientSurplusCheckId = z.number().brand('PatientSurplusCheckId')
export type PatientSurplusCheckId = number & z.BRAND<"PatientSurplusCheckId">

export const PatientSurplusId = z.number().brand('PatientSurplusId')
export type PatientSurplusId = number & z.BRAND<"PatientSurplusId">

export const PatientSurplusInvoiceId = z.number().brand('PatientSurplusInvoiceId')
export type PatientSurplusInvoiceId = number & z.BRAND<"PatientSurplusInvoiceId">

export const PatientTaskDocumentChangeRequestId = z.number().brand('PatientTaskDocumentChangeRequestId')
export type PatientTaskDocumentChangeRequestId = number & z.BRAND<"PatientTaskDocumentChangeRequestId">

export const PatientTaskId = z.number().brand('PatientTaskId')
export type PatientTaskId = number & z.BRAND<"PatientTaskId">

export const PatientTaskInstanceId = z.number().brand('PatientTaskInstanceId')
export type PatientTaskInstanceId = number & z.BRAND<"PatientTaskInstanceId">

export const PatientTaskInstanceScheduleOverrideId = z.number().brand('PatientTaskInstanceScheduleOverrideId')
export type PatientTaskInstanceScheduleOverrideId = number & z.BRAND<"PatientTaskInstanceScheduleOverrideId">

export const PatientTaskTemplateId = z.number().brand('PatientTaskTemplateId')
export type PatientTaskTemplateId = number & z.BRAND<"PatientTaskTemplateId">

export const PatientVacationId = z.number().brand('PatientVacationId')
export type PatientVacationId = number & z.BRAND<"PatientVacationId">

export const PatientWeeklyTemplateShiftId = z.number().brand('PatientWeeklyTemplateShiftId')
export type PatientWeeklyTemplateShiftId = number & z.BRAND<"PatientWeeklyTemplateShiftId">

export const PayerId = z.number().brand('PayerId')
export type PayerId = number & z.BRAND<"PayerId">

export const PayRateCountyId = z.number().brand('PayRateCountyId')
export type PayRateCountyId = number & z.BRAND<"PayRateCountyId">

export const PayRateId = z.number().brand('PayRateId')
export type PayRateId = number & z.BRAND<"PayRateId">

export const PayRateSupplementalId = z.number().brand('PayRateSupplementalId')
export type PayRateSupplementalId = number & z.BRAND<"PayRateSupplementalId">

export const PayrollBatchId = z.number().brand('PayrollBatchId')
export type PayrollBatchId = number & z.BRAND<"PayrollBatchId">

export const PayrollClassroomTrainingId = z.number().brand('PayrollClassroomTrainingId')
export type PayrollClassroomTrainingId = number & z.BRAND<"PayrollClassroomTrainingId">

export const PayrollCodeId = z.number().brand('PayrollCodeId')
export type PayrollCodeId = number & z.BRAND<"PayrollCodeId">

export const PayrollOnlineTrainingId = z.number().brand('PayrollOnlineTrainingId')
export type PayrollOnlineTrainingId = number & z.BRAND<"PayrollOnlineTrainingId">

export const PayrollPtoId = z.number().brand('PayrollPtoId')
export type PayrollPtoId = number & z.BRAND<"PayrollPtoId">

export const PayrollSetupId = z.number().brand('PayrollSetupId')
export type PayrollSetupId = number & z.BRAND<"PayrollSetupId">

export const PayrollTravelTimeId = z.number().brand('PayrollTravelTimeId')
export type PayrollTravelTimeId = number & z.BRAND<"PayrollTravelTimeId">

export const PayrollVisitId = z.number().brand('PayrollVisitId')
export type PayrollVisitId = number & z.BRAND<"PayrollVisitId">

export const PdfFormTemplateId = z.number().brand('PdfFormTemplateId')
export type PdfFormTemplateId = number & z.BRAND<"PdfFormTemplateId">

export const PdfFormTemplateVersionId = z.number().brand('PdfFormTemplateVersionId')
export type PdfFormTemplateVersionId = number & z.BRAND<"PdfFormTemplateVersionId">

export const PhysicianId = z.number().brand('PhysicianId')
export type PhysicianId = number & z.BRAND<"PhysicianId">

export const PhysicianPatientAssocId = z.number().brand('PhysicianPatientAssocId')
export type PhysicianPatientAssocId = number & z.BRAND<"PhysicianPatientAssocId">

export const PlanOfCareDutyId = z.number().brand('PlanOfCareDutyId')
export type PlanOfCareDutyId = number & z.BRAND<"PlanOfCareDutyId">

export const PlanOfCareId = z.number().brand('PlanOfCareId')
export type PlanOfCareId = number & z.BRAND<"PlanOfCareId">

export const PlanOfCareItemId = z.number().brand('PlanOfCareItemId')
export type PlanOfCareItemId = number & z.BRAND<"PlanOfCareItemId">

export const PlanOfCareTypeId = z.number().brand('PlanOfCareTypeId')
export type PlanOfCareTypeId = number & z.BRAND<"PlanOfCareTypeId">

export const PortalUserId = z.number().brand('PortalUserId')
export type PortalUserId = number & z.BRAND<"PortalUserId">

export const ProcessJobId = z.number().brand('ProcessJobId')
export type ProcessJobId = number & z.BRAND<"ProcessJobId">

export const ProcessJobItemId = z.number().brand('ProcessJobItemId')
export type ProcessJobItemId = number & z.BRAND<"ProcessJobItemId">

export const ReferralSourceId = z.number().brand('ReferralSourceId')
export type ReferralSourceId = number & z.BRAND<"ReferralSourceId">

export const ReferralUserId = z.number().brand('ReferralUserId')
export type ReferralUserId = number & z.BRAND<"ReferralUserId">

export const RnPlatformAgencyContractId = z.number().brand('RnPlatformAgencyContractId')
export type RnPlatformAgencyContractId = number & z.BRAND<"RnPlatformAgencyContractId">

export const RnPlatformContractId = z.number().brand('RnPlatformContractId')
export type RnPlatformContractId = number & z.BRAND<"RnPlatformContractId">

export const RnPlatformHhaxBroadcastRequestJobId = z.number().brand('RnPlatformHhaxBroadcastRequestJobId')
export type RnPlatformHhaxBroadcastRequestJobId = number & z.BRAND<"RnPlatformHhaxBroadcastRequestJobId">

export const RnPlatformHhaxBroadcastRequestJobItemId = z.number().brand('RnPlatformHhaxBroadcastRequestJobItemId')
export type RnPlatformHhaxBroadcastRequestJobItemId = number & z.BRAND<"RnPlatformHhaxBroadcastRequestJobItemId">

export const RobocallInstanceId = z.number().brand('RobocallInstanceId')
export type RobocallInstanceId = number & z.BRAND<"RobocallInstanceId">

export const SandataPlanOfCareItemId = z.number().brand('SandataPlanOfCareItemId')
export type SandataPlanOfCareItemId = number & z.BRAND<"SandataPlanOfCareItemId">

export const SandataVisitSubmissionBatchId = z.number().brand('SandataVisitSubmissionBatchId')
export type SandataVisitSubmissionBatchId = number & z.BRAND<"SandataVisitSubmissionBatchId">

export const SavedReportId = z.number().brand('SavedReportId')
export type SavedReportId = number & z.BRAND<"SavedReportId">

export const ScheduledSavedReportId = z.number().brand('ScheduledSavedReportId')
export type ScheduledSavedReportId = number & z.BRAND<"ScheduledSavedReportId">

export const ScheduledSavedReportJobHistoryId = z.number().brand('ScheduledSavedReportJobHistoryId')
export type ScheduledSavedReportJobHistoryId = number & z.BRAND<"ScheduledSavedReportJobHistoryId">

export const ServiceCodeId = z.number().brand('ServiceCodeId')
export type ServiceCodeId = number & z.BRAND<"ServiceCodeId">

export const SocialWorkerId = z.number().brand('SocialWorkerId')
export type SocialWorkerId = number & z.BRAND<"SocialWorkerId">

export const StandardReportId = z.number().brand('StandardReportId')
export type StandardReportId = number & z.BRAND<"StandardReportId">

export const StatusChangeReasonId = z.number().brand('StatusChangeReasonId')
export type StatusChangeReasonId = number & z.BRAND<"StatusChangeReasonId">

export const StatusChangeToId = z.number().brand('StatusChangeToId')
export type StatusChangeToId = number & z.BRAND<"StatusChangeToId">

export const TaskCreditOrderOptionId = z.number().brand('TaskCreditOrderOptionId')
export type TaskCreditOrderOptionId = number & z.BRAND<"TaskCreditOrderOptionId">

export const TaskCreditStripeInvoiceId = z.number().brand('TaskCreditStripeInvoiceId')
export type TaskCreditStripeInvoiceId = number & z.BRAND<"TaskCreditStripeInvoiceId">

export const TaskDocumentRejectionId = z.number().brand('TaskDocumentRejectionId')
export type TaskDocumentRejectionId = number & z.BRAND<"TaskDocumentRejectionId">

export const TaskIssueTypeId = z.number().brand('TaskIssueTypeId')
export type TaskIssueTypeId = number & z.BRAND<"TaskIssueTypeId">

export const TelephonyBotAgentId = z.string().brand('TelephonyBotAgentId')
export type TelephonyBotAgentId = string & z.BRAND<"TelephonyBotAgentId">

export const TelephonyCallId = z.string().brand('TelephonyCallId')
export type TelephonyCallId = string & z.BRAND<"TelephonyCallId">

export const TelephonyCallParticipantId = z.string().brand('TelephonyCallParticipantId')
export type TelephonyCallParticipantId = string & z.BRAND<"TelephonyCallParticipantId">

export const TimesheetId = z.number().brand('TimesheetId')
export type TimesheetId = number & z.BRAND<"TimesheetId">

export const TrainingCenterBundleDueDateId = z.number().brand('TrainingCenterBundleDueDateId')
export type TrainingCenterBundleDueDateId = number & z.BRAND<"TrainingCenterBundleDueDateId">

export const TrainingCenterBundleId = z.number().brand('TrainingCenterBundleId')
export type TrainingCenterBundleId = number & z.BRAND<"TrainingCenterBundleId">

export const TrainingCenterBundleItemFullDescriptionId = z.number().brand('TrainingCenterBundleItemFullDescriptionId')
export type TrainingCenterBundleItemFullDescriptionId = number & z.BRAND<"TrainingCenterBundleItemFullDescriptionId">

export const TrainingCenterBundleItemId = z.number().brand('TrainingCenterBundleItemId')
export type TrainingCenterBundleItemId = number & z.BRAND<"TrainingCenterBundleItemId">

export const TrainingCenterBundleItemTestQuestionId = z.number().brand('TrainingCenterBundleItemTestQuestionId')
export type TrainingCenterBundleItemTestQuestionId = number & z.BRAND<"TrainingCenterBundleItemTestQuestionId">

export const TrainingCenterBundleItemVideoEngmtQuestionId = z.number().brand('TrainingCenterBundleItemVideoEngmtQuestionId')
export type TrainingCenterBundleItemVideoEngmtQuestionId = number & z.BRAND<"TrainingCenterBundleItemVideoEngmtQuestionId">

export const TrainingCenterBundleItemVideoMediaOverlayId = z.number().brand('TrainingCenterBundleItemVideoMediaOverlayId')
export type TrainingCenterBundleItemVideoMediaOverlayId = number & z.BRAND<"TrainingCenterBundleItemVideoMediaOverlayId">

export const TreatmentAdvanceDirectiveId = z.number().brand('TreatmentAdvanceDirectiveId')
export type TreatmentAdvanceDirectiveId = number & z.BRAND<"TreatmentAdvanceDirectiveId">

export const TreatmentDiagnosisId = z.number().brand('TreatmentDiagnosisId')
export type TreatmentDiagnosisId = number & z.BRAND<"TreatmentDiagnosisId">

export const TreatmentId = z.number().brand('TreatmentId')
export type TreatmentId = number & z.BRAND<"TreatmentId">

export const TreatmentMedicalOrderId = z.number().brand('TreatmentMedicalOrderId')
export type TreatmentMedicalOrderId = number & z.BRAND<"TreatmentMedicalOrderId">

export const UserId = z.number().brand('UserId')
export type UserId = number & z.BRAND<"UserId">

export const VBPItemId = z.number().brand('VBPItemId')
export type VBPItemId = number & z.BRAND<"VBPItemId">

export const VisitAssignmentId = z.number().brand('VisitAssignmentId')
export type VisitAssignmentId = number & z.BRAND<"VisitAssignmentId">

export const VisitBatchId = z.number().brand('VisitBatchId')
export type VisitBatchId = number & z.BRAND<"VisitBatchId">

export const VisitBroadcastId = z.number().brand('VisitBroadcastId')
export type VisitBroadcastId = number & z.BRAND<"VisitBroadcastId">

export const VisitDailyNoteCriticalIncidentEventId = z.number().brand('VisitDailyNoteCriticalIncidentEventId')
export type VisitDailyNoteCriticalIncidentEventId = number & z.BRAND<"VisitDailyNoteCriticalIncidentEventId">

export const VisitInstanceDailyNoteAttestationId = z.number().brand('VisitInstanceDailyNoteAttestationId')
export type VisitInstanceDailyNoteAttestationId = number & z.BRAND<"VisitInstanceDailyNoteAttestationId">

export const VisitInstanceDailyNoteId = z.number().brand('VisitInstanceDailyNoteId')
export type VisitInstanceDailyNoteId = number & z.BRAND<"VisitInstanceDailyNoteId">

export const VisitInstanceDutyReassignmentId = z.number().brand('VisitInstanceDutyReassignmentId')
export type VisitInstanceDutyReassignmentId = number & z.BRAND<"VisitInstanceDutyReassignmentId">

export const VisitInstanceId = z.number().brand('VisitInstanceId')
export type VisitInstanceId = number & z.BRAND<"VisitInstanceId">

export const WorkflowDefinitionCorrelationKey = z.string().brand('WorkflowDefinitionCorrelationKey')
export type WorkflowDefinitionCorrelationKey = string & z.BRAND<"WorkflowDefinitionCorrelationKey">

export const WorkflowDefinitionId = z.number().brand('WorkflowDefinitionId')
export type WorkflowDefinitionId = number & z.BRAND<"WorkflowDefinitionId">

export const WorkflowDefinitionTriggerId = z.number().brand('WorkflowDefinitionTriggerId')
export type WorkflowDefinitionTriggerId = number & z.BRAND<"WorkflowDefinitionTriggerId">

export const WorkflowInstanceId = z.number().brand('WorkflowInstanceId')
export type WorkflowInstanceId = number & z.BRAND<"WorkflowInstanceId">

export const WorkflowSkillId = z.string().brand('WorkflowSkillId')
export type WorkflowSkillId = string & z.BRAND<"WorkflowSkillId">

export const WorkflowTagId = z.string().brand('WorkflowTagId')
export type WorkflowTagId = string & z.BRAND<"WorkflowTagId">

export const WorkflowTaskClusterId = z.string().brand('WorkflowTaskClusterId')
export type WorkflowTaskClusterId = string & z.BRAND<"WorkflowTaskClusterId">

export const WorkflowTaskInstanceId = z.number().brand('WorkflowTaskInstanceId')
export type WorkflowTaskInstanceId = number & z.BRAND<"WorkflowTaskInstanceId">

/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/openapi": {
    /** openapi */
    get: {
      parameters: {
        query: {
          tags?: string[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": { [key: string]: unknown };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/webapp-messages": {
    /** webapp messages */
    get: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": { [key: string]: unknown };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/mobile-messages": {
    /** mobile messages */
    get: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": { [key: string]: unknown };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/realtime_session_token": {
    /** A nurse generates OpenAI realtime token */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              token: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/realtime_translation_prompt": {
    /** A nurse retrieves OpenAI realtime translation prompt */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              prompt: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/branches": {
    /** Associate caregiver to agency_branch */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            branchIds: components["schemas"]["AgencyBranchId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/branches": {
    /** Associate patient to agency_branch */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            agencyBranchIds: components["schemas"]["AgencyBranchId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/office_branches": {
    /** List all active office branches across the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["OfficeBranch"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/:officeId/office_branches": {
    /** List active office branches for a specific office */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["OfficeBranch"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create a new office branch */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["OfficeBranchId"];
              officeId: components["schemas"]["OfficeId"];
              name: string;
              licenseNumber: null | string;
              address: string;
              addressComponents: components["schemas"]["AddressComponents"];
              counties: components["schemas"]["OfficeBranchCounty"][];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["AgencyMemberId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            licenseNumber: null | string;
            address: string;
            addressComponents: components["schemas"]["AddressComponents"];
            counties: {
              state: string;
              countyName: string;
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/:officeId/office_branches/:officeBranchId": {
    /** Edit an office branch */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
          officeBranchId: OfficeBranchId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["OfficeBranchId"];
              officeId: components["schemas"]["OfficeId"];
              name: string;
              licenseNumber: null | string;
              address: string;
              addressComponents: components["schemas"]["AddressComponents"];
              counties: components["schemas"]["OfficeBranchCounty"][];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["AgencyMemberId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name?: string;
            licenseNumber?: null | string;
            address?: string;
            addressComponents?: components["schemas"]["AddressComponents"];
            counties?: {
              state: string;
              countyName: string;
            }[];
          };
        };
      };
    };
    /** Soft-delete an office branch */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
          officeBranchId: OfficeBranchId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/office_branches": {
    /** Replace a caregiver's office branch associations */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeBranchIds: components["schemas"]["OfficeBranchId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/:officeId/office_branches/available_counties": {
    /** Get distinct counties from patients in this office for autocomplete */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              counties: {
                state: string;
                countyName: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/pdf_form_templates": {
    /** Agency member lists PDF form templates */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              templates: components["schemas"]["PdfFormTemplateListItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/pdf_form_templates/:pdfFormTemplateId": {
    /** Agency member fetches a PDF form template with all versions */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          pdfFormTemplateId: PdfFormTemplateId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PdfFormTemplateId"];
              name: string;
              pageCount: number;
              isPublished: boolean;
              versions: components["schemas"]["PdfFormTemplateVersionData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member soft-deletes a PDF form template */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          pdfFormTemplateId: PdfFormTemplateId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/pdf_form_templates/:pdfFormTemplateId/draft": {
    /** Agency member saves the draft fields of a PDF form template */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          pdfFormTemplateId: PdfFormTemplateId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name?: string;
            fields: components["schemas"]["PdfFormField"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/pdf_form_templates/:pdfFormTemplateId/versions": {
    /** Agency member publishes the current fields as a frozen version */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          pdfFormTemplateId: PdfFormTemplateId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fields: components["schemas"]["PdfFormField"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/pdf_form_templates/:pdfFormTemplateId/generate_preview": {
    /** Agency member generates a filled preview PDF via the fill lambda */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          pdfFormTemplateId: PdfFormTemplateId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fields: components["schemas"]["GeneratePdfPreviewField"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/geocode": {
    /** Geocode an address */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              location: components["schemas"]["Geo"];
              country: string;
              administrativeAreaLevel1: string;
              administrativeAreaLevel2: string;
              sublocalityLevel1?: null | string;
              neighborhood?: null | string;
              locality?: null | string;
              administrativeLevels?: {
                level1short?: null | string;
              } | null;
              formatedAddressDetails?: components["schemas"]["FormatedAddressDetails"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            address: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/settings/:targetAgencyMemberId": {
    /** An agency member patches an agency member setting */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          targetAgencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sendEmailOnCaregiverJoinRequest?: boolean;
            sendEmailOnCaregiverHRPending?: boolean;
            sendEmailUnreadChatReminder?: boolean;
            sendEmailVisitAwaitingAssignment?: boolean;
            sendEmailFileUploaded?: boolean;
            sendEmailRNFiles?: boolean;
            sendEmailRNGeneralUploads?: boolean;
            sendEmailDutySheets?: boolean;
            sendEmailPlanOfCare?: boolean;
            sendEmailHRFiles?: boolean;
            sendEmailInService?: boolean;
            sendEmailNewCommCenterMessage?: boolean;
            sendPushNewCommCenterMessage?: boolean;
            sendEmailNewAssignedTicket?: boolean;
            sendPushNewAssignedTicket?: boolean;
            sendEmailNoteAssigned?: boolean;
            sendPushNoteAssigned?: boolean;
            sendEmailNewSMSMessage?: boolean;
            sendPushNewSMSMessage?: boolean;
            sendEmailNewEmailMessage?: boolean;
            sendPushNewEmailMessage?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/logrocket_settings": {
    /** Whether the webapp should initialize LogRocket for this agency member */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              shouldInitLogRocket: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/coordinator/:agencyMemberId/caregivers/:caregiverId/show_unblock_login": {
    /** Should coordinator see unblock button for this caregiver? */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              show: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/coordinator/:agencyMemberId/caregivers/:caregiverId/unblock_login": {
    /** Unblock login for caregiver */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Unblock login for caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/get_signed_photo_url": {
    /** Agency member attempts to get signed photo url */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          url?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "FORBIDDEN_PATH"
                | "UNSUPPORTED_FILE_STORAGE_TYPE"
                | "URL_IS_REQUIRED";
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/get_pre_signed_url": {
    /** Agency member attempts to get pre signed upload url */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          fileExtension?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
              key: string;
              type: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error: "FILE_EXTENSION_IS_REQUIRED";
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/search/agency-members": {
    /** Agency member searches agency members */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          q?: string;
          limit?: number;
          roles?: string;
          status?: string;
          officeId?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                id: number;
                displayName: string;
                jobTitle: null | string;
                status: string;
                officeIds: number[];
                photoUrl: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/search/social-workers": {
    /** Agency member searches social workers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          q?: string;
          limit?: number;
          status?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                id: number;
                displayName: string;
                email: null | string;
                phoneNumber: null | string;
                status: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/search/referral-sources": {
    /** Agency member searches referral sources */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          q?: string;
          limit?: number;
          type?: string;
          status?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                id: number;
                displayName: string;
                type: null | string;
                phoneNumber: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/search/offices": {
    /** Agency member searches offices */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          q?: string;
          limit?: number;
          status?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                id: number;
                displayName: string;
                isActive: boolean;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/search/caregivers": {
    /** Agency member searches caregivers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          q?: string;
          limit?: number;
          status?: string;
          certifications?: string;
          officeId?: string;
          ids?: string;
          assignableForPatientId?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                id: number;
                displayName: string;
                /**
                 * @description The name parts as well as the assembled `displayName`, because the
                 * pickers fall back to initials when there is no photo.
                 */
                firstName: string;
                middleName: null | string;
                lastName: string;
                displayId: null | number;
                status: string;
                certifications: string[];
                /** @description The caregiver's offices, for callers that pick an office-scoped setup. */
                officeIds: number[];
                photoUrl: null | string;
                /**
                 * @description Per-agency employment type, which the visit caregiver picker renders as
                 * a badge beside the name. Null for an agency that does not record one.
                 */
                employmentType: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/search/patients": {
    /** Agency member searches patients */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          q?: string;
          limit?: number;
          status?: string;
          officeId?: string;
          ids?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                id: number;
                displayName: string;
                /** @description As for caregivers: the picker falls back to initials with no photo. */
                firstName: string;
                middleName: null | string;
                lastName: string;
                displayId: null | number;
                status: string;
                /** @description The patient's offices, for callers that need the office scope. */
                officeIds: number[];
                /**
                 * @description Needed by the callers that used to read it off the patient dictionary
                 * and have nowhere else to get it - the upcoming-tasks list shows it
                 * beside each task.
                 */
                address: null | string;
                /** @description The team and coordinator, for the callers that filter or group by them. */
                agencyTeamId: null | number;
                assignedCoordinatorId: null | number;
                admissionId: null | string;
                photoUrl: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/records": {
    /** Agency member requests the agency's caregivers as wider records */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          statuses?: string;
          certifications?: string;
          officeId?: number;
          withPhoneNumbers?: boolean;
          ids?: string;
          languages?: string;
          installation?: string;
          limit?: number;
          offset?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverRecord"][];
              /**
               * @description Caregivers matching the filters, which is *not* `caregivers.length` when
               * the caller asked for a page.
               *
               * Absent when no paging was requested, so a caller that wants the whole
               * filtered set does not pay for a count it already has.
               */
              totalCount?: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/stats": {
    /** Agency member requests the dashboard's caregiver counts */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /**
               * @description Caregivers whose first app install was in the last day, for the
               * "downloaded the app" notifications.
               */
              recentlyInstalled: components["schemas"]["CaregiverRowDisplay"][];
              total: number;
              byStatus: {
                status: components["schemas"]["CaregiverStatus"];
                total: number;
                installed: number;
                uninstalled: number;
                notInstalled: number;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/options": {
    /** Agency member requests the agency's caregivers for an option list */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          limit?: number;
          statuses?: string;
          certifications?: string;
          officeId?: number;
          notBlacklistedForPatientId?: number;
          withPhoneNumbers?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverRowDisplay"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/assignable_caregivers/list": {
    /** Search and page caregivers eligible for a patient's visit */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          certifications?: string;
          state?: string;
          search?: string;
          maxDistanceMiles?: number;
          sortField?: string;
          sortOrder?: string;
          limit?: number;
          offset?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: (components["schemas"]["CaregiverRowDisplay"] & {
                distanceFromHomeInMiles: null | number;
              })[];
              totalCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/assignable_caregivers": {
    /** Agency member requests the caregivers a patient's visit can be assigned to */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          certifications?: string;
          state?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverRowDisplay"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/list": {
    /** Agency member lists caregivers, one page at a time */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          search?: string;
          status?: string;
          certifications?: string;
          languages?: string;
          officeId?: string;
          agencyBranchId?: string;
          fromHireDate?: LocalDate;
          toHireDate?: LocalDate;
          installation?: string;
          installations?: string;
          genders?: string;
          counties?: string;
          zip?: string;
          caregiverCode?: string;
          sortField?: string;
          sortOrder?: string;
          limit?: number;
          offset?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalCount: number;
              items: components["schemas"]["CaregiverListItem"][];
              /**
               * @description True when rows in the middle of the result set cannot be paged to at all.
               * The first and the last page window are always reachable, so this only
               * happens beyond twice that window. The count is still exact.
               */
              isTruncated: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/recipient_ids": {
    /** Agency member resolves all matching caregiver IDs for a broadcast */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          search?: string;
          status?: string;
          certifications?: string;
          languages?: string;
          officeId?: string;
          installations?: string;
          genders?: string;
          counties?: string;
          zip?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverIds: components["schemas"]["CaregiverId"][];
              totalCount: number;
              installedCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/list": {
    /** Agency member lists patients, one page at a time */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          search?: string;
          status?: string;
          officeId?: string;
          contractTypeId?: string;
          agencyTeamId?: string;
          assignedCoordinatorId?: string;
          firstNameSearch?: string;
          lastNameSearch?: string;
          displayIdSearch?: string;
          addressSearch?: string;
          homePhoneSearch?: string;
          mobilePhoneSearch?: string;
          sortField?: string;
          sortOrder?: string;
          limit?: number;
          offset?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalCount: number;
              items: components["schemas"]["PatientListItem"][];
              /**
               * @description True when rows in the middle of the result set cannot be paged to at all.
               * The first and the last page window are always reachable, so this only
               * happens beyond twice that window. The count is still exact.
               */
              isTruncated: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/teams": {
    /** Agency member request a list off agency teams */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyTeams: components["schemas"]["AgencyTeam"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/caregivers": {
    /** Retrieve all of the caregivers that belong to an agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["Caregiver"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/caregivers_dict2": {
    /** Retrieve all of the caregivers that belong to an agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              [key: string]: components["schemas"]["CaregiverDictEntry"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/caregivers_dict3": {
    /** Retrieve all of the caregivers that belong to an agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "links";
                  links: string[];
                  extraData?: { [key: string]: unknown };
                }
              | {
                  /** @enum {string} */
                  type: "dict";
                  dict: components["schemas"]["CaregiverDict2"];
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/coordinator_activity": {
    /** Retrieve the coordinator activity in the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          startDate?: LocalDate;
          endDate?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              activities: components["schemas"]["CoordinatorActivity"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId": {
    /** Retrieve a single caregiver that belongs to an agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              officeBranchIds: components["schemas"]["OfficeBranchId"][];
              agencyAssocCreatedAt: components["schemas"]["Instant"];
              agencyAssocCreatedByAgencyMemberId:
                | components["schemas"]["AgencyMemberId"]
                | null;
              agencyAssocCreatedByCaregiverId:
                | components["schemas"]["CaregiverId"]
                | null;
              agencyAssocUpdatedAt: components["schemas"]["Instant"] | null;
              agencyAssocUpdatedByAgencyMemberId:
                | components["schemas"]["AgencyMemberId"]
                | null;
              agencyAssocUpdatedByCaregiverId:
                | components["schemas"]["CaregiverId"]
                | null;
              /**
               * @description Denormalised so the profile page can label "created/updated by" without a
               * dictionary of every caregiver.
               */
              agencyAssocCreatedByCaregiverName: null | string;
              agencyAssocUpdatedByCaregiverName: null | string;
              isEmailVerified: null | boolean;
              isTestUser: boolean;
              authenticareWorkerId: null | string;
              employmentType: null | string;
              /**
               * @description New York Home Care Worker ID, scoped to this agency. Distinct from
               * `stateRegistryNum`, which is a different identifier on the shared
               * caregiver record.
               */
              hcwId: null | string;
              id: components["schemas"]["CaregiverId"];
              status: components["schemas"]["CaregiverStatus"];
              caregiverCode: null | string;
              officeIds: components["schemas"]["OfficeId"][];
              officeNames?: string[];
              branchIds: components["schemas"]["AgencyBranchId"][];
              branchNames?: string[];
              caregiverBranch?: null | string;
              workAreaPreference?: null | string;
              createdAt: components["schemas"]["Instant"];
              /** Format: date-time */
              birthDate: null | string;
              birthDateDate: components["schemas"]["LocalDate"] | null;
              phoneNumber: string;
              phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
              homePhone: null | string;
              firstName: string;
              middleName: null | string;
              lastName: string;
              /** @description "M", "F" */
              gender: string;
              /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
              languages: string[];
              address: string;
              address2: null | string;
              isCustomAddress: boolean;
              addressCounty: null | string;
              addressGeoLocation: components["schemas"]["Geo"];
              addressComponents?:
                | components["schemas"]["AddressComponents"]
                | null;
              missingAddressFields?: string[];
              certifications: components["schemas"]["CaregiverCertification"][];
              certificationNames?: string[];
              agencyAssocCreatedByAgencyMemberName?: null | string;
              photoUrl: null | string;
              photoUrlOriginal: null | string;
              installedUserAgent: null | string;
              appInstalledDate: components["schemas"]["Instant"] | null;
              appInstalled: boolean;
              appInstalledAt: components["schemas"]["Instant"][];
              appUninstalledAt: components["schemas"]["Instant"][];
              /** @description Is the caregiver's app currently open */
              online: boolean;
              /** @description When was the last time the caregiver was online? */
              lastSeen: components["schemas"]["Instant"] | null;
              notificationSettings?: components["schemas"]["NotificationSettings"];
              email: null | string;
              isFullTime: boolean;
              hireDate: components["schemas"]["LocalDate"] | null;
              rehireDate: components["schemas"]["LocalDate"] | null;
              terminationDate: components["schemas"]["LocalDate"] | null;
              isCompliant: boolean;
              stateRegistryNum: null | number;
              isClockEnabled: boolean;
              ssn: null | string;
              applicationStartDate: components["schemas"]["LocalDate"] | null;
              lastWorkDate: components["schemas"]["LocalDate"] | null;
              firstWorkDate: components["schemas"]["LocalDate"] | null;
              displayId: null | number;
              externalId: null | string;
              customFields: components["schemas"]["EntityCustomField"];
              blacklisted: components["schemas"]["PatientId"][] | null;
              emergencyContacts: components["schemas"]["CaregiverEmergencyContact"][];
              nextStatus?:
                | (
                    | "ACTIVE"
                    | "JOIN_REQUEST"
                    | "ON_HOLD"
                    | "ON_LEAVE"
                    | "PENDING"
                    | "QUIT"
                    | "REJECTED"
                    | "SUSPENDED"
                    | "TERMINATED"
                  )
                | null;
              nextStatusEffectiveDate?:
                | components["schemas"]["LocalDate"]
                | null;
              isFromLandingPage: boolean;
              mainLanguage: string;
              glovesSize?: ("L" | "M" | "S" | "XL") | null;
              scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
              agencyIds?: components["schemas"]["AgencyId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/status": {
    /** An AgencyMember changes the status and offices of a caregiver within the Agency */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            status: components["schemas"]["CaregiverStatus"];
            offices?: components["schemas"]["OfficeId"][];
            certifications?: components["schemas"]["CaregiverCertification"][];
            note: components["schemas"]["AgencyNoteCreateParams"] | null;
            effectiveDate: components["schemas"]["LocalDate"];
            setEffectiveDateAsHireDate: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/hire_date": {
    /** An AgencyMember changes the hire date of a caregiver within the Agency */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            hireDate: components["schemas"]["LocalDate"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/broadcasted_filters_by_caregiver": {
    /** An agency member asks to see data about which visits were broadcasted or not to a specific caregiver. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverDetails: {
                caregiverId: components["schemas"]["CaregiverId"];
                caregiverFirstName: string;
                caregiverLastName: string;
                caregiverGender: string;
                caregiverAddress: string;
                caregiverCertifications: components["schemas"]["CaregiverCertification"][];
              };
              visitsBroadcastFilterInfo: {
                visitBroadcastId: components["schemas"]["VisitBroadcastId"];
                patientId: components["schemas"]["PatientId"];
                startTime: components["schemas"]["Instant"];
                endTime: components["schemas"]["Instant"];
                broadcasted: boolean;
                isMultipleCaregivers: boolean;
                isFlexibleVisit: boolean;
                flexibleVisitParams:
                  | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
                  | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
                  | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
                  | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
                  | components["schemas"]["PermanentFixedHoursFlexibleDays"]
                  | components["schemas"]["SingleFlexible"]
                  | null;
                visitNotBroadcastedReasons: components["schemas"]["NotBroadcastedToCaregiverReason"][];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/termination_date": {
    /** An AgencyMember changes the termination date of a caregiver within the Agency */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            terminationDate: components["schemas"]["LocalDate"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/enable_clock_in": {
    /** An AgencyMember enable/disable a caregiver ability to use clock-in and clock-out in mobile */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            isClockEnabled: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/agency_members": {
    /** Retrieve all of the agency members that belong to an agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyMembers: components["schemas"]["AgencyMember"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members": {
    /** Retrieve all of the agency members that belong to an agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyMembers: components["schemas"]["AgencyMember"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/settings": {
    /** Get settings for agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitPriceRequired: boolean;
              patientPhoneRequired: boolean;
              visitPatientAlternativePhoneRequired: boolean;
              checkInRequired?: boolean;
              pendingAcceptanceTime: number;
              timesheetSubmissionLimitation?: null | number;
              /**
               * @description 0 - Sunday
               * 1 - Monday
               * 2 - Tueday
               * 3 - Wednesday
               * 4 - Thurday
               * 5 - Friday
               * 6 - Saturday
               */
              hoursWorked_firstDayOfWeek?: number;
              hoursWorked_overnightHoursCountAsNextWeek?: boolean;
              rnContactTime?: number;
              agencyIpSecuritySetting: components["schemas"]["AgencyIpSecuritySettings"];
              disableCoronaPreScreening?: boolean;
              showPatientMedicationProfileDocument: boolean;
              showVBPOnMobile: boolean;
              hrLogoutTime: number;
              sendEmailOnMedicationProfileUpdate: boolean;
              checkinMaxDistance?: number;
              isMilitaryTime?: boolean;
              invalidateExpiredComplianceItems?: boolean;
              requireCaregiverAssignWithOvertimePermission?: boolean;
              sendExpiredComplianceItemsMobileNotifications?: boolean;
              hidePatientPhoneNumbersFromCaregiver?: boolean;
              requireCms485CertificationPeriod?: boolean;
              mobileOfflineModeEnabled?: boolean;
              preventRemoveTaskInstanceWhenRemovingCertificationPeriod?: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/dashboard": {
    /** Get agency webapp dashboard data */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              statuses: components["schemas"]["DashboardStatuses"];
              online: components["schemas"]["DashboardOnline"];
              installs: components["schemas"]["DashboardInstalls"];
              newInstalls: components["schemas"]["DashboardCaregiver"][];
              recentlyOnline: components["schemas"]["DashboardCaregiver"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/ivr/fetch_treatment": {
    /** Attempt to fetch treatment details based on IVR request */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              taskId: components["schemas"]["PlanOfCareItemId"];
              taskName: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
            patientId: components["schemas"]["PatientId"] | null;
            caregiverId: components["schemas"]["CaregiverId"];
            agencyId: components["schemas"]["AgencyId"];
            sourcePhoneNumber: string;
            treatmentCode: string;
          };
        };
      };
    };
  };
  "/ivr/fetch_duty_requirement": {
    /** Check whether duties are required based on an IVR request */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              dutiesRequired: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
            patientId: components["schemas"]["PatientId"] | null;
            agencyId: components["schemas"]["AgencyId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/search": {
    /** Global search */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
        query: {
          text?: string;
          patient_id?: boolean;
          patient_first_name?: boolean;
          patient_middle_name?: boolean;
          patient_last_name?: boolean;
          patient_address?: boolean;
          patient_phone_numbers?: boolean;
          patient_ssn?: boolean;
          patient_member_id?: boolean;
          patient_medicaid_number?: boolean;
          patient_medicare_number?: boolean;
          patient_email?: boolean;
          caregiver_id?: boolean;
          caregiver_first_name?: boolean;
          caregiver_middle_name?: boolean;
          caregiver_last_name?: boolean;
          caregiver_address?: boolean;
          caregiver_phone_numbers?: boolean;
          caregiver_ssn?: boolean;
          caregiver_email?: boolean;
          include_invoices?: boolean;
          full_search?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["GlobalSearchPatientResult"][];
              caregivers: components["schemas"]["GlobalSearchCaregiverResult"][];
              visits: components["schemas"]["GlobalSearchVisitResult"][];
              invoices: components["schemas"]["GlobalSearchInvoiceResult"][];
              total: {
                amount: number;
                /** @enum {string} */
                relation: "eq" | "gte";
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members_user_ids": {
    /** Get an array of all agency members user ids */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["AgencyMembersUserId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/certifications_settings": {
    /** Ageny member attempts to get agency certifications settings */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              certifications: components["schemas"]["AgencyCertificationSetting"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/onboarding_stages": {
    /** Get all onboarding stages */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              stages: components["schemas"]["HRSectionStage"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/is_rn_platform_agency": {
    /** Get if agency is RN platform agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              isRnPlatformAgency: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/billing/summary": {
    /** Agency admin fetches billing summary; restricted to the billing owner pinned on Stripe customer metadata */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              customerExists: boolean;
              customerName: null | string;
              customerAddress: null | string;
              defaultPaymentMethod:
                | components["schemas"]["AgencyBillingPaymentMethod"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/billing/setup_intent": {
    /** Billing-owner admin requests a Stripe SetupIntent; lazily creates the Stripe customer on first use */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              clientSecret: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/billing/payment_method/default": {
    /** Billing-owner admin sets the default payment method for the agency's subscription and customer */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              customerExists: boolean;
              customerName: null | string;
              customerAddress: null | string;
              defaultPaymentMethod:
                | components["schemas"]["AgencyBillingPaymentMethod"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            paymentMethodId: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/allergies": {
    /** Get all allergies. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              allergies: components["schemas"]["Allergy"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/patients/:patientId/allergies": {
    /** Get patient allergies. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              allergies: components["schemas"]["Allergy"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update patient allergies */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            allergyIds: components["schemas"]["AllergyId"][];
            /** @enum {string} */
            type: "ASSOCIATE" | "DISSOCIATE";
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/check_force_logout": {
    /** Caregiver checks if should force logout */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              logout: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/auth/caregiver/:phoneNumber/request_code": {
    /**
     * Request to login with a phoneNumber.
     *
     *                 After this endpoint is called, an SMS message will immediately be sent to
     *                 phoneNumber with a login code.
     *
     *                 If the config setting DEBUG_AUTH_PREDICTABLE_TOKENS is set, then the code
     *                 will always be "66666"
     *
     *                 Returns HTTP status code 404 if a user does not exist for the phoneNumber
     */
    post: {
      parameters: {
        path: {
          phoneNumber: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  action: "none";
                }
              | {
                  /** @enum {string} */
                  action: "updateUrls";
                  apiUrl: string;
                  socketUrl: string;
                }
              | {
                  /** @enum {string} */
                  action: "blockNewApp";
                  androidAppUrl: string;
                  iosAppUrl: string;
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/auth/caregiver/passthrough2": {
    /** Login using a passthrough code */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            passthrough: string;
          };
        };
      };
    };
  };
  "/auth/caregiver/:phoneNumber/login2": {
    /** User logins from mobile with phone number */
    post: {
      parameters: {
        path: {
          phoneNumber: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            code: string;
            isFromMobileApp?: boolean;
          };
        };
      };
    };
  };
  "/auth/token": {
    /** User refreshes token */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/auth/caregiver/migrate_token": {
    /** Temporary endpoint for migration to JWT */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/auth/new_login": {
    /** User logins with email and password. Using JWT authentication. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              permissions: components["schemas"]["AgencyMemberPermission"][];
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            password: string;
            code?: string;
            twoFactorCode?: string;
          };
        };
      };
    };
  };
  "/auth/new_login/otp": {
    /** User logins with email OTP. Using JWT authentication. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {boolean} */
                  registered: false;
                }
              | {
                  /** @enum {boolean} */
                  registered: true;
                  accessJWT: string;
                  refreshJWT: string;
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            otp: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/audit/table/patient/id/:patientId": {
    /** Get patient audit trails */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["Audit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/audit/table/caregiver/id/:caregiverId": {
    /** Get caregiver audit trails */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["Audit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/audit/etl": {
    /** Load audit trails to target per field table */
    get: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              result: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorizations/:patientId": {
    /** Agency member request a list off authorizations of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              authorizations: components["schemas"]["AuthorizationWithDisplayData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/authorization/:authorizationId": {
    /** update authorization details */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          authorizationId: AuthorizationId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["AuthorizationId"];
              code: null | string;
              startDate: components["schemas"]["LocalDate"];
              endDate: components["schemas"]["LocalDate"];
              maxMinutes: number;
              minutes: number;
              patientContractId: components["schemas"]["PatientContractId"];
              periodType: components["schemas"]["AuthorizationPeriodType"];
              files: components["schemas"]["PatientAuthorizationFileId"][];
              serviceCode: components["schemas"]["ServiceCodeId"];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              updatedAt: components["schemas"]["Instant"];
              updatedBy: components["schemas"]["AgencyMemberId"];
              firstDayOfWeek: components["schemas"]["DayOfWeek"];
              mondayMinutes: null | number;
              tuesdayMinutes: null | number;
              wednesdayMinutes: null | number;
              thursdayMinutes: null | number;
              fridayMinutes: null | number;
              saturdayMinutes: null | number;
              sundayMinutes: null | number;
              removedBy?: components["schemas"]["AgencyMemberId"] | null;
              removedAt?: components["schemas"]["Instant"] | null;
              note: components["schemas"]["Note"] | null;
              externalId: null | string;
              createVisitOfficeIdOverride:
                | components["schemas"]["OfficeId"]
                | null;
              restrictions:
                | components["schemas"]["AuthorizationTimeConfig.WeeklyRestriction"][]
                | null;
              /**
               * @description Illinois DHS/DRS district number, labelled "Caseload" on the authorization
               * document. Printed in the District column of the IL488-2387 monthly billing
               * statement, and unused by every other contract type.
               */
              districtNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | components["schemas"]["AuthorizationOfficeOverrideConflictError"]
              | {
                  /** @enum {string} */
                  error: "AUTH_HAS_BILLED_VISITS";
                }
              | {
                  /** @enum {string} */
                  error: "AUTH_HAS_PAID_VISITS";
                }
              | components["schemas"]["EditAuthorizationVisitHoursRestrictionError"];
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            /** @description The code that appears on the Authorization Document */
            authCode: null | string;
            patientContractId: components["schemas"]["PatientContractId"];
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            /** @description The first day that the authorization is valid for */
            startDate: components["schemas"]["LocalDate"];
            /** @description The last day that the authorization  is valid for */
            endDate: components["schemas"]["LocalDate"];
            /**
             * @description Total number of minutes available in the entire authorization (note that
             * the value is in minutes)
             */
            maxMinutes: null | number;
            /** @description The time configuration of the authorizaion (weekly, daily, etc..) */
            timeConfig: components["schemas"]["AuthorizationTimeConfig"];
            /** @description External Id of this authorization from other systems */
            externalId: null | string;
            notes?: components["schemas"]["AgencyNoteEditParams"] | null;
            /** @description rollover Should create past visits? */
            creatVisitsOnPastDates?: boolean;
            /** @description The office that the authorization will alter visits to */
            createVisitOfficeIdOverride?:
              | components["schemas"]["OfficeId"]
              | null;
            /**
             * @description Illinois DHS/DRS district number, labelled "Caseload" on the authorization
             * document. Only relevant to contracts billed on the IL488-2387 form.
             */
            districtNumber?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorizations": {
    /** insert new authorization */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["AuthorizationId"];
              code: null | string;
              startDate: components["schemas"]["LocalDate"];
              endDate: components["schemas"]["LocalDate"];
              maxMinutes: number;
              minutes: number;
              patientContractId: components["schemas"]["PatientContractId"];
              periodType: components["schemas"]["AuthorizationPeriodType"];
              files: components["schemas"]["PatientAuthorizationFileId"][];
              serviceCode: components["schemas"]["ServiceCodeId"];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              updatedAt: components["schemas"]["Instant"];
              updatedBy: components["schemas"]["AgencyMemberId"];
              firstDayOfWeek: components["schemas"]["DayOfWeek"];
              mondayMinutes: null | number;
              tuesdayMinutes: null | number;
              wednesdayMinutes: null | number;
              thursdayMinutes: null | number;
              fridayMinutes: null | number;
              saturdayMinutes: null | number;
              sundayMinutes: null | number;
              removedBy?: components["schemas"]["AgencyMemberId"] | null;
              removedAt?: components["schemas"]["Instant"] | null;
              note: components["schemas"]["Note"] | null;
              externalId: null | string;
              createVisitOfficeIdOverride:
                | components["schemas"]["OfficeId"]
                | null;
              restrictions:
                | components["schemas"]["AuthorizationTimeConfig.WeeklyRestriction"][]
                | null;
              /**
               * @description Illinois DHS/DRS district number, labelled "Caseload" on the authorization
               * document. Printed in the District column of the IL488-2387 monthly billing
               * statement, and unused by every other contract type.
               */
              districtNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | components["schemas"]["AuthorizationOfficeOverrideConflictError"]
              | components["schemas"]["EditAuthorizationVisitHoursRestrictionError"];
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            /** @description The code that appears on the Authorization Document */
            authCode: null | string;
            patientContractId: components["schemas"]["PatientContractId"];
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            /** @description The first day that the authorization is valid for */
            startDate: components["schemas"]["LocalDate"];
            /** @description The last day that the authorization  is valid for */
            endDate: components["schemas"]["LocalDate"];
            /**
             * @description Total number of minutes available in the entire authorization (note that
             * the value is in minutes)
             */
            maxMinutes: null | number;
            /** @description The time configuration of the authorizaion (weekly, daily, etc..) */
            timeConfig: components["schemas"]["AuthorizationTimeConfig"];
            /** @description External Id of this authorization from other systems */
            externalId: null | string;
            notes?: components["schemas"]["AgencyNoteCreateParams"] | null;
            icdCodesForDX?: components["schemas"]["ICD10CodeId"][] | null;
            /** @description The office that the authorization will alter visits to */
            createVisitOfficeIdOverride?:
              | components["schemas"]["OfficeId"]
              | null;
            /**
             * @description Illinois DHS/DRS district number, labelled "Caseload" on the authorization
             * document. Only relevant to contracts billed on the IL488-2387 form.
             */
            districtNumber?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorization/:authorizationId": {
    /** Agency member attempts to delete patient authorization */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          authorizationId: AuthorizationId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorization_utilization_reports/patients": {
    /** Per-patient authorization utilization list for a date range */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          officeIds?: OfficeId[];
          contractTypeIds?: ContractTypeId[];
          coordinatorIds?: AgencyMemberId[];
          periodTypes?: string[];
          patientStatuses?: string[];
          noScheduleYet?: boolean;
          states?: string[];
          search?: string;
          limit?: number;
          offset?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalCount: number;
              nodes: components["schemas"]["PatientUtilizationListItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorization_utilization_reports/dashboard": {
    /** Office- and contract-level authorization utilization dashboard */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          officeIds?: OfficeId[];
          contractTypeIds?: ContractTypeId[];
          coordinatorIds?: AgencyMemberId[];
          periodTypes?: string[];
          patientStatuses?: string[];
          states?: string[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              authorizedMinutes: number;
              scheduledMinutes: number;
              unscheduledMinutes: number;
              overAllocatedMinutes: number;
              authorizedReductionMinutes: number;
              scheduledUtilization: null | number;
              countUnderAllocated: number;
              countFullyAllocated: number;
              countOverAllocated: number;
              unlimitedAuthorizations: number;
              byOfficeContract: components["schemas"]["UtilizationOfficeContractRollup"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorization_utilization/check_over_utilization": {
    /** Check whether proposed visits would cause over-utilization */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              warnings:
                | components["schemas"]["OverUtilizationWarningItem"][]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            proposedVisits: {
              visitDate: string;
              minutes: number;
            }[];
            excludeVisitInstanceIds?: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/ai_weekly_template_builder/authorizations": {
    /** Authorizations that the AI weekly template builder can work from */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              authorizations: components["schemas"]["AiWeeklyTemplateBuilderAuthorizationOption"][];
              rateLimit: components["schemas"]["AiWeeklyTemplateRateLimitStatus"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorizations/:authorizationId/ai_weekly_template_builder/context": {
    /** Authorization periods and calendar facts for the AI weekly template builder */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          authorizationId: AuthorizationId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              authorization: components["schemas"]["AiWeeklyTemplateAuthorizationSummary"];
              periods: components["schemas"]["AiWeeklyTemplatePeriodContext"][];
              totals: components["schemas"]["AiWeeklyTemplateContextTotals"];
              existingTemplateShifts: components["schemas"]["PatientWeeklyTemplateShiftExtended"][];
              /**
               * @description The suggestion-independent half of the apply verdict. Combine with a
               * suggestion's own `status` and `appliedAt` for the full answer.
               */
              apply: components["schemas"]["AiWeeklyTemplateApplyEligibility"];
              rateLimit: components["schemas"]["AiWeeklyTemplateRateLimitStatus"];
              /**
               * @description Past suggestions for this authorization, newest first, capped at
               * `AI_WEEKLY_TEMPLATE_HISTORY_LIMIT`. Summaries only — fetch the detail
               * endpoint for the full stored result.
               */
              recentSuggestions: components["schemas"]["AiWeeklyTemplateSuggestionSummary"][];
              warnings: components["schemas"]["AiWeeklyTemplateContextWarning"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorizations/:authorizationId/ai_weekly_template_builder/suggestions/:suggestionId": {
    /** One previously generated weekly template suggestion, as it was recorded */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          authorizationId: AuthorizationId;
          suggestionId: AiWeeklyTemplateSuggestionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              summary: components["schemas"]["AiWeeklyTemplateSuggestionSummary"];
              suggestion: components["schemas"]["AiWeeklyTemplateSuggestion"];
              verification: components["schemas"]["AiWeeklyTemplateVerification"];
              /** @description The combined verdict for *this* suggestion, ready for the button. */
              apply: components["schemas"]["AiWeeklyTemplateApplyEligibility"];
              /**
               * @description Every turn of the conversation this suggestion belongs to, oldest first —
               * not just its ancestors. Opening an earlier version must not make the later
               * ones disappear from the version strip.
               */
              thread: components["schemas"]["AiWeeklyTemplateThreadTurn"][];
              /** @description Refinements this conversation still allows. 0 hides the feedback box. */
              remainingFeedbackTurns: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorizations/:authorizationId/ai_weekly_template_builder/generate": {
    /** Generate a suggested repeating weekly template for an authorization */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          authorizationId: AuthorizationId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              status: components["schemas"]["AiWeeklyTemplateGenerationStatus"];
              context: components["schemas"]["AiWeeklyTemplateBuilderContext"];
              /** @description Exactly what the assistant proposed. `null` when no proposal was obtained. */
              suggestion:
                | components["schemas"]["AiWeeklyTemplateSuggestion"]
                | null;
              /** @description Server-computed truth. The client renders this, not `suggestion`. */
              verification:
                | components["schemas"]["AiWeeklyTemplateVerification"]
                | null;
              /**
               * @description The stored row this result was recorded as, which is what the apply
               * endpoint takes. `null` for the statuses that are deliberately not
               * recorded — see `aiWeeklyTemplateRecordedStatuses`.
               */
              suggestionId:
                | components["schemas"]["AiWeeklyTemplateSuggestionId"]
                | null;
              /** @description The combined verdict for the suggestion just generated. */
              apply: components["schemas"]["AiWeeklyTemplateApplyEligibility"];
              /**
               * @description Every turn of the conversation this result belongs to, oldest first.
               *
               * Empty when nothing was recorded and there is no earlier turn to fall back
               * on — a refinement that produced no usable result still returns the
               * conversation as it stood, so the version strip does not blink out.
               */
              thread: components["schemas"]["AiWeeklyTemplateThreadTurn"][];
              /** @description Refinements this conversation still allows. 0 hides the feedback box. */
              remainingFeedbackTurns: number;
              /** @description Model calls made: 0 when rate limited, otherwise 1 or 2. */
              attempts: number;
              modelName: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @description Free text from the "Scheduling Rules / Restrictions" field. */
            schedulingRules: null | string;
            /** @description Defaults to 15. Must be one of `aiWeeklyTemplateIncrementMinutesOptions`. */
            incrementMinutes?: number;
            /** @description Defaults to true. */
            includeTrueUps?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorizations/:authorizationId/ai_weekly_template_builder/suggestions/:suggestionId/refine": {
    /** Revise a suggested weekly template from the coordinator's feedback on it */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          authorizationId: AuthorizationId;
          suggestionId: AiWeeklyTemplateSuggestionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              status: components["schemas"]["AiWeeklyTemplateGenerationStatus"];
              context: components["schemas"]["AiWeeklyTemplateBuilderContext"];
              /** @description Exactly what the assistant proposed. `null` when no proposal was obtained. */
              suggestion:
                | components["schemas"]["AiWeeklyTemplateSuggestion"]
                | null;
              /** @description Server-computed truth. The client renders this, not `suggestion`. */
              verification:
                | components["schemas"]["AiWeeklyTemplateVerification"]
                | null;
              /**
               * @description The stored row this result was recorded as, which is what the apply
               * endpoint takes. `null` for the statuses that are deliberately not
               * recorded — see `aiWeeklyTemplateRecordedStatuses`.
               */
              suggestionId:
                | components["schemas"]["AiWeeklyTemplateSuggestionId"]
                | null;
              /** @description The combined verdict for the suggestion just generated. */
              apply: components["schemas"]["AiWeeklyTemplateApplyEligibility"];
              /**
               * @description Every turn of the conversation this result belongs to, oldest first.
               *
               * Empty when nothing was recorded and there is no earlier turn to fall back
               * on — a refinement that produced no usable result still returns the
               * conversation as it stood, so the version strip does not blink out.
               */
              thread: components["schemas"]["AiWeeklyTemplateThreadTurn"][];
              /** @description Refinements this conversation still allows. 0 hides the feedback box. */
              remainingFeedbackTurns: number;
              /** @description Model calls made: 0 when rate limited, otherwise 1 or 2. */
              attempts: number;
              modelName: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @description What the coordinator wants changed about the suggestion they are looking at. */
            feedback: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/authorizations/:authorizationId/ai_weekly_template_builder/suggestions/:suggestionId/apply": {
    /** Create the patient's weekly template and its visits from a suggestion */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          authorizationId: AuthorizationId;
          suggestionId: AiWeeklyTemplateSuggestionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              suggestionId: components["schemas"]["AiWeeklyTemplateSuggestionId"];
              appliedAt: components["schemas"]["Instant"];
              /** @description Rows written to `patient_weekly_template_shift`. */
              templateShiftsCreated: number;
              /** @description `PERMANENT` visit batches backing them — the busiest day's shift count. */
              visitBatchesCreated: number;
              recurringVisitsCreated: number;
              /**
               * @description Dates the generator declined for an overlap.
               *
               * Note this does not account for every date that produced no visit: dates
               * outside the patient's service window are dropped silently upstream, so
               * `recurringVisitsCreated` can be lower than shifts × weekday occurrences
               * without this number explaining the gap.
               */
              recurringVisitsSkipped: number;
              firstVisitDate: components["schemas"]["LocalDate"] | null;
              lastVisitDate: components["schemas"]["LocalDate"] | null;
              /** @description Accepted true-ups in the snapshot, whether or not they were created. */
              trueUpsAccepted: number;
              trueUpVisitsCreated: number;
              /** @description Every attempt, successes and failures, for one table in the UI. */
              trueUps: components["schemas"]["AiWeeklyTemplateApplyTrueUpResult"][];
              /**
               * @description Non-fatal notes worth showing. Always populated when nothing at all was
               * created — a template with no visits is the most confusing possible
               * outcome and must never be silent.
               */
              warnings: components["schemas"]["AiWeeklyTemplateApplyWarning"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "NOT_ELIGIBLE";
                  blockers: components["schemas"]["AiWeeklyTemplateApplyBlocker"][];
                }
              | {
                  /** @enum {string} */
                  type: "VISIT_HOURS_RESTRICTION_CONFLICT";
                  conflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "WEEKLY_TEMPLATE_CONFLICT";
                  reasons: string[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description Chosen in the confirmation dialog. `null` creates unassigned template
             * shifts and unassigned visits, which the coordinator staffs or broadcasts
             * with the existing tools.
             */
            caregiverId: components["schemas"]["CaregiverId"] | null;
            payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
            /**
             * @description The weekly total the coordinator had on screen. When it disagrees with the
             * stored snapshot the apply is refused, so a dialog left open while another
             * suggestion was selected cannot write numbers nobody reviewed.
             *
             * Advisory only: the server always applies the stored snapshot, never this.
             */
            expectedWeeklyTotalMinutes?: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/banked_minutes/visits": {
    /** Get visits with billing adjustments for banked minutes */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          officeIds?: OfficeId[];
          contractTypeIds?: ContractTypeId[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["BankedMinutesVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/banked_minutes/jobs/reset": {
    /** Create a banked minutes reset job */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/banked_minutes/jobs": {
    /** Get all banked minutes jobs for the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["BankedMinutesJob"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/banked_minutes/jobs/:jobId/items": {
    /** Get items for a banked minutes job */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          jobId: ProcessJobId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["BankedMinutesJobItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/banked_minutes/jobs/:jobId/stop": {
    /** Stop a running banked minutes job */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          jobId: ProcessJobId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/process_jobs/ar_notes/references": {
    /** Download valid AR note reasons, status refs and agency members */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileName: string;
              csv: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/process_jobs": {
    /** Get process jobs for the agency, filtered by process type */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          processType?: string;
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["ProcessJob"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/process_jobs/:jobId/items": {
    /** Get items for a process job */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          jobId: ProcessJobId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["ProcessJobItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/process_jobs/:jobId/stop": {
    /** Stop a running process job */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          jobId: ProcessJobId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/process_jobs/:jobId/errors_file": {
    /** Download errored authorization rows as CSV */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          jobId: ProcessJobId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileName: string;
              csv: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/process_jobs/:jobId/retry_errored": {
    /** Create a new upload job containing only errored items */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          jobId: ProcessJobId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              jobId: components["schemas"]["ProcessJobId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver_document_type_agency_settings/:caregiverDocumentTypeId": {
    /** Agency member updates document setting */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverDocumentTypeId: CaregiverDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["CaregiverDocumentTypeAgencySettingId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            displayName: null | string;
            sectionLabel: null | string;
            isForHr: boolean;
            isForCompliance: boolean;
            complianceUploadFromMobile: boolean;
            requireReVerification: boolean;
            isMandatory: boolean;
            certifications: components["schemas"]["CaregiverCertification"][];
            activeDate:
              | {
                  /** @enum {string} */
                  type: "static";
                  value: components["schemas"]["LocalDate"];
                }
              | {
                  /** @enum {string} */
                  type: "dynamic";
                  value: components["schemas"]["ActiveDateDynamic"];
                }
              | {
                  /** @enum {string} */
                  type: "general";
                  value: components["schemas"]["LocalDate"];
                }
              | null;
            expiryUnit: ("DAY" | "MONTH" | "WEEK") | null;
            expiryAmount: null | number;
            expires: boolean;
            expireOnlyOnNoHireDate: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/document_uploads/:documentUploadId/generate_url": {
    /** Agency asks for signed url for caregiver document upload */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
          documentUploadId: CaregiverDocumentUploadId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/uploaded_documents": {
    /** All documents of caregiver from passport/hr/compliance */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: components["schemas"]["CaregiverDocumentTypeWithUploads"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver_uploaded_document/:caregiverUploadedDocumentId": {
    /** Agency member updates caregiver uploaded document */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverUploadedDocumentId: CaregiverDocumentUploadId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            expiryDate: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/extended_contact_details": {
    /** Agency member requests caregiver extended contact details */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              details:
                | components["schemas"]["CaregiverExtendedContactDetailsData"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member updates caregiver extended contact details */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              details:
                | components["schemas"]["CaregiverExtendedContactDetailsData"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            birthCountryPlace: null | string;
            lookingForLongPermanentCases: null | string;
            cdpapToPcaSwitch: null | boolean;
            commentForTeam: null | string;
            experienceWithBedboundPatient: null | boolean;
            dohFormSection3Complete: components["schemas"]["Instant"] | null;
            eVerifySubmissionDate: components["schemas"]["LocalDate"] | null;
            experienceWithWalkingAssistanceNeed: null | boolean;
            experienceWorkingWithShabbatObserver: null | boolean;
            experienceWorkingAtKosherHome: null | boolean;
            experienceWorkingWithHalalCulture: null | boolean;
            eyeColor: null | string;
            hairColor: null | string;
            height: null | string;
            isCaregiverSmoking: null | boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/export-profile-pdf": {
    /** Agency member attempts to export caregiver profile as PDF */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
              signedUrl: string;
              bucket: string;
              key: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sectionsIncluded:
              | components["schemas"]["ExportCaregiverProfileSectionName"][]
              | null;
            calendarPeriod:
              | components["schemas"]["CalendarDatePeriodParam"]
              | null;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/agency_members": {
    /** Retrieve the agencies that the caregiver is associated with, and all of the agency members */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencies: components["schemas"]["CaregiverAgency"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver/:caregiverId": {
    /** Agency member updates caregiver details */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumbers?: string[];
            firstName?: string;
            middleName?: string;
            lastName?: string;
            /** Format: date-time */
            birthDate?: null | string;
            birthDateDate?: components["schemas"]["LocalDate"] | null;
            homePhone?: null | string;
            /** @description "M", "F" */
            gender?: string;
            /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
            languages?: string[];
            mainLanguage?: string;
            address?: string;
            address2?: null | string;
            addressGeoLocation?: components["schemas"]["Geo"];
            isCustomAddress?: boolean;
            addressComponents?: components["schemas"]["AddressComponents"];
            isFullTime?: boolean;
            email?: null | string;
            addressCounty?: string;
            ssn?: null | string;
            officeIds?: components["schemas"]["OfficeId"][];
            externalId?: null | string;
            terminationDate?: components["schemas"]["LocalDate"] | null;
            displayId?: null | number;
            caregiverCode?: null | string;
            stateRegistryNum?: null | number;
            rehireDate?: components["schemas"]["LocalDate"] | null;
            gloves_size?: ("L" | "M" | "S" | "XL") | null;
            scrubs_size?: ("L" | "M" | "S" | "XL" | "XXL") | null;
            isTestUser?: boolean;
            authenticareWorkerId?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/visit_engagements": {
    /** Get the caregivers visit engagements for the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              engagements: components["schemas"]["AgencyCaregiverVisitEngagement"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/availability": {
    /** Coordinator gets caregiver availability */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverAvailability:
                | components["schemas"]["CaregiverAvailability"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/caregivers_availability_map": {
    /** Get availability map for all caregivers in an agency (only non-null entries) */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": { [key: string]: unknown };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/attendance": {
    /** Get caregiver attendance data for year */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          year?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverPtos: {
                overall: components["schemas"]["CaregiverAttendancePTOOverallRow"][];
                breakdown: components["schemas"]["CaregiverAttendancePTOBreakdownRow"][];
              };
              missedVisits: components["schemas"]["CaregiverAttendanceMissedVisit"][];
              missedClockInOuts: components["schemas"]["CaregiverAttendanceMissedClockInOut"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver/:caregiverId/evv_compliance": {
    /** Agency member gets statistics about the caregiver's evv usage */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalVisits: number;
              evvCount: number;
              manualCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/phone_number": {
    /** Add caregiver phone number */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              phoneNumberSmsable: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/phone_number/:phoneNumber": {
    /** Removes a caregiver's registered phone number so long as at least one SMSable phone number still exists. */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
          phoneNumber: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/agency_assoc": {
    /** Agency member update caregiver details on caregiver_agency_assoc */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            applicationStartDate?: components["schemas"]["LocalDate"] | null;
            firstWorkDate?: components["schemas"]["LocalDate"] | null;
            lastWorkDate?: components["schemas"]["LocalDate"] | null;
            emergencyContacts?: components["schemas"]["CaregiverEmergencyContact"][];
            employmentType?: null | string;
            /**
             * @description New York Home Care Worker ID. Per agency, so it belongs on the assoc
             * rather than on the shared caregiver record -- and it is a different
             * identifier from `stateRegistryNum`, not a rename of it.
             */
            hcwId?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/certifications": {
    /** Agency member updates caregiver agency certifications */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            certifications: components["schemas"]["CaregiverCertification"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/payroll_tax": {
    /** Get caregiver payroll tax details */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documentType: ("2020_ONWARDS" | "UNTIL_2020") | null;
              multipleJobs: null | boolean;
              stateMaritalStatus: null | string;
              stateDependents: null | number;
              localDependents: null | number;
              federalMaritalStatus: null | string;
              federalWithholdingExemption: null | number;
              federalWithholdingExemptionConditions: null | boolean;
              federalDependentsClaimsTotalDollar: null | number;
              federalOtherIncomeDollar: null | number;
              federalDeductionsDollar: null | number;
              federalExtraWithholdingDollar: null | number;
              stateExtraWithholdingDollar: null | number;
              nycExtraWithholdingDollar: null | number;
              yonkersExtraWithholdingDollar: null | number;
              cityTaxCode: components["schemas"]["CityTaxCodeId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Edit caregiver payroll tax details */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            documentType: components["schemas"]["PayrollTaxDocumentType"];
            multipleJobs?: null | boolean;
            stateMaritalStatus?: null | string;
            stateDependents?: null | number;
            localDependents?: null | number;
            federalMaritalStatus?: null | string;
            federalWithholdingExemption?: null | number;
            federalWithholdingExemptionConditions?: null | boolean;
            federalDependentsClaimsTotalDollar?: null | number;
            federalOtherIncomeDollar?: null | number;
            federalDeductionsDollar?: null | number;
            federalExtraWithholdingDollar?: null | number;
            stateExtraWithholdingDollar?: null | number;
            nycExtraWithholdingDollar?: null | number;
            yonkersExtraWithholdingDollar?: null | number;
            cityTaxCode?: components["schemas"]["CityTaxCodeId"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver/:caregiverId/patients_associated": {
    /** Get patient list of all the patients associated with a caregiver in the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: {
                patientId: components["schemas"]["PatientId"];
                from: components["schemas"]["LocalDateTime"];
                to: components["schemas"]["LocalDateTime"];
                visitsCount: number;
                displayId: null | number;
                patientDisplayId: null | number;
                firstName: string;
                middleName: null | string;
                lastName: string;
                patientDisplayName: null | string;
                patientStatus: null | string;
                displayName: null | string;
                status: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/get_signed_photo_url": {
    /** Caregiver attempts to get a signed photo url */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
        query: {
          url?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "FORBIDDEN_PATH"
                | "UNSUPPORTED_FILE_STORAGE_TYPE"
                | "URL_IS_REQUIRED";
            };
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/rating": {
    /** get rating for caregiver in onboarding agency */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rating: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/points": {
    /** get points for caregiver in onboarding agency */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              points: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/online_caregivers": {
    /** Agency member gets list of online caregivers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/notification_status": {
    /** Caregiver update push notification status */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            enabled: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/search": {
    /** Agency member search caregivers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          term?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverSearchItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId": {
    /** Agency member gets caregiver */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiver: components["schemas"]["CaregiverProfileWithDisplayData"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/raffle": {
    /** Get current raffle */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tokens: number;
              shiftsPerToken: number;
              shiftsToNextToken: number;
              raffleEndsAt: components["schemas"]["Instant"];
              winnerCaregiverId: components["schemas"]["CaregiverId"] | null;
              previousWinners: components["schemas"]["RafflePreviousWinner"][];
              participants: components["schemas"]["RaffleParticipant"][];
              prize: components["schemas"]["RafflePrize"];
              participationStatus: components["schemas"]["RaffleParticipationStatus"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/attendance_stats": {
    /** Agency member gets caregiver attendance stats */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              attendanceRate: number;
              attendedVisits: number;
              callOuts: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/get_calls_count_to_patient_before_visit/:patientId": {
    /** Get calls count to patient before visit */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
        query: {
          phoneNumbers?: string[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              allMet: boolean;
              summary: components["schemas"]["NursePhoneCallsCount"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "FORBIDDEN_PATH"
                | "UNSUPPORTED_FILE_STORAGE_TYPE"
                | "URL_IS_REQUIRED";
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/status_history": {
    /** Agency member fetches the caregiver status history */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rows: components["schemas"]["CaregiverStatusHistory"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/status": {
    /** Agency member changes the caregiver status */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            effectiveDate: components["schemas"]["LocalDate"];
            status: components["schemas"]["CaregiverStatus"];
            note: components["schemas"]["AgencyNoteCreateParams"] | null;
            setEffectiveDateAsHireDate: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/deleteFutureStatus/:futureStatusChangeId": {
    /** Agency member deletes a future status change. */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          futureStatusChangeId: CaregiverStatusHistoryId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/getNextFutureStatusChange": {
    /** Agency member deletes a future status change. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              nextStatus:
                | (
                    | "ACTIVE"
                    | "JOIN_REQUEST"
                    | "ON_HOLD"
                    | "ON_LEAVE"
                    | "PENDING"
                    | "QUIT"
                    | "REJECTED"
                    | "SUSPENDED"
                    | "TERMINATED"
                  )
                | null;
              nextStatusEffectiveDate:
                | components["schemas"]["LocalDate"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/chat_rooms/:agencyMemberId": {
    /** Retrieve all of the chat rooms of an agency member */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              chatRooms: components["schemas"]["ChatRoom"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/chats/:chatRoomId": {
    /** Retrieve all of the chat messages of a chat room from webapp */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          chatRoomId: ChatRoomId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ChatRoomId"];
              chatRoomType: components["schemas"]["ChatRoomType"];
              members: components["schemas"]["ChatRoomMember"][];
              messages: components["schemas"]["ChatRoomMessage"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/check_batches_2/:checkBatchId": {
    /** Agency member request the details of a specified check_batch of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          checkBatchId: CheckId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              checkLines: components["schemas"]["CheckLineWithVisitInstanceDetails"][];
              unappliedLines: components["schemas"]["CheckUnappliedLine"][];
              servicesCount: number;
              appliedAmount: number;
              unappliedAmount: number;
              id: components["schemas"]["CheckId"];
              checkNumber: string;
              agencyId: components["schemas"]["AgencyId"];
              contractTypeId: components["schemas"]["ContractTypeId"] | null;
              fileUrl: null | string;
              amount: number;
              forwardingBalance: number;
              overpaymentRecovery: number;
              interest: number;
              nonreimbursable: number;
              levyAmount: number;
              lumpSum: number;
              adjustment: number;
              providerRefund: number;
              checkDate: components["schemas"]["LocalDate"];
              depositDate: components["schemas"]["LocalDate"] | null;
              notes: null | string;
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              updatedAt: components["schemas"]["Instant"];
              updatedBy: components["schemas"]["AgencyMemberId"];
              appliedPositiveAmount?: number;
              appliedNegativeAmount?: number;
              unappliedPositiveAmount?: number;
              unappliedNegativeAmount?: number;
              officesIds?: components["schemas"]["OfficeId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/check_batch_export": {
    /** Agency member requests an export file of check batches */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          checkIds?: CheckId[];
          grouped?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member requests an export file of check batches */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            checkIds: components["schemas"]["CheckId"][];
            grouped?: boolean;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/clockin_clockout_attestations": {
    /** Get required attestations for a visit instance clock action */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
        query: {
          language?: string;
          clockType?: "IN" | "OUT";
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              attestations: components["schemas"]["ClockinClockoutAttestation"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/clockin_clockout_record_by_ivr/:ivrId": {
    /** Get clockin clockout record by ivr Id */
    get: {
      parameters: {
        path: {
          caregiverId: string;
          ivrId: ClockinClockoutRecordIvrId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ClockinClockoutRecordId"];
              agencyId: components["schemas"]["AgencyId"];
              callDuration: number;
              caregiverId: components["schemas"]["CaregiverId"] | null;
              patientId: components["schemas"]["PatientId"] | null;
              sourcePhone: null | string;
              callType: string;
              methodType: string;
              visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
              geoLocation: components["schemas"]["Geo"] | null;
              duties: string[] | null;
              dutyTexts: string[] | null;
              deviceId: null | string;
              deviceUuid: null | string;
              callLogDetails: string;
              linkedAt: components["schemas"]["Instant"] | null;
              linkedBy: components["schemas"]["AgencyMemberId"] | null;
              rejectedAt: components["schemas"]["Instant"] | null;
              rejectedBy: components["schemas"]["AgencyMemberId"] | null;
              clockTime: components["schemas"]["Instant"];
              ivrId: null | string;
              caregiverPhoneNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/clockin_clockout_record_selfie/:callType": {
    /** Caregvier upload selfie for verification on clock in or clock out */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
          callType: "IN" | "OUT";
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            imageBase64: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/can_adjust_times": {
    /** Checks if visit times are adjustable */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              result: components["schemas"]["ClockinClockoutCheckAdjustmentStatusResult"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits/:visitInstanceId/clockin_clockout_record/:callType": {
    /** caregiver performs clock in or clock out action */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
          callType: "IN" | "OUT";
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ClockinClockoutRecordId"];
              agencyId: components["schemas"]["AgencyId"];
              callDuration: number;
              caregiverId: components["schemas"]["CaregiverId"] | null;
              patientId: components["schemas"]["PatientId"] | null;
              sourcePhone: null | string;
              callType: string;
              methodType: string;
              visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
              geoLocation: components["schemas"]["Geo"] | null;
              duties: string[] | null;
              dutyTexts: string[] | null;
              deviceId: null | string;
              deviceUuid: null | string;
              callLogDetails: string;
              linkedAt: components["schemas"]["Instant"] | null;
              linkedBy: components["schemas"]["AgencyMemberId"] | null;
              rejectedAt: components["schemas"]["Instant"] | null;
              rejectedBy: components["schemas"]["AgencyMemberId"] | null;
              clockTime: components["schemas"]["Instant"];
              ivrId: null | string;
              caregiverPhoneNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            geoLocation: components["schemas"]["Geo"] | null;
            adjustVisitTimes?: boolean;
            attestationVersionIds?: string[];
            /**
             * Format: yyyy-MM-ddTHH:mm:ss.SSSZ
             * @description Caregiver-supplied clock event time. Used when the mutation was queued
             * offline and replayed later — the queued timestamp must win over the
             * server's `now` so billing / compliance reflect when the work
             * actually happened. Optional for backward compatibility.
             */
            clockEventTime?: Instant;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visits/:visitInstanceId/clockin_clockout_record/:callType/IVR": {
    /** caregiver performs clock in or clock out action via IVR */
    post: {
      parameters: {
        path: {
          caregiverId: string;
          callType: string;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ClockinClockoutRecordId"];
              agencyId: components["schemas"]["AgencyId"];
              callDuration: number;
              caregiverId: components["schemas"]["CaregiverId"] | null;
              patientId: components["schemas"]["PatientId"] | null;
              sourcePhone: null | string;
              callType: string;
              methodType: string;
              visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
              geoLocation: components["schemas"]["Geo"] | null;
              duties: string[] | null;
              dutyTexts: string[] | null;
              deviceId: null | string;
              deviceUuid: null | string;
              callLogDetails: string;
              linkedAt: components["schemas"]["Instant"] | null;
              linkedBy: components["schemas"]["AgencyMemberId"] | null;
              rejectedAt: components["schemas"]["Instant"] | null;
              rejectedBy: components["schemas"]["AgencyMemberId"] | null;
              clockTime: components["schemas"]["Instant"];
              ivrId: null | string;
              caregiverPhoneNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            geoLocation: components["schemas"]["Geo"] | null;
            callDuration: number;
            agencyId: components["schemas"]["AgencyId"];
            patientId: components["schemas"]["PatientId"] | null;
            timestamp: components["schemas"]["Instant"];
            dutyCodes: string[] | null;
            dutyTexts?: string[] | null;
            sourcePhoneNumber: null | string;
            calledPhoneNumber?: null | string;
            ivrId: null | string;
            caregiverPhoneNumber: null | string;
            clockLocation?: ("COMMUNITY" | "HOME") | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/link": {
    /** Agency member attempts to bulk / single link an unlinked clockin/clockout record */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            records: components["schemas"]["ClockinClockoutLinkParam"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/reject": {
    /** Agency member attempts to reject an unlinked clockin/clockout record / records */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            records: components["schemas"]["ClockinClockoutRecordId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/restore": {
    /** Agency member attempts to restore a rejected clockin/clockout record / records */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            records: components["schemas"]["ClockinClockoutRecordId"][];
          };
        };
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/compliance_items/:complianceItemId": {
    /** Update caregiver compliance item */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          complianceItemId: CaregiverComplianceInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            isCompliant?: boolean;
            expiryDate?: components["schemas"]["LocalDate"] | null;
            effectiveDate?: components["schemas"]["LocalDate"] | null;
            fields?: components["schemas"]["ComplianceV2FieldInstanceWithValue"][];
            /** Format: CaregiverDocumentUploadId */
            caregiverDocumentUploadId?: CaregiverDocumentUploadId;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/compliance_items": {
    /** Agency member add compliance instance to caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["CaregiverComplianceInstanceId"];
              caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
              agencyId: components["schemas"]["AgencyId"];
              fields: components["schemas"]["ComplianceV2FieldInstanceWithValue"][];
              createdAt: components["schemas"]["Instant"];
              uploadedBy: string;
              caregiverId: components["schemas"]["CaregiverId"];
              isCompliant: boolean;
              expiryDate: components["schemas"]["LocalDate"] | null;
              effectiveDate: components["schemas"]["LocalDate"];
              caregiverDocumentUploadId:
                | components["schemas"]["CaregiverDocumentUploadId"]
                | null;
              fictiveType: "due_date" | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
            isCompliant: boolean;
            effectiveDate: components["schemas"]["LocalDate"];
            /** Format: yyyy-MM-dd */
            expiryDate?: LocalDate;
            /** Format: CaregiverDocumentUploadId */
            caregiverDocumentUploadId?: CaregiverDocumentUploadId;
            fields: components["schemas"]["ComplianceV2FieldInstanceWithValue"][];
            fictiveType?: "due_date" | null;
            shouldDuplicateUploadForFollowup?: boolean;
            /** Format: CaregiverDocumentUploadId */
            duplicateDocumentUpload?: CaregiverDocumentUploadId;
            swapUploadedDocumentTypeId?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/multiple_compliance_items": {
    /** Agency member add compliance instances to caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            items: components["schemas"]["ComplianceInstanceCreate"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/compliance_items/:complianceInstanceId": {
    /** Delete a compliance instance */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          complianceInstanceId: CaregiverComplianceInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/missing_followup_items": {
    /** List caregiver compliance followup items in the agency. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          showExpiredItemsRegardlessDateFilter?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                caregiverId: components["schemas"]["CaregiverId"];
                documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance": {
    /** Fetches compliance items. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["ComplianceCaregiverRecord"][];
              documents: components["schemas"]["ComplianceDocument"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance/page": {
    /** Fetches one page of the compliance dashboard. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rows: components["schemas"]["ComplianceDashboardPageRow"][];
              /** @description Caregivers matching the filters, not the number of `rows`. */
              totalCount: number;
              /**
               * @description True when rows in the middle of the result set cannot be paged to. The
               * first and last windows are always reachable; the count stays exact.
               */
              isTruncated: boolean;
              documents: components["schemas"]["ComplianceDocument"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @description Matched against the caregiver's name and ids. */
            search: null | string;
            statuses: (
              | "ACTIVE"
              | "JOIN_REQUEST"
              | "ON_HOLD"
              | "ON_LEAVE"
              | "PENDING"
              | "QUIT"
              | "REJECTED"
              | "SUSPENDED"
              | "TERMINATED"
            )[];
            /**
             * @description Caregivers holding *any* of these certifications.
             *
             * Note this is not what the pre-paging dashboard did: it kept a caregiver
             * only when every certification they hold was among the selected ones, so an
             * HHA+PCA+RN caregiver disappeared when HHA and PCA were selected. Any-of is
             * what every other certification filter in the app means, and it is what a
             * `terms` filter can express.
             */
            certifications: components["schemas"]["CaregiverCertification"][];
            /** @description null when not filtering, i.e. when both or neither option is selected. */
            isCompliant: null | boolean;
            isFromLandingPage: null | boolean;
            hasHireDate: null | boolean;
            /**
             * @description Caregivers in *any* of these offices. Used by the Caregiver Status tab.
             *
             * Optional, like everything below it: these were added after the paged
             * dashboard shipped, and the schema marks every non-optional field required -
             * so making them required would reject a webapp that predates them, including
             * during a rolling deploy.
             */
            officeIds?: components["schemas"]["OfficeId"][];
            /**
             * @description Restrict to these caregivers, for the chart and card filters. `null` is no
             * restriction; an empty list is "nobody" and is honoured as such.
             */
            caregiverIds: components["schemas"]["CaregiverId"][] | null;
            /** @description Has an item in one of these states. */
            itemStatuses?: string[];
            /** @description Both ends required, as on the page. */
            expiryFrom?: components["schemas"]["LocalDate"] | null;
            expiryTo?: components["schemas"]["LocalDate"] | null;
            /**
             * @description The page's "Include items with issues" toggle, on by default.
             *
             * Worth knowing what it does: it short-circuits the expiry window, so with
             * it on any item that is not Compliant / Resolved / Not due yet matches
             * whatever its dates say. The default view is therefore barely a date filter
             * at all.
             */
            includeItemsWithIssues?: boolean;
            /**
             * @description Non-compliant items of these document types.
             *
             * By id. The pre-paging page matched on the document type's display *name*
             * and expanded a selected parent to its descendants' names; names are
             * per-agency overrides, so the caller expands to ids instead.
             */
            issueDocumentTypeIds?: components["schemas"]["CaregiverDocumentTypeId"][];
            /** @description "automation" and/or "reviewer". */
            failedReviews?: string[];
            /** @description "Agency Member", "Reviewer" and/or "System". */
            declinedBy?: string[];
            sortField: components["schemas"]["ComplianceDashboardSortField"];
            /** @enum {string} */
            sortOrder: "asc" | "desc";
            limit: number;
            offset: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance_stats": {
    /** Fetches compliance statistics. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              employment: components["schemas"]["ComplianceStatsEmploymentStatus"][];
              caregivers: components["schemas"]["ComplianceStatsCaregiver"][];
              items: components["schemas"]["ComplianceStatsItem"][];
              incompliantCaregiversWithActiveCase: components["schemas"]["CaregiverId"][];
              caregiversWithOnlyOneIncompliantItem: components["schemas"]["CaregiverId"][];
              incompliantItemsWithUploadedDocuments: components["schemas"]["ComplianceStatsIcompliantItemsWithUploadedDocuments"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/failed_reviews_compliance_uploads": {
    /** Fetches failed compliance document reviews. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              automations: {
                documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
                caregiverId: components["schemas"]["CaregiverId"];
              }[];
              reviewers: {
                documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
                caregiverId: components["schemas"]["CaregiverId"];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance_declined_documents": {
    /** Fetches compliance declined documents. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: components["schemas"]["ComplianceDeclinedDocument"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance/reminders": {
    /** Sends reminders to caregivers. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            caregiverIds: components["schemas"]["CaregiverId"][];
            message: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hr_caregiver_status": {
    /** Get HR statistics of all caregivers for onboarding agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["HROnboardingStatistics"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/uploaded_documents/:uploadedDocumentId/dismiss": {
    /** Agency member dismiss caregiver document upload for validity for compliance item */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          uploadedDocumentId: CaregiverDocumentUploadId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/complaince_instances/:complianceInstanceId/attach_file": {
    /** Agency member attach file to compliance item */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: VisitBroadcastId;
          caregiverId: CaregiverId;
          complianceInstanceId: CaregiverComplianceInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            base64: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance_fields/:complianceFieldId/possible_values/:possibleValueId/resolve_parent": {
    /** Agency member update resolve parent of item possible value */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          complianceFieldId: ComplianceV2ItemFieldId;
          possibleValueId: ComplianceV2ItemFieldPossibleValueId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ComplianceV2ItemFieldPossibleValueId"];
              text: string;
              followupDocumentRequireData:
                | components["schemas"]["ComplianceV2FollowupDocumentData"]
                | null;
              followupResolvesParent: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            resolveParent: boolean;
          };
        };
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/compliance_items/:caregiverDocumentTypeId/records_info": {
    /** Agency member request caregiver compliance item records info */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          caregiverDocumentTypeId: CaregiverDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              instances: components["schemas"]["CaregiverComplianceInstance"][];
              caregiverPendingUploads: components["schemas"]["CaregiverDocumentUploadBasicDetails"][];
              historyStatusChanges: components["schemas"]["ComplianceInstanceHistory"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance_items/:caregiverDocumentTypeId/rejection_reasons": {
    /** request compliance item rejection reasons */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverDocumentTypeId: CaregiverDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              reasons: components["schemas"]["ComplianceItemRejectReason"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/next_pending_caregiver": {
    /** Agency member requests the most relevant caregiver to review compliance-wise */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              data:
                | components["schemas"]["CompliancePrioritizedCaregiverByPendingDocuments"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/compliance_ai_review_manual_check": {
    /** Agency member requests the ai reviews of documents for manual check */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverDocuments: {
                caregiver: components["schemas"]["ComplianceAiReviewManualCheckCaregiver"];
                documents: components["schemas"]["ComplianceAiReviewManualCheckDocument"][];
              }[];
              documentTypes: components["schemas"]["ComplianceDocument"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            reviewStatuses: string[] | null;
            statuses: string[] | null;
            documents:
              | components["schemas"]["CaregiverDocumentTypeId"][]
              | null;
            dateFrom: components["schemas"]["LocalDate"] | null;
            dateTo: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/skip_pending_caregiver/:caregiverId": {
    /** Agency member skips the most relevant caregiver to review compliance-wise */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/agencies/:agencyId/compliance_items": {
    /** Caregiver request all compliance items */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              isCompliant: boolean;
              items: components["schemas"]["CaregiverComplianceItemMobile"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/i9_form": {
    /** Caregiver requests I-9 form */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              form: components["schemas"]["ComplianceFormDocument"];
              questionOptionIdDocumentTypeIdEntries: [
                components["schemas"]["ComplianceFormQuestionOptionId"],
                components["schemas"]["CaregiverDocumentTypeId"]
              ][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/caregiver_document_upload/:caregiverDocumentUploadId": {
    /** Caregiver updates a caregiver document */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          caregiverDocumentUploadId: CaregiverDocumentUploadId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            expiryDate: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/review_document": {
    /** Reviewer requests & locks a document to review */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              document: components["schemas"]["ReviewDocumentRecord"];
              questions: components["schemas"]["ComplianceQuestion"][];
              uploadedDocuments: components["schemas"]["ComplianceReviewUploadedDocument"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              code: "NO_AVAILABLE_DOCUMENTS";
              message: string;
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/review_document/:complianceReviewRecordId/questionId/:questionId/answer": {
    /** Reviewer answers a question */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          complianceReviewRecordId: ComplianceReviewRecordId;
          questionId: ComplianceReviewQuestionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              questions: components["schemas"]["ComplianceQuestion"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              code: "FORBIDDEN" | "QUESTION_NOT_FOUND";
              message: string;
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            value: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/review_document/:complianceReviewRecordId": {
    /** Reviewer completes the review of a document */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          complianceReviewRecordId: ComplianceReviewRecordId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              code: "FORBIDDEN" | "UNANSWERED_QUESTIONS_FOUND";
              message: string;
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/compliance_automations": {
    /** Agency member gets compliance automations for a caregiver */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["ComplianceItemAutomationResult"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/agencies/:agencyId/compliance_form_documents/:documentTypeId": {
    /** Caregiver gets form questions */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
          documentTypeId: CaregiverDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              formDocument: components["schemas"]["ComplianceFormDocument"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/agencies/:agencyId/compliance_form_records": {
    /** Caregiver submits a form document */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
            questions: components["schemas"]["ComplianceFormQuestion"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/contractType/:contractTypeId/offices/:officeId/service_code_issues_settings": {
    /** Get the per-service-code issue setting overrides for a contract type + office, along with the eligible service codes (from Direct Care Rates) and issue-type metadata */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          contractTypeId: ContractTypeId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contractTypeId: components["schemas"]["ContractTypeId"];
              issueTypes: components["schemas"]["IssueTypeMeta"][];
              serviceCodes: components["schemas"]["EligibleServiceCode"][];
              overrides: components["schemas"]["ServiceCodeIssuesSetting"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/contractType/:contractTypeId/service_code_issues_settings": {
    /** Update or insert a service code's issue setting override under a contract type + office */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          contractTypeId: ContractTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contractTypeId: components["schemas"]["ContractTypeId"];
              officeId: components["schemas"]["OfficeId"];
              serviceCodeId: components["schemas"]["ServiceCodeId"];
              billing_issue_no_caregiver: null | boolean;
              billing_issue_clockin_time_mismatch: null | boolean;
              billing_issue_clockout_time_mismatch: null | boolean;
              billing_issue_calendar_day_mismatch: null | boolean;
              billing_issue_daily_minimum_hours_not_met: null | boolean;
              billing_issue_has_patient_overlap_issue: null | boolean;
              billing_issue_has_caregiver_overlap_issue: null | boolean;
              billing_issue_overbilled_day: null | boolean;
              billing_issue_missing_dx_codes: null | boolean;
              billing_issue_missed_visit_no_travel_time: null | boolean;
              billing_issue_no_billing_rate: null | boolean;
              billing_issue_no_billing_rate_county: null | boolean;
              billing_issue_missing_clock_times: null | boolean;
              billing_issue_invalid_authorization_assignment: null | boolean;
              billing_issue_missing_authorization_hours: null | boolean;
              billing_issue_missing_matching_mutual_visit: null | boolean;
              billing_issue_zero_billing_units: null | boolean;
              billing_issue_authorization_over_allocation: null | boolean;
              billing_issue_schedule_auth_allocation_conflict: null | boolean;
              billing_issue_no_matching_authorization: null | boolean;
              billing_issue_unapproved_manual_clock_time_edit: null | boolean;
              billing_issue_caregiver_incompliant: null | boolean;
              billing_issue_insufficient_visit_duties: null | boolean;
              billing_issue_missing_personal_care_duty: null | boolean;
              billing_issue_excessive_clock_distance: null | boolean;
              billing_issue_manual_hold_invoicing: null | boolean;
              billing_issue_zero_dollar_pay_rate: null | boolean;
              billing_issue_missing_caregiver_ssn: null | boolean;
              billing_issue_missing_patient_member_id: null | boolean;
              billing_issue_missing_address: null | boolean;
              payroll_issue_no_caregiver: null | boolean;
              payroll_issue_clockin_time_mismatch: null | boolean;
              payroll_issue_clockout_time_mismatch: null | boolean;
              payroll_issue_calendar_day_mismatch: null | boolean;
              payroll_issue_daily_minimum_hours_not_met: null | boolean;
              payroll_issue_has_patient_overlap_issue: null | boolean;
              payroll_issue_has_caregiver_overlap_issue: null | boolean;
              payroll_issue_overbilled_day: null | boolean;
              payroll_issue_missing_dx_codes: null | boolean;
              payroll_issue_missed_visit_no_travel_time: null | boolean;
              payroll_issue_no_billing_rate: null | boolean;
              payroll_issue_no_billing_rate_county: null | boolean;
              payroll_issue_missing_clock_times: null | boolean;
              payroll_issue_invalid_authorization_assignment: null | boolean;
              payroll_issue_missing_authorization_hours: null | boolean;
              payroll_issue_missing_matching_mutual_visit: null | boolean;
              payroll_issue_zero_billing_units: null | boolean;
              payroll_issue_authorization_over_allocation: null | boolean;
              payroll_issue_schedule_auth_allocation_conflict: null | boolean;
              payroll_issue_no_matching_authorization: null | boolean;
              payroll_issue_unapproved_manual_clock_time_edit: null | boolean;
              payroll_issue_caregiver_incompliant: null | boolean;
              payroll_issue_insufficient_visit_duties: null | boolean;
              payroll_issue_missing_personal_care_duty: null | boolean;
              payroll_issue_excessive_clock_distance: null | boolean;
              payroll_issue_manual_hold_invoicing: null | boolean;
              payroll_issue_zero_dollar_pay_rate: null | boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeId: components["schemas"]["OfficeId"];
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            billing_issue_no_caregiver: null | boolean;
            billing_issue_clockin_time_mismatch: null | boolean;
            billing_issue_clockout_time_mismatch: null | boolean;
            billing_issue_calendar_day_mismatch: null | boolean;
            billing_issue_daily_minimum_hours_not_met: null | boolean;
            billing_issue_has_patient_overlap_issue: null | boolean;
            billing_issue_has_caregiver_overlap_issue: null | boolean;
            billing_issue_overbilled_day: null | boolean;
            billing_issue_missing_dx_codes: null | boolean;
            billing_issue_missed_visit_no_travel_time: null | boolean;
            billing_issue_no_billing_rate: null | boolean;
            billing_issue_no_billing_rate_county: null | boolean;
            billing_issue_missing_clock_times: null | boolean;
            billing_issue_invalid_authorization_assignment: null | boolean;
            billing_issue_missing_authorization_hours: null | boolean;
            billing_issue_missing_matching_mutual_visit: null | boolean;
            billing_issue_zero_billing_units: null | boolean;
            billing_issue_authorization_over_allocation: null | boolean;
            billing_issue_schedule_auth_allocation_conflict: null | boolean;
            billing_issue_no_matching_authorization: null | boolean;
            billing_issue_unapproved_manual_clock_time_edit: null | boolean;
            billing_issue_caregiver_incompliant: null | boolean;
            billing_issue_insufficient_visit_duties: null | boolean;
            billing_issue_missing_personal_care_duty: null | boolean;
            billing_issue_excessive_clock_distance: null | boolean;
            billing_issue_manual_hold_invoicing: null | boolean;
            billing_issue_zero_dollar_pay_rate: null | boolean;
            billing_issue_missing_caregiver_ssn: null | boolean;
            billing_issue_missing_patient_member_id: null | boolean;
            billing_issue_missing_address: null | boolean;
            payroll_issue_no_caregiver: null | boolean;
            payroll_issue_clockin_time_mismatch: null | boolean;
            payroll_issue_clockout_time_mismatch: null | boolean;
            payroll_issue_calendar_day_mismatch: null | boolean;
            payroll_issue_daily_minimum_hours_not_met: null | boolean;
            payroll_issue_has_patient_overlap_issue: null | boolean;
            payroll_issue_has_caregiver_overlap_issue: null | boolean;
            payroll_issue_overbilled_day: null | boolean;
            payroll_issue_missing_dx_codes: null | boolean;
            payroll_issue_missed_visit_no_travel_time: null | boolean;
            payroll_issue_no_billing_rate: null | boolean;
            payroll_issue_no_billing_rate_county: null | boolean;
            payroll_issue_missing_clock_times: null | boolean;
            payroll_issue_invalid_authorization_assignment: null | boolean;
            payroll_issue_missing_authorization_hours: null | boolean;
            payroll_issue_missing_matching_mutual_visit: null | boolean;
            payroll_issue_zero_billing_units: null | boolean;
            payroll_issue_authorization_over_allocation: null | boolean;
            payroll_issue_schedule_auth_allocation_conflict: null | boolean;
            payroll_issue_no_matching_authorization: null | boolean;
            payroll_issue_unapproved_manual_clock_time_edit: null | boolean;
            payroll_issue_caregiver_incompliant: null | boolean;
            payroll_issue_insufficient_visit_duties: null | boolean;
            payroll_issue_missing_personal_care_duty: null | boolean;
            payroll_issue_excessive_clock_distance: null | boolean;
            payroll_issue_manual_hold_invoicing: null | boolean;
            payroll_issue_zero_dollar_pay_rate: null | boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/contractType/:contractTypeId/offices/:officeId/service_code_issues_settings/:serviceCodeId": {
    /** Reset a service code's issue setting override to inherit (removes the override row) */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          contractTypeId: ContractTypeId;
          officeId: OfficeId;
          serviceCodeId: ServiceCodeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/contract_types": {
    /** Agency member request a list off contract_types of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contractTypes: components["schemas"]["ContractType"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/patients/:patientId/contracts_extended": {
    /** Get the patient's extended contracts */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contractsAndTreatments: components["schemas"]["ContractExtendedData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/contracts/:contractId": {
    /** Edit contract */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          contractId: PatientContractId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["PatientContractId"];
            /** Format: PatientId */
            patient?: PatientId;
            startDate?: components["schemas"]["LocalDate"] | null;
            isPrimary?: boolean;
            medicaidNumber?: null | string;
            medicareNumber?: null | string;
            memberId?: string;
            isOnHold?: boolean;
            endDate?: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/custom_fields": {
    /** Agency members gets all agency custom fields list */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          entity?: "PATIENT" | "CAREGIVER";
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["CustomField"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** insert new agency custom field */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            entityName: components["schemas"]["CustomFieldEntity"];
            fieldName: string;
            fieldType: components["schemas"]["CustomFieldType"];
            fieldOptions?: string[];
            addToSettings: boolean;
            active: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/custom_field/:agencyCustomFieldId": {
    /** Agency member edit a custom field */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          agencyCustomFieldId: AgencyCustomFieldId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            fieldType?:
              | "ADDRESS"
              | "BOOLEAN"
              | "CAREGIVER"
              | "DATE"
              | "DATE_RANGE"
              | "ENUM"
              | "NUMBER"
              | "PATIENT"
              | "PHONE_NUMBER"
              | "TEXT";
            fieldOptions?: string[] | null;
            addToSettings?: boolean;
            active?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/custom_field/:agencyCustomFieldId/single_selection_custom_field": {
    /** Agency member edits a single selection custom field option */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          agencyCustomFieldId: AgencyCustomFieldId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            entityName: components["schemas"]["CustomFieldEntity"];
            fieldName: string;
            currentOption: string;
            newOption: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/time_sheet": {
    /** Get the time sheet for a visit instance */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              clockInTime: components["schemas"]["LocalTime"] | null;
              clockOutTime: components["schemas"]["LocalTime"] | null;
              /**
               * @description The same list, with the same `isRequired`, that the visit's duty sheet
               * reports. It used to be the whole plan with no requirement flag, so a past
               * visit's sheet disagreed with the clock-out sheet of the same visit.
               */
              requiredDutyTasks: components["schemas"]["RequiredDutySheetTask"][];
              selectedDuties: components["schemas"]["SelectedDutySheetTask"][];
              patientSignature: null | string;
              caregiverSignature: null | string;
              patientNotSignReason: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visit_instance/:visitInstanceId/manual_time_sheet": {
    /** Create manual duty sheet for visit instance */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              clockInTime: components["schemas"]["Instant"] | null;
              clockOutTime: components["schemas"]["Instant"] | null;
              timeSheetSubmittedAt: components["schemas"]["Instant"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "Can't submit timesheet for a billed visit"
                | "Can't submit timesheet for future visit"
                | "Can't submit timesheet prior to"
                | "Clock in time must be before clock out time";
              invalidVisits?: components["schemas"]["VisitInstanceDetailsInvalidClockTimes"][];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            clockInTime: components["schemas"]["LocalTime"];
            clockOutTime: components["schemas"]["LocalTime"];
            /**
             * @description Exactly the duty occurrences this timesheet reports, one entry per
             * occurrence.
             *
             * NOT a set of duties: a duty performed twice appears twice, once per
             * occurrence, each with its own note.
             *
             * The submission is authoritative for the occurrences it names AND for the
             * ones it does not — an occurrence of a named duty that this list omits is
             * retired. Duties it does not mention at all are left alone, so records made
             * by another channel survive.
             */
            selectedDutyTasks: {
              planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
              /**
               * @description Which occurrence of the duty this entry reports.
               *
               * OPTIONAL, and absent means occurrence 1 — which is what every timesheet
               * submitted before occurrences existed meant. App versions that have not
               * migrated keep behaving exactly as they did. Must be 1 or greater when
               * sent.
               */
              occurrenceIndex?: number;
              notes: null | string;
            }[];
            patientSignature: null | string;
            patientNotSignReason: null | string;
            caregiverSignature: string;
            clockinGeoLocation?: components["schemas"]["Geo"] | null;
            clockoutGeoLocation?: components["schemas"]["Geo"] | null;
            /** @enum {string} */
            clockinLocation?: "COMMUNITY" | "HOME";
            /** @enum {string} */
            clockoutLocation?: "COMMUNITY" | "HOME";
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/time_sheet/v2": {
    /** Get the time sheet for a visit instance, with duty answers per occurrence */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              clockInTime: components["schemas"]["LocalTime"] | null;
              clockOutTime: components["schemas"]["LocalTime"] | null;
              /** @description True when the office changed the visit's clocks after the timesheet was sent. */
              clocksChanged: boolean;
              duties: components["schemas"]["CaregiverVisitDutyV2"][];
              patientSignature: null | string;
              caregiverSignature: null | string;
              patientNotSignReason: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Submit the time sheet for a visit instance, with duty answers per occurrence */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              clockInTime: components["schemas"]["Instant"] | null;
              clockOutTime: components["schemas"]["Instant"] | null;
              timeSheetSubmittedAt: components["schemas"]["Instant"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "Can't submit timesheet for a billed visit"
                | "Can't submit timesheet for future visit"
                | "Can't submit timesheet prior to"
                | "Clock in time must be before clock out time";
              invalidVisits?: components["schemas"]["VisitInstanceDetailsInvalidClockTimes"][];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            clockInTime: components["schemas"]["LocalTime"];
            clockOutTime: components["schemas"]["LocalTime"];
            /** @description Every answered occurrence on the visit. Omitted occurrences become unanswered. */
            answers: {
              planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
              occurrenceIndex: number;
              answer: components["schemas"]["CaregiverDutyAnswerV2"];
            }[];
            patientSignature: null | string;
            patientNotSignReason: null | string;
            caregiverSignature: string;
            clockinGeoLocation: components["schemas"]["Geo"] | null;
            clockoutGeoLocation: components["schemas"]["Geo"] | null;
            clockinLocation: ("COMMUNITY" | "HOME") | null;
            clockoutLocation: ("COMMUNITY" | "HOME") | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/time_sheet_approval": {
    /** Create manual duty sheet for visit instance */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          coordinators?: string;
          offices?: string;
          teams?: string;
          statuses?: string;
          dateByTimesheet?: boolean;
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              timeSheets: components["schemas"]["TimeSheetApproval"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create manual duty sheet for visit instance */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            timesheets: components["schemas"]["TimeSheetForApproval"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/time_sheet_decline": {
    /** Decline manual duty sheet for visit instance */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            timesheets: components["schemas"]["TimeSheetForApproval"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/duty_sheet": {
    /** Get the duty sheet form for a visit instance */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              requiredDutyTasks: components["schemas"]["RequiredDutySheetTask"][];
              selectedDuties: components["schemas"]["SelectedDutySheetTask"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/duty_sheet/v2": {
    /** Get the caregiver duty sheet: one row per occurrence to answer */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              duties: components["schemas"]["CaregiverVisitDutyV2"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/duty_sheet/answer": {
    /** Answer one occurrence of a duty on a visit instance */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
            /** @description Which occurrence is being answered. 1 or greater. */
            occurrenceIndex: number;
            /** @description Whether this occurrence was performed. False retires the record for it. */
            completed: boolean;
            /**
             * @description The caregiver's note about THIS occurrence.
             *
             * Omitting the field leaves any note already recorded alone; sending one
             * replaces it, and `null` clears it. Kept separate from `completed` so an app
             * can save a note without asserting anything about whether the work is done.
             */
            notes?: null | string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/duty_sheet/v2/occurrence": {
    /** Set the caregiver's answer for one occurrence of a duty */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
            occurrenceIndex: number;
            /** @description null clears the occurrence back to unanswered. */
            answer:
              | {
                  /** @enum {string} */
                  type: "DONE";
                  notes: null | string;
                  startTime: components["schemas"]["LocalDateTime"] | null;
                  endTime: components["schemas"]["LocalDateTime"] | null;
                }
              | {
                  /** @enum {string} */
                  type: "NOT_DONE";
                  reason: null | string;
                }
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/export_batches/create_exports_zip_file": {
    /** Created a zip file from selected export batches files. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              zipFileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            exportsIds: components["schemas"]["ExportBatchId"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/application_banner": {
    /** Mobile asks whether to show banner application banner or not */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              show: boolean;
              chatAgencyMemberId:
                | components["schemas"]["AgencyMemberId"]
                | null;
              onboardingStage:
                | (
                    | "generalDetails"
                    | "interview"
                    | "landingPage"
                    | "onboarding1"
                    | "onboarding2"
                  )
                | null;
              caregiverStatus:
                | (
                    | "ACTIVE"
                    | "JOIN_REQUEST"
                    | "ON_HOLD"
                    | "ON_LEAVE"
                    | "PENDING"
                    | "QUIT"
                    | "REJECTED"
                    | "SUSPENDED"
                    | "TERMINATED"
                  )
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/hr_application_answer": {
    /** Caregiver submits answer to hr application */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              isSuccessful: boolean;
              reason?: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error: "Agency not authorized";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["HRQuestion.TextQuestion"]
            | components["schemas"]["HRQuestion.AddressQuestion"]
            | components["schemas"]["HRQuestion.EmailQuestion"]
            | components["schemas"]["HRQuestion.NumericQuestion"]
            | components["schemas"]["HRQuestion.DollarQuestion"]
            | components["schemas"]["HRQuestion.PhoneNumberQuestion"]
            | components["schemas"]["HRQuestion.SSNQuestion"]
            | components["schemas"]["HRQuestion.FullDateQuestion"]
            | components["schemas"]["HRQuestion.BirthDateQuestion"]
            | components["schemas"]["HRQuestion.MonthYearDateQuestion"]
            | components["schemas"]["HRQuestion.YearDateQuestion"]
            | components["schemas"]["HRQuestion.RadioQuestion"]
            | components["schemas"]["HRQuestion.DropDownQuestion"]
            | components["schemas"]["HRQuestion.CheckboxQuestion"]
            | components["schemas"]["HRQuestion.SignatureQuestion"]
            | components["schemas"]["HRQuestion.GeneralSignatureQuestion"]
            | components["schemas"]["HRQuestion.StartAndEndTimeQuestion"]
            | components["schemas"]["HRQuestion.StarQuestion"]
            | components["schemas"]["HRQuestion.Placeholder"]
            | components["schemas"]["HRQuestion.DocumentQuestion"]
            | components["schemas"]["HRQuestion.DocumentWithExpiryQuestion"]
            | components["schemas"]["HRQuestion.AmericanTestQuestion"]
            | components["schemas"]["HRQuestion.FreeTextQuestion"]
            | components["schemas"]["HRQuestion.TitelTextQuestion"]
            | components["schemas"]["HRQuestion.PlainTextQuestion"]
            | components["schemas"]["HRQuestion.DownloadableFileQuestion"]
            | components["schemas"]["HRQuestion.DocumentWithEffectiveDateQuestion"]
            | components["schemas"]["HRQuestion.Video"]
            | components["schemas"]["HRQuestion.InterviewQuestion"];
        };
      };
    };
  };
  "/hr/caregivers/:caregiverId/subsection/:subSectionId/generate_subsection": {
    /** generates caregiver subsection form */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          subSectionId: HRSubSectionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/hr/caregivers/:caregiverId/subsection/:subsectionId/send_reference_message": {
    /** generates caregiver subsection form */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          subsectionId: HRSubSectionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            notificationType: "Email" | "SMS";
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/welcome_chat_message": {
    /** Sends welcome chat message to caregiver */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/certifications/:certification/application_form": {
    /** Caregiver requests application form for mobile - medflyt agency */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          certification: string;
        };
        query: {
          language?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sections: components["schemas"]["HRSection"][];
              settings: components["schemas"]["HRApplicationFormSettings"];
              orientationBundleDueDateId: components["schemas"]["TrainingCenterBundleDueDateId"];
              caregiverSectionStageId:
                | components["schemas"]["HRSectionStageId"]
                | null;
              caregiverSectionStageLabel: null | string;
              showMessageOnVideoThumbnail: boolean;
              isCriminalBackgroundCompliant: boolean;
              emailVerificationTemplateId:
                | components["schemas"]["HRQuestionTemplateId"]
                | null;
              isInterviewCompliant: null | boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/hr/agencies/:agencyId/caregivers/:caregiverId/documents": {
    /** Get caregiver hr documents data for agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: components["schemas"]["HRDocumentData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/application_certifications": {
    /** Get caregiver hr application certifications. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              certifications: components["schemas"]["CaregiverCertification"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/hr/agencies/:agencyId/caregivers/:caregiverId/certifications/:certification/caregiver_application_answers": {
    /** Get caregiver hr application answers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
          certification: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sections: components["schemas"]["HRSection"][];
              settings: components["schemas"]["HRApplicationFormSettings"];
              orientationBundleDueDateId: components["schemas"]["TrainingCenterBundleDueDateId"];
              caregiverSectionStageId:
                | components["schemas"]["HRSectionStageId"]
                | null;
              caregiverSectionStageLabel: null | string;
              showMessageOnVideoThumbnail: boolean;
              isCriminalBackgroundCompliant: boolean;
              emailVerificationTemplateId:
                | components["schemas"]["HRQuestionTemplateId"]
                | null;
              isInterviewCompliant: null | boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/hr/agencies/:agencyId/caregivers/:caregiverId/send_i9_data": {
    /** Complete i-9 form */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            reHireDate: components["schemas"]["LocalDate"] | null;
            type: string;
            subsection: components["schemas"]["HRSubSectionId"];
          };
        };
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/send_8850_data": {
    /** Complete 8850 form */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              title: string;
              url: string;
              bucket: string;
              key: string;
              signedAt: components["schemas"]["Instant"];
              docType: components["schemas"]["CaregiverDocumentTypeId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            question: components["schemas"]["HRQuestion"];
            subsectionId: components["schemas"]["HRSubSectionId"];
          };
        };
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/agency_confirm_subsection": {
    /** Complete susbection form */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              title: string;
              url: string;
              bucket: string;
              key: string;
              signedAt: components["schemas"]["Instant"];
              docType: components["schemas"]["CaregiverDocumentTypeId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            questions: components["schemas"]["HRQuestion"][];
            subsectionId: components["schemas"]["HRSubSectionId"];
          };
        };
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/hr_section_stages": {
    /** Agency member request all hr section stages */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sectionStages: components["schemas"]["SectionStagesByCertification"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/hr_application_answers/:hrQuestionId": {
    /** Agency member reject caregiver application answer */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          hrQuestionId: HRQuestionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            rejectStatus?:
              | {
                  /** @enum {boolean} */
                  rejected: true;
                  reason: string;
                }
              | {
                  /** @enum {boolean} */
                  rejected: false;
                };
          };
        };
      };
    };
  };
  "/hr/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/copy_application": {
    /** Copy caregiver certification application */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fromCertification: components["schemas"]["CaregiverCertification"];
            toCertification: components["schemas"]["CaregiverCertification"];
          };
        };
      };
    };
  };
  "/i9_reviewer/:token": {
    /** Get i9 reviewer information */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              files: components["schemas"]["I9CaregiverUploadedFiles"][];
              reviewerName: string;
              caregiverName: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "I-9 Data not found"
                | "Invalid token"
                | "Reviewer name not found"
                | "Token already used"
                | "agency not authorizaed";
            };
          };
        };
      };
    };
    /** I9 reviewer post signature */
    post: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "Agency not authorized"
                | "I-9 Data not found"
                | "Invalid token"
                | "Signature question not found"
                | "Token already used";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            base64Signature: string;
            approved: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/icd_10_codes/auto_complete": {
    /** Agency member required autocomplete data matching the provided search string */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          search_string?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              codes: components["schemas"]["Icd10Code"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/insta_pay_rules_exempt": {
    /** Agency changes visit exemption from instapay rules */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              exempt: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            exempt: boolean;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/payroll_information": {
    /** Caregiver requests their weekly payroll information from the mobile application */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
        query: {
          weekNum?: number;
          stub?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              overview: {
                eligibleBalance: number;
                totalPayroll: number;
              };
              totalVisits: number;
              totalHours: string;
              bankInformation:
                | components["schemas"]["CaregiverBankInformationWithEmail"]
                | null;
              prevWeek: components["schemas"]["LocalDate"];
              nextWeek: components["schemas"]["LocalDate"];
              visits: components["schemas"]["InstaPayVisitData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/payroll/overview": {
    /** Caregiver requests their payroll overview */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              balance: number;
              totalVisits: number;
              totalHours: string;
              bankInformation:
                | components["schemas"]["CaregiverBankInformationWithEmail"]
                | null;
              visits: components["schemas"]["EligibleInstaPayVisit"][];
              isHoliday: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/insta_pay_info": {
    /** Caregiver requests their instapy account info */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              bankAccountInfoWithMail:
                | components["schemas"]["CaregiverBankInformationWithEmail"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/insta_pay_info/bank_account_types": {
    /** Get the bank account types */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accountTypes: components["schemas"]["BankAccountType"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/insta_pay_info/banks": {
    /** Get banks names */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              banks: components["schemas"]["BankAccountName"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/set_bank_information": {
    /** Caregiver sets their bank information */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            accountType: components["schemas"]["InstaPayBankAccountTypeId"];
            bankId: components["schemas"]["InstaPayBankId"];
            routingNumber: string;
            accountNumber: string;
            email: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/update_bank_information": {
    /** Caregiver updates their bank information */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            accountType: components["schemas"]["InstaPayBankAccountTypeId"];
            bankId: components["schemas"]["InstaPayBankId"];
            routingNumber: string;
            accountNumber: string;
            email: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/withdraw_payment": {
    /** Withdraw payment and update the caregiver's payment info. */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              expectedDeliveryTime: components["schemas"]["Instant"];
              hasHoliday: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            eligibleVisitInstanceIds: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/insta_pay_info/bank_account_types": {
    /** Agency member requests bank account types */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accountTypes: components["schemas"]["BankAccountType"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/insta_pay_info/banks": {
    /** Agency member requests banks names */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              banks: components["schemas"]["BankAccountName"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/insta_pay_info/bank_information": {
    /** Agency member requests to view caregiver bank information */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          caregiverId?: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              bankAccountInformation:
                | components["schemas"]["CaregiverBankInformation"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member requests to update caregiver bank information */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          caregiverId?: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            routingNumber: string;
            accountNumber: string;
            bankAccountTypeId: components["schemas"]["InstaPayBankAccountTypeId"];
            bankId: components["schemas"]["InstaPayBankId"];
            hasAgreedToTerms: boolean;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/paystubs": {
    /** Caregiver requests their paystubs */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              paystubs: components["schemas"]["Paystub"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/paystub": {
    /** Caregiver request download specific paytub */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            paystub: components["schemas"]["Paystub"];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/receipts": {
    /** Contractor requests their receipt data */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              receipts: components["schemas"]["PayReceipt"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/receipt": {
    /** Caregiver request download specific pay receipt */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            receipt: components["schemas"]["PayReceipt"];
          };
        };
      };
    };
  };
  "/insurers/:insurerId/patients/:patientId": {
    /** Get patient extended data */
    get: {
      parameters: {
        path: {
          insurerId: InsurerId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientId"];
              status: components["schemas"]["PatientStatus"];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              createdByName: null | string;
              currentOfficeId: components["schemas"]["OfficeId"];
              currentOfficeName: null | string;
              contracts: components["schemas"]["ContractExtendedData"][];
              clinicalInfo: components["schemas"]["PatientClinicalInfo"][];
              socialWorker: components["schemas"]["BasicSocialWorker"] | null;
              source: components["schemas"]["BasicReferralSource"] | null;
              ssn: null | string;
              firstName: string;
              middleName: null | string;
              lastName: string;
              gender: null | string;
              dateOfBirth: components["schemas"]["LocalDate"] | null;
              address: components["schemas"]["PatientAddressComponents"] | null;
              address2: null | string;
              addressInstructions: null | string;
              generalNotes: null | string;
              medicalNotes: null | string;
              medicareNumber: null | string;
              medicaidNumber: null | string;
              clinicalSeverityLevel:
                | (
                    | "HIGHEST_ASSISTANCE"
                    | "MINIMAL_ASSISTANCE"
                    | "WALKING_ASSISTANCE"
                  )
                | null;
              wageParityNumber: null | number;
              mainLanguage: null | string;
              secondaryLanguage: null | string;
              preferredHHAGender: null | string;
              smoking: null | boolean;
              pets: null | string;
              kosherHome: null | boolean;
              kidsInHouse: null | number;
              familyInformation:
                | components["schemas"]["PatientFamilyInformation"][]
                | null;
              contacts: components["schemas"]["PatientContact"][] | null;
              emergencyContact:
                | components["schemas"]["PatientEmergencyContact"][]
                | null;
              priorityCode: null | number;
              evacuationZone: null | string;
              mobilityStatus: null | string;
              evacuationLocation: null | string;
              electricEquipmentDependency: null | string;
              allergies: components["schemas"]["Allergy"][];
              patientHIClaim: null | string;
              email: null | string;
              assignedSalesRep: components["schemas"]["AgencyMemberId"] | null;
              assignedSalesRepName: null | string;
              assignedIntake: components["schemas"]["AgencyMemberId"] | null;
              assignedIntakeName: null | string;
              assignedCoordinator:
                | components["schemas"]["AgencyMemberId"]
                | null;
              assignedCoordinatorName: null | string;
              agencyTeamId: components["schemas"]["AgencyTeamId"] | null;
              agencyTeamName: null | string;
              assignedDPS: components["schemas"]["AgencyMemberId"] | null;
              assignedDPSName: null | string;
              updatedAt: components["schemas"]["Instant"];
              updatedBy: components["schemas"]["AgencyMemberId"];
              updatedByName: null | string;
              linkedPatient: components["schemas"]["LinkedPatient"];
              phoneNumbers: components["schemas"]["PatientPhoneNumber"][];
              addresses: components["schemas"]["PatientAddress"][];
              nurseOnCase: components["schemas"]["MiniCaregiver"] | null;
              caregiverOnCase: components["schemas"]["MiniCaregiver"] | null;
              missingAddressFields?: string[];
              displayId: null | number;
              agencyBranchIds: components["schemas"]["AgencyBranchId"][];
              customFields: components["schemas"]["PatientEntityCustomField"];
              externalId: null | string;
              locationGroupName: null | string;
              blacklisted: components["schemas"]["CaregiverId"][] | null;
              blacklistedCaregivers: {
                caregiverId: components["schemas"]["CaregiverId"];
                displayName: string;
                displayId: null | number;
                status: null | string;
                photoUrl: null | string;
              }[];
              wageParity: null | boolean;
              vacations: components["schemas"]["PatientVacation"][];
              startOfCare: components["schemas"]["LocalDate"] | null;
              eligibiltyStatus:
                | components["schemas"]["PatientEligibiltyStatus"]
                | null;
              isCustomAddress: boolean;
              mainPhoneNumber: null | string;
              advancedDirective:
                | components["schemas"]["PatientAdvancedDirective"]
                | null;
              isTestUser: boolean;
              pimsId: null | string;
              currCertPeriodTaskStatus: components["schemas"]["PatientCertificationPeriodTaskStatus"];
              arizonaContingencyPlanCode?: null | string;
              orderingPcpNpi: null | string;
              adultServiceWorkerName: null | string;
              adultServiceWorkerEmail: null | string;
              aideFrequency: null | string;
              serviceType: null | string;
              payerSource: null | string;
              agencyBranches: {
                id: components["schemas"]["AgencyBranchId"];
                name: string;
              }[];
              criticalInformationForFirstResponders: null | string;
              hhaxAdmissionIdOverride: null | number;
              maPayerProgramCode: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/invoices": {
    /** Agency member requested all patient invoices including related details */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              invoices: components["schemas"]["InvoiceDetails"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            pageNum: number;
            pageSize: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/unexport_invoices": {
    /** Unexport invoices */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            invoiceIds: components["schemas"]["InvoiceId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/medication_profile": {
    /** Agency member requests patient medication profile */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              medications: components["schemas"]["PatientMedicationProfileWithDetails"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient/:patientId/medication_profile": {
    /** Caregiver requests patient medication profile */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              medications: components["schemas"]["PatientMedicationProfileWithDetails"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient/:patientId/medication_profile/search": {
    /** Caregiver requests search for medications by patient id, query = &value */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
        query: {
          value?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              medications: components["schemas"]["Medication"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/medications/similar_medications": {
    /** Agency member checks whether there are similar medications before crateing a new one */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              type: components["schemas"]["CreateAgencyMedicationValidationType"];
              similarMedications: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            displayName: string;
            route: string;
            dose: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/agency_medication_profile": {
    /** Agency member creates a new agency medication and adding to patient medication profile */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: VisitBroadcastId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientMedicationProfileId"];
              patientId: components["schemas"]["PatientId"];
              medicationId: components["schemas"]["MedicationId"];
              from: components["schemas"]["LocalDate"] | null;
              until: components["schemas"]["LocalDate"] | null;
              frequency: null | string;
              status: components["schemas"]["PatientMedicationProfileStatus"];
              notes: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            displayName: string;
            route: string;
            dose: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/medications/search": {
    /** A nurse searches for medications by medication name */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
        query: {
          searchString?: string;
          offset?: number;
          limit?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalResultsCount: number;
              medications: {
                name: string;
                doses: string[];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/medication_recommendations": {
    /** A nurse requests medication recommendations */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
        query: {
          medicationName?: string;
          dosage?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              frequencies: string[];
              administrationNotes: string[];
              diagnosisCodes: {
                code: string;
                description: string;
                existsInProfile: boolean;
              }[];
              dosages: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/medication_recommendations": {
    /** A nurse requests medication recommendations */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
        query: {
          medicationName?: string;
          dosage?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              frequencies: string[];
              administrationNotes: string[];
              diagnosisCodes: {
                code: string;
                description: string;
                existsInProfile: boolean;
              }[];
              dosages: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/medications": {
    /** A nurse requests patient medications */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              medications: {
                id: components["schemas"]["PatientMedicationId"];
                name: string;
                dosage: string;
                frequency: null | string;
                administrationNotes: null | string;
                diagnosisCodes: components["schemas"]["PatientMedicationDiagnosisCode"][];
              }[];
              draftMedications: components["schemas"]["DraftMedication"][];
              notTakingMedications: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** A nurse inserts a new medication for a patient */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            dosage: string;
            frequency: null | string;
            administrationNotes: null | string;
            /** Format: PatientTaskInstanceId */
            taskInstanceId?: PatientTaskInstanceId;
            diagnosisCodes?: {
              code: string;
              type: components["schemas"]["DiagnosisCodeType"];
            }[];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/not_taking_medications": {
    /** A nurse indicates whether the patient is not taking any medications */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            notTakingMedications: boolean;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/medications/:medicationId": {
    /** A nurse updates a patient's medication */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
          medicationId: PatientMedicationId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            dosage: string;
            frequency: null | string;
            administrationNotes: null | string;
          };
        };
      };
    };
    /** A nurse deletes a patient's medication */
    delete: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
          medicationId: PatientMedicationId;
        };
        query: {
          deleteDiagnosisCodes?: boolean;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/medications/extract_from_text": {
    /** Extracts medications from the OCR text of a patient's medication list. The text is scrubbed of the patient's PII and sent to OpenAI. Nothing is saved — the nurse reviews the result before saving. */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              medications: components["schemas"]["ScannedMedication"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            text: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/medications/search": {
    /** An agency member searches for medications by medication name */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          searchString?: string;
          offset?: number;
          limit?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalResultsCount: number;
              medications: {
                name: string;
                doses: string[];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/medications": {
    /** An agency member requests patient medications */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              medications: {
                id: components["schemas"]["PatientMedicationId"];
                name: string;
                dosage: string;
                frequency: null | string;
                administrationNotes: null | string;
              }[];
              notTakingMedications: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** An agency member inserts a new medication for a patient */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            dosage: string;
            frequency: null | string;
            administrationNotes: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/not_taking_medications": {
    /** An agency member indicates whether the patient is not taking any medications */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            notTakingMedications: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/medications/:medicationId": {
    /** An agency member updates a patient's medication */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          medicationId: PatientMedicationId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            dosage: string;
            frequency: null | string;
            administrationNotes: null | string;
          };
        };
      };
    };
    /** An agency member deletes a patient's medication */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          medicationId: PatientMedicationId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/upload_medication_photo_presigned_urls": {
    /** Caregiver requests a pre-signed URL to upload medication photo for a task instance */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              response: components["schemas"]["medicationPhotoUrlResponse"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            keys: string[];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/task_instances/:taskInstanceId/generate_medication_photo_attempt": {
    /** Caregiver requests a generation attempt for uploaded medication photos for a task instance */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalMedicationsExtracted: number;
              partiallyExtractedMedications: number;
              successfullyExtractedMedications: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            keys: string[];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/draft_medications/:draftMedicationId": {
    /** Caregiver updates a draft medication */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          draftMedicationId: PatientDraftMedicationId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            dosage?: null | string;
            frequency?: null | string;
            administrationNotes?: null | string;
            diagnosisCodes?: {
              code: string;
              type: components["schemas"]["DiagnosisCodeType"];
            }[];
          };
        };
      };
    };
    /** Caregiver deletes a draft medication */
    delete: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          draftMedicationId: PatientDraftMedicationId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/draft_medications/:draftMedicationId": {
    /** Caregiver submits a draft medication */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          draftMedicationId: PatientDraftMedicationId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            dosage: string;
            frequency: null | string;
            administrationNotes: null | string;
            /** Format: PatientTaskInstanceId */
            taskInstanceId?: PatientTaskInstanceId;
            diagnosisCodes?: {
              code: string;
              type: components["schemas"]["DiagnosisCodeType"];
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices": {
    /** Agency member request a list off offices of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              offices: components["schemas"]["OfficeExtended"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/office/:officeId": {
    /** Update office details */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              mmis: null | string;
              id: components["schemas"]["OfficeId"];
              name: string;
              agencyId: components["schemas"]["AgencyId"];
              active: boolean;
              address: string;
              address2: null | string;
              addressComponents:
                | components["schemas"]["AddressComponents"]
                | null;
              timezone: string;
              hhaExternalIds?: null | string;
              phoneNumber: null | string;
              tax_id: null | string;
              npi: null | string;
              provider_id: null | string;
              external_name: null | string;
              pfi: null | string;
              onlyPayBilledVisits: boolean;
              allowBillPendingVisits: boolean;
              requireCaregiverAssignWithOvertimePermission: boolean;
              broadcastBasedOnCaregiverOfficeBranch: boolean;
              showPayratesToCaregivers: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            active?: boolean;
            name?: string;
            address?: components["schemas"]["OfficeAddress"];
            address2?: null | string;
            phoneNumber?: null | string;
            tax_id?: string;
            npi?: string;
            mmis?: string;
            external_name?: string;
            pfi?: null | string;
            allowBillPendingVisits?: boolean;
            onlyPayBilledVisits?: boolean;
            requireCaregiverAssignWithOvertimePermission?: boolean;
            broadcastBasedOnCaregiverOfficeBranch?: boolean;
            showPayratesToCaregivers?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/office": {
    /** Insert new office */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              mmis: null | string;
              id: components["schemas"]["OfficeId"];
              name: string;
              agencyId: components["schemas"]["AgencyId"];
              active: boolean;
              address: string;
              address2: null | string;
              addressComponents:
                | components["schemas"]["AddressComponents"]
                | null;
              timezone: string;
              hhaExternalIds?: null | string;
              phoneNumber: null | string;
              tax_id: null | string;
              npi: null | string;
              provider_id: null | string;
              external_name: null | string;
              pfi: null | string;
              onlyPayBilledVisits: boolean;
              allowBillPendingVisits: boolean;
              requireCaregiverAssignWithOvertimePermission: boolean;
              broadcastBasedOnCaregiverOfficeBranch: boolean;
              showPayratesToCaregivers: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            address: components["schemas"]["OfficeAddress"];
            phoneNumber: null | string;
            tax_id?: null | string;
            npi?: null | string;
            provider_id?: null | string;
            external_name?: null | string;
            pfi?: null | string;
            address2: null | string;
            onlyPayBilledVisits?: boolean;
            allowBillPendingVisits?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/offices/agency_members/:agencyMemberId/assoc_agency_members": {
    /** An agency member attempts to associate agency members to offices */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            associations: components["schemas"]["AssocAgencyMemberParams"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/offices/agency_members/:agencyMemberId/assoc_caregivers": {
    /** An agency member attempts to associate caregivers to offices */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            associations: components["schemas"]["AssocCaregiverParams"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/certification_periods": {
    /** get all patient certification periods */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              certificationPeriods: components["schemas"]["PatientActiveCertificationPeriod"][];
              /** @description The patients these periods belong to, so the page need not resolve them. */
              patients: components["schemas"]["PatientRowDisplay"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "ErrorParsingRow";
              message: string;
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/certification_periods": {
    /** get certification periods for patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              certificationPeriods: components["schemas"]["PatientCertificationPeriod"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "ErrorParsingRow";
              message: string;
            };
          };
        };
      };
    };
    /** agency member creates a certification period */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              certificationPeriod: components["schemas"]["PatientCertificationPeriod"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            type: components["schemas"]["CertificationPeriodType"];
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/certification_periods/:certificationPeriodId/assign_task": {
    /** assign reassessment or start of care task for certification period */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          certificationPeriodId: CertificationPeriodId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              task:
                | components["schemas"]["PatientTaskTypes.DraftTask"]
                | components["schemas"]["PatientTaskTypes.RegularTask"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "TaskAlreadyExists";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            caregiverId: components["schemas"]["CaregiverId"] | null;
            taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
            title: string;
            repeatMonths: null | number;
            isDraft: boolean;
            startDate: components["schemas"]["LocalDate"];
            dueDate: components["schemas"]["LocalDate"];
            planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
            documents: components["schemas"]["PatientDocumentTypeId"][];
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            patientContractId: components["schemas"]["PatientContractId"];
            payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
            broadcastDistance: null | number;
            isBroadcasting: boolean;
            priority: number;
            dayTimeParams: components["schemas"]["TaskDayTimeParams"];
            dayTimeScheduleOverrideParams?:
              | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
              | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
              | null;
            certificationPeriodId:
              | components["schemas"]["CertificationPeriodId"]
              | null;
            isFutureAssigned: boolean;
            scheduledDateTime:
              | components["schemas"]["PatientTaskInstanceEditScheduleDateTime"]
              | null;
            taskIssues?: string[];
            price?: null | number;
            agencyNote: null | string;
            notes?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/certification_periods/check_anomalies": {
    /** find anomalies of certification period */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              gapped:
                | components["schemas"]["PatientCertificationPeriod"]
                | null;
              overlaps: components["schemas"]["PatientCertificationPeriod"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
            patientId: components["schemas"]["PatientId"];
            certificationPeriodId:
              | components["schemas"]["CertificationPeriodId"]
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/certification_periods/:certificationPeriodId": {
    /** Agency member updates certification period */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          certificationPeriodId: CertificationPeriodId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              certificationPeriod: components["schemas"]["PatientCertificationPeriod"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            type: components["schemas"]["CertificationPeriodType"];
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
            isCompleted: boolean;
          };
        };
      };
    };
    /** Agency member deletes certification period */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          certificationPeriodId: CertificationPeriodId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_contract_diagnosis_codes": {
    /** Agency member request a list of patient contract diagnosis codes related to a patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientContractDiagnosisCodes: components["schemas"]["PatientContractDiagnosisCode"][];
              /** Format: PatientContractDiagnosisCodeId */
              createdId?: PatientContractDiagnosisCodeId;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_contract_diagnosis_codes/:patientContractDiagnosisCodeId": {
    /** Agency member delete a patient contract diagnosis code */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientContractDiagnosisCodeId: PatientContractDiagnosisCodeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_contract_diagnosis_codes/bulk": {
    /** Bulk insert new patient_contract_diagnosis_code */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientContractId: components["schemas"]["PatientContractId"];
            codes: {
              icdCode: components["schemas"]["ICD10CodeId"];
              startDate: components["schemas"]["LocalDate"];
              endDate: components["schemas"]["LocalDate"];
              type: ("PRINCIPAL" | "SURGICAL") | null;
              isForBilling: boolean;
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_medical_diagnosis_codes": {
    /** Agency member requests a list of patient medical diagnosis codes for a patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientMedicalDiagnosisCodes: components["schemas"]["PatientMedicalDiagnosisCode"][];
              /** Format: PatientMedicalDiagnosisCodeId */
              createdId?: PatientMedicalDiagnosisCodeId;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_medical_diagnosis_codes": {
    /** Insert new patient medical diagnosis code */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientMedicalDiagnosisCodeId"];
              patientId: components["schemas"]["PatientId"];
              icdCode: components["schemas"]["ICD10CodeId"];
              formattedDxCode: string;
              shortDesc: string;
              /** @enum {string} */
              designation: "OTHER" | "PRIMARY";
              /** @description Free text, e.g. "Provider" or "Plan". */
              source: null | string;
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            icdCode: components["schemas"]["ICD10CodeId"];
            /** @enum {string} */
            designation: "OTHER" | "PRIMARY";
            source?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_medical_diagnosis_codes/:patientMedicalDiagnosisCodeId": {
    /** Update patient medical diagnosis code details */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientMedicalDiagnosisCodeId: PatientMedicalDiagnosisCodeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientMedicalDiagnosisCodeId"];
              patientId: components["schemas"]["PatientId"];
              icdCode: components["schemas"]["ICD10CodeId"];
              formattedDxCode: string;
              shortDesc: string;
              /** @enum {string} */
              designation: "OTHER" | "PRIMARY";
              /** @description Free text, e.g. "Provider" or "Plan". */
              source: null | string;
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            designation?: "OTHER" | "PRIMARY";
            /** Format: ICD10CodeId */
            icdCode?: ICD10CodeId;
            source?: null | string;
          };
        };
      };
    };
    /** Delete a patient medical diagnosis code */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientMedicalDiagnosisCodeId: PatientMedicalDiagnosisCodeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/patient_medical_diagnosis_codes": {
    /** Caregiver gets patient medical diagnosis codes by visit instance id */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientMedicalDiagnosisCodes: components["schemas"]["PatientMedicalDiagnosisCode"][];
              /** Format: PatientMedicalDiagnosisCodeId */
              createdId?: PatientMedicalDiagnosisCodeId;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_medical_diagnosis_codes": {
    /** Caregiver gets patient medical diagnosis codes by task instance id */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientMedicalDiagnosisCodes: components["schemas"]["PatientMedicalDiagnosisCode"][];
              /** Format: PatientMedicalDiagnosisCodeId */
              createdId?: PatientMedicalDiagnosisCodeId;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_medical_diagnosis_codes": {
    /** Caregiver creates a patient medical diagnosis code */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientMedicalDiagnosisCodes: components["schemas"]["PatientMedicalDiagnosisCode"][];
              /** Format: PatientMedicalDiagnosisCodeId */
              createdId?: PatientMedicalDiagnosisCodeId;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            icdCode: components["schemas"]["ICD10CodeId"];
            /** @enum {string} */
            designation: "OTHER" | "PRIMARY";
            source?: null | string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_medical_diagnosis_codes/:patientMedicalDiagnosisCodeId": {
    /** Caregiver deletes a patient medical diagnosis code */
    delete: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientMedicalDiagnosisCodeId: PatientMedicalDiagnosisCodeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/service_plans": {
    /** Agency member lists CDSC service plans and imports for a patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              servicePlans: components["schemas"]["PatientServicePlanListItem"][];
              imports: components["schemas"]["PatientServicePlanImportListItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/plan_of_care_items": {
    /** Agency member lists the plan of care items a service plan task can be mapped to */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientPlanOfCareItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/service_plans/:patientServicePlanId": {
    /** Agency member gets a CDSC service plan with its tasks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientServicePlanId"];
              patientId: components["schemas"]["PatientId"];
              status: components["schemas"]["PatientServicePlanStatus"];
              startDate: components["schemas"]["LocalDate"] | null;
              endDate: components["schemas"]["LocalDate"] | null;
              program: null | string;
              service: null | string;
              caseManagerName: null | string;
              planStart: ("NEW_CONSUMER" | "RENEWING") | null;
              visitDate: components["schemas"]["LocalDate"] | null;
              visitSummary: null | string;
              lrpHoursPerWeek: null | number;
              assessor: components["schemas"]["PatientServicePlanSignature"];
              consumer: components["schemas"]["PatientServicePlanSignature"];
              caseManager: components["schemas"]["PatientServicePlanSignature"];
              /** @description The current (non-revoked) emailed signing link per signature role. */
              signatureClaims: components["schemas"]["PatientServicePlanSignatureClaim"][];
              finalizedAt: components["schemas"]["Instant"] | null;
              hasPdf: boolean;
              tasks: components["schemas"]["PatientServicePlanTask"][];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member updates CDSC service plan header details */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startDate: components["schemas"]["LocalDate"] | null;
            endDate: components["schemas"]["LocalDate"] | null;
            program: null | string;
            service: null | string;
            caseManagerName: null | string;
            planStart: ("NEW_CONSUMER" | "RENEWING") | null;
            visitDate: components["schemas"]["LocalDate"] | null;
            visitSummary: null | string;
            lrpHoursPerWeek: null | number;
          };
        };
      };
    };
    /** Agency member deletes a draft CDSC service plan */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/service_plans/:patientServicePlanId/tasks": {
    /** Agency member replaces the tasks of a CDSC service plan */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            tasks: components["schemas"]["PatientServicePlanTaskParams"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/service_plans/:patientServicePlanId/signatures": {
    /** Agency member saves a signature on a CDSC service plan */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            role: components["schemas"]["PatientServicePlanSignatureRole"];
            name: string;
            signedDate: components["schemas"]["LocalDate"];
            signatureData: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/service_plans/:patientServicePlanId/signature_claims": {
    /** Agency member emails a one-time signing link for a service plan signature */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              claim: components["schemas"]["PatientServicePlanSignatureClaim"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            role: components["schemas"]["PatientServicePlanSignatureRole"];
            recipientEmail: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/service_plans/:patientServicePlanId/finalize": {
    /** Agency member finalizes a CDSC service plan and generates its PDF */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              signedUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/service_plans/:patientServicePlanId/pdf": {
    /** Agency member gets a signed URL for a finalized CDSC service plan PDF */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanId: PatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              signedUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/service_plan_imports/:patientServicePlanImportId/retry": {
    /** Agency member re-enqueues a failed CDSC calculator import */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientServicePlanImportId: PatientServicePlanImportId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/service_plan_signature_claims/:token": {
    /** Signee opens an emailed service plan signing link */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  kind: "ready";
                  role: components["schemas"]["PatientServicePlanSignatureRole"];
                  roleTitle: string;
                  patientName: string;
                  agencyName: string;
                  planStartDate: components["schemas"]["LocalDate"] | null;
                  planEndDate: components["schemas"]["LocalDate"] | null;
                }
              | {
                  /** @enum {string} */
                  kind: "unavailable";
                  reason: components["schemas"]["ServicePlanSignatureClaimUnavailableReason"];
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Signee submits their signature for an emailed service plan link */
    post: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  kind: "ok";
                }
              | {
                  /** @enum {string} */
                  kind: "unavailable";
                  reason: components["schemas"]["ServicePlanSignatureClaimUnavailableReason"];
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            signedDate: components["schemas"]["LocalDate"];
            signatureData: string;
          };
        };
      };
    };
  };
  "/cdsc-calculator/extraction_result": {
    /** CdscExtractor lambda reports a CDSC calculator extraction result */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              applied: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            importId: components["schemas"]["PatientServicePlanImportId"];
            result: components["schemas"]["CdscExtractionResult"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/dynamic_prefilled_answers": {
    /** Get dynamic prefilled answers for patient documents */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              dynamicPrefilledAnswers: {
                id: string;
                description: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/:agencyMemberId/patient_documents_history/:patientId": {
    /** Agency member asked for the history of a patient's documents */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: (
                | components["schemas"]["PatientExpectedDocumentObjectTask"]
                | components["schemas"]["PatientExpectedDocumentObjectAgencyMember"]
                | components["schemas"]["PatientExpectedDocumentObjectVisit"]
              )[];
              scannedDocuments: (
                | components["schemas"]["PatientExpectedScannedDocumentObjectVisit"]
                | components["schemas"]["PatientExpectedScannedDocumentObjectTask"]
              )[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/submit": {
    /** Caregiver submits a patient's document for a patient task (v2) */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "TaskCompleted";
                  completionDate: components["schemas"]["LocalDate"];
                }
              | {
                  /** @enum {string} */
                  type: "HasRejections";
                  rejections: components["schemas"]["PatientDocumentQuestionRejection"][];
                }
              | {
                  /** @enum {string} */
                  type: "OK";
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "DOCUMENT_DEPENDENCY_BLOCK";
                  blockingDocumentNames: string[];
                }
              | {
                  /** @enum {string} */
                  type: "DOCUMENT_HAS_REJECTIONS";
                }
              | {
                  /** @enum {string} */
                  type: "NOT_ALL_REQUIRED_FOR_GENERATION_HAVE_BEEN_GENERATED";
                }
              | {
                  /** @enum {string} */
                  type: "MISSING_ANSWERS";
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            /** Format: yyyy-MM-dd */
            date?: LocalDate;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId": {
    /** Caregiver submits a patient's document for a patient task */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              date: components["schemas"]["LocalDate"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** Format: yyyy-MM-dd */
            date?: LocalDate;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/should_ask_for_regenerate_other_documents": {
    /** Caregiver checks if other documents should be regenerated */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documentsToBeRegenerated: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/patient_documents/:documentTypeId/should_ask_for_regenerate_other_documents": {
    /** Caregiver checks if other documents should be regenerated */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documentsToBeRegenerated: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/answer": {
    /** Caregiver answers a patient's document question from task */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              document: components["schemas"]["PatientTaskDocumentObjectPartial"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "DOCUMENT_DEPENDENCY_BLOCK";
              blockingDocumentNames: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            answer: components["schemas"]["PatientDocumentAnswer"];
            questionId: number;
            chartRow: number;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            createdAt?: Instant;
            vitalExtraDetails?: components["schemas"]["VitalExtraDetails"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/patient_documents/:documentTypeId/answer": {
    /** Agency answers a patient's document question - same as above endpoint without visitId */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          documentTypeId: PatientDocumentTypeId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            answer: components["schemas"]["PatientDocumentAnswer"];
            questionId: number;
            chartRow: number;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            createdAt?: Instant;
            vitalExtraDetails?: components["schemas"]["VitalExtraDetails"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/answer": {
    /** Agency answers a patient's document question of task */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          documentTypeId: PatientDocumentTypeId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "DOCUMENT_DEPENDENCY_BLOCK";
              blockingDocumentNames: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            answer: components["schemas"]["PatientDocumentAnswer"];
            questionId: number;
            chartRow: number;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            createdAt?: Instant;
            vitalExtraDetails?: components["schemas"]["VitalExtraDetails"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/patient_documents/:patientDocumentTypeId/submit": {
    /** Agency submits a patient's document for a scheduled visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
          patientDocumentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              date: components["schemas"]["Instant"];
              fileUrl: null | string;
              complianceRecords: {
                caregiverName: string;
                documentName: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            makeCopy: boolean;
            keepOriginalSubmissionDate: boolean;
            regenerateOtherNursingQuestionsDocuments?: boolean;
            forceGeneratePDF?: boolean;
            /** @description When set, overrides submitted_at with start-of-day of this date in the agency timezone */
            submittedDate?: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/submit": {
    /** Agency submits a patient's document for a task instance */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              date: components["schemas"]["Instant"];
              fileUrl: null | string;
              complianceRecords: {
                caregiverName: string;
                documentName: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            makeCopy: boolean;
            keepOriginalSubmissionDate: boolean;
            regenerateOtherNursingQuestionsDocuments?: boolean;
            forceGeneratePDF?: boolean;
            /** @description When set, overrides submitted_at with start-of-day of this date in the agency timezone */
            submittedDate?: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/:agencyMemberId/patient_document_types/:documentTypeId/example": {
    /** Agency member requests an example patient document version with data */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            title: string;
            content: components["schemas"]["PatientDocumentContentItem"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/send_patient_documents_by_email": {
    /** Agency member sends scheduled docs file via email */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            name: string;
            subject: string;
            documentIds: components["schemas"]["PatientDocumentScheduleId"][];
            body: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/:agencyMemberId/send_patient_documents_by_email": {
    /** Agency member sends scheduled docs file via email */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            name: string;
            subject: string;
            documentIds: components["schemas"]["PatientDocumentScheduleId"][];
            body: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/:agencyMemberId/send_patient_documents_by_fax": {
    /** Agency member sends scheduled doc file via e-fax */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
            name: string;
            body?: string;
            documentIds: components["schemas"]["PatientDocumentScheduleId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:scheduledDocId/openSubmission": {
    /** Agency member open schedule doc for resubmission */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          scheduledDocId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            reason: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/duty_sheets/answer": {
    /** Agency member answer a duty sheet item via the patient profile */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            dutyId: components["schemas"]["PlanOfCareItemId"];
            /**
             * @description Which occurrence of the duty on this visit the answer is about.
             *
             * A visit may record the same duty several times, so an answer has to say
             * which record it means rather than naming the duty alone.
             *
             * OPTIONAL, and absent means occurrence 1 -- which is what every record
             * written before occurrences existed means. Three AngularJS clients post
             * this payload and are migrated one at a time, so a caller that has never
             * heard of occurrences keeps behaving exactly as it did. Must be 1 or
             * greater when sent.
             */
            occurrenceIndex?: number;
            notes?: null | string;
            completed?: boolean;
            /**
             * @description When the coordinator says the occurrence started / ended, in the visit's local
             * time. OPTIONAL: absent leaves the stored time alone (every AngularJS caller that
             * predates duty times), null clears it. Only applied to a completed occurrence.
             */
            startTime?: components["schemas"]["LocalDateTime"] | null;
            endTime?: components["schemas"]["LocalDateTime"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/duty_sheets/submit_note": {
    /** Agency member submits a duty sheet item note via the patient profile */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            dutyId: components["schemas"]["PlanOfCareItemId"];
            /**
             * @description Which occurrence of the duty on this visit the note belongs to. Optional,
             * and absent means occurrence 1. See
             * `VisitCaregiverDutyUpdateParams.occurrenceIndex`.
             */
            occurrenceIndex?: number;
            notes: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/scheduled_documents": {
    /** Agency member submits a duty sheet item note via the patient profile */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: {
                id: components["schemas"]["PatientDocumentScheduleId"];
                title: string;
                type: components["schemas"]["PatientDocumentTypes"];
                fileUrl: string;
                fileType: string;
                fileExtension: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            documentIds: components["schemas"]["PatientDocumentScheduleId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/task_change_requests": {
    /** Get patient task document change requests */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              changeRequests: components["schemas"]["PatientTaskDocumentChangeRequest"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/task_change_requests/:changeRequestId/resolve": {
    /** Resolve patient task document change request */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          changeRequestId: PatientTaskDocumentChangeRequestId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            message: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/task_document_rejections": {
    /** Get patient task document rejections */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: components["schemas"]["PatientTaskDocumentRejection"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/task_document_rejections/:rejectionId/resolve": {
    /** Mark a blocked task document rejection as fixed */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          rejectionId: TaskDocumentRejectionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/narrative_questions": {
    /** Caregiver answers a patient's document question from task */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              questionsText: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sectionCode: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/question_rejections/:rejectionId/reply": {
    /** The RN answers a reviewer's question comment with free text */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
          rejectionId: PatientDocumentAiReviewProcessQuestionRejectionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            reply: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/review": {
    /** Agency member loads a task document for review, with its comments */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              document: components["schemas"]["PatientTaskDocumentObjectPartial"];
              scheduledDocId:
                | components["schemas"]["PatientDocumentScheduleId"]
                | null;
              isSubmitted: boolean;
              isScanned: boolean;
              isOpenForResubmission: boolean;
              approvedAt: components["schemas"]["LocalDate"] | null;
              pdfGeneratedAt: components["schemas"]["Instant"] | null;
              hasAnswersNewerThanPdf: boolean;
              isPdfGenerating: boolean;
              header: components["schemas"]["AgencyDocumentReviewHeader"];
              comments: components["schemas"]["DocumentQuestionComment"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:scheduledDocId/reopen_with_comments": {
    /** Agency member reopens a submitted document with per-question comments */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          scheduledDocId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            generalComment: null | string;
            questionComments: components["schemas"]["ReopenDocumentQuestionComment"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:scheduledDocId/question_comments/:rejectionId/withdraw": {
    /** Agency member withdraws an open agency question comment */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          scheduledDocId: PatientDocumentScheduleId;
          rejectionId: PatientDocumentAiReviewProcessQuestionRejectionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:scheduledDocId/regenerate_pdf": {
    /** Agency member regenerates the PDF of a submitted document */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          scheduledDocId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              pdfUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/d/:token": {
    /** Retrieves patient document by token */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/documents_delivery_log": {
    /** RN Platform website user requests delivery logs for patient documents */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              entries: components["schemas"]["RnPlatformDocumentDeliveryLogEntry"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_document_scheduled/:patientDocumentScheduleId": {
    /** Agency member attempts to get a patient document */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientDocumentScheduleId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientDocumentScheduleId"];
              agencyMemberId: components["schemas"]["AgencyMemberId"] | null;
              caregiverId: components["schemas"]["CaregiverId"] | null;
              documentScanned: boolean;
              documentTitle: null | string;
              fileUrl: null | string;
              title: string;
              patientDocumentTypeId: components["schemas"]["PatientDocumentTypeId"];
              patientId: components["schemas"]["PatientId"];
              submittedAt: components["schemas"]["Instant"] | null;
              submittedBy: components["schemas"]["UserId"];
              versionId:
                | components["schemas"]["PatientDocumentVersionId"]
                | null;
              taskInstanceId:
                | components["schemas"]["PatientTaskInstanceId"]
                | null;
              visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
              createdAt: components["schemas"]["Instant"];
              removedAt: components["schemas"]["Instant"] | null;
              sentToPhysicianAt: components["schemas"]["LocalDate"] | null;
              approvedAt: components["schemas"]["LocalDate"] | null;
              content:
                | components["schemas"]["PatientDocumentContentItem"][]
                | null;
              answers: components["schemas"]["PatientDocumentAnswerObject"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_document_scheduled": {
    /** Agency member attempts to create patient document */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientDocumentScheduleId"];
              agencyMemberId: components["schemas"]["AgencyMemberId"] | null;
              caregiverId: components["schemas"]["CaregiverId"] | null;
              documentScanned: boolean;
              documentTitle: null | string;
              fileUrl: null | string;
              patientDocumentTypeId: components["schemas"]["PatientDocumentTypeId"];
              patientId: components["schemas"]["PatientId"];
              submittedAt: components["schemas"]["Instant"] | null;
              submittedBy: components["schemas"]["UserId"];
              versionId:
                | components["schemas"]["PatientDocumentVersionId"]
                | null;
              taskInstanceId:
                | components["schemas"]["PatientTaskInstanceId"]
                | null;
              visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
              createdAt: components["schemas"]["Instant"];
              removedAt: components["schemas"]["Instant"] | null;
              content:
                | components["schemas"]["PatientDocumentContentItem"][]
                | null;
              answers: components["schemas"]["PatientDocumentAnswerObject"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            documentTypeId: components["schemas"]["PatientDocumentTypeId"];
            certificationPeriodId:
              | components["schemas"]["CertificationPeriodId"]
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_document_scheduled/:patientDocumentScheduleId/submit": {
    /** Agency member submits a patient document */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientDocumentScheduleId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              date: components["schemas"]["Instant"];
              fileUrl: null | string;
              complianceRecords: {
                caregiverName: string;
                documentName: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            makeCopy: boolean;
            keepOriginalSubmissionDate: boolean;
            regenerateOtherNursingQuestionsDocuments?: boolean;
            forceGeneratePDF?: boolean;
            /** @description When set, overrides submitted_at with start-of-day of this date in the agency timezone */
            submittedDate?: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_document_scheduled/:patientDocumentScheduleId/answer": {
    /** Agency member answers a patient document */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
          agencyMemberId: AgencyMemberId;
          patientDocumentScheduleId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            answer: components["schemas"]["PatientDocumentAnswer"];
            questionId: number;
            chartRow: number;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            createdAt?: Instant;
            vitalExtraDetails?: components["schemas"]["VitalExtraDetails"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/sign_physician_document": {
    /** Agency member attempts to mark a patient document as signed by the physician */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientDocumentId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              document: components["schemas"]["PatientDocumentRow"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            signDate: components["schemas"]["LocalDate"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/mark_as_sent_to_physician": {
    /** Agency member attempts to mark a patient document as sent to physician */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientDocumentId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              document: components["schemas"]["PatientDocumentRow"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sentDate: components["schemas"]["LocalDate"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/mark_as_approved": {
    /** Agency member attempts to mark a patient document as approved */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientDocumentId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              document: components["schemas"]["PatientDocumentRow"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            approvedDate: components["schemas"]["LocalDate"];
            sendToEmails?: string[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_document/:patientDocumentId": {
    /** Agency member attempts to (soft) delete a patient document scheduled */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientDocumentId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId": {
    /** Agency member attempts to delete a patient task document, and scheduled document (if answered) */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents": {
    /** Agency member fetches documents of all patients */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          dueDateFrom?: LocalDate;
          dueDateTo?: LocalDate;
          documentSubmissionDateFrom?: LocalDate;
          documentSubmissionDateTo?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: components["schemas"]["AgencyPatientDocument"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/pdf_url": {
    /** Agency member fetches a PDF of a patient document */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientDocumentId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/generation_map2": {
    /** Agency member asks for generation map V2 for patient task */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientDocumentId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              questionGenerationAvailabilityMap: components["schemas"]["Record<string,QuestionGenerationAvailability>"];
              sections:
                | components["schemas"]["PatientTaskDocumentSection"][]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/template_id/:htmlTemplateId/generate": {
    /** Agency member ask to generate an answer for a given question */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientDocumentId: PatientDocumentScheduleId;
          htmlTemplateId: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "AnswerGenerated";
              answer: components["schemas"]["PatientDocumentAnswer"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "DOCUMENT_DEPENDENCY_BLOCK";
              blockingDocumentNames: string[];
            };
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/patient_documents/:documentTypeId/answer": {
    /** Caregiver submits a patient document answer */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            answer: components["schemas"]["PatientDocumentAnswer"];
            questionId: number;
            chartRow: number;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            createdAt?: Instant;
            vitalExtraDetails?: components["schemas"]["VitalExtraDetails"];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/patient_documents/:documentTypeId": {
    /** Caregiver submits a patient's document for a scheduled visit */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            submissionDate: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/documents/all_submitted": {
    /** Caregiver checks if all documents submitted for a visit instance */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              allSubmitted: boolean;
              hasAwaitingReview: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:taskInstanceId/document_types/:documentTypeId/approve_icd_codes": {
    /** Caregiver approves ICD codes for a patient document linked to a task */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            diagnosisCodes: {
              formattedDxCode: string;
              type: ("PRINCIPAL" | "SURGICAL") | null;
            }[];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:taskInstanceId/document_types/:documentTypeId/check_icd_codes_approved": {
    /** Check if caregiver has approved ICD codes for a patient document linked to a task */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          documentTypeId: PatientDocumentTypeId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              approved: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            diagnosisCodes: {
              formattedDxCode: string;
              type: ("PRINCIPAL" | "SURGICAL") | null;
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/patient_task_instance/:patientTaskInstanceId/patient_document": {
    /** Agency member manually submit document for patient task instance */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
              id: components["schemas"]["PatientDocumentScheduleId"];
              patientTaskInstanceCompletionDate:
                | components["schemas"]["LocalDate"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            base64: null | string;
            documentId: components["schemas"]["PatientDocumentTypeId"] | null;
            documentVersion:
              | components["schemas"]["PatientDocumentVersionId"]
              | null;
            documentTitle: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/patient_document_with_scans": {
    /** Agency member uploads a document for the scheduled visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
              id: components["schemas"]["PatientDocumentScheduleId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            base64: null | string;
            documentId: components["schemas"]["PatientDocumentTypeId"] | null;
            documentVersion:
              | components["schemas"]["PatientDocumentVersionId"]
              | null;
            documentTitle: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_statuses/patient_status_change": {
    /** Agency members gets all patients status changes list */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["PatientStatusChange"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            status: components["schemas"]["PatientStatus"];
            updateStatusOnPatient: boolean;
            removeFutureVisits?: boolean;
            patientContractId?:
              | components["schemas"]["PatientContractId"]
              | null;
            effectiveDate: components["schemas"]["LocalDate"];
            reason?: components["schemas"]["StatusChangeReasonId"] | null;
            to?: components["schemas"]["StatusChangeToId"] | null;
            note?: components["schemas"]["AgencyNoteCreateParams"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_surpluses": {
    /** Get patient surpluses */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          surplusDate?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientSurpluses: components["schemas"]["PatientSurplus"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** create patient surplus */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientContractId: components["schemas"]["PatientContractId"];
            fromDate: components["schemas"]["LocalDate"];
            toDate: components["schemas"]["LocalDate"] | null;
            amountInCents: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_surplus_checks": {
    /** Get patient surplus checks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientSurplusChecks: components["schemas"]["PatientSurplusCheck"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** create patient surplus check */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            receivedAt: components["schemas"]["LocalDate"];
            totalAmountInCents: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_surplus_invoices": {
    /** Get patient surplus invoices */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientSurplusInvoices: components["schemas"]["PatientSurplusInvoiceExtended"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** create patient surplus invoice */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientSurplusInvoiceCreateResponseRecords: components["schemas"]["PatientSurplusInvoiceCreateResponseRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            datesArr: components["schemas"]["LocalDate"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/:invoiceId/pdf": {
    /** Get patient surplus invoice pdf */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          invoiceId: PatientSurplusInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients_surplus_dashboard": {
    /** Get patient surplus dashboard */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientSurplusDashboardRecords: components["schemas"]["PatientSurplusDashboardRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_vacations/:patientVacationId": {
    /** Agency member deletes a patient vacation */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientVacationId: PatientVacationId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_vacations/delete": {
    /** Agency member deletes a patient vacation */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ids: components["schemas"]["PatientVacationId"][];
            regenerateVisits: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/patients": {
    /** Get the agency's patients, according to role */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["MessagesPatient"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/patients2": {
    /** Get the agency's patients, according to role */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | components["schemas"]["MessagesPatients"]
              | components["schemas"]["MessagesPatientsLinks"];
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_addresses": {
    /** Get the agency's patients's addresses */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              addresses: {
                patientId: components["schemas"]["PatientId"];
                address:
                  | components["schemas"]["PatientAddressComponents"]
                  | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ids: components["schemas"]["PatientId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/availability_settings": {
    /** Get the patient's availability preferences. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              availability: {
                day: components["schemas"]["Day"];
                timeframesIds: components["schemas"]["PatientAvailabilityTimeframeId"][];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update patient's availability preferences. */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            newSettings: {
              day: components["schemas"]["Day"];
              timeframesIds: components["schemas"]["PatientAvailabilityTimeframeId"][];
            }[];
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/availability_settings": {
    /** Get the patient's availability preferences. */
    get: {
      parameters: {
        path: {
          portalUserId: PortalUserId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              availability: {
                day: components["schemas"]["Day"];
                timeframesIds: components["schemas"]["PatientAvailabilityTimeframeId"][];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update patient's availability preferences. */
    put: {
      parameters: {
        path: {
          portalUserId: PortalUserId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            newSettings: {
              day: components["schemas"]["Day"];
              timeframesIds: components["schemas"]["PatientAvailabilityTimeframeId"][];
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/availability_time_frames": {
    /** Get all availability timeframes. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              timeframes: {
                id: components["schemas"]["PatientAvailabilityTimeframeId"];
                name: string;
                startTime: number;
                endTime: number;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/availability_time_frames": {
    /** Get all availability timeframes. */
    get: {
      parameters: {
        path: {
          portalUserId: PortalUserId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              timeframes: {
                id: components["schemas"]["PatientAvailabilityTimeframeId"];
                name: string;
                startTime: number;
                endTime: number;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/patients_search": {
    /** Get the agency's patients, according to role */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["GlobalSearchPatientResult"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/patients/:patientId": {
    /** Get patient data */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientId"];
              status: components["schemas"]["PatientStatus"];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              createdByName: null | string;
              currentOfficeId: components["schemas"]["OfficeId"];
              currentOfficeName: null | string;
              contracts: components["schemas"]["ContractExtendedData"][];
              clinicalInfo: components["schemas"]["PatientClinicalInfo"][];
              socialWorker: components["schemas"]["BasicSocialWorker"] | null;
              source: components["schemas"]["BasicReferralSource"] | null;
              ssn: null | string;
              firstName: string;
              middleName: null | string;
              lastName: string;
              gender: null | string;
              dateOfBirth: components["schemas"]["LocalDate"] | null;
              address: components["schemas"]["PatientAddressComponents"] | null;
              address2: null | string;
              addressInstructions: null | string;
              generalNotes: null | string;
              medicalNotes: null | string;
              medicareNumber: null | string;
              medicaidNumber: null | string;
              clinicalSeverityLevel:
                | (
                    | "HIGHEST_ASSISTANCE"
                    | "MINIMAL_ASSISTANCE"
                    | "WALKING_ASSISTANCE"
                  )
                | null;
              wageParityNumber: null | number;
              mainLanguage: null | string;
              secondaryLanguage: null | string;
              preferredHHAGender: null | string;
              smoking: null | boolean;
              pets: null | string;
              kosherHome: null | boolean;
              kidsInHouse: null | number;
              familyInformation:
                | components["schemas"]["PatientFamilyInformation"][]
                | null;
              contacts: components["schemas"]["PatientContact"][] | null;
              emergencyContact:
                | components["schemas"]["PatientEmergencyContact"][]
                | null;
              priorityCode: null | number;
              evacuationZone: null | string;
              mobilityStatus: null | string;
              evacuationLocation: null | string;
              electricEquipmentDependency: null | string;
              allergies: components["schemas"]["Allergy"][];
              patientHIClaim: null | string;
              email: null | string;
              assignedSalesRep: components["schemas"]["AgencyMemberId"] | null;
              assignedSalesRepName: null | string;
              assignedIntake: components["schemas"]["AgencyMemberId"] | null;
              assignedIntakeName: null | string;
              assignedCoordinator:
                | components["schemas"]["AgencyMemberId"]
                | null;
              assignedCoordinatorName: null | string;
              agencyTeamId: components["schemas"]["AgencyTeamId"] | null;
              agencyTeamName: null | string;
              assignedDPS: components["schemas"]["AgencyMemberId"] | null;
              assignedDPSName: null | string;
              updatedAt: components["schemas"]["Instant"];
              updatedBy: components["schemas"]["AgencyMemberId"];
              updatedByName: null | string;
              linkedPatient: components["schemas"]["LinkedPatient"];
              phoneNumbers: components["schemas"]["PatientPhoneNumber"][];
              addresses: components["schemas"]["PatientAddress"][];
              nurseOnCase: components["schemas"]["MiniCaregiver"] | null;
              caregiverOnCase: components["schemas"]["MiniCaregiver"] | null;
              missingAddressFields?: string[];
              displayId: null | number;
              agencyBranchIds: components["schemas"]["AgencyBranchId"][];
              customFields: components["schemas"]["PatientEntityCustomField"];
              externalId: null | string;
              locationGroupName: null | string;
              blacklisted: components["schemas"]["CaregiverId"][] | null;
              blacklistedCaregivers: {
                caregiverId: components["schemas"]["CaregiverId"];
                displayName: string;
                displayId: null | number;
                status: null | string;
                photoUrl: null | string;
              }[];
              wageParity: null | boolean;
              vacations: components["schemas"]["PatientVacation"][];
              startOfCare: components["schemas"]["LocalDate"] | null;
              eligibiltyStatus:
                | components["schemas"]["PatientEligibiltyStatus"]
                | null;
              isCustomAddress: boolean;
              mainPhoneNumber: null | string;
              advancedDirective:
                | components["schemas"]["PatientAdvancedDirective"]
                | null;
              isTestUser: boolean;
              pimsId: null | string;
              currCertPeriodTaskStatus: components["schemas"]["PatientCertificationPeriodTaskStatus"];
              arizonaContingencyPlanCode?: null | string;
              orderingPcpNpi: null | string;
              adultServiceWorkerName: null | string;
              adultServiceWorkerEmail: null | string;
              aideFrequency: null | string;
              serviceType: null | string;
              payerSource: null | string;
              agencyBranches: {
                id: components["schemas"]["AgencyBranchId"];
                name: string;
              }[];
              criticalInformationForFirstResponders: null | string;
              hhaxAdmissionIdOverride: null | number;
              maPayerProgramCode: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Edit patient data */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["PatientId"];
            /**
             * @description The status of a Patient within a specific Agency
             * @enum {string}
             */
            status?:
              | "ACCEPTED"
              | "ACTIVE"
              | "DECEASED"
              | "DISCHARGED"
              | "DRAFT"
              | "ELIGIBLE"
              | "HOSPITALIZED"
              | "LOST"
              | "ON_HOLD"
              | "PENDING_FILES"
              | "REFERRAL"
              | "VACATION";
            ssn?: null | string;
            firstName?: string;
            middleName?: null | string;
            lastName?: string;
            gender?: ("F" | "M") | null;
            dateOfBirth?: components["schemas"]["LocalDate"] | null;
            homePhoneNumber?: null | string;
            mobilePhoneNumber?: null | string;
            address?: components["schemas"]["PatientAddressComponents"] | null;
            address2?: null | string;
            addressInstructions?: null | string;
            /** Format: OfficeId */
            currentOfficeId?: OfficeId;
            phone3?: null | string;
            phone4?: null | string;
            phoneNumbers?:
              | components["schemas"]["InsertPatientPhoneNumberParams"][]
              | null;
            generalNotes?: null | string;
            medicalNotes?: null | string;
            medicareNumber?: null | string;
            medicaidNumber?: null | string;
            wageParityNumber?: null | number;
            mainLanguage?: null | string;
            secondaryLanguage?: null | string;
            preferredHHAGender?: ("F" | "M") | null;
            smoking?: null | boolean;
            pets?: null | string;
            kosherHome?: null | boolean;
            kidsInHouse?: null | number;
            familyInformation?:
              | components["schemas"]["PatientFamilyInformation"][]
              | null;
            emergencyContact?:
              | components["schemas"]["PatientEmergencyContact"][]
              | null;
            priorityCode?: null | number;
            evacuationZone?: null | string;
            mobilityStatus?: null | string;
            evacuationLocation?: null | string;
            electricEquipmentDependency?: null | string;
            allergies?: components["schemas"]["AllergyId"][];
            patientHIClaim?: null | string;
            source?: components["schemas"]["ReferralSourceId"] | null;
            socialWorker?: components["schemas"]["SocialWorkerId"] | null;
            assignedSalesRep?: components["schemas"]["AgencyMemberId"] | null;
            assignedIntake?: components["schemas"]["AgencyMemberId"] | null;
            assignedCoordinator?:
              | components["schemas"]["AgencyMemberId"]
              | null;
            assignedDPS?: components["schemas"]["AgencyMemberId"] | null;
            insurer?: components["schemas"]["InsurerId"] | null;
            assignedRN?: components["schemas"]["CaregiverId"] | null;
            admissionId?: null | string;
            agencyPatientId?: null | string;
            agencyTeamId?: components["schemas"]["AgencyTeamId"] | null;
            externalId?: null | string;
            displayId?: null | number;
            wageParity?: null | boolean;
            startOfCare?: components["schemas"]["LocalDate"] | null;
            clinicalSeverityLevel?:
              | (
                  | "HIGHEST_ASSISTANCE"
                  | "MINIMAL_ASSISTANCE"
                  | "WALKING_ASSISTANCE"
                )
              | null;
            email?: null | string;
            isCustomAddress?: null | boolean;
            mainPhoneNumber?: null | string;
            isTestUser?: boolean;
            pimsId?: null | string;
            arizonaContingencyPlanCode?: null | string;
            orderingPcpNpi?: null | string;
            adultServiceWorkerName?: null | string;
            adultServiceWorkerEmail?: null | string;
            aideFrequency?: null | string;
            serviceType?: null | string;
            payerSource?: null | string;
            criticalInformationForFirstResponders?: null | string;
            hhaxAdmissionIdOverride?: null | number;
            maPayerProgramCode?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/search": {
    /** Agency member search patients */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          term?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["PatientSearchItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/check_caregivers_blacklist": {
    /** Check patient caregivers blacklist */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              toDelete: components["schemas"]["CaregiverId"][];
              toInsert: components["schemas"]["CaregiverId"][];
              hasFutureVisits: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ids: components["schemas"]["CaregiverId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/patients/:patientId/sync_address_to_visits": {
    /**
     * Copy the patient's current address onto all of the patient's visits
     *                 in the given (optionally unbounded) date range
     */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              address: string;
              matchedVisitsCount: number;
              updatedVisitsCount: number;
              skippedVisitsCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startDate: components["schemas"]["LocalDate"] | null;
            endDate: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/update_caregivers_blacklist": {
    /** Update patient caregivers blacklist */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              status: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            toDelete: components["schemas"]["CaregiverId"][];
            toInsert: components["schemas"]["CaregiverId"][];
            unassignVisits: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/patients_draft": {
    /** Create patient as draft */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ssn: null | string;
            firstName: string;
            middleName: null | string;
            lastName: string;
            gender: ("F" | "M") | null;
            dateOfBirth: components["schemas"]["LocalDate"] | null;
            homePhoneNumber: null | string;
            mobilePhoneNumber: null | string;
            address: components["schemas"]["PatientAddressComponents"] | null;
            address2: null | string;
            addressInstructions?: null | string;
            isCustomAddress?: boolean;
            phone3: null | string;
            phone4: null | string;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            createdAt?: Instant;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            updatedAt?: Instant;
            generalNotes: null | string;
            medicalNotes: null | string;
            medicareNumber: null | string;
            medicaidNumber: null | string;
            wageParityNumber: null | number;
            mainLanguage: null | string;
            secondaryLanguage: null | string;
            preferredHHAGender: ("F" | "M") | null;
            smoking: null | boolean;
            pets: null | string;
            kosherHome: null | boolean;
            kidsInHouse: null | number;
            familyInformation:
              | components["schemas"]["PatientFamilyInformation"][]
              | null;
            emergencyContact:
              | components["schemas"]["PatientEmergencyContact"][]
              | null;
            priorityCode: null | number;
            evacuationZone: null | string;
            mobilityStatus: null | string;
            evacuationLocation: null | string;
            electricEquipmentDependency: null | string;
            allergies: components["schemas"]["AllergyId"][] | null;
            patientHIClaim: null | string;
            email: null | string;
            source: components["schemas"]["ReferralSourceId"] | null;
            socialWorker: components["schemas"]["SocialWorkerId"] | null;
            assignedSalesRep: components["schemas"]["AgencyMemberId"] | null;
            assignedIntake: components["schemas"]["AgencyMemberId"] | null;
            assignedCoordinator: components["schemas"]["AgencyMemberId"] | null;
            agencyTeamId: components["schemas"]["AgencyTeamId"] | null;
            assignedDPS: components["schemas"]["AgencyMemberId"] | null;
            assignedRN: components["schemas"]["CaregiverId"] | null;
            admissionId: null | string;
            agencyPatientId: null | string;
            currentOfficeId: components["schemas"]["OfficeId"];
            /**
             * @description The status of a Patient within a specific Agency
             * @enum {string}
             */
            status?:
              | "ACCEPTED"
              | "ACTIVE"
              | "DECEASED"
              | "DISCHARGED"
              | "DRAFT"
              | "ELIGIBLE"
              | "HOSPITALIZED"
              | "LOST"
              | "ON_HOLD"
              | "PENDING_FILES"
              | "REFERRAL"
              | "VACATION";
            externalId?: null | string;
            clinicalSeverityLevel?:
              | (
                  | "HIGHEST_ASSISTANCE"
                  | "MINIMAL_ASSISTANCE"
                  | "WALKING_ASSISTANCE"
                )
              | null;
            displayId?: null | number;
            wageParity: null | boolean;
            contract?:
              | components["schemas"]["InlineCreateContractParams"]
              | null;
            startOfCare: components["schemas"]["LocalDate"] | null;
            isTestUser?: boolean;
            pimsId?: null | string;
            adultServiceWorkerName?: null | string;
            adultServiceWorkerEmail?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agencyMember/:agencyMemberId/patients/merge_patients": {
    /** Get the patients that might need to be merged */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["Patient"][][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Get patient duty sheet PDF url */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            masterPatient: components["schemas"]["PatientId"];
            mergePatients: components["schemas"]["PatientId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/patients/:patientId/duty_sheets": {
    /** Get patient duty sheets for week, query: ?startOfWeek=LocalDate */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
        };
        query: {
          startOfWeek?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              hasPlanOfCare: boolean;
              rows: components["schemas"]["PatientPlanOfCareDutySheets"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/caregivers_associated": {
    /** Get caregivers list of all the caregivers associated with patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: {
                caregiverId: components["schemas"]["CaregiverId"];
                displayName: null | string;
                displayId: null | number;
                status: null | string;
                photoUrl: null | string;
                from: components["schemas"]["LocalDateTime"];
                to: components["schemas"]["LocalDateTime"];
                visitsCount: number;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/caergivers_associated": {
    /** Get caregivers list of all the caregivers associated with patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: {
                caregiverId: components["schemas"]["CaregiverId"];
                displayName: null | string;
                displayId: null | number;
                status: null | string;
                photoUrl: null | string;
                from: components["schemas"]["LocalDateTime"];
                to: components["schemas"]["LocalDateTime"];
                visitsCount: number;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/patients/:patientId/plans_of_care/:planOfCareId/generate_duty_sheets_pdf_by_dates": {
    /** Get patient duty sheets PDF url */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          patientId: PatientId;
          planOfCareId: PlanOfCareId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/contracts_basic": {
    /** Get patient contracts basic data */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          include_general?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contracts: components["schemas"]["PatientContractBasicData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/check_medicaid_number": {
    /** Check if a medicaid number of a patient already exists */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          medicaidNumber?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              isPatientMedicaidNumberUnique: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/advanced_directive": {
    /** Update patient advanced directive */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            hasDNR: null | boolean;
            hasProxy: null | boolean;
            firstName: null | string;
            lastName: null | string;
            phoneNumber: null | string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/outsourcing_agency_data": {
    /** Get patient outsourcing agency data */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyData: components["schemas"]["Agency"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/near_future_caregivers": {
    /** Get a list of caregivers that are scheduled to visit the patient in the near future */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["NearFutureCaregiver"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/agency": {
    /** Request patient agency data (considering outsourced agencies) */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agency: {
                id: components["schemas"]["AgencyId"];
                name: string;
                phoneNumber: null | string;
                address: null | string;
                address2: null | string;
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/export-profile-pdf": {
    /** Agency member attempts to export patient profile as PDF */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
              signedUrl: string;
              bucket: string;
              key: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sectionsIncluded:
              | (
                  | "authorizations"
                  | "calendar"
                  | "caregivers"
                  | "contracts"
                  | "diagnosesCodes"
                  | "emergency"
                  | "name"
                  | "planOfCare"
                  | "statusReview"
                  | "summary"
                )[]
              | null;
            calendarPeriod:
              | components["schemas"]["CalendarDatePeriodParam"]
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/schedule": {
    /** Get the patient cost share schedule (current + history) */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              current: components["schemas"]["PatientCostShareSchedule"] | null;
              history: components["schemas"]["PatientCostShareSchedule"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Set the patient cost share schedule (closes any open schedule first) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              current: components["schemas"]["PatientCostShareSchedule"] | null;
              history: components["schemas"]["PatientCostShareSchedule"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            amountCents: number;
            frequency: components["schemas"]["PatientCostShareFrequency"];
            startDate: components["schemas"]["LocalDate"];
            paymentDate: components["schemas"]["PatientCostSharePaymentDay"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/schedule/:scheduleId/update": {
    /** Update the open patient cost share schedule in place (keeps the start date) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          scheduleId: PatientCostShareScheduleId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              current: components["schemas"]["PatientCostShareSchedule"] | null;
              history: components["schemas"]["PatientCostShareSchedule"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            amountCents: number;
            frequency: components["schemas"]["PatientCostShareFrequency"];
            paymentDate: components["schemas"]["PatientCostSharePaymentDay"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/schedule/:scheduleId/close": {
    /** Close (stop) the patient cost share schedule */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          scheduleId: PatientCostShareScheduleId;
        };
        query: {
          closeOn?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              current: components["schemas"]["PatientCostShareSchedule"] | null;
              history: components["schemas"]["PatientCostShareSchedule"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share": {
    /** Combined patient-page cost share data (schedule + past-month invoice) */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              schedule: components["schemas"]["GetPatientCostShareScheduleResponse"];
              /**
               * @description Whether the patient has an email on file. Pay-link emails can't be
               * sent without one — the UI surfaces a warning and disables sending.
               */
              patientHasEmail: boolean;
              /**
               * @description Whether the patient has a MOBILE phone number on file. Pay-link SMS
               * can't be sent without one (when the schedule delivers via SMS).
               */
              patientHasMobilePhone: boolean;
              /**
               * @description The card we are allowed to charge off-session, or null when the patient
               * has never ticked "save my payment details" in Checkout. A schedule set
               * to "charge" with this null is the case the UI has to warn about.
               */
              savedPaymentMethod:
                | components["schemas"]["PatientCostShareSavedPaymentMethod"]
                | null;
              /**
               * @description Patient-level collection + delivery settings. Always present — a patient
               * with no stored row reports {@link PATIENT_COST_SHARE_CONFIG_DEFAULTS}.
               */
              config: components["schemas"]["PatientCostShareConfig"];
              /**
               * @description The agency-wide go-live switch, so the patient's own toggle can say
               * whether it is actually doing anything.
               */
              agencyProductionEnabled: boolean;
              /**
               * @description The Stripe account the patient's NEXT invoice would be generated
               * against — "live" only when the agency switch and the patient toggle
               * are both on. Existing invoices keep whatever they were stamped with.
               */
              effectiveStripeMode: components["schemas"]["PatientCostShareStripeMode"];
              /** @description All invoices for this patient, newest first (period_start DESC). */
              invoices: components["schemas"]["PatientCostShareInvoice"][];
              /**
               * @description Weekly anchors that fall in the most-recent invoice's month BUT were
               * skipped by the 4-per-month generator (i.e. a 5th week date) AND don't
               * yet have a payment request. Used by the override flow to optionally
               * add the extra week. Derived from the schedule the most recent invoice
               * was generated under, not the current one. Empty when that schedule is
               * not weekly / no invoices.
               */
              currentMonthExtraWeeklyDates: components["schemas"]["LocalDate"][];
              /**
               * @description Sum of outstanding cents across the patient's OTHER non-void invoices
               * (everything except the most-recent invoice itself). Caps how much
               * extra an override on the most-recent invoice may collect.
               */
              otherInvoicesOutstandingCents: number;
              /** @description The patient's most recent STEDI eligibility check, or null if never checked. */
              lastStediCheck:
                | components["schemas"]["PatientCostShareStediCheck"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/notifications/:notificationId": {
    /** The message a cost-share notification actually delivered (invoice email, pay link email/SMS, or payment receipt): subject and HTML body, or SMS text. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          notificationId: PatientCostShareNotificationId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientCostShareNotificationId"];
              kind: components["schemas"]["PatientCostShareNotificationKind"];
              deliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
              sentTo: string;
              sentAt: components["schemas"]["Instant"];
              /** @description Email subject; null for an SMS. */
              subject: null | string;
              /** @description Email HTML, or the SMS text. Null when not captured. */
              body: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/invoices": {
    /** List patient cost share invoices for a patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostShareInvoice"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/invoices/:invoiceId": {
    /** Get a patient cost share invoice's full detail */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          invoiceId: PatientCostShareInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              invoice: components["schemas"]["PatientCostShareInvoice"];
              allocations: {
                allocationId: components["schemas"]["PatientCostSharePaymentAllocationId"];
                paymentId: components["schemas"]["PatientCostSharePaymentId"];
                amountCents: number;
                appliedAt: components["schemas"]["Instant"];
                paymentReceivedAt: components["schemas"]["Instant"];
              }[];
              adjustments: components["schemas"]["PatientCostShareInvoiceAdjustment"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/generate_invoices": {
    /** Trigger asynchronous generation + Stripe finalize for a patient via n8n, billing through the given asOfDate. Returns immediately; the result is pushed back over the PatientCostShareUpdated websocket when n8n finishes. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              queued: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate: components["schemas"]["LocalDate"];
            patientId: components["schemas"]["PatientId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/run_eligibility": {
    /** Trigger a real-time STEDI eligibility check for one patient via n8n (sets the cost-share schedule from the result). Returns immediately; the view refreshes over the PatientCostShareUpdated websocket when n8n finishes (~seconds). */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              queued: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/finalize": {
    /** Drain the patient-cost-share Stripe outbox for this agency (optionally narrowed to one patient). Safe to retry — uses Stripe Idempotency-Keys per DB row. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              invoicesFinalized: number;
              invoicesMarkedUncollectible: number;
              errors: {
                kind: string;
                rowId: number;
                error: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/invoices/:invoiceId/void": {
    /** Void a patient cost share invoice (no payments allowed) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          invoiceId: PatientCostShareInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              invoice: components["schemas"]["PatientCostShareInvoice"];
              allocations: {
                allocationId: components["schemas"]["PatientCostSharePaymentAllocationId"];
                paymentId: components["schemas"]["PatientCostSharePaymentId"];
                amountCents: number;
                appliedAt: components["schemas"]["Instant"];
                paymentReceivedAt: components["schemas"]["Instant"];
              }[];
              adjustments: components["schemas"]["PatientCostShareInvoiceAdjustment"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/invoices/:invoiceId/adjust": {
    /** Apply an adjustment (delta + reason) to a patient cost share invoice */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          invoiceId: PatientCostShareInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              invoice: components["schemas"]["PatientCostShareInvoice"];
              allocations: {
                allocationId: components["schemas"]["PatientCostSharePaymentAllocationId"];
                paymentId: components["schemas"]["PatientCostSharePaymentId"];
                amountCents: number;
                appliedAt: components["schemas"]["Instant"];
                paymentReceivedAt: components["schemas"]["Instant"];
              }[];
              adjustments: components["schemas"]["PatientCostShareInvoiceAdjustment"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            amountCentsDelta: number;
            reason: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/invoices/:invoiceId/override": {
    /** Distribute override amounts across an invoice's upcoming payment requests */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          invoiceId: PatientCostShareInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              invoice: components["schemas"]["PatientCostShareInvoice"];
              allocations: {
                allocationId: components["schemas"]["PatientCostSharePaymentAllocationId"];
                paymentId: components["schemas"]["PatientCostSharePaymentId"];
                amountCents: number;
                appliedAt: components["schemas"]["Instant"];
                paymentReceivedAt: components["schemas"]["Instant"];
              }[];
              adjustments: components["schemas"]["PatientCostShareInvoiceAdjustment"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            /** @description Per-existing-request additions; their sum is part of the extra to collect. */
            distributions: {
              paymentRequestId: components["schemas"]["PatientCostSharePaymentRequestId"];
              overrideAmountCents: number;
            }[];
            /**
             * @description Optional NEW payment requests to add for this invoice (e.g. a 5th-week
             * date that the generator skipped). Each has base = 0 and is created with
             * the given override-only amount. The combined sum of these plus
             * `distributions` is capped by the patient's outstanding balance across
             * other invoices.
             */
            additionalRequests: {
              dueDate: components["schemas"]["LocalDate"];
              overrideAmountCents: number;
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/payment_requests/:paymentRequestId/client_secret": {
    /** Get the Stripe client secret to pay a payment request */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          paymentRequestId: PatientCostSharePaymentRequestId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              clientSecret: null | string;
              paymentIntentId: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/payment_requests/:paymentRequestId/send_link": {
    /** Trigger sending the pay link for a payment request via n8n. Returns immediately; the sent state is pushed back over the PatientCostShareUpdated websocket when n8n finishes. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          paymentRequestId: PatientCostSharePaymentRequestId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              queued: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/payment_requests/:paymentRequestId/charge": {
    /** Charge the patient's saved card for one payment request now, without waiting for the daily worker. Synchronous: the response says whether the card was charged, or why it was skipped (already paid, canceled, no saved card, or a schedule that collects by pay link) or declined. On success the patient is emailed a payment receipt. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          paymentRequestId: PatientCostSharePaymentRequestId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              candidates: number;
              charged: number;
              failed: number;
              skipped: number;
              outcomes: components["schemas"]["PatientCostShareChargeOutcome"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/config": {
    /** Set the patient's cost-share collection method (charge a saved card vs send a pay link) and delivery method (email vs SMS, used for the pay link AND the charge receipt). These are patient-level and survive schedule changes; a patient with no stored settings collects by link over email. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientId: components["schemas"]["PatientId"];
              collectionMethod: components["schemas"]["PatientCostShareCollectionMethod"];
              /** @description Applies to the pay link AND the charge receipt. */
              linkDeliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
              /**
               * @description The patient's half of the go-live switch, ON by default: when the agency
               * turns production cost share on, everybody moves unless they were
               * deliberately held back. Only meaningful together with the agency switch —
               * on its own it does nothing.
               */
              productionMode: boolean;
              /** @description Null when the patient has no explicit row and is running on defaults. */
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["AgencyMemberId"] | null;
              updatedByName: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            collectionMethod: components["schemas"]["PatientCostShareCollectionMethod"];
            linkDeliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/agency_config": {
    /** Read the agency-wide cost-share go-live switch. Off until someone turns it on, which is what keeps every patient on the test Stripe account. Also reports whether this environment has live Stripe credentials at all. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyId: components["schemas"]["AgencyId"];
              /** @description Master switch. While false, every patient is forced to "test". */
              productionEnabled: boolean;
              /**
               * @description Whether this environment even has live Stripe credentials. False on
               * local dev and the testing boxes, where turning the switch on is
               * refused rather than silently ineffective.
               */
              liveConfigured: boolean;
              /**
               * @description What this agency calls cost share when talking to a patient — e.g.
               * "Structured Family Care cost share". Null means no opinion, in which case
               * messages use {@link PATIENT_COST_SHARE_DEFAULT_DISPLAY_NAME}.
               */
              displayName: null | string;
              /** @description Null when the agency has never been configured and is running on the default. */
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["AgencyMemberId"] | null;
              updatedByName: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Turn production cost share on or off for the agency. While off, no patient can reach the live Stripe account whatever their own toggle says. Turning it on is refused in an environment with no live Stripe credentials. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyId: components["schemas"]["AgencyId"];
              /** @description Master switch. While false, every patient is forced to "test". */
              productionEnabled: boolean;
              /**
               * @description Whether this environment even has live Stripe credentials. False on
               * local dev and the testing boxes, where turning the switch on is
               * refused rather than silently ineffective.
               */
              liveConfigured: boolean;
              /**
               * @description What this agency calls cost share when talking to a patient — e.g.
               * "Structured Family Care cost share". Null means no opinion, in which case
               * messages use {@link PATIENT_COST_SHARE_DEFAULT_DISPLAY_NAME}.
               */
              displayName: null | string;
              /** @description Null when the agency has never been configured and is running on the default. */
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["AgencyMemberId"] | null;
              updatedByName: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            productionEnabled: boolean;
            /** @description Blank or whitespace is stored as null, i.e. back to the built-in phrase. */
            displayName: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/mode": {
    /** Move one patient between the test and production Stripe accounts. Only has an effect once the agency-wide switch is on; invoices already generated keep the account they were stamped with. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientId: components["schemas"]["PatientId"];
              collectionMethod: components["schemas"]["PatientCostShareCollectionMethod"];
              /** @description Applies to the pay link AND the charge receipt. */
              linkDeliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
              /**
               * @description The patient's half of the go-live switch, ON by default: when the agency
               * turns production cost share on, everybody moves unless they were
               * deliberately held back. Only meaningful together with the agency switch —
               * on its own it does nothing.
               */
              productionMode: boolean;
              /** @description Null when the patient has no explicit row and is running on defaults. */
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["AgencyMemberId"] | null;
              updatedByName: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            productionMode: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/remove_payment_method": {
    /** Remove the patient's saved card: detach it in Stripe, clear it locally, and expire the Checkout Sessions behind their outstanding pay links so the next click asks for card details again. Links with a payment already in flight are left alone. Idempotent — safe to call when no card is saved. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description False when there was no saved card to remove (the call is idempotent). */
              detached: boolean;
              /**
               * @description Outstanding pay links whose Checkout Session was expired and cleared, so
               * the next click mints a fresh one that asks for card details again.
               */
              linksReset: number;
              /**
               * @description Links left untouched because Stripe reports their session `complete` — a
               * payment is in flight and its webhook still needs to match the request.
               */
              linksSkipped: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_cost_share/payments": {
    /** List patient cost share payments for a patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostSharePayment"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Record a patient cost share payment (cascades to open invoices) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              paymentId: components["schemas"]["PatientCostSharePaymentId"];
              invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
              invoicePaidCents: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
            amountCents: number;
            receivedAt: components["schemas"]["Instant"];
            notes: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/payments/:paymentId/reverse": {
    /** Reverse a patient cost share payment */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          paymentId: PatientCostSharePaymentId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {boolean} */
              ok: true;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/invoices/:invoiceId/notes": {
    /** List notes on a patient cost share invoice */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          invoiceId: PatientCostShareInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostShareInvoiceNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Add a note to a patient cost share invoice */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          invoiceId: PatientCostShareInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostShareInvoiceNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            note: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/ar_view": {
    /** Patient cost share AR detailed view */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          asOfDate?: LocalDate;
          patientIds?: PatientId[];
          officeIds?: OfficeId[];
          statuses?: string[];
          paymentStatuses?: string[];
          serviceDateFrom?: LocalDate;
          serviceDateTo?: LocalDate;
          invoiceDateFrom?: LocalDate;
          invoiceDateTo?: LocalDate;
          dueDateFrom?: LocalDate;
          dueDateTo?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostShareArViewItem"][];
              totalOutstandingCents: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_cost_share/ar_summary": {
    /** Patient cost share AR summary view (per patient + ageing) */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          asOfDate?: LocalDate;
          patientIds?: PatientId[];
          officeIds?: OfficeId[];
          statuses?: string[];
          paymentStatuses?: string[];
          serviceDateFrom?: LocalDate;
          serviceDateTo?: LocalDate;
          invoiceDateFrom?: LocalDate;
          invoiceDateTo?: LocalDate;
          dueDateFrom?: LocalDate;
          dueDateTo?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              requestCount: number;
              totalAmountCents: number;
              totalOutstandingCents: number;
              bucketsCents: number[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/patient_cost_share/worker/sync_customer_emails": {
    /** Push patient email changes to their Stripe cost-share customers. Run before /worker/generate so invoices always bill against current addresses. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              candidates: number;
              updated: number;
              errors: {
                patientId: number;
                error: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            /** @description Scope generate to one patient (per-patient webhook); null = bulk. */
            patientId?: components["schemas"]["PatientId"] | null;
            /**
             * @description Scope pending-links / pending-receipts to one request (manual send
             * webhook); null = bulk.
             */
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/generate": {
    /** Bulk-generate this month's invoices for every patient with an active schedule. Restricted to Medflyt-internal agency API users (called by the n8n daily worker). */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientsProcessed: number;
              invoicesGenerated: number;
              paymentRequestsCreated: number;
              errors: {
                agencyId: number;
                patientId: number;
                error: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            /** @description Scope generate to one patient (per-patient webhook); null = bulk. */
            patientId?: components["schemas"]["PatientId"] | null;
            /**
             * @description Scope pending-links / pending-receipts to one request (manual send
             * webhook); null = bulk.
             */
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/charge_due": {
    /** Automatic charge of saved cards for auto-charge patients: the named payment request (from /worker/pending_charges), or every pending one in scope. Each request is attempted at most once automatically, within two weeks of its due date; a decline is recorded on the request and not retried — staff follow up with Charge now or Send link. Requests already paid or canceled, with no saved card, or of a pay-link patient are reported as skipped. A request already collected on Stripe is recorded rather than charged again. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              candidates: number;
              charged: number;
              failed: number;
              skipped: number;
              outcomes: components["schemas"]["PatientCostShareChargeOutcome"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            patientId?: components["schemas"]["PatientId"] | null;
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/pending_charges": {
    /** Payment requests the automatic charge would attempt as of asOfDate: auto-charge patients with a saved card, due within the last two weeks, never attempted. n8n calls /worker/charge_due once per item. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostSharePendingCharge"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            patientId?: components["schemas"]["PatientId"] | null;
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/finalize": {
    /** Drain the patient-cost-share Stripe outbox: create + finalize Stripe invoices for newly-generated DB rows, create Payment Links for new PRs, mark prior Stripe invoices uncollectible and deactivate their Payment Links. Idempotent: uses deterministic Stripe Idempotency-Keys per DB row so retries don't duplicate. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              invoicesFinalized: number;
              invoicesMarkedUncollectible: number;
              errors: {
                kind: string;
                rowId: number;
                error: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            /** @description Scope generate to one patient (per-patient webhook); null = bulk. */
            patientId?: components["schemas"]["PatientId"] | null;
            /**
             * @description Scope pending-links / pending-receipts to one request (manual send
             * webhook); null = bulk.
             */
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/pending_links": {
    /** List the pay links the worker still needs to deliver — every awaiting-payment request whose due date has arrived and whose link hasn't been sent yet, pre-rendered (SMS body / email subject+HTML) for the patient's delivery method. Pay links only: invoices and receipts have their own lists. On Saturday and Sunday in the patient's timezone SMS links are held back unless paymentRequestId is given; they go out on the next weekday run. Read-only: n8n does the actual sending and calls /worker/mark_link_sent per success. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostSharePendingLink"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            /** @description Scope generate to one patient (per-patient webhook); null = bulk. */
            patientId?: components["schemas"]["PatientId"] | null;
            /**
             * @description Scope pending-links / pending-receipts to one request (manual send
             * webhook); null = bulk.
             */
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/payment_requests/:paymentRequestId/mark_link_sent": {
    /** Record that the worker (n8n) successfully delivered a pay link, stamping when and where it was sent so the request stops being returned by /worker/pending_links. Medflyt-internal API users only. */
    post: {
      parameters: {
        path: {
          paymentRequestId: PatientCostSharePaymentRequestId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sentAt: components["schemas"]["Instant"];
              sentTo: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sentTo: string;
            /** @description Email subject that was sent; absent/null for an SMS. */
            subject?: null | string;
            /** @description Email HTML or SMS text that was sent, stored for the webapp's viewer. */
            body?: null | string;
            /**
             * @description Set when the send was triggered by an agency member (manual webhook) so
             * the server can push a refresh to their open cost-share view. Null/absent
             * for the cron bulk run.
             */
            agencyMemberId?: components["schemas"]["AgencyMemberId"] | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/pending_invoice_emails": {
    /** List the monthly invoice emails the worker still needs to deliver: the finalized, still-collectible invoice for the month containing asOfDate, for every patient with an email whose invoice email hasn't gone out yet. Always email, fully rendered. Read-only: n8n sends and calls /worker/invoices/:invoiceId/mark_email_sent per success. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostSharePendingInvoiceEmail"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            /** @description Scope generate to one patient (per-patient webhook); null = bulk. */
            patientId?: components["schemas"]["PatientId"] | null;
            /**
             * @description Scope pending-links / pending-receipts to one request (manual send
             * webhook); null = bulk.
             */
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/invoices/:invoiceId/mark_email_sent": {
    /** Record that the worker (n8n) delivered the monthly invoice email, so the invoice stops being returned by /worker/pending_invoice_emails. Medflyt-internal API users only. */
    post: {
      parameters: {
        path: {
          invoiceId: PatientCostShareInvoiceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sentAt: components["schemas"]["Instant"];
              sentTo: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sentTo: string;
            /** @description The email subject + HTML that was sent, stored for the webapp's viewer. */
            subject?: null | string;
            body?: null | string;
            /** @description Set when an agency member triggered the send; null/absent for the worker. */
            agencyMemberId?: components["schemas"]["AgencyMemberId"] | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/pending_receipts": {
    /** List the payment receipt emails the worker still needs to deliver: every request paid through Stripe (link or saved-card charge) that hasn't been receipted, for patients with an email. Pass paymentRequestId to scope to one request (still skipped once receipted). Read-only: n8n sends and calls /worker/payment_requests/:paymentRequestId/mark_receipt_sent per success. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PatientCostSharePendingReceipt"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            asOfDate?: components["schemas"]["LocalDate"] | null;
            /** @description Scope generate to one patient (per-patient webhook); null = bulk. */
            patientId?: components["schemas"]["PatientId"] | null;
            /**
             * @description Scope pending-links / pending-receipts to one request (manual send
             * webhook); null = bulk.
             */
            paymentRequestId?:
              | components["schemas"]["PatientCostSharePaymentRequestId"]
              | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/payment_requests/:paymentRequestId/mark_receipt_sent": {
    /** Record that the worker (n8n) delivered a payment receipt email, so the request stops being returned by /worker/pending_receipts. Medflyt-internal API users only. */
    post: {
      parameters: {
        path: {
          paymentRequestId: PatientCostSharePaymentRequestId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sentAt: components["schemas"]["Instant"];
              sentTo: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sentTo: string;
            /** @description The email subject + HTML that was sent, stored for the webapp's viewer. */
            subject?: null | string;
            body?: null | string;
            /** @description Set when an agency member triggered the send; null/absent for the worker. */
            agencyMemberId?: components["schemas"]["AgencyMemberId"] | null;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/generation_complete": {
    /** Per-patient finalize-done callback: n8n calls this after running generate + finalize for a patient so the originating agency member's open cost-share view refreshes (websocket). Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ok: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            agencyMemberId: components["schemas"]["AgencyMemberId"];
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/eligibility_patients": {
    /** List active cost-share-agency patients in an office that have a Medicaid number + DOB, pre-shaped for a STEDI eligibility subscriber block. Feeds the n8n STEDI → schedule workflow. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["EligibilityPatient"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeId?: components["schemas"]["OfficeId"] | null;
            patientId?: components["schemas"]["PatientId"] | null;
            /**
             * @description Leave out patients who already got an answer (cost share or no cost
             * share) today, New York time. A check that ended in an error doesn't
             * count, so the patient is listed again.
             */
            onlyNeedingCheck?: null | boolean;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/set_schedule_from_eligibility": {
    /** Reconcile a patient's cost-share schedule against a STEDI eligibility result. Creates a schedule (starting on the run date) when a cost-share amount is reported, ends the open schedule when none is reported, leaves it unchanged when the result already matches, and replaces it when it differs. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ok: boolean;
              /**
               * @description What the reconcile did, for the n8n run's logging:
               * - `created`   — no schedule existed; a new one was opened.
               * - `replaced`  — a different schedule existed; it was ended and a new one opened.
               * - `ended`     — an open schedule existed and STEDI reported no cost share.
               * - `unchanged` — the open schedule already matches the eligibility result.
               * - `noop`      — no schedule existed and no cost share was reported.
               * - `error`     — STEDI gave no usable answer; recorded, schedule untouched.
               * @enum {string}
               */
              action:
                | "created"
                | "ended"
                | "error"
                | "noop"
                | "replaced"
                | "unchanged";
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            /**
             * @description Cost-share amount from the eligibility benefit, in cents. `null` (or a
             * value <= 0) means STEDI reported no cost share for this patient — any
             * open schedule is ended. When an amount is present,
             * frequency/paymentDate/linkDeliveryMethod are required.
             */
            amountCents: null | number;
            /** @enum {string} */
            frequency?: "biweekly" | "monthly" | "weekly";
            /** @enum {string} */
            paymentDate?:
              | "FRIDAY"
              | "MONDAY"
              | "SATURDAY"
              | "SUNDAY"
              | "THURSDAY"
              | "TUESDAY"
              | "WEDNESDAY";
            /**
             * @description How the pay link reaches the patient.
             * @enum {string}
             */
            linkDeliveryMethod?: "email" | "sms";
            /**
             * @description Set when STEDI gave no usable answer for this patient (the message says
             * why). The check is recorded as an error and the schedule is left
             * untouched; `amountCents` is ignored.
             */
            stediError?: null | string;
            /** Format: yyyy-MM-dd */
            startDate?: LocalDate;
          };
        };
      };
    };
  };
  "/patient_cost_share/worker/run_attribution": {
    /** Drain one batch of the cost-share attribution queue: match MA64 check lines against cost share the patient paid in the same month. Call in a loop while `didWork` is true. A concurrent call returns status `already_running` and does nothing — stop rather than retry, the run that holds the lock will finish the queue. Medflyt-internal API users only. */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {string} */
              status: "already_running" | "ran";
              didWork: boolean;
              claimed: number;
              succeeded: number;
              failed: number;
              pendingRemaining: number;
              failures: components["schemas"]["CostShareAttributionFailure"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description How many queued (patient, month) pairs to process in this call. Omitted
             * means the server default; the server also caps it, since the whole batch
             * shares one transaction and one advisory lock.
             */
            batchSize?: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/addresses": {
    /** Get patient address */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              addresses: components["schemas"]["PatientAddress"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create a new patient address */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              address: components["schemas"]["PatientAddress"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            evvLocation: "COMMUNITY" | "HOME";
            address: string;
            address2?: null | string;
            description?: null | string;
            phoneNumberIds: components["schemas"]["PatientPhoneNumberId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/addresses/:patientAddressId": {
    /** Update an existing patient address */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientAddressId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              address: components["schemas"]["PatientAddress"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            evvLocation?: "COMMUNITY" | "HOME";
            address?: string;
            address2?: null | string;
            description?: null | string;
            phoneNumberIds?: components["schemas"]["PatientPhoneNumberId"][];
          };
        };
      };
    };
    /** Delete an existing patient address */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientAddressId: number;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/addresses/:patientAddressId/create_phonenumber": {
    /** An agency member attempts to create a phone number and link it to an address */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientAddressId: number;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/phonenumbers": {
    /** Get patient phonenumbers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              phoneNumbers: components["schemas"]["PatientPhoneNumber"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create a new patient phonenumber */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              phoneNumber: components["schemas"]["PatientPhoneNumber"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            type: "MOBILE" | "OTHER" | "TEL";
            label: null | string;
            description: null | string;
            phonenumber: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/phonenumbers/:patientPhoneNumberId": {
    /** Update an existing patient phonenumber */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          patientPhoneNumberId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              phoneNumber: components["schemas"]["PatientPhoneNumber"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            type?: "MOBILE" | "OTHER" | "TEL";
            label?: null | string;
            description?: null | string;
            phonenumber?: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/phonenumbers/:phoneNumberId": {
    /** Delete an existing patient phonenumber */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          phoneNumberId: number;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_payers": {
    /** Get the agency's payers integrated with hhax */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              payers: components["schemas"]["PayerId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/pay_rates": {
    /** Agency member request a list of pay rates of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              payRates: components["schemas"]["PayRateExtended"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/pay_rates": {
    /** Agency member request a list of caregiver pay rates of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverPayRates: components["schemas"]["CaregiverPayRate"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/pay_rates": {
    /** Agency member request a list of patient pay rates of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientPayRates: components["schemas"]["PatientPayRate"][];
              patientDefaultPayRates: components["schemas"]["DefaultPayRate"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/default_visit_pay_rate": {
    /** Agency member request the default hourly payrate for a visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              defaultPayrate: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            payrollCodeId: components["schemas"]["PayrollCodeId"];
            startDate: components["schemas"]["LocalDate"];
            patientId: components["schemas"]["PatientId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches/:payrollBatchId": {
    /** Agency member request a payroll_batch with visits */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              payrollItems: components["schemas"]["PayrollItemExtended"][];
              payrollBatch: components["schemas"]["PayrollBatchExtended"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member request to confirm payroll batch, with excluded visits list */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              payrollItems: components["schemas"]["PayrollItemExtended"][];
              payrollBatch: components["schemas"]["PayrollBatchExtended"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["OldPayrollBatchEditParams"]
            | components["schemas"]["NewPayrollBatchEditParams"];
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/payroll": {
    /** Agency member request all the caregiver's payroll data */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              payrollBatchs: components["schemas"]["PayrollBatchWithVisits"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches/:payrollBatchId/payroll_csv/:version": {
    /** Agency member request a list of payroll_batches of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
          version: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visits: components["schemas"]["PayrollVisitsForCSV"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches/:payrollBatchId/payroll_report_file": {
    /** Agency member request a list of payroll_batches of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              lines: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches_caregivers_report": {
    /** Agency member request caregivers report. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: string;
          to?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              lines: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_verification/:payrollBatchId": {
    /** Agency member requests payroll verification comparison for a payroll batch and previous successful batches. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
        };
        query: {
          count?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              batches: components["schemas"]["PayrollVerificationBatch"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_audit/:payrollBatchId": {
    /** Agency member requests an audit of the visit pay in a payroll batch, for the given service types. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
        };
        query: {
          serviceTypes?: ("HOURLY" | "DAILY" | "VISIT" | "CLUSTER")[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              payrollBatchId: components["schemas"]["PayrollBatchId"];
              isDraft: boolean;
              date: components["schemas"]["LocalDate"];
              weekStart: components["schemas"]["LocalDate"];
              serviceTypes: ("CLUSTER" | "DAILY" | "HOURLY" | "VISIT")[];
              /** @description The latest confirmed batches of the same payroll setup that came before this one. */
              comparableBatches: components["schemas"]["PayrollAuditComparableBatch"][];
              totals: components["schemas"]["PayrollAuditTotals"];
              currentPeriod: components["schemas"]["PayrollAuditTotals"];
              oldPeriod: components["schemas"]["PayrollAuditTotals"];
              payrollCodes: components["schemas"]["PayrollAuditPayrollCode"][];
              topCaregivers: components["schemas"]["PayrollAuditCaregiver"][];
              oldestVisit: components["schemas"]["PayrollAuditVisit"] | null;
              nonOvertimeRates: components["schemas"]["PayrollAuditRateRange"][];
              repaidVisits: components["schemas"]["PayrollAuditRepaidVisit"][];
              /** @description Every caregiver's totals, to compare a caregiver against another batch. */
              caregiverTotals: components["schemas"]["PayrollAuditCaregiverTotal"][];
              distributions: components["schemas"]["PayrollAuditDistributions"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches/:payrollBatchId/items/:itemType/:itemId": {
    /** Agency member removes a single item from a draft payroll batch */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
          itemType:
            | "VISIT"
            | "TRAVEL_TIME"
            | "PTO"
            | "ONLINE_TRAINING"
            | "IN_CLASS";
          itemId: number;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_verification/:payrollBatchId/instapay": {
    /** Agency member requests instapay status for payroll verification */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
        };
        query: {
          "payroll-time"?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              employees: components["schemas"]["PayrollVerificationInstapayEmployee"][];
              hasErrors: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches/:payrollBatchId/upload_caregiver_info": {
    /** Agency member requests uploading caregiver info from payroll batch to payroll platform */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payrollBatchId: PayrollBatchId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              new: number;
              updated: number;
              validationErrors: string[];
              uploadErrors: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/weekly_template_shifts": {
    /** Agency member request patient weekly shifts */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              shifts: components["schemas"]["PatientWeeklyTemplateShiftExtended"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/physicians": {
    /** Agency member attempts to create a new physician for a patient */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PhysicianPatientAssocId"];
              physicianId: components["schemas"]["PhysicianId"];
              isPrimary: boolean;
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
              removedAt: components["schemas"]["Instant"] | null;
              removedBy: components["schemas"]["UserId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            physicianId: components["schemas"]["PhysicianId"];
            isPrimary: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_physicians/:physicianPatientAssocId": {
    /** Agency member asks to delete a patient physician */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          physicianPatientAssocId: PhysicianPatientAssocId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/primary_physician": {
    /** Agency member asks for primary physician for a patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              physician: {
                id: components["schemas"]["PhysicianId"];
                physicianAssocId: components["schemas"]["PhysicianPatientAssocId"];
                firstName: string;
                lastName: string;
                faxNumber: null | string;
                npi: null | string;
                phone: null | string;
                address: null | string;
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/available_physicians": {
    /** Agency member asks for patient available physicians */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              physicians: {
                id: components["schemas"]["PhysicianId"];
                firstName: string;
                lastName: string;
                address: null | string;
                npi: null | string;
                fax: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/primary_physician": {
    /** Caregiver Asks for patients primary physician */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              physician: {
                id: components["schemas"]["PhysicianId"];
                physicianAssocId: components["schemas"]["PhysicianPatientAssocId"];
                firstName: string;
                lastName: string;
                faxNumber: null | string;
                npi: string;
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/v2/primary_physician": {
    /** Caregiver Asks for patients primary physician */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              physician: {
                id: components["schemas"]["PhysicianId"];
                physicianAssocId: components["schemas"]["PhysicianPatientAssocId"];
                firstName: string;
                lastName: string;
                faxNumber: null | string;
                npi: null | string;
                phone: null | string;
                address: null | string;
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/physicians": {
    /** Caregiver asks for all available patients physicians for selection */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              physicians: {
                id: components["schemas"]["PhysicianId"];
                firstName: string;
                lastName: string;
                address: null | string;
                npi: null | string;
                fax: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Caregiver create a physician in a patient's agency */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PhysicianId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            firstName: string;
            lastName: string;
            npi: string;
            fax: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/physicians/:physicianId": {
    /** Caregiver assigns a physician to a patient */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
          physicianId: PhysicianId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patients/:patientId/v2/physicians": {
    /** Caregiver create a physician in a patient's agency */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PhysicianId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            firstName: string;
            lastName: string;
            npi: null | string;
            fax: string;
            address: null | string;
            phone: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/co_service_plan_imports/:importId": {
    /** Everything recorded about one Colorado service plan submission */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          importId: ExternalPatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ExternalPatientServicePlanId"];
              submissionId: string;
              /** @description Which pipeline the submission goes through. See `CoServicePlanKind`. */
              planKind: components["schemas"]["CoServicePlanKind"];
              planLogId: null | string;
              planVersion: null | number;
              planNotes: null | string;
              /** @description When the sender locked the plan. */
              finalizedAt: components["schemas"]["Instant"];
              /** @description When we accepted it. The dashboard's date filter is on this. */
              receivedAt: components["schemas"]["Instant"];
              /** @description The window the sender asked for, null when they left it to the authorizations. */
              startDate: components["schemas"]["LocalDate"] | null;
              endDate: components["schemas"]["LocalDate"] | null;
              status: components["schemas"]["CoServicePlanImportStatus"];
              patientId: components["schemas"]["PatientId"];
              patientFirstName: string;
              patientLastName: string;
              officeId: components["schemas"]["OfficeId"];
              officeName: null | string;
              planOfCareId: components["schemas"]["PlanOfCareId"] | null;
              /**
               * @description A past plan's history plan of care, applied as the plan states it. Null for a
               * current plan, and for a past plan whose history is not applied yet.
               * `planOfCareId` is then the new week's: staged for review, or in force from the
               * start chosen at approval.
               */
              pastPlanOfCareId: components["schemas"]["PlanOfCareId"] | null;
              /**
               * @description When approving would make the schedule take effect, for the patient's today:
               * the choice between today and the next Sunday, or the one day that decides it.
               * Null unless a proposal is waiting for approval.
               */
              approvalStart:
                | {
                    /** @enum {string} */
                    kind: "CHOICE";
                    immediately: components["schemas"]["LocalDate"];
                    nextSunday: components["schemas"]["LocalDate"];
                  }
                | {
                    /** @enum {string} */
                    kind: "FIXED";
                    startDate: components["schemas"]["LocalDate"];
                  }
                | null;
              job: components["schemas"]["CoServicePlanImportJob"] | null;
              /**
               * @description The caregivers the submission named, in this agency. A past plan's also lists the
               * caregivers staffing the patient's existing visits that the sender did not name,
               * with no validated duty.
               */
              caregivers: components["schemas"]["CoServicePlanImportCaregiver"][];
              duties: components["schemas"]["CoServicePlanImportDuty"][];
              /** @description What the model produced. Null when it never ran or nothing was kept. */
              schedule:
                | components["schemas"]["CoServicePlanImportSchedule"]
                | null;
              /**
               * @description The schedule waiting to be applied, when one is. Null for any submission that
               * is not pending review — there is nothing staged to show or change.
               */
              stagedShifts:
                | components["schemas"]["CoServicePlanImportStagedShift"][]
                | null;
              /**
               * @description The Monday of the patient's current week, on their own clock: the week
               * `currentWeekVisits` covers.
               */
              currentWeekStart: components["schemas"]["LocalDate"];
              /**
               * @description The visits the patient actually has this week, which is what their schedule
               * really is -- a template says what visits are generated, not what became of
               * them after a coordinator moved, added or removed one. Empty when they have none.
               */
              currentWeekVisits: components["schemas"]["CoServicePlanImportWeekVisit"][];
              /**
               * @description The weekly template the patient has today, so a reviewer can see what
               * approving would replace. Empty when they have none.
               */
              currentTemplate: components["schemas"]["CoServicePlanImportTemplateShift"][];
              /** @description Authorized vs proposed vs asked-for hours, per service line. */
              hours: components["schemas"]["CoServicePlanImportHoursLine"][];
              /** @description The plan's service lines, for the editor's pickers. */
              lines: components["schemas"]["CoServicePlanImportLine"][];
              /**
               * @description The week exactly as it was FIRST staged, for the editor's original column.
               *
               * Not `schedule.shifts`, which is the engine's raw answer before re-pricing and
               * differs from the staged week on nearly every shift of every generation.
               */
              stagedAsGenerated:
                | components["schemas"]["CoServicePlanImportStagedShift"][]
                | null;
              /** @description Set once a coordinator has replaced the week. */
              coordinatorEdit:
                | components["schemas"]["CoServicePlanImportCoordinatorEdit"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/co_service_plan_imports/:importId/approve": {
    /** Approve the schedule a Colorado service plan submission proposed */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          importId: ExternalPatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              planOfCareId: components["schemas"]["PlanOfCareId"];
              templateShiftsCreated: number;
              recurringVisitsCreated: number;
              /**
               * @description Caveats about a schedule that WAS written — chiefly dates the calendar
               * declined. Returned to the coordinator who approved it, because they are the
               * last person in a position to do anything about them.
               */
              warnings: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description IMMEDIATELY: from today, on the patient's own calendar. NEXT_SUNDAY: from the
             * first Sunday on or after today (today when approving on a Sunday), so the current
             * week finishes on the schedule the patient already has. A current plan whose own
             * start date is still ahead starts on that date either way.
             * @enum {string}
             */
            startFrom: "IMMEDIATELY" | "NEXT_SUNDAY";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/co_service_plan_imports/:importId/schedule": {
    /** Replace a proposed schedule with one a coordinator built */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          importId: ExternalPatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  kind: "VIOLATIONS";
                  violations: components["schemas"]["CoServicePlanImportViolation"][];
                }
              | {
                  /** @enum {string} */
                  kind: "REPLACED";
                  shiftsStaged: number;
                  groupsStaged: number;
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            shifts: components["schemas"]["ReplaceServicePlanScheduleShift"][];
            /**
             * @description Whether the findings have already been answered.
             *
             * False asks the question -- the week is verified and its violations returned
             * with NOTHING written -- and true answers it. One endpoint rather than a
             * separate dry run, because the commit has to re-verify anyway and a check that
             * cannot commit is the same call with the flag the other way.
             */
            acceptViolations: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/co_service_plan_imports/:importId/decline": {
    /** Decline the schedule a Colorado service plan submission proposed */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          importId: ExternalPatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            notes?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/co_service_plan_imports/:importId/regenerate": {
    /** Ask for another schedule for a Colorado service plan submission */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          importId: ExternalPatientServicePlanId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description The engine to use, recorded on the submission. The LP solver is the only one:
             * the AI schedule builder is retired and `ai` is no longer accepted.
             *
             * Omitted leaves whatever the submission already records in place. Sending a
             * value REPLACES it and it sticks across the worker's own retries.
             */
            scheduler?: "solver-highs" | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/offices": {
    /** The offices where caregiver daily-note review is switched on */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              offices: components["schemas"]["VisitDailyNoteReviewOffice"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/page": {
    /** One page of the caregiver daily-note review dashboard */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["VisitDailyNoteListItem"][];
              totalCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            status: components["schemas"]["VisitDailyNotePageStatusFilter"];
            /** @description Null means every office the agency has enabled. */
            officeId: components["schemas"]["OfficeId"] | null;
            patientId: components["schemas"]["PatientId"] | null;
            /** @description Empty means every priority. */
            priorities: string[];
            /** @description Empty means every pathway; otherwise notes routed to any of these. */
            reviewPathways: string[];
            /**
             * @description `CONCERNING` for the notes the classifier flagged, `NON_CONCERNING` for the rest, null for
             * both. One of `visitDailyNoteConcerningFilters`.
             */
            concerning: null | string;
            /**
             * @description Only notes that are due: the visit started longer ago than its office allows for this
             * kind of note. The rule lives on the server so the filter, the `isDue` badge and the
             * patient counts cannot disagree about it.
             */
            dueOnly: null | boolean;
            /** @description Both ends inclusive, read against the visit's start date in its own zone. */
            fromDate: components["schemas"]["LocalDate"] | null;
            toDate: components["schemas"]["LocalDate"] | null;
            limit: number;
            offset: number;
            sortField: null | string;
            sortOrder: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/patients/page": {
    /** One page of patients with daily notes waiting for review */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["VisitDailyNotePatientGroup"][];
              /** @description Patients, not notes. */
              totalCount: number;
              /** @description Notes across every patient the filters match, not only this page's. */
              totalNoteCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeId: components["schemas"]["OfficeId"] | null;
            patientId: components["schemas"]["PatientId"] | null;
            priorities: string[];
            reviewPathways: string[];
            /** @description As on the notes page. */
            concerning: null | string;
            dueOnly: null | boolean;
            fromDate: components["schemas"]["LocalDate"] | null;
            toDate: components["schemas"]["LocalDate"] | null;
            limit: number;
            offset: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/dashboard": {
    /** The daily-notes dashboard: the backlog and the statistics */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              backlog: components["schemas"]["VisitDailyNoteBacklogStats"];
              compliance: components["schemas"]["VisitDailyNoteComplianceStats"];
              incidents: components["schemas"]["VisitDailyNoteIncidentStats"];
              timeToSign: components["schemas"]["VisitDailyNoteTimeToSign"][];
              aiQuality: components["schemas"]["VisitDailyNoteAiQualityStats"];
              syncIssues: components["schemas"]["VisitDailyNoteSyncIssueCounts"];
              /** @description Null when no office the dashboard covers requires a co-signature. */
              cosign: components["schemas"]["VisitDailyNoteCosignStats"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeId: components["schemas"]["OfficeId"] | null;
            visitFrom: components["schemas"]["LocalDate"] | null;
            visitTo: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/sync_issues/page": {
    /** Daily notes whose DoCare upload or Salesforce incident failed */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["VisitDailyNoteSyncIssue"][];
              totalCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            kind: ("DOCARE" | "SALESFORCE") | null;
            officeId: components["schemas"]["OfficeId"] | null;
            limit: number;
            offset: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/sync_issues/resubmit": {
    /** Send failed daily-note syncs again */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              results: components["schemas"]["VisitDailyNoteSyncIssueResubmitResult"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            items: components["schemas"]["VisitDailyNoteSyncIssueResubmitItem"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/patients/:patientId/summary": {
    /** One patient's daily notes at a glance */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientId: components["schemas"]["PatientId"];
              patientName: string;
              patientExternalId: null | string;
              /** @description Notes no attestation covers yet, broken down the same way as a patient group row. */
              unsignedNoteCount: number;
              urgentCount: number;
              highCount: number;
              routineCount: number;
              dueCount: number;
              unclassifiedCount: number;
              /** @description Every live note for the patient, signed or not. */
              totalNoteCount: number;
              attestationCount: number;
              lastSignedAt: components["schemas"]["Instant"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/attestation_declaration": {
    /** The declaration a reviewer signs when approving daily notes */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              version: string;
              text: string;
              /** @description The separate wording a case manager signs when co-signing a batch. */
              cosignVersion: string;
              cosignText: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/:visitInstanceDailyNoteId": {
    /** One caregiver daily note in full */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteId: VisitInstanceDailyNoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["VisitInstanceDailyNoteId"];
              visitInstanceId: components["schemas"]["VisitInstanceId"];
              visitStartTime: components["schemas"]["LocalDateTime"];
              visitEndTime: components["schemas"]["LocalDateTime"];
              visitTimezone: string;
              patientId: components["schemas"]["PatientId"];
              patientName: string;
              caregiverId: components["schemas"]["CaregiverId"] | null;
              caregiverName: null | string;
              source: string;
              revision: number;
              submittedAt: components["schemas"]["Instant"];
              locale: null | string;
              questionnaireVersion: null | string;
              noteCreatedAt: components["schemas"]["Instant"];
              answers: components["schemas"]["VisitDailyNoteAnswerView"][];
              summary: null | string;
              priority: ("HIGH" | "ROUTINE" | "URGENT") | null;
              flagged: boolean;
              reviewPathways: ("CASE_MANAGEMENT" | "RN")[];
              primaryReason: null | string;
              /** @description What the classifier suggested; the confirmed value lives on the critical incident. */
              suggestedIncidentSubtype:
                | (
                    | "Abuse"
                    | "Criminal Activity / Theft"
                    | "Death other than natural cause"
                    | "Exploitation"
                    | "Fraud / Waste / Abuse"
                    | "Legal Involvement"
                    | "Medication Errors"
                    | "Missing Person / Loss of Contact / Elopement"
                    | "Neglect"
                    | "Other"
                    | "Provider and Staff member misconduct"
                    | "Safeguarding Intervention"
                    | "Serious injury"
                    | "Service Interruption"
                    | "Suicide Threat / Suicide Attempt"
                    | "Unplanned Hospitalization"
                    | "Unsafe Living Environment"
                  )
                | null;
              /** @description Which rules fired and the note text that fired them — the audit trail. */
              triggeredRules: components["schemas"]["VisitDailyNoteTriggeredRule"][];
              clinicalSignals: string[];
              /** @description How negation, timing or ambiguity was resolved. */
              contextInterpretation: null | string;
              recommendedReview: null | string;
              confidence: ("HIGH" | "LOW" | "MEDIUM") | null;
              analysisState: components["schemas"]["VisitDailyNoteAnalysisState"];
              /** @description Why the model produced nothing, when it produced nothing. */
              analysisError: null | string;
              status: components["schemas"]["VisitDailyNoteReviewStatus"];
              determination: ("NON_ROUTINE" | "ROUTINE") | null;
              attestation:
                | components["schemas"]["VisitDailyNoteAttestationInfo"]
                | null;
              /** @description Null unless this note's review raised a critical incident. */
              escalationStatus:
                | (
                    | "CREATED_IN_SALESFORCE"
                    | "FAILED"
                    | "NEEDS_REVIEW"
                    | "PENDING_ESCALATION"
                    | "RESOLVED"
                    | "SENDING"
                  )
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/:visitInstanceDailyNoteId/document": {
    /** One daily note as its office's branded PDF */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteId: VisitInstanceDailyNoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /**
               * @description A time-limited link to the rendered PDF.
               *
               * Minted per request and never stored: the URL expires, so a persisted one would
               * serve a dead link on the first read after it lapsed.
               */
              signedUrl: string;
              /** @description When the file behind that link was produced. */
              renderedAt: components["schemas"]["Instant"];
              /** @description Which office template produced it, e.g. `GEORGIA_V1`. */
              template: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/approve": {
    /** Sign an attestation covering a batch of caregiver daily notes */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              attestationId: components["schemas"]["VisitInstanceDailyNoteAttestationId"];
              approvedCount: number;
              signedAt: components["schemas"]["Instant"];
              /** @description True when the office requires a case manager to co-sign before this completes. */
              awaitingCosignature: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description Every note the signer confirmed. The batch is signed whole or not at all: the
             * declaration enumerates these notes, so approving a subset would record a
             * signature over a list the signer never saw.
             */
            visitInstanceDailyNoteIds: components["schemas"]["VisitInstanceDailyNoteId"][];
            /**
             * @description One entry for every note the classifier called HIGH or URGENT. The request is
             * refused if any is missing, or if one names a note that was not flagged.
             */
            determinations: components["schemas"]["VisitDailyNoteDeterminationInput"][];
            /**
             * @description The nurse's "Findings, Evidence, and Recommendations" for notes in the batch, at most one
             * entry per note, and only for notes flagged HIGH or URGENT. A note left out, or with blank
             * text, has none. Printed on that note's PDF.
             */
            findings: components["schemas"]["VisitDailyNoteFindingsInput"][];
            /** @description The declaration the signer actually read, checked against the current one. */
            declarationVersion: string;
            /** @description The identity-and-intent checkbox. Anything but `true` is refused. */
            confirmed: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/sign_off_check": {
    /** Which of these daily notes the caller may not sign, and why */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              blocked: components["schemas"]["VisitDailyNoteSignOffBlock"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceDailyNoteIds: components["schemas"]["VisitInstanceDailyNoteId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/agency_member_licenses": {
    /** The agency's members' professional licenses */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              licenses: components["schemas"]["AgencyMemberLicense"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Record a professional license an agency member holds */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["AgencyMemberLicenseId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            agencyMemberId: components["schemas"]["AgencyMemberId"];
            /** @description Two-letter code of a US state, e.g. "GA". */
            state: string;
            /** @description One of `agencyMemberLicenseTypes`. */
            licenseType: string;
            licenseNumber: string;
            /** @description Null when the license has no expiry on record; it then counts until removed. */
            expiresOn: components["schemas"]["LocalDate"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/agency_member_licenses/:agencyMemberLicenseId/remove": {
    /** Remove a professional license, so it no longer satisfies sign-off rules */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          agencyMemberLicenseId: AgencyMemberLicenseId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              licenses: components["schemas"]["AgencyMemberLicense"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/:visitInstanceDailyNoteId/docare_upload": {
    /** Publish one daily note to DoCare again */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteId: VisitInstanceDailyNoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /**
               * @description Derived from the job's timestamps, never stored -- the same scheme the analysis and
               * document rows use.
               */
              status: components["schemas"]["VisitDailyNoteDocareUploadStatus"];
              /** @description Why the last attempt failed, when it did. */
              error: null | string;
              /** @description How many attempts have been made, and how many are allowed. */
              retryCount: number;
              maxRetries: number;
              /** @description The name the document was filed under in DoCare, once one has been sent. */
              fileName: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/:visitInstanceDailyNoteId/critical_incident": {
    /** The critical incident a daily note raised, and what Salesforce said */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteId: VisitInstanceDailyNoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description Null when the note's review raised no critical incident. */
              incident:
                | components["schemas"]["VisitDailyNoteCriticalIncident"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/:visitInstanceDailyNoteId/critical_incident/resend": {
    /** Send a daily note's critical incident to Salesforce again */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteId: VisitInstanceDailyNoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              status: components["schemas"]["VisitDailyNoteEscalationStatus"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description Correct the subtype before sending again, for an incident Salesforce sent back for
             * review because of it. Null keeps the one already stored.
             */
            incidentSubtype:
              | (
                  | "Abuse"
                  | "Criminal Activity / Theft"
                  | "Death other than natural cause"
                  | "Exploitation"
                  | "Fraud / Waste / Abuse"
                  | "Legal Involvement"
                  | "Medication Errors"
                  | "Missing Person / Loss of Contact / Elopement"
                  | "Neglect"
                  | "Other"
                  | "Provider and Staff member misconduct"
                  | "Safeguarding Intervention"
                  | "Serious injury"
                  | "Service Interruption"
                  | "Suicide Threat / Suicide Attempt"
                  | "Unplanned Hospitalization"
                  | "Unsafe Living Environment"
                )
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_notes/signer_signature": {
    /** Store the signing nurse's own signature */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /**
               * @description Always true -- the request either stored the signature or failed.
               *
               * A body rather than an empty response because every endpoint on this router
               * declares a named response type, and a field that is only ever `true` is easier
               * for a caller to assert on than an empty object it cannot distinguish from a
               * mis-typed one.
               */
              saved: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description Must be a Data URI png image
             *
             * <https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs>
             */
            signatureData: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_note_attestations/page": {
    /** Signed daily-note batches, for the case manager who co-signs them */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["VisitDailyNoteAttestationListItem"][];
              totalCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            status: components["schemas"]["VisitDailyNoteAttestationFilter"];
            /** @description Null means every office the agency has enabled. */
            officeId: components["schemas"]["OfficeId"] | null;
            /** @description Null means every participant. An attestation covers exactly one. */
            patientId: components["schemas"]["PatientId"] | null;
            /**
             * @description Both ends inclusive, read against the date the batch was SIGNED.
             *
             * Not the visit date, which is what the same-named filter means on the notes tab.
             * This list is a record of signing events and shows the signed date in its own
             * column; filtering it by a date the reader cannot see would be the more confusing
             * of the two inconsistencies.
             */
            fromDate: components["schemas"]["LocalDate"] | null;
            toDate: components["schemas"]["LocalDate"] | null;
            limit: number;
            offset: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_note_attestations/:visitInstanceDailyNoteAttestationId": {
    /** One signed batch and the manifest of notes it covers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteAttestationId: VisitInstanceDailyNoteAttestationId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["VisitInstanceDailyNoteAttestationId"];
              signedBy: components["schemas"]["AgencyMemberId"];
              signedByName: string;
              signedAt: components["schemas"]["Instant"];
              declarationVersion: string;
              declarationText: string;
              requiresCosignature: boolean;
              status: components["schemas"]["VisitDailyNoteAttestationStatus"];
              cosignedByName: null | string;
              cosignedAt: components["schemas"]["Instant"] | null;
              cosignDeclarationText: null | string;
              items: components["schemas"]["VisitDailyNoteAttestationManifestItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_note_attestations/:visitInstanceDailyNoteAttestationId/document": {
    /** One PDF of every note in a signed batch */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteAttestationId: VisitInstanceDailyNoteAttestationId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /**
               * @description `PREPARING` means some of the attestation's note documents still had to be rendered and
               * the work was cut off to stay inside one request. Ask again and it carries on.
               */
              state: components["schemas"]["VisitDailyNoteAttestationDocumentState"];
              /** @description One combined PDF of every note in the attestation. Null until `READY`. */
              signedUrl: null | string;
              noteCount: number;
              /** @description Notes still to render; 0 once `READY`. */
              remaining: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_daily_note_attestations/:visitInstanceDailyNoteAttestationId/cosign": {
    /** Co-sign a batch of daily notes a nurse has already signed */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceDailyNoteAttestationId: VisitInstanceDailyNoteAttestationId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              attestationId: components["schemas"]["VisitInstanceDailyNoteAttestationId"];
              cosignedAt: components["schemas"]["Instant"];
              noteCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @description The co-sign declaration the signer actually read. */
            declarationVersion: string;
            /** @description The identity-and-intent checkbox. Anything but `true` is refused. */
            confirmed: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/:officeId/plan_of_care_items": {
    /** Agency member fetches active plan of care items for an office */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
        query: {
          visitInstanceId?: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PlanOfCareItemExtended"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/coordinator/:agencyMemberId/plan_of_care_settings": {
    /** Agency membet attempts to fetch the plan of care settings for the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              planOfCares: components["schemas"]["OfficePlanOfCareSettings"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency membet attempts to update plan of care settings for the agency */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            defaultPocSignaturePerson:
              | components["schemas"]["CaregiverId"]
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/send_plan_of_care_documents_by_email": {
    /** Agency member sends plan of care docs file via email */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            name: string;
            subject: string;
            documentIds: components["schemas"]["PlanOfCareId"][];
            body: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/:officeId/plan_of_care/copy_from_template": {
    /** Agency copy plan of care from template */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              planOfCareTypeId:
                | components["schemas"]["PlanOfCareTypeId"]
                | null;
              showPatientSignature: null | boolean;
              name: null | string;
              columns: {
                id: components["schemas"]["PlanOfCareItemId"];
                /**
                 * @description The HHAeXchange items this plan of care item is mapped to, one per payer. Populated by
                 * `getOfficesPlanOfCareSettingsOfAgency`; absent on the copy-from-template response.
                 */
                hhaxItemsMapping?: {
                  hhaxItemId: components["schemas"]["HHAXPocItemId"];
                  payerId: components["schemas"]["PayerId"];
                }[];
                label: string;
                type: components["schemas"]["POCItemAnswer.POCAnswerType"];
                code: string;
                orderInSection: number;
                section: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/custom_plan_of_care_type": {
    /** Agency member creates a new custom plan of care type for offices */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeIds: components["schemas"]["OfficeId"][];
            requirePatientSignature: boolean;
            items: components["schemas"]["CustomPOCItemRequest"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/default_poc_task_items": {
    /** Get default hard-coded plan of care task items */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sections: string[];
              items: components["schemas"]["CustomPOCItemResponse"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/plans_of_care": {
    /** Get sorted patient plans of care */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              plansOfCare: {
                planOfCareId: components["schemas"]["PlanOfCareId"];
                planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"];
                startDate: components["schemas"]["LocalDate"] | null;
                endDate: components["schemas"]["LocalDate"] | null;
                patientId: components["schemas"]["PatientId"];
                submittedAt: components["schemas"]["Instant"];
                caregiverSignature: null | string;
                patientSignature: null | string;
                pdfUrl: null | string;
                createdAt: components["schemas"]["Instant"];
                duties: {
                  id: components["schemas"]["PlanOfCareDutyId"];
                  period: components["schemas"]["PlanOfCareDutyPeriod"];
                  daysOfWeek: components["schemas"]["DayOfWeek"][] | null;
                  visitsPerWeek: null | number;
                  frequency: null | number;
                  notes: null | string;
                  durationMinutes: null | number;
                  /** @description Occurrences per scheduled day; null means once. */
                  timesPerDay: null | number;
                  /**
                   * @description Occurrences on EACH day, keyed by day name, when a duty happens more
                   * often on some of its days than others: `{"MONDAY": 2, "SUNDAY": 1}`.
                   *
                   * Null is the ordinary case and means `timesPerDay` describes every
                   * day. Where both are present this one is authoritative and
                   * `timesPerDay` is the largest of its values.
                   */
                  timesPerDayByDay:
                    | components["schemas"]["Record<string,number>"]
                    | null;
                  /** @description Whether only caregivers validated for the item may perform the duty. */
                  caregiverRestricted: boolean;
                  item: {
                    id: components["schemas"]["PlanOfCareItemId"];
                    label: string;
                    sectionName: string;
                    code: string;
                    /** @description Agency-wide service code scope of the item. Empty means every service. */
                    serviceCodeIds: components["schemas"]["ServiceCodeId"][];
                  };
                }[];
                signeeName: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member creates a plan of care for a patient */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"];
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"] | null;
            duties: {
              planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
              period: components["schemas"]["PlanOfCareDutyPeriod"];
              daysAWeek: components["schemas"]["DayOfWeek"][] | null;
              visitsPerWeek: null | number;
              frequency: null | number;
              notes: null | string;
              /**
               * @description Occurrences per scheduled day. Omitted or null means once, which is what
               * every duty meant before the field existed.
               */
              timesPerDay?: null | number;
              /**
               * @description Occurrences on EACH day, keyed by `DayOfWeek.name()`, for a duty that
               * happens more often on some of its days than others:
               * `{"MONDAY": 2, "SUNDAY": 1}`.
               *
               * Omitted or null is the ordinary case and means `timesPerDay` describes
               * every day the duty is due. Where both are given this one is
               * authoritative and `timesPerDay` should be the largest of its values.
               */
              timesPerDayByDay?:
                | components["schemas"]["Record<string,number>"]
                | null;
              /**
               * @description Whether only caregivers validated for this duty's catalogue item (see
               * the caregiver's plan-of-care item validations) may perform it. Omitted
               * means false: any caregiver, as every plan of care has always meant.
               */
              caregiverRestricted?: boolean;
            }[];
            /** Format: PlanOfCareId */
            overrideSignatureAndDateFromPlanOfCareId?: PlanOfCareId;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plans_of_care/:planOfCareId": {
    /** Agency member attempts to edit plan of care */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            planOfCareId: components["schemas"]["PlanOfCareId"];
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"] | null;
            duties: {
              planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
              period: components["schemas"]["PlanOfCareDutyPeriod"];
              daysAWeek: components["schemas"]["DayOfWeek"][] | null;
              visitsPerWeek: null | number;
              frequency: null | number;
              notes: null | string;
              /**
               * @description Occurrences per scheduled day. Omitted or null means once, which is what
               * every duty meant before the field existed.
               */
              timesPerDay?: null | number;
              /**
               * @description Occurrences on EACH day, keyed by `DayOfWeek.name()`, for a duty that
               * happens more often on some of its days than others:
               * `{"MONDAY": 2, "SUNDAY": 1}`.
               *
               * Omitted or null is the ordinary case and means `timesPerDay` describes
               * every day the duty is due. Where both are given this one is
               * authoritative and `timesPerDay` should be the largest of its values.
               */
              timesPerDayByDay?:
                | components["schemas"]["Record<string,number>"]
                | null;
              /**
               * @description Whether only caregivers validated for this duty's catalogue item (see
               * the caregiver's plan-of-care item validations) may perform it. Omitted
               * means false: any caregiver, as every plan of care has always meant.
               */
              caregiverRestricted?: boolean;
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/plan_of_care_item_validations": {
    /** The plan of care items a caregiver is validated to perform in this agency. Consulted only for duties a plan restricts to validated caregivers. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              planOfCareItemIds: components["schemas"]["PlanOfCareItemId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member replaces the set of plan of care items a caregiver is validated to perform in this agency */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              planOfCareItemIds: components["schemas"]["PlanOfCareItemId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            planOfCareItemIds: components["schemas"]["PlanOfCareItemId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visits_of_week": {
    /** Agency member ask for all visits of week for caregiver / patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          startOfWeek?: LocalDate;
          patientId?: PatientId;
          caregiverId?: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visits: components["schemas"]["VisitInstanceForDutySheets"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member post bulk duty sheets update for visit instances */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visits: components["schemas"]["VisitsOfWeekDetailsEditParams"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plan_of_care/:planOfCareId/signed_url": {
    /** Agency member requests plan of care signed url */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plans_of_care/:planOfCareId/generate_url": {
    /** Get submitted plan of care pdf url */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plans_of_care/:planOfCareId/regenerate_pdf": {
    /** Regenerate plan of care PDF and return signed URL */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plans_of_care/:planOfCareId/generate_duty_sheets_csv_by_dates": {
    /** Agency member attempts to receive plan of care duties for csv generation */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: PatientId;
          planOfCareId: PlanOfCareId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              duties: {
                id: components["schemas"]["PlanOfCareDutyId"];
                period: components["schemas"]["PlanOfCareDutyPeriod"];
                daysOfWeek: components["schemas"]["DayOfWeek"][] | null;
                visitsPerWeek: null | number;
                frequency: null | number;
                notes: null | string;
                caregiverName: string;
                isCompleted: boolean;
                startDate: components["schemas"]["LocalDate"];
                item: {
                  id: components["schemas"]["PlanOfCareItemId"];
                  label: string;
                  code: string;
                };
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/missed_duties": {
    /** Agency member fetches the duties a visit missed and where they can be made up */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              missedDuties: components["schemas"]["VisitInstanceMissedDuty"][];
              /**
               * @description The live make-ups already handed off this visit, so the modal can list each
               * one with its own undo.
               *
               * A separate list rather than a field on `missedDuties`, because a duty whose
               * occurrences are ALL made up has nothing left to make up and so is not a
               * missed duty at all -- it is absent from that list, and without this one its
               * make-up could not be undone from this page.
               */
              existingMakeUps: components["schemas"]["VisitInstanceDutyMakeUp"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/missed_duties/:planOfCareDutyId/reassign": {
    /** Agency member assigns a missed duty to another visit of the same week */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
          planOfCareDutyId: PlanOfCareDutyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {string} */
              result: "NOT_MISSED" | "SUCCESS" | "TARGET_NOT_ELIGIBLE";
              reassignmentId:
                | components["schemas"]["VisitInstanceDutyReassignmentId"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            targetVisitInstanceId: components["schemas"]["VisitInstanceId"];
            /**
             * @description How many occurrences of the duty this make-up moves.
             *
             * ABSENT means one, which is what every make-up written before a duty could
             * be missed more than once on a visit meant -- so a client that has never
             * heard of occurrences keeps writing exactly the row it always did.
             *
             * More than the source visit still has outstanding is a bad request, not a
             * smaller make-up: see `reassignMissedDuty`.
             */
            occurrences?: number;
          };
        };
      };
    };
    /** Agency member undoes a missed duty reassignment */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
          planOfCareDutyId: PlanOfCareDutyId;
        };
        query: {
          targetVisitInstanceId?: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregiver/:caregiverId/visit/:visitInstanceId/plan_of_care": {
    /** Get latest plan of care for scheduled visit */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              planOfCareWithAnswers: {
                poc: {
                  id: components["schemas"]["PlanOfCareId"];
                  createdAt: components["schemas"]["Instant"];
                  createdBy: components["schemas"]["UserId"];
                  patientId: components["schemas"]["PatientId"];
                  patientSignature:
                    | components["schemas"]["PlanOfCareSignature"]
                    | null;
                  patientUnsignedReason?: null | string;
                  caregiverSignature:
                    | components["schemas"]["PlanOfCareSignature"]
                    | null;
                  submittedAt: components["schemas"]["Instant"] | null;
                  startDate: components["schemas"]["LocalDate"] | null;
                  endDate: components["schemas"]["LocalDate"] | null;
                  pdfUrl: null | string;
                  externalId: null | string;
                };
                planOfCareType: {
                  id: components["schemas"]["PlanOfCareTypeId"];
                  showPatientSignature: boolean;
                };
                docItems: components["schemas"]["PatientDocumentContentItem"][];
                planOfCareItems: components["schemas"]["POCItem"][];
                patientDocId: components["schemas"]["PatientDocumentTypeId"];
                patientDocumentVersionId: components["schemas"]["PatientDocumentVersionId"];
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/plan_of_care": {
    /** Get latest plan of care for patient task */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              planOfCareWithAnswers: {
                poc: {
                  id: components["schemas"]["PlanOfCareId"];
                  createdAt: components["schemas"]["Instant"];
                  createdBy: components["schemas"]["UserId"];
                  patientId: components["schemas"]["PatientId"];
                  patientSignature:
                    | components["schemas"]["PlanOfCareSignature"]
                    | null;
                  patientUnsignedReason?: null | string;
                  caregiverSignature:
                    | components["schemas"]["PlanOfCareSignature"]
                    | null;
                  submittedAt: components["schemas"]["Instant"] | null;
                  startDate: components["schemas"]["LocalDate"] | null;
                  endDate: components["schemas"]["LocalDate"] | null;
                  pdfUrl: null | string;
                  externalId: null | string;
                };
                planOfCareType: {
                  id: components["schemas"]["PlanOfCareTypeId"];
                  showPatientSignature: boolean;
                };
                docItems: components["schemas"]["PatientDocumentContentItem"][];
                planOfCareItems: components["schemas"]["POCItem"][];
                patientDocId: components["schemas"]["PatientDocumentTypeId"];
                patientDocumentVersionId: components["schemas"]["PatientDocumentVersionId"];
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregiver/:caregiverId/scheduled_visit/:scheduledVisitId/plan_of_care/:planOfCareId/signature": {
    /** RN (or patient) signs a plan of care */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          scheduledVisitId: VisitInstanceId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            type: "Caregiver" | "Patient";
            data: null | string;
            unsignedReason?: null | string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/plan_of_care/:planOfCareId/signature": {
    /** RN (or patient) signs a plan of care of patient task */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            type: "Caregiver" | "Patient";
            data: null | string;
            unsignedReason?: null | string;
          };
        };
      };
    };
  };
  "/caregiver/:caregiverId/scheduled_visit/:visitInstanceId/plan_of_care/:planOfCareId/version": {
    /** RN answers or submits the plan of care of visit instance */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              success: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            content: components["schemas"]["PatientDocumentContentItem"][];
            isPublished: boolean;
            /** Format: yyyy-MM-dd */
            startDate?: LocalDate;
            /** Format: yyyy-MM-dd */
            endDate?: LocalDate;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/plan_of_care/:planOfCareId/version": {
    /** RN answers or submits the plan of care of patient task */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          planOfCareId: PlanOfCareId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              success: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            content: components["schemas"]["PatientDocumentContentItem"][];
            isPublished: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_poc_payers": {
    /** Get the agency's HHAeXchange payers for the duty code mapping screen */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              payers: components["schemas"]["HHAXPlanOfCarePayer"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_poc/:payerId": {
    /** Get all HHAX poc items for payer */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          payerId: PayerId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["HHAXPlanOfCareItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_medflyt_poc_mapping": {
    /** Upsert new HHAX-Medflyt poc mapping */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            payerId: components["schemas"]["PayerId"];
            planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"];
            medflytPOCItemId: components["schemas"]["PlanOfCareItemId"];
            hhaxPOCItemId: components["schemas"]["HHAXPocItemId"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/sandata_poc_item_mappings": {
    /** Get the Sandata duty code mapping of every plan of care item of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          /** Narrow the Sandata duty codes to the ones usable by this office's state */
          officeId?: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sandataItems: components["schemas"]["SandataPlanOfCareItem"][];
              mappings: components["schemas"]["SandataPlanOfCareItemMapping"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Set or clear the Sandata duty code of a plan of care item */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
            /**
             * @description The complete set of Sandata duty codes for the item - codes that are left out are
             * unmapped. An empty array clears the mapping entirely.
             */
            sandataPlanOfCareItemIds: components["schemas"]["SandataPlanOfCareItemId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plan_of_care_type/:planOfCareTypeId": {
    /** Agency member patches plan of care type */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareTypeId: PlanOfCareTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PlanOfCareTypeId"];
              createdAt: components["schemas"]["Instant"];
              agencyId: components["schemas"]["AgencyId"];
              name: string;
              removedAt: components["schemas"]["Instant"] | null;
              officeId: components["schemas"]["OfficeId"];
              showPatientSignature: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            showPatientSignature?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plan_of_care_type/:planOfCareTypeId/items": {
    /** Agency member gets all plan of care type items, including inactive ones */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareTypeId: PlanOfCareTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PlanOfCareTypeItemDetailed"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member adds items to an existing plan of care type */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareTypeId: PlanOfCareTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PlanOfCareTypeItemDetailed"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            items: components["schemas"]["CustomPOCItemRequest"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plan_of_care_type/:planOfCareTypeId/items/:planOfCareItemId": {
    /** Agency member activates or deactivates a plan of care type item */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareTypeId: PlanOfCareTypeId;
          planOfCareItemId: PlanOfCareItemId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PlanOfCareTypeItemDetailed"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            isActive: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/plan_of_care_type/:planOfCareTypeId/items/:planOfCareItemId/service_codes": {
    /** Agency member sets the service codes a plan of care type item applies to, agency-wide. An empty list means every service code. */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          planOfCareTypeId: PlanOfCareTypeId;
          planOfCareItemId: PlanOfCareItemId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["PlanOfCareTypeItemDetailed"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            serviceCodeIds: components["schemas"]["ServiceCodeId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/staffing_issues": {
    /** Staffing issues */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          issues?: string;
          offices?: string;
          contracts?: string;
          startDate?: LocalDate;
          endDate?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              issues: components["schemas"]["StaffingIssue"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/staffing_issues_types": {
    /** Staffing issues */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              types: components["schemas"]["StaffingIssuesType"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hours_usage": {
    /** Get hours usage compare */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          startDate?: LocalDate;
          endDate?: LocalDate;
          compareOptions?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              data: components["schemas"]["HoursUsagePatientData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              errors: string[];
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/service_codes": {
    /** Get the agency's service code */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              serviceCodes: components["schemas"]["ServiceCodeWithPayrollCodes"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/patient/:patientId/uploaded_documents": {
    /** Gets all uploaded documents by patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: components["schemas"]["CaregiverUploadedPatientDocumentForWebapp"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/training_center/all_bundles": {
    /** Caregiver gets a list of all the training center bundles that she can see */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              bundles: components["schemas"]["TrainingCenterCaregiverBundle"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/training_center/bundles/:trainingCenterBundleDueDateId": {
    /** Caregiver gets a training center bundle */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          trainingCenterBundleDueDateId: TrainingCenterBundleDueDateId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyId: components["schemas"]["AgencyId"];
              bundleId: components["schemas"]["TrainingCenterBundleId"];
              bundleDueDateId: components["schemas"]["TrainingCenterBundleDueDateId"];
              bundleDueDateYear: number;
              bundleDueDateEnforceWatchOrder: boolean;
              visibleDate: components["schemas"]["LocalDate"];
              completionDate: components["schemas"]["LocalDate"];
              complianceDate: components["schemas"]["LocalDate"];
              bundleParams: components["schemas"]["TrainingCenterBundleParams"];
              bundleDisplayData: components["schemas"]["TrainingCenterTranslated<TrainingCenterDisplayData>"][];
              completionCertificate:
                | components["schemas"]["TrainingCenterBundleCertificate"]
                | null;
              bundleItems: components["schemas"]["TrainingCenterBundleItem"][];
              isOrientation: boolean;
              showDuration: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/training_center/bundles/:trainingCenterBundleDueDateId/items/:trainingCenterBundleItemId/video/:language/:clientUniqueId/watch_segment": {
    /** Caregiver notifies the server that she watched a segment of a training center video item */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          trainingCenterBundleDueDateId: TrainingCenterBundleDueDateId;
          trainingCenterBundleItemId: TrainingCenterBundleItemId;
          /** The language that the caregiver chose to watch the video in */
          language: string;
          /** A unique random token that the client generates */
          clientUniqueId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalSecondsWatched: number;
              /** @description Array of segments that were watched: `[startSecond, endSecond]` */
              watchedSegments: [number, number][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startSeconds: number;
            endSeconds: number;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/training_center/bundles/:trainingCenterBundleDueDateId/items/:trainingCenterBundleItemId/pdf/:clientUniqueId/watch_segment": {
    /** Caregiver notifies the server that she watched a segment of a training center pdf item */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          trainingCenterBundleDueDateId: TrainingCenterBundleDueDateId;
          trainingCenterBundleItemId: TrainingCenterBundleItemId;
          clientUniqueId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalSecondsWatched: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            language: components["schemas"]["TrainingCenterDisplayLanguage"];
            secondsWatched: number;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/training_center/bundles/:trainingCenterBundleDueDateId/items/:trainingCenterBundleItemId/submit_test": {
    /** Caregiver submits the answers to a training center bundle item test */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          trainingCenterBundleDueDateId: TrainingCenterBundleDueDateId;
          trainingCenterBundleItemId: TrainingCenterBundleItemId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.NotFound"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.BundleNotVisibleToCaregiver"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.OutdatedTestVersion"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.AlreadyCompletedBundleItem"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.ExemptFromBundleItem"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.TooManyFailedAttempts"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.TestNotUnlocked"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.QuestionAnswersInvalid"]
              | components["schemas"]["TrainingCenterCaregiverSubmitTestResult.Success"];
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            testVersionNum: number;
            /**
             * @description The language that was displayed to the caregiver when she submitted the
             * test.
             */
            language: components["schemas"]["TrainingCenterDisplayLanguage"];
            caregiverSignatureDataURL: string;
            questionAnswers: components["schemas"]["TrainingCenterCaregiverQuestionAnswer"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/training_center/bundles/:trainingCenterBundleId/bundle_items/:trainingCenterBundleItemId/languages/:language/video_dimensions": {
    /** Update video dimensions settings */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          trainingCenterBundleId: TrainingCenterBundleId;
          trainingCenterBundleItemId: TrainingCenterBundleItemId;
          language: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            width: null | number;
            height: null | number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/auto_recalculate_visit_authorizations": {
    /** Clear matching visit authorizations and automatically recalculate the optimal authorization allocation */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientContractId: components["schemas"]["PatientContractId"];
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            full?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/visit_instances_billing": {
    /** Agency member request a list off visit_instances of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstances: components["schemas"]["VisitInstanceBillingWithBroadcast"][];
              patientVacations: components["schemas"]["PatientVacation"][];
              notes: components["schemas"]["CalendarNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/visit_instances_billing": {
    /** Agency member request a list off visit_instances of the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstances: components["schemas"]["VisitInstanceBillingWithBroadcast"][];
              ptoInstances: components["schemas"]["CaregiverPtoInstances"];
              notes: components["schemas"]["CalendarNote"][];
              absences: components["schemas"]["CaregiverAbsence"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/clocked_visits": {
    /**
     * Agency member request a list of visit_instances of the agency
     *                 only for caregivers enabled the clock-in and clock-out feature.
     */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          contracts?: string;
          offices?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstances: components["schemas"]["ClockedVisitInstance"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/selfie_compare/:clockType": {
    /** Agency Member request a selfie compare of a visit instance. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
          clockType: "IN" | "OUT";
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverSelfieSignedUrl: null | string;
              visitInstanceSelfieSignedUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/bulk_edit_visit_instance": {
    /** Update bulk visit_instance records */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstances: components["schemas"]["VisitInstance"][];
              overlappingCaregiver: components["schemas"]["VisitInstanceOverlappingValidation"][];
              overlappingPatient: components["schemas"]["VisitInstanceOverlappingValidation"][];
              caregiverChangeBlockIds: components["schemas"]["VisitInstanceId"][];
              missingNotes: components["schemas"]["VisitInstanceId"][];
              skippedVisitsAndMissingPermissions:
                | components["schemas"]["EditVisitsInstancesError"]
                | null;
              caregiversWithNoValidHireDate: string[];
              assignWithIncreasedCaregiverOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ids: components["schemas"]["VisitInstanceId"][];
            changes: components["schemas"]["VisitInstanceEditParams"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instance_info/:visitInstanceId": {
    /** Agency member requests visit instance modal's general data. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["Patient"];
              caregiver: components["schemas"]["Caregiver"] | null;
              visitInfo: components["schemas"]["VisitInstaceModalVisitInfo"];
              planOfCareVersionDuties: components["schemas"]["VisitInstanceModalCaregiverPlanOfCareVersionDuties"];
              visitNotes: components["schemas"]["VisitInstanceNote"][];
              potentialClockRecords: components["schemas"]["ClockinClockoutRecordPossibilityByVisitInstance"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/missed": {
    /** Caregiver marks visit as missed */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            taskUnscheduleReason?: {
              id: components["schemas"]["NotePredefinedAnswerId"];
              text: string;
              code: null | string;
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/remove_visit_instances": {
    /** Agency member requests to remove visit instances. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              deletedVisitInstanceIds: components["schemas"]["VisitInstanceId"][];
              skippedVisitsAndMissingPermissions:
                | components["schemas"]["EditVisitsInstancesError"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ids: components["schemas"]["VisitInstanceId"][];
            manualRemoveNote?: components["schemas"]["AgencyNoteCreateParams"];
            approvalNote?: components["schemas"]["AgencyNoteEditParams"] | null;
            broadcastTask?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/revive": {
    /** Agency member revives a removed task visit and re-links its task instance. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/bulk_remove_visit_instances": {
    /** Agency member requests to remove visit instances. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              deletedVisitInstanceIds: components["schemas"]["VisitInstanceId"][];
              skippedVisitsAndMissingPermissions:
                | components["schemas"]["EditVisitsInstancesError"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            removeMode?: "SingleVisits" | "WeeklyPattern";
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
            shouldUpdateWeeklyTemplate?: boolean;
            manualRemoveNote?: components["schemas"]["AgencyNoteCreateParams"];
            approvalNote?: components["schemas"]["AgencyNoteCreateParams"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/flattened": {
    /** Agency member request a list of visit_instances of the agency by searchTerm (id), caregiverId and/or patientId */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
        query: {
          searchTerm?: string;
          caregiverId?: CaregiverId;
          patientId?: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visits: components["schemas"]["VisitInstanceFlattenedData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/visits/:visitBroadcastId/engagements2": {
    /** Retrieve all the caregiver visit engagments of said visit */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | components["schemas"]["VisitEngagementsDetailsWithInstances"]
              | components["schemas"]["FlexibleVisitEngagementDetails"];
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/visits/:visitId/broadcasted_to": {
    /**
     * Get a list of all the caregivers that a visit was broadcasted to
     *
     *         note: returns all the caregivers that visit would of been broadcasted to
     */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          visitId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["BroadcastedToCaregiver"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/visits/:visitId/broadcast_overtime": {
    /** Gets a list of overtime for caregiver visit engagements */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          visitId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverWithOvertime"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/visits/:visitId/caregivers_work_time_by_visit_weeks": {
    /** Coordinator requests the working hours of a caregiver in each week of a time period. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitId: VisitBroadcastId;
        };
        query: {
          caregiverIds?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverWithWorkTimeData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/visit_recommendations": {
    /** Agency Member gets recommendations for a potential new visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              recommendations: components["schemas"]["VisitChangeRecommendation"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            treatment: components["schemas"]["TreatmentId"] | null;
            startTime: components["schemas"]["LocalDateTime"];
            endTime: components["schemas"]["LocalDateTime"];
            /** @description Is this a single visit or recurring visit? */
            isSingleVisit: boolean;
            /** @description Defines the time slots of the visit over a given week. */
            dayTimeParams: components["schemas"]["VisitDayTimeParams"] | null;
            /** @description USD, integer cents. "$11.99" equals the value 1199 */
            price: null | number;
            certification: components["schemas"]["CaregiverCertification"][];
            /** @description "M" or "F" (or null for either gender) */
            gender: ("F" | "M") | null;
            /** @description "M" or "F" (or null for either gender) */
            patientGender: ("F" | "M") | null;
            /** @description Must be one of 'Caregiver.ALL_LANGUAGES' */
            languages: string[];
            generalNotes?: string;
            patientName: string;
            patientAddress: string;
            patientAddress2: null | string;
            patientAddressInstructions: null | string;
            /** @description Should be derived from the patientAddress using the Google Maps Geocoding API */
            patientAddressComponents: components["schemas"]["AddressComponents"];
            /** @description Value is in meters */
            assignableCaregiverRadius: null | number;
            patientPhone: null | string;
            patientAlternativePhone: null | string;
            paymentType: string;
            hideEndDateFromCaregiver: null | boolean;
            caseDetails?: string;
            salesRep?: null | string;
            referralDate?: components["schemas"]["LocalDate"] | null;
            referralSource?: null | string;
            /** @description timezone from the tz database (IANA) */
            timezone: string;
            assignedCoordinators: components["schemas"]["AgencyMemberId"][];
            isAssessment: boolean;
            isPreAssigned: boolean;
            isFromAlgorithm: boolean;
            rnVisitParams: components["schemas"]["RNVisitParams"];
            broadcastToRNTypes?: string[];
            visitLabels: components["schemas"]["VisitLabelText"][];
            flexibleVisitParams:
              | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
              | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
              | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
              | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
              | components["schemas"]["PermanentFixedHoursFlexibleDays"]
              | components["schemas"]["SingleFlexible"]
              | null;
            splitShiftParams: components["schemas"]["SplitShiftParams"] | null;
            isGradual: boolean;
            requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
            patientId: components["schemas"]["PatientId"];
            planOfCareType: components["schemas"]["PlanOfCareTypeId"] | null;
            visitInfo?: string[] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/visits": {
    /** Agency Member creates a new Visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["VisitBroadcastId"];
              treatmentId: components["schemas"]["TreatmentId"] | null;
              createdAt: components["schemas"]["Instant"];
              updatedAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMember"];
              assignedCoordinators: components["schemas"]["AgencyMemberId"][];
              previewedBy: components["schemas"]["CaregiverWithReason"][];
              moreDetailsViewedBy: components["schemas"]["CaregiverWithReason"][];
              acceptedBy: components["schemas"]["CaregiverAccepted"][];
              ignoredRequestsBy: components["schemas"]["Caregiver"][];
              pendingConfirmationRequests:
                | components["schemas"]["FlexibleVisitEngagementPendingConfirmationTo"][]
                | components["schemas"]["VisitEngagementPendingConfirmationTo"][];
              assignedCaregiver: components["schemas"]["Caregiver"] | null;
              assignedAt: components["schemas"]["Instant"] | null;
              cancelled: boolean;
              cancelledDate: components["schemas"]["Instant"] | null;
              cancelledByCaregiver: boolean;
              cancelledReason: null | string;
              startTime: components["schemas"]["LocalDateTime"];
              endTime: components["schemas"]["LocalDateTime"];
              /** @description Is this a single visit or recurring visit? */
              isSingleVisit: boolean;
              /** @description Defines the time slots of the visit over a given week. */
              dayTimeParams: components["schemas"]["VisitDayTimeParams"] | null;
              /** @description USD, integer cents. "$10.99" equals the value 1099 */
              price: null | number;
              certification: components["schemas"]["CaregiverCertification"][];
              /** @description "M" or "F" (or null for either gender) */
              gender: null | string;
              /** @description "M" or "F" (or null for either gender) */
              patientGender: null | string;
              /** @description Must be one of 'Caregiver.ALL_LANGUAGES' */
              languages: string[];
              generalNotes: string;
              patientName: string;
              patientAddress: string;
              patientAddress2: null | string;
              patientAddressInstructions: null | string;
              patientAddressComponents: components["schemas"]["AddressComponents"];
              patientAddressLoc: components["schemas"]["Geo"];
              /** @description timezone from the tz database (IANA) */
              timezone: string;
              /** @description Value is in meters */
              assignableCaregiverRadius: null | number;
              patientPhone: null | string;
              patientAlternativePhone: null | string;
              caseDetails: string;
              salesRep: null | string;
              referralDate: components["schemas"]["LocalDate"] | null;
              referralSource: null | string;
              paymentType: null | string;
              hideEndDateFromCaregiver: null | boolean;
              isPreAssigned: boolean;
              fullTimeOffered: components["schemas"]["CaregiverId"] | null;
              fullTimeOfferRejected: boolean;
              rnVisitParams: components["schemas"]["RNVisitParams"];
              visitLabels: components["schemas"]["VisitLabelText"][];
              flexibleVisitParams:
                | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
                | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
                | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
                | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
                | components["schemas"]["PermanentFixedHoursFlexibleDays"]
                | components["schemas"]["SingleFlexible"]
                | null;
              splitShiftParams:
                | components["schemas"]["SplitShiftParams"]
                | null;
              splitShiftFullyAssigned: null | boolean;
              isGradual: boolean;
              requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
              originalVisitDetails:
                | components["schemas"]["OriginalVisitDetails"]
                | null;
              patientId: components["schemas"]["PatientId"];
              planOfCareType: components["schemas"]["PlanOfCareTypeId"] | null;
              awaitingCaregiverPatientContact:
                | components["schemas"]["CaregiverId"]
                | null;
              patientContactEndTime: components["schemas"]["Instant"] | null;
              patientAdmissionId?: null | string;
              isNewVisitType: boolean;
              assignedCaregiverIds: components["schemas"]["CaregiverId"][];
              visitInstancesCount: number;
              broadcastType: null | string;
              originalStartTime: components["schemas"]["LocalDateTime"];
              allowMultipleCaregivers: boolean;
              visitInstances?: components["schemas"]["VisitInstance"][] | null;
              visitInfo?: string[] | null;
              isVisitAssignmentBlocked: boolean;
              relatedVisitAssignmentId?:
                | components["schemas"]["VisitAssignmentId"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            treatment: components["schemas"]["TreatmentId"] | null;
            startTime: components["schemas"]["LocalDateTime"];
            endTime: components["schemas"]["LocalDateTime"];
            /** @description Is this a single visit or recurring visit? */
            isSingleVisit: boolean;
            /** @description Defines the time slots of the visit over a given week. */
            dayTimeParams: components["schemas"]["VisitDayTimeParams"] | null;
            /** @description USD, integer cents. "$11.99" equals the value 1199 */
            price: null | number;
            certification: components["schemas"]["CaregiverCertification"][];
            /** @description "M" or "F" (or null for either gender) */
            gender: ("F" | "M") | null;
            /** @description "M" or "F" (or null for either gender) */
            patientGender: ("F" | "M") | null;
            /** @description Must be one of 'Caregiver.ALL_LANGUAGES' */
            languages: string[];
            generalNotes?: string;
            patientName: string;
            patientAddress: string;
            patientAddress2: null | string;
            patientAddressInstructions: null | string;
            /** @description Should be derived from the patientAddress using the Google Maps Geocoding API */
            patientAddressComponents: components["schemas"]["AddressComponents"];
            /** @description Value is in meters */
            assignableCaregiverRadius: null | number;
            patientPhone: null | string;
            patientAlternativePhone: null | string;
            paymentType: string;
            hideEndDateFromCaregiver: null | boolean;
            caseDetails?: string;
            salesRep?: null | string;
            referralDate?: components["schemas"]["LocalDate"] | null;
            referralSource?: null | string;
            /** @description timezone from the tz database (IANA) */
            timezone: string;
            assignedCoordinators: components["schemas"]["AgencyMemberId"][];
            isAssessment: boolean;
            isPreAssigned: boolean;
            isFromAlgorithm: boolean;
            rnVisitParams: components["schemas"]["RNVisitParams"];
            broadcastToRNTypes?: string[];
            visitLabels: components["schemas"]["VisitLabelText"][];
            flexibleVisitParams:
              | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
              | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
              | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
              | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
              | components["schemas"]["PermanentFixedHoursFlexibleDays"]
              | components["schemas"]["SingleFlexible"]
              | null;
            splitShiftParams: components["schemas"]["SplitShiftParams"] | null;
            isGradual: boolean;
            requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
            patientId: components["schemas"]["PatientId"];
            planOfCareType: components["schemas"]["PlanOfCareTypeId"] | null;
            visitInfo?: string[] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/visits/:visitId": {
    /** Agency Member sends another push notification for a visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          visitId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visits/:visitBroadcastId/broadcasted_filters_by_visit": {
    /** Agency Member asks to see which caregivers got or didn't get a specific visit. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitDetails: {
                visitBroadcastId: components["schemas"]["VisitBroadcastId"];
                patientId: components["schemas"]["PatientId"];
                patientName: string;
                startTime: components["schemas"]["Instant"];
                endTime: components["schemas"]["Instant"];
                isMultipleCaregivers: boolean;
                isFlexibleVisit: boolean;
                flexibleVisitParams:
                  | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
                  | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
                  | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
                  | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
                  | components["schemas"]["PermanentFixedHoursFlexibleDays"]
                  | components["schemas"]["SingleFlexible"]
                  | null;
              };
              caregiverBroadcastedToFilterInfo: {
                caregiverId: components["schemas"]["CaregiverId"];
                caregiverFirstName: string;
                caregiverLastName: string;
                caregiverGender: string;
                caregiverAddress: string;
                caregiverCertifications: components["schemas"]["CaregiverCertification"][];
                visitBroadcatedToCaregiver: boolean;
                visitNotBroadcastedReasons: components["schemas"]["NotBroadcastedToCaregiverReason"][];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visits/:visitBroadcastId/not_broadcasted_to_caregivers": {
    /** Agency Member asks to see which caregivers didn't get a specific visit. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: {
                caregiverId: components["schemas"]["CaregiverId"];
                visitNotBroadcastedReasons: components["schemas"]["NotBroadcastedToCaregiverReason"][];
                /**
                 * @description Denormalised so the broadcast modal can label the caregiver without a
                 * dictionary of every caregiver. Null if the id resolves to nobody.
                 */
                caregiver: components["schemas"]["CaregiverRowDisplay"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits5": {
    /** Retrieve all of the visits that are available for a caregiver */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitBroadcasts: components["schemas"]["CaregiverVisitBroadcastTypes.Available"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits6": {
    /** Retrieve all of the visits that are available for a caregiver */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitBroadcasts: components["schemas"]["CaregiverVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits8": {
    /** Retrieve all of the visits that are available for a caregiver */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitBroadcasts: components["schemas"]["CaregiverVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits7": {
    /** Retrieve all of the visits that are available for a caregiver */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitBroadcasts: components["schemas"]["CaregiverVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits9": {
    /** Retrieve all of the visits that are available for a caregiver */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitBroadcasts: components["schemas"]["CaregiverVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits/:visitId/more_details_viewed": {
    /** Caregiver has entered the more details screen */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/visits/:visitId/accepted2": {
    /** Caregiver requests a visit. */
    put: {
      parameters: {
        path: {
          visitId: VisitBroadcastId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error: "ONBOARDING_NOT_COMPLETED";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            requestedInstances: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_broadcasts/:visitBroadcastId/accepted_flexible": {
    /** Caregiver accepts flexible visit */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            days: components["schemas"]["CaregiverFlexibleVisitRequestParams"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visits/:visitBroadcastId/not_interested2": {
    /** Caregiver doesn't want to see visit the visit instances anymore. */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            reason: components["schemas"]["NotInterestedReason"];
            rejectedInstances: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/agency/:agencyId/agency_members/:agencyMemberId/visits/:visitBroadcastId/caregivers/:caregiverId/ignore_request": {
    /** Agency member ignored the caregivers request. */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstances: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visits/:visitBroadcastId/requested2": {
    /** Caregiver has cancelled her request of a visit */
    delete: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
        query: {
          visitInstances?: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/schedule_instances": {
    /** Get future schedule for caregiver, consisting of scheduled visits */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstances: components["schemas"]["VisitInstanceMobileDetails"][];
              importedVisits: components["schemas"]["CaregiverImportedVisitDetails"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/visits": {
    /** Edit single(s)/permanent visit(s) */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              skippedVisitsAndMissingPermissions:
                | components["schemas"]["EditVisitsInstancesError"]
                | null;
              skippedBroadcastAssignedVisitInstnaces:
                | components["schemas"]["VisitInstanceWithLocalDateTime"][]
                | null;
              assignWithIncreasedCaregiverOvertime: boolean;
              visitInstanceIds: components["schemas"]["VisitInstanceId"][];
              overlappingIds: components["schemas"]["VisitInstanceId"][];
              caregiversWithNoValidHireDate: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["VisitEditParamsTypes.SingleVisits"]
            | components["schemas"]["VisitEditParamsTypes.WeeklyPattern"];
        };
      };
    };
    /** Create new single/permanent/multiple-singles visit form new visit modal */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstanceIds: components["schemas"]["VisitInstanceId"][];
              visitBatchIds: components["schemas"]["VisitBatchId"][];
              /** Format: VisitBroadcastId */
              visitBroadcastId?: VisitBroadcastId;
              overlappingPatient: components["schemas"]["VisitInstanceOverlappingValidation"][];
              overlappingCaregiver: components["schemas"]["VisitInstanceOverlappingValidation"][];
              assignWithIncreasedCaregiverOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "InvalidFlexibleVisitRequest";
                  error: string;
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["FlexiblePermanentVisit"]
            | components["schemas"]["FlexibleSingleVisit"]
            | components["schemas"]["FlexibleMultipleShifts"]
            | components["schemas"]["VisitCreateParamsTypes.SingleVisit"]
            | components["schemas"]["VisitCreateParamsTypes.PermanentVisit"]
            | components["schemas"]["VisitCreateParamsTypes.MultipleShifts"];
        };
      };
    };
    /** Remove single(s)/permanent visit(s) */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              deletedVisitInstanceIds: components["schemas"]["VisitInstanceId"][];
              skippedVisitsAndMissingPermissions:
                | components["schemas"]["EditVisitsInstancesError"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["VisitRemoveParamsTypes.SingleVisits"]
            | components["schemas"]["VisitRemoveParamsTypes.WeeklyPattern"];
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/visits/check_overlapping": {
    /** Check and get caregiver overlapping visits */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              overlappingVisits: components["schemas"]["VisitInstanceBillingWithBroadcast"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/broadcast_visits": {
    /** Agency member broadcasts visits */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitBroadcastId: components["schemas"]["VisitBroadcastId"];
              updatedInstancesIds:
                | components["schemas"]["VisitInstanceId"][]
                | null;
              skippedAssignedVisitInstances:
                | components["schemas"]["VisitInstanceWithLocalDateTime"][]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["VisitBroadcastCreateTypes.Pattern"]
            | components["schemas"]["VisitBroadcastCreateTypes.PatternWithInstances"]
            | components["schemas"]["VisitBroadcastCreateTypes.PermanentWithIds"]
            | components["schemas"]["VisitBroadcastCreateTypes.Singles"];
        };
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/broadcast_visits/:visitBroadcastId": {
    /** Agency member stops broadcast */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/patients/:patientId/broadcast_visits/stop": {
    /** Agency member stops visits broadcast */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["VisitBroadcastStopParams.BroadcastStopParams"]
            | components["schemas"]["VisitBroadcastStopParams.VisitStopParams"];
        };
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/patients/:patientId/broadcast_visits/edit_flexible": {
    /** Agency member stops visits broadcast */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            stopParams: {
              visitBroadcastIdToStop: components["schemas"]["VisitBroadcastId"];
            };
            newVisitParams: components["schemas"]["FlexibleVisitBroadcastCreateParams"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/flexible_visit_broadcast": {
    /** Agency member getting all the patient flexible visit broadcasts by date range and patient id */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              flexibleVisitBroadcasts: components["schemas"]["FlexibleVisitBroadcast"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/visits/:visitBroadcastId/caregiver_times": {
    /** Get all requested caregivers hours per weeks of the broadcast */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregviers: components["schemas"]["CaregiverRequestedHoursPerWeek"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_broadcasts/flattened": {
    /** Agency member request a list of visit_broadcasts of the agency by searchTerm (id), and/or patientId */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
        query: {
          searchTerm?: string;
          caregiverId?: CaregiverId;
          patientId?: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visits: components["schemas"]["VisitBroadcastFlattenedData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_caregivers": {
    /** Assign and stop broadcast */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "CargeiverVisitOverlap";
                  /** @enum {string} */
                  error: "Visits times overlapps";
                }
              | {
                  /** @enum {string} */
                  type: "InactiveCaregiverAssignement";
                  /** @enum {string} */
                  error: "Caregiver is inactive";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsFlexibleForNotFlexibleRequestEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't confirm flexible visit on this endpoint"
                    | "Can't request flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsNotFlexibleForFlexibleEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't assign not flexible visit on this endpoint"
                    | "Can't confirm not flexible visit on this endpoint"
                    | "Can't request not flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitsOverlapError";
                  /** @enum {string} */
                  error: "OVERLAP ISSUE - Visit overlapps with caregiver or patient";
                }
              | {
                  /** @enum {string} */
                  type: "WeeklyTemplateAdjustmentError";
                  /** @enum {string} */
                  error: "Can't adjust weekly template";
                  reasons: string[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            dayTimeAssignParams: components["schemas"]["DayTimeAssignParams"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_caregivers_partially": {
    /** Assign caregivers to part of the visit broadcast. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "CargeiverVisitOverlap";
                  /** @enum {string} */
                  error: "Visits times overlapps";
                }
              | {
                  /** @enum {string} */
                  type: "InactiveCaregiverAssignement";
                  /** @enum {string} */
                  error: "Caregiver is inactive";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsFlexibleForNotFlexibleRequestEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't confirm flexible visit on this endpoint"
                    | "Can't request flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsNotFlexibleForFlexibleEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't assign not flexible visit on this endpoint"
                    | "Can't confirm not flexible visit on this endpoint"
                    | "Can't request not flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitsOverlapError";
                  /** @enum {string} */
                  error: "OVERLAP ISSUE - Visit overlapps with caregiver or patient";
                }
              | {
                  /** @enum {string} */
                  type: "WeeklyTemplateAdjustmentError";
                  /** @enum {string} */
                  error: "Can't adjust weekly template";
                  reasons: string[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            assignParams: {
              visitInstancesIds: components["schemas"]["VisitInstanceId"][];
              caregiverId: components["schemas"]["CaregiverId"];
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_caregivers_partially/request": {
    /** Agency member requests the caregiver to confirm the assignment of regular visit parts */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "CargeiverVisitOverlap";
                  /** @enum {string} */
                  error: "Visits times overlapps";
                }
              | {
                  /** @enum {string} */
                  type: "InactiveCaregiverAssignement";
                  /** @enum {string} */
                  error: "Caregiver is inactive";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsFlexibleForNotFlexibleRequestEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't confirm flexible visit on this endpoint"
                    | "Can't request flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsNotFlexibleForFlexibleEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't assign not flexible visit on this endpoint"
                    | "Can't confirm not flexible visit on this endpoint"
                    | "Can't request not flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitsOverlapError";
                  /** @enum {string} */
                  error: "OVERLAP ISSUE - Visit overlapps with caregiver or patient";
                }
              | {
                  /** @enum {string} */
                  type: "WeeklyTemplateAdjustmentError";
                  /** @enum {string} */
                  error: "Can't adjust weekly template";
                  reasons: string[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            assignParams: {
              visitInstancesIds: components["schemas"]["VisitInstanceId"][];
              caregiverId: components["schemas"]["CaregiverId"];
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_caregivers_partially/confirm/:caregiverId": {
    /** Agency member manually confirms the assignment of regular visit parts to a caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "CargeiverVisitOverlap";
                  /** @enum {string} */
                  error: "Visits times overlapps";
                }
              | {
                  /** @enum {string} */
                  type: "InactiveCaregiverAssignement";
                  /** @enum {string} */
                  error: "Caregiver is inactive";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsFlexibleForNotFlexibleRequestEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't confirm flexible visit on this endpoint"
                    | "Can't request flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsNotFlexibleForFlexibleEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't assign not flexible visit on this endpoint"
                    | "Can't confirm not flexible visit on this endpoint"
                    | "Can't request not flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitsOverlapError";
                  /** @enum {string} */
                  error: "OVERLAP ISSUE - Visit overlapps with caregiver or patient";
                }
              | {
                  /** @enum {string} */
                  type: "WeeklyTemplateAdjustmentError";
                  /** @enum {string} */
                  error: "Can't adjust weekly template";
                  reasons: string[];
                };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_caregivers_partially/reject/:caregiverId": {
    /** Agency member revokes the assignment confirmation of regular visit parts to a caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/broadcast_visits/:visitBroadcastId/assign_caregivers_partially/confirm": {
    /** Caregiver confirms the assignment of regular visit parts */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "CargeiverVisitOverlap";
                  /** @enum {string} */
                  error: "Visits times overlapps";
                }
              | {
                  /** @enum {string} */
                  type: "InactiveCaregiverAssignement";
                  /** @enum {string} */
                  error: "Caregiver is inactive";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsFlexibleForNotFlexibleRequestEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't confirm flexible visit on this endpoint"
                    | "Can't request flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsNotFlexibleForFlexibleEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't assign not flexible visit on this endpoint"
                    | "Can't confirm not flexible visit on this endpoint"
                    | "Can't request not flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitsOverlapError";
                  /** @enum {string} */
                  error: "OVERLAP ISSUE - Visit overlapps with caregiver or patient";
                }
              | {
                  /** @enum {string} */
                  type: "WeeklyTemplateAdjustmentError";
                  /** @enum {string} */
                  error: "Can't adjust weekly template";
                  reasons: string[];
                };
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/broadcast_visits/:visitBroadcastId/assign_caregivers_partially/decline": {
    /** Caregiver declines the assignment of regular visit parts */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_flexible_visit": {
    /** Agency member assigns caregiver to a flexible visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "CargeiverVisitOverlap";
                  /** @enum {string} */
                  error: "Visits times overlapps";
                }
              | {
                  /** @enum {string} */
                  type: "InactiveCaregiverAssignement";
                  /** @enum {string} */
                  error: "Caregiver is inactive";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsFlexibleForNotFlexibleRequestEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't confirm flexible visit on this endpoint"
                    | "Can't request flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsNotFlexibleForFlexibleEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't assign not flexible visit on this endpoint"
                    | "Can't confirm not flexible visit on this endpoint"
                    | "Can't request not flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitsOverlapError";
                  /** @enum {string} */
                  error: "OVERLAP ISSUE - Visit overlapps with caregiver or patient";
                }
              | {
                  /** @enum {string} */
                  type: "WeeklyTemplateAdjustmentError";
                  /** @enum {string} */
                  error: "Can't adjust weekly template";
                  reasons: string[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            assignParams: components["schemas"]["AssignCaregiverToFlexibleVisitParams"][];
            /** @enum {string} */
            weeklyTemplateAction?: "ADD" | "NO_EFFECT" | "REPLACE";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_flexible_visit/request": {
    /** Agency member requests the caregiver to confirm the assignment of a flexible visit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "AssignWithOvertimeError";
                  /** @enum {string} */
                  error: "Not permitted to increase caregiver overtime";
                }
              | {
                  /** @enum {string} */
                  type: "OfficeHoursRestrictionsConflict";
                  /** @enum {string} */
                  error: "Exceeded office hours resctrictions for caregivers";
                  officeHoursRestrictionsConflicts: {
                    caregiverId: components["schemas"]["CaregiverId"];
                    exceededHours: number;
                  }[];
                }
              | {
                  /** @enum {string} */
                  type: "CargeiverVisitOverlap";
                  /** @enum {string} */
                  error: "Visits times overlapps";
                }
              | {
                  /** @enum {string} */
                  type: "InactiveCaregiverAssignement";
                  /** @enum {string} */
                  error: "Caregiver is inactive";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsFlexibleForNotFlexibleRequestEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't confirm flexible visit on this endpoint"
                    | "Can't request flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitIsNotFlexibleForFlexibleEndpointError";
                  /** @enum {string} */
                  error:
                    | "Can't assign not flexible visit on this endpoint"
                    | "Can't confirm not flexible visit on this endpoint"
                    | "Can't request not flexible visit on this endpoint";
                }
              | {
                  /** @enum {string} */
                  type: "VisitsOverlapError";
                  /** @enum {string} */
                  error: "OVERLAP ISSUE - Visit overlapps with caregiver or patient";
                }
              | {
                  /** @enum {string} */
                  type: "WeeklyTemplateAdjustmentError";
                  /** @enum {string} */
                  error: "Can't adjust weekly template";
                  reasons: string[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            assignParams: components["schemas"]["AssignCaregiverToFlexibleVisitParams"][];
            /** @enum {string} */
            weeklyTemplateAction?: "ADD" | "NO_EFFECT" | "REPLACE";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_flexible_visit/confirm": {
    /** Agency member manually confirms the assignment of a flexible visit to a caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/broadcast_visits/:visitBroadcastId/assign_flexible_visit/reject": {
    /** Agency member revokes the assignment confirmation of a flexible visit to a caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/broadcast_visits/:visitBroadcastId/assign_flexible_visit/confirm": {
    /** Caregiver confirms the assignment of a flexible visit */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              pendingCaregiversCount: number;
              assignedWithOvertime: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/broadcast_visits/:visitBroadcastId/assign_flexible_visit/decline": {
    /** Caregiver declines the assignment of a flexible visit */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/nursing_questions_settings": {
    /** Agency getting all nursing questions with settings */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              questions: components["schemas"]["NursingQuestionWithSettings"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency creating nursing questions with settings */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["NursingQuestionId"];
              agencyId: components["schemas"]["AgencyId"] | null;
              questionText: string;
              possibleAnswers:
                | components["schemas"]["NursingQuestionPossibleAnswer"][]
                | null;
              answerType: components["schemas"]["NursingQuestionAnswerType"];
              databaseLink:
                | (
                    | "contract_is_primary"
                    | "contract_member_id"
                    | "contract_start_date"
                    | "frequency"
                    | "nurse_name"
                    | "patent_address"
                    | "patient_address2"
                    | "patient_allergies"
                    | "patient_assigned_caregiver"
                    | "patient_assigned_dps"
                    | "patient_assigned_intake"
                    | "patient_assigned_sales_rep"
                    | "patient_assinged_coordinator"
                    | "patient_certification_period_from_date"
                    | "patient_certification_period_to_date"
                    | "patient_critical_information_for_first_responders"
                    | "patient_date_of_birth"
                    | "patient_discharge_reinstate_discharge_date"
                    | "patient_discharge_reinstate_discharge_reason_id"
                    | "patient_discharge_reinstate_discharge_to_id"
                    | "patient_discharge_reinstate_reinstate_date"
                    | "patient_electric_equipment_dependency"
                    | "patient_electric_equipment_dependency_check"
                    | "patient_electricity_dependent"
                    | "patient_email"
                    | "patient_emergency_contact"
                    | "patient_evacuation_location"
                    | "patient_evacuation_zone"
                    | "patient_family_information"
                    | "patient_first_name"
                    | "patient_gender"
                    | "patient_general_notes"
                    | "patient_home_phone_number"
                    | "patient_id"
                    | "patient_kids_in_house"
                    | "patient_kosher_home"
                    | "patient_last_name"
                    | "patient_main_language"
                    | "patient_medicaid_number"
                    | "patient_medical_notes"
                    | "patient_medicare_number"
                    | "patient_middle_name"
                    | "patient_mobile_phone_number"
                    | "patient_mobility_status"
                    | "patient_patient_hi_claim"
                    | "patient_pets"
                    | "patient_phone3"
                    | "patient_phone4"
                    | "patient_priority_code"
                    | "patient_secondary_language"
                    | "patient_smoking"
                    | "patient_social_worker"
                    | "patient_source"
                    | "patient_ssn"
                    | "patient_start_of_care"
                    | "patient_status"
                    | "patient_ventilator_dependent"
                    | "patient_wage_parity_number"
                    | "payer_source"
                    | "physician_address"
                    | "physician_name"
                    | "service_type"
                    | "task_or_visit_date"
                    | "task_type"
                  )
                | null;
              isVital: boolean;
              icon: null | string;
              showOnPatient: boolean;
              showOnAgency: boolean;
              isVBP: boolean;
              transferAnswerBetweenTasks: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            questionText: string;
            answerType: components["schemas"]["NursingQuestionAnswerType"];
            showOnPatient: boolean;
            showOnAgency: boolean;
            possibleAnswers:
              | components["schemas"]["NursingQuestionPossibleAnswer"][]
              | null;
            isVBP: boolean;
            transferAnswerBetweenTasks?: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/vital_questions": {
    /** Agency getting all vital nursing questions with answers for patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientVitals: components["schemas"]["PatientNursingQuestionVitalsWithAnswer"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/nursing_questions_settings/:nursingQuestionId": {
    /** Agency updating nursing questions with settings */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          nursingQuestionId: NursingQuestionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            questionText?: string;
            possibleAnswers?:
              | components["schemas"]["NursingQuestionPossibleAnswer"][]
              | null;
            showOnPatient?: boolean;
            showOnAgency?: boolean;
            isVBP?: boolean;
            transferAnswerBetweenTasks?: boolean;
          };
        };
      };
    };
    /** Agency deleting nursing questions with settings */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          nursingQuestionId: NursingQuestionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/nursing_questions": {
    /** Agency member asks for nursing questions of patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              questions: components["schemas"]["NursingQuestionWithAnswers"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member creates a new answer for a patient nursing question (append-only edit) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            questionId: components["schemas"]["NursingQuestionId"];
            answer: string[] | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/vbp_items": {
    /** Agency member requests patient vbp items */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              reports: components["schemas"]["PatientNursingQuestionVBPReport"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member submits patient vbp items */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            date: components["schemas"]["LocalDate"];
            answers: components["schemas"]["NursingQuestionVBPAnswer"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/dashboard/patients/:patientId/calendar": {
    /** Patient calendar of the web dashboard: visits with billing data, vacations, notes, tasks and flexible visit broadcasts for a date range */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tasks: components["schemas"]["PatientTaskInstances"];
              flexibleVisitBroadcasts: components["schemas"]["FlexibleVisitBroadcast"][];
              visitInstances: components["schemas"]["VisitInstanceBillingWithBroadcast"][];
              patientVacations: components["schemas"]["PatientVacation"][];
              notes: components["schemas"]["CalendarNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/dashboard/caregivers/:caregiverId/calendar": {
    /** Caregiver calendar of the web dashboard: visits with billing data, PTO, notes and absences for a date range */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstances: components["schemas"]["VisitInstanceBillingWithBroadcast"][];
              ptoInstances: components["schemas"]["CaregiverPtoInstances"];
              notes: components["schemas"]["CalendarNote"][];
              absences: components["schemas"]["CaregiverAbsence"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task": {
    /** Agency member create new task to patient */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              task:
                | components["schemas"]["PatientTaskTypes.DraftTask"]
                | components["schemas"]["PatientTaskTypes.RegularTask"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            caregiverId: components["schemas"]["CaregiverId"] | null;
            taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
            title: string;
            repeatMonths: null | number;
            isDraft: boolean;
            startDate: components["schemas"]["LocalDate"];
            dueDate: components["schemas"]["LocalDate"];
            planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
            documents: components["schemas"]["PatientDocumentTypeId"][];
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            patientContractId: components["schemas"]["PatientContractId"];
            payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
            broadcastDistance: null | number;
            isBroadcasting: boolean;
            priority: number;
            dayTimeParams: components["schemas"]["TaskDayTimeParams"];
            dayTimeScheduleOverrideParams?:
              | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
              | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
              | null;
            certificationPeriodId:
              | components["schemas"]["CertificationPeriodId"]
              | null;
            isFutureAssigned: boolean;
            scheduledDateTime:
              | components["schemas"]["PatientTaskInstanceEditScheduleDateTime"]
              | null;
            taskIssues?: string[];
            price?: null | number;
            agencyNote: null | string;
            notes?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_tasks/bulk_schedule": {
    /** Agency member creates the same task for many patients and packs them into one caregiver's free 09:00-18:00 time from the schedule date onwards */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tasks: components["schemas"]["PatientTaskBulkScheduledTask"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            caregiverId: components["schemas"]["CaregiverId"];
            taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
            title: string;
            serviceCodeId: components["schemas"]["ServiceCodeId"];
            payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
            documents: components["schemas"]["PatientDocumentTypeId"][];
            scheduleDate: components["schemas"]["LocalDate"];
            patients: components["schemas"]["PatientTaskBulkSchedulePatientParams"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_tasks/:patientTaskId": {
    /** Agency member edits draft task */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              task:
                | components["schemas"]["PatientTaskTypes.DraftTask"]
                | components["schemas"]["PatientTaskTypes.RegularTask"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** Format: PatientId */
            patientId?: PatientId;
            caregiverId?: components["schemas"]["CaregiverId"] | null;
            /** Format: PatientTaskTemplateId */
            taskTemplateId?: PatientTaskTemplateId;
            title?: string;
            repeatMonths?: null | number;
            isDraft?: boolean;
            /** Format: yyyy-MM-dd */
            startDate?: LocalDate;
            /** Format: yyyy-MM-dd */
            dueDate?: LocalDate;
            planOfCareTypeId?: components["schemas"]["PlanOfCareTypeId"] | null;
            documents?: components["schemas"]["PatientDocumentTypeId"][];
            broadcastDistance?: null | number;
            isBroadcasting?: boolean;
            /** Format: ServiceCodeId */
            serviceCodeId?: ServiceCodeId;
            /** Format: PatientContractId */
            patientContractId?: PatientContractId;
            payrollCodeId?: components["schemas"]["PayrollCodeId"] | null;
            dayTimeParams?: components["schemas"]["TaskDayTimeParam"][] | null;
            certificationPeriodId?:
              | components["schemas"]["CertificationPeriodId"]
              | null;
            scheduledDateTime?:
              | components["schemas"]["PatientTaskInstanceEditScheduleDateTime"]
              | null;
            priority?: number;
            dayTimeScheduleOverrideParams?: {
              taskDayTimeScheduleOverrideParams: components["schemas"]["TaskDayTimeScheduleOverrideParams"];
              isAgencyInitialTimeSlots?: boolean;
            } | null;
            taskIssues?: string[];
            price?: null | number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId": {
    /** Agency member edits assigned task instance */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["PatientAssignedTaskParamsTypes.CurrentTask"]
            | components["schemas"]["PatientAssignedTaskParamsTypes.GoingForward"];
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_templates": {
    /** Agency member creates a new patient task template */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientTaskTemplateId"];
              title: string;
              agencyId: components["schemas"]["AgencyId"];
              allowedCertifications: components["schemas"]["CaregiverCertification"][];
              durationMinutes: null | number;
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["AgencyMemberId"] | null;
              removedAt: components["schemas"]["Instant"] | null;
              removedBy: components["schemas"]["AgencyMemberId"] | null;
              documents: components["schemas"]["PatientDocumentTypeId"][];
              hasPlanOfCare: boolean;
              context: ("REASSESSMENT" | "START_OF_CARE") | null;
              priority: number;
              type: ("REASSESSMENT" | "START_OF_CARE" | "SUPERVISORY") | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              errorType: "INVALID_CONTEXT";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            title: string;
            durationMinutes: null | number;
            documents: components["schemas"]["PatientDocumentTypeId"][];
            allowedCertifications: components["schemas"]["CaregiverCertification"][];
            hasPlanOfCare: boolean;
            context: ("REASSESSMENT" | "START_OF_CARE") | null;
            priority: number;
            type: ("REASSESSMENT" | "START_OF_CARE" | "SUPERVISORY") | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_templates/:patientTaskTemplateId": {
    /** Agency member updates patient task template */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskTemplateId: PatientTaskTemplateId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "TaskContextAlreadyExists";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            allowedCertifications?: components["schemas"]["CaregiverCertification"][];
            documents?: components["schemas"]["PatientDocumentTypeId"][];
            title?: string;
            durationMinutes?: null | number;
            hasPlanOfCare?: boolean;
            context?: ("REASSESSMENT" | "START_OF_CARE") | null;
            priority?: number;
            type?: ("REASSESSMENT" | "START_OF_CARE" | "SUPERVISORY") | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances": {
    /** Agency member getting all the patient task instances by date range */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          taskStartDate?: LocalDate;
          taskDueDate?: LocalDate;
          taskCompletionDateFrom?: LocalDate;
          taskCompletionDateTo?: LocalDate;
          certificationPeriodEndFrom?: LocalDate;
          certificationPeriodEndTo?: LocalDate;
          taskIssues?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientTaskInstances: components["schemas"]["PatientTaskTypesForWebapp"][];
              /**
               * @description The caregivers assigned to these tasks, resolved here so the page does not
               * have to look them up by id. A sibling list rather than a field on the row
               * because `PatientTaskTypesForWebapp` is a union of four task shapes.
               */
              caregivers: components["schemas"]["CaregiverRowDisplay"][];
              /** @description The patients these tasks belong to, resolved for the same reason. */
              patients: components["schemas"]["PatientRowDisplay"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/patient_task_instances_billing": {
    /** Agency member getting all the patient task instances by date range and patient id */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientTaskInstances: components["schemas"]["PatientTaskTypesForWebapp"][];
              /**
               * @description The caregivers assigned to these tasks, resolved here so the page does not
               * have to look them up by id. A sibling list rather than a field on the row
               * because `PatientTaskTypesForWebapp` is a union of four task shapes.
               */
              caregivers: components["schemas"]["CaregiverRowDisplay"][];
              /** @description The patients these tasks belong to, resolved for the same reason. */
              patients: components["schemas"]["PatientRowDisplay"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/patient_task_instance": {
    /** Agency member request a patient task instance by visit instance id */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: {
                documentTypeId: components["schemas"]["PatientDocumentTypeId"];
                documentScheduleId:
                  | components["schemas"]["PatientDocumentScheduleId"]
                  | null;
                title: string;
                submitted: boolean;
                sentToPhysician: boolean;
                openForResubmission: boolean;
                approved: boolean;
                isScanned: boolean;
                fileUrl: null | string;
              }[];
              planOfCare?: {
                planOfCareId: components["schemas"]["PlanOfCareId"];
                title: string;
                submitted: boolean;
                fileUrl: null | string;
              };
              caregiver: {
                id: components["schemas"]["CaregiverId"];
                fullName: string;
              } | null;
              hasClockedIn: boolean;
              /** @description Denormalised so a caller can label the row without resolving the patient. */
              patientAddress: null | string;
              visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
              patientConfirmedSchedule: boolean;
              taskIssues: components["schemas"]["DisplayTaskIssue"][];
              patientId: components["schemas"]["PatientId"];
              caregiverId: components["schemas"]["CaregiverId"] | null;
              patientContractId: components["schemas"]["PatientContractId"];
              serviceCodeId: components["schemas"]["ServiceCodeId"];
              payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
              price: null | number;
              planOfCareTypeId:
                | components["schemas"]["PlanOfCareTypeId"]
                | null;
              /** @enum {string} */
              type: "RegularTask";
              status: components["schemas"]["PatientTaskStatus"];
              createdAt: components["schemas"]["Instant"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
              dueDate: components["schemas"]["LocalDate"];
              completionDate: components["schemas"]["LocalDate"] | null;
              repeatMonths: null | number;
              patientContractName: string;
              taskId: components["schemas"]["PatientTaskId"];
              title: string;
              durationMinutes: null | number;
              taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
              patientTaskInstanceId: components["schemas"]["PatientTaskInstanceId"];
              priority: number;
              patientName: string;
              startDate: components["schemas"]["LocalDate"];
              originalCompletionDate: components["schemas"]["LocalDate"] | null;
              scheduleDateTime: components["schemas"]["Instant"] | null;
              createdBy: components["schemas"]["AgencyMemberId"];
              removedAt: components["schemas"]["Instant"] | null;
              removedBy: components["schemas"]["AgencyMemberId"] | null;
              taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
              taskCanceledAt: components["schemas"]["Instant"] | null;
              taskCanceledBy: components["schemas"]["AgencyMemberId"] | null;
              taskInstanceCanceledAt: components["schemas"]["Instant"] | null;
              taskInstanceCanceledBy:
                | components["schemas"]["AgencyMemberId"]
                | null;
              broadcastDistance: null | number;
              isBroadcasting: boolean;
              allowedCertifications: components["schemas"]["CaregiverCertification"][];
              dayTimeParams: components["schemas"]["TaskDayTimeParams"];
              patientOfficeId: components["schemas"]["OfficeId"];
              isCertificationPeriodBoundTask: null | boolean;
              certificationPeriodId:
                | components["schemas"]["CertificationPeriodId"]
                | null;
              certificationStartDate: components["schemas"]["LocalDate"] | null;
              certificationEndDate: components["schemas"]["LocalDate"] | null;
              taskTemplateContext: ("REASSESSMENT" | "START_OF_CARE") | null;
              dayTimeScheduleOverrideParams:
                | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
                | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
                | null;
              mainLanguage: null | string;
              agencyNote?: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_tasks/review_multiple": {
    /** Agency member reviews multiple tasks */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            tasks: (
              | components["schemas"]["PatientTaskTypes.FutureTask"]
              | components["schemas"]["PatientTaskTypes.DraftTask"]
            )[];
            caregiverId: components["schemas"]["CaregiverId"] | null;
            isBroadcasting: boolean;
            broadcastDistance: null | number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances_broadcast/:taskInstanceId": {
    /** Agency member stops brodcast of task instance */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId/update_schedule_date_time": {
    /** Agency member sets a schedule date time for a task instance */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            scheduledDateTime: components["schemas"]["LocalDateTime"];
            duration: number;
            isConfirmed?: boolean;
            stopBroadcasting?: boolean;
            /** Format: CaregiverId */
            caregiverId?: CaregiverId;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId/notes": {
    /** Agency member sets the internal agency notes on a task instance */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            notes: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId/metrics": {
    /** Get task metrics by task instance id */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
        query: {
          RNName?: string;
          zipCode?: string;
          taskType?:
            | "received"
            | "viewed"
            | "opened"
            | "scheduled"
            | "unscheduled";
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientAddress: null | string;
              patientAddressComponents:
                | components["schemas"]["AddressComponents"]
                | null;
              patientName: string;
              taskDatesRange: string;
              taskType: string;
              certPeriodRange: null | string;
              metrics: components["schemas"]["PatientTaskInstanceMetricTableData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances/:patientTaskInstanceId/metrics/count": {
    /** Get task metrics count by task instance id */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              typeCount: components["schemas"]["PatientTaskInstanceMetricsTypeCount"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/task_history_summary_chat": {
    /** Get a summarized history of patient task changes using chat */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              summary: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            questions: string[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/task_history_summary": {
    /** Get a summarized history of patient task changes */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              summary: components["schemas"]["PatientTaskHistorySummaryRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_tasks": {
    /** Caregiver request all patient tasks assigned */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tasks: components["schemas"]["PatientTaskInstanceType"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/update_schedule_date_time": {
    /** Caregiver sets a schedule date time for a task instance */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstance: components["schemas"]["VisitInstanceMobileDetails"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            scheduleDateTime?: Instant;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSS */
            scheduledDateTime?: LocalDateTime;
            patientConfirmedSchedule?: boolean;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/unschedule_task": {
    /** Caregiver removes schedule date time for a task instance */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/unschedule_task_with_reason": {
    /** Caregiver removes schedule date time for a task instance */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            reason: {
              id: components["schemas"]["NotePredefinedAnswerId"];
              text: string;
            };
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/documents/:patientDocumentId/generation_map2": {
    /** Careiver asks for generation map V2 for patient task */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientDocumentId: PatientDocumentTypeId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              questionGenerationAvailabilityMap: components["schemas"]["Record<string,QuestionGenerationAvailability>"];
              sections:
                | components["schemas"]["PatientTaskDocumentSection"][]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/documents/:patientDocumentId/generation_map": {
    /** Careiver asks for generation map for patient task */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientDocumentId: PatientDocumentTypeId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              questionGenerationAvailabilityMap: components["schemas"]["Record<string,boolean>"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_broadcasts": {
    /** Caregiver request patient relevant task broadcasts */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              taskBroadcasts: components["schemas"]["PatientTaskBroadcastDetails"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_schedule": {
    /** A nurse asks for patient's schedule within a task due dates range */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitInstances: {
                id: components["schemas"]["VisitInstanceId"];
                startDateTime: components["schemas"]["LocalDateTime"];
                endDateTime: components["schemas"]["LocalDateTime"];
                caregiverName: string;
                caregiverPhoneNumber: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/unschedule_reasons": {
    /** A nurse asks for task unschedule reasons */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              reasons: {
                id: components["schemas"]["NotePredefinedAnswerId"];
                text: string;
                code: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_unschedule_reasons": {
    /** A nurse asks for task unschedule reasons */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              reasons: {
                id: components["schemas"]["NotePredefinedAnswerId"];
                text: string;
                code: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/rn_clockout_no_documents_reasons": {
    /** A nurse clockout reasons when no documents are filled */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              reasons: {
                id: components["schemas"]["NotePredefinedAnswerId"];
                text: string;
                code: null | string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/rn_next_suggested_task": {
    /** Get next suggested task time for caregiver */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              data: {
                closestTaskId: components["schemas"]["PatientTaskInstanceId"];
                basedOnTaskId:
                  | components["schemas"]["PatientTaskInstanceId"]
                  | null;
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/agencies/:agencyId/patients/:patientId/taskInstanceId/:taskInstanceId/time_slots": {
    /** A nurse asks for available patient time slots */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          agencyId: AgencyId;
          patientId: PatientId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              slots: {
                day: components["schemas"]["LocalDate"];
                timeSlots: {
                  from: components["schemas"]["LocalTime"];
                  to: components["schemas"]["LocalTime"];
                }[];
              }[];
              note: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/is_available_to_schedule": {
    /** A nurse checks if a task instance is available to be scheduled */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              isAvailable: boolean;
              hasActiveSchedulingAttempt: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/schedule": {
    /** A nurse schedules a task instance */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            scheduledDateTime: components["schemas"]["LocalDateTime"];
            patientConfirmedSchedule: boolean;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instance_metrics": {
    /** A nurse reports a metric for task instances */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            metricType: components["schemas"]["PatientTaskInstanceMetricType"];
            patientTaskInstanceIds: components["schemas"]["PatientTaskInstanceId"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:taskInstanceId/notes": {
    /** RN creates a note on a patient */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              noteId: components["schemas"]["NoteId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            noteRichText: null | string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/agency_chat": {
    /** Caregiver gets task agency chat */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              taskChat: {
                ticketId: components["schemas"]["CommCenterTicketId"];
                createdBy: components["schemas"]["UserId"];
                createdAt: components["schemas"]["Instant"];
                updatedAt: components["schemas"]["Instant"];
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/agency_chat/v2": {
    /** Caregiver gets task agency chat */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              taskChat: {
                ticketId: components["schemas"]["CommCenterTicketId"];
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/caregiver_pto_statuses": {
    /** Agency member requests PTO status of a caregiver by years */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          years?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverHireDate: components["schemas"]["LocalDate"];
              ptoStatuses: components["schemas"]["CaregiverPtoStatusWithYear"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/reports/request": {
    /** Executes report */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              lines: unknown[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            timezone: string;
            /** @enum {string} */
            format?: "csv" | "json";
            primaryTable: components["schemas"]["ReportRequestTable"];
            tables: components["schemas"]["ReportRequestTable"][];
            columns: components["schemas"]["ReportRequestColumn"][];
            filters: components["schemas"]["ReportRequestFilter"][];
            allowEmpty: boolean;
            id?: number;
            /** @enum {string} */
            reportType?: "CUSTOM" | "REPORTING_TOOL";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/reports/custom_request": {
    /** Executes Custom report */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              lines: unknown[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            filters: components["schemas"]["ReportRequestFilterWithDisplayAttributes"][];
            allowEmpty: boolean;
            id?: number;
            /** @enum {string} */
            reportType?: "CUSTOM" | "REPORTING_TOOL";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/reports/request_saved/:savedReportId": {
    /** Executes a saved report */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          savedReportId: SavedReportId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              lines: unknown[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            timezone: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/standard_reports": {
    /** Get agency and/or member standard reports */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list:
                | components["schemas"]["StandardReport"][]
                | components["schemas"]["StandardReportWithVisabilityAttributes"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/standard_reports/:standardReportId": {
    /** Get agency standard report */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          standardReportId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["StandardReportId"];
              created_by: components["schemas"]["UserId"] | null;
              created_at: components["schemas"]["Instant"];
              updated_at: components["schemas"]["Instant"] | null;
              name: string;
              category: null | string;
              report_type: null | string;
              report_template: components["schemas"]["CustomReportRequestBase"];
              report_table_def: unknown;
              class_name?: null | string;
              description: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/standard_reports/:standardReportId/access": {
    /** Create agency standard report role */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          standardReportId: number;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            rolesIds: components["schemas"]["AgencyRoleId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/saved_report/:savedReportId/scheduled_history": {
    /** Get saved report's scheduled with history */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          savedReportId: SavedReportId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["ScheduledSavedReportWithHistory"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/saved_report/:savedReportId/scheduled": {
    /** Create a new scheduled saved report */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          savedReportId: SavedReportId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            periodType: string;
            timeInDayDate: components["schemas"]["Instant"];
            interval: null | number;
            dayOfWeek: null | string;
            dayOfMonth: null | number;
            timezone: string;
            recipientEmails: string[];
            reportTemplate:
              | components["schemas"]["CustomReportRequestBase"]
              | components["schemas"]["ReportRequest"]
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/scheduled_saved_report/:scheduledSavedReportId": {
    /** Toggle activate/deactivate a scheduled saved report */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          scheduledSavedReportId: ScheduledSavedReportId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            type: "ACTIVATE" | "DEACTIVATE";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/standard_reports/:standardReportId/scheduled_history": {
    /** Get standard report's scheduled with history */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          standardReportId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["ScheduledSavedReportWithHistory"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/standard_reports/:standardReportId/scheduled": {
    /** Create a new scheduled standard report */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          standardReportId: number;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            periodType: string;
            timeInDayDate: components["schemas"]["Instant"];
            interval: null | number;
            dayOfWeek: null | string;
            dayOfMonth: null | number;
            timezone: string;
            recipientEmails: string[];
            reportTemplate:
              | components["schemas"]["CustomReportRequestBase"]
              | components["schemas"]["ReportRequest"]
              | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/:noteId/status": {
    /** edit note status */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            status: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/:noteId": {
    /** agency member attempts to get a note */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["NoteId"];
              noteRichText: null | string;
              status: string;
              subject: {
                id: components["schemas"]["NoteSubjectId"];
                name: string;
              } | null;
              patientId: components["schemas"]["PatientId"] | null;
              patientIds: components["schemas"]["PatientId"][];
              caregiverId: components["schemas"]["CaregiverId"] | null;
              caregiverIds: components["schemas"]["CaregiverId"][];
              agencyMembers: components["schemas"]["AgencyMemberId"][];
              commCenterTicketId:
                | components["schemas"]["CommCenterTicketId"]
                | null;
              comments: components["schemas"]["NoteComment"][];
              followUp: components["schemas"]["LocalDate"] | null;
              createdBy: {
                id: components["schemas"]["AgencyMemberId"];
                firstName: string;
                lastName: string;
              };
              createdAt: components["schemas"]["Instant"];
              noteType: components["schemas"]["NoteTypes"];
              notePredefinedAnswerId:
                | components["schemas"]["NotePredefinedAnswerId"]
                | null;
              predefinedAnswerText: null | string;
              files: components["schemas"]["NoteFile"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** delete note */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/:noteId/comments": {
    /** Get note comments */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["NoteComment"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes": {
    /** Agency member creates a note */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              noteId: components["schemas"]["NoteId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            noteRichText: null | string;
            /** Format: PatientId */
            patientId?: PatientId;
            patientIds?: components["schemas"]["PatientId"][];
            /** Format: CaregiverId */
            caregiverId?: CaregiverId;
            caregiverIds?: components["schemas"]["CaregiverId"][];
            agencyMemberIds?: components["schemas"]["AgencyMemberId"][];
            /** Format: NoteSubjectId */
            subject?: NoteSubjectId;
            /** Format: CommCenterTicketId */
            commCenterTicketId?: CommCenterTicketId;
            status: string;
            followUp?: components["schemas"]["LocalDate"] | null;
            /** Format: VisitInstanceId */
            visitInstanceId?: VisitInstanceId;
            notePredefinedAnswerId?:
              | components["schemas"]["NotePredefinedAnswerId"]
              | null;
            noteType: components["schemas"]["NoteTypes"];
            /** Format: yyyy-MM-dd */
            calendarDate?: LocalDate;
            base64File?: string;
            /** Format: VisitAssignmentId */
            visitAssignmentId?: VisitAssignmentId;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/:noteId/v2": {
    /** agency member edits a single note */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            noteRichText?: null | string;
            patientId?: components["schemas"]["PatientId"] | null;
            patientIds?: components["schemas"]["PatientId"][];
            caregiverId?: components["schemas"]["CaregiverId"] | null;
            caregiverIds?: components["schemas"]["CaregiverId"][];
            agencyMemberIds?: components["schemas"]["AgencyMemberId"][];
            commCenterTicketId?:
              | components["schemas"]["CommCenterTicketId"]
              | null;
            subject?: components["schemas"]["NoteSubjectId"] | null;
            status: string;
            followUp?: components["schemas"]["LocalDate"] | null;
            notePredefinedAnswerId?:
              | components["schemas"]["NotePredefinedAnswerId"]
              | null;
            noteType: components["schemas"]["NoteTypes"];
            base64File?: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/:noteId/comment": {
    /** create new note comment */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            text: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/:noteId/comment/:commentId": {
    /** delete note comment */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
          commentId: NoteCommentId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver/:caregiverId/notes": {
    /** Get caregiver notes */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["EntityNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/notes": {
    /** Agency member attempts to get patient notes */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              list: components["schemas"]["EntityNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/export_notes": {
    /** Export patient notes to pdfs */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            noteIds: components["schemas"]["NoteId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver/:caregiverId/export_notes": {
    /** Export patient notes to pdfs */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            noteIds: components["schemas"]["NoteId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/send_notes_by_email": {
    /** Export patient notes to pdf and send it by email */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            name: string;
            subject: string;
            noteIds: components["schemas"]["NoteId"][];
            body: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/send_notes_by_email": {
    /** Export caregiver notes to pdf and send it by email */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            name: string;
            subject: string;
            noteIds: components["schemas"]["NoteId"][];
            body: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/send_notes_by_fax": {
    /** Export patient notes to pdf and send it by fax */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
            name: string;
            body?: string;
            noteIds: components["schemas"]["NoteId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/send_notes_by_fax": {
    /** Export caregiver notes to pdf and send it by fax */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
            name: string;
            body?: string;
            noteIds: components["schemas"]["NoteId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes_settings": {
    /** Agency member request a subject note settings and entity note settings */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyNoteSubjects: components["schemas"]["NoteSubject"][];
              agencyEntityNotes: components["schemas"]["EntityNoteSetting"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/caregivers/:caregiverId/generate_url": {
    /** Agency member generates caregiver notes signed url */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            noteIds: components["schemas"]["NoteId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/patients/:patientId/generate_url": {
    /** Agency member generates patient notes signed url */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            noteIds: components["schemas"]["NoteId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/entity_notes/predefined_answer/:answerId": {
    /** edit entity note predefined answer */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          answerId: NotePredefinedAnswerId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            entityNoteSettingId: components["schemas"]["EntityNoteSettingId"];
            text: string;
            active: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/files/:noteFileId": {
    /** Agency member request a note file signed url */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteFileId: NoteFileId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/notes/:noteId/files": {
    /** Agency member attempts to upload a note file */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: NoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["NoteFileId"];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["AgencyMemberId"];
              createdByName: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            base64File: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/roles_permissions": {
    /** Get agency roles permissions */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyRoles: components["schemas"]["AgencyRolePermissions"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/exclusion_list": {
    /** Get exclusions list */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          includeNonMatching?: boolean;
          offices?: OfficeId[];
          searchTerm?: string;
          statuses?: ("Flagged" | "Un-Flagged" | "NoMatch")[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["CaregiverExlusionDataNew"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/exclusion_list/:exclusionId/caregivers/:caregiverId/terminate": {
    /** An Agency Member terminates caregiver based on exclusion list */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          exclusionId: CaregiverExclusionId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            note: components["schemas"]["AgencyNoteCreateParams"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/exclusion_list/:exclusionId/flag": {
    /** An Agency Member un/flags a caregiver */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          exclusionId: CaregiverExclusionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            flag: boolean;
            note: components["schemas"]["AgencyNoteCreateParams"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_patient_dem": {
    /** Agency getting all HHAX Integration patient demographics not-processed records */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          date_record_times?: string;
          from?: LocalDate;
          to?: LocalDate;
          offices?: string;
          payers?: string;
          record_status?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              records: components["schemas"]["HHAIntegrationPatientDemRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_authorization": {
    /** Agency getting all HHA Integration authorization file records of specific file id */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          date_record_times?: string;
          from?: LocalDate;
          to?: LocalDate;
          offices?: string;
          payers?: string;
          record_status?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              records: components["schemas"]["HHAIntegrationAuthFileRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_authorization/:hhaIntegrationAuthorizationRecordId": {
    /** Agency getting HHA Integration authorization file records extra details */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          hhaIntegrationAuthorizationRecordId: HHAIntegrationNonBillingFileRecordId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contractTypesIds: components["schemas"]["ContractTypeId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_poc": {
    /** Agency getting all HHA Integration poc file records of specific file id */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          date_record_times?: string;
          from?: LocalDate;
          to?: LocalDate;
          offices?: string;
          payers?: string;
          record_status?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              records: components["schemas"]["HHAIntegrationPOCFileRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hha_integration_download_file/:hhaIntegrationImportedFileId": {
    /** Get file S3 signed file url */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          hhaIntegrationImportedFileId: HHAIntegrationImportedFileId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_mark_records": {
    /** Mark record as processed or ignored */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            records: components["schemas"]["HHAIntegrationNonBillingFileRecordId"][];
            /** @enum {string} */
            fileType: "Authorization" | "POC" | "Patient";
            markType: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_unlinked_patients": {
    /** Get agency hhax unlinked patients */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          payerHHACode?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              unlinkedPatients: components["schemas"]["HHAXIntegrationUnlinkedPatient"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_response_file_rejections": {
    /** Get agency hhax response file rejections visits */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          offices?: string;
          contracts?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: components["schemas"]["HHAIntegrationRejectedVisitRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_billing_exceptions": {
    /** Get agency hhax billing exceptions visits */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          offices?: string;
          contracts?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: components["schemas"]["HHAIntegrationBillingExceptionVisitRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_integration_pre_adj_rejections": {
    /** Get agency hhax pre adj rejections visits */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          offices?: string;
          contracts?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: components["schemas"]["HHAIntegrationPreAdjRejectionsVisitRecord"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/hhax_edit_patient": {
    /** Edit patient and patient contract data */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            recordId: components["schemas"]["HHAIntegrationNonBillingFileRecordId"];
            patientContractId: components["schemas"]["PatientContractId"];
            /**
             * @description The status of a Patient within a specific Agency
             * @enum {string}
             */
            status?:
              | "ACCEPTED"
              | "ACTIVE"
              | "DECEASED"
              | "DISCHARGED"
              | "DRAFT"
              | "ELIGIBLE"
              | "HOSPITALIZED"
              | "LOST"
              | "ON_HOLD"
              | "PENDING_FILES"
              | "REFERRAL"
              | "VACATION";
            firstName?: string;
            middleName?: null | string;
            lastName?: string;
            gender?: ("F" | "M") | null;
            dateOfBirth?: components["schemas"]["LocalDate"] | null;
            address?: components["schemas"]["PatientAddressComponents"] | null;
            address2?: null | string;
            phoneNumbers?:
              | components["schemas"]["InsertPatientPhoneNumberParams"][]
              | null;
            medicaidNumber?: null | string;
            memberId?: string;
            admissionId?: null | string;
            contractStartDate?: components["schemas"]["LocalDate"] | null;
            contractEndDate?: components["schemas"]["LocalDate"] | null;
            orderingPcpNpi?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/adjustment_approval_by_visit": {
    /** Handle adjustment per visit */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            confirmRemoveFromInvoice: boolean;
            visits: components["schemas"]["BillingPayrollApprovalByVisit"][];
            approvalStatus: components["schemas"]["AdjustmentApprovalStatus"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/absence": {
    /** Agency member creates caregiver absences by date range */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            from: components["schemas"]["LocalDate"];
            to: components["schemas"]["LocalDate"];
            caregiverAbsenceNote?: components["schemas"]["AgencyNoteCreateParams"];
            ptosCreateParams?: components["schemas"]["CaregiverPtoInstancesCreateParams"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/caregiver_absences/delete": {
    /** Agency member deletes caregiver absences */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            caregiverAbsenceIds: components["schemas"]["CaregiverAbsenceId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/tasks": {
    /** Agency member getting all the caregiver tasks instances by date range */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverTaskInstances: components["schemas"]["CaregiverTaskTypesForWebapp"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/eligibility_checks": {
    /** Agency member requests the agency's eligibility checks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          runDate?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              records: components["schemas"]["EligibilityCheck"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/check_eligibility": {
    /** Agency member requests to run eligibility check for a patient */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              status: components["schemas"]["PatientEligibiltyStatus"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake_eligibility_check": {
    /** Agency member requests to run eligibility check for an intake patient */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake_eligibility_checks": {
    /** Agency member requests the most recent eligibility check for an intake patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              records: components["schemas"]["EligibilityCheckForIntakePatient"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/insurers/:insurerId/insurer_member/:insurerMemberId/conflict_report": {
    /** Get a conflict report for VO */
    get: {
      parameters: {
        path: {
          insurerId: InsurerId;
          insurerMemberId: InsurerId;
        };
        query: {
          fromDate?: LocalDate;
          toDate?: LocalDate;
          calcByClockOrSchedule?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              report: components["schemas"]["VoConflictReport"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/insurers/:insurerId/insurer_member/:insurerMemberId/visit/:visitInstanceId": {
    /** Get a conflict report for VO */
    get: {
      parameters: {
        path: {
          insurerId: InsurerId;
          insurerMemberId: InsurerId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              history: components["schemas"]["Audit"][];
              visitInstanceId: components["schemas"]["VisitInstanceId"];
              agencyId: components["schemas"]["AgencyId"];
              patient: {
                firstName: string;
                middleName: null | string;
                lastName: string;
                medicaidNumber: null | string;
                phoneNumbers: string[];
              };
              caregiver: {
                firstName: string;
                middleName: null | string;
                lastName: string;
                address: string;
                address2: null | string;
                phoneNumbers: string[];
              } | null;
              notes: components["schemas"]["VisitInstanceNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/insurers/:insurerId/insurer_member/:insurerMemberId/visit_report": {
    /** Get a report of visits for VO */
    get: {
      parameters: {
        path: {
          insurerId: InsurerId;
          insurerMemberId: InsurerId;
        };
        query: {
          fromDate?: LocalDate;
          toDate?: LocalDate;
          agencies?: AgencyId[];
          partial?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visits: components["schemas"]["VoVisitReportResultsVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/insurers/:insurerId/insurer_member/:insurerMemberId/rejections_report": {
    /** Get a report of visits and rejections for VO */
    get: {
      parameters: {
        path: {
          insurerId: InsurerId;
          insurerMemberId: InsurerId;
        };
        query: {
          fromDate?: LocalDate;
          toDate?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visits: components["schemas"]["VoVisitRejectionsReportResultsVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/insurers/:insurerId/insurer_member/:insurerMemberId/dashboard": {
    /** Get a dashboard counts for VO */
    get: {
      parameters: {
        path: {
          insurerId: InsurerId;
          insurerMemberId: InsurerId;
        };
        query: {
          fromDate?: LocalDate;
          toDate?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitClockTypes: {
                full: number;
                partial: number;
                none: number;
                manual: number;
              };
              clockTypes: {
                app: number;
                ivr: number;
                manual: number;
              };
              reasons: components["schemas"]["VoDashboardReasonCount"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/insurers/:insurerId/insurer_member/:insurerMemberId/agencies": {
    /** Get a dashboard counts for VO */
    get: {
      parameters: {
        path: {
          insurerId: InsurerId;
          insurerMemberId: InsurerId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencies: {
                agencyId: components["schemas"]["AgencyId"];
                name: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/onboarding/caregivers": {
    /** Caregiver request to start onboarding process */
    post: {
      parameters: {
        query: {
          campaign?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              token: components["schemas"]["LandingPageToken"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "AGENCY_NOT_AUTHORIZED";
            };
          };
        };
      };
    };
  };
  "/onboarding/send_sms": {
    /** Caregiver request to start onboarding process */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "AGENCY_NOT_AUTHORIZED";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
          };
        };
      };
    };
  };
  "/onboarding/verify_sms_code": {
    /** Caregiver request to start onboarding process */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              isCodeCorrect: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "AGENCY_NOT_AUTHORIZED";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            code: string;
            phoneNumber: string;
          };
        };
      };
    };
  };
  "/onboarding/caregivers/:token": {
    /** Endpoint for caregivers landing page onboarding */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              token: components["schemas"]["LandingPageToken"];
              phoneNumber?: string;
              firstName?: string;
              lastName?: string;
              addressText?: string;
              addressComponents?: components["schemas"]["AddressComponents"];
              address2?: string;
              certifications?: components["schemas"]["CaregiverCertification"][];
              middleName?: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Endpoint for caregivers landing page onboarding */
    patch: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverId: components["schemas"]["CaregiverId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type:
                | "Cannot Complete Registration at this time"
                | "Caregiver already exists"
                | "Invalid Data"
                | "No data on phone number"
                | "No onboarding agency data";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber?: string;
            firstName?: string;
            lastName?: string;
            addressText?: string;
            address2?: string;
            addressComponents?: components["schemas"]["AddressComponents"];
            clickedJoinNow?: boolean;
            clickedDownloadApp?: boolean;
            isNotCertified?: boolean;
            certifications?: components["schemas"]["CaregiverCertification"][];
            middleName?: string;
            completed?: boolean;
            isTestUser?: boolean;
          };
        };
      };
    };
  };
  "/references/:token": {
    /** Get reference data by token */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiver: {
                id: components["schemas"]["CaregiverId"];
                firstName: string;
                lastName: string;
              };
              subsectionId: components["schemas"]["HRSubSectionId"];
              isEmployee: boolean;
              finishedAt: components["schemas"]["Instant"] | null;
              referenceNum: number;
              createdAt: components["schemas"]["Instant"];
              isAgency: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Post reference person answers */
    post: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            answers: {
              questionTemplateId: components["schemas"]["HRQuestionTemplateId"];
              answer: string;
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/staffing_preferences": {
    /** Get caregiver staffing preferences */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workWithKids: null | boolean;
              workWithSmokingPatient: null | boolean;
              smokingCaregiver: null | boolean;
              workWithPets: null | boolean;
              workWithBedbound: null | boolean;
              workWithWalkingAsistant: null | boolean;
              workWithKosher: null | boolean;
              workWithHalal: null | boolean;
              workWithHoyerLift: null | boolean;
              workWithShabat: null | boolean;
              languages: string[] | null;
              mainLanguage: null | string;
              transportationType: null | string;
              publicTransprotationTimeLimit: null | number;
              casesLength: string[] | null;
              workTimes: null | string;
              studying: null | boolean;
              studyingTimes: null | string;
              patientsTypes: string[] | null;
              additionalInfo: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update caregiver staffing preferences */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workWithKids: null | boolean;
              workWithSmokingPatient: null | boolean;
              smokingCaregiver: null | boolean;
              workWithPets: null | boolean;
              workWithBedbound: null | boolean;
              workWithWalkingAsistant: null | boolean;
              workWithKosher: null | boolean;
              workWithHalal: null | boolean;
              workWithHoyerLift: null | boolean;
              workWithShabat: null | boolean;
              languages: string[] | null;
              mainLanguage: null | string;
              transportationType: null | string;
              publicTransprotationTimeLimit: null | number;
              casesLength: string[] | null;
              workTimes: null | string;
              studying: null | boolean;
              studyingTimes: null | string;
              patientsTypes: string[] | null;
              additionalInfo: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            workWithKids: null | boolean;
            workWithSmokingPatient: null | boolean;
            smokingCaregiver: null | boolean;
            workWithPets: null | boolean;
            workWithBedbound: null | boolean;
            workWithWalkingAsistant: null | boolean;
            workWithKosher: null | boolean;
            workWithHalal: null | boolean;
            workWithHoyerLift: null | boolean;
            workWithShabat: null | boolean;
            languages: string[] | null;
            mainLanguage: null | string;
            transportationType: null | string;
            publicTransprotationTimeLimit: null | number;
            casesLength: string[] | null;
            workTimes: null | string;
            studying: null | boolean;
            studyingTimes: null | string;
            patientsTypes: string[] | null;
            additionalInfo: null | string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/staffing_preferences": {
    /** Caregiver requests their staffing preferences. */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sections: components["schemas"]["CaregiverPreferencesSettingsSection"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Caregiver updates their staffing preferences */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            changes: components["schemas"]["Partial<CaregiverStaffingPreferencesResponse>"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/staffing_preferences": {
    /** Get patient staffing preferences */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              kids: null | boolean;
              kidsCount: null | number;
              smoking: null | boolean;
              smokingCaregiver: null | boolean;
              pets: null | boolean;
              hoyerLift: null | boolean;
              petsDetails: string[] | null;
              bedbound: null | boolean;
              cane: null | boolean;
              walker: null | boolean;
              wheelchair: null | boolean;
              kosher: null | boolean;
              halal: null | boolean;
              gender: null | string;
              shabat: null | boolean;
              mainLanguage: null | string;
              secondaryLanguage: null | string;
              allowMultipleCaregivers: null | boolean;
              requests: string[] | null;
              tasks: string[] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update caregiver staffing preferences */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              kids: null | boolean;
              kidsCount: null | number;
              smoking: null | boolean;
              smokingCaregiver: null | boolean;
              pets: null | boolean;
              hoyerLift: null | boolean;
              petsDetails: string[] | null;
              bedbound: null | boolean;
              cane: null | boolean;
              walker: null | boolean;
              wheelchair: null | boolean;
              kosher: null | boolean;
              halal: null | boolean;
              gender: null | string;
              shabat: null | boolean;
              mainLanguage: null | string;
              secondaryLanguage: null | string;
              allowMultipleCaregivers: null | boolean;
              requests: string[] | null;
              tasks: string[] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            kids: null | boolean;
            kidsCount: null | number;
            smoking: null | boolean;
            smokingCaregiver: null | boolean;
            pets: null | boolean;
            hoyerLift: null | boolean;
            petsDetails: string[] | null;
            bedbound: null | boolean;
            cane: null | boolean;
            walker: null | boolean;
            wheelchair: null | boolean;
            kosher: null | boolean;
            halal: null | boolean;
            gender: null | string;
            shabat: null | boolean;
            mainLanguage: null | string;
            secondaryLanguage: null | string;
            allowMultipleCaregivers: null | boolean;
            requests: string[] | null;
            tasks: string[] | null;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/staffing_preferences": {
    /** Get patient staffing preferences */
    get: {
      parameters: {
        path: {
          portalUserId: PortalUserId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              kids: null | boolean;
              kidsCount: null | number;
              smoking: null | boolean;
              smokingCaregiver: null | boolean;
              pets: null | boolean;
              hoyerLift: null | boolean;
              petsDetails: string[] | null;
              bedbound: null | boolean;
              cane: null | boolean;
              walker: null | boolean;
              wheelchair: null | boolean;
              kosher: null | boolean;
              halal: null | boolean;
              gender: null | string;
              shabat: null | boolean;
              mainLanguage: null | string;
              secondaryLanguage: null | string;
              allowMultipleCaregivers: null | boolean;
              requests: string[] | null;
              tasks: string[] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update caregiver staffing preferences */
    put: {
      parameters: {
        path: {
          portalUserId: PortalUserId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              kids: null | boolean;
              kidsCount: null | number;
              smoking: null | boolean;
              smokingCaregiver: null | boolean;
              pets: null | boolean;
              hoyerLift: null | boolean;
              petsDetails: string[] | null;
              bedbound: null | boolean;
              cane: null | boolean;
              walker: null | boolean;
              wheelchair: null | boolean;
              kosher: null | boolean;
              halal: null | boolean;
              gender: null | string;
              shabat: null | boolean;
              mainLanguage: null | string;
              secondaryLanguage: null | string;
              allowMultipleCaregivers: null | boolean;
              requests: string[] | null;
              tasks: string[] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            kids: null | boolean;
            kidsCount: null | number;
            smoking: null | boolean;
            smokingCaregiver: null | boolean;
            pets: null | boolean;
            hoyerLift: null | boolean;
            petsDetails: string[] | null;
            bedbound: null | boolean;
            cane: null | boolean;
            walker: null | boolean;
            wheelchair: null | boolean;
            kosher: null | boolean;
            halal: null | boolean;
            gender: null | string;
            shabat: null | boolean;
            mainLanguage: null | string;
            secondaryLanguage: null | string;
            allowMultipleCaregivers: null | boolean;
            requests: string[] | null;
            tasks: string[] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/sources": {
    /** Get all comm center ticket sources */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              sources: components["schemas"]["CommCenterTicketSourceLabel"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/stats": {
    /** Agency emmber request all tickets stats */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              unassigned: number;
              myTickets: number;
              myTeamTicket: number;
              allTickets: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/open": {
    /** Agency member request all open communication center tickets */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticketsWithNewMessageCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/:ticketId": {
    /** Agency member asks for a communication center ticket by it's id. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticket: components["schemas"]["CommCenterTicket"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/tickets/:ticketId": {
    /** Caregiver asks for a communication center ticket by it's id. */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticket: components["schemas"]["CommCenterTicket"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/caregivers/:caregiverId": {
    /** Agency member asks all the tickets related to a specific caregiver. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tickets: components["schemas"]["CommCenterTicket"][];
              roboCalls: components["schemas"]["RobocallLogData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/patients/:patientId": {
    /** Agency member asks all the tickets related to a specific patient. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tickets: components["schemas"]["CommCenterTicket"][];
              roboCalls: components["schemas"]["RobocallLogData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/labels": {
    /** Get primary labels for communication center */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              labels: components["schemas"]["CommCenterLabel"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/labels": {
    /** Get labels for communication center for agency member */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              labels: components["schemas"]["CommCenterLabel"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/tickets": {
    /** Get all communication center tickets for caregiver */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tickets: components["schemas"]["CommCenterTicket"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Caregiver opens ticket */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticket: components["schemas"]["CommCenterTicket"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            agencyId: components["schemas"]["AgencyId"];
            source: components["schemas"]["CommCenterTicketSource"];
            label?: null | string;
            /** Format: PatientTaskInstanceId */
            taskInstanceId?: PatientTaskInstanceId;
            shouldSendFirstMessage?: boolean;
            reuseOpenTicketWithSameLabel?: boolean;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_instances/:visitInstanceId/comm_center/tickets": {
    /** Create ticket about assigned visit */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticket: components["schemas"]["CommCenterTicket"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            visitInstanceId: components["schemas"]["VisitInstanceId"];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/visit_broadcasts/:visitBroadcastId/comm_center/tickets": {
    /** Create ticket about available visit */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          visitBroadcastId: VisitBroadcastId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticket: components["schemas"]["CommCenterTicket"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            visitBroadcastId: components["schemas"]["VisitBroadcastId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/comm_center_team_members/:commCenterTeamMemberId/comm_center/tickets": {
    /** Agency member opens ticket */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          commCenterTeamMemberId: CommCenterTeamMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticketId: components["schemas"]["CommCenterTicketId"];
              ticket: components["schemas"]["CommCenterTicket"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            labelId: components["schemas"]["CommCenterLabelId"];
            caregiverId: components["schemas"]["CaregiverId"][] | null;
            patientId: components["schemas"]["PatientId"][] | null;
            phonebookContactId?:
              | components["schemas"]["AgencyPhonebookContactId"]
              | null;
            message: string;
            topic: components["schemas"]["CommCenterTicketTopic"];
            phoneNumber?: null | string;
            visitBroadcastId?: components["schemas"]["VisitBroadcastId"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/:ticketId/edit": {
    /** Agency member edits a field (or more) or communication center ticket. */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "One of the tickets is already resolved"
                | "Ticket already resolved";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            params: components["schemas"]["Partial<EditCommCenterTicketParams>"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/edit_bulk": {
    /** Agency member edits a field (or more) of multiple communication center tickets. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "One of the tickets is already resolved"
                | "Ticket already resolved";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            ticketIds: components["schemas"]["CommCenterTicketId"][];
            params: components["schemas"]["Partial<EditCommCenterTicketParams>"];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/tickets/:commCenterTicketId/resolve": {
    /** Caregiver mark a ticket as resolved */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          commCenterTicketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets": {
    /** Agency member requets communication center tickets */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          caregiverStatus?: (
            | "PENDING"
            | "ACTIVE"
            | "ON_HOLD"
            | "SUSPENDED"
            | "TERMINATED"
            | "ON_LEAVE"
            | "JOIN_REQUEST"
            | "QUIT"
            | "REJECTED"
          )[];
          onboardingStage?: HRSectionStageId[];
          priority?: ("LOW" | "MEDIUM" | "HIGH")[];
          rnPlatform?: (
            | "PENDING_APPLICATION_RN"
            | "ACTIVE_RN"
            | "PATIENT"
            | "OTHER"
          )[];
          assignee?: AgencyMemberId[];
          topic?: (
            | "Patient"
            | "Caregiver"
            | "NotIdentifiedPhoneNumber"
            | "PhonebookContact"
            | "NotIdentifiedEmailEntity"
            | "BotAgent"
          )[];
          team?: CommCenterTeamId[];
          ticketStatus?: ("NEW" | "IN PROGRESS" | "RESOLVED")[];
          lastMessageFrom?: LocalDate;
          lastMessageTo?: LocalDate;
          caregiverId?: CaregiverId[];
          patientId?: PatientId[];
          unassigned?: boolean;
          labelId?: CommCenterLabelId[];
          ticketSource?: (
            | "MOBILE_CHAT"
            | "MANUAL"
            | "SYSTEM_TRIGGER"
            | "PHONE_CALL"
            | "SMS_CONVERSATION"
            | "EMAIL"
          )[];
          relatedNotIdentifiedPhoneNumber?: string[];
          phonebookContactId?: AgencyPhonebookContactId[];
          relatedNotIdentifiedEmailEntity?: string[];
          isAgencyResponseEnabled?: boolean;
          telephonyCallStatus?: (
            | "Initiated"
            | "Ringing"
            | "Connecting"
            | "InProgress"
            | "Missed"
            | "NoAnswer"
            | "Completed"
            | "VoiceMail"
            | "MovedToSMS"
            | "Failed"
            | "Canceled"
            | "Classifying"
          )[];
          hideVisitAssignmentRelatedTickets?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tickets: components["schemas"]["CommCenterTicket"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/tickets/:commCenterTicketId/message": {
    /** Caregiver sends a message on a ticket */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          commCenterTicketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "One of the tickets is already resolved"
                | "Ticket already resolved";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            message: (
              | components["schemas"]["CaregiverTextMessage"]
              | components["schemas"]["CaregiverImageMessage"]
              | components["schemas"]["CaregiverActionMessage"]
              | components["schemas"]["CaregiverDocumentMessage"]
              | components["schemas"]["CaregiverVideoMessage"]
            )[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/:commCenterTicketId/message": {
    /** Agency member sends a message on a ticket */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          commCenterTicketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "One of the tickets is already resolved"
                | "Ticket already resolved";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            message: (
              | components["schemas"]["AgencyMemberTextMessage"]
              | components["schemas"]["AgencyMemberImageMessage"]
              | components["schemas"]["AgencyMemberDocumentMessage"]
              | components["schemas"]["AgencyMemberVideoMessage"]
            )[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/teams": {
    /** Get all team and team members for comm center */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              teams: components["schemas"]["CommCenterTeamWithMembers"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/tickets/:ticketId/view": {
    /** Caregiver Mark all message until specific id as `read` */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            latestMessageId: components["schemas"]["CommCenterMessageId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/:ticketId/view": {
    /** Agency Member Mark all message until specific id as `read` */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** Format: CommCenterMessageId */
            latestMessageId?: CommCenterMessageId;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/:ticketId/unread": {
    /** Agency member mark comm center ticket messages as not seen */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/tickets/:ticketId/typing": {
    /** Agency member typing */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "One of the tickets is already resolved"
                | "Ticket already resolved";
            };
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/tickets/:ticketId/typing": {
    /** Caregiver typing */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "One of the tickets is already resolved"
                | "Ticket already resolved";
            };
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/comm_center/tickets/not_read": {
    /** Caregvier request for all ticket-ids with not read message */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ids: components["schemas"]["CommCenterTicketId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/sms": {
    /** Agency member opens an SMS ticket and sends a message */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticketId: components["schemas"]["CommCenterTicketId"];
              ticket: components["schemas"]["CommCenterTicket"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            caregiverId: components["schemas"]["CaregiverId"] | null;
            patientId: components["schemas"]["PatientId"] | null;
            message: string;
            topic: components["schemas"]["CommCenterTicketTopic"];
            phoneNumber?: null | string;
            /** Format: CommCenterTeamId */
            teamId?: CommCenterTeamId;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_definitions": {
    /** Agency member requests the workflow task definitions */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tasks: components["schemas"]["WorkflowTaskDefinition"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/tasks": {
    /** Agency member requests a list of open workflow tasks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
        query: {
          assignee?: AgencyMemberId[];
          workflow?: WorkflowDefinitionId[];
          correlation?: unknown[];
          task?: string[];
          owner?: AgencyMemberId[];
          skill?: WorkflowSkillId[];
          createdAtFrom?: LocalDate;
          createdAtTo?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tasks: components["schemas"]["ListedWorkflowHumanTaskInstance"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/skills": {
    /** Agency member requests a list of workflow task skills */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              skills: {
                id: components["schemas"]["WorkflowSkillId"];
                createdAt: components["schemas"]["Instant"];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member requests to add a workflow task skill */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            skill: components["schemas"]["WorkflowSkillId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/skills/:workflowSkillId": {
    /** Agency member requests to delete a workflow task skill */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowSkillId: WorkflowSkillId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/agency_member_skills": {
    /** Agency member requests to update another agency member's workflow skills */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            agencyMemberId: components["schemas"]["AgencyMemberId"];
            skills: components["schemas"]["WorkflowSkillId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/agency_members_skills": {
    /** Agency member requests a list of workflow skills per agency member */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              data: [
                components["schemas"]["AgencyMemberId"],
                components["schemas"]["WorkflowSkillId"][]
              ][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/human_task_names": {
    /** Agency member requests a list of workflow human task names */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tasks: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/assignment_strategies": {
    /** Agency member requests the workflow task assignment strategies */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              strategies: components["schemas"]["HumanTaskAssignmentStrategyOption"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/:workflowTaskInstanceId": {
    /** Agency member requests a workflow task instance */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              item: components["schemas"]["WorkflowHumanTaskInstance"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/:workflowTaskInstanceId/signed_files": {
    /** Agency member requests a workflow task instance signed files */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              files: [string, string][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/:workflowTaskInstanceId/presign_urls": {
    /** Presign urls for workflow attachments */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              urls: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fileNames: string[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/:workflowTaskInstanceId/submit": {
    /** Agency member submits a workflow task instance */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            outputKey: string;
            data: { [key: string]: unknown };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/open_count": {
    /** Agency member requests the total number of open workflow tasks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              count: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_viewer/assignments": {
    /** Agency member requests to view assigned workflow tasks */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              cluster: {
                id: components["schemas"]["WorkflowTaskClusterId"];
                value: string;
                name: string;
                tasksCount: number;
              } | null;
              tasks: {
                instance: components["schemas"]["WorkflowHumanTaskInstance"];
                endsAt: components["schemas"]["Instant"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_viewer/assign/:workflowTaskInstanceId": {
    /** Agency member requests to view assigned workflow tasks */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              cluster: {
                id: components["schemas"]["WorkflowTaskClusterId"];
                value: string;
                name: string;
                tasksCount: number;
              } | null;
              tasks: {
                instance: components["schemas"]["WorkflowHumanTaskInstance"];
                endsAt: components["schemas"]["Instant"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_viewer/prolong/:workflowTaskInstanceId": {
    /** Agency member requests to prolong viewing a workflow task */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              cluster: {
                id: components["schemas"]["WorkflowTaskClusterId"];
                value: string;
                name: string;
                tasksCount: number;
              } | null;
              tasks: {
                instance: components["schemas"]["WorkflowHumanTaskInstance"];
                endsAt: components["schemas"]["Instant"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_viewer/skip/:workflowTaskInstanceId": {
    /** Agency member requests to skip a workflow task */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              cluster: {
                id: components["schemas"]["WorkflowTaskClusterId"];
                value: string;
                name: string;
                tasksCount: number;
              } | null;
              tasks: {
                instance: components["schemas"]["WorkflowHumanTaskInstance"];
                endsAt: components["schemas"]["Instant"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_viewer/skip_cluster": {
    /** Agency member requests to skip a cluster of workflow tasks */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              cluster: {
                id: components["schemas"]["WorkflowTaskClusterId"];
                value: string;
                name: string;
                tasksCount: number;
              } | null;
              tasks: {
                instance: components["schemas"]["WorkflowHumanTaskInstance"];
                endsAt: components["schemas"]["Instant"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/:workflowTaskInstanceId/assign": {
    /** Agency member requests to assign a workflow task */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            assignee: components["schemas"]["AgencyMemberId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tasks/:workflowTaskInstanceId/unassign": {
    /** Agency member requests to unassign a workflow task */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowTaskInstanceId: WorkflowTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/workflow_task_queries": {
    /** Agency member requests the workflow task queries */
    get: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              queries: components["schemas"]["WorkflowTaskQueryDefinition"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/listed_workflows": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflows: components["schemas"]["ListedWorkflow"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/latest_workflow_definitions": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflows: {
                name: string;
                correlationKey: components["schemas"]["WorkflowDefinitionCorrelationKey"];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflows: components["schemas"]["DesignerListedWorkflowDefinition"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflow: components["schemas"]["WorkflowDefinition"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            workflow: components["schemas"]["CreateWorkflowDefinition"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions/:workflowDefinition": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowDefinition: WorkflowDefinitionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflow: components["schemas"]["WorkflowDefinition"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update a workflow definition */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowDefinition: WorkflowDefinitionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowDefinitionId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            workflow: components["schemas"]["UpdateWorkflowDefinition"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions/:workflowDefinitionCorrelationKey/scheduled_tasks_count": {
    /** Get the number of scheduled tasks for a workflow definition */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowDefinitionCorrelationKey: WorkflowDefinitionCorrelationKey;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflowRunCount: number;
              inProgressTasksCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions/:workflowDefinitionId/publish": {
    /** Agency member publishes a workflow definition */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowDefinitionId: WorkflowDefinitionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflow: components["schemas"]["WorkflowDefinition"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            published: boolean;
            deleteScheduledInstances: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions/:workflowDefinitionId/clone": {
    /** Clone a workflow definition */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowDefinitionId: WorkflowDefinitionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowDefinitionId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            correlationKey: components["schemas"]["WorkflowDefinitionCorrelationKey"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions/:workflowDefinitionId/run": {
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowDefinitionId: WorkflowDefinitionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflowInstanceId: components["schemas"]["WorkflowInstanceId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            input: { [key: string]: unknown };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions/:workflowDefinitionId/instances": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowDefinitionId: WorkflowDefinitionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              instances: components["schemas"]["WorkflowInstance"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_triggers": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              jobTriggers: components["schemas"]["WorkflowJobTriggerOption"][];
              eventTriggers: components["schemas"]["WorkflowEventTriggerOption"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_human_task_template_definitions": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              templates: components["schemas"]["WorkflowHumanTaskTemplateDefinition"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_entities": {
    /** List all workflow entities */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              data: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_definitions/:workflowDefinitionId/presign_urls": {
    /** Presign urls for workflow attachments */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowDefinitionId: WorkflowDefinitionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              urls: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fileNames: string[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/entity_layouts": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              layouts: components["schemas"]["WorkflowEntityLayouts"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/entity_search": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          entity?: string;
          filters?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | ({
                  /** @enum {string} */
                  type: "table";
                } & components["schemas"]["WorkflowEntityTableLayoutResponse"])
              | ({
                  /** @enum {string} */
                  type: "list";
                } & components["schemas"]["WorkflowEntityListLayoutResponse"]);
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error:
                | "INVALID_ENTITY"
                | "INVALID_FILTERS"
                | "RESOLVER_NOT_IMPLEMENTED";
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_entities/display_values": {
    /** Resolve entity display values */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              entities: {
                [key: string]: components["schemas"]["Record<string,unknown>"];
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            entities: components["schemas"]["WorkflowEntityWithId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_dashboard/:correlationKey": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          correlationKey: WorkflowDefinitionCorrelationKey;
        };
        query: {
          workflowDefinitionId?: WorkflowDefinitionId;
          from?: LocalDate;
          to?: LocalDate;
          publicationStatus?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              workflow: components["schemas"]["WorkflowDashboard"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_clusters": {
    /** A list of all workflow task clusters */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              clusters: components["schemas"]["ListedWorkflowTaskCluster"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create a new workflow task cluster */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowTaskClusterId"];
              name: string;
              input: [string, components["schemas"]["WorkflowDataFieldType"]][];
              threshold: null | number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["WorkflowTaskClusterId"];
            name: string;
            input: [string, components["schemas"]["WorkflowDataFieldType"]][];
            threshold: null | number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_clusters/:workflowTaskClusterId/get/:workflowTaskClusterValue/tasks": {
    /** Agency member requests task's cluster and its tasks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTaskClusterId: WorkflowTaskClusterId;
          workflowTaskClusterValue: string;
        };
        query: {
          limit?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              cluster: components["schemas"]["ListedWorkflowTaskCluster"];
              tasks: components["schemas"]["WorkflowHumanTaskInstance"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_task_clusters/:workflowTaskClusterId": {
    /** A single workflow task cluster */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTaskClusterId: WorkflowTaskClusterId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowTaskClusterId"];
              name: string;
              input: [string, components["schemas"]["WorkflowDataFieldType"]][];
              threshold: null | number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update a workflow task cluster */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTaskClusterId: WorkflowTaskClusterId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowTaskClusterId"];
              name: string;
              input: [string, components["schemas"]["WorkflowDataFieldType"]][];
              threshold: null | number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            threshold: null | number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_instances/aggregated_executions": {
    /** Aggregated executions of workflow instances */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          workflowDefinitionId?: WorkflowDefinitionId[];
          correlationKey?: unknown[];
          from?: LocalDate;
          to?: LocalDate;
          groupBy?: "day" | "hour";
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              unit: components["schemas"]["AggregationUnit"];
              data: components["schemas"]["WorkflowInstanceAggregatedExecutionsDatum"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_instances/:workflowInstanceId": {
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowInstanceId: WorkflowInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": components["schemas"]["WorkflowInstance"] & {
              input: components["schemas"]["WorkflowExecutionValueObject"];
              nodeResults: components["schemas"]["SerializedMap<string,WorkflowExecutionNodeResult>"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_instances/:workflowInstanceId/cancel": {
    /** Cancel a workflow instance */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          workflowInstanceId: WorkflowInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tags": {
    /** A list of all workflow tags */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tags: components["schemas"]["ListedWorkflowTag"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create a new workflow tag */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowTagId"];
              name: string;
              input: [string, components["schemas"]["WorkflowDataFieldType"]][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["WorkflowTagId"];
            name: string;
            input: [string, components["schemas"]["WorkflowDataFieldType"]][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/workflow_tags/:workflowTagId": {
    /** A single workflow tag */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTagId: WorkflowTagId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowTagId"];
              name: string;
              input: [string, components["schemas"]["WorkflowDataFieldType"]][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update a workflow tag */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyId;
          workflowTagId: WorkflowTagId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["WorkflowTagId"];
              name: string;
              input: [string, components["schemas"]["WorkflowDataFieldType"]][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/parallel_calls/make": {
    /** Agency member attempts to start parallel calls */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            calls: {
              requestCallId: string;
              source: string;
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/parallel_calls/queue": {
    /** Agency member attempts to start parallel calls */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contacts: components["schemas"]["TelephonyParallelCallContactInfo"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/make": {
    /** Agency member attempts to start an outbound call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignResult: components["schemas"]["TelephonyCallAssignmentResult"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            callId: components["schemas"]["TelephonyCallId"];
            destination: string;
            botAgent?: {
              type: string;
              input: { [key: string]: unknown };
            };
            ticketParams?: {
              relatedEntities?: {
                /** Format: VisitInstanceId */
                visitInstanceId?: VisitInstanceId;
                /** Format: VisitBroadcastId */
                visitBroadcastId?: VisitBroadcastId;
                /** Format: PatientTaskInstanceId */
                taskInstanceId?: PatientTaskInstanceId;
              };
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/bot_agents": {
    /** Agency member attempts to get bot agents */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              botAgents: {
                type: string;
                phoneNumber: string;
                description: string;
                input: {
                  [key: string]: components["schemas"]["WorkflowDataFieldType"];
                };
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/endpoints": {
    /** Agency member attempts get sip endpoints */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              primary: components["schemas"]["TelephonySipEndpointInfo"] | null;
              additional: components["schemas"]["TelephonySipEndpointInfo"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/answer": {
    /** Agency member attempts to answer an inbound call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              result: components["schemas"]["TelephonyCallAnswerResult"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            intent: components["schemas"]["TelephonyCallAnswerIntent"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/decline": {
    /** Agency member declines an inbound call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/tickets/:ticketId/answer": {
    /** Agency member attempts to answer a call by ticket id */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          ticketId: CommCenterTicketId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              result: components["schemas"]["TelephonyCallAnswerResult"];
              call: components["schemas"]["TelephonyCallInfo"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            intent: components["schemas"]["TelephonyCallAnswerIntent"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/invite": {
    /** Agency member attempts to invite a third party to a call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              result: components["schemas"]["TelephonyInvitationResult"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            invitee: components["schemas"]["TelephonyUnResolvedInviteToCallInvitee"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/participants/:participantId/remove": {
    /** Agency member removes a participant from a call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
          participantId: TelephonyCallParticipantId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/notes": {
    /** Agency member attempts to add a note to a call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            subjectId: components["schemas"]["NoteSubjectId"] | null;
            body: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/result": {
    /** Agency member attempts to set a result to a call */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            result: "CallGotDisconnected" | "NoAnswer";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/mark_as_voicemail": {
    /** Agency member marks a call as voicemail */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/recording": {
    /** Agency member gets telephony call recording signed url */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              signedUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/ringing": {
    /** Returns a list of ringing calls */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              calls: components["schemas"]["TelephonyInboundRingingCallInfo"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/missed": {
    /** Returns a list of missed calls */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          inLastMinutes?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              calls: components["schemas"]["TelephonyInboundCallInfo"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId": {
    /** Agency member attempts a telephony call record */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              call: components["schemas"]["TelephonyCallInfo"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/inbound_call_entity_options": {
    /** Get inbound call entity options */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              entityOptions: components["schemas"]["InboundCallIdentifiedCallerEntity"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/telephony/calls/:callId/update_caller_entity": {
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          callId: TelephonyCallId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              call: components["schemas"]["TelephonyCallInfo"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            entity: components["schemas"]["TelephonyCallParticipantEntity"];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/agencies/:agencyId/telephony/calls": {
    /** Caregiver attempts to start an outbound call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            source: string;
            destination: string;
            ticketParams?: {
              relatedEntities?: {
                /** Format: VisitInstanceId */
                visitInstanceId?: VisitInstanceId;
                /** Format: VisitBroadcastId */
                visitBroadcastId?: VisitBroadcastId;
                /** Format: PatientTaskInstanceId */
                taskInstanceId?: PatientTaskInstanceId;
              };
            };
          };
        };
      };
    };
  };
  "/ivr/agency-config": {
    /** IVR agent fetches agency call context for a dialed number */
    get: {
      parameters: {
        query: {
          dialedNumber?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyId: components["schemas"]["AgencyId"];
              agencyName: string;
              requiresClockLocation: boolean;
              dutiesAvailable: boolean;
              availableDuties: components["schemas"]["IvrDutyOption"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/ivr/potential-visits": {
    /** IVR agent fetches potential visits for a caller */
    get: {
      parameters: {
        query: {
          dialedNumber?: string;
          callerNumber?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              potentialVisits: components["schemas"]["IvrPotentialVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/ivr/caregiver-by-phone": {
    /** IVR agent / clock Lambda looks up a caregiver by mobile number */
    get: {
      parameters: {
        query: {
          agencyId?: AgencyId;
          mobileNumber?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiver: components["schemas"]["IvrCaregiverByPhone"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/ivr/clock": {
    /** Clock-submit Lambda records an IVR clock-in/out event */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              success: boolean;
              message: string;
              visitResults: components["schemas"]["IvrClockVisitResult"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ivrId: string;
            agencyId: components["schemas"]["AgencyId"];
            caregiverId: components["schemas"]["CaregiverId"] | null;
            callStartedAt: number;
            agencyPhoneNumber: string;
            patientPhoneNumber: string;
            pinCode?: null | string;
            /** @enum {string} */
            clockType: "IN" | "OUT";
            clockLocation?: ("COMMUNITY" | "HOME") | null;
            agentNotes?: null | string;
            recordingUrl?: null | string;
            visits: components["schemas"]["IvrClockVisit"][];
          };
        };
      };
    };
  };
  "/ivr/clock/recording": {
    /** IVR recording pipeline attaches an S3 recording to a call */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            ivrId: string;
            recordingS3Key: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockinClockoutRecordId/recording": {
    /** Agency member fetches a signed URL for an IVR call recording */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          clockinClockoutRecordId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              signedUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockinClockoutRecordId/candidate_visits": {
    /** Agency member fetches candidate visits to link a call against */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          clockinClockoutRecordId: number;
        };
        query: {
          caregiverId?: CaregiverId;
          patientId?: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              candidateVisits: components["schemas"]["IvrCandidateVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockinClockoutRecordId/visit_duty_requirement": {
    /** Agency member checks whether linking a clock-OUT to a visit must record duties */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          clockinClockoutRecordId: number;
        };
        query: {
          visitInstanceId?: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              dutiesRequired: boolean;
              duties: components["schemas"]["IvrCandidateDuty"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/duty_codes": {
    /** Agency member fetches plan-of-care duty catalogs (code → name) for offices */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              offices: components["schemas"]["OfficeDutyCatalog"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeIds: components["schemas"]["OfficeId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/intake_plan": {
    /** Get all intake plans */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              intakePlans: components["schemas"]["IntegrationPayer"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/intake_status": {
    /** Get all intake statuses */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              intakeStatuses: components["schemas"]["IntakeStatus"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/intake_status_by_track": {
    /** Get all intake statuses by track */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              intakeStatusesByTrack: components["schemas"]["IntakeStatusByTrack"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/medicaid_status": {
    /** Get all medicaid statuses */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              medicaidStatuses: components["schemas"]["MedicaidStatus"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/intake_tracks": {
    /** Get all intake tracks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tracks: components["schemas"]["PatientIntakeTrack"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/dashboard": {
    /** Get dashboard info for patient intake */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          freeTextSearch?: string;
          plan?: IntegrationPayerId[];
          lastCallFrom?: LocalDate;
          lastCallTo?: LocalDate;
          createdAtFrom?: LocalDate;
          createdAtTo?: LocalDate;
          medicaidStatus?: MedicaidStatusId[];
          intakeStatusId?: IntakeStatusId[];
          mainIntakeStatusId?: IntakeStatusId[];
          intakeFlowType?: ("Regular" | "Self Serve")[];
          intakeQueueName?: (
            | "Q1 - High"
            | "Q1 - Low"
            | "Q1 - Initial"
            | "Q2 - Regular"
            | "Q3 - Call To Plan"
          )[];
          intakeTracks?: IntakeTrackId[];
          incompletePatientIntake?: boolean;
          assignedAgencyMemberIds?: {
            values: AgencyMemberId[] | null;
          };
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["IntakePatientDashboardDetails"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/incomplete_patients": {
    /** Get all incomplete intake process patients */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientsCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake": {
    /** Get patient intake profile */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["IntakePatientProfile"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Edit intake details */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["IntakePatientProfile"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["PatientId"];
            firstName?: string;
            email?: null | string;
            lastName?: string;
            middleName?: null | string;
            dateOfBirth?: components["schemas"]["LocalDate"] | null;
            displayId?: null | number;
            intakeStatus?: components["schemas"]["IntakeStatus"];
            referralSource?:
              | (
                  | "A Place for Mom"
                  | "FC"
                  | "Facility lead"
                  | "Insurance plan"
                  | "Marketer - Asher"
                  | "Marketer - Omar"
                  | "Marketer - Rodel"
                  | "Online lead - Bing"
                  | "Online lead - Facebook"
                  | "Online lead - General"
                  | "Online lead - Google"
                )
              | null;
            address?: null | string;
            address2?: null | string;
            addressComponents?:
              | components["schemas"]["PatientAddressComponents"]
              | null;
            addressInstructions?: null | string;
            /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
            createdAt?: Instant;
            gender?: ("F" | "M") | null;
            notes?: components["schemas"]["EntityNote"][];
            plans?: components["schemas"]["EditPatientIntakePlan"][] | null;
            NYIA1AppoitmentDate?: components["schemas"]["Instant"] | null;
            NYIA2AppoitmentDate?: components["schemas"]["Instant"] | null;
            NYIA1Completed?: boolean;
            NYIA2Completed?: boolean;
            NYIA1Location?: ("Face-to-face" | "via Zoom") | null;
            NYIA1Clinician?: null | string;
            NYIA2Location?: ("Face-to-face" | "via Zoom") | null;
            NYIA2Clinician?: null | string;
            NYIAResults?: ("Approved" | "Denied") | null;
            UASAssessmentDate?: components["schemas"]["Instant"] | null;
            UASCompleted?: boolean;
            UASHoursAmount?: null | number;
            track?: components["schemas"]["PatientIntakeTrack"];
            exceptionCode?:
              | components["schemas"]["MedicaidExceptionCode"][]
              | null;
            planEnrollmentStatus?:
              | (
                  | "No plan"
                  | "Pending Enrollment agreement"
                  | "Pending UAS"
                  | "Pending first contact"
                  | "Plan chosen - in network"
                  | "Plan chosen - not in network"
                )
              | null;
            medicareId?: null | string;
            medicaidId?: null | string;
            medicaidStatus?: components["schemas"]["MedicaidStatus"] | null;
            medicareStatus?: ("Eligible" | "Not Eligible") | null;
            planStartDate?: components["schemas"]["LocalDate"] | null;
            nextCallDate?: components["schemas"]["LocalDateTime"] | null;
            lastCallDate?: components["schemas"]["LocalDateTime"] | null;
            phoneNumbers?: components["schemas"]["InsertPatientPhoneNumberParams"][];
            contacts?: components["schemas"]["EditPatientContact"][] | null;
            isMainContactPatient?: boolean;
            planSelectionCompleted?: boolean;
            dischargeDate?: components["schemas"]["LocalDate"] | null;
            caseManagerName?: null | string;
            caseManagerPhoneNumber?: null | string;
            caseManagerRouting?: null | string;
            essenAssessmentDate?: components["schemas"]["Instant"] | null;
            essenAssessmentCompleted?: boolean;
            referralDate?: components["schemas"]["LocalDate"] | null;
            mainPhoneNumber?: null | string;
            /** @enum {string} */
            intakeFlowType?: "Regular" | "Self Serve";
            ssn?: null | string;
            applyToChha?: boolean;
            assignedAgencyMember?:
              | components["schemas"]["PatientIntakeAssignedAgencyMember"]
              | null;
            referrerId?: components["schemas"]["ReferralUserId"] | null;
            hearAboutUs?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake": {
    /** Create new intake patient */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["IntakePatientProfile"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            firstName: string;
            lastName: string;
            phoneNumber: string;
            gender: ("F" | "M") | null;
            address2: null | string;
            middleName: null | string;
            email: null | string;
            dateOfBirth: components["schemas"]["LocalDate"] | null;
            lastCallDate: components["schemas"]["LocalDateTime"] | null;
            nextCallDate: components["schemas"]["LocalDateTime"] | null;
            addressComponents:
              | components["schemas"]["PatientAddressComponents"]
              | null;
            contact: components["schemas"]["EditPatientContact"] | null;
            medicaidId: null | string;
            intakeFlowType: components["schemas"]["IntakeFlowType"];
            referralSource?:
              | (
                  | "A Place for Mom"
                  | "FC"
                  | "Facility lead"
                  | "Insurance plan"
                  | "Marketer - Asher"
                  | "Marketer - Omar"
                  | "Marketer - Rodel"
                  | "Online lead - Bing"
                  | "Online lead - Facebook"
                  | "Online lead - General"
                  | "Online lead - Google"
                )
              | null;
            isTestUser?: boolean;
            agencyMemberAssignment?:
              | ({
                  createdBy: components["schemas"]["AgencyMemberId"];
                } & {
                  /** @enum {string} */
                  type: "manual";
                  agencyMemberId: components["schemas"]["AgencyMemberId"];
                })
              | ({
                  createdBy: components["schemas"]["AgencyMemberId"];
                } & {
                  /** @enum {string} */
                  type: "auto";
                  excludeAgencyMemberIds?: components["schemas"]["AgencyMemberId"][];
                })
              | ({
                  createdBy: components["schemas"]["AgencyMemberId"];
                } & {
                  /** @enum {string} */
                  type: "toLastAssigned";
                });
            ssn?: null | string;
            referrerId?: components["schemas"]["ReferralUserId"] | null;
            hearAboutUs?: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/reschedule_next_call": {
    /** Agency member reschedule next call */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake_calls_order": {
    /** Get patient intake calls order */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              queueOrder: {
                [key: string]: components["schemas"]["IntakeCallOrder"][];
              };
              assigneeOrder: {
                agencyMemberId: components["schemas"]["AgencyMemberId"];
                calls: components["schemas"]["IntakeCallOrder"][];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/statuses_and_tracks": {
    /** Get all intake statuses with their relevant track */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                statusId: components["schemas"]["IntakeStatusId"];
                trackId: components["schemas"]["IntakeTrackId"];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/intake_teams": {
    /** Get all intake teams */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              teams: components["schemas"]["IntakeTeam"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/patient_plans": {
    /** Get all patients intake plans */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          freeTextSearch?: string;
          plan?: IntegrationPayerId[];
          referralDateFrom?: LocalDate;
          referralDateTo?: LocalDate;
          intakeStatusId?: IntakeStatusId[];
          patientStatus?: (
            | "DRAFT"
            | "REFERRAL"
            | "PENDING_FILES"
            | "ELIGIBLE"
            | "ACCEPTED"
            | "ACTIVE"
            | "DISCHARGED"
            | "ON_HOLD"
            | "HOSPITALIZED"
            | "VACATION"
            | "DECEASED"
            | "LOST"
          )[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              plans: components["schemas"]["IntakePatientPlansDashboardDetails"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/parallel_calls_patients": {
    /** Get all intake patients for parallel calls */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["IntakePatientParallelCall"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/:patientId/intake_process_summary": {
    /** Get the patient's intake process summary */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              summary:
                | components["schemas"]["PatientIntakeProcessSummary"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/:patientId/update_intake_process_summary": {
    /** Update the patient's intake process summary */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              summary:
                | components["schemas"]["PatientIntakeProcessSummary"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake/agency_members": {
    /** Get all agency members that are under any intake team */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyMembers: {
                id: components["schemas"]["AgencyMemberId"];
                firstName: string;
                lastName: string;
                dev: boolean;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake/transfer": {
    /** Transfer phone numbers and/or tickets to existing patient/caregiver */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fromPatientId: components["schemas"]["PatientId"];
            to:
              | {
                  /** @enum {string} */
                  type: "Caregiver";
                  id: components["schemas"]["CaregiverId"];
                }
              | {
                  /** @enum {string} */
                  type: "Patient";
                  id: components["schemas"]["PatientId"];
                };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/:patientId/history": {
    /** Agency member requests the patient's intake history */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              history: components["schemas"]["PatientIntakeHistoryRow"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/:patientId/next_call_date": {
    /** Get the next call date for the patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              nextCallDate: components["schemas"]["LocalDateTime"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update the next call date for the patient */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            nextCallDate: components["schemas"]["LocalDateTime"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/faxes": {
    /** Agency member request all faxes for dashboard */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          phoneNumber?: string;
          faxStatus?: ("success" | "failed" | "processing" | "transmitting")[];
          createdAtFrom?: LocalDate;
          createdAtTo?: LocalDate;
          caregiver?: CaregiverId;
          patient?: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              faxes: components["schemas"]["DashboardFax"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/faxes/:faxId": {
    /** Agency member request fax pdf */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          faxId: FaxDetailsId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/faxes/update_status": {
    /** Set fax action status done */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["FaxDetailsId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/faxes/send_patient_document": {
    /** Agenct member requests to send a patient document as a pdf via fax */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["PatientTaskDocumentFaxRequest"]
            | components["schemas"]["PatientScheduledDocumentFaxRequest"]
            | components["schemas"]["MultiplePatientScheduledDocumentsFaxRequest"];
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/faxes/send_document": {
    /** Agenct member requests to send a document as fax */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            file: string;
            fileName: string;
            faxNumber: string;
            relatedEntity: components["schemas"]["FaxRelatedEntity"];
            recipient: string;
            comment: string;
            subject: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/faxes/:faxId/assign_entity": {
    /** Agenct member requests to assign a caregiver/patient to the fax */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          faxId: FaxDetailsId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            newDetails:
              | {
                  /** @enum {string} */
                  relatedEntityType: "Caregiver";
                  caregiverId: components["schemas"]["CaregiverId"];
                }
              | {
                  /** @enum {string} */
                  relatedEntityType: "Patient";
                  patientId: components["schemas"]["PatientId"];
                }
              | {
                  relatedEntityType: null;
                };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/patient_blood_pressure/history": {
    /** Agency member requests patient blood pressure */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              imei: components["schemas"]["PatientBpDeviceImei"] | null;
              history: components["schemas"]["PatientBpHistory"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/patient_blood_pressure_device/assign/:imei": {
    /** Agency member requests to change assigned patient blood pressure device */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          imei: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              success: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient/:patientId/patient_blood_pressure_device/unassign": {
    /** Agency member requests to change assigned patient blood pressure device */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              success: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver/:caregiverId/flags": {
    /** Get caregiver's flags */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              flags: components["schemas"]["CaregiverFlagMap"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Get caregiver's flags */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            flag: components["schemas"]["CaregiverFlagOption"];
            active: boolean;
          };
        };
      };
    };
  };
  "/patient_website/featured_caregivers": {
    /** Get featured caregivers */
    get: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["PatientWebsiteFeaturedCaregiver"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/patient_website/caregivers_in_proximity": {
    /** Get caregivers in proximity */
    get: {
      parameters: {
        query: {
          lat?: number;
          lng?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregivers: components["schemas"]["PatientWebsiteCaregiverInProximity"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/patient_website/visit": {
    /** Log visitor */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              assignedPhoneNumber: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitorId: string;
            source: string;
            campaign: null | string;
            medium: null | string;
            searchTerm: null | string;
            adContent: null | string;
            adGroup: null | string;
            extraPayload: { [key: string]: unknown } | null;
          };
        };
      };
    };
  };
  "/patient_website/events": {
    /** Log visitor */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitorId: string;
            eventType: components["schemas"]["WebsiteVisitorEventType"];
            eventName: string;
            extraPayload: { [key: string]: unknown } | null;
          };
        };
      };
    };
  };
  "/patient_website/submit_form": {
    /** Log visitor */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              redirectUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitorId: null | string;
            name: null | string;
            firstName: null | string;
            lastName: null | string;
            phoneNumber: null | string;
            address: null | string;
            email: null | string;
            /** @enum {string} */
            timeToCall?:
              | "afternoon"
              | "any-time"
              | "evening"
              | "morning"
              | "now";
            /** @enum {string} */
            intakeFlowType?: "Regular" | "Self Serve";
            referralSource?:
              | (
                  | "A Place for Mom"
                  | "FC"
                  | "Facility lead"
                  | "Insurance plan"
                  | "Marketer - Asher"
                  | "Marketer - Omar"
                  | "Marketer - Rodel"
                  | "Online lead - Bing"
                  | "Online lead - Facebook"
                  | "Online lead - General"
                  | "Online lead - Google"
                )
              | null;
            /** @enum {string} */
            servicesFor?: "caregiver" | "family" | "myself" | "other";
            isTestUser?: boolean;
          };
        };
      };
    };
  };
  "/google_ads/forms": {
    /** cyder ai webhook for form submission */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            data: {
              accountId: string;
              campaignId: string;
              createdAt: {
                _nanoseconds: number;
                _seconds: number;
              };
              form: {
                [key: string]: {
                  label: string;
                  value: string;
                };
              };
              formId: string;
              id: string;
              sessionHash: number;
              url: string;
              userHash: number;
              variantId: string;
              websiteId: string;
            };
            /** @enum {string} */
            type: "new_lead";
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/profile": {
    /** Portal user requests patient data for patient profile */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["PortalPatient"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Portal user requests to edit patient data in patient profile */
    put: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["PortalPatient"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            firstName: string;
            middleName: null | string;
            lastName: string;
            phoneNumber: null | string;
            email: null | string;
            dateOfBirth: components["schemas"]["LocalDate"] | null;
            medicaidId: null | string;
            gender: null | string;
            address: null | string;
            address2: null | string;
            ssn: null | string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/nyia_appointments": {
    /** Portal user requests patient data for nyia appointments */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              nyia1: components["schemas"]["PortalNYIAAppointment"] | null;
              nyia2: components["schemas"]["PortalNYIAAppointment"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Portal user requests to complete nyia appointment */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              nyia1: components["schemas"]["PortalNYIAAppointment"] | null;
              nyia2: components["schemas"]["PortalNYIAAppointment"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            appointmentType: components["schemas"]["AppointmentTypes"];
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/nyia_request": {
    /** Portal user requests help with nyia form */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              canRequest: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/login_phone_number": {
    /** Get a list of patient and family member phone numbers used for portal login */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientPhoneNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member requests to make other patient phone number as primary (used for portal login) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientPhoneNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            oldPhoneNumber: string;
            newPhoneNumber: string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/insurance": {
    /** Portal user requests patient insurance data */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              plan: components["schemas"]["IntegrationPayer"] | null;
              UASAssessmentDate: components["schemas"]["LocalDateTime"] | null;
              UASCompleted: boolean;
              UASHoursAmount: null | number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error: "NOT_FOUND";
            };
          };
        };
      };
    };
    /** Portal user requests to edit patient insurance data */
    put: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            UASAssessmentDate: components["schemas"]["LocalDateTime"] | null;
            UASCompleted: boolean;
            UASHoursAmount: null | number;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/stripe_key": {
    /** Portal user requests client secret for stripe */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
        query: {
          intentType?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              key: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              error: string;
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/visits_with_cico_issues": {
    /** Agency member requests visits with cico issues */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          caregiverId?: CaregiverId;
          patientId?: PatientId;
          officeIds?: OfficeId[];
          assignedAgencyMemberIds?: AgencyMemberId[];
          hasNotes?: boolean;
          attemptedToReach?: boolean;
          notAttemptedToReach?: boolean;
          successfullyReached?: boolean;
          notSuccessfullyReached?: boolean;
          timesheetSent?: boolean;
          timesheetNotSent?: boolean;
          freeText?: string;
          showMissedClockIn?: boolean;
          showMissedClockOut?: boolean;
          showNoClocks?: boolean;
          showVisitsWithRecords?: boolean;
          hasNoNotes?: boolean;
          isAssigned?: boolean;
          isNotAssigned?: boolean;
          contractIds?: ContractTypeId[];
          visitIssues?: (
            | "authorization_over_allocation"
            | "no_matching_authorization"
            | "invalid_authorization_assignment"
            | "missing_authorization_hours"
            | "missing_clock_times"
            | "no_caregiver"
            | "clockin_time_mismatch"
            | "clockout_time_mismatch"
            | "calendar_day_mismatch"
            | "no_billing_rate"
            | "no_billing_rate_county"
            | "same_day_visits_with_issues"
            | "caregiver_compliance"
            | "has_patient_overlap_issue"
            | "has_caregiver_overlap_issue"
            | "zero_billing_units"
            | "missing_dx_codes"
            | "daily_minimum_hours_not_met"
            | "overbilled_day"
            | "missed_visit_no_travel_time"
            | "missing_matching_mutual_visit"
            | "zero_billing_units"
            | "schedule_auth_allocation_conflict"
            | "unapproved_manual_clock_time_edit"
            | "caregiver_incompliant"
            | "insufficient_visit_duties"
            | "missing_personal_care_duty"
            | "excessive_clock_distance"
            | "manual_hold_invoicing"
            | "zero_dollar_pay_rate"
            | "missing_caregiver_ssn"
            | "missing_patient_member_id"
            | "missing_address"
          )[];
          noNegativeTimelyFilingDaysLeft?: boolean;
          lessThanTimelyFilingDaysLeft?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visits: components["schemas"]["CicoIssuesVisit"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member requests to update visits with cico issues records */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
            assignedAgencyMemberId:
              | components["schemas"]["AgencyMemberId"]
              | null;
            note: null | string;
            attemptedToReach: null | boolean;
            successfullyReached: null | boolean;
            timesheetSent: null | boolean;
            onlyAssigneeChanged: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/sandata_visits/resubmit": {
    /** Re-submit Sandata EVV visits that have errors */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              results: components["schemas"]["SandataResubmitVisitResult"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/sandata_visits/resubmit/jobs": {
    /** Queue an approved set of visits for Sandata EVV re-submission */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              jobId: components["schemas"]["ProcessJobId"];
              /** @description Visits queued for submission. */
              visitCount: number;
              /** @description Visits that matched no Sandata credentials and will not be submitted. */
              unroutableCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
            /** @description Carried through for the uploads history; null when not from a file. */
            fileName: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/sandata_visits/resubmit/jobs/:jobId": {
    /** Progress of a Sandata EVV re-submission job */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          jobId: ProcessJobId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              jobId: components["schemas"]["ProcessJobId"];
              status: components["schemas"]["ProcessJobStatus"];
              totalVisits: number;
              submitted: number;
              failed: number;
              skipped: number;
              /** @description Items not yet processed; zero means the job has finished. */
              pendingItems: number;
              errorMessage: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/evv_dev_help_requests/availability": {
    /** Whether "Need dev help" is switched on for this agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              enabled: boolean;
              canManage: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/evv_dev_help_requests": {
    /** Agency staff ask a developer to look at visits that will not submit */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description Null when every visit was already awaiting a developer, so nothing was created. */
              requestId: components["schemas"]["EvvDevHelpRequestId"] | null;
              flaggedVisitInstanceIds: components["schemas"]["VisitInstanceId"][];
              /** @description Visits that already had an open flag; reported back rather than flagged twice. */
              alreadyOpenVisitInstanceIds: components["schemas"]["VisitInstanceId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
            reasonText: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/evv_dev_help_requests/visit_statuses": {
    /** Where visits stand with the developers */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              statuses: components["schemas"]["EvvDevHelpVisitStatusEntry"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/evv_dev_help_requests/search": {
    /** A developer lists the EVV requests that need a look */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              requests: components["schemas"]["EvvDevHelpDashboardEntry"][];
              /** @description Request-and-office groups matching the filter, for paging. */
              totalRequests: number;
              /** @description The offices that have at least one request, for the office filter. */
              offices: components["schemas"]["EvvDevHelpOfficeOption"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            status: components["schemas"]["EvvDevHelpDashboardStatusFilter"];
            officeId: components["schemas"]["OfficeId"] | null;
            aggregator: null | string;
            /** @description Matched case-insensitively against the error text each visit was flagged with. */
            errorSearch: null | string;
            limit: number;
            offset: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/evv_dev_help_requests/handle": {
    /** A developer marks flagged EVV visits handled */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              handledVisitInstanceIds: components["schemas"]["VisitInstanceId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
            note: null | string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/evv_dev_help_requests/export": {
    /** A developer downloads the flagged EVV visits behind the filter as CSV */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description One row per matching visit, ready to save as a .csv file. */
              csv: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            status: components["schemas"]["EvvDevHelpDashboardStatusFilter"];
            officeId: components["schemas"]["OfficeId"] | null;
            aggregator: null | string;
            /** @description Matched case-insensitively against the error text each visit was flagged with. */
            errorSearch: null | string;
            limit: number;
            offset: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/sandata_visits/:visitInstanceId/submission_attempts": {
    /** Every Sandata submission attempt for a visit, with the payload sent each time */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitInstanceId: VisitInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description Newest attempt first. */
              attempts: components["schemas"]["SandataVisitSubmissionAttempt"][];
              /**
               * @description The visit's current error, which belongs to whichever attempt produced
               * the latest result — not necessarily the newest attempt, and never
               * attributable to an older one. Null when the visit has no error on record.
               */
              currentError: {
                attemptedAt: components["schemas"]["Instant"];
                errors: string[];
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/hhax_visits/resubmit": {
    /** Re-queue HHAX EVV V5 visits that have errors so the next worker run picks them up */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              results: components["schemas"]["HHAXResubmitVisitResult"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            visitInstanceIds: components["schemas"]["VisitInstanceId"][];
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/show_intake_button": {
    /** Portal user requests to know if to show intake button */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              showIntakeButton: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/intake_call": {
    /** Portal user requests to schedule a intake call */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /**
               * @description Indicates if the call is currently beig made and there is a free agency member to take the call.
               * If not there will be a scheduled call for later.
               */
              callingNow: boolean;
              isWithinWorkinHours: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/intake_patient": {
    /** Request to create patient and portal user from unrecognized phone number */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            firstName: string;
            lastName: string;
            email: string;
            phoneNumber: string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/contacts": {
    /** Portal user requests the list of family members for a patient */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contacts: components["schemas"]["PatientContactPortalUser"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Portal user requests to add new portal user as contact */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PortalUserId"];
              firstName: string;
              lastName: string;
              phoneNumber: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": components["schemas"]['Omit<PortalUser,"id"|"userId">'] & {
            relationship: string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/contacts/:phoneNumber": {
    /** Portal user requests to check if a portal user for a phone number exists */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
          phoneNumber: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              portalUser:
                | components["schemas"]['Omit<PortalUser,"userId">']
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/contacts/link": {
    /** Portal user requests to add portal user as contact */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            portalUserId: components["schemas"]["PortalUserId"];
            relationship: string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/contacts/:portalUserIdToRemove": {
    /** Portal user requests to remove portal user as family member from patient */
    delete: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
          portalUserIdToRemove: PortalUserId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/contacts": {
    /** Agency member requests the list of family members for a patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contacts: components["schemas"]["PatientContactPortalUser"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/user": {
    /** Create portal user from phone number if found in our system */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
          };
        };
      };
    };
  };
  "/portal/auth/:phoneNumber/request_code": {
    /** Portal user requests SMS login code */
    post: {
      parameters: {
        path: {
          phoneNumber: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/auth/:phoneNumber/login": {
    /** Portal user inputs code from SMS to verify */
    post: {
      parameters: {
        path: {
          phoneNumber: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error: "CODE_EXPIRED" | "INVALID_CODE" | "INVALID_PHONE_NUMBER";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            code: string;
          };
        };
      };
    };
  };
  "/portal/agencies/:agencyId/agency_members/:agencyMemberId/redirect_url/send": {
    /** Agency member requests to send portal redirect to for portal user */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            redirectUrl: components["schemas"]["PatientPortalRedirectUrl"];
            phoneNumber: string;
            message: string;
            patientId: components["schemas"]["PatientId"];
            /** Format: CommCenterTeamId */
            teamId?: CommCenterTeamId;
          };
        };
      };
    };
  };
  "/portal/auth/client/:token": {
    /** Portal user requests JWTs from client redirect token */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/auth/lookup/:phoneNumber": {
    /** Lookup portal user inputed phone number in system */
    get: {
      parameters: {
        path: {
          phoneNumber: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "NotFound" | "Patient" | "PatientContact" | "PortalUser";
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/documents": {
    /** Portal user requests patient's filled documents */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: components["schemas"]["PatientPortalDocument"][];
              showPrivatePayAgreement: boolean;
              showAuthRepForm: boolean;
              showWelcomePackage: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/document/auth_rep": {
    /** Get patient Authorized Representative form fields data */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              firstName: null | string;
              lastName: null | string;
              medicaidId: null | string;
              ssn: null | string;
              address: null | string;
              dateOfBirth: components["schemas"]["LocalDate"] | null;
              phoneNumber: components["schemas"]["PatientPhoneNumber"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Portal user submits patient Authorized Representative form */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url?: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            firstName: null | string;
            lastName: null | string;
            address: string;
            phoneNumber: null | string;
            arSignature: string;
            patientSignature: string;
            signReason: null | string;
            ssn: null | string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/document/private_pay": {
    /** Portal user submits private pay agreement form */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url?: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientSign: string;
            cardHolderName: null | string;
            mainPaymentMethodId: string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/document/supplement_form": {
    /** Portal user submits supplement form */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url?: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientFirstName: string;
            patientMiddleName: null | string;
            patientLastName: string;
            patientDateOfBirth: string;
            patientSSN: string;
            patientMaritalStatus: string;
            patientIll: boolean;
            patientBlind: boolean;
            SupplementSpouseInfo:
              | components["schemas"]["SupplementSpouseInfo"]
              | null;
            hasAccount: boolean;
            accounts: components["schemas"]["SupplementBankAccount"][] | null;
            hasRetirement: boolean;
            retirementAccounts:
              | components["schemas"]["SupplementRetirementAccount"][]
              | null;
            hasStocks: boolean;
            stocks: components["schemas"]["SupplementAnnuitie"][] | null;
            hasLifeInsurance: boolean;
            lifeInsurances:
              | components["schemas"]["SupplementLifeInsurance"][]
              | null;
            hasBurial: boolean;
            hasFuneral: boolean;
            hasSpace: boolean;
            hasFund: boolean;
            burialAccounts: components["schemas"]["SupplementBurial"][] | null;
            hasFundInsurance: boolean;
            burialFundPolicyNumber: null | string;
            burialFundFullCash: null | boolean;
            hasFundInsSpouse: boolean;
            burialSpouseFundPolicyNumber: null | string;
            burialSpouseFundFullCash: null | boolean;
            hasTrustAccount: boolean;
            trustAccounts:
              | components["schemas"]["SupplementTrustAccount"][]
              | null;
            hasVehicle: boolean;
            vehicles: components["schemas"]["SupplementVehicle"][] | null;
            hasOtherResources: boolean;
            otherResources:
              | components["schemas"]["SupplementOtherResources"][]
              | null;
            homestead1: boolean;
            homestead2: boolean;
            homestead3: null | string;
            hasAsset: boolean;
            hasTax: boolean;
            applicantSignature: string;
            spouseSignature: null | string;
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/document/welcome_package": {
    /** Portal user submits wp form */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url?: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientSignature: string;
            accessPref: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/documents": {
    /** Agency member requests patient's filled documents */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: components["schemas"]["PatientPortalDocument"][];
              showPrivatePayAgreement: boolean;
              showAuthRepForm: boolean;
              showWelcomePackage: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/clinical_documents": {
    /** Get patient portal clinical documents */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              documents: {
                title: string;
                url: string;
                date: components["schemas"]["LocalDate"];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/contacts": {
    /** Agency member edits patient's family members */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contacts: components["schemas"]["PatientContact"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            contacts: components["schemas"]["EditPatientContact"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake_contacts": {
    /** Agency member asks for all the patient's contacts from the intake profile */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contacts: components["schemas"]["PatientContact"][];
              mainPhoneNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member adds patient contact from intake profile */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              newContact: components["schemas"]["PatientContact"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            newContact: {
              firstName: string;
              middleName?: null | string;
              lastName?: string;
              relationship: string;
              mobilePhoneNumber: string;
              homePhoneNumber?: null | string;
              email?: null | string;
              address?: null | string;
              addressComponents?:
                | components["schemas"]["PatientContactAddressComponents"]
                | null;
              address2?: null | string;
              isEmergencyContact: boolean;
              livesWithPatient: boolean;
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake_contacts/:contactId": {
    /** Agency member edits patient contact from intake profile */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          contactId: PatientContactId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contact: components["schemas"]["PatientContact"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            changes: components["schemas"]["EditPatientContactRequestParams"];
          };
        };
      };
    };
    /** Agency member edits patient contact from intake profile */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          contactId: PatientContactId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake_flow_step/:intakeTrackStepId": {
    /** Submit answers for a step in the intake flow for a patient and get the next step */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          intakeTrackStepId: IntakeTrackStepId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              steps: components["schemas"]["IntakeTrackStepPreview"][];
              activeStep: components["schemas"]["PatientIntakeTrackStep"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              error: string;
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            answers: components["schemas"]["IntakeTrackStepFieldWithNewAnswer"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake_steps": {
    /** Get all steps preview for patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          externalFlowId?: IntakeExternalFlowId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              steps: components["schemas"]["IntakeTrackStepPreview"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/intake_steps/:intakeTrackStepId": {
    /** Get specific step with answers for patient */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          intakeTrackStepId: IntakeTrackStepId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              step: components["schemas"]["PatientIntakeTrackStep"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake_steps/external_flows": {
    /** Agency member request all external flows */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              externalFlows: components["schemas"]["IntakeExternalFlow"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/get_full_flow": {
    /** Get full flow for desinger */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              actions: (
                | "ADD_ALL_PLANS_TO_SCRIPT_TEXT"
                | "ADD_EXCEPTION_CODE_DESCRIPTION_IF_NECESSARY"
                | "ADD_NOT_ELIGIBLE_EXCEPTION_CODES_TO_SCRIPT"
                | "ADD_SUGGESTED_PLANS_TO_SCRIPT_TEXT"
                | "ADD_SUGGESTED_PLANS_TO_SELF_SERVE"
                | "ASSIGN_REGULAR_FLOW_PATIENT_TO_Q2_TEAM_MEMBER"
                | "AUTO_SELECT_PLAN_SELF_SERVE"
                | "CALCULATE_STATUS_FOR_NYIA_CALL"
                | "CALCULATE_TRACK"
                | "CALCULATE_WHICH_MMC"
                | "CHECK_ELIGIBILITY"
                | "CHECK_ELIGIBILITY_WITH_MEDICAID_ID"
                | "CHECK_ELIGIBILITY_WITH_PATIENT_DETAILS"
                | "CHECK_PORTAL_CALL_AVAILABILITY"
                | "COMPLETE_CHECKLIST_ITEM_NYIA_APPROVED"
                | "EMAIL_PATIENT_WITH_NYIA_APPOINTMENTS"
                | "FAX_AUTH_REP_FORM_TO_NYIA"
                | "HANDLE_EXCEPTION_CODES_EXT_FLOW"
                | "INSERT_PATIENT_INFORMATION_TO_DB"
                | "INSTRUCTIONS_FOR_PLAN_CHOICE_FAMILY_MEMBER_OR_PATIENT"
                | "NH_DISCHARGE_DATE_CHECK"
                | "PRESENT_MOST_AVAIABLE_Q2_AGENCY_MEMBER_ON_SCRIPT"
                | "REQUEST_PORTAL_CALL_MEDICAID_CHOICE_PATIENT"
                | "REQUEST_PORTAL_CALL_NYIA_FAMILY_MEMBER"
                | "REQUEST_PORTAL_CALL_NYIA_PATIENT"
                | "REQUEST_PORTAL_CALL_SWITCH_AGENCIES"
                | "RESCHEDULE_NET_CALL_IN_5_MINUTES"
                | "RETURN_PATIENT_TO_LAST_STEP_BEFORE_CURRENT_INTAKE_STATUS"
                | "RETURN_TO_MAIN_FLOW"
                | "SAVE_ADDITIONAL_CONTACT_DETAILS"
                | "SAVE_CONTACT_DETAILS"
                | "SAVE_PATIENT_PHYSICIAN"
                | "SAVE_SOCIAL_WORKER_CONTACT"
                | "SELF_SERVE_ADD_PATIENT_DETAILS"
                | "SELF_SERVE_ADD_PATIENT_PHONE_NUMBER"
                | "SELF_SERVE_ELIGIBILITY_CHECK"
                | "SELF_SERVE_MOVE_TO_REGULAR_FLOW"
                | "SELF_SERVE_TRANSFER_CALL_TO_Q2_AGENCY_MEMBER"
                | "SEND_LEAD_TO_FC"
                | "SEND_PARIVATE_PAY_AGGREEMENT"
                | "SEND_REFERRAL_FORM"
                | "SEND_REFERRAL_TO_ESSEN"
                | "SEND_SMS_LINK_AUTH_REP_FORM"
                | "SEND_SMS_LINK_NYIA_REQUEST_FORM"
                | "SEND_SMS_LINK_PROFILE"
                | "SEND_UNDER_18_FORM_TO_PATIENT_EMAIL"
                | "SEND_UNDER_18_FORM_TO_PATIENT_SMS"
                | "SEND_WP_FORM_TO_PATIENT_SMS"
                | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_MEDICAID_ELIGIBILITY_VERIFICATION"
                | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_SSN_ELIGIBILITY_VERIFICATION"
                | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_VERIFICATION"
                | "SS_VALIDATE_AND_CALCULATE_TRACK"
                | "SS_VALIDATE_AND_CALCULATE_TRACK_2"
              )[];
              fieldCodes: (
                | "APPLY_TO_CHHA"
                | "ASSISTANCE_LEVEL"
                | "CALLER_FIRST_NAME"
                | "CALLER_LAST_NAME"
                | "CALLER_RELATIONSHIP_WITH_PATIENT"
                | "CASE_MANAGER_NAME"
                | "CASE_MANAGER_PHONE_NUMBER"
                | "CASE_MANAGER_ROUTE"
                | "CONFIRM_PHONE_NUMBER"
                | "CONTACT_FIRST_NAME"
                | "CONTACT_LAST_NAME"
                | "CONTACT_PHONE_NUMBER"
                | "CONTACT_RELATIONSHIP"
                | "DISCHARGE_DATE"
                | "ESSEN_ASSESSMENT_DATE"
                | "FAMILY_MEMBER_EMAIL"
                | "GOT_SERVICES_BEFORE"
                | "IS_PATIENT_QUESTION"
                | "MEMBER_PHONE_NUMBER_REGISTERED"
                | "NEXT_CALL_DATE"
                | "NEXT_CALL_DATE_APPROXIMATE"
                | "NURSING_HOME_NAME"
                | "NYIA_1_CLINICIAL_NAME"
                | "NYIA_1_DATE_AND_TIME"
                | "NYIA_1_LCOATION"
                | "NYIA_2_CLINICIAL_NAME"
                | "NYIA_2_DATE_AND_TIME"
                | "NYIA_2_LCOATION"
                | "OUR_SERVICES"
                | "PATIENT_ADDRESS_1"
                | "PATIENT_ADDRESS_2"
                | "PATIENT_DOB"
                | "PATIENT_EMAIL"
                | "PATIENT_FIRST_NAME"
                | "PATIENT_GENDER"
                | "PATIENT_HEAR_ABOUT_US_OPTIONS"
                | "PATIENT_HEAR_ABOUT_US_TEXT"
                | "PATIENT_INTAKE_PLAN"
                | "PATIENT_INTAKE_PLAN_START_DATE"
                | "PATIENT_LAST_NAME"
                | "PATIENT_MEDICAID_ID"
                | "PATIENT_PHONE_NUMBER"
                | "PATIENT_SSN"
                | "PHYSICIAN_ADDRESS"
                | "PHYSICIAN_FAX_NUMBER"
                | "PHYSICIAN_FIRST_NAME"
                | "PHYSICIAN_LAST_NAME"
                | "PHYSICIAN_MOBILE_NUMBER"
                | "PHYSICIAN_NPI"
                | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
                | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
                | "SELF_SERVE_PAYMENT_METHOD"
                | "SELF_SERVE_ZIP_CODE"
                | "SOCIAL_WORKER_EXTENSION"
                | "SOCIAL_WORKER_FIRST_NAME"
                | "SOCIAL_WORKER_LAST_NAME"
                | "SOCIAL_WORKER_PHONE_NUMBER"
                | "TEMP_PATIENT_NUMBER"
                | "UAS_DATE_AND_TIME"
                | "UAS_HOURS_AMOUNT"
              )[];
              stepCodes: (
                | "AuthFormSignRedirect"
                | "AuthFormSignWaiting"
                | "CantMatchMedicaidInformation"
                | "CantTakeLessThan12Hours"
                | "DisableNextButtonFor45Seconds"
                | "EligibilityErrorStep"
                | "EligibleForHomeCare"
                | "ErrorStep"
                | "ExplainOurAgency"
                | "ExplainPrivatePay"
                | "FinalStep"
                | "InformationProcessing"
                | "MedicaidChoiceCallIsNotAvailable"
                | "NHExplainAboutCHHA"
                | "NHWaitForDischarge"
                | "NYIACallIsNotAvailable"
                | "NotEligible"
                | "OurServices"
                | "PaymentMethods"
                | "PhoneNumberExists"
                | "PrivatePayFinalStep"
                | "PrivatePayWillingTo12HoursAWeek"
                | "ScheduleAssessment"
                | "SelfNew->MAPAutoSelectedPlan"
                | "SelfNew->MAPConfirmNYIAScheduled"
                | "SelfNew->MAPExplainCallNYIA"
                | "SelfNew->MAPExplainNYIA"
                | "SelfNew->MAPExplainNextSteps"
                | "SelfNew->MAPExplainPlans"
                | "SelfNew->MLTCAutoSelectedPlan"
                | "SelfNew->MLTCCOnfirmNYIAScheduled"
                | "SelfNew->MLTCExplainCallNYIA"
                | "SelfNew->MLTCExplainNYIA"
                | "SelfNew->MLTCExplainNextSteps"
                | "SelfNew->MLTCExplainPlans"
                | "SelfNew->MMCAutoSelectedPlan"
                | "SelfNew->MMCConfirmNYIAScheduled"
                | "SelfNew->MMCExplainCallNYIA"
                | "SelfNew->MMCExplainMedicaidChoice"
                | "SelfNew->MMCExplainNYIA"
                | "SelfNew->MMCExplainNextSteps"
                | "SelfNew->MMCExplainPlans"
                | "SelfServeEligibilityCheckError"
                | "SelfServeEnterMedicaidAgain"
                | "SelfStayingOnMMCConfirmNYIAScheduled"
                | "SelfStayingOnMMCExplainCallNYIA"
                | "SelfStayingOnMMCExplainNYIA"
                | "SelfStayingOnMMCExplainNextSteps"
                | "SendToOnboarding"
                | "SwitchAgenciesCallIsNotAvailable"
                | "SwitchAgenciesCallIsNotAvailableAfterCallCheck"
                | "TransferCallToAgencyMember"
                | "WontService"
                | "ZipOutOfRange"
              )[];
              tracks: components["schemas"]["IntakeTrackForFullFlow"][];
              statuses: components["schemas"]["IntakeStatusForFullFlow"][];
              steps: components["schemas"]["IntakeTrackStepForFullFlow"][];
              externalFlows: components["schemas"]["IntakeExternalFlow"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake_flow_step/external_flow": {
    /** Upsert External Flow */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["IntakeExternalFlowId"];
            title: string;
            description: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake_flow_step/external_flow/:externalFlowId": {
    /** Upsert External Flow */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          externalFlowId: IntakeExternalFlowId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake_flow_step/:intakeTrackStepId": {
    /** Upsert full flow step */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          intakeTrackStepId: IntakeTrackStepId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["IntakeTrackStepId"];
            trackId: components["schemas"]["IntakeTrackId"];
            statusId: components["schemas"]["IntakeStatusId"];
            isStop: boolean;
            action:
              | (
                  | "ADD_ALL_PLANS_TO_SCRIPT_TEXT"
                  | "ADD_EXCEPTION_CODE_DESCRIPTION_IF_NECESSARY"
                  | "ADD_NOT_ELIGIBLE_EXCEPTION_CODES_TO_SCRIPT"
                  | "ADD_SUGGESTED_PLANS_TO_SCRIPT_TEXT"
                  | "ADD_SUGGESTED_PLANS_TO_SELF_SERVE"
                  | "ASSIGN_REGULAR_FLOW_PATIENT_TO_Q2_TEAM_MEMBER"
                  | "AUTO_SELECT_PLAN_SELF_SERVE"
                  | "CALCULATE_STATUS_FOR_NYIA_CALL"
                  | "CALCULATE_TRACK"
                  | "CALCULATE_WHICH_MMC"
                  | "CHECK_ELIGIBILITY"
                  | "CHECK_ELIGIBILITY_WITH_MEDICAID_ID"
                  | "CHECK_ELIGIBILITY_WITH_PATIENT_DETAILS"
                  | "CHECK_PORTAL_CALL_AVAILABILITY"
                  | "COMPLETE_CHECKLIST_ITEM_NYIA_APPROVED"
                  | "EMAIL_PATIENT_WITH_NYIA_APPOINTMENTS"
                  | "FAX_AUTH_REP_FORM_TO_NYIA"
                  | "HANDLE_EXCEPTION_CODES_EXT_FLOW"
                  | "INSERT_PATIENT_INFORMATION_TO_DB"
                  | "INSTRUCTIONS_FOR_PLAN_CHOICE_FAMILY_MEMBER_OR_PATIENT"
                  | "NH_DISCHARGE_DATE_CHECK"
                  | "PRESENT_MOST_AVAIABLE_Q2_AGENCY_MEMBER_ON_SCRIPT"
                  | "REQUEST_PORTAL_CALL_MEDICAID_CHOICE_PATIENT"
                  | "REQUEST_PORTAL_CALL_NYIA_FAMILY_MEMBER"
                  | "REQUEST_PORTAL_CALL_NYIA_PATIENT"
                  | "REQUEST_PORTAL_CALL_SWITCH_AGENCIES"
                  | "RESCHEDULE_NET_CALL_IN_5_MINUTES"
                  | "RETURN_PATIENT_TO_LAST_STEP_BEFORE_CURRENT_INTAKE_STATUS"
                  | "RETURN_TO_MAIN_FLOW"
                  | "SAVE_ADDITIONAL_CONTACT_DETAILS"
                  | "SAVE_CONTACT_DETAILS"
                  | "SAVE_PATIENT_PHYSICIAN"
                  | "SAVE_SOCIAL_WORKER_CONTACT"
                  | "SELF_SERVE_ADD_PATIENT_DETAILS"
                  | "SELF_SERVE_ADD_PATIENT_PHONE_NUMBER"
                  | "SELF_SERVE_ELIGIBILITY_CHECK"
                  | "SELF_SERVE_MOVE_TO_REGULAR_FLOW"
                  | "SELF_SERVE_TRANSFER_CALL_TO_Q2_AGENCY_MEMBER"
                  | "SEND_LEAD_TO_FC"
                  | "SEND_PARIVATE_PAY_AGGREEMENT"
                  | "SEND_REFERRAL_FORM"
                  | "SEND_REFERRAL_TO_ESSEN"
                  | "SEND_SMS_LINK_AUTH_REP_FORM"
                  | "SEND_SMS_LINK_NYIA_REQUEST_FORM"
                  | "SEND_SMS_LINK_PROFILE"
                  | "SEND_UNDER_18_FORM_TO_PATIENT_EMAIL"
                  | "SEND_UNDER_18_FORM_TO_PATIENT_SMS"
                  | "SEND_WP_FORM_TO_PATIENT_SMS"
                  | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_MEDICAID_ELIGIBILITY_VERIFICATION"
                  | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_SSN_ELIGIBILITY_VERIFICATION"
                  | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_VERIFICATION"
                  | "SS_VALIDATE_AND_CALCULATE_TRACK"
                  | "SS_VALIDATE_AND_CALCULATE_TRACK_2"
                )
              | null;
            title: string;
            script: string;
            nextStepId: components["schemas"]["IntakeTrackStepId"] | null;
            fields: components["schemas"]["IntakeTrackStepField"][];
            isMainInStatusAndTrack: boolean;
            flowType: components["schemas"]["IntakeFlowType"];
            code:
              | (
                  | "AuthFormSignRedirect"
                  | "AuthFormSignWaiting"
                  | "CantMatchMedicaidInformation"
                  | "CantTakeLessThan12Hours"
                  | "DisableNextButtonFor45Seconds"
                  | "EligibilityErrorStep"
                  | "EligibleForHomeCare"
                  | "ErrorStep"
                  | "ExplainOurAgency"
                  | "ExplainPrivatePay"
                  | "FinalStep"
                  | "InformationProcessing"
                  | "MedicaidChoiceCallIsNotAvailable"
                  | "NHExplainAboutCHHA"
                  | "NHWaitForDischarge"
                  | "NYIACallIsNotAvailable"
                  | "NotEligible"
                  | "OurServices"
                  | "PaymentMethods"
                  | "PhoneNumberExists"
                  | "PrivatePayFinalStep"
                  | "PrivatePayWillingTo12HoursAWeek"
                  | "ScheduleAssessment"
                  | "SelfNew->MAPAutoSelectedPlan"
                  | "SelfNew->MAPConfirmNYIAScheduled"
                  | "SelfNew->MAPExplainCallNYIA"
                  | "SelfNew->MAPExplainNYIA"
                  | "SelfNew->MAPExplainNextSteps"
                  | "SelfNew->MAPExplainPlans"
                  | "SelfNew->MLTCAutoSelectedPlan"
                  | "SelfNew->MLTCCOnfirmNYIAScheduled"
                  | "SelfNew->MLTCExplainCallNYIA"
                  | "SelfNew->MLTCExplainNYIA"
                  | "SelfNew->MLTCExplainNextSteps"
                  | "SelfNew->MLTCExplainPlans"
                  | "SelfNew->MMCAutoSelectedPlan"
                  | "SelfNew->MMCConfirmNYIAScheduled"
                  | "SelfNew->MMCExplainCallNYIA"
                  | "SelfNew->MMCExplainMedicaidChoice"
                  | "SelfNew->MMCExplainNYIA"
                  | "SelfNew->MMCExplainNextSteps"
                  | "SelfNew->MMCExplainPlans"
                  | "SelfServeEligibilityCheckError"
                  | "SelfServeEnterMedicaidAgain"
                  | "SelfStayingOnMMCConfirmNYIAScheduled"
                  | "SelfStayingOnMMCExplainCallNYIA"
                  | "SelfStayingOnMMCExplainNYIA"
                  | "SelfStayingOnMMCExplainNextSteps"
                  | "SendToOnboarding"
                  | "SwitchAgenciesCallIsNotAvailable"
                  | "SwitchAgenciesCallIsNotAvailableAfterCallCheck"
                  | "TransferCallToAgencyMember"
                  | "WontService"
                  | "ZipOutOfRange"
                )
              | null;
            showTitle: boolean;
            showAssistantButton: boolean;
            externalFlowId:
              | components["schemas"]["IntakeExternalFlowId"]
              | null;
            graphPoint: components["schemas"]["GraphPoint"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake_flow/graph_points": {
    /** Patch intake flow steps */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            steps: {
              id: components["schemas"]["IntakeTrackStepId"];
              graphPoint: components["schemas"]["GraphPoint"];
            }[];
            notes: {
              id: components["schemas"]["IntakeTrackNoteId"];
              graphPoint: components["schemas"]["GraphPoint"];
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake_flow/notes": {
    /** Get all intake flow notes */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              notes: components["schemas"]["IntakeTrackNote"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create intake flow note */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["IntakeTrackNoteId"];
              trackId: components["schemas"]["IntakeTrackId"];
              graphPoint: components["schemas"]["GraphPoint"];
              content: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            trackId: components["schemas"]["IntakeTrackId"];
            graphPoint: components["schemas"]["GraphPoint"];
            content: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/intake_flow/notes/:noteId": {
    /** Delete intake flow note */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: IntakeTrackNoteId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create intake flow note */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          noteId: IntakeTrackNoteId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["IntakeTrackNoteId"];
              trackId: components["schemas"]["IntakeTrackId"];
              graphPoint: components["schemas"]["GraphPoint"];
              content: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            content?: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/phonebook": {
    /** Agency member requests all phonebook contacts */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contacts: components["schemas"]["AgencyPhonebookContact"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/email/threads": {
    /** Agency member opens a new email thread and sends a message */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ticket: components["schemas"]["CommCenterTicket"];
              threadId: components["schemas"]["CommCenterEmailThreadId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            subject: string;
            assignedTeamId: components["schemas"]["CommCenterTeamId"];
            message: {
              recipients: components["schemas"]["CommCenterEmailAddressObject"][];
              content: string;
              contentPlainText: string;
              attachments: components["schemas"]["CreateEmailMessageAttachmentParams"][];
              cc: components["schemas"]["CommCenterEmailAddressObject"][];
              bcc: components["schemas"]["CommCenterEmailAddressObject"][];
            };
            entity: components["schemas"]["CreateEmailThreadRequestEntity"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/email/threads/:threadId/messages": {
    /** Agency member sends email message to a thread */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          threadId: CommCenterEmailThreadId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              messageId: components["schemas"]["CommCenterEmailMessageId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            sender: components["schemas"]["CommCenterEmailAddressObject"];
            recipients: components["schemas"]["CommCenterEmailAddressObject"][];
            content: string;
            contentPlainText: string;
            attachments: components["schemas"]["CreateEmailMessageAttachmentParams"][];
            cc: components["schemas"]["CommCenterEmailAddressObject"][];
            bcc: components["schemas"]["CommCenterEmailAddressObject"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/email/search/:term": {
    /** Search for email address / name in the system in email context */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          term: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              entities: components["schemas"]["SearchEmailEntity"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/email/system_addresses": {
    /** Get all system email addresses */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              emailAddresses: components["schemas"]["MedflytEmailAddress"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/comm_center/email/presign_urls": {
    /** Presign urls for email attachments */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              urls: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fileNames: string[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/robocall/:robocallInstanceId/recording_signed_url": {
    /** Agency member requests robocall recording signed URL */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          robocallInstanceId: RobocallInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              signedUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/referral_portal/:referralUserId/robocall/:robocallInstanceId/recording_signed_url": {
    /** Referral user requests robocall recording signed URL */
    post: {
      parameters: {
        path: {
          referralUserId: ReferralUserId;
          robocallInstanceId: RobocallInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              signedUrl: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/intake_steps": {
    /** Get the intake steps for a portal user */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              steps: components["schemas"]["IntakeTrackStepPreview"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/intake_steps/:intakeTrackStepId": {
    /** Get specific step with answers for portal user */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
          intakeTrackStepId: IntakeTrackStepId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              step: components["schemas"]["PatientIntakeTrackStep"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Submit answers for a step in the intake flow for a patient and get the next step */
    post: {
      parameters: {
        path: {
          portalUserId: PortalUserId;
          patientId: PatientId;
          intakeTrackStepId: IntakeTrackStepId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              steps: components["schemas"]["IntakeTrackStepPreview"][];
              activeStep: components["schemas"]["PatientIntakeTrackStep"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              error: string;
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            answers: components["schemas"]["IntakeTrackStepFieldWithNewAnswer"][];
          };
        };
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/intake_steps/call_schedule": {
    /** Portal user ask for patient to be called for help */
    post: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/portal/:portalUserId/patient/:patientId/phone_to_call": {
    /** Get portal patient phone number to call for intake help */
    get: {
      parameters: {
        path: {
          patientId: PatientId;
          portalUserId: PortalUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              phoneNumber: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver_supplies_shipments": {
    /** Agency member requests all supplies shipments made to caregivers */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          caregiverStatus?: (
            | "PENDING"
            | "ACTIVE"
            | "ON_HOLD"
            | "SUSPENDED"
            | "TERMINATED"
            | "ON_LEAVE"
            | "JOIN_REQUEST"
            | "QUIT"
            | "REJECTED"
          )[];
          shipmentDateFrom?: LocalDate;
          shipmentDateTo?: LocalDate;
          caregiverName?: string;
          arrivalDateFrom?: LocalDate;
          arrivalDateTo?: LocalDate;
          caregiverConfirmation?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              shipments: components["schemas"]["CaregiverSuppliesShipmentRow"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member imports the caregiver supplies shipments table from a spreadsheet. */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            newRows: components["schemas"]['Omit<CaregiverSuppliesShipmentRow,"id"|"caregiverFullName"|"caregiverStatus"|"caregiverHireDate"|"caregiverDisplayId"|"caregiverPhotoUrl"|"glovesSize"|"scrubsSize">'][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver_supplies_shipments/:caregiverId": {
    /** Agency member requests to get all of the supplies shipments made to a specific caregiver */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              shipments: components["schemas"]['Omit<CaregiverSuppliesShipmentRow,"caregiverId"|"caregiverFullName"|"caregiverStatus"|"caregiverHireDate"|"caregiverDisplayId"|"caregiverPhotoUrl">'][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregiver_supplies_shipments/:caregiverSuppliesShipmentId": {
    /** Agency member wants to edit caregiver supplies shipments table rows. */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverSuppliesShipmentId: CaregiverSuppliesShipmentId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            changes: components["schemas"]["Partial<CaregiverSuppliesShipmentRow>"];
            caregiverId: components["schemas"]["CaregiverId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/caregivers/:caregiverId/supplies_sizes": {
    /** Agency member updates caregiver gloves or scrubs sizes */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            glovesSize?: ("L" | "M" | "S" | "XL") | null;
            scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/:patientId/checklist": {
    /** Get patient intake checklist */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["IntakeChecklistItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/:patientId/checklist/:checklistItemId": {
    /** Update patient intake checklist item */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
          checklistItemId: IntakeChecklistItemId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | components["schemas"]["UpdatePatientIntakeChecklistItem.Manual.ByFieldEdit"]
            | components["schemas"]['Omit<UpdatePatientIntakeChecklistItem.Manual.ByAgencyMember,"agencyMemberId">'];
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_intake/:patientId/checklist/uncheck_bulk": {
    /** Unchecks a bulk of checklist items by id */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            items: components["schemas"]["IntakeChecklistItemId"][];
            params: components["schemas"]["UpdatePatientIntakeChecklistItemRequest"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_caregiver_relationship": {
    /** Get patient-caregiver relationship records for caregiver */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          caregiverId?: CaregiverId;
          patientId?: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              relationships: components["schemas"]["PatientCaregiverRelationship"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member creates a patient-caregiver relationship record */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
            patientId: components["schemas"]["PatientId"];
            caregiverId: components["schemas"]["CaregiverId"];
            relationshipTypeId: components["schemas"]["PatientCaregiverRelationshipTypeId"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_caregiver_relationship_types": {
    /** Get patient-caregiver relationship types */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              relationshipTypes: {
                name: string;
                id: components["schemas"]["PatientCaregiverRelationshipTypeId"];
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_caregiver_relationship/:patientCaregiverRelationshipId": {
    /** Agency member edits a patient-caregiver relationship record */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientCaregiverRelationshipId: PatientCaregiverRelationshipId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** Format: yyyy-MM-dd */
            startDate?: LocalDate;
            /** Format: yyyy-MM-dd */
            endDate?: LocalDate;
            /** Format: PatientId */
            patientId?: PatientId;
            /** Format: CaregiverId */
            caregiverId?: CaregiverId;
            /** Format: PatientCaregiverRelationshipTypeId */
            relationshipTypeId?: PatientCaregiverRelationshipTypeId;
          };
        };
      };
    };
    /** Agency member deletes a patient-caregiver relationship record */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientCaregiverRelationshipId: PatientCaregiverRelationshipId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/assignment/:visitAssignmentId": {
    /** Agency member requests a visit assignment */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitAssignmentId: VisitAssignmentId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              visitAssignment: {
                id: components["schemas"]["VisitAssignmentId"];
                patientId: components["schemas"]["PatientId"];
                caregiverId: components["schemas"]["CaregiverId"] | null;
                reason: components["schemas"]["VisitAssignmentReason"];
                status: components["schemas"]["VisitAssignmentStatus"];
                createdAt: components["schemas"]["Instant"];
                resolvedAt: components["schemas"]["Instant"] | null;
                resolvedBy: components["schemas"]["AgencyMemberId"] | null;
                visitInstances: {
                  id: components["schemas"]["VisitInstanceId"];
                  startTimeLocal: components["schemas"]["LocalDateTime"];
                  endTimeLocal: components["schemas"]["LocalDateTime"];
                  startTime: components["schemas"]["Instant"];
                  endTime: components["schemas"]["Instant"];
                  isCanceled: boolean;
                  isMissed: boolean;
                }[];
                visitBroadcasts: {
                  id: components["schemas"]["VisitBroadcastId"];
                  startTimeLocal: components["schemas"]["LocalDateTime"];
                  endTimeLocal: components["schemas"]["LocalDateTime"];
                  startTime: components["schemas"]["Instant"];
                  endTime: components["schemas"]["Instant"];
                  isCanceled: boolean;
                }[];
                notes: {
                  id: components["schemas"]["NoteId"];
                  noteRichText: null | string;
                  createdAt: components["schemas"]["Instant"];
                }[];
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member requests to change a visit assignment */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitAssignmentId: VisitAssignmentId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            status?: "Resolved" | "Unresolved";
            /** @enum {string} */
            reason?:
              | "CannotAttendFirstVisit"
              | "CannotAttendShift"
              | "CannotAttendShiftChat"
              | "CannotAttendShiftLateClockInRobocall"
              | "CannotAttendShiftRN"
              | "ChatRN"
              | "CoordinatorBroadcastedVisit"
              | "CoordinatorRemovedAllFutureVisits"
              | "CoordinatorRemovedVisits"
              | "Default"
              | "MissingClockIn"
              | "MissingPhysicianInfo"
              | "NoAnswerFirstVisitVerifyChat"
              | "NoReplacementCancelledMoreThanOneShift"
              | "NoReplacementFirstMonthOfServices"
              | "NursingVisitScheduling"
              | "PatientCalled"
              | "PatientMissedCall"
              | "PatientMovedToSMS"
              | "PatientSentSMS"
              | "RNNote"
              | "UnassignedVisit"
              | "WantToStopWorkingWithPatientChat";
            assigneeId?: components["schemas"]["AgencyMemberId"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/assignment/:visitAssignmentId/tickets": {
    /** Get visit assignment's related tickets */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitAssignmentId: VisitAssignmentId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              tickets: components["schemas"]["CommCenterTicket"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/assignment": {
    /** Agency member creates a visit assignment */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["VisitAssignmentId"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            caregiverId: components["schemas"]["CaregiverId"] | null;
            visitInstances: components["schemas"]["VisitInstanceId"][];
            visitBroadcasts: components["schemas"]["VisitBroadcastId"][];
            commCenterTickets: components["schemas"]["CommCenterTicketId"][];
            reason: components["schemas"]["VisitAssignmentReason"];
            assigneeId: components["schemas"]["AgencyMemberId"] | null;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/assignment/:visitAssignmentId/summary": {
    /** Get visit assignment's summary */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          visitAssignmentId: VisitAssignmentId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              prompt: string;
              summary: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/care_moments/progression": {
    /** Caregiver requests to view care moments rank progression */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rank: {
                from: components["schemas"]["CaregiverRankProgression"] | null;
                to: components["schemas"]["CaregiverRankProgression"];
              };
              ranks: {
                id: components["schemas"]["CareMomentsRankId"];
                title: string;
                icon: string;
                wage: number;
                requiredPoints: number;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/care_moments/adjustments/mark_viewed": {
    /** Caregiver marks care moments adjustments as viewed */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/patient_website/eligibility_checker/check": {
    /** Website visitor asks to check medicaid eligibility */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              verified: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            medicaidId: string;
            patientDOB: components["schemas"]["LocalDate"];
            zipCode: string;
            submitterUUID: string;
            websiteVisitorUUID: string;
          };
        };
      };
    };
  };
  "/patient_website/eligibility_checker/send_results_sms": {
    /** Website visitor requests to get an sms with the eligibility check results */
    put: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            phoneNumber: string;
            submitterUUID: string;
          };
        };
      };
    };
  };
  "/patient_website/eligibility_check/results": {
    /** Website visitor requests medicaid eligibility results */
    get: {
      parameters: {
        query: {
          id?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              results: components["schemas"]["PatientWebsiteEligibilityCheckResults"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/patient_website/eligibility_checker/refer_to_intake_flow": {
    /** Website visitor requests to continue the intake process and go to the intake flow page with the patient's data pre-filled */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              redirectUrl: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            linkToken: string;
          };
        };
      };
    };
  };
  "/patient_website/eligibility_checker/refer_to_patient_portal": {
    /** Website visitor requests to continue the intake process and go to the patient portal login */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            submitterToken: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/caregiver_hours_restrictions": {
    /** Get all offices caregiver hours restrictions */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              restrictions: components["schemas"]["OfficeCaregiverHoursRestriction"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/offices/:officeId/caregiver_hours_restrictions": {
    /** Create office caregiver hours restriction */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["OfficeCaregiverHoursRestrictionId"];
              officeId: components["schemas"]["OfficeId"];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
              removedAt: components["schemas"]["Instant"] | null;
              removedBy: components["schemas"]["UserId"] | null;
              startTime: components["schemas"]["LocalDate"];
              endTime: components["schemas"]["LocalDate"];
              hoursPerWeek: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startTime: components["schemas"]["LocalDate"];
            endTime: components["schemas"]["LocalDate"];
            hoursPerWeek: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/offices/:officeId/caregiver_hours_restrictions/:restrictionId": {
    /** Edit office caregiver hours restriction by id */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
          restrictionId: OfficeCaregiverHoursRestrictionId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["OfficeCaregiverHoursRestrictionId"];
              officeId: components["schemas"]["OfficeId"];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
              removedAt: components["schemas"]["Instant"] | null;
              removedBy: components["schemas"]["UserId"] | null;
              startTime: components["schemas"]["LocalDate"];
              endTime: components["schemas"]["LocalDate"];
              hoursPerWeek: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startTime: components["schemas"]["LocalDate"];
            endTime: components["schemas"]["LocalDate"];
            hoursPerWeek: number;
          };
        };
      };
    };
    /** Get all office caregiver hours restrictions */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
          restrictionId: OfficeCaregiverHoursRestrictionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/caregiver/:caregiverId/hours_overrides": {
    /** Get all offices caregiver hours overrides */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          officeIds?: OfficeId[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              overrides: components["schemas"]["OfficeCaregiverHoursOverride"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create office caregiver hours override */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | components["schemas"]["Validation.Success"]
              | components["schemas"]["Validation.Conflict"];
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            officeId: components["schemas"]["OfficeId"];
            startTime: components["schemas"]["LocalDate"];
            endTime: components["schemas"]["LocalDate"];
            hoursPerWeek: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_member/:agencyMemberId/caregiver/:caregiverId/hours_overrides/:overrideId": {
    /** Edit office caregiver hours override */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          overrideId: OfficeCaregiverHoursRestrictionOverrideId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | components["schemas"]["Validation.Success"]
              | components["schemas"]["Validation.Conflict"];
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            id: components["schemas"]["OfficeCaregiverHoursRestrictionOverrideId"];
            officeId: components["schemas"]["OfficeId"];
            startTime: components["schemas"]["LocalDate"];
            endTime: components["schemas"]["LocalDate"];
            hoursPerWeek: number;
          };
        };
      };
    };
    /** Remove office caregiver hours override */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
          overrideId: OfficeCaregiverHoursRestrictionOverrideId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | components["schemas"]["Validation.Success"]
              | components["schemas"]["Validation.Conflict"];
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/:officeId/certification_broadcast_settings": {
    /** Get all certification broadcast settings for an office */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              settings: components["schemas"]["CertificationBroadcastSetting"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create certification broadcast setting */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["CertificationBroadcastSettingsId"];
              agencyId: components["schemas"]["AgencyId"];
              officeId: components["schemas"]["OfficeId"];
              primaryCertification: components["schemas"]["CaregiverCertification"];
              permittedCertifications: components["schemas"]["CaregiverCertification"][];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            primaryCertification: components["schemas"]["CaregiverCertification"];
            permittedCertifications: components["schemas"]["CaregiverCertification"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/offices/:officeId/certification_broadcast_settings/:settingId": {
    /** Update certification broadcast setting */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
          settingId: CertificationBroadcastSettingsId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["CertificationBroadcastSettingsId"];
              agencyId: components["schemas"]["AgencyId"];
              officeId: components["schemas"]["OfficeId"];
              primaryCertification: components["schemas"]["CaregiverCertification"];
              permittedCertifications: components["schemas"]["CaregiverCertification"][];
              createdAt: components["schemas"]["Instant"];
              createdBy: components["schemas"]["UserId"];
              updatedAt: components["schemas"]["Instant"] | null;
              updatedBy: components["schemas"]["UserId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            permittedCertifications: components["schemas"]["CaregiverCertification"][];
          };
        };
      };
    };
    /** Delete certification broadcast setting */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          officeId: OfficeId;
          settingId: CertificationBroadcastSettingsId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/invoice_administrative_payment/invoicing": {
    /** Get invoicing view for administrative payment */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          contractTypeIds?: ContractTypeId[];
          officeIds?: OfficeId[];
          patientIds?: PatientId[];
          invoiceTypes?: string[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["AdministrativePaymentInvoicingData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/invoice_administrative_payment": {
    /** Get claims view for administrative payment */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
          contractTypeIds?: ContractTypeId[];
          officeIds?: OfficeId[];
          patientIds?: PatientId[];
          exportStatuses?: string[];
          paymentStatuses?: string[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["AdministrativePaymentInvoiceData"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Invoice patient administrative payment */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              ids: components["schemas"]["InvoiceAdministrativePaymentId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            months: {
              year: number;
              month: number;
              contracts: {
                contractId: components["schemas"]["ContractTypeId"];
                offices: {
                  officeId: components["schemas"]["OfficeId"];
                  patients: components["schemas"]["PatientId"][];
                }[];
              }[];
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/invoice_administrative_payment/export": {
    /** Export administrative payment invoices */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              type: components["schemas"]["EBillingProviderType"];
              files: components["schemas"]["ExportedFile"][];
              errors: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            force?: boolean;
            ids: components["schemas"]["InvoiceAdministrativePaymentId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/contracts/:contractId/admin_rates": {
    /** Get contract rates for administrative payment */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          contractId: ContractTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rates: components["schemas"]["AdministrativePaymentRate"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/admin_rate": {
    /** Create new administrative payment rate */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            contractTypeId: components["schemas"]["ContractTypeId"];
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"] | null;
            rates: components["schemas"]["AdministrativePaymentRateTiersCreateParams"][];
            updateExistingInvoiceRatesData?: components["schemas"]["UpdateExistingInvoiceRatesData"];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/admin_rate/:adminRateId/tiers": {
    /** Update administrative payment rate tiers */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          adminRateId: AdministrativePaymentRateId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            tiers: components["schemas"]["AdministrativePaymentRateTier"][];
          };
        };
      };
    };
  };
  "/su/:token": {
    /** Redirects to the original URL */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/fba_benefits": {
    /** Agency member requests the caregiver's FBA benefits information */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
        query: {
          transactionDateFrom?: LocalDate;
          transactionDateTo?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              transactions: components["schemas"]["FBABenefitsTransaction"][];
              currentBalance: number;
              totalSpent: number;
              totalEarned: number;
              lastUpdatedAt: components["schemas"]["Instant"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "NO_BENEFITS_DATA_FOUND";
              /** @enum {string} */
              message: "Caregiver has no FBA benefits data";
            };
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/benefits": {
    /** Caregiver requests their FBA benefits information */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
        query: {
          transactionDateFrom?: LocalDate;
          transactionDateTo?: LocalDate;
          transactionTypes?: ("DEPOSITED" | "SPENT")[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              transactions: components["schemas"]["FBABenefitsTransaction"][];
              currentBalance: number;
              totalSpent: number;
              totalEarned: number;
              lastUpdatedAt: components["schemas"]["Instant"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "NO_BENEFITS_DATA_FOUND";
              /** @enum {string} */
              message: "Caregiver has no FBA benefits data";
            };
          };
        };
      };
    };
  };
  "/referral_portal/auth/login": {
    /** Referral user tries to login to the portal */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            password: string;
          };
        };
      };
    };
  };
  "/referral_portal/signup": {
    /** Anonymous user tries to sign up for the referral portal */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            email: string;
            phoneNumber: string;
            role: null | string;
            organization: null | string;
            password?: string;
          };
        };
      };
    };
  };
  "/referral_portal/otp": {
    /** [Referral Portal] User attempts OTP login */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {boolean} */
                  registered: false;
                }
              | {
                  /** @enum {boolean} */
                  registered: true;
                  accessJWT: string;
                  refreshJWT: string;
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error: "CODE_EXPIRED" | "INVALID_CODE";
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            otp: string;
          };
        };
      };
    };
  };
  "/referral_portal/auth/client/:token": {
    /** Referral user requests JWTs from client redirect token */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/referral_portal/:referralUserId/patients": {
    /** Referral user requests their referred patients */
    get: {
      parameters: {
        path: {
          referralUserId: ReferralUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["ReferralPortalPatientDashboardInfo"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Referral user requests to refer a patient */
    post: {
      parameters: {
        path: {
          referralUserId: ReferralUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["ReferralPortalPatientProfile"];
              communicationLog: {
                tickets: components["schemas"]["CommCenterTicket"][];
                roboCalls: components["schemas"]["RobocallLogData"][];
              };
              documents: components["schemas"]["ReferralPatientPortalDocument"][];
              eligibilityChecks: components["schemas"]["EligibilityCheckForIntakePatient"][];
              checklist: components["schemas"]["IntakeChecklistItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | {
                /** @enum {string} */
                type: "ByMedicaidId";
                medicaidId: string;
                phoneNumber: string;
              }
            | {
                /** @enum {string} */
                type: "FreeForm";
                firstName: string;
                lastName: string;
                phoneNumber: string;
                ssn?: string;
                /** @enum {string} */
                gender?: "F" | "M";
                /** Format: yyyy-MM-dd */
                dateOfBirth?: LocalDate;
              };
        };
      };
    };
  };
  "/referral_portal/:referralUserId/patients/:patientId": {
    /** Referral user requests patient information */
    get: {
      parameters: {
        path: {
          referralUserId: ReferralUserId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patient: components["schemas"]["ReferralPortalPatientProfile"];
              communicationLog: {
                tickets: components["schemas"]["CommCenterTicket"][];
                roboCalls: components["schemas"]["RobocallLogData"][];
              };
              documents: components["schemas"]["ReferralPatientPortalDocument"][];
              eligibilityChecks: components["schemas"]["EligibilityCheckForIntakePatient"][];
              checklist: components["schemas"]["IntakeChecklistItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/referral_portal/refer_patient": {
    /** Anonymous user requests to refer a patient */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientToken: string;
              eligibility: components["schemas"]["ReferralPortalPatientMedicaidStatus"];
              patientInformation: {
                firstName: null | string;
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | {
                /** @enum {string} */
                type: "ByMedicaidId";
                medicaidId: string;
                phoneNumber: string;
              }
            | {
                /** @enum {string} */
                type: "FreeForm";
                firstName: string;
                lastName: string;
                phoneNumber: string;
                ssn?: string;
                /** @enum {string} */
                gender?: "F" | "M";
                /** Format: yyyy-MM-dd */
                dateOfBirth?: LocalDate;
              };
        };
      };
    };
  };
  "/referral_portal/:referralUserId/associate": {
    /** Referral portal request to associate patient tokens to referral user */
    post: {
      parameters: {
        path: {
          referralUserId: ReferralUserId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientTokens: string[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/referral_users": {
    /** Agency member creates a referral user */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ReferralUserId"];
              generatedPassword: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            email: string;
            phoneNumber: string;
            role: null | string;
            organization: null | string;
            password?: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/referral_users/phonebook_contacts/:phonebookContactId": {
    /** Agency member creates a referral user by phonebook contact */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          phonebookContactId: AgencyPhonebookContactId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["ReferralUserId"];
              generatedPassword: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
            role: null | string;
            organization: null | string;
            password?: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/referral_users/:referralUserId/reset_password": {
    /** Agency member resets referral user password */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          referralUserId: ReferralUserId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              generatedPassword: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/otp/email": {
    /** Anonymous user requests an OTP to be sent to their email */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            email: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_issue/:patientIssueId": {
    /** Get patient issue */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientIssueId: PatientIssueId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: components["schemas"]["PatientIssueId"];
              type: components["schemas"]["PatientIssueType"];
              patientId: components["schemas"]["PatientId"];
              patientFirstName: string;
              patientLastName: string;
              status: components["schemas"]["PatientIssueStatus"];
              description: string;
              descriptionNoteId: components["schemas"]["NoteId"];
              resolutionDescription: null | string;
              resolutionNoteId: components["schemas"]["NoteId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update patient issue */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientIssueId: PatientIssueId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            status?: "In_Progress" | "Not_Relevant" | "Open" | "Resolved";
            resolutionDescription?: string;
            description?: string;
            /** @enum {string} */
            type?: "Complaint" | "Incident";
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/state_compliance/chrc_statuses": {
    /** Get all available CHRC statuses */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              statuses: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/state_compliance/chrc/:chrcId/caregivers": {
    /** Get all caregiver connections to HCR data row */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          chrcId: MedflytCHRCDataId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverIds: components["schemas"]["CaregiverId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update all caregiver connections to CHRC data row */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          chrcId: MedflytCHRCDataId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            caregiverIds: components["schemas"]["CaregiverId"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/state_compliance/hcr/:hcrId/caregivers": {
    /** Get all caregiver connections to HCR data row */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          hcrId: MedflytHCRDataId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              caregiverIds: components["schemas"]["CaregiverId"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update all caregiver connections to HCR data row */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          hcrId: MedflytHCRDataId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            caregiverIds: components["schemas"]["CaregiverId"][];
          };
        };
      };
    };
  };
  "/mobile/version_check": {
    /** Check if mobile app is running the latest version */
    get: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {boolean} */
                  shouldUpdate: true;
                  downloadUrl: string;
                  newVersionString: string;
                }
              | {
                  /** @enum {boolean} */
                  shouldUpdate: false;
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/offline_mode/status": {
    /** Whether the mobile offline-mode subsystem should be enabled for this caregiver. */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              enabled: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/offline_bundle": {
    /** Bundled offline-mode prefetch: tasks, documents, patients, medications, diagnosis codes. */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description Server-filtered task list: scheduleDateTime ∈ [now-48h, now+48h]. */
              tasks: components["schemas"]["PatientTaskInstanceType"][];
              /** @description Per-task per-document-type templates (already mobile-filtered). */
              documents: components["schemas"]["MobileOfflineBundleDocument"][];
              /** @description Patient details, one per unique patientId referenced by `tasks`. */
              patients: components["schemas"]["MobileOfflineBundlePatient"][];
              /** @description Current medications + drafts, one per unique patientId. */
              patientMedications: components["schemas"]["MobileOfflineBundlePatientMedications"][];
              /** @description Per-task contract diagnosis codes. */
              diagnosisCodes: components["schemas"]["MobileOfflineBundleDiagnosisCodes"][];
              /** @description Per-task medical diagnosis codes. */
              medicalDiagnosisCodes: components["schemas"]["MobileOfflineBundleMedicalDiagnosisCodes"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/__heartbeat": {
    /** Reachability probe for the mobile offline-mode ConnectivityService. */
    get: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/patient_task_instances/:patientTaskInstanceId/patient_documents/:documentTypeId/submit_batch": {
    /**
     * Mobile offline-mode batch submission for a single patient-task document.
     *                 Replays cached answers and finalizes the document in one atomic call.
     *                 The Idempotency-Key header dedupes retries.
     */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          patientTaskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "Submitted";
                }
              | {
                  /** @enum {string} */
                  type: "AlreadySubmitted";
                }
              | {
                  /** @enum {string} */
                  type: "TaskCompleted";
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "IDEMPOTENCY_KEY_MISSING";
                }
              | {
                  /** @enum {string} */
                  type: "IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_BODY";
                }
              | {
                  /** @enum {string} */
                  type: "TASK_UNASSIGNED";
                }
              | {
                  /** @enum {string} */
                  type: "DOCUMENT_HAS_REJECTIONS";
                }
              | {
                  /** @enum {string} */
                  type: "MISSING_ANSWERS";
                }
              | {
                  /** @enum {string} */
                  type: "VALIDATION_FAILED";
                  details: string;
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            submittedAt: components["schemas"]["Instant"];
            answers: components["schemas"]["MobileOfflineAnswerItem"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/offline_reference/medical_diagnosis_codes": {
    /**
     * Curated subset of medical diagnosis (ICD-10) codes for offline search.
     *                 Used by the mobile offline-mode prefetch.
     */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rows: components["schemas"]["MobileOfflineMedicalDiagnosisCodeRow"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/offline_reference/medications": {
    /**
     * Curated list of medications visible to the caregiver, deduped by.
     *                 display_name with doses aggregated. Used by the mobile offline-mode prefetch.
     */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rows: components["schemas"]["MobileOfflineMedicationRow"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/offline_mode/medications/submit_batch": {
    /**
     * Mobile offline-mode batch submission for patient medication
     *                 mutations (V2 per-patient endpoints). All items are applied in a
     *                 single transaction; any failure rolls the batch back. The
     *                 Idempotency-Key header dedupes retries.
     */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "OK";
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "IDEMPOTENCY_KEY_MISSING";
                }
              | {
                  /** @enum {string} */
                  type: "IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_BODY";
                }
              | {
                  /** @enum {string} */
                  type: "ITEM_FAILED";
                  index: number;
                  reason: string;
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            items: components["schemas"]["MobileOfflineMedicationBatchItem"][];
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/offline_mode/patient_medical_diagnosis_codes/submit_batch": {
    /**
     * Mobile offline-mode batch submission for patient medical
     *                 diagnosis code mutations (attach / detach per patient).
     *                 Transaction-wrapped, all-or-nothing. The Idempotency-Key header
     *                 dedupes retries.
     */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {string} */
              type: "OK";
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "IDEMPOTENCY_KEY_MISSING";
                }
              | {
                  /** @enum {string} */
                  type: "IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_BODY";
                }
              | {
                  /** @enum {string} */
                  type: "ITEM_FAILED";
                  index: number;
                  reason: string;
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            items: components["schemas"]["MobileOfflineMedicalDiagnosisCodeBatchItem"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/worker_credentials": {
    /** Get worker credentials for an agency member */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @enum {string} */
              workerType: "StateHealthCommerceSystem";
              username: string;
              password: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update worker credentials for an agency member */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** @enum {string} */
            workerType: "StateHealthCommerceSystem";
            username: string;
            password: string;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_task/:patientTaskId/schedule-override": {
    /** Agency member requests patient's task instance schedule override */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              override:
                | components["schemas"]["PatientTaskScheduleOverride"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member requests to update patient's task instance schedule override */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patientId: components["schemas"]["PatientId"];
            taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
            timeSlots: {
              day: components["schemas"]["LocalDate"];
              timeSlots: {
                from: components["schemas"]["LocalTime"];
                to: components["schemas"]["LocalTime"];
              }[];
            }[];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/task_instances/schedule-override": {
    /** Agency member requests patient's task instance's schedule override */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
        query: {
          from?: LocalDate;
          to?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              overrides: components["schemas"]["PatientTaskScheduleOverride"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/auth/client/:token": {
    /** RN Platform website user requests JWTs from client redirect token */
    get: {
      parameters: {
        path: {
          token: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/signup": {
    /** RN Platform website user tries to signup */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              accessJWT: string;
              refreshJWT: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            data: {
              name: string;
              contact: {
                firstName: string;
                lastName: string;
                email: string;
              };
            };
          };
        };
      };
    };
  };
  "/rn/submit": {
    /** RN Platform website user submits form */
    post: {
      parameters: {};
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            patient: {
              firstName: string;
              lastName: string;
              phoneNumbers: {
                number: string;
                isPrimary: boolean;
              }[];
              address: components["schemas"]["PatientAddressComponents"];
              address2: null | string;
              addressInstructions: null | string;
              language: string;
              canPatientSpeakEnglish: null | boolean;
              gender: components["schemas"]["PatientGender"];
              dateOfBirth: components["schemas"]["LocalDate"];
              isTestUser: boolean;
              schedule: {
                assessmentStartDate: components["schemas"]["LocalDate"];
                assessmentDueDate: components["schemas"]["LocalDate"];
                scheduleFreeText: null | string;
              } | null;
              admissionId?: null | string;
              uploadedDocuments?: {
                title: string;
                /** @description S3 key (not full URL) - obtained from the upload URL endpoint */
                s3Key: string;
              }[];
            };
            agency: {
              name: string;
              contact: {
                firstName: string;
                lastName: string;
                email: string;
              };
            };
            task: components["schemas"]["RnPlatformWebsiteSubmissionTask"];
            caregiver?: {
              name: string;
              phoneNumber: string;
              isAbleToTranslate?: boolean;
            };
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks": {
    /** RN Platform website user requests agency's submitted tasks */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          limit?: number;
          page?: number;
          sortBy?: string;
          sortOrder?: string;
          search?: string;
          status?: string[];
          reviewStatus?: string[];
          hasUnreadChat?: boolean;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: {
                id: components["schemas"]["PatientTaskId"];
                createdAt: components["schemas"]["LocalDateTime"];
                firstName: string;
                lastName: string;
                scheduledDateTime:
                  | components["schemas"]["LocalDateTime"]
                  | null;
                isPatientConfirmed: boolean;
                status: components["schemas"]["RnPlatformWebsiteTaskStatus"];
                reviewStatus:
                  | ("Approved" | "Pending RN changes" | "Resolved")
                  | null;
                taskIssues: components["schemas"]["DisplayTaskIssue"][];
                taskType: components["schemas"]["PatientTaskTemplateType"];
                creditsUsed: null | number;
                paidViaInvoice: boolean;
              }[];
              pagination: {
                page: number;
                limit: number;
                total: number;
                totalPages: number;
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/submit": {
    /** RN Platform website user requests agency's submitted patients */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              /** @enum {string} */
              error: "DUPLICATE_ASSESSMENT";
              duplicateInfo: components["schemas"]["RnPlatformDuplicateAssessmentInfo"];
            };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            patient: {
              firstName: string;
              lastName: string;
              phoneNumbers: {
                number: string;
                isPrimary: boolean;
              }[];
              address: components["schemas"]["PatientAddressComponents"];
              address2: null | string;
              addressInstructions: null | string;
              language: string;
              canPatientSpeakEnglish: null | boolean;
              gender: components["schemas"]["PatientGender"];
              dateOfBirth: components["schemas"]["LocalDate"];
              isTestUser: boolean;
              schedule: {
                assessmentStartDate: components["schemas"]["LocalDate"];
                assessmentDueDate: components["schemas"]["LocalDate"];
                scheduleFreeText: null | string;
              } | null;
              admissionId?: null | string;
              uploadedDocuments?: {
                title: string;
                /** @description S3 key (not full URL) - obtained from the upload URL endpoint */
                s3Key: string;
              }[];
            };
            task: components["schemas"]["RnPlatformWebsiteSubmissionTask"];
            caregiver?: {
              name: string;
              phoneNumber: string;
              isAbleToTranslate?: boolean;
            };
            acceptDuplicates?: boolean;
          };
        };
      };
    };
  };
  "/rn/has_coverage/lat/:lat/lng/:lng": {
    /** RN Platform website user requests agency's coverage by zipcode */
    get: {
      parameters: {
        path: {
          lat: number;
          lng: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              hasCoverage: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId": {
    /** RN Platform website user requests data on patient task */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              task: components["schemas"]["RnPlatformWebsitePatientTask"];
              patient: {
                id: components["schemas"]["PatientId"];
                firstName: string;
                middleName: null | string;
                lastName: string;
                gender: ("F" | "M") | null;
                dateOfBirth: components["schemas"]["LocalDate"] | null;
                languages: string[] | null;
                address: null | string;
                address2: null | string;
                addressInstructions: null | string;
                phoneNumbers: {
                  number: string;
                  isPrimary: boolean;
                  label: string;
                  type: ("home" | "mobile") | null;
                  kind: string;
                }[];
                startOfCareDate: components["schemas"]["LocalDate"] | null;
                diagnosisCodes: {
                  id: components["schemas"]["PatientContractDiagnosisCodeId"];
                  icd: {
                    id: components["schemas"]["ICD10CodeId"];
                    formattedDxCode: string;
                    description: string;
                  };
                  type: ("PRINCIPAL" | "SURGICAL") | null;
                  startDate: components["schemas"]["LocalDate"] | null;
                  endDate: components["schemas"]["LocalDate"] | null;
                }[];
                uploadedDocuments: {
                  id: components["schemas"]["PatientDocumentScheduleId"];
                  title: string;
                  url: string;
                }[];
              };
              caregiver: {
                name: string;
                phoneNumber: string;
                isAbleToTranslate?: boolean;
              } | null;
              lastScheduleDetails: {
                assessmentStartDate: components["schemas"]["LocalDate"];
                assessmentDueDate: components["schemas"]["LocalDate"];
                scheduleFreeText: null | string;
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** RN Platform user requests to change patient/task details */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            schedule?: {
              assessmentStartDate: components["schemas"]["LocalDate"];
              assessmentDueDate: components["schemas"]["LocalDate"];
              scheduleFreeText: null | string;
            } | null;
            patient?: components["schemas"]["RnPlatformWebsiteEditPatientParams"];
            task?: components["schemas"]["RnPlatformWebsiteEditTaskParams"];
            caregiver?:
              | components["schemas"]["RnPlatformWebsiteEditCaregiverParams"]
              | null;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/change_requests": {
    /** RN Platform website user requests data on patient task */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              requests: components["schemas"]["RnPlatformWebsiteChangeRequest"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** RN Platform website user submits a change request for a task */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            request: string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/diagnosis_codes": {
    /** RN Platform website user requests ICD-10 codes matching search string */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          query?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              codes: {
                id: components["schemas"]["ICD10CodeId"];
                formattedDxCode: string;
                description: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/patients/:patientId/communications": {
    /** Agency member asks all the tickets related to a specific patient. */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientId: PatientId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              communications: {
                createdAt: components["schemas"]["Instant"];
                /** @enum {string} */
                type: "PHONE_CALL" | "SMS_CONVERSATION";
                isPatientResponded: boolean;
                summary: null | string;
                visitStartTime: components["schemas"]["LocalDateTime"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/rebroadcast_task_on_hold": {
    /** RN Platform website user requests to rebroadcast a task */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            startDate: components["schemas"]["LocalDate"];
            dueDate: components["schemas"]["LocalDate"];
            scheduleFreeText: null | string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/generate_nurse_profile": {
    /** RN Platform website user requests to generate task nurse profile */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              title: string;
              url: string;
              bucket: string;
              key: string;
              signedAt: components["schemas"]["Instant"];
              docType: components["schemas"]["CaregiverDocumentTypeId"] | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/contracts": {
    /** Get RN platform contracts for agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              contracts: components["schemas"]["RnPlatformContract"][];
              nyBestIntegrationEnabled: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Create RN platform contract after signing */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            contractId: components["schemas"]["RnPlatformContractId"];
            agencyId: components["schemas"]["AgencyId"];
            agencyName: string;
            agencyMemberName: string;
            agencyMemberPosition: string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/ny_best_integration": {
    /** Update NY Best integration setting for RN platform agency */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            nyBestIntegrationEnabled: boolean;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/contracts/:contractId": {
    /** RN Platform website user requests to download completed contract */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          contractId: RnPlatformAgencyContractId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              fileUrl: string;
              title: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/cancel_assessment": {
    /** RN Platform website user requests to cancel an assessment */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/agency_details": {
    /** Get RN platform agency details */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              agencyDetails:
                | components["schemas"]["RnPlatformAgencyDetails"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update RN platform agency details */
    patch: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            agencyName?: string;
            npiNumber?: null | string;
            agencyAddressComponents?:
              | components["schemas"]["AddressComponents"]
              | null;
            agencyLogoUrl?: null | string;
            agencyPhoneNumber?: null | string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/upload_logo_presigned": {
    /** RN Platform website user requests to presigned url to upload logo */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
              key: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/presigned-upload-urls": {
    /** Get presigned URLs to upload documents directly to S3 for assessment submission */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              files: {
                url: string;
                key: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            filenames: string[];
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/stripe_key": {
    /** Portal user requests client secret for stripe */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          intentType?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              key: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json": {
              error: string;
            };
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/email_preferences": {
    /** Get all email preferences for the agency member */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              emailPreferences: {
                id: components["schemas"]["RNPlatformEmailTypeId"];
                name: string;
                description: null | string;
                subscribed: boolean;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update email preferences for the agency member */
    put: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              emailPreferences: {
                id: components["schemas"]["RNPlatformEmailTypeId"];
                name: string;
                description: null | string;
                subscribed: boolean;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            emailPreferences: {
              emailTypeId: components["schemas"]["RNPlatformEmailTypeId"];
              subscribed: boolean;
            }[];
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/feature_flags": {
    /** RN Platform website user requests feature flags */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              bulkAssessmentsEnabled: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/credit_order_options": {
    /** Get available credit order options for the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              options: components["schemas"]["RnPlatformCreditOrderOption"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/credit_orders": {
    /** Get credit orders for the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          limit?: number;
          page?: number;
          sortBy?: string;
          sortOrder?: string;
          status?: string[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              creditOrders: components["schemas"]["RnPlatformCreditOrder"][];
              totalCount: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/credit_balance": {
    /** Get credit balance for the agency */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              totalCreditsPurchased: number;
              totalCreditsReserved: number;
              availableCredits: number;
              pendingCredits: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/credit_orders/:creditOrderId": {
    /** Cancel a credit order (soft delete) */
    delete: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          creditOrderId: TaskCreditStripeInvoiceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/patient-previsit-form/submit": {
    /** Submit patient previsit form response */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              id: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            formData: components["schemas"]["Record<string,unknown>"];
            context: {
              patientId: components["schemas"]["PatientId"];
            };
            idempotencyKey?: string;
          };
        };
      };
    };
  };
  "/patient-previsit-form/upload-url": {
    /** Get presigned URL for uploading files to patient previsit form */
    post: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              url: string;
              key: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            fileName: string;
            formKey: string;
          };
        };
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/task_document_rejections": {
    /** Get task document rejections for a document */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          documentTypeId: PatientDocumentTypeId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: {
                id: components["schemas"]["TaskDocumentRejectionId"];
                rejection: string;
                rejectionType: components["schemas"]["RejectionType"];
                rejectionFlags: string[];
                resolvedAt: components["schemas"]["Instant"] | null;
                createdAt: components["schemas"]["Instant"];
                createdBy: string;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/task_document_rejections/:rejectionId": {
    /** Update task document rejection (resolve or unresolve) */
    put: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
          rejectionId: TaskDocumentRejectionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            resolved: boolean;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/chat": {
    /** Agency member gets chat for a task */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              taskChat: {
                ticketId: components["schemas"]["CommCenterTicketId"];
                createdBy: components["schemas"]["UserId"];
                createdAt: components["schemas"]["Instant"];
                updatedAt: components["schemas"]["Instant"];
              } | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/chat_messages": {
    /** Agency member gets chat messages for a task */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              messages: components["schemas"]["CommCenterMessage"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Agency member sends a message to RN task chat (auto-creates ticket if needed) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            message: string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/chat_messages/read": {
    /** Agency member marks a task chat as read */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /** Format: CommCenterMessageId */
            latestMessageId?: CommCenterMessageId;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/task_chats/unread_counts": {
    /** Get unread message counts for all task chats */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              unreadCounts: { [key: string]: unknown };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/documents/:scheduledDocId/approve": {
    /** Approve a task document */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
          scheduledDocId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/tasks/:patientTaskId/documents/:scheduledDocId/open_for_changes": {
    /** Open task document for changes with rejections */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          patientTaskId: PatientTaskId;
          scheduledDocId: PatientDocumentScheduleId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            rejections: string[];
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/rejections/:rejectionId/resolve": {
    /** Mark a blocked rejection as fixed */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          rejectionId: TaskDocumentRejectionId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/question_rejections": {
    /** Get the question rejections for a document for task instance */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          documentTypeId: PatientDocumentTypeId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: {
                reviewId: components["schemas"]["PatientDocumentAIReviewId"];
                questionId: number;
                rejection: string;
                resolvedAt: components["schemas"]["Instant"] | null;
                declinedAt: components["schemas"]["Instant"] | null;
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/question_rejections2": {
    /** Get the question rejections for a document for task instance */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          documentTypeId: PatientDocumentTypeId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: components["schemas"]["PatientDocumentQuestionRejection"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_ai_reviews/:reviewId/question_rejections/:questionId/decline": {
    /** Caregiver decline a patient document question rejection */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          reviewId: PatientDocumentAIReviewId;
          questionId: number;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_ai_reviews/:reviewId/question_rejections/:questionId/resolve": {
    /** Caregiver resolves a patient document question rejection */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          reviewId: PatientDocumentAIReviewId;
          questionId: number;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/question_rejections/:rejectionId/decline": {
    /** Caregiver decline a patient document question rejection */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          rejectionId: PatientDocumentAiReviewProcessQuestionRejectionId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/question_rejections/:rejectionId/decline2": {
    /** Caregiver decline a patient document question rejection */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          rejectionId: PatientDocumentAiReviewProcessQuestionRejectionId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/question_rejections/:rejectionId/resolve": {
    /** Caregiver resolves a patient document question rejection */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          rejectionId: PatientDocumentAiReviewProcessQuestionRejectionId;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/section/:sectionCode/rejections": {
    /** Get the question rejections for document by section code */
    get: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          documentTypeId: PatientDocumentTypeId;
          taskInstanceId: PatientTaskInstanceId;
          sectionCode: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              rejections: components["schemas"]["PatientDocumentQuestionRejection"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/template_id/:htmlTemplateId/generate": {
    /** Caregiver ask to generate an answer for a given question */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          documentTypeId: PatientDocumentTypeId;
          htmlTemplateId: string;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "Reject";
                  rejections: components["schemas"]["PatientDocumentQuestionRejection"][];
                }
              | {
                  /** @enum {string} */
                  type: "AnswerGenerated";
                  answer: components["schemas"]["PatientDocumentAnswer"];
                };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "DOCUMENT_DEPENDENCY_BLOCK";
                  blockingDocumentNames: string[];
                }
              | {
                  /** @enum {string} */
                  type: "DOCUMENT_HAS_REJECTIONS";
                }
              | {
                  /** @enum {string} */
                  type: "NOT_ALL_REQUIRED_FOR_GENERATION_HAVE_BEEN_GENERATED";
                }
              | {
                  /** @enum {string} */
                  type: "MISSING_ANSWERS";
                };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/task_issue_types": {
    /** Get all task issue types */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              taskIssueTypes: components["schemas"]["TaskIssueType"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/templateId/:htmlTemplateId/get_icd_codes": {
    /** RN requests ICD codes for a specific question (tied to the htmlTemplateId) (might run an AI generate) */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
          htmlTemplateId: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              suggestions: {
                icdCode: string;
                description: string;
              }[];
              currentIcdCodes: {
                icdCode: string;
                description: string;
                isCreatedByAgency: boolean;
              }[];
              noRelevantCodes: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/final_icd_code_template_id/:htmlTemplateId": {
    /** RN requests the final ICD codes for document */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
          htmlTemplateId: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patientContractDiagnosisCodes: components["schemas"]["PatientContractDiagnosisCode"][];
              /** Format: PatientContractDiagnosisCodeId */
              createdId?: PatientContractDiagnosisCodeId;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/templateId/:htmlTemplateId/save_icd_codes": {
    /** RN saves ICD codes for a given section (by template id) */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          taskInstanceId: PatientTaskInstanceId;
          documentTypeId: PatientDocumentTypeId;
          htmlTemplateId: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | {
                icdCodes: string[];
                /** @enum {boolean} */
                noRelevantCodes: false;
              }
            | {
                /** @enum {boolean} */
                noRelevantCodes: true;
              };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:scheduledDocumentId/templateId/:htmlTemplateId/save_icd_codes": {
    /** Agency member saves ICD codes for a given section (by template id) */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          scheduledDocumentId: PatientDocumentScheduleId;
          htmlTemplateId: string;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json":
            | {
                icdCodes: string[];
                /** @enum {boolean} */
                noRelevantCodes: false;
              }
            | {
                /** @enum {boolean} */
                noRelevantCodes: true;
              };
        };
      };
    };
  };
  "/caregivers/:caregiverId/task_instances/:taskInstanceId/document_types/:documentTypeId/questions/:questionId/search_rn_platform_physician": {
    /** Caregiver request to search for physician for patient document */
    post: {
      parameters: {
        path: {
          caregiverId: CaregiverId;
          documentTypeId: PatientDocumentTypeId;
          questionId: number;
          taskInstanceId: PatientTaskInstanceId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              physician:
                | components["schemas"]["RNPlatformPatientPhysicianDetails"]
                | null;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            name: string;
            address: string;
          };
        };
      };
    };
  };
  "/rn-platform/hhax/agencies/:agencyId/get_otp": {
    /** Endpoint for HHAX crawlers to get OTP for 2FA login */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              otp: null | string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn-platform/hhax/agencies/:agencyId/mark_otp_used": {
    /** Endpoint for HHAX crawlers to mark OTP as used for 2FA login */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            otp: string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/bulk-assessment-report": {
    /** RN Platform website user requests bulk assessment report */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          startDate?: LocalDate;
          endDate?: LocalDate;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: {
                startOfCareDate: components["schemas"]["LocalDate"] | null;
                admissionId: string;
                patientName: string;
                lastNurseVisitDate: components["schemas"]["LocalDate"] | null;
                visitDueDate: components["schemas"]["LocalDate"];
                recentAssessment?: {
                  date: components["schemas"]["LocalDate"] | null;
                  type: components["schemas"]["PatientTaskTemplateType"];
                  status: components["schemas"]["RnPlatformWebsiteTaskStatus"];
                };
              }[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/assessment-queue-jobs": {
    /** RN Platform website user requests assessment queue jobs */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          page?: number;
          limit?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["RnPlatformBulkAssessmentJob"][];
              pagination: {
                page: number;
                limit: number;
                total: number;
                totalPages: number;
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** RN Platform website user creates assessment queue job */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  error: "INSUFFICIENT_CREDITS";
                }
              | {
                  /** @enum {string} */
                  error: "MISSING_BILLING_RATES";
                }
              | {
                  /** @enum {string} */
                  error: "EXISTING_NON_TEST_PATIENTS";
                  patientNames: string[];
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            items: components["schemas"]["CreateRnPlatformWebsiteBulkAssessmentQueueJobItem"][];
            isTest?: boolean;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/assessment-queue-jobs/:id": {
    /** RN Platform website user requests assessment queue job */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          id: RnPlatformHhaxBroadcastRequestJobId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              job: components["schemas"]["RnPlatformBulkAssessmentJob"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/assessment-queue-jobs/:id/items": {
    /** RN Platform website user requests assessment queue job items */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          id: RnPlatformHhaxBroadcastRequestJobId;
        };
        query: {
          page?: number;
          limit?: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["RnPlatformBulkAssessmentJobItem"][];
              pagination: {
                page: number;
                limit: number;
                total: number;
                totalPages: number;
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/hhax-patients-registry": {
    /** RN Platform website user requests the agency's HHAX patients registry */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          page?: number;
          limit?: number;
          search?: string;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["RnPlatformWebsiteHhaxRegistryPatient"][];
              pagination: {
                page: number;
                limit: number;
                total: number;
                totalPages: number;
              };
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/prompt_testing/schemas": {
    /** Get available schemas and models for prompt testing */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              schemas: components["schemas"]["SchemaInfo"][];
              models: (
                | "gpt-4.1"
                | "gpt-4.1-mini"
                | "gpt-4.1-mini-json"
                | "gpt-4o-json"
                | "gpt-4o-mini"
                | "gpt-4o-mini-json"
                | "gpt-4o-text"
                | "gpt-5"
                | "gpt-5-chat-latest"
                | "gpt-5.1"
                | "gpt-5.1-2025-11-13"
                | "gpt-5.1-chat-latest"
                | "gpt-5.2"
                | "gpt-5.2-2025-12-11"
                | "gpt-5.2-chat-latest"
                | "gpt-5.4-nano-2026-03-17"
                | "gpt-5.6-sol"
                | "o1"
                | "o3"
              )[];
              defaultModel: components["schemas"]["GPTVersion"];
              defaultTemperature: number;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/prompt_testing/run": {
    /** Run a prompt test with custom system prompt, user prompt, and schema */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              success: boolean;
              result?: unknown;
              error?: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            systemPrompt: string;
            userPrompt: string;
            schemaId: string;
            /** @enum {string} */
            model?:
              | "gpt-4.1"
              | "gpt-4.1-mini"
              | "gpt-4.1-mini-json"
              | "gpt-4o-json"
              | "gpt-4o-mini"
              | "gpt-4o-mini-json"
              | "gpt-4o-text"
              | "gpt-5"
              | "gpt-5-chat-latest"
              | "gpt-5.1"
              | "gpt-5.1-2025-11-13"
              | "gpt-5.1-chat-latest"
              | "gpt-5.2"
              | "gpt-5.2-2025-12-11"
              | "gpt-5.2-chat-latest"
              | "gpt-5.4-nano-2026-03-17"
              | "gpt-5.6-sol"
              | "o1"
              | "o3";
            temperature?: number;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/ai_omnibar/plan": {
    /** Turn a free text request typed in the global search bar into a plan of UI capabilities to invoke */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description Message to show under the search box. */
              reply: string;
              /**
               * @description Empty when the model has nothing to run - either it needs more information or the
               * request is outside what the loaded components offer.
               */
              steps: components["schemas"]["AiOmnibarPlanStep"][];
              /** @description True when the model is asking the user a question instead of acting. */
              needsInput: boolean;
              /**
               * @description True when this request continued the previous one - a follow-up, a correction, more detail for
               * the same task - and false when it started something unrelated.
               *
               * The browser uses it to decide what to send next time: the history it passes is the run of
               * turns since the last unrelated request, so an old task stops colouring a new one.
               */
              continuesPrevious: boolean;
              model: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description Omit to use the server's configured default.
             * @enum {string}
             */
            provider?:
              | "bedrock-deepseek"
              | "bedrock-gpt"
              | "bedrock-gpt-oss"
              | "bedrock-qwen-coder"
              | "bedrock-sonnet"
              | "gemini";
            text: string;
            capabilities: components["schemas"]["AiOmnibarCapability"][];
            context: components["schemas"]["AiOmnibarContext"];
            history: components["schemas"]["AiOmnibarMessage"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/ai_omnibar/value_search": {
    /** Search the lists of the screen a planned step is about to drive for the values the plan asked for in the user's words */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              matches: components["schemas"]["AiOmnibarValueSearchMatch"][];
              model: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description Which model plans the request.
             *
             * Gemini is the default. The Bedrock options exist so they can be compared on identical manifests,
             * and because some deployments would rather keep the traffic inside AWS: DeepSeek V3.2, Claude
             * Sonnet 5, GPT-5.6 sol and gpt-oss-20b, all through Converse.
             *
             * `bedrock-gpt-oss` is the fastest of them at the twenty cases in tests/ai_omnibar_cases.ts - about
             * 3s a plan against Gemini's 5-15s, with the same answers.
             *
             * `bedrock-qwen-coder` is for the value search only, where it answers every case in about 0.8s -
             * half what the planner takes at the same job. It plans badly, so setting it as the planner is a
             * mistake the type cannot prevent: see AI_OMNIBAR_VALUE_SEARCH_PROVIDER, which is the point of the
             * two settings being separate.
             * @enum {string}
             */
            provider?:
              | "bedrock-deepseek"
              | "bedrock-gpt"
              | "bedrock-gpt-oss"
              | "bedrock-qwen-coder"
              | "bedrock-sonnet"
              | "gemini";
            /** @description The capability whose step is about to run, for the prompt's benefit only. */
            capabilityId: string;
            capabilityTitle: string;
            terms: components["schemas"]["AiOmnibarValueSearchTerm"][];
            fields: components["schemas"]["AiOmnibarValueSearchField"][];
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/ai_omnibar/build_report": {
    /** Lay out an advanced report - primary table, columns and which columns to filter on - from the tables this agency member is allowed to report on */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              /** @description A short name for the report, for the tool's name field. */
              name: string;
              /** @description The table the report is centred on. Always one of the tables that was sent. */
              primaryTable: null | string;
              /** @description Columns to show, in the order they should appear. */
              columns: components["schemas"]["AiOmnibarReportColumnChoice"][];
              /** @description Columns to filter on, with values where the request gave them. */
              filters: components["schemas"]["AiOmnibarReportFilterChoice"][];
              /** @description One or two sentences for the user: what was built, and anything it could not do. */
              reply: string;
              model: string;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            /**
             * @description Which model plans the request.
             *
             * Gemini is the default. The Bedrock options exist so they can be compared on identical manifests,
             * and because some deployments would rather keep the traffic inside AWS: DeepSeek V3.2, Claude
             * Sonnet 5, GPT-5.6 sol and gpt-oss-20b, all through Converse.
             *
             * `bedrock-gpt-oss` is the fastest of them at the twenty cases in tests/ai_omnibar_cases.ts - about
             * 3s a plan against Gemini's 5-15s, with the same answers.
             *
             * `bedrock-qwen-coder` is for the value search only, where it answers every case in about 0.8s -
             * half what the planner takes at the same job. It plans badly, so setting it as the planner is a
             * mistake the type cannot prevent: see AI_OMNIBAR_VALUE_SEARCH_PROVIDER, which is the point of the
             * two settings being separate.
             * @enum {string}
             */
            provider?:
              | "bedrock-deepseek"
              | "bedrock-gpt"
              | "bedrock-gpt-oss"
              | "bedrock-qwen-coder"
              | "bedrock-sonnet"
              | "gemini";
            /** @description What the user asked for, in their words - the whole request, not a filter value. */
            text: string;
            /**
             * @description The tables this user may report on, sent by the page that has them.
             *
             * This is the permission boundary as well as the vocabulary: `/reports/schema` returns only the
             * entities this agency member is allowed to report on, so a table absent from here is one the
             * model must never be told about, let alone build against.
             */
            tables: components["schemas"]["AiOmnibarReportTable"][];
            /** @description The aggregate and filter rules per column type - see AiOmnibarReportTypeRules. */
            typeRules: components["schemas"]["AiOmnibarReportTypeRules"][];
            /**
             * @description The periods the tool's relative date filters accept, sent by the page that renders them.
             *
             * Two shapes, and getting them wrong is silent: "LAST X" takes one of `single` ("MONTH"), while
             * "LAST N X" takes a count and one of `counted` ("MONTHS"). A period outside these lists - a
             * quarter, say, or a lower-case "month" - leaves the filter's dropdown empty.
             */
            periods: {
              single: string[];
              counted: string[];
              relative: string[];
            };
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/caregivers/:caregiverId/rn_performance_blocks": {
    /** Get all RN performance blocks for a caregiver (historical) */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          caregiverId: CaregiverId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              blocks: components["schemas"]["RNPerformanceBlockItem"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/rn_performance_blocks/:blockId/unblock": {
    /** Manually unblock an RN performance block */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
          blockId: number;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              success: boolean;
              block: components["schemas"]["RNPerformanceBlockItem"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
        /** Operation Failed (See Response Body) */
        409: {
          content: {
            "application/json":
              | {
                  /** @enum {string} */
                  type: "BlockNotFound";
                }
              | {
                  /** @enum {string} */
                  type: "BlockAlreadyUnblocked";
                  unblockedAt: components["schemas"]["Instant"];
                  unblockedReason: string;
                };
          };
        };
      };
      requestBody: {
        content: {
          "application/json": {
            note: string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/rn-platform/poc-codes": {
    /** Get all POC items with agency codes and PDF enabled flag */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              items: components["schemas"]["RnPlatformPocItemWithCode"][];
              isPdfEnabled: boolean;
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
    /** Update code for a specific POC item */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            planOfCareItemId: string;
            code: string;
          };
        };
      };
    };
  };
  "/rn/agencies/:agencyId/agency_members/:agencyMemberId/rn-platform/poc-codes/pdf-enabled": {
    /** Toggle PDF display setting for POC codes */
    post: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation (No Content) */
        204: never;
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
      requestBody: {
        content: {
          "application/json": {
            isEnabled: boolean;
          };
        };
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/rn_scheduling_map": {
    /** Patients whose current certification period ends in the given date range, with the geo location needed to place them on the RN scheduling map */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
        query: {
          certificationPeriodEndFrom?: LocalDate;
          certificationPeriodEndTo?: LocalDate;
          contractTypeIds?: ContractTypeId[];
          countyNames?: string[];
          officeIds?: OfficeId[];
          schedulingStatuses?: (
            | "VISIT_COMPLETED"
            | "RN_SCHEDULED"
            | "REQUIRE_SCHEDULING"
          )[];
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              patients: components["schemas"]["RnSchedulingMapPatient"][];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "/agencies/:agencyId/agency_members/:agencyMemberId/rn_scheduling_map/counties": {
    /** The counties (NYC boroughs included) of the agency's in-care patients, used as the borough / region filter options of the RN scheduling map */
    get: {
      parameters: {
        path: {
          agencyId: AgencyId;
          agencyMemberId: AgencyMemberId;
        };
      };
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              countyNames: string[];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
  "@/socket-events": {
    /** socket events */
    get: {
      parameters: {};
      responses: {
        /** Successful operation */
        200: {
          content: {
            "application/json": {
              TaskChatUpdated: components["schemas"]["TaskChatUpdatedEventPayload"];
              AgenciesUpdated: { [key: string]: unknown };
              AgencyMemberWasMentioned: components["schemas"]["AgencyMemberWasMentionedSocketEventPayload"];
              CaregiversUpdated: components["schemas"]["CaregiversUpdatedEventPayload"];
              CaregiverUpdated: components["schemas"]["CaregiverUpdatedEventPayload"];
              ChatRoomUpdated: components["schemas"]["ChatRoomUpdatedEventPayload"];
              ClockedInStatusUpdated: { [key: string]: unknown };
              ClusterUpdated: components["schemas"]["ClusterUpdatedEventPayload"];
              NotificationsUpdated: components["schemas"]["NotificationsUpdatedEventPayload"];
              PatientUpdated: components["schemas"]["PatientUpdatedEventPayload"];
              PatientCostShareUpdated: {
                patientId: components["schemas"]["PatientId"];
              };
              PatientServicePlanImportCompleted: {
                patientId: components["schemas"]["PatientId"];
                importId: components["schemas"]["PatientServicePlanImportId"];
                patientServicePlanId:
                  | components["schemas"]["PatientServicePlanId"]
                  | null;
                success: boolean;
              };
              /**
               * @description An off-platform signee submitted their signature through an emailed
               * claim link. Broadcast to the whole agency rather than the sender,
               * because the claim is submitted anonymously — anyone with the plan open
               * should see it appear.
               */
              PatientServicePlanSignatureClaimed: {
                patientId: components["schemas"]["PatientId"];
                patientServicePlanId: components["schemas"]["PatientServicePlanId"];
                role: components["schemas"]["PatientServicePlanSignatureRole"];
                signedBy: string;
              };
              ScheduledVisitEditRequestChange: { [key: string]: unknown };
              ScheduledVisitsUpdated: { [key: string]: unknown };
              ScoreChanged: components["schemas"]["ScoreChangedEventPayload"];
              VisitsUpdated: { [key: string]: unknown };
              VisitUpdated: components["schemas"]["VisitUpdatedEventPayload"];
              VisitAssignmentAssigneeUpdated: components["schemas"]["VisitAssignmentAssigneeUpdatedEventPayload"];
              TaskBroadcastsUpdated: { [key: string]: unknown };
              PatientTasksUpdated: { [key: string]: unknown };
              TelephonyInboundCallRinging: components["schemas"]["TelephonyInboundCallRingingEventPayload"];
              TelephonyInboundCallAnswered: components["schemas"]["TelephonyInboundCallAnsweredEventPayload"];
              TelephonyOutboundCallAnswered: components["schemas"]["TelephonyOutboundCallAnsweredEventPayload"];
              TelephonyOutboundCallInitiated: components["schemas"]["TelephonyOutboundCallInitiatedEventPayload"];
              TelephonyCallEnded: components["schemas"]["TelephonyCallEndedEventPayload"];
              TelephonyCallConnected: components["schemas"]["TelephonyCallConnectedEventPayload"];
              TelephonyOutboundCallStarted: components["schemas"]["TelephonyOutboundCallStartedEventPayload"];
              TelephonyCallParticipantCreated: components["schemas"]["TelephonyCallParticipantCreatedEventPayload"];
              TelephonyCallParticipantUpdated: components["schemas"]["TelephonyCallParticipantUpdatedEventPayload"];
              TelephonyConferenceInvitationReceived: components["schemas"]["TelephonyConferenceInvitationReceivedEventPayload"];
              TelephonyConferenceInvitationFailed: components["schemas"]["TelephonyConferenceInvitationFailedPayload"];
              TelephonyPortalCallRequested: components["schemas"]["TelephonyPortalCallRequested"];
              TelephonyParallelCallStarted: components["schemas"]["TelephonyParallelCallStartedEventPayload"];
              TelephonyParallelCallRinging: components["schemas"]["TelephonyParallelCallRingingEventPayload"];
              TelephonyParallelCallAnswered: components["schemas"]["TelephonyParallelCallAnsweredEventPayload"];
              TelephonyParallelCallCalleeClassified: components["schemas"]["TelephonyParallelCallCalleeClassifiedEventPayload"];
              TelephonyParallelCallTranscribed: components["schemas"]["TelephonyParallelCallTranscribedEventPayload"];
              TelephonyAnyAgencyMemberInvited: components["schemas"]["TelephonyAnyAgencyMemberInvitedEventPayload"];
              TelephonyConferenceAnswered: components["schemas"]["TelephonyConferenceAnsweredEventPayload"];
              CommCenterTyping: components["schemas"]["CommCenterTypingEventPayload"];
              CommCenterTicketUpdated: components["schemas"]["CommCenterTicketUpdatedEventPayload"];
              CommCenterTicketViewed: { [key: string]: unknown };
              CommCenterRedirect: components["schemas"]["CommCenterRedirectEventPayload"];
              CommCenterChatRoomRedirect: components["schemas"]["CommCenterChatRoomRedirectEventPayload"];
              InstapaySuccess: { [key: string]: unknown };
              CommCenterNotifyAgencyMember: components["schemas"]["CommCenterAgencyMemberNotificationSocketPayload"];
              OnboardingStageUpdated: components["schemas"]["OnboardingStageUpdatedPayload"];
              PortalPatientProfileUpdate: components["schemas"]["PortalPatientProfileUpdatePayload"];
              PortalPatientDocumentUpload: components["schemas"]["PortalPatientDocumentUploadPayload"];
              NewIntakePatientCreated: { [key: string]: unknown };
              PatientIntackeChecklistChanged: components["schemas"]["PatientIntackeChecklistChangedPayload"];
              OutboundSMSSentSuccessfully: components["schemas"]["OutboundSMSSentSuccessfully"];
              OutboundSMSFailed: components["schemas"]["OutboundSMSFailed"];
              AuthorizationFileDiagnosisCodeFetched: components["schemas"]["AuthorizationFileDiagnosisCodeFetched"];
              PatientTaskInstanceDocumentReviewFinished: {
                taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
                documentTypeId: components["schemas"]["PatientDocumentTypeId"];
                patientId: components["schemas"]["PatientId"];
              };
              BroadcastVisitPosted: components["schemas"]["BroadcastVisitPostedEventPayload"];
              CaregiverAssignedToVisit: components["schemas"]["CaregiverAssignedToVisitEventPayload"];
              BroadcastVisitCancellationConfirmed: components["schemas"]["BroadcastVisitCancellationConfirmedEventPayload"];
              VisitInstanceDeleted: components["schemas"]["VisitInstanceDeletedEventPayload"];
              VisitUnmissed: components["schemas"]["VisitUnmissedEventPayload"];
            };
          };
        };
        /** Error: Object Unavailable (Insufficient Privileges or Deleted) */
        403: unknown;
      };
    };
  };
}

export interface components {
  schemas: {
    /** Format: CaregiverId */
    CaregiverId: CaregiverId;
    /** Format: AgencyBranchId */
    AgencyBranchId: AgencyBranchId;
    /** Format: AgencyId */
    AgencyId: AgencyId;
    /** Format: AgencyMemberId */
    AgencyMemberId: AgencyMemberId;
    /** Format: PatientId */
    PatientId: PatientId;
    OfficeBranch: {
      id: components["schemas"]["OfficeBranchId"];
      officeId: components["schemas"]["OfficeId"];
      name: string;
      licenseNumber: null | string;
      address: string;
      addressComponents: components["schemas"]["AddressComponents"];
      counties: components["schemas"]["OfficeBranchCounty"][];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
    };
    /** Format: OfficeBranchId */
    OfficeBranchId: OfficeBranchId;
    /** Format: OfficeId */
    OfficeId: OfficeId;
    AddressComponents: {
      location: components["schemas"]["Geo"];
      country: string;
      administrativeAreaLevel1: string;
      administrativeAreaLevel2: string;
      sublocalityLevel1?: null | string;
      neighborhood?: null | string;
      locality?: null | string;
      administrativeLevels?: {
        level1short?: null | string;
      } | null;
      formatedAddressDetails?: components["schemas"]["FormatedAddressDetails"];
    };
    Geo: {
      lat: number;
      lng: number;
    };
    FormatedAddressDetails: {
      location: components["schemas"]["Geo"];
      address1: string;
      country: string;
      state: string;
      county: string;
      fullAddress: string;
      city?: null | string;
      zip5?: null | string;
      zip4?: null | string;
      street?: null | string;
      streetNumber?: null | string;
      crossStreet?: null | string;
      address2?: null | string;
    };
    OfficeBranchCounty: {
      id: components["schemas"]["OfficeBranchCountyId"];
      state: string;
      countyName: string;
    };
    /** Format: OfficeBranchCountyId */
    OfficeBranchCountyId: OfficeBranchCountyId;
    /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
    Instant: Instant;
    PdfFormTemplateListItem: {
      id: components["schemas"]["PdfFormTemplateId"];
      name: string;
      pageCount: number;
      latestVersionNumber: number;
      isPublished: boolean;
      updatedAt: components["schemas"]["Instant"] | null;
    };
    /** Format: PdfFormTemplateId */
    PdfFormTemplateId: PdfFormTemplateId;
    PdfFormTemplateVersionData: {
      id: components["schemas"]["PdfFormTemplateVersionId"];
      versionNumber: number;
      fields: components["schemas"]["PdfFormField"][];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
    };
    /** Format: PdfFormTemplateVersionId */
    PdfFormTemplateVersionId: PdfFormTemplateVersionId;
    /**
     * @description One overlay field. `rect` is null exactly when type === "radio" (the
     * geometry lives on the options); `options` is non-null exactly when
     * type === "radio". `id` is the DB row id as a string on output; on input
     * the server ignores it (clients may send temporary ids).
     */
    PdfFormField: {
      id: string;
      type: components["schemas"]["PdfFormFieldType"];
      name: string;
      page: number;
      rect: components["schemas"]["PdfFormFieldRect"] | null;
      options: components["schemas"]["PdfFormRadioOption"][] | null;
    };
    /** @enum {string} */
    PdfFormFieldType: "checkbox" | "multiline" | "radio" | "signature" | "text";
    /** @description PDF points at scale 1, origin top-left of the page. */
    PdfFormFieldRect: {
      x: number;
      y: number;
      width: number;
      height: number;
    };
    PdfFormRadioOption: {
      value: string;
      rect: components["schemas"]["PdfFormFieldRect"];
    };
    GeneratePdfPreviewField: {
      field: components["schemas"]["PdfFormField"];
      /**
       * @description string for text/multiline/radio/signature (signature = base64 or data-URL
       * PNG/JPEG); boolean for checkbox; null = unset (the field is skipped).
       */
      value: null | string | boolean;
    };
    /**
     * @description The wider caregiver record, for the pages that genuinely enumerate caregivers
     * (compliance, onboarding, pending applications, the COVID report) rather than
     * decorating a row. Everything a page derives for itself - initials, a joined
     * office-name string, an "installed / uninstalled / never" label - stays on the
     * page; this carries only what the database holds.
     */
    CaregiverRecord: {
      birthDate: components["schemas"]["LocalDate"] | null;
      gender: string;
      lastSeen: components["schemas"]["Instant"] | null;
      appInstalledAt: components["schemas"]["Instant"][];
      appUninstalledAt: components["schemas"]["Instant"][];
      stateRegistryNum: null | number;
      caregiverBranch: null | string;
      workAreaPreference: null | string;
      isFromLandingPage: boolean;
      applicationStartDate: components["schemas"]["LocalDate"] | null;
      isCompliant: boolean;
      id: components["schemas"]["CaregiverId"];
      displayName: string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      displayId: null | number;
      caregiverCode: null | string;
      hireDate: components["schemas"]["LocalDate"] | null;
      photoUrl: null | string;
      appInstalled: boolean;
      address: string;
      /** @description Where the caregiver lives, for callers that show a distance. */
      addressGeoLocation: components["schemas"]["Geo"];
      certifications: components["schemas"]["CaregiverCertification"][];
      officeIds: components["schemas"]["OfficeId"][];
      employmentType: null | string;
      status: components["schemas"]["CaregiverStatus"];
      languages: string[];
      /**
       * @description Only present when the caller asked for it - it costs a per-row aggregate,
       * which the list endpoints using this type should not pay for. Absent, not
       * empty, when not requested, so a caller cannot mistake "not asked" for
       * "no phone numbers".
       */
      phoneNumbers?: string[];
    };
    /** Format: yyyy-MM-dd */
    LocalDate: LocalDate;
    /** Format: CaregiverCertification */
    CaregiverCertification: string;
    /**
     * @description The status of a Caregiver within a specific Agency
     * @enum {string}
     */
    CaregiverStatus:
      | "ACTIVE"
      | "JOIN_REQUEST"
      | "ON_HOLD"
      | "ON_LEAVE"
      | "PENDING"
      | "QUIT"
      | "REJECTED"
      | "SUSPENDED"
      | "TERMINATED";
    /**
     * @description The caregiver fields a list row needs to render: a name, the ids a user
     * recognises, and the code they search by.
     *
     * Denormalised onto row payloads so a page does not have to hold a dictionary of
     * every caregiver in the agency to label its rows. `hireDate` is only populated
     * where a table shows it.
     *
     * Shaped as a nested object rather than flat `caregiverName` fields because the
     * billing and approval tables already read `row.caregiver.displayName` - this is
     * what they were building client-side from the dictionary.
     */
    CaregiverRowDisplay: {
      id: components["schemas"]["CaregiverId"];
      displayName: string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      displayId: null | number;
      caregiverCode: null | string;
      hireDate: components["schemas"]["LocalDate"] | null;
      photoUrl: null | string;
      appInstalled: boolean;
      address: string;
      /** @description Where the caregiver lives, for callers that show a distance. */
      addressGeoLocation: components["schemas"]["Geo"];
      certifications: components["schemas"]["CaregiverCertification"][];
      officeIds: components["schemas"]["OfficeId"][];
      employmentType: null | string;
      status: components["schemas"]["CaregiverStatus"];
      languages: string[];
      /**
       * @description Only present when the caller asked for it - it costs a per-row aggregate,
       * which the list endpoints using this type should not pay for. Absent, not
       * empty, when not requested, so a caller cannot mistake "not asked" for
       * "no phone numbers".
       */
      phoneNumbers?: string[];
    };
    CaregiverListItem: {
      id: components["schemas"]["CaregiverId"];
      displayId: null | number;
      firstName: string;
      middleName: null | string;
      lastName: string;
      avatarUrl: null | string;
      email: null | string;
      address: null | string;
      gender: null | string;
      languages: string[];
      certifications: components["schemas"]["CaregiverCertification"][];
      status: components["schemas"]["CaregiverStatus"];
      caregiverCode: null | string;
      hireDate: components["schemas"]["LocalDate"] | null;
      terminationDate: components["schemas"]["LocalDate"] | null;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      workAreaPreference: null | string;
      stateRegistryNum: null | number;
      appInstalled: boolean;
      /** @description Last heartbeat from the caregiver's app, if it has ever reported one. */
      lastSeen: components["schemas"]["Instant"] | null;
      /**
       * @description Whether the app is connected right now, on the same ten-second window the
       * caregivers page has always used. Computed when the request is served, so it
       * is a snapshot rather than a live value.
       */
      isOnline: boolean;
      agencyAssocCreatedAt: components["schemas"]["Instant"];
      isFromLandingPage: boolean;
      customFields: components["schemas"]["EntityCustomField"];
      phoneNumbers: components["schemas"]["CaregiverListPhoneNumber"][];
      offices: components["schemas"]["CaregiverListOffice"][];
      branches: components["schemas"]["CaregiverListBranch"][];
      createdBy: components["schemas"]["CaregiverListCreatedBy"] | null;
    };
    EntityCustomField: {
      [key: string]: components["schemas"]["CustomFieldValue"];
    };
    CustomFieldValue:
      | components["schemas"]["CustomFieldValue.Text"]
      | components["schemas"]["CustomFieldValue.Number"]
      | components["schemas"]["CustomFieldValue.Date"]
      | components["schemas"]["CustomFieldValue.DateRange"]
      | components["schemas"]["CustomFieldValue.Address"]
      | components["schemas"]["CustomFieldValue.PhoneNumber"]
      | components["schemas"]["CustomFieldValue.Caregiver"]
      | components["schemas"]["CustomFieldValue.Patient"]
      | components["schemas"]["CustomFieldValue.Boolean"]
      | components["schemas"]["CustomFieldValue.Enum"];
    "CustomFieldValue.Text": {
      /** @enum {string} */
      fieldType: "TEXT";
      fieldName: string;
      value: string;
    };
    "CustomFieldValue.Number": {
      /** @enum {string} */
      fieldType: "NUMBER";
      fieldName: string;
      value: number;
    };
    "CustomFieldValue.Date": {
      /** @enum {string} */
      fieldType: "DATE";
      fieldName: string;
      value: components["schemas"]["LocalDate"];
    };
    "CustomFieldValue.DateRange": {
      /** @enum {string} */
      fieldType: "DATE_RANGE";
      fieldName: string;
      from: components["schemas"]["LocalDate"];
      to: components["schemas"]["LocalDate"];
    };
    "CustomFieldValue.Address": {
      /** @enum {string} */
      fieldType: "ADDRESS";
      fieldName: string;
      value: string;
    };
    "CustomFieldValue.PhoneNumber": {
      /** @enum {string} */
      fieldType: "PHONE_NUMBER";
      fieldName: string;
      value: string;
    };
    "CustomFieldValue.Caregiver": {
      /** @enum {string} */
      fieldType: "CAREGIVER";
      fieldName: string;
      value: components["schemas"]["CaregiverId"];
    };
    "CustomFieldValue.Patient": {
      /** @enum {string} */
      fieldType: "PATIENT";
      fieldName: string;
      value: components["schemas"]["PatientId"];
    };
    "CustomFieldValue.Boolean": {
      /** @enum {string} */
      fieldType: "BOOLEAN";
      fieldName: string;
      value: boolean;
    };
    "CustomFieldValue.Enum": {
      /** @enum {string} */
      fieldType: "ENUM";
      fieldName: string;
      value: string;
    };
    CaregiverListPhoneNumber: {
      /** @description As stored, in E.164. */
      number: string;
      /** @description As a person reads it: `+1 (211) 311 4111`. Also what the search index holds. */
      formatted: string;
    };
    CaregiverListOffice: {
      id: components["schemas"]["OfficeId"];
      name: string;
    };
    CaregiverListBranch: {
      id: components["schemas"]["AgencyBranchId"];
      name: string;
    };
    CaregiverListCreatedBy: {
      firstName: string;
      lastName: string;
    };
    PatientListItem: {
      id: components["schemas"]["PatientId"];
      displayId: null | number;
      firstName: string;
      middleName: null | string;
      lastName: string;
      gender: null | string;
      address: null | string;
      homePhoneNumber: null | string;
      mobilePhoneNumber: null | string;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      startOfCare: components["schemas"]["LocalDate"] | null;
      admissionId: null | string;
      status: components["schemas"]["PatientStatus"];
      /**
       * @description When the current status took effect, falling back to the creation date.
       * Read from Postgres, so this is always today's answer even where the index
       * used for ordering has not caught up — see `effectiveDate` in the index.
       */
      effectiveDate: components["schemas"]["LocalDate"] | null;
      currentOffice: components["schemas"]["PatientListOffice"] | null;
      agencyTeam: components["schemas"]["PatientListAgencyTeam"] | null;
      assignedCoordinator: components["schemas"]["PatientListPerson"] | null;
      /** @description The patient's currently active contracts, one row per contract. */
      contracts: components["schemas"]["PatientListContract"][];
      customFields: components["schemas"]["EntityCustomField"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["PatientListPerson"] | null;
    };
    /**
     * @description The status of a Patient within a specific Agency
     * @enum {string}
     */
    PatientStatus:
      | "ACCEPTED"
      | "ACTIVE"
      | "DECEASED"
      | "DISCHARGED"
      | "DRAFT"
      | "ELIGIBLE"
      | "HOSPITALIZED"
      | "LOST"
      | "ON_HOLD"
      | "PENDING_FILES"
      | "REFERRAL"
      | "VACATION";
    PatientListOffice: {
      id: components["schemas"]["OfficeId"];
      name: string;
    };
    PatientListAgencyTeam: {
      id: components["schemas"]["AgencyTeamId"];
      name: string;
    };
    /** Format: AgencyTeamId */
    AgencyTeamId: AgencyTeamId;
    PatientListPerson: {
      id: components["schemas"]["AgencyMemberId"];
      firstName: string;
      lastName: string;
    };
    /**
     * @description One active contract. `memberId` and `medicaidNumber` are shown as their own
     * columns, so they travel with the contract they belong to rather than being
     * flattened into two unrelated lists.
     */
    PatientListContract: {
      id: components["schemas"]["PatientContractId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      contractTypeName: string;
      memberId: null | string;
      medicaidNumber: null | string;
    };
    /** Format: PatientContractId */
    PatientContractId: PatientContractId;
    /** Format: ContractTypeId */
    ContractTypeId: ContractTypeId;
    AgencyTeam: {
      id: components["schemas"]["AgencyTeamId"];
      name: string;
      /** Format: AgencyMemberId */
      teamLeader?: AgencyMemberId;
      teamMembers: components["schemas"]["AgencyMemberId"][];
      active: boolean;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      hasCasesNotDischarged?: boolean;
    };
    Caregiver: {
      id: components["schemas"]["CaregiverId"];
      status: components["schemas"]["CaregiverStatus"];
      caregiverCode: null | string;
      officeIds: components["schemas"]["OfficeId"][];
      officeNames?: string[];
      branchIds: components["schemas"]["AgencyBranchId"][];
      branchNames?: string[];
      caregiverBranch?: null | string;
      workAreaPreference?: null | string;
      createdAt: components["schemas"]["Instant"];
      /** Format: date-time */
      birthDate: null | string;
      birthDateDate: components["schemas"]["LocalDate"] | null;
      phoneNumber: string;
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      homePhone: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      /** @description "M", "F" */
      gender: string;
      /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      address: string;
      address2: null | string;
      isCustomAddress: boolean;
      addressCounty: null | string;
      addressGeoLocation: components["schemas"]["Geo"];
      addressComponents?: components["schemas"]["AddressComponents"] | null;
      missingAddressFields?: string[];
      certifications: components["schemas"]["CaregiverCertification"][];
      certificationNames?: string[];
      agencyAssocCreatedByAgencyMemberName?: null | string;
      agencyAssocCreatedByCaregiverName?: null | string;
      photoUrl: null | string;
      photoUrlOriginal: null | string;
      installedUserAgent: null | string;
      appInstalledDate: components["schemas"]["Instant"] | null;
      appInstalled: boolean;
      appInstalledAt: components["schemas"]["Instant"][];
      appUninstalledAt: components["schemas"]["Instant"][];
      /** @description Is the caregiver's app currently open */
      online: boolean;
      /** @description When was the last time the caregiver was online? */
      lastSeen: components["schemas"]["Instant"] | null;
      notificationSettings?: components["schemas"]["NotificationSettings"];
      email: null | string;
      isFullTime: boolean;
      hireDate: components["schemas"]["LocalDate"] | null;
      rehireDate: components["schemas"]["LocalDate"] | null;
      terminationDate: components["schemas"]["LocalDate"] | null;
      isCompliant: boolean;
      stateRegistryNum: null | number;
      isClockEnabled: boolean;
      ssn: null | string;
      applicationStartDate: components["schemas"]["LocalDate"] | null;
      lastWorkDate: components["schemas"]["LocalDate"] | null;
      firstWorkDate: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      externalId: null | string;
      customFields: components["schemas"]["EntityCustomField"];
      blacklisted: components["schemas"]["PatientId"][] | null;
      emergencyContacts: components["schemas"]["CaregiverEmergencyContact"][];
      nextStatus?:
        | (
            | "ACTIVE"
            | "JOIN_REQUEST"
            | "ON_HOLD"
            | "ON_LEAVE"
            | "PENDING"
            | "QUIT"
            | "REJECTED"
            | "SUSPENDED"
            | "TERMINATED"
          )
        | null;
      nextStatusEffectiveDate?: components["schemas"]["LocalDate"] | null;
      isFromLandingPage: boolean;
      mainLanguage: string;
      glovesSize?: ("L" | "M" | "S" | "XL") | null;
      scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
      agencyIds?: components["schemas"]["AgencyId"][];
    };
    CaregiverPhoneNumber: {
      phoneNumber: string;
      /** @enum {string} */
      type: "landline" | "mobile" | "unknown";
    };
    NotificationSettings: {
      receiveVisitNotifications: boolean;
    };
    CaregiverEmergencyContact: {
      name: string;
      relationship: string;
      livesWithPatient: null | boolean;
      phone1: string;
      phone2: string;
      address: string;
    };
    CaregiverDictEntry: components["schemas"]["Caregiver"] &
      components["schemas"]["DisplayNameField"];
    DisplayNameField: {
      displayName: string;
    };
    CaregiverDict2: {
      [key: string]: components["schemas"]["CaregiverDict2Entry"];
    };
    CaregiverDict2Entry: components["schemas"]["CaregiverProfile"] &
      components["schemas"]["DisplayNameField"];
    CaregiverProfile: {
      officeBranchIds: components["schemas"]["OfficeBranchId"][];
      agencyAssocCreatedAt: components["schemas"]["Instant"];
      agencyAssocCreatedByAgencyMemberId:
        | components["schemas"]["AgencyMemberId"]
        | null;
      agencyAssocCreatedByCaregiverId:
        | components["schemas"]["CaregiverId"]
        | null;
      agencyAssocUpdatedAt: components["schemas"]["Instant"] | null;
      agencyAssocUpdatedByAgencyMemberId:
        | components["schemas"]["AgencyMemberId"]
        | null;
      agencyAssocUpdatedByCaregiverId:
        | components["schemas"]["CaregiverId"]
        | null;
      /**
       * @description Denormalised so the profile page can label "created/updated by" without a
       * dictionary of every caregiver.
       */
      agencyAssocCreatedByCaregiverName: null | string;
      agencyAssocUpdatedByCaregiverName: null | string;
      isEmailVerified: null | boolean;
      isTestUser: boolean;
      authenticareWorkerId: null | string;
      employmentType: null | string;
      /**
       * @description New York Home Care Worker ID, scoped to this agency. Distinct from
       * `stateRegistryNum`, which is a different identifier on the shared
       * caregiver record.
       */
      hcwId: null | string;
      id: components["schemas"]["CaregiverId"];
      status: components["schemas"]["CaregiverStatus"];
      caregiverCode: null | string;
      officeIds: components["schemas"]["OfficeId"][];
      officeNames?: string[];
      branchIds: components["schemas"]["AgencyBranchId"][];
      branchNames?: string[];
      caregiverBranch?: null | string;
      workAreaPreference?: null | string;
      createdAt: components["schemas"]["Instant"];
      /** Format: date-time */
      birthDate: null | string;
      birthDateDate: components["schemas"]["LocalDate"] | null;
      phoneNumber: string;
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      homePhone: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      /** @description "M", "F" */
      gender: string;
      /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      address: string;
      address2: null | string;
      isCustomAddress: boolean;
      addressCounty: null | string;
      addressGeoLocation: components["schemas"]["Geo"];
      addressComponents?: components["schemas"]["AddressComponents"] | null;
      missingAddressFields?: string[];
      certifications: components["schemas"]["CaregiverCertification"][];
      certificationNames?: string[];
      agencyAssocCreatedByAgencyMemberName?: null | string;
      photoUrl: null | string;
      photoUrlOriginal: null | string;
      installedUserAgent: null | string;
      appInstalledDate: components["schemas"]["Instant"] | null;
      appInstalled: boolean;
      appInstalledAt: components["schemas"]["Instant"][];
      appUninstalledAt: components["schemas"]["Instant"][];
      /** @description Is the caregiver's app currently open */
      online: boolean;
      /** @description When was the last time the caregiver was online? */
      lastSeen: components["schemas"]["Instant"] | null;
      notificationSettings?: components["schemas"]["NotificationSettings"];
      email: null | string;
      isFullTime: boolean;
      hireDate: components["schemas"]["LocalDate"] | null;
      rehireDate: components["schemas"]["LocalDate"] | null;
      terminationDate: components["schemas"]["LocalDate"] | null;
      isCompliant: boolean;
      stateRegistryNum: null | number;
      isClockEnabled: boolean;
      ssn: null | string;
      applicationStartDate: components["schemas"]["LocalDate"] | null;
      lastWorkDate: components["schemas"]["LocalDate"] | null;
      firstWorkDate: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      externalId: null | string;
      customFields: components["schemas"]["EntityCustomField"];
      blacklisted: components["schemas"]["PatientId"][] | null;
      emergencyContacts: components["schemas"]["CaregiverEmergencyContact"][];
      nextStatus?:
        | (
            | "ACTIVE"
            | "JOIN_REQUEST"
            | "ON_HOLD"
            | "ON_LEAVE"
            | "PENDING"
            | "QUIT"
            | "REJECTED"
            | "SUSPENDED"
            | "TERMINATED"
          )
        | null;
      nextStatusEffectiveDate?: components["schemas"]["LocalDate"] | null;
      isFromLandingPage: boolean;
      mainLanguage: string;
      glovesSize?: ("L" | "M" | "S" | "XL") | null;
      scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
      agencyIds?: components["schemas"]["AgencyId"][];
    };
    CoordinatorActivity: {
      agencyMemberId: components["schemas"]["AgencyMemberId"];
      broadcast: number;
      scheduled: number;
      unstaffed: number;
      cancelledByCaregiver: number;
      cancelled: number;
      awaitingAssignment: number;
      changes: number;
    };
    AgencyNoteCreateParams: {
      noteRichText: null | string;
      /** Format: PatientId */
      patientId?: PatientId;
      patientIds?: components["schemas"]["PatientId"][];
      /** Format: CaregiverId */
      caregiverId?: CaregiverId;
      caregiverIds?: components["schemas"]["CaregiverId"][];
      agencyMemberIds?: components["schemas"]["AgencyMemberId"][];
      /** Format: NoteSubjectId */
      subject?: NoteSubjectId;
      /** Format: CommCenterTicketId */
      commCenterTicketId?: CommCenterTicketId;
      status: string;
      followUp?: components["schemas"]["LocalDate"] | null;
      /** Format: VisitInstanceId */
      visitInstanceId?: VisitInstanceId;
      notePredefinedAnswerId?:
        | components["schemas"]["NotePredefinedAnswerId"]
        | null;
      noteType: components["schemas"]["NoteTypes"];
      /** Format: yyyy-MM-dd */
      calendarDate?: LocalDate;
      base64File?: string;
      /** Format: VisitAssignmentId */
      visitAssignmentId?: VisitAssignmentId;
    };
    /** Format: NotePredefinedAnswerId */
    NotePredefinedAnswerId: NotePredefinedAnswerId;
    /** @enum {string} */
    NoteTypes:
      | "adjustment_approval"
      | "agency_member_remove_task_visit"
      | "bulk"
      | "calendar"
      | "caregiver_absence"
      | "caregiver_exclusion"
      | "caregiver_pto"
      | "caregiver_remove_task_visit"
      | "caregiver_status_change"
      | "missed_visit_instance"
      | "patient_authorization"
      | "patient_status"
      | "phone_call"
      | "profile_note"
      | "removed_task"
      | "visit_assignment_note"
      | "visit_distance_approval"
      | "visit_instance"
      | "visit_instance_caregiver_unassign"
      | "visit_instance_edit"
      | "visit_manual_clock_time"
      | "visit_manual_remove";
    /** Format: VisitBroadcastId */
    VisitBroadcastId: VisitBroadcastId;
    PermanentFlexibleHoursAndDaysPerWeek: {
      /** @enum {string} */
      type: "PermanentFlexibleHoursAndDaysPerWeek";
      daysToChooseFrom: components["schemas"]["DayOfWeek"][];
      excludedDaysFromCaregivers: components["schemas"]["DayOfWeek"][];
      amountOfHoursPerWeek: number;
      minHoursPerShift: number;
      maxHoursPerShift: number;
    };
    /** Format: MONDAY */
    DayOfWeek: string;
    PermanentFlexibleHoursAndDaysPattern: {
      /** @enum {string} */
      type: "PermanentFlexibleHoursAndDaysPattern";
      daysToChooseFrom: components["schemas"]["DayOfWeek"][];
      excludedDaysFromCaregivers: components["schemas"]["DayOfWeek"][];
      flexibleDetails: {
        amountOfDays: number;
        amountOfHours: number;
      }[];
    };
    PermanentFlexibleHoursFixedDaysPattern: {
      /** @enum {string} */
      type: "PermanentFlexibleHoursFixedDaysPattern";
      details: {
        day: components["schemas"]["DayOfWeek"];
        amountOfHours: number;
      }[];
      excludedDaysFromCaregivers: components["schemas"]["DayOfWeek"][];
    };
    PermanentFlexibleHoursFixedDaysPerWeek: {
      /** @enum {string} */
      type: "PermanentFlexibleHoursFixedDaysPerWeek";
      amountOfHoursPerWeek: number;
      days: components["schemas"]["DayOfWeek"][];
      excludedDaysFromCaregivers: components["schemas"]["DayOfWeek"][];
      minHoursPerShift: number;
      maxHoursPerShift: number;
    };
    PermanentFixedHoursFlexibleDays: {
      /** @enum {string} */
      type: "PermanentFixedHoursFlexibleDays";
      daysToChooseFrom: {
        day: components["schemas"]["DayOfWeek"];
        startTime: components["schemas"]["LocalTime"];
        endTime: components["schemas"]["LocalTime"];
      }[];
      amountOfDays: number;
      excludedDaysFromCaregivers: components["schemas"]["DayOfWeek"][];
    };
    /** Format: HH:mm:ss.SSS */
    LocalTime: LocalTime;
    SingleFlexible: {
      /** @enum {string} */
      type: "SingleFlexible";
      date: components["schemas"]["LocalDate"];
      amountOfHours: number;
      excludedDaysFromCaregivers: components["schemas"]["DayOfWeek"][];
    };
    NotBroadcastedToCaregiverReason:
      | components["schemas"]["AddressNotInRange"]
      | components["schemas"]["GenderDoesNotMatch"]
      | components["schemas"]["CaregiverNotAvailableForNonFlexibleVisit"]
      | components["schemas"]["CaregiverHasOverlappingVisits"]
      | components["schemas"]["CaregiverMarkedVisitAsNotInterested"]
      | components["schemas"]["VisitNotInCaregiverAvailabilityMaxDistance"]
      | components["schemas"]["CaregiverStatusDoesNotMatch"]
      | components["schemas"]["CaregiverInOnboardingProcess"]
      | components["schemas"]["CertificationsDoNotMatch"]
      | components["schemas"]["LanguagesDoNotMatch"]
      | components["schemas"]["ExcludedReasonForMultipleCaregiversAllShiftsExcluded"]
      | components["schemas"]["ExcludedReasonForMultipleCaregiversPartOfVisit"]
      | components["schemas"]["CaregiverUnavailableForMoreThanRequiredShifts"]
      | components["schemas"]["CaregiverUnavailableForAtLeastOneShift"]
      | components["schemas"]["CaregiverIsUnavailableForMoreThanVisitWeeklyHours"]
      | components["schemas"]["CaregiverHasAtLeastOneOverlappingVisits"]
      | components["schemas"]["CaregiverHasMoreOverlappingVisitsThenRequiredShifts"]
      | components["schemas"]["ExcludedShiftsByAvailabilityReason"]
      | components["schemas"]["CaregiverNotAvailableForEveryShiftOfNotFlexibleVisit"];
    AddressNotInRange: {
      /** @enum {string} */
      type: "AddressNotInRange";
      /** @enum {string} */
      description: "The caregivers's address is not in visit's distance range.";
      visitAddress: string;
      caregiverAddress: string;
      maxDistanceLimitation: null | number;
      caregiverDistanceFromVisit: number;
    };
    GenderDoesNotMatch: {
      /** @enum {string} */
      type: "GenderDoesNotMatch";
      /** @enum {string} */
      description: "The caregivers's gender doesn't match the patient's gender preference.";
      caregiverGender: string;
      visitGender: ("F" | "M") | null;
    };
    CaregiverNotAvailableForNonFlexibleVisit: {
      /** @enum {string} */
      type: "CaregiverNotAvailableForNonFlexibleVisit";
      /** @enum {string} */
      description: "The caregiver is not available for enough of the visit's instances overall. Either because of overlapping vists or because of their availability settings.";
      caregiverAvailability: components["schemas"]["CaregiverAvailability"];
      additionalInfo?: string;
    };
    /** @description when is the caregiver available, and to which visits */
    CaregiverAvailability: {
      dayAvailabilities: components["schemas"]["DayAvailability"][];
      /** @description in miles */
      maxDistance: number;
      /** @description in hours */
      minDuration: number;
      /** @description in hours, between 1 and 24 */
      maxDuration: number;
    };
    /** @description when is the caregiver available during each day */
    DayAvailability: {
      /** @description 0 = sunday, 1 = monday, ... , 6 = saturday */
      day: number;
      /** @description 24-hour time */
      startHour: number;
      /** @description 24-hour time */
      endHour: number;
      busyAllDay: boolean;
    };
    CaregiverHasOverlappingVisits: {
      /** @enum {string} */
      type: "CaregiverHasOverlappingVisits";
      /** @enum {string} */
      description: "The caregiver has overlapping visits that conflicts with more than the required amount of days (has more than 10h of work per overlapping day, or overlapps directly with the visit's hours).";
      overlappingInstancesVisitIds: components["schemas"]["VisitInstanceId"][];
      overlappingDays: components["schemas"]["DayOfWeek"][];
      additionalInfo?: string;
    };
    /** Format: VisitInstanceId */
    VisitInstanceId: VisitInstanceId;
    CaregiverMarkedVisitAsNotInterested: {
      /** @enum {string} */
      type: "CaregiverMarkedVisitAsNotInterested";
      /** @enum {string} */
      description: "The caregiver chose to dismiss this visit from the app (clicked on 'not interested' below the request button).";
      additionalInfo?: string;
    };
    VisitNotInCaregiverAvailabilityMaxDistance: {
      /** @enum {string} */
      type: "VisitNotInCaregiverAvailabilityMaxDistance";
      /** @enum {string} */
      description: "The visit is outside of the max distance configured in his availability settings.";
      caregiverMaxDistanceAvailabilitySetting: number;
      visitsAddress: string;
      caregiverDistanceFromVisit: number;
      additionalInfo?: string;
    };
    CaregiverStatusDoesNotMatch: {
      /** @enum {string} */
      type: "CaregiverStatusDoesNotMatch";
      /** @enum {string} */
      description: "The caregiver is in a status that doesn't allow him to see broadcasts.";
      caregiverStatus: components["schemas"]["CaregiverStatus"];
    };
    CaregiverInOnboardingProcess: {
      /** @enum {string} */
      type: "CaregiverInOnboarding";
      /** @enum {string} */
      description: "The caregiver is currently in onboarding processs.";
    };
    CertificationsDoNotMatch: {
      /** @enum {string} */
      type: "CertificationsDoNotMatch";
      /** @enum {string} */
      description: "The caregiver's certifications do not match with the visit's certifications.";
      caregiverCertifications: components["schemas"]["CaregiverCertification"][];
      visitCertifications: components["schemas"]["CaregiverCertification"][];
    };
    LanguagesDoNotMatch: {
      /** @enum {string} */
      type: "LanguagesDoNotMatch";
      /** @enum {string} */
      description: "The caregiver's languages do not match with the visit's languages.";
      caregiverMainLanguage: string;
      caregiverLanguages: string[];
      patientMainLanguage: string;
      visitLanguages: string[];
    };
    ExcludedReasonForMultipleCaregiversAllShiftsExcluded: {
      /** @enum {string} */
      description: "Caregiver has overlapping shifts or is unavailable (through the availability settings in the app) for the entire visit.";
      /** @enum {string} */
      type: "ExcludedReasonForMultipleCaregiversAllShiftsExcluded";
      /** @enum {boolean} */
      areAllShiftsExcluded: true;
      excludedShifts: components["schemas"]["ExcludedShiftsReason"][];
    };
    ExcludedShiftsReason: {
      shiftDayOfWeek: components["schemas"]["DayOfWeek"];
      excludedFor: components["schemas"]["MultipleCaregiversShiftExcludedForReason"][];
    };
    /** @enum {string} */
    MultipleCaregiversShiftExcludedForReason:
      | "AvailabilitySettings"
      | "OverlappingVisits"
      | "PotentiallyOverworking";
    ExcludedReasonForMultipleCaregiversPartOfVisit: {
      /** @enum {string} */
      type: "ExcludedReasonForMultipleCaregiversPartOfVisit";
      /** @enum {string} */
      description: "Caregiver has overlapping shifts or is unavailable (through the availability settings in the app) for the a part of the visit.";
      /** @enum {boolean} */
      areAllShiftsExcluded: false;
      excludedShifts: components["schemas"]["ExcludedShiftsReason"][];
    };
    CaregiverUnavailableForMoreThanRequiredShifts: {
      /** @enum {string} */
      type: "CaregiverUnavailableForMoreThanRequiredShifts";
      /** @enum {string} */
      description: "The caregiver is either unavailable (through the availability settings in the app) for the shift's exact time, or for the amount of hours he should choose, for more shifts than the required amount in this visit.";
      unavailableShiftsDays: components["schemas"]["DayOfWeek"][];
      numOfRequiredShifts: number;
    };
    CaregiverUnavailableForAtLeastOneShift: {
      /** @enum {string} */
      type: "CaregiverUnavailableForAtLeastOneShift";
      /** @enum {string} */
      description: "The caregiver is either unavailable (through the availability settings in the app) for the shift's exact time, or for the amount of hours he should choose.";
      unavailableShiftsDays: components["schemas"]["DayOfWeek"][];
    };
    CaregiverIsUnavailableForMoreThanVisitWeeklyHours: {
      /** @enum {string} */
      type: "CaregiverIsUnavailableForMoreThanVisitWeeklyHours";
      /** @enum {string} */
      description: "The caregiver isn't available for the amount of hours neccessary in a week for this visit.";
      weeklyHoursRequired: number;
    };
    CaregiverHasAtLeastOneOverlappingVisits: {
      /** @enum {string} */
      type: "CaregiverHasAtLeastOneOverlappingVisits";
      /** @enum {string} */
      description: "The caregiver has overlapping visits, or will be overworked (more than 10h a shift) for at least one shift of this visit.";
      overlappingShiftsDays: components["schemas"]["DayOfWeek"][];
    };
    CaregiverHasMoreOverlappingVisitsThenRequiredShifts: {
      /** @enum {string} */
      type: "CaregiverHasMoreOverlappingVisitsThenRequiredShifts";
      /** @enum {string} */
      description: "The caregiver has overlapping visits, or will be overworked (more than 10h a shift) in a number of shifts that exceeds the number of the required days.";
      overlappingShiftsDays: components["schemas"]["DayOfWeek"][];
      numOfRequiredShifts: number;
    };
    ExcludedShiftsByAvailabilityReason: {
      /** @enum {string} */
      type: "ExcludedShiftsByAvailabilityReason";
      /** @enum {string} */
      description: "Caregivers have shifts that won't be presented to them in the app, because they are not available for them (through availability settings in the app).";
      excludedShifts: components["schemas"]["DayOfWeek"][];
    };
    CaregiverNotAvailableForEveryShiftOfNotFlexibleVisit: {
      /** @enum {string} */
      type: "CaregiverNotAvailableForEveryShiftOfNotFlexibleVisit";
      /** @enum {string} */
      description: "The caregiver is not available for each shift of the visit. Either because of overlapping visits, or because of their availability settings.";
      caregiverAvailability: components["schemas"]["CaregiverAvailability"];
      additionalInfo?: string;
    };
    AgencyMember: {
      id: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
      agencyAdmin: boolean;
      jobTitle: string;
      email: null | string;
      firstName: string;
      lastName: string;
      photoUrl: null | string;
      status: string;
      supervisor: components["schemas"]["AgencyMemberId"] | null;
      officeIds: components["schemas"]["OfficeId"][];
      agencyRoles: string[];
      isUserLoginBlocked?: boolean;
      settings?: components["schemas"]["AgencyMemberSettings"];
      agencyMemberIpSecuritySettings: components["schemas"]["AgencyMemberIpSecuritySettings"];
      pocPermissions: boolean;
      timezone?: string;
      hasCasesNotDischarged?: boolean;
    };
    AgencyMemberSettings: {
      email: {
        sendEmailOnCaregiverJoinRequest: null | boolean;
        sendEmailOnCaregiverHRPending: null | boolean;
        sendEmailUnreadChatReminder: null | boolean;
        sendEmailVisitAwaitingAssignment: null | boolean;
        sendEmailFileUploaded: null | boolean;
        sendEmailRNFiles: null | boolean;
        sendEmailRNGeneralUploads: null | boolean;
        sendEmailDutySheets: null | boolean;
        sendEmailPlanOfCare: null | boolean;
        sendEmailHRFiles: null | boolean;
        sendEmailInService: null | boolean;
        sendEmailNewCommCenterMessage: null | boolean;
        sendPushNewCommCenterMessage: null | boolean;
        sendEmailNewAssignedTicket: null | boolean;
        sendPushNewAssignedTicket: null | boolean;
        sendEmailNoteAssigned: null | boolean;
        sendPushNoteAssigned: null | boolean;
        sendEmailNewSMSMessage: null | boolean;
        sendPushNewSMSMessage: null | boolean;
        sendEmailNewEmailMessage: null | boolean;
        sendPushNewEmailMessage: null | boolean;
      };
    };
    AgencyMemberIpSecuritySettings:
      | components["schemas"]["IpSecuritySettings.Open"]
      | components["schemas"]["IpSecuritySettings.WhitelistOnly"]
      | components["schemas"]["IpSecuritySettings.UserNoRestriction"];
    "IpSecuritySettings.Open": {
      /** @enum {string} */
      type: "Open";
    };
    "IpSecuritySettings.WhitelistOnly": {
      /** @enum {string} */
      type: "WhitelistOnly";
      ipAddressesWhitelist: string[];
    };
    "IpSecuritySettings.UserNoRestriction": {
      /** @enum {string} */
      type: "UserNoRestriction";
    };
    AgencyIpSecuritySettings:
      | components["schemas"]["IpSecuritySettings.Open"]
      | components["schemas"]["IpSecuritySettings.WhitelistOnly"];
    DashboardStatuses: {
      active: number;
      pending: number;
      on_hold: number;
      on_leave: number;
      suspended: number;
      terminated: number;
    };
    DashboardOnline: {
      day: number;
      week: number;
      month: number;
    };
    DashboardInstalls: {
      installed: number;
      unInstalled: number;
      not_installed: number;
    };
    DashboardCaregiver: {
      id: components["schemas"]["CaregiverId"];
      firstName: string;
      photoUrl: null | string;
    };
    /** Format: PlanOfCareItemId */
    PlanOfCareItemId: PlanOfCareItemId;
    GlobalSearchPatientResult: {
      id: components["schemas"]["PatientId"];
      firstName: string;
      middleName: null | string;
      lastName: string;
      address: null | string;
      phoneNumbers: string[];
      phoneNumbersExtended: components["schemas"]["GlobalSearchPatientPhoneNumber"][];
      ssn: null | string;
      displayId: null | number;
      officeName: string;
      memberId: null | string;
      gender: null | string;
      medicaIDNumber: null | string;
      medicareNumber: null | string;
      status: components["schemas"]["PatientStatus"];
      familyInfo: components["schemas"]["PatientFamilyInformation"][];
      email: null | string;
    };
    GlobalSearchPatientPhoneNumber: {
      phoneNumber: string;
      /** @enum {string} */
      type: "landline" | "mobile" | "unknown";
    };
    PatientFamilyInformation: {
      firstName: string;
      lastName: string;
      relationship: string;
      mobilePhoneNumber: string;
      homePhoneNumber: string;
    };
    GlobalSearchCaregiverResult: {
      id: components["schemas"]["CaregiverId"];
      firstName: string;
      middleName: null | string;
      lastName: string;
      address: string;
      email: null | string;
      gender: string;
      phoneNumbers: string[];
      phoneNumbersExtended: components["schemas"]["CaregiverPhoneNumber"][];
      displayId: null | number;
      officeNames: string[];
      photoUrl: null | string;
      ssn: null | string;
      status: components["schemas"]["CaregiverStatus"];
    };
    GlobalSearchVisitResult: {
      id: components["schemas"]["VisitBroadcastId"];
    };
    GlobalSearchInvoiceResult: {
      id: components["schemas"]["InvoiceId"];
      displayId: string;
    };
    /** Format: InvoiceId */
    InvoiceId: InvoiceId;
    AgencyMembersUserId: {
      userId: components["schemas"]["UserId"];
      agencyMemberId: components["schemas"]["AgencyMemberId"];
    };
    /** Format: UserId */
    UserId: UserId;
    AgencyCertificationSetting: {
      certification: components["schemas"]["CaregiverCertification"];
      isActive: boolean;
    };
    HRSectionStage: {
      id: components["schemas"]["HRSectionStageId"];
      agencyId: components["schemas"]["AgencyId"];
      label: string;
      order: number;
      labelColor: string;
      certification: components["schemas"]["CaregiverCertification"];
    };
    /** Format: HRSectionStageId */
    HRSectionStageId: HRSectionStageId;
    AgencyBillingPaymentMethod: {
      id: string;
      brand: null | string;
      last4: null | string;
      expMonth: null | number;
      expYear: null | number;
      type: string;
    };
    Allergy: {
      id: components["schemas"]["AllergyId"];
      name: string;
    };
    /** Format: AllergyId */
    AllergyId: AllergyId;
    string: string;
    /** @enum {string} */
    AgencyMemberPermission:
      | "add_caregiver"
      | "add_new_users"
      | "add_note_subject"
      | "add_patient"
      | "add_patient_page_plan_of_care"
      | "allow_download_notes_pdf"
      | "allow_patient_page_new_visit"
      | "allow_visit_instance_adjustment_approve"
      | "allow_visit_instance_adjustment_ignore"
      | "allow_visit_instance_adjustment_reject"
      | "assign_inactive_caregiver_to_visits"
      | "assign_workflow_task"
      | "caregivers_page_allow_add_caregivers"
      | "caregivers_page_allow_boost"
      | "change_user_roles"
      | "cosign_visit_daily_note_attestation"
      | "create/delete_caregiver_absence"
      | "create/edit/delete_advanced_reports"
      | "create_new_patient_visit"
      | "create_new_ticket_communication_center"
      | "delete_bulk_visits"
      | "delete_invoice"
      | "delete_notes"
      | "delete_patient_visit"
      | "delete_visit_from_invoice"
      | "edit_administrative_payment_invoice"
      | "edit_banked_minutes"
      | "edit_billed_visit_instance_contract_replacement"
      | "edit_billed_visit_instance_info"
      | "edit_bulk_visits"
      | "edit_caregiver_compliance"
      | "edit_caregiver_direct_deposit_information"
      | "edit_caregiver_hours_overrides"
      | "edit_caregiver_hours_restrictions"
      | "edit_caregiver_is_test_user"
      | "edit_caregiver_page_about_details"
      | "edit_caregiver_page_emergency"
      | "edit_caregiver_page_pay_rates"
      | "edit_caregiver_page_payroll_tax"
      | "edit_caregiver_status"
      | "edit_cico_issues_visits"
      | "edit_invoice"
      | "edit_new_patient_note"
      | "edit_new_patient_task"
      | "edit_new_patient_vacation"
      | "edit_notes"
      | "edit_paid_visit_instance_info"
      | "edit_patient_blood_pressure"
      | "edit_patient_cost_share"
      | "edit_patient_is_test_user"
      | "edit_patient_page_authorizations"
      | "edit_patient_page_authorizations_with_billed_visits"
      | "edit_patient_page_authorizations_with_paid_visits"
      | "edit_patient_page_calendar"
      | "edit_patient_page_cdsc_import"
      | "edit_patient_page_contracts"
      | "edit_patient_page_diagnosis_codes"
      | "edit_patient_page_documents"
      | "edit_patient_page_emergency"
      | "edit_patient_page_information"
      | "edit_patient_page_medical_info"
      | "edit_patient_page_medication_profile"
      | "edit_patient_page_pay_rates"
      | "edit_patient_page_plan_of_care"
      | "edit_patient_page_summary_details"
      | "edit_patient_page_vbp"
      | "edit_patient_physicians"
      | "edit_patient_task_scheduled_date"
      | "edit_patient_visit"
      | "edit_plan_of_care_items"
      | "edit_teams"
      | "edit_ticket_communication_center"
      | "edit_visit_instance_billing_authorization"
      | "edit_visit_instance_billing_payroll"
      | "edit_visit_instance_caregiver_replacement"
      | "edit_visit_instance_caregiver_tasks"
      | "edit_visit_instance_caregiver_with_overtime"
      | "edit_visit_instance_general_info"
      | "edit_visit_instance_on_payroll_draft"
      | "edit_workers_credentials"
      | "export_administrative_payment_invoice"
      | "export_invoice"
      | "is_rn"
      | "manage_advanced_reports_settings"
      | "manage_daily_note_licenses"
      | "manage_standard_reports_settings"
      | "manage_workflow_skills"
      | "patient_page_delete_authorization"
      | "patient_page_run_authorization_allocation"
      | "patient_page_run_authorization_allocation_full"
      | "perform_workflow_task"
      | "resubmit_evv_records"
      | "review_caregiver_compliance_document"
      | "run_eligibility_check_for_patient"
      | "send_compliance_reminders"
      | "service_plan_import_edit"
      | "show_caregiver_ssn"
      | "show_patient_ssn"
      | "sign_visit_daily_note_attestation"
      | "skip_workflow_task"
      | "unassign_workflow_task"
      | "unexport_invoice"
      | "upload_authorizations"
      | "use_ai_search"
      | "use_beta_profile_window"
      | "use_caregiver_memory_improvements"
      | "use_patient_memory_improvements"
      | "view_admin_section"
      | "view_admin_section_billing"
      | "view_admin_section_flyers"
      | "view_admin_section_hr"
      | "view_admin_section_members"
      | "view_admin_section_notes"
      | "view_admin_section_patient_documents"
      | "view_admin_section_settings"
      | "view_admin_section_training"
      | "view_agencies_section"
      | "view_agencies_section_customer_engagement"
      | "view_agencies_section_engagement_kpi"
      | "view_analytics_section"
      | "view_authorization_utilization"
      | "view_billing_section"
      | "view_billing_section_835_edi"
      | "view_billing_section_837_edi"
      | "view_billing_section_adjustment_approvals"
      | "view_billing_section_administrative_payment"
      | "view_billing_section_administrative_payment_invoices"
      | "view_billing_section_ar"
      | "view_billing_section_banked_minutes"
      | "view_billing_section_billable_visits"
      | "view_billing_section_billing_review"
      | "view_billing_section_checks"
      | "view_billing_section_exports"
      | "view_billing_section_invoices"
      | "view_billing_section_visit_with_issues"
      | "view_billing_section_visits_to_export"
      | "view_calls_section"
      | "view_calls_section_maintenance"
      | "view_calls_section_missed_both"
      | "view_calls_section_missed_in"
      | "view_calls_section_missed_out"
      | "view_calls_section_rejected"
      | "view_caregiver_direct_deposit_information"
      | "view_caregiver_page_about"
      | "view_caregiver_page_application"
      | "view_caregiver_page_assigned_tasks"
      | "view_caregiver_page_assigned_visits"
      | "view_caregiver_page_attendance"
      | "view_caregiver_page_availability"
      | "view_caregiver_page_calendar"
      | "view_caregiver_page_compliance"
      | "view_caregiver_page_documents"
      | "view_caregiver_page_emergency"
      | "view_caregiver_page_pay_rates"
      | "view_caregiver_page_payroll"
      | "view_caregiver_page_payroll_tax"
      | "view_caregiver_page_recent_activity"
      | "view_caregiver_page_status_review"
      | "view_caregiver_page_training_center"
      | "view_caregiver_page_visits_broadcasted"
      | "view_caregiver_profile"
      | "view_caregiver_search_result"
      | "view_caregivers_section"
      | "view_caregivers_section_availability_issues"
      | "view_caregivers_section_compliance"
      | "view_caregivers_section_list"
      | "view_caregivers_section_passport"
      | "view_caregivers_section_pending_acceptance"
      | "view_caregivers_section_pending_application"
      | "view_caregivers_section_pto_approvals"
      | "view_caregivers_section_training_overview"
      | "view_cico_issues_visits"
      | "view_communication_center"
      | "view_communication_section"
      | "view_covid_section"
      | "view_dashboard_section"
      | "view_dashboard_section_caregivers"
      | "view_dashboard_section_coordinator"
      | "view_dashboard_section_installations"
      | "view_dashboard_section_online"
      | "view_dashboard_section_statistics"
      | "view_edit_requests_section"
      | "view_eligibility_checks"
      | "view_evv_calls"
      | "view_evv_clock_in_out"
      | "view_evv_duty_code_mapping"
      | "view_evv_section"
      | "view_hhax_integration_section"
      | "view_hhax_integration_section_billing"
      | "view_hhax_integration_section_non_billing"
      | "view_mentions_section"
      | "view_mentions_section_done"
      | "view_mentions_section_inbox"
      | "view_notes_section"
      | "view_passport_section"
      | "view_passport_verifier_section"
      | "view_patient_blood_pressure"
      | "view_patient_cost_share"
      | "view_patient_issues"
      | "view_patient_page_authorizations"
      | "view_patient_page_calendar"
      | "view_patient_page_care_level"
      | "view_patient_page_caregivers"
      | "view_patient_page_cdsc_import"
      | "view_patient_page_contracts"
      | "view_patient_page_diagnosis_codes"
      | "view_patient_page_documents"
      | "view_patient_page_duty_sheet"
      | "view_patient_page_emergency"
      | "view_patient_page_information"
      | "view_patient_page_intake"
      | "view_patient_page_medical_info"
      | "view_patient_page_medication_profile"
      | "view_patient_page_patient_tasks"
      | "view_patient_page_pay_rates"
      | "view_patient_page_plan_of_care"
      | "view_patient_page_summary"
      | "view_patient_page_uploaded_documents"
      | "view_patient_page_vbp"
      | "view_patient_page_visits"
      | "view_patient_page_weekly_template"
      | "view_patient_physicians"
      | "view_patient_profile"
      | "view_patient_search_result"
      | "view_patients_section"
      | "view_patients_section_alerts"
      | "view_patients_section_care"
      | "view_patients_section_list"
      | "view_patients_section_medical_statistics"
      | "view_patients_section_upcoming_tasks"
      | "view_payroll_section"
      | "view_payroll_section_batches"
      | "view_recruitment_section"
      | "view_reports_section"
      | "view_reports_section_advanced"
      | "view_reports_section_standard"
      | "view_tutorials_section"
      | "view_uploads_section"
      | "view_visits_section"
      | "view_visits_section_clockin"
      | "view_visits_section_daily_notes"
      | "view_visits_section_duty_sheets"
      | "view_visits_section_instances"
      | "view_visits_section_list"
      | "view_visits_section_staffing_issues"
      | "view_visits_section_upload"
      | "view_workers_credentials"
      | "view_workflow_task"
      | "view_workflows"
      | "workflow_task_viewer";
    Audit: {
      id: number;
      updatedBy: null | number;
      updatedByUser: string;
      updatedByUserType: string;
      updatedByAgencyMemberId?: components["schemas"]["AgencyMemberId"] | null;
      updatedByCaregiverId?: components["schemas"]["CaregiverId"] | null;
      updatedByPhotoUrl?: null | string;
      updatedByDisplayName?: null | string;
      updated: components["schemas"]["Instant"];
      actionStr: string;
      changes: unknown;
      tableId: null | number;
      tableName: string;
      subTable: null | string;
      subTableId: null | string;
      customName: null | string;
      subTableDisplay: null | string;
    };
    AuthorizationWithDisplayData: {
      fileDetails: components["schemas"]["PatientAuthorizationFileDetails"][];
      serviceCodeDisplayName: null | string;
      /**
       * @description The service code's revenue code, when the query that built this selected it.
       *
       * Null both when the service code has none and when the caller did not ask
       * for it, so it is only meaningful to a caller that knows it requested it.
       */
      serviceCodeRevenueCode: null | string;
      /**
       * @description The service code's export code — the code this service is known by OUTSIDE
       * MedFlyt.
       *
       * Null only when the query that built this did not select it. The column is NOT
       * NULL and service_code is joined on a NOT NULL foreign key, so an
       * authorization that carries one always has a value.
       */
      serviceCodeExportCode: null | string;
      createVisitOfficeName: null | string;
      createdByName: null | string;
      updatedByName: null | string;
      remainingMinutes: null | number;
      periodTypeDisplayName: string;
      hasBilledVisits: boolean;
      hasPaidVisits: boolean;
      canDelete: boolean;
      canEdit: boolean;
      hasVisitConflicts: boolean;
      conflictMetadata: components["schemas"]["AuthorizationConflictMetadata"];
      id: components["schemas"]["AuthorizationId"];
      code: null | string;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      maxMinutes: number;
      minutes: number;
      patientContractId: components["schemas"]["PatientContractId"];
      periodType: components["schemas"]["AuthorizationPeriodType"];
      files: components["schemas"]["PatientAuthorizationFileId"][];
      serviceCode: components["schemas"]["ServiceCodeId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      firstDayOfWeek: components["schemas"]["DayOfWeek"];
      mondayMinutes: null | number;
      tuesdayMinutes: null | number;
      wednesdayMinutes: null | number;
      thursdayMinutes: null | number;
      fridayMinutes: null | number;
      saturdayMinutes: null | number;
      sundayMinutes: null | number;
      removedBy?: components["schemas"]["AgencyMemberId"] | null;
      removedAt?: components["schemas"]["Instant"] | null;
      note: components["schemas"]["Note"] | null;
      externalId: null | string;
      createVisitOfficeIdOverride: components["schemas"]["OfficeId"] | null;
      restrictions:
        | components["schemas"]["AuthorizationTimeConfig.WeeklyRestriction"][]
        | null;
      /**
       * @description Illinois DHS/DRS district number, labelled "Caseload" on the authorization
       * document. Printed in the District column of the IL488-2387 monthly billing
       * statement, and unused by every other contract type.
       */
      districtNumber: null | string;
    };
    PatientAuthorizationFileDetails: {
      id: components["schemas"]["PatientAuthorizationFileId"];
      fileKey: null | string;
      fileName: null | string;
      url?: null | string;
      canDelete?: boolean;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdByName?: null | string;
      removedAt?: components["schemas"]["Instant"] | null;
      removedBy?: components["schemas"]["AgencyMemberId"] | null;
    };
    /** Format: PatientAuthorizationFileId */
    PatientAuthorizationFileId: PatientAuthorizationFileId;
    AuthorizationConflictMetadata: {
      hasBilledVisits: boolean;
      hasPaidVisits: boolean;
      canDelete: boolean;
      canEdit: boolean;
    };
    /** Format: AuthorizationId */
    AuthorizationId: AuthorizationId;
    /** @enum {string} */
    AuthorizationPeriodType: "DAILY" | "ENTIRE_PERIOD" | "MONTHLY" | "WEEKLY";
    /** Format: ServiceCodeId */
    ServiceCodeId: ServiceCodeId;
    Note: {
      id: components["schemas"]["NoteId"];
      noteRichText: null | string;
      status: string;
      subject: {
        id: components["schemas"]["NoteSubjectId"];
        name: string;
      } | null;
      patientId: components["schemas"]["PatientId"] | null;
      patientIds: components["schemas"]["PatientId"][];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverIds: components["schemas"]["CaregiverId"][];
      agencyMembers: components["schemas"]["AgencyMemberId"][];
      commCenterTicketId: components["schemas"]["CommCenterTicketId"] | null;
      comments: components["schemas"]["NoteComment"][];
      followUp: components["schemas"]["LocalDate"] | null;
      createdBy: {
        id: components["schemas"]["AgencyMemberId"];
        firstName: string;
        lastName: string;
      };
      createdAt: components["schemas"]["Instant"];
      noteType: components["schemas"]["NoteTypes"];
      notePredefinedAnswerId:
        | components["schemas"]["NotePredefinedAnswerId"]
        | null;
      predefinedAnswerText: null | string;
      files: components["schemas"]["NoteFile"][];
    };
    /** Format: NoteId */
    NoteId: NoteId;
    /** Format: NoteSubjectId */
    NoteSubjectId: NoteSubjectId;
    /** Format: CommCenterTicketId */
    CommCenterTicketId: CommCenterTicketId;
    NoteComment: {
      id: components["schemas"]["NoteCommentId"];
      noteId: components["schemas"]["NoteId"];
      commentRichText: null | string;
      author: {
        id: components["schemas"]["AgencyMemberId"];
        firstName: string;
        lastName: string;
        photoUrl: null | string;
      };
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: NoteCommentId */
    NoteCommentId: NoteCommentId;
    NoteFile: {
      id: components["schemas"]["NoteFileId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdByName: string;
    };
    /** Format: NoteFileId */
    NoteFileId: NoteFileId;
    "AuthorizationTimeConfig.WeeklyRestriction": {
      /** @description How many days during the week apply to this restriction */
      numDays: number;
      /** @description Max minutes per day for this restriction */
      maxMinutesPerDay: number;
    };
    AuthorizationOfficeOverrideConflictError: {
      /** @enum {string} */
      error: "OFFICE_OVERRIDE_CONFLICT";
    };
    EditAuthorizationVisitHoursRestrictionError: {
      /** @enum {string} */
      error: "VISIT_HOURS_RESTRICTION_CONFLICT";
      /** @enum {string} */
      type: "Conflict";
      conflicts: {
        caregiverId: components["schemas"]["CaregiverId"];
        exceededHours: number;
      }[];
    };
    AuthorizationTimeConfig:
      | components["schemas"]["AuthorizationTimeConfig.Daily"]
      | components["schemas"]["AuthorizationTimeConfig.Weekly"]
      | components["schemas"]["AuthorizationTimeConfig.Monthly"]
      | components["schemas"]["AuthorizationTimeConfig.EntirePeriod"];
    "AuthorizationTimeConfig.Daily": {
      /** @enum {string} */
      type: "Daily";
      /** @description The amount of minutes in the Authorization for each day of the week */
      dailyMinutes: [components["schemas"]["DayOfWeek"], number][];
    };
    "AuthorizationTimeConfig.Weekly": {
      /** @enum {string} */
      type: "Weekly";
      firstDayOfWeek: components["schemas"]["DayOfWeek"];
      /** @description The amount of minutes in the Authorization each week */
      weeklyMinutes: number;
      /**
       * @description Optional additional restrictions that limit the amount of minutes
       * per day. Limited to 2 restrictions per authorization.
       *
       * An example: 2 days max 180 minutes, and 3 days max 120 minutes
       *
       * If set, then the sum of the minutes for all of the days should be
       * equal to `weeklyMinutes` (above).
       */
      dayRestrictions:
        | components["schemas"]["AuthorizationTimeConfig.WeeklyRestriction"][]
        | null;
    };
    "AuthorizationTimeConfig.Monthly": {
      /** @enum {string} */
      type: "Monthly";
      /** @description The amount of minutes in the Authorization each month */
      monthlyMinutes: number;
    };
    "AuthorizationTimeConfig.EntirePeriod": {
      /** @enum {string} */
      type: "EntirePeriod";
    };
    AgencyNoteEditParams: {
      noteRichText?: null | string;
      patientId?: components["schemas"]["PatientId"] | null;
      patientIds?: components["schemas"]["PatientId"][];
      caregiverId?: components["schemas"]["CaregiverId"] | null;
      caregiverIds?: components["schemas"]["CaregiverId"][];
      agencyMemberIds?: components["schemas"]["AgencyMemberId"][];
      commCenterTicketId?: components["schemas"]["CommCenterTicketId"] | null;
      subject?: components["schemas"]["NoteSubjectId"] | null;
      status: string;
      followUp?: components["schemas"]["LocalDate"] | null;
      notePredefinedAnswerId?:
        | components["schemas"]["NotePredefinedAnswerId"]
        | null;
      noteType: components["schemas"]["NoteTypes"];
      base64File?: string;
    };
    /** Format: ICD10CodeId */
    ICD10CodeId: ICD10CodeId;
    PatientUtilizationListItem: {
      authorizationId: components["schemas"]["AuthorizationId"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      officeId: components["schemas"]["OfficeId"];
      officeName: string;
      contractTypeId: components["schemas"]["ContractTypeId"];
      contractTypeName: string;
      serviceCode: string;
      /** @description Current patient.status (ACTIVE, ON_HOLD, HOSPITALIZED, ...). */
      patientStatus: string;
      periodType: string;
      /** @description ISO date string (e.g. "2018-10-05") */
      authStartDate: string;
      /** @description ISO date string */
      authEndDate: string;
      /**
       * @description Whether this authorization has any visit at all that is neither removed
       * nor cancelled — on any date, past or future. The inverse of "no schedule
       * yet", and the same fact the `noScheduleYet` filter selects on.
       */
      hasActiveVisits: boolean;
      utilization: components["schemas"]["AuthorizationUtilizationMeasures"];
    };
    /**
     * @description The computed utilization measures for a single authorization over a date
     * range. All values in minutes. `authorizedMinutes` (and the derived fields)
     * are null for an unlimited authorization.
     */
    AuthorizationUtilizationMeasures: {
      authorizationId: components["schemas"]["AuthorizationId"];
      authorizedMinutes: null | number;
      scheduledMinutes: number;
      unscheduledMinutes: null | number;
      scheduledUtilization: null | number;
      /** @description Days in range the patient was on hold / hospitalized (prorated out of authorized). */
      unavailableDays: number;
      /** @description Minutes removed from authorized because the patient was on hold / hospitalized. */
      authorizedReductionMinutes: number;
      state: components["schemas"]["AuthorizationUtilizationState"];
    };
    /** @enum {string} */
    AuthorizationUtilizationState:
      | "fully_allocated"
      | "over_allocated"
      | "under_allocated";
    UtilizationOfficeContractRollup: {
      officeId: components["schemas"]["OfficeId"];
      officeName: string;
      contractTypeId: components["schemas"]["ContractTypeId"];
      contractTypeName: string;
      authorizedMinutes: number;
      scheduledMinutes: number;
      unscheduledMinutes: number;
      authorizedReductionMinutes: number;
      patientsUnderAllocated: number;
      patientsFullyAllocated: number;
      patientsOverAllocated: number;
    };
    OverUtilizationWarningItem: {
      authorizationId: components["schemas"]["AuthorizationId"];
      serviceCode: string;
      periodType: string;
      periodLabel: string;
      authorizedMinutes: number;
      currentScheduledMinutes: number;
      proposedTotalMinutes: number;
      utilizationPercent: number;
    };
    AiWeeklyTemplateBuilderAuthorizationOption: {
      authorizationId: components["schemas"]["AuthorizationId"];
      code: null | string;
      contractTypeName: string;
      serviceCode: string;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      periodType: components["schemas"]["AuthorizationPeriodType"];
      /** @description `patient_authorization.minutes` — per-period allotment. */
      periodMinutes: null | number;
      /** @description `patient_authorization.max_minutes`. `null` means no maximum. */
      maxMinutes: null | number;
      /** @description Today falls within [startDate, endDate]. */
      isCurrentlyActive: boolean;
      hasWeeklyTemplate: boolean;
    };
    /**
     * @description Types for the AI Weekly Template Builder.
     *
     * Everything is in whole minutes, matching `patient_authorization`,
     * `visit_authorization.minutes_allocated` and `AuthorizationTimeConfig`. The
     * client divides by 60 to display hours (exact for any 15-minute multiple).
     */
    AiWeeklyTemplateRateLimitStatus: {
      /** @description Generations allowed per patient per rolling 24 hours. */
      limit: number;
      usedInLast24Hours: number;
      remaining: number;
      /**
       * @description When the oldest counted generation falls out of the 24 hour window, i.e.
       * when the next generation becomes possible. `null` when `remaining > 0`.
       */
      nextAvailableAt: components["schemas"]["Instant"] | null;
    };
    AiWeeklyTemplateAuthorizationSummary: {
      authorizationId: components["schemas"]["AuthorizationId"];
      code: null | string;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientStatus: string;
      patientContractId: components["schemas"]["PatientContractId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      contractTypeName: string;
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      serviceCode: string;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      totalDaysInRange: number;
      periodType: components["schemas"]["AuthorizationPeriodType"];
      timeConfig: components["schemas"]["AuthorizationTimeConfig"];
      periodMinutes: null | number;
      maxMinutes: null | number;
      /** @description Populated only for a DAILY authorization. */
      dailyMinutesByWeekday:
        | components["schemas"]["AiWeeklyTemplateDailyMinutes"][]
        | null;
      /** @description Populated only for a WEEKLY authorization with `weekly_day_minutes`. */
      weeklyDayRestrictions:
        | components["schemas"]["AiWeeklyTemplateDayRestriction"][]
        | null;
      firstDayOfWeek: components["schemas"]["DayOfWeek"];
    };
    AiWeeklyTemplateDailyMinutes: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      minutes: number;
    };
    AiWeeklyTemplateDayRestriction: {
      numDays: number;
      maxMinutesPerDay: number;
    };
    AiWeeklyTemplatePeriodContext: {
      /** @description 1-based, stable across the context, the prompt and the verification. */
      periodIndex: number;
      label: string;
      /**
       * @description The period as enumerated. May extend outside the authorization range:
       * WEEKLY periods back-align to `firstDayOfWeek`, MONTHLY periods are whole
       * calendar months.
       */
      periodStart: components["schemas"]["LocalDate"];
      periodEnd: components["schemas"]["LocalDate"];
      /** @description The period clipped to the authorization range — the schedulable window. */
      effectiveStart: components["schemas"]["LocalDate"];
      effectiveEnd: components["schemas"]["LocalDate"];
      isPartialPeriod: boolean;
      daysInPeriod: number;
      effectiveDays: number;
      /** @description The hard cap for this period. NOT reduced when the period is partial. */
      availableMinutes: number;
      /**
       * @description `availableMinutes * effectiveDays / daysInPeriod`, rounded. Display and
       * "realistic utilization" only — never used for limit checks.
       */
      proratedAvailableMinutes: number;
      weekdayOccurrences: components["schemas"]["AiWeeklyTemplateWeekdayOccurrence"][];
      /** @description Minutes already allocated to this authorization inside the window. */
      alreadyScheduledMinutes: number;
      /** @description ON_HOLD / HOSPITALIZED days inside the window. */
      unavailableDays: number;
    };
    AiWeeklyTemplateWeekdayOccurrence: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      /** @description How many times this weekday occurs in [effectiveStart, effectiveEnd]. */
      count: number;
      /** @description Last occurrence of this weekday in the window. `null` when `count === 0`. */
      lastDate: components["schemas"]["LocalDate"] | null;
      /**
       * @description The most recent occurrences of this weekday, latest first, capped at
       * `AI_WEEKLY_TEMPLATE_TRUE_UP_LOOKBACK_SERVICE_DAYS`.
       *
       * A true-up that cannot fit on the period's last service day walks backwards
       * through earlier service days, so the assistant needs those dates handed to
       * it — deriving them itself is the calendar arithmetic this whole design
       * avoids.
       */
      recentDates: components["schemas"]["LocalDate"][];
    };
    AiWeeklyTemplateContextTotals: {
      numberOfPeriods: number;
      sumOfPeriodLimitMinutes: number;
      sumOfProratedPeriodLimitMinutes: number;
      maxMinutes: null | number;
      /** @description `min(sumOfPeriodLimitMinutes, maxMinutes)` — the binding ceiling. */
      effectiveAuthorizedMinutes: number;
      alreadyScheduledMinutes: number;
    };
    PatientWeeklyTemplateShiftExtended: {
      id: components["schemas"]["PatientWeeklyTemplateShiftId"];
      dayOfWeek: components["schemas"]["DayOfWeek"];
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
      serviceCode: {
        id: components["schemas"]["ServiceCodeId"];
        name: string;
        certification: components["schemas"]["CaregiverCertification"];
      } | null;
      contract: {
        id: components["schemas"]["PatientContractId"];
        name: string;
      } | null;
      payrollCode: {
        id: components["schemas"]["PayrollCodeId"];
        name: string;
      } | null;
      caregiver: {
        id: components["schemas"]["CaregiverId"];
        name: string;
        currentStatus: components["schemas"]["CaregiverStatus"];
      } | null;
    };
    /** Format: PatientWeeklyTemplateShiftId */
    PatientWeeklyTemplateShiftId: PatientWeeklyTemplateShiftId;
    /** Format: PayrollCodeId */
    PayrollCodeId: PayrollCodeId;
    /**
     * @description Whether applying is possible, and if not, every reason why.
     *
     * On the context this answers the suggestion-independent question, so the UI can
     * disable the button before anything is generated. It is an affordance only —
     * the write endpoint re-derives all of it inside its own transaction, which is
     * the actual enforcement point.
     */
    AiWeeklyTemplateApplyEligibility: {
      canApply: boolean;
      /** @description Every applicable reason, not just the first. Empty when `canApply`. */
      blockers: components["schemas"]["AiWeeklyTemplateApplyBlocker"][];
    };
    AiWeeklyTemplateApplyBlocker: {
      code: components["schemas"]["AiWeeklyTemplateApplyBlockerCode"];
      message: string;
    };
    /**
     * @description Why a suggestion cannot be turned into a weekly template and its visits.
     *
     * The first four are properties of the patient and the authorization, so they
     * are known before any suggestion is chosen and travel on the context. The rest
     * are properties of one stored suggestion.
     * @enum {string}
     */
    AiWeeklyTemplateApplyBlockerCode:
      | "AUTHORIZATION_ALREADY_ENDED"
      | "NO_VISITS_WOULD_BE_CREATED"
      | "PATIENT_HAS_WEEKLY_TEMPLATE"
      | "PATIENT_IN_NEW_YORK"
      | "PATIENT_NOT_SERVICEABLE"
      | "PATIENT_STATE_UNKNOWN"
      | "SNAPSHOT_NOT_READABLE"
      | "SUGGESTION_ALREADY_APPLIED"
      | "SUGGESTION_HAS_NO_SHIFTS"
      | "SUGGESTION_STATUS_NOT_APPLYABLE";
    /** @description One row of the history list. Never carries the stored snapshots. */
    AiWeeklyTemplateSuggestionSummary: {
      id: components["schemas"]["AiWeeklyTemplateSuggestionId"];
      createdAt: components["schemas"]["Instant"];
      createdByName: string;
      status: components["schemas"]["AiWeeklyTemplateGenerationStatus"];
      /** @description The free text the coordinator typed, exactly as sent. */
      schedulingRules: null | string;
      incrementMinutes: number;
      weeklyTotalMinutes: number;
      totalScheduledMinutes: number;
      totalAuthorizedMinutes: number;
      utilizationPercent: null | number;
      realisticUtilizationPercent: null | number;
      errorCount: number;
      warningCount: number;
      /** @description When this suggestion was turned into a weekly template. `null` if never. */
      appliedAt: components["schemas"]["Instant"] | null;
      appliedByName: null | string;
      /**
       * @description The turn this one refines. `null` when it came straight from Generate.
       *
       * No turn *number* is carried here on purpose: the list is a flat window over
       * one authorization, so a row's parent may well have fallen off the end of it,
       * and a number counted from what happens to be visible would be a lie. The
       * position within a conversation comes from the thread, which is loaded whole.
       */
      parentSuggestionId:
        | components["schemas"]["AiWeeklyTemplateSuggestionId"]
        | null;
      /** @description The feedback that produced this turn. `null` when it came from Generate. */
      feedback: null | string;
    };
    /** Format: AiWeeklyTemplateSuggestionId */
    AiWeeklyTemplateSuggestionId: AiWeeklyTemplateSuggestionId;
    /** @enum {string} */
    AiWeeklyTemplateGenerationStatus:
      | "INVALID"
      | "LLM_UNAVAILABLE"
      | "MATH_MISMATCH"
      | "RATE_LIMITED"
      | "UNSUPPORTED_AUTHORIZATION"
      | "VERIFIED"
      | "VERIFIED_WITH_WARNINGS";
    AiWeeklyTemplateContextWarning: {
      code: components["schemas"]["AiWeeklyTemplateContextWarningCode"];
      message: string;
    };
    /** @enum {string} */
    AiWeeklyTemplateContextWarningCode:
      | "AUTHORIZATION_ALREADY_ENDED"
      | "AUTHORIZATION_NOT_STARTED"
      | "EXISTING_TEMPLATE_PRESENT"
      | "EXISTING_VISITS_PRESENT"
      | "PATIENT_CURRENTLY_UNAVAILABLE"
      | "PERIODS_COLLAPSED_IN_PROMPT"
      | "UNLIMITED_AUTHORIZATION";
    AiWeeklyTemplateSuggestion: {
      weeklyShifts: components["schemas"]["AiWeeklyTemplateShiftSuggestion"][];
      weeklyTotalMinutes: number;
      periodValidations: components["schemas"]["AiWeeklyTemplatePeriodValidationRow"][];
      trueUps: components["schemas"]["AiWeeklyTemplateTrueUpRow"][];
      totalRecurringMinutes: number;
      totalTrueUpMinutes: number;
      totalScheduledMinutes: number;
      totalAuthorizedMinutes: number;
      utilizationPercent: number;
      limitsVerifiedConfirmation: string;
      unusedMinutesExplanations: string[];
      ruleInterpretations: components["schemas"]["AiWeeklyTemplateRuleInterpretation"][];
      assumptions: string[];
      /** @description Non-null only when a single repeating week was mathematically impossible. */
      multipleSchedulesRequiredReason: null | string;
      explanation: string;
    };
    AiWeeklyTemplateShiftSuggestion: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
      /** @description As claimed by the assistant. The server recomputes and may disagree. */
      durationMinutes: number;
      crossesMidnight: boolean;
      rationale: string;
    };
    AiWeeklyTemplatePeriodValidationRow: {
      periodIndex: number;
      label: string;
      periodLimitMinutes: number;
      maxMinutes: null | number;
      recurringScheduledMinutes: number;
      trueUpMinutes: number;
      finalScheduledMinutes: number;
      unusedMinutes: number;
    };
    AiWeeklyTemplateTrueUpRow: {
      periodIndex: number;
      date: components["schemas"]["LocalDate"];
      dayOfWeek: components["schemas"]["DayOfWeek"];
      additionalMinutes: number;
      resultingTotalMinutesThatDay: number;
      reasonAllowed: string;
    };
    AiWeeklyTemplateRuleInterpretation: {
      rule: string;
      appliedAs: string;
    };
    AiWeeklyTemplateVerification: {
      /** @description The proposal as the server understands it, with durations recomputed. */
      weeklyShifts: components["schemas"]["AiWeeklyTemplateVerifiedShift"][];
      weeklyTotalMinutes: number;
      periodRows: components["schemas"]["AiWeeklyTemplateVerifiedPeriodRow"][];
      trueUpRows: components["schemas"]["AiWeeklyTemplateVerifiedTrueUpRow"][];
      totalRecurringMinutes: number;
      totalTrueUpMinutes: number;
      totalScheduledMinutes: number;
      totalAuthorizedMinutes: number;
      totalUnusedMinutes: number;
      utilizationPercent: null | number;
      /** @description Against prorated period limits — the number to judge the plan by. */
      realisticUtilizationPercent: null | number;
      violations: components["schemas"]["AiWeeklyTemplateViolation"][];
      discrepancies: components["schemas"]["AiWeeklyTemplateDiscrepancy"][];
    };
    AiWeeklyTemplateVerifiedShift: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
      /** @description Recomputed by the server from `startTime` / `endTime`. */
      durationMinutes: number;
      crossesMidnight: boolean;
      rationale: string;
    };
    AiWeeklyTemplateVerifiedPeriodRow: {
      periodIndex: number;
      label: string;
      periodStart: components["schemas"]["LocalDate"];
      periodEnd: components["schemas"]["LocalDate"];
      isPartialPeriod: boolean;
      periodLimitMinutes: number;
      proratedPeriodLimitMinutes: number;
      recurringMinutes: number;
      trueUpMinutes: number;
      finalScheduledMinutes: number;
      unusedMinutes: number;
      alreadyScheduledMinutes: number;
      combinedWithExistingMinutes: number;
      overAllocatedMinutes: number;
      utilizationPercent: null | number;
      realisticUtilizationPercent: null | number;
      /** @description Last date in the period on which the proposed template places a shift. */
      lastServiceDate: components["schemas"]["LocalDate"] | null;
      withinLimits: boolean;
    };
    AiWeeklyTemplateVerifiedTrueUpRow: {
      periodIndex: number;
      date: components["schemas"]["LocalDate"];
      dayOfWeek: components["schemas"]["DayOfWeek"];
      additionalMinutes: number;
      isLastServiceDayOfPeriod: boolean;
      /**
       * @description 0 when this is the period's last service day, 1 for the one before it, and
       * so on. `null` when the date is further back than the permitted lookback
       * (or is not a service day at all).
       */
      serviceDaysFromEndOfPeriod: null | number;
      accepted: boolean;
      rejectionReason: null | string;
    };
    AiWeeklyTemplateViolation: {
      code: components["schemas"]["AiWeeklyTemplateViolationCode"];
      severity: components["schemas"]["AiWeeklyTemplateViolationSeverity"];
      periodIndex: null | number;
      dayOfWeek: components["schemas"]["DayOfWeek"] | null;
      date: components["schemas"]["LocalDate"] | null;
      message: string;
      limitMinutes: null | number;
      actualMinutes: null | number;
    };
    /** @enum {string} */
    AiWeeklyTemplateViolationCode:
      | "CONFLICTS_WITH_EXISTING_VISITS"
      | "DAY_RESTRICTION_DAYS_EXCEEDED"
      | "DAY_RESTRICTION_MINUTES_EXCEEDED"
      | "EMPTY_SCHEDULE"
      | "MAX_MINUTES_EXCEEDED"
      | "NOT_ALLOWED_INCREMENT"
      | "PERIOD_OVER_ALLOCATED"
      | "PERIOD_UNDER_UTILIZED"
      | "SCHEDULE_ON_UNAVAILABLE_DAYS"
      | "SHIFT_OVERLAP"
      | "TRUE_UP_DUPLICATE_DATE"
      | "TRUE_UP_NOT_ON_LAST_SERVICE_DAY"
      | "TRUE_UP_ON_NON_SERVICE_DAY"
      | "TRUE_UP_OUT_OF_RANGE"
      | "UNPARSEABLE_PROPOSAL_ENTRY"
      | "WEEKDAY_DAILY_LIMIT_EXCEEDED"
      | "ZERO_OR_NEGATIVE_DURATION";
    /** @enum {string} */
    AiWeeklyTemplateViolationSeverity: "ERROR" | "INFO" | "WARNING";
    AiWeeklyTemplateDiscrepancy: {
      /** @description e.g. "weeklyTotalMinutes", "periodValidations[3].finalScheduledMinutes" */
      field: string;
      periodIndex: null | number;
      assistantValue: number;
      serverValue: number;
      differenceMinutes: number;
    };
    /**
     * @description One turn of a refinement conversation — enough to render a version chip and
     * nothing more. The full result of any turn is its own stored suggestion.
     */
    AiWeeklyTemplateThreadTurn: {
      suggestionId: components["schemas"]["AiWeeklyTemplateSuggestionId"];
      /**
       * @description 1-based position in the conversation, in the order the turns were created.
       *
       * Deliberately not the turn's depth: going back to an earlier version and
       * refining that produces a branch, and two versions numbered the same would
       * make the version strip impossible to navigate. `parentSuggestionId` is what
       * says which version a turn actually came from.
       */
      turnIndex: number;
      /** @description The version this one was refined from. `null` on the first turn. */
      parentSuggestionId:
        | components["schemas"]["AiWeeklyTemplateSuggestionId"]
        | null;
      /** @description The feedback that produced this turn. `null` on turn 1. */
      feedback: null | string;
      status: components["schemas"]["AiWeeklyTemplateGenerationStatus"];
      createdAt: components["schemas"]["Instant"];
      createdByName: string;
      weeklyTotalMinutes: number;
      realisticUtilizationPercent: null | number;
      errorCount: number;
      warningCount: number;
      appliedAt: components["schemas"]["Instant"] | null;
    };
    AiWeeklyTemplateBuilderContext: {
      authorization: components["schemas"]["AiWeeklyTemplateAuthorizationSummary"];
      periods: components["schemas"]["AiWeeklyTemplatePeriodContext"][];
      totals: components["schemas"]["AiWeeklyTemplateContextTotals"];
      existingTemplateShifts: components["schemas"]["PatientWeeklyTemplateShiftExtended"][];
      /**
       * @description The suggestion-independent half of the apply verdict. Combine with a
       * suggestion's own `status` and `appliedAt` for the full answer.
       */
      apply: components["schemas"]["AiWeeklyTemplateApplyEligibility"];
      rateLimit: components["schemas"]["AiWeeklyTemplateRateLimitStatus"];
      /**
       * @description Past suggestions for this authorization, newest first, capped at
       * `AI_WEEKLY_TEMPLATE_HISTORY_LIMIT`. Summaries only — fetch the detail
       * endpoint for the full stored result.
       */
      recentSuggestions: components["schemas"]["AiWeeklyTemplateSuggestionSummary"][];
      warnings: components["schemas"]["AiWeeklyTemplateContextWarning"][];
    };
    /**
     * @description One true-up, and whether it made it onto the calendar.
     *
     * A true-up is extra minutes on a day that already has a recurring shift, so it
     * is placed immediately after that day's last shift ends. Reported per item
     * because a top-up that will not fit is a nuance the coordinator fixes by hand,
     * not a reason to throw away a correct template.
     */
    AiWeeklyTemplateApplyTrueUpResult: {
      date: components["schemas"]["LocalDate"];
      periodIndex: number;
      additionalMinutes: number;
      /** @description Where it was placed. `null` when no placement was possible at all. */
      startTime: components["schemas"]["LocalDateTime"] | null;
      endTime: components["schemas"]["LocalDateTime"] | null;
      created: boolean;
      /** @description Why it was not created. `null` when it was. */
      failureReason: null | string;
    };
    /** Format: yyyy-MM-ddTHH:mm:ss.SSS */
    LocalDateTime: LocalDateTime;
    AiWeeklyTemplateApplyWarning: {
      code: components["schemas"]["AiWeeklyTemplateApplyWarningCode"];
      message: string;
    };
    /**
     * @description Something the coordinator should know about a *successful* apply.
     *
     * Separate from `AiWeeklyTemplateApplyBlocker` on purpose: a blocker is a reason
     * nothing happened, a warning is a caveat about something that did.
     * @enum {string}
     */
    AiWeeklyTemplateApplyWarningCode:
      | "NO_VISITS_CREATED"
      | "RECURRING_VISITS_SKIPPED"
      | "TRUE_UPS_NOT_CREATED";
    BankedMinutesVisit: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      patientId: components["schemas"]["PatientId"];
      patientDisplayId: null | number;
      patientFirstName: string;
      patientLastName: string;
      visitDate: components["schemas"]["LocalDate"];
      adjustmentMinutes: number;
      fullyAuthorized: boolean;
      contractName: string;
      officeName: string;
    };
    BankedMinutesJob: {
      id: components["schemas"]["ProcessJobId"];
      type: components["schemas"]["BankedMinutesJobType"];
      status: components["schemas"]["BankedMinutesJobStatus"];
      createdAt: components["schemas"]["Instant"];
      createdByName: string;
      errorMessage: null | string;
      fileName: null | string;
      totalItems: number;
      completedItems: number;
      errorItems: number;
      cancelledItems: number;
      pendingItems: number;
    };
    /** Format: ProcessJobId */
    ProcessJobId: ProcessJobId;
    /** @enum {string} */
    BankedMinutesJobType: "reset" | "update";
    /** @enum {string} */
    BankedMinutesJobStatus: "completed" | "error" | "running" | "stopped";
    BankedMinutesJobItem: {
      id: components["schemas"]["ProcessJobItemId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      patientDisplayId: null | number;
      patientName: null | string;
      month: components["schemas"]["LocalDate"] | null;
      bankedMinutes: null | number;
      status: components["schemas"]["BankedMinutesJobItemStatus"];
      errorMessage: null | string;
      processedAt: components["schemas"]["Instant"] | null;
    };
    /** Format: ProcessJobItemId */
    ProcessJobItemId: ProcessJobItemId;
    /** @enum {string} */
    BankedMinutesJobItemStatus:
      | "cancelled"
      | "completed"
      | "error"
      | "pending"
      | "processing";
    /**
     * @description A row in the uploads / jobs list. `label` is a human-readable action label
     * (e.g. "Authorization upload"), independent of the raw action_type string.
     */
    ProcessJob: {
      id: components["schemas"]["ProcessJobId"];
      processType: components["schemas"]["ProcessType"];
      actionType: string;
      label: string;
      status: components["schemas"]["ProcessJobStatus"];
      createdAt: components["schemas"]["Instant"];
      createdByName: string;
      errorMessage: null | string;
      fileName: null | string;
      totalItems: number;
      completedItems: number;
      errorItems: number;
      cancelledItems: number;
      pendingItems: number;
    };
    /**
     * @description The kind of processing a job performs. Discriminates the generic
     * process_job / process_job_item tables. New async bulk-processing features
     * should add a variant here rather than creating their own tables.
     * @enum {string}
     */
    ProcessType:
      | "AR_NOTES"
      | "AUTH_FILE"
      | "BANKED_MINUTES"
      | "SANDATA_RESUBMIT";
    /** @enum {string} */
    ProcessJobStatus: "completed" | "error" | "running" | "stopped";
    /**
     * @description A single unit of work within a job, shaped for display. `label`/`detail`
     * are computed server-side from the item's jsonb input so the same UI can
     * render every process type; `resultText` summarizes the jsonb output.
     */
    ProcessJobItem: {
      id: components["schemas"]["ProcessJobItemId"];
      status: components["schemas"]["ProcessJobItemStatus"];
      label: string;
      detail: null | string;
      resultText: null | string;
      errorMessage: null | string;
      processedAt: components["schemas"]["Instant"] | null;
      createdAt: components["schemas"]["Instant"];
    };
    /** @enum {string} */
    ProcessJobItemStatus:
      | "cancelled"
      | "completed"
      | "error"
      | "pending"
      | "processing";
    /** Format: CaregiverDocumentTypeAgencySettingId */
    CaregiverDocumentTypeAgencySettingId: CaregiverDocumentTypeAgencySettingId;
    ActiveDateDynamic: {
      unit: components["schemas"]["ComplianceDocumentUnitType"];
      amount: number;
    };
    /** @enum {string} */
    ComplianceDocumentUnitType: "DAY" | "MONTH" | "WEEK";
    /** Format: CaregiverDocumentTypeId */
    CaregiverDocumentTypeId: CaregiverDocumentTypeId;
    /** Format: CaregiverDocumentUploadId */
    CaregiverDocumentUploadId: CaregiverDocumentUploadId;
    CaregiverDocumentTypeWithUploads: {
      documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      documentTypeName: string;
      category: string;
      uploads: components["schemas"]["CaregiverDocumentUpload"][];
      isHr: boolean;
      isCompliance: boolean;
      isPassport: boolean;
      isExpires: boolean;
      isMandatory: boolean;
    };
    CaregiverDocumentUpload: {
      uploadId: components["schemas"]["CaregiverDocumentUploadId"];
      expiryDate: components["schemas"]["LocalDate"] | null;
      createdAt: components["schemas"]["Instant"];
      caregiverId: components["schemas"]["CaregiverId"];
      uploadedBy: components["schemas"]["CaregiverDocumentUploadedBy"];
    };
    CaregiverDocumentUploadedBy:
      | components["schemas"]["CaregiverDocumentUploadedBy.Caregiver"]
      | components["schemas"]["CaregiverDocumentUploadedBy.AgencyMember"];
    "CaregiverDocumentUploadedBy.Caregiver": {
      /** @enum {string} */
      type: "Caregiver";
      id: components["schemas"]["CaregiverId"];
      fullName: string;
    };
    "CaregiverDocumentUploadedBy.AgencyMember": {
      /** @enum {string} */
      type: "AgencyMember";
      id: components["schemas"]["AgencyMemberId"];
      fullName: string;
    };
    CaregiverExtendedContactDetailsData: {
      birthCountryPlace: null | string;
      lookingForLongPermanentCases: null | string;
      cdpapToPcaSwitch: null | boolean;
      commentForTeam: null | string;
      experienceWithBedboundPatient: null | boolean;
      dohFormSection3Complete: components["schemas"]["Instant"] | null;
      eVerifySubmissionDate: components["schemas"]["LocalDate"] | null;
      experienceWithWalkingAssistanceNeed: null | boolean;
      experienceWorkingWithShabbatObserver: null | boolean;
      experienceWorkingAtKosherHome: null | boolean;
      experienceWorkingWithHalalCulture: null | boolean;
      eyeColor: null | string;
      hairColor: null | string;
      height: null | string;
      isCaregiverSmoking: null | boolean;
    };
    /** @enum {string} */
    ExportCaregiverProfileSectionName:
      | "calendar"
      | "compliance"
      | "inservices"
      | "personal"
      | "professional";
    CalendarDatePeriodParam: {
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"] | null;
    };
    CaregiverAgency: {
      agency: components["schemas"]["AgencyIsChatOnly"];
      status: components["schemas"]["CaregiverStatus"];
      agencyMembers: components["schemas"]["AgencyMember"][];
    };
    AgencyIsChatOnly: {
      isChatOnly: boolean;
      defaultAgencyMemberForChat:
        | components["schemas"]["AgencyMemberId"]
        | null;
      id: components["schemas"]["AgencyId"];
      createdAt: components["schemas"]["Instant"];
      name: string;
      logoUrl: null | string;
      website: null | string;
      address: null | string;
      address2: null | string;
      officePhone: null | string;
      organizationType: null | string;
      allowBoost: boolean;
      shouldSendInvoice: boolean;
      ipAddressesOpen?: boolean;
      ipAddressesWhitelist?: string[] | null;
      signaturePerson?: components["schemas"]["AgencyMemberId"] | null;
      clockInFeature: boolean;
      defaultOfficeId: components["schemas"]["OfficeId"];
      notificationAgencyMemberId:
        | components["schemas"]["AgencyMemberId"]
        | null;
      ivrPhoneNumber: null | string;
      ivrPhoneNumbers: components["schemas"]["AgencyIvrPhoneNumber"][] | null;
      isMedflytAgency: boolean;
      isMobileComplianceEnabled: boolean;
    };
    AgencyIvrPhoneNumber: {
      ivrPhoneNumber: string;
      description: null | string;
    };
    AgencyCaregiverVisitEngagement: {
      visit: components["schemas"]["BasicVisitDetails"];
      broadcastAt: components["schemas"]["Instant"];
      viewedAt: components["schemas"]["Instant"] | null;
      moreDetailsViewedAt: components["schemas"]["Instant"] | null;
      requestedAt: components["schemas"]["Instant"] | null;
      cancelledAt: components["schemas"]["Instant"] | null;
      notInterestedAt: components["schemas"]["Instant"] | null;
      notInterestedReason: null | string;
      flexibleVisitTimeRequestParams:
        | components["schemas"]["CaregiverFlexibleVisitRequestParams"][]
        | null;
      instancesEngagements: components["schemas"]["AgencyVisitInstancesEngagements"];
    };
    BasicVisitDetails: {
      id: components["schemas"]["VisitBroadcastId"];
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      cancelled: boolean;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      patientName: string;
      patientAddress: string;
      createdBy: components["schemas"]["AgencyMemberId"];
      isSingleVisit: boolean;
      cancelledDate: components["schemas"]["Instant"] | null;
      cancelledByCaregiver: boolean;
      cancelledReason: null | string;
      assignedCaregiver: components["schemas"]["CaregiverId"] | null;
      /** @description Denormalised so the caller does not need a caregiver dictionary. */
      assignedCaregiverName: null | string;
      endReason: null | string;
      patientId: components["schemas"]["PatientId"];
    };
    CaregiverFlexibleVisitRequestParams: {
      day: components["schemas"]["DayOfWeek"];
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
    };
    AgencyVisitInstancesEngagements: {
      requestedInstances: components["schemas"]["TimestampedVisitInstanceEngagement"][];
      rejectedInstances: components["schemas"]["TimestampedVisitInstanceEngagement"][];
      ignoredByAgencyMemberInstances: components["schemas"]["TimestampedVisitInstanceEngagement"][];
      cancelledInstances: components["schemas"]["TimestampedVisitInstanceEngagement"][];
    };
    TimestampedVisitInstanceEngagement: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      engagementTime: components["schemas"]["Instant"];
      rejectedReason?: string;
    };
    CaregiverAttendancePTOOverallRow: {
      labelId: components["schemas"]["CaregiverPtoLabelId"];
      labelText: string;
      overallMinutes: number;
      ptoSettingType: components["schemas"]["CaregiverPtoSettingType"];
      usageMinutes: number;
      leftoverMinutes: number;
      pendingMinutes: number;
    };
    /** Format: CaregiverPtoLabelId */
    CaregiverPtoLabelId: CaregiverPtoLabelId;
    /** @enum {string} */
    CaregiverPtoSettingType: "ACCUM" | "FIXED";
    CaregiverAttendancePTOBreakdownRow: {
      caregiverPtoInstanceId: components["schemas"]["CaregiverPtoInstanceId"];
      certification: components["schemas"]["CaregiverCertification"];
      ptoLabelText: string;
      dateTime: components["schemas"]["LocalDateTime"];
      durationMinutes: number;
      notes: string[];
    };
    /** Format: CaregiverPtoInstanceId */
    CaregiverPtoInstanceId: CaregiverPtoInstanceId;
    CaregiverAttendanceMissedVisit: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      durationMinutes: number;
      missedNotePredefinedAnswer: null | string;
      missedNoteText: null | string;
    };
    CaregiverAttendanceMissedClockInOut: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      missedType: components["schemas"]["ClocksType"];
    };
    /** @enum {string} */
    ClocksType: "IN" | "OUT";
    /** Format: CityTaxCodeId */
    CityTaxCodeId: CityTaxCodeId;
    /** @enum {string} */
    PayrollTaxDocumentType: "2020_ONWARDS" | "UNTIL_2020";
    CaregiverSearchItem: {
      id: components["schemas"]["CaregiverId"];
      externalId: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      status: components["schemas"]["CaregiverStatus"];
      gender: ("F" | "M") | null;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      address: null | string;
      photoUrl: null | string;
    };
    CaregiverProfileWithDisplayData: {
      hcwId: null | string;
      officeBranchIds: components["schemas"]["OfficeBranchId"][];
      officeNames: string[];
      branchNames: string[];
      certificationNames: string[];
      agencyAssocCreatedByAgencyMemberName: null | string;
      agencyAssocCreatedByCaregiverName: null | string;
      id: components["schemas"]["CaregiverId"];
      status: components["schemas"]["CaregiverStatus"];
      caregiverCode: null | string;
      officeIds: components["schemas"]["OfficeId"][];
      branchIds: components["schemas"]["AgencyBranchId"][];
      caregiverBranch?: null | string;
      workAreaPreference?: null | string;
      createdAt: components["schemas"]["Instant"];
      /** Format: date-time */
      birthDate: null | string;
      birthDateDate: components["schemas"]["LocalDate"] | null;
      phoneNumber: string;
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      homePhone: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      /** @description "M", "F" */
      gender: string;
      /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      address: string;
      address2: null | string;
      isCustomAddress: boolean;
      addressCounty: null | string;
      addressGeoLocation: components["schemas"]["Geo"];
      addressComponents?: components["schemas"]["AddressComponents"] | null;
      missingAddressFields?: string[];
      certifications: components["schemas"]["CaregiverCertification"][];
      photoUrl: null | string;
      photoUrlOriginal: null | string;
      installedUserAgent: null | string;
      appInstalledDate: components["schemas"]["Instant"] | null;
      appInstalled: boolean;
      appInstalledAt: components["schemas"]["Instant"][];
      appUninstalledAt: components["schemas"]["Instant"][];
      /** @description Is the caregiver's app currently open */
      online: boolean;
      /** @description When was the last time the caregiver was online? */
      lastSeen: components["schemas"]["Instant"] | null;
      notificationSettings?: components["schemas"]["NotificationSettings"];
      email: null | string;
      isFullTime: boolean;
      hireDate: components["schemas"]["LocalDate"] | null;
      rehireDate: components["schemas"]["LocalDate"] | null;
      terminationDate: components["schemas"]["LocalDate"] | null;
      isCompliant: boolean;
      stateRegistryNum: null | number;
      isClockEnabled: boolean;
      ssn: null | string;
      applicationStartDate: components["schemas"]["LocalDate"] | null;
      lastWorkDate: components["schemas"]["LocalDate"] | null;
      firstWorkDate: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      externalId: null | string;
      customFields: components["schemas"]["EntityCustomField"];
      blacklisted: components["schemas"]["PatientId"][] | null;
      emergencyContacts: components["schemas"]["CaregiverEmergencyContact"][];
      nextStatus?:
        | (
            | "ACTIVE"
            | "JOIN_REQUEST"
            | "ON_HOLD"
            | "ON_LEAVE"
            | "PENDING"
            | "QUIT"
            | "REJECTED"
            | "SUSPENDED"
            | "TERMINATED"
          )
        | null;
      nextStatusEffectiveDate?: components["schemas"]["LocalDate"] | null;
      isFromLandingPage: boolean;
      mainLanguage: string;
      glovesSize?: ("L" | "M" | "S" | "XL") | null;
      scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
      agencyIds?: components["schemas"]["AgencyId"][];
    };
    RafflePreviousWinner: {
      avatar: null | string;
      name: string;
      prize: string;
    };
    RaffleParticipant: {
      caregiverId: components["schemas"]["CaregiverId"];
      avatar: null | string;
      name: string;
      tokens: number;
    };
    RafflePrize: {
      name: string;
      image: string;
    };
    RaffleParticipationStatus:
      | {
          /** @enum {boolean} */
          isParticipating: true;
        }
      | {
          /** @enum {boolean} */
          isParticipating: false;
          /** @enum {string} */
          reason: "NOT_ENOUGH_SHIFTS";
          numRequiredShiftsLeft: number;
        }
      | {
          /** @enum {boolean} */
          isParticipating: false;
          /** @enum {string} */
          reason: "NO_CALL_NO_SHOW" | "NO_TOKENS" | "RECENTLY_WON";
        };
    NursePhoneCallsCount: {
      phoneNumber: string;
      callCount: number;
    };
    CaregiverStatusHistory: {
      id: components["schemas"]["CaregiverStatusHistoryId"];
      status: {
        id: components["schemas"]["CaregiverStatus"];
        value: string;
      };
      note: {
        id: components["schemas"]["NoteId"] | null;
        reason: null | string;
        message: null | string;
      };
      effectiveDate: components["schemas"]["LocalDate"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["CaregiverStatusHistoryCreatedBy"];
    };
    /** Format: CaregiverStatusHistoryId */
    CaregiverStatusHistoryId: CaregiverStatusHistoryId;
    CaregiverStatusHistoryCreatedBy:
      | {
          /** @enum {string} */
          entity: "AgencyMemberId";
          userDetails: {
            id: components["schemas"]["AgencyMemberId"];
            firstName: string;
            lastName: string;
          };
        }
      | {
          /** @enum {string} */
          entity: "CaregiverId";
          userDetails: {
            id: components["schemas"]["CaregiverId"];
            firstName: string;
            lastName: string;
          };
        };
    ChatRoom: {
      id: components["schemas"]["ChatRoomId"];
      chatRoomType: components["schemas"]["ChatRoomType"];
      members: components["schemas"]["ChatRoomMember"][];
      messages: components["schemas"]["ChatRoomMessage"][];
    };
    /** Format: ChatRoomId */
    ChatRoomId: ChatRoomId;
    ChatRoomType:
      | components["schemas"]["ChatRoomType.CaregiverVisitChat"]
      | components["schemas"]["ChatRoomType.AgencyMemberCaregiverChat"]
      | components["schemas"]["ChatRoomType.CaregiverPatientChat"]
      | components["schemas"]["ChatRoomType.InternalAgencyChat"];
    "ChatRoomType.CaregiverVisitChat": {
      /** @enum {string} */
      type: "CaregiverVisitChat";
      visitId: components["schemas"]["VisitBroadcastId"];
      caregiverId: components["schemas"]["CaregiverId"];
    };
    "ChatRoomType.AgencyMemberCaregiverChat": {
      /** @enum {string} */
      type: "AgencyMemberCaregiverChat";
      agencyMemberId: components["schemas"]["AgencyMemberId"];
      agencyId: components["schemas"]["AgencyId"];
      caregiverId: components["schemas"]["CaregiverId"];
    };
    "ChatRoomType.CaregiverPatientChat": {
      /** @enum {string} */
      type: "CaregiverPatientChat";
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      agencyId: components["schemas"]["AgencyId"];
      caregiverId: components["schemas"]["CaregiverId"];
    };
    "ChatRoomType.InternalAgencyChat": {
      /** @enum {string} */
      type: "InternalAgencyChat";
      agencyId: components["schemas"]["AgencyId"];
    };
    ChatRoomMember: {
      user: components["schemas"]["ChatRoomUser"];
      /**
       * @description Will be equal to the value of the "createdAt" field of the latest
       * ChatMessage that was viewed.
       */
      lastViewed: components["schemas"]["Instant"];
    };
    ChatRoomUser:
      | components["schemas"]["ChatRoomUser.Caregiver"]
      | components["schemas"]["ChatRoomUser.AgencyMember"];
    "ChatRoomUser.Caregiver": {
      /** @enum {string} */
      type: "Caregiver";
      caregiverId: components["schemas"]["CaregiverId"];
    };
    "ChatRoomUser.AgencyMember": {
      /** @enum {string} */
      type: "AgencyMember";
      agencyMemberId: components["schemas"]["AgencyMemberId"];
    };
    ChatRoomMessage: {
      /** @description When was this message sent */
      createdAt: components["schemas"]["Instant"];
      /**
       * @description Can be used by the client to hide/merge a message that is queued for sending,
       * to prevent it from being displayed twice.
       */
      requestId: string;
      user: components["schemas"]["ChatRoomUser"];
      broadcast: boolean;
      payload: components["schemas"]["ChatPayload"];
    };
    ChatPayload:
      | components["schemas"]["ChatPayload.Message"]
      | components["schemas"]["ChatPayload.Image"];
    "ChatPayload.Message": {
      /** @enum {string} */
      type: "Message";
      message: string;
      images?: string[];
    };
    /** @description (For future use...) */
    "ChatPayload.Image": {
      /** @enum {string} */
      type: "Image";
      imageUrl: string;
    };
    CheckLineWithVisitInstanceDetails: {
      patientName: null | string;
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      invoiceAdministrativePaymentId:
        | components["schemas"]["InvoiceAdministrativePaymentId"]
        | null;
      writeOffAmount: null | number;
      expectedTotalAmount: null | number;
      infoLines: components["schemas"]["CheckInfoLine"][];
      id: components["schemas"]["CheckLineId"];
      checkId: components["schemas"]["CheckId"];
      invoiceVisitId: components["schemas"]["InvoiceVisitId"] | null;
      payment: number;
      date: components["schemas"]["LocalDate"];
      depositDate?: components["schemas"]["LocalDate"] | null;
      notes?: null | string;
      invoiceId: components["schemas"]["InvoiceId"];
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      invoiceTime?: Instant;
      invoiceNumber?: null | string;
      claimNumber: string;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      /** Format: PatientId */
      patientId?: PatientId;
    };
    /** Format: InvoiceAdministrativePaymentId */
    InvoiceAdministrativePaymentId: InvoiceAdministrativePaymentId;
    CheckInfoLine:
      | components["schemas"]["CheckAdjustmentInfoLine"]
      | components["schemas"]["CheckRemarkInfoLine"];
    CheckAdjustmentInfoLine: {
      groupCode: string;
      reason: string;
      amount: number;
    };
    CheckRemarkInfoLine: {
      identifier: string;
      qualifier: string;
    };
    /** Format: CheckLineId */
    CheckLineId: CheckLineId;
    /** Format: CheckId */
    CheckId: CheckId;
    /** Format: InvoiceVisitId */
    InvoiceVisitId: InvoiceVisitId;
    CheckUnappliedLine: {
      id: components["schemas"]["CheckUnappliedLineId"];
      checkId: components["schemas"]["CheckId"];
      claimIndentifier: string;
      claimTransactionNumber: string;
      patientIdentifier: string;
      patientFirstName: string;
      patientLastName: string;
      date: components["schemas"]["LocalDate"];
      amount: number;
      adjustment: boolean;
      flaggedAsApplied: boolean;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      infoLines: components["schemas"]["CheckInfoLine"][];
    };
    /** Format: CheckUnappliedLineId */
    CheckUnappliedLineId: CheckUnappliedLineId;
    ClockinClockoutAttestation: {
      attestationVersionId: string;
      title: string;
      text: string;
      warning: null | string;
      footer: null | string;
    };
    /** Format: ClockinClockoutRecordId */
    ClockinClockoutRecordId: ClockinClockoutRecordId;
    /** Format: ClockinClockoutRecordIvrId */
    ClockinClockoutRecordIvrId: ClockinClockoutRecordIvrId;
    /** @enum {undefined} */
    CallType: "IN" | "OUT";
    ClockinClockoutCheckAdjustmentStatusResult:
      | {
          /** @enum {string} */
          status: "SUCCESS";
          adjustedUTC: components["schemas"]["Instant"];
          adjustedLocal: components["schemas"]["LocalDateTime"];
          offset: components["schemas"]["Duration"];
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          error: "OUTSIDE_OF_OFFSET";
          adjustedLocal: components["schemas"]["LocalDateTime"];
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          error: "CANT_ADJUST_DAY";
          adjustedLocal: components["schemas"]["LocalDateTime"];
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          error: "VISIT_ALREADY_CLOCKED_IN";
          adjustedLocal: components["schemas"]["LocalDateTime"];
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          error: "VISIT_BACK_TO_BACK";
          visitInstanceId: components["schemas"]["VisitInstanceId"];
          adjustedLocal: components["schemas"]["LocalDateTime"];
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          error: "VISIT_OVERLAPPING";
          visitInstanceId: components["schemas"]["VisitInstanceId"];
          adjustedLocal: components["schemas"]["LocalDateTime"];
        };
    Duration: string;
    /** @enum {undefined} */
    ClockTypes: "IN" | "OUT";
    ClockinClockoutLinkParam: {
      clockinClockoutRecordId: components["schemas"]["ClockinClockoutRecordId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      /** Format: CaregiverId */
      caregiverId?: CaregiverId;
      dutyIds?: components["schemas"]["PlanOfCareItemId"][];
    };
    ComplianceV2FieldInstanceWithValue:
      | components["schemas"]["ComplianceV2FieldInstanceWithValue.Date"]
      | components["schemas"]["ComplianceV2FieldInstanceWithValue.Text"]
      | components["schemas"]["ComplianceV2FieldInstanceWithValue.Dropdown"];
    "ComplianceV2FieldInstanceWithValue.Date": {
      /** @enum {string} */
      type: "Date";
      value: components["schemas"]["LocalDate"] | null;
      id: components["schemas"]["ComplianceV2ItemFieldId"];
      name: string;
      isMandatory: boolean;
      hrQuestionTemplateId?:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    /** Format: ComplianceV2ItemFieldId */
    ComplianceV2ItemFieldId: ComplianceV2ItemFieldId;
    /** Format: HRQuestionTemplateId */
    HRQuestionTemplateId: HRQuestionTemplateId;
    "ComplianceV2FieldInstanceWithValue.Text": {
      /** @enum {string} */
      type: "Text";
      value: null | string;
      id: components["schemas"]["ComplianceV2ItemFieldId"];
      name: string;
      isMandatory: boolean;
      hrQuestionTemplateId?:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    "ComplianceV2FieldInstanceWithValue.Dropdown": {
      /** @enum {string} */
      type: "Dropdown";
      possibleValues: components["schemas"]["ComplianceV2FieldPossibleValueInstance"][];
      value:
        | components["schemas"]["ComplianceV2FieldPossibleValueInstance"]
        | null;
      id: components["schemas"]["ComplianceV2ItemFieldId"];
      name: string;
      isMandatory: boolean;
      hrQuestionTemplateId?:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceV2FieldPossibleValueInstance: {
      id: components["schemas"]["ComplianceV2ItemFieldPossibleValueId"];
      text: string;
      followupDocumentRequireData:
        | components["schemas"]["ComplianceV2FollowupDocumentData"]
        | null;
      followupResolvesParent: boolean;
    };
    /** Format: ComplianceV2ItemFieldPossibleValueId */
    ComplianceV2ItemFieldPossibleValueId: ComplianceV2ItemFieldPossibleValueId;
    ComplianceV2FollowupDocumentData: {
      followupDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      followupDocumentRequireDate: components["schemas"]["LocalDate"] | null;
      followupDocumentRequireDateDynamic: {
        followupDocumentRequireUnit: components["schemas"]["ComplianceDocumentUnitType"];
        followupDocumentRequireAmount: number;
      } | null;
    };
    /** Format: CaregiverComplianceInstanceId */
    CaregiverComplianceInstanceId: CaregiverComplianceInstanceId;
    ComplianceInstanceCreate: {
      caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      isCompliant: boolean;
      effectiveDate: components["schemas"]["LocalDate"];
      /** Format: yyyy-MM-dd */
      expiryDate?: LocalDate;
      /** Format: CaregiverDocumentUploadId */
      caregiverDocumentUploadId?: CaregiverDocumentUploadId;
      fields: components["schemas"]["ComplianceV2FieldInstanceWithValue"][];
      fictiveType?: "due_date" | null;
      shouldDuplicateUploadForFollowup?: boolean;
      /** Format: CaregiverDocumentUploadId */
      duplicateDocumentUpload?: CaregiverDocumentUploadId;
      swapUploadedDocumentTypeId?: boolean;
    };
    ComplianceCaregiverRecord: {
      caregiverId: components["schemas"]["CaregiverId"];
      items: components["schemas"]["DashboardComplianceItem"][];
    };
    DashboardComplianceItem: {
      documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      status: components["schemas"]["ComplianceStatus"];
      effectiveDate: components["schemas"]["LocalDate"] | null;
      expiryDate: components["schemas"]["LocalDate"] | null;
      dueDate: components["schemas"]["LocalDate"] | null;
      latestInstanceId:
        | components["schemas"]["CaregiverComplianceInstanceId"]
        | null;
      uploadedAt: components["schemas"]["LocalDate"] | null;
      uploadedBy: components["schemas"]["AgencyMemberId"] | null;
      fields:
        | components["schemas"]["ComplianceV2FieldInstanceWithValue"][]
        | null;
    };
    /** @enum {string} */
    ComplianceStatus:
      | "Compliant"
      | "Missing"
      | "Not Compliant"
      | "Not due yet"
      | "Pending Uploads"
      | "Resolved";
    ComplianceDocument: {
      id: components["schemas"]["CaregiverDocumentTypeId"];
      name: string;
      section: string;
      children: components["schemas"]["CaregiverDocumentTypeId"][];
      isRoot: boolean;
      fields: components["schemas"]["ComplianceV2FieldInstance"][];
      expiryUnit: ("DAY" | "MONTH" | "WEEK") | null;
      expiryAmount: null | number;
      groupType: ("and" | "or") | null;
      expires: boolean;
      requireReVerification: boolean;
      certifications: components["schemas"]["CaregiverCertification"][];
    };
    ComplianceV2FieldInstance:
      | components["schemas"]["ComplianceV2FieldInstance.Date"]
      | components["schemas"]["ComplianceV2FieldInstance.Text"]
      | components["schemas"]["ComplianceV2FieldInstance.Dropdown"];
    "ComplianceV2FieldInstance.Date": {
      /** @enum {string} */
      type: "Date";
      id: components["schemas"]["ComplianceV2ItemFieldId"];
      name: string;
      isMandatory: boolean;
      hrQuestionTemplateId?:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    "ComplianceV2FieldInstance.Text": {
      /** @enum {string} */
      type: "Text";
      id: components["schemas"]["ComplianceV2ItemFieldId"];
      name: string;
      isMandatory: boolean;
      hrQuestionTemplateId?:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    "ComplianceV2FieldInstance.Dropdown": {
      /** @enum {string} */
      type: "Dropdown";
      possibleValues: components["schemas"]["ComplianceV2FieldPossibleValueInstance"][];
      id: components["schemas"]["ComplianceV2ItemFieldId"];
      name: string;
      isMandatory: boolean;
      hrQuestionTemplateId?:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    /** @description One row of the paged compliance dashboard: a caregiver and its items. */
    ComplianceDashboardPageRow: {
      caregiver: components["schemas"]["ComplianceDashboardCaregiver"];
      items: components["schemas"]["DashboardComplianceItem"][];
      /**
       * @description The followup document types this caregiver is missing, which is what
       * decides whether a blank cell reads "Missing" or "Not required". Sent per
       * row because the whole-agency map it replaces was the other half of what
       * kept this page loading everything.
       */
      missingFollowupDocumentTypeIds: components["schemas"]["CaregiverDocumentTypeId"][];
    };
    /**
     * @description The caregiver as the compliance dashboard's grid shows it.
     *
     * `CaregiverRowDisplay` plus the three columns the dashboard filters on, so the
     * page never needs a caregiver collection of its own. Deliberately not the wider
     * `CaregiverRecord`: the extra columns there cost a second query per page and
     * this grid displays none of them.
     */
    ComplianceDashboardCaregiver: {
      id: components["schemas"]["CaregiverId"];
      displayName: string;
      displayId: null | number;
      photoUrl: null | string;
      appInstalled: boolean;
      /**
       * @description Whether the app is connected right now, on the same ten-second window the
       * caregivers list uses. A snapshot taken when the request is served - the
       * dictionary used to be patched live by socket events, and nothing replaces
       * that.
       */
      isOnline: boolean;
      status: components["schemas"]["CaregiverStatus"];
      certifications: components["schemas"]["CaregiverCertification"][];
      hireDate: components["schemas"]["LocalDate"] | null;
      /** @description The agency association's compliance flag - the "Compliance" column. */
      isCompliant: boolean;
      /** @description `caregiver.from_landing_page` - the "Is Medflyt CG" filter. */
      isFromLandingPage: boolean;
      address: string;
      languages: string[];
      /** @description Office names, for the tab's Offices column. */
      officeNames: string[];
      /**
       * @description Number and type, not bare strings: the Caregiver Status column renders
       * "(212) 555-0100 (MOBILE)", so the type has to come with it.
       */
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      /** @description Last app heartbeat. `isOnline` above is the snapshot derived from it. */
      lastSeen: components["schemas"]["Instant"] | null;
      /**
       * @description A scheduled future status change, if one is pending - the tab shows "going
       * on hold on <date>" from it.
       */
      nextStatus: {
        status: components["schemas"]["CaregiverStatus"];
        effectiveDate: components["schemas"]["LocalDate"];
      } | null;
    };
    /**
     * @description What the grid can be ordered by.
     *
     * Only these three: the document-type columns hold compliance statuses, which
     * live in Postgres and are not in the search index, so there is no way to order
     * the whole result set by one of them. The paged view leaves those columns
     * unsortable rather than sorting a single page and looking like it sorted
     * everything.
     * @enum {string}
     */
    ComplianceDashboardSortField: "displayId" | "isCompliant" | "name";
    ComplianceStatsEmploymentStatus: {
      /** @enum {string} */
      status:
        | "ACTIVE"
        | "Future status of on hold"
        | "JOIN_REQUEST"
        | "ON_HOLD"
        | "ON_LEAVE"
        | "PENDING"
        | "QUIT"
        | "REJECTED"
        | "SUSPENDED"
        | "TERMINATED";
      caregiverIds: components["schemas"]["CaregiverId"][];
    };
    ComplianceStatsCaregiver: {
      /** @enum {string} */
      status: "Compliant" | "Not compliant" | "Not compliant in next 30 days";
      caregiverIds: components["schemas"]["CaregiverId"][];
    };
    ComplianceStatsItem: {
      documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      /** @enum {string} */
      status: "Compliant" | "Invalid in next 30 days" | "Not compliant";
      caregiverIds: components["schemas"]["CaregiverId"][];
    };
    ComplianceStatsIcompliantItemsWithUploadedDocuments: {
      length: number;
      caregiverIds: components["schemas"]["CaregiverId"][];
    };
    ComplianceDeclinedDocument: {
      /** @enum {string} */
      rejectedBy: "Agency Member" | "Reviewer" | "System";
      caregiverDocumentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      caregiverId: components["schemas"]["CaregiverId"];
    };
    HROnboardingStatistics: {
      caregiverId: components["schemas"]["CaregiverId"];
      certification: components["schemas"]["CaregiverCertification"];
      startedAt: components["schemas"]["Instant"];
      currentStage: {
        id: components["schemas"]["HRSectionStageId"];
        name: string;
        completion: number;
      };
      workReadiness: {
        completion: number;
        missingItems: components["schemas"]["WorkReadinessItems"][];
      };
      scheduledInterview: null | string;
      scheduleMedicals: components["schemas"]["ScheduleMedicalsType"];
      medicalsStatus: components["schemas"]["OnboardingMedicalsStatus"];
      pendingDocs: number;
      orientation: components["schemas"]["OrientationStatusType"];
      criminalBackground: components["schemas"]["CriminalBackgroundStatus"];
    };
    /** @enum {string} */
    WorkReadinessItems:
      | "Caregiver Certificate"
      | "Criminal Background"
      | "I-9"
      | "Medicals"
      | "Orientation"
      | "SSN Card";
    ScheduleMedicalsType:
      | {
          /** @enum {string} */
          type: "No need to schedule";
        }
      | {
          /** @enum {string} */
          type: "Waiting for appoitment";
        }
      | {
          /** @enum {string} */
          type: "N/A";
        }
      | {
          /** @enum {string} */
          type: "Scheduled";
          date: components["schemas"]["LocalDate"];
        };
    /** @enum {string} */
    OnboardingMedicalsStatus: "Done" | "In Progress" | "Missing";
    OrientationStatusType:
      | {
          /** @enum {string} */
          type: "Not Started";
        }
      | {
          /** @enum {string} */
          type: "Started";
          completion: number;
        };
    /** @enum {string} */
    CriminalBackgroundStatus: "Done" | "N/A" | "Pending" | "Rejected" | "Sent";
    CaregiverComplianceInstance: {
      id: components["schemas"]["CaregiverComplianceInstanceId"];
      caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      agencyId: components["schemas"]["AgencyId"];
      fields: components["schemas"]["ComplianceV2FieldInstanceWithValue"][];
      createdAt: components["schemas"]["Instant"];
      uploadedBy: string;
      caregiverId: components["schemas"]["CaregiverId"];
      isCompliant: boolean;
      expiryDate: components["schemas"]["LocalDate"] | null;
      effectiveDate: components["schemas"]["LocalDate"];
      caregiverDocumentUploadId:
        | components["schemas"]["CaregiverDocumentUploadId"]
        | null;
      fictiveType: "due_date" | null;
    };
    CaregiverDocumentUploadBasicDetails:
      | components["schemas"]["CaregiverDocumentUploadBasicDetails.CaregiverDocumentUploadBasicDetailsWithExpiration"]
      | components["schemas"]["CaregiverDocumentUploadBasicDetails.CaregiverDocumentUploadBasicDetailsWithoutExpiration"];
    "CaregiverDocumentUploadBasicDetails.CaregiverDocumentUploadBasicDetailsWithExpiration": {
      caregiverDocumentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      caregiverId: components["schemas"]["CaregiverId"];
      expirationDate: components["schemas"]["LocalDate"] | null;
      uploadDate: components["schemas"]["LocalDate"];
      complianceStatus: string;
      complianceRejectReason: null | string;
      complianceRejectedBy:
        | components["schemas"]["CaregiverDocumentUploadBasicDetails.RejectedBy"]
        | null;
    };
    "CaregiverDocumentUploadBasicDetails.RejectedBy": {
      id: components["schemas"]["AgencyMemberId"];
      fullName: string;
    };
    "CaregiverDocumentUploadBasicDetails.CaregiverDocumentUploadBasicDetailsWithoutExpiration": {
      caregiverDocumentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      caregiverId: components["schemas"]["CaregiverId"];
      uploadDate: components["schemas"]["LocalDate"];
      complianceStatus: string;
      complianceRejectReason: null | string;
      complianceRejectedBy:
        | components["schemas"]["CaregiverDocumentUploadBasicDetails.RejectedBy"]
        | null;
    };
    ComplianceInstanceHistory: {
      effectiveDate: components["schemas"]["LocalDate"];
      compliant: boolean;
    };
    ComplianceItemRejectReason: {
      code: string;
      message: string;
    };
    CompliancePrioritizedCaregiverByPendingDocuments: {
      extra: {
        chrc: {
          race: null | string;
          height: null | number;
          weight: null | number;
          eyeColor: null | string;
          hairColor: null | string;
          countryBorn: null | string;
        };
      };
      caregiver: {
        id: components["schemas"]["CaregiverId"];
        displayId: null | number;
        status: components["schemas"]["CaregiverStatus"];
        isCompliant: boolean;
        firstName: string;
        middleName: null | string;
        lastName: string;
        dateOfBirth: components["schemas"]["LocalDate"] | null;
        certifications: components["schemas"]["CaregiverCertification"][];
        gender: string;
        ssn: null | string;
        addressText: string;
        languages: string[];
        phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
        avatarUrl: null | string;
        stateRegistryNum: null | number;
        onboardingStage:
          | (
              | "generalDetails"
              | "interview"
              | "landingPage"
              | "onboarding1"
              | "onboarding2"
            )
          | null;
        orientationStatus: components["schemas"]["OrientationStatusType"];
      };
      documents: components["schemas"]["CompliancePriorityPendingDocument"][];
      sectionsItems: components["schemas"]["CompliancePrioritizedCaregiverSection"][];
      documentTypes: components["schemas"]["ComplianceDocument"][];
      uploadedDocuments: components["schemas"]["CompliancePriorityUploadedDocument"][];
    };
    CompliancePriorityPendingDocument: {
      caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      caregiverDocumentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      /** @enum {string} */
      type: "General" | "I-9" | "Medical";
      title: string;
      fields: components["schemas"]["ComplianceV2FieldInstance"][];
      expires: boolean;
      requireReVerification: boolean;
      defaultExpirySettings:
        | components["schemas"]["ComplianceItemDefaultExpirySettings"]
        | null;
      fileUrl: string;
      /** @enum {string} */
      fileType: "IMAGE" | "PDF";
      automationResult:
        | components["schemas"]["ComplianceItemAutomationResult"]
        | null;
    };
    ComplianceItemDefaultExpirySettings: {
      expiryUnit: components["schemas"]["ComplianceV2ExpiryDocumentUnitType"];
      expiryAmount: number;
    };
    /** @enum {string} */
    ComplianceV2ExpiryDocumentUnitType: "DAY" | "MONTH" | "WEEK";
    ComplianceItemAutomationResult: {
      item: {
        id: components["schemas"]["CaregiverDocumentTypeId"];
        name: string;
        uploadId: components["schemas"]["CaregiverDocumentUploadId"];
      };
      result: {
        status: string;
        message: null | string;
        runAt: components["schemas"]["LocalDateTime"] | null;
      };
      reviewersAnswers?: components["schemas"]["ComplianceQuestion"][][];
    };
    ComplianceQuestion:
      | components["schemas"]["ComplianceDropdownQuestion"]
      | components["schemas"]["ComplianceTextQuestion"]
      | components["schemas"]["ComplianceNumberQuestion"]
      | components["schemas"]["ComplianceDateQuestion"]
      | components["schemas"]["ComplianceChangeDocumentQuestion"];
    ComplianceDropdownQuestion: {
      /** @enum {string} */
      type: "dropdown";
      options: components["schemas"]["ComplianceQuestionOption"][];
      value: components["schemas"]["ComplianceReviewQuestionOptionId"] | null;
      id: components["schemas"]["ComplianceReviewQuestionId"];
      title: string;
      description: null | string;
      titleForAI: null | string;
      descriptionForAI: null | string;
      parentId: components["schemas"]["ComplianceReviewQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceReviewQuestionOptionId"]
        | null;
      approvalCondition:
        | components["schemas"]["ComplianceReviewApprovalCondition"]
        | null;
      linkedFieldId: components["schemas"]["ComplianceV2ItemFieldId"] | null;
      hardcodedFieldValue: null | string;
      prependFieldValue: null | string;
      isMandatory: boolean;
      isFuzzyMatch: boolean;
    };
    ComplianceQuestionOption: {
      id: components["schemas"]["ComplianceReviewQuestionOptionId"];
      title: string;
      rejectReason:
        | components["schemas"]["ComplianceReviewRejectReason"]
        | null;
      linkedPossibleValueId:
        | components["schemas"]["ComplianceV2ItemFieldPossibleValueId"]
        | null;
    };
    /** Format: ComplianceReviewQuestionOptionId */
    ComplianceReviewQuestionOptionId: ComplianceReviewQuestionOptionId;
    ComplianceReviewRejectReason: {
      id: components["schemas"]["ComplianceReviewRejectReasonId"];
      code: string;
      message: string;
      createComplianceRecord: boolean;
    };
    /** Format: ComplianceReviewRejectReasonId */
    ComplianceReviewRejectReasonId: ComplianceReviewRejectReasonId;
    /** Format: ComplianceReviewQuestionId */
    ComplianceReviewQuestionId: ComplianceReviewQuestionId;
    ComplianceReviewApprovalCondition: {
      id: components["schemas"]["ComplianceReviewApprovalConditionId"];
      operator: components["schemas"]["ComplianceReviewApprovalConditionOperator"];
      value: components["schemas"]["ComplianceReviewApprovalConditionValue"];
      rejectReason:
        | components["schemas"]["ComplianceReviewRejectReason"]
        | null;
    };
    /** Format: ComplianceReviewApprovalConditionId */
    ComplianceReviewApprovalConditionId: ComplianceReviewApprovalConditionId;
    /** @enum {string} */
    ComplianceReviewApprovalConditionOperator: "!=" | "<" | "=" | ">" | "~";
    ComplianceReviewApprovalConditionValue:
      | {
          /** @enum {string} */
          type: "text";
          value: string;
        }
      | {
          /** @enum {string} */
          type: "argument";
          value: components["schemas"]["ComplianceReviewApprovalConditionValueArgument"];
        }
      | {
          /** @enum {string} */
          type: "answerOfQuestionId";
          value: components["schemas"]["ComplianceReviewQuestionId"];
        }
      | {
          /** @enum {string} */
          type: "daysAgo";
          value: number;
        };
    /** @enum {string} */
    ComplianceReviewApprovalConditionValueArgument:
      | "caregiver.birth_date"
      | "caregiver.first_name"
      | "caregiver.full_name"
      | "caregiver.last_name"
      | "caregiver.middle_name";
    ComplianceTextQuestion: {
      /** @enum {string} */
      type: "text";
      value: null | string;
      id: components["schemas"]["ComplianceReviewQuestionId"];
      title: string;
      description: null | string;
      titleForAI: null | string;
      descriptionForAI: null | string;
      parentId: components["schemas"]["ComplianceReviewQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceReviewQuestionOptionId"]
        | null;
      approvalCondition:
        | components["schemas"]["ComplianceReviewApprovalCondition"]
        | null;
      linkedFieldId: components["schemas"]["ComplianceV2ItemFieldId"] | null;
      hardcodedFieldValue: null | string;
      prependFieldValue: null | string;
      isMandatory: boolean;
      isFuzzyMatch: boolean;
    };
    ComplianceNumberQuestion: {
      /** @enum {string} */
      type: "number";
      value: null | number;
      id: components["schemas"]["ComplianceReviewQuestionId"];
      title: string;
      description: null | string;
      titleForAI: null | string;
      descriptionForAI: null | string;
      parentId: components["schemas"]["ComplianceReviewQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceReviewQuestionOptionId"]
        | null;
      approvalCondition:
        | components["schemas"]["ComplianceReviewApprovalCondition"]
        | null;
      linkedFieldId: components["schemas"]["ComplianceV2ItemFieldId"] | null;
      hardcodedFieldValue: null | string;
      prependFieldValue: null | string;
      isMandatory: boolean;
      isFuzzyMatch: boolean;
    };
    ComplianceDateQuestion: {
      /** @enum {string} */
      type: "date";
      value: components["schemas"]["LocalDate"] | null;
      effectiveDateForDocumentTypeId:
        | components["schemas"]["CaregiverDocumentTypeId"]
        | null;
      isExpiryDate: boolean;
      id: components["schemas"]["ComplianceReviewQuestionId"];
      title: string;
      description: null | string;
      titleForAI: null | string;
      descriptionForAI: null | string;
      parentId: components["schemas"]["ComplianceReviewQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceReviewQuestionOptionId"]
        | null;
      approvalCondition:
        | components["schemas"]["ComplianceReviewApprovalCondition"]
        | null;
      linkedFieldId: components["schemas"]["ComplianceV2ItemFieldId"] | null;
      hardcodedFieldValue: null | string;
      prependFieldValue: null | string;
      isMandatory: boolean;
      isFuzzyMatch: boolean;
    };
    ComplianceChangeDocumentQuestion: {
      /** @enum {string} */
      type: "change_document";
      value: components["schemas"]["CaregiverDocumentUploadId"] | null;
      id: components["schemas"]["ComplianceReviewQuestionId"];
      title: string;
      description: null | string;
      titleForAI: null | string;
      descriptionForAI: null | string;
      parentId: components["schemas"]["ComplianceReviewQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceReviewQuestionOptionId"]
        | null;
      approvalCondition:
        | components["schemas"]["ComplianceReviewApprovalCondition"]
        | null;
      linkedFieldId: components["schemas"]["ComplianceV2ItemFieldId"] | null;
      hardcodedFieldValue: null | string;
      prependFieldValue: null | string;
      isMandatory: boolean;
      isFuzzyMatch: boolean;
    };
    CompliancePrioritizedCaregiverSection: {
      section: components["schemas"]["ComplianceDocumentSection"];
      items: components["schemas"]["CompliancePrioritizedCaregiverItem"][];
    };
    /** @enum {string} */
    ComplianceDocumentSection: "General" | "I-9" | "Medical";
    CompliancePrioritizedCaregiverItem: {
      documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      title: string;
      status: components["schemas"]["ComplianceStatus"];
      section: components["schemas"]["ComplianceDocumentSection"];
      groupType: ("and" | "or") | null;
      parentId: components["schemas"]["CaregiverDocumentTypeId"] | null;
    };
    CompliancePriorityUploadedDocument: {
      caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      caregiverDocumentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      title: string;
      fileUrl: string;
      /** @enum {string} */
      fileType: "IMAGE" | "PDF";
      complianceStatus: components["schemas"]["ComplianceStatus"];
      section: components["schemas"]["ComplianceDocumentSection"];
      status: components["schemas"]["UploadedDocumentStatus"];
      uploadedAt: components["schemas"]["LocalDate"];
      rejectionReason: null | string;
    };
    /** @enum {string} */
    UploadedDocumentStatus: "Approved" | "Dismissed" | "Pending" | "Rejected";
    ComplianceAiReviewManualCheckCaregiver: {
      id: components["schemas"]["CaregiverId"];
      displayId: null | number;
      status: components["schemas"]["CaregiverStatus"];
      isCompliant: boolean;
      firstName: string;
      middleName: null | string;
      lastName: string;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      certifications: components["schemas"]["CaregiverCertification"][];
      gender: string;
      ssn: null | string;
      addressText: string;
      languages: string[];
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      avatarUrl: null | string;
      stateRegistryNum: null | number;
    };
    ComplianceAiReviewManualCheckDocument: {
      caregiverDocumentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
      caregiverDocumentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      /** @enum {string} */
      type: "General" | "I-9" | "Medical";
      title: string;
      fields: components["schemas"]["ComplianceV2FieldInstance"][];
      expires: boolean;
      requireReVerification: boolean;
      defaultExpirySettings:
        | components["schemas"]["ComplianceItemDefaultExpirySettings"]
        | null;
      fileUrl: string;
      /** @enum {string} */
      fileType: "IMAGE" | "PDF";
      automationResult:
        | components["schemas"]["ComplianceItemAutomationResult"]
        | null;
      complianceStatus: components["schemas"]["ComplianceStatus"];
      section: components["schemas"]["ComplianceDocumentSection"];
      status: components["schemas"]["UploadedDocumentStatus"];
      uploadedAt: components["schemas"]["LocalDate"];
      rejectionReason: null | string;
      reviewStatus: null | string;
    };
    CaregiverComplianceItemMobile: {
      documentType: {
        id: components["schemas"]["CaregiverDocumentTypeId"];
        name: string;
        section: components["schemas"]["ComplianceDocumentSection"];
        isPassport: boolean;
        groupType: ("and" | "or") | null;
        children: components["schemas"]["CaregiverDocumentTypeGroupInfo"][];
        isFillable: boolean;
        fillableUploadAlternative:
          | components["schemas"]["CaregiverDocumentTypeId"]
          | null;
        adhocType: ("flu" | "i-9") | null;
        requiresReVerification: boolean;
        requiresExpiryDate: boolean;
      };
      complianceStatus: components["schemas"]["ComplianceStatus"];
      dueDate: components["schemas"]["LocalDate"] | null;
      expiryDate: components["schemas"]["LocalDate"] | null;
      uploads: components["schemas"]["CaregiverUploadDocumentMobile"][];
      referenceDocumentData:
        | components["schemas"]["CaregiverComplianceReferenceDocumentData"]
        | null;
      isHidden: boolean;
    };
    CaregiverDocumentTypeGroupInfo: {
      id: components["schemas"]["CaregiverDocumentTypeId"];
      parentId: components["schemas"]["CaregiverDocumentTypeId"] | null;
      name: string;
      groupType: ("and" | "or") | null;
      isPassport: boolean;
      isFillable: boolean;
      children: components["schemas"]["CaregiverDocumentTypeGroupInfo"][];
    };
    CaregiverUploadDocumentMobile: {
      id: components["schemas"]["CaregiverDocumentUploadId"];
      url: string;
      createdAt: components["schemas"]["Instant"];
      status: components["schemas"]["UploadedDocumentStatus"];
      rejectReason: null | string;
      documentNamesTrail: string[];
      expires: boolean;
    };
    CaregiverComplianceReferenceDocumentData: {
      referenceName: null | string;
      referencePhoneNumber: null | string;
      referenceLink: null | string;
      uploadAlternative:
        | components["schemas"]["CaregiverDocumentTypeId"]
        | null;
    };
    ComplianceFormDocument: {
      id: components["schemas"]["ComplianceFormDocumentId"];
      documentType: {
        id: components["schemas"]["CaregiverDocumentTypeId"];
        name: string;
      };
      questions: components["schemas"]["ComplianceFormQuestion"][];
    };
    /** Format: ComplianceFormDocumentId */
    ComplianceFormDocumentId: ComplianceFormDocumentId;
    ComplianceFormQuestion:
      | components["schemas"]["ComplianceFormRadioQuestion"]
      | components["schemas"]["ComplianceFormTextQuestion"]
      | components["schemas"]["ComplianceFormYesNoQuestion"]
      | components["schemas"]["ComplianceFormDateQuestion"]
      | components["schemas"]["ComplianceFormPhoneNumberQuestion"]
      | components["schemas"]["ComplianceFormSignatureQuestion"]
      | components["schemas"]["ComplianceFormPlainTextQuestion"]
      | components["schemas"]["ComplianceFormDocumentQuestion"];
    ComplianceFormRadioQuestion: {
      /** @enum {string} */
      type: "radio";
      options: components["schemas"]["ComplianceFormQuestionOption"][];
      value: components["schemas"]["ComplianceFormQuestionOptionId"] | null;
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceFormQuestionOption: {
      id: components["schemas"]["ComplianceFormQuestionOptionId"];
      title: string;
    };
    /** Format: ComplianceFormQuestionOptionId */
    ComplianceFormQuestionOptionId: ComplianceFormQuestionOptionId;
    /** Format: ComplianceFormQuestionId */
    ComplianceFormQuestionId: ComplianceFormQuestionId;
    ComplianceFormTextQuestion: {
      /** @enum {string} */
      type: "text";
      value: null | string;
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceFormYesNoQuestion: {
      /** @enum {string} */
      type: "yesno";
      value: null | boolean;
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceFormDateQuestion: {
      /** @enum {string} */
      type: "date";
      value: components["schemas"]["LocalDate"] | null;
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceFormPhoneNumberQuestion: {
      /** @enum {string} */
      type: "phone_number";
      value: null | string;
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceFormSignatureQuestion: {
      /** @enum {string} */
      type: "signature";
      value: null | string;
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceFormPlainTextQuestion: {
      /** @enum {string} */
      type: "plain_text";
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ComplianceFormDocumentQuestion: {
      /** @enum {string} */
      type: "document";
      value: null | string;
      isRequired: boolean;
      id: components["schemas"]["ComplianceFormQuestionId"];
      title: string;
      description: null | string;
      parentId: components["schemas"]["ComplianceFormQuestionId"] | null;
      parentOptionId:
        | components["schemas"]["ComplianceFormQuestionOptionId"]
        | null;
      parentBooleanValue: null | boolean;
      hrQuestionTemplateId:
        | components["schemas"]["HRQuestionTemplateId"]
        | null;
    };
    ReviewDocumentRecord: {
      id: components["schemas"]["ComplianceReviewRecordId"];
      reviewDocumentId: components["schemas"]["ComplianceReviewDocumentId"];
      documentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      name: string;
      fileUrl: string;
      /** @enum {string} */
      fileType: "IMAGE" | "PDF";
      examples: {
        valid: string[];
        invalid: string[];
      };
      ttl: number;
    };
    /** Format: ComplianceReviewRecordId */
    ComplianceReviewRecordId: ComplianceReviewRecordId;
    /** Format: ComplianceReviewDocumentId */
    ComplianceReviewDocumentId: ComplianceReviewDocumentId;
    ComplianceReviewUploadedDocument: {
      caregiverDocumentUploadId: components["schemas"]["CaregiverDocumentUploadId"];
      fileUrl: string;
      /** @enum {string} */
      fileType: "IMAGE" | "PDF";
    };
    /**
     * @description Describes a single issue toggle for the override editor UI. `key` is the issue
     * suffix shared by the `billing_issue_<key>` / `payroll_issue_<key>` fields.
     */
    IssueTypeMeta: {
      key: string;
      label: string;
      tooltip: string;
      groups: components["schemas"]["IssueGroup"][];
    };
    /** @enum {string} */
    IssueGroup: "billing" | "payroll";
    /**
     * @description A service code connected to the contract type via Direct Care Rates (`billing_rate`),
     * eligible to receive an override.
     */
    EligibleServiceCode: {
      id: components["schemas"]["ServiceCodeId"];
      code: string;
    };
    ServiceCodeIssuesSetting: {
      contractTypeId: components["schemas"]["ContractTypeId"];
      officeId: components["schemas"]["OfficeId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      billing_issue_no_caregiver: null | boolean;
      billing_issue_clockin_time_mismatch: null | boolean;
      billing_issue_clockout_time_mismatch: null | boolean;
      billing_issue_calendar_day_mismatch: null | boolean;
      billing_issue_daily_minimum_hours_not_met: null | boolean;
      billing_issue_has_patient_overlap_issue: null | boolean;
      billing_issue_has_caregiver_overlap_issue: null | boolean;
      billing_issue_overbilled_day: null | boolean;
      billing_issue_missing_dx_codes: null | boolean;
      billing_issue_missed_visit_no_travel_time: null | boolean;
      billing_issue_no_billing_rate: null | boolean;
      billing_issue_no_billing_rate_county: null | boolean;
      billing_issue_missing_clock_times: null | boolean;
      billing_issue_invalid_authorization_assignment: null | boolean;
      billing_issue_missing_authorization_hours: null | boolean;
      billing_issue_missing_matching_mutual_visit: null | boolean;
      billing_issue_zero_billing_units: null | boolean;
      billing_issue_authorization_over_allocation: null | boolean;
      billing_issue_schedule_auth_allocation_conflict: null | boolean;
      billing_issue_no_matching_authorization: null | boolean;
      billing_issue_unapproved_manual_clock_time_edit: null | boolean;
      billing_issue_caregiver_incompliant: null | boolean;
      billing_issue_insufficient_visit_duties: null | boolean;
      billing_issue_missing_personal_care_duty: null | boolean;
      billing_issue_excessive_clock_distance: null | boolean;
      billing_issue_manual_hold_invoicing: null | boolean;
      billing_issue_zero_dollar_pay_rate: null | boolean;
      billing_issue_missing_caregiver_ssn: null | boolean;
      billing_issue_missing_patient_member_id: null | boolean;
      billing_issue_missing_address: null | boolean;
      payroll_issue_no_caregiver: null | boolean;
      payroll_issue_clockin_time_mismatch: null | boolean;
      payroll_issue_clockout_time_mismatch: null | boolean;
      payroll_issue_calendar_day_mismatch: null | boolean;
      payroll_issue_daily_minimum_hours_not_met: null | boolean;
      payroll_issue_has_patient_overlap_issue: null | boolean;
      payroll_issue_has_caregiver_overlap_issue: null | boolean;
      payroll_issue_overbilled_day: null | boolean;
      payroll_issue_missing_dx_codes: null | boolean;
      payroll_issue_missed_visit_no_travel_time: null | boolean;
      payroll_issue_no_billing_rate: null | boolean;
      payroll_issue_no_billing_rate_county: null | boolean;
      payroll_issue_missing_clock_times: null | boolean;
      payroll_issue_invalid_authorization_assignment: null | boolean;
      payroll_issue_missing_authorization_hours: null | boolean;
      payroll_issue_missing_matching_mutual_visit: null | boolean;
      payroll_issue_zero_billing_units: null | boolean;
      payroll_issue_authorization_over_allocation: null | boolean;
      payroll_issue_schedule_auth_allocation_conflict: null | boolean;
      payroll_issue_no_matching_authorization: null | boolean;
      payroll_issue_unapproved_manual_clock_time_edit: null | boolean;
      payroll_issue_caregiver_incompliant: null | boolean;
      payroll_issue_insufficient_visit_duties: null | boolean;
      payroll_issue_missing_personal_care_duty: null | boolean;
      payroll_issue_excessive_clock_distance: null | boolean;
      payroll_issue_manual_hold_invoicing: null | boolean;
      payroll_issue_zero_dollar_pay_rate: null | boolean;
    };
    ContractType: {
      id: components["schemas"]["ContractTypeId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      agency: components["schemas"]["AgencyId"];
      payer: components["schemas"]["PayerId"];
      name: string;
      offices: components["schemas"]["Office"][];
      active: boolean;
      effectiveDate: components["schemas"]["LocalDate"];
      expirationDate: components["schemas"]["LocalDate"];
      wageParity: boolean;
      roundingUnit: components["schemas"]["PaymentRoundingUnit"];
      roundingDirection: components["schemas"]["PaymentRoundingDirection"];
      timelyFilingLimit: number;
      adjustmentTimelyFilingLimit: number;
      contractPaymentTerms: number;
      notificationPaymentTerms: number;
      weeksToCreateWithNoAuth: number;
      assignedARAgencyMemberId: components["schemas"]["AgencyMemberId"] | null;
      exportType: null | string;
      exportAdmissionDateType: null | string;
      invoiceCalendarSplit: components["schemas"]["ContractTypeInvoiceCalendarSplitTypes"];
      requiredDutyCount: null | number;
      exportShowAuthorization: null | boolean;
      exportShowNMSegment: null | boolean;
      exportShowMedicalRecordNumber: null | boolean;
      showBillingProviderNPI: null | boolean;
      secondaryBillingIdentifier: "MMIS" | null;
      ediIncludeCaregiverStateRegistry: boolean;
      ediIncludeCaregiverHcwId: boolean;
      ediBillSplitShiftsSeparately: boolean;
      ediBillSameDayCaregiversSeparately: boolean;
      requiredPersonalCareDuty: null | boolean;
      startOfAuthWeek: components["schemas"]["DayOfWeek"];
      allowBillPendingVisits: boolean;
      onlyPayBilledVisits: boolean;
      clockInToleranceMinutes: number;
      clockOutToleranceMinutes: number;
      eBillingProvider: components["schemas"]["EBillingProviderType"];
      evvAggregator:
        | (
            | "Emedny"
            | "HHAExchange - API"
            | "HHAExchange - SFTP"
            | "Sandata"
            | "Tellus"
          )
        | null;
      cms1500Type: ("Medicaid" | "Medicare" | "Other") | null;
      cms1500SignaturePerson: null | string;
      autoApproveAdmissionDate: boolean;
      autoApproveAuthNumber: boolean;
      autoApproveBillingRate: boolean;
      autoApproveDiagnosisCodes: boolean;
      autoApproveIsHoliday: boolean;
      autoApproveLocation: boolean;
      autoApproveOffice: boolean;
      autoApprovePatientInfo: boolean;
      autoApproveVisitRate: boolean;
      etin: null | string;
      mmis: null | string;
      exportGSReceiverIdCode: null | string;
      exportBillingUnitsDivision: null | boolean;
      certificationPeriodDuration: null | number;
      ediClaimFilingIndicatorCode: null | string;
      ediFaciltyTypeCode: null | string;
      ediShowCompositeMedicalProcedureIdentifier: null | boolean;
      ediPAPromiseIdentifier: null | string;
      ediHideHCServiceIfEmptyProcedureCode: null | boolean;
      administrativePaymentDxCode: {
        id: components["schemas"]["ICD10CodeId"];
        shortDesc: string;
        formattedDxCode: string;
      } | null;
      isRnPlatformClient: boolean;
      rnPlatformAgencyId: components["schemas"]["AgencyId"] | null;
    };
    /** Format: PayerId */
    PayerId: PayerId;
    Office: {
      id: components["schemas"]["OfficeId"];
      name: string;
      agencyId: components["schemas"]["AgencyId"];
      active: boolean;
      address: string;
      address2: null | string;
      addressComponents: components["schemas"]["AddressComponents"] | null;
      timezone: string;
      hhaExternalIds?: null | string;
      phoneNumber: null | string;
      tax_id: null | string;
      npi: null | string;
      provider_id: null | string;
      external_name: null | string;
      pfi: null | string;
      onlyPayBilledVisits: boolean;
      allowBillPendingVisits: boolean;
      requireCaregiverAssignWithOvertimePermission: boolean;
      broadcastBasedOnCaregiverOfficeBranch: boolean;
      showPayratesToCaregivers: boolean;
    };
    /** @enum {number} */
    PaymentRoundingUnit: 1 | 15 | 30 | 60;
    /** @enum {string} */
    PaymentRoundingDirection:
      | "CLOSEST"
      | "CLOSEST_MINIMUM_ONE_UNIT"
      | "DOWN"
      | "UP";
    ContractTypeInvoiceCalendarSplitTypes: ("DAY" | "MONTH" | "WEEK") | null;
    /** @enum {string} */
    EBillingProviderType:
      | "Authenticare - Claims"
      | "CMS-1500"
      | "CSV"
      | "EDI - Availity"
      | "EDI - PA Promise"
      | "EDI - eMedNY"
      | "EDI File"
      | "HHAExchange"
      | "IL488"
      | "MSA-1904"
      | "PDF File"
      | "Tellus"
      | "UB04";
    ContractExtendedData: {
      id: components["schemas"]["PatientContractId"];
      createdAt: components["schemas"]["Instant"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      contractTypeName: string;
      payerId: components["schemas"]["PayerId"];
      payerName: string;
      isPrimary: null | boolean;
      isOnHold: null | boolean;
      patientId: components["schemas"]["PatientId"];
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"] | null;
      medicaidNumber: null | string;
      medicareNumber: null | string;
      memberId: string;
      serviceCodeName: null | string;
      treatments: components["schemas"]["TreatmentExtendedData"][];
      treatmentCount: number;
      hhaPayer: components["schemas"]["HHAPayersByPatientId"] | null;
      hhaPayerName: null | string;
      files: string[];
      fileDetails: components["schemas"]["PatientContractFileDetails"][];
      isRnPlatformClient: boolean;
    };
    TreatmentExtendedData: {
      id: components["schemas"]["TreatmentId"];
      createdAt: components["schemas"]["Instant"];
      startOfPeriod: components["schemas"]["LocalDate"] | null;
      endOfPeriod: components["schemas"]["LocalDate"] | null;
      visits: components["schemas"]["CoordinatorVisitDetails"][];
      medicalOrders: components["schemas"]["TreatmentMedicalOrder"][];
      diagnosis: components["schemas"]["TreatmentDiagnosis"][];
      advanceDirectives: components["schemas"]["TreatmentAdvanceDirective"][];
      accepted_services: string[];
      experience_required_by_the_caregiver: string[];
      auth_number: null | string;
      eligibility_sunday: null | number;
      eligibility_monday: null | number;
      eligibility_tuesday: null | number;
      eligibility_wednesday: null | number;
      eligibility_thursday: null | number;
      eligibility_friday: null | number;
      eligibility_saturday: null | number;
      rn_assessment_done_by_admission_source: null | boolean;
      rn_assessment_required: null | boolean;
      rn_assessment_done: components["schemas"]["LocalDate"] | null;
      next_rn_assessment_required: components["schemas"]["LocalDate"] | null;
    };
    /** Format: TreatmentId */
    TreatmentId: TreatmentId;
    /** @description Exposes information about a visit that is permissible to be viewed by agency members */
    CoordinatorVisitDetails: {
      id: components["schemas"]["VisitBroadcastId"];
      treatmentId: components["schemas"]["TreatmentId"] | null;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMember"];
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
      previewedBy: components["schemas"]["CaregiverWithReason"][];
      moreDetailsViewedBy: components["schemas"]["CaregiverWithReason"][];
      acceptedBy: components["schemas"]["CaregiverAccepted"][];
      ignoredRequestsBy: components["schemas"]["Caregiver"][];
      pendingConfirmationRequests:
        | components["schemas"]["FlexibleVisitEngagementPendingConfirmationTo"][]
        | components["schemas"]["VisitEngagementPendingConfirmationTo"][];
      assignedCaregiver: components["schemas"]["Caregiver"] | null;
      assignedAt: components["schemas"]["Instant"] | null;
      cancelled: boolean;
      cancelledDate: components["schemas"]["Instant"] | null;
      cancelledByCaregiver: boolean;
      cancelledReason: null | string;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      /** @description Is this a single visit or recurring visit? */
      isSingleVisit: boolean;
      /** @description Defines the time slots of the visit over a given week. */
      dayTimeParams: components["schemas"]["VisitDayTimeParams"] | null;
      /** @description USD, integer cents. "$10.99" equals the value 1099 */
      price: null | number;
      certification: components["schemas"]["CaregiverCertification"][];
      /** @description "M" or "F" (or null for either gender) */
      gender: null | string;
      /** @description "M" or "F" (or null for either gender) */
      patientGender: null | string;
      /** @description Must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      generalNotes: string;
      patientName: string;
      patientAddress: string;
      patientAddress2: null | string;
      patientAddressInstructions: null | string;
      patientAddressComponents: components["schemas"]["AddressComponents"];
      patientAddressLoc: components["schemas"]["Geo"];
      /** @description timezone from the tz database (IANA) */
      timezone: string;
      /** @description Value is in meters */
      assignableCaregiverRadius: null | number;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
      salesRep: null | string;
      referralDate: components["schemas"]["LocalDate"] | null;
      referralSource: null | string;
      paymentType: null | string;
      hideEndDateFromCaregiver: null | boolean;
      isPreAssigned: boolean;
      fullTimeOffered: components["schemas"]["CaregiverId"] | null;
      fullTimeOfferRejected: boolean;
      rnVisitParams: components["schemas"]["RNVisitParams"];
      visitLabels: components["schemas"]["VisitLabelText"][];
      flexibleVisitParams:
        | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
        | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
        | components["schemas"]["PermanentFixedHoursFlexibleDays"]
        | components["schemas"]["SingleFlexible"]
        | null;
      splitShiftParams: components["schemas"]["SplitShiftParams"] | null;
      splitShiftFullyAssigned: null | boolean;
      isGradual: boolean;
      requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
      originalVisitDetails:
        | components["schemas"]["OriginalVisitDetails"]
        | null;
      patientId: components["schemas"]["PatientId"];
      planOfCareType: components["schemas"]["PlanOfCareTypeId"] | null;
      awaitingCaregiverPatientContact:
        | components["schemas"]["CaregiverId"]
        | null;
      patientContactEndTime: components["schemas"]["Instant"] | null;
      patientAdmissionId?: null | string;
      isNewVisitType: boolean;
      assignedCaregiverIds: components["schemas"]["CaregiverId"][];
      visitInstancesCount: number;
      broadcastType: null | string;
      originalStartTime: components["schemas"]["LocalDateTime"];
      allowMultipleCaregivers: boolean;
      visitInstances?: components["schemas"]["VisitInstance"][] | null;
      visitInfo?: string[] | null;
      isVisitAssignmentBlocked: boolean;
      relatedVisitAssignmentId?:
        | components["schemas"]["VisitAssignmentId"]
        | null;
    };
    CaregiverWithReason: {
      caregiver: components["schemas"]["Caregiver"];
      reason: null | string;
    };
    CaregiverAccepted: {
      acceptedData:
        | components["schemas"]["CaregiverFlexibleVisitRequestParams"][]
        | null;
      distanceInMiles: null | number;
      requestedInstances: components["schemas"]["VisitInstanceId"][] | null;
      id: components["schemas"]["CaregiverId"];
      status: components["schemas"]["CaregiverStatus"];
      caregiverCode: null | string;
      officeIds: components["schemas"]["OfficeId"][];
      officeNames?: string[];
      branchIds: components["schemas"]["AgencyBranchId"][];
      branchNames?: string[];
      caregiverBranch?: null | string;
      workAreaPreference?: null | string;
      createdAt: components["schemas"]["Instant"];
      /** Format: date-time */
      birthDate: null | string;
      birthDateDate: components["schemas"]["LocalDate"] | null;
      phoneNumber: string;
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      homePhone: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      /** @description "M", "F" */
      gender: string;
      /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      address: string;
      address2: null | string;
      isCustomAddress: boolean;
      addressCounty: null | string;
      addressGeoLocation: components["schemas"]["Geo"];
      addressComponents?: components["schemas"]["AddressComponents"] | null;
      missingAddressFields?: string[];
      certifications: components["schemas"]["CaregiverCertification"][];
      certificationNames?: string[];
      agencyAssocCreatedByAgencyMemberName?: null | string;
      agencyAssocCreatedByCaregiverName?: null | string;
      photoUrl: null | string;
      photoUrlOriginal: null | string;
      installedUserAgent: null | string;
      appInstalledDate: components["schemas"]["Instant"] | null;
      appInstalled: boolean;
      appInstalledAt: components["schemas"]["Instant"][];
      appUninstalledAt: components["schemas"]["Instant"][];
      /** @description Is the caregiver's app currently open */
      online: boolean;
      /** @description When was the last time the caregiver was online? */
      lastSeen: components["schemas"]["Instant"] | null;
      notificationSettings?: components["schemas"]["NotificationSettings"];
      email: null | string;
      isFullTime: boolean;
      hireDate: components["schemas"]["LocalDate"] | null;
      rehireDate: components["schemas"]["LocalDate"] | null;
      terminationDate: components["schemas"]["LocalDate"] | null;
      isCompliant: boolean;
      stateRegistryNum: null | number;
      isClockEnabled: boolean;
      ssn: null | string;
      applicationStartDate: components["schemas"]["LocalDate"] | null;
      lastWorkDate: components["schemas"]["LocalDate"] | null;
      firstWorkDate: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      externalId: null | string;
      customFields: components["schemas"]["EntityCustomField"];
      blacklisted: components["schemas"]["PatientId"][] | null;
      emergencyContacts: components["schemas"]["CaregiverEmergencyContact"][];
      nextStatus?:
        | (
            | "ACTIVE"
            | "JOIN_REQUEST"
            | "ON_HOLD"
            | "ON_LEAVE"
            | "PENDING"
            | "QUIT"
            | "REJECTED"
            | "SUSPENDED"
            | "TERMINATED"
          )
        | null;
      nextStatusEffectiveDate?: components["schemas"]["LocalDate"] | null;
      isFromLandingPage: boolean;
      mainLanguage: string;
      glovesSize?: ("L" | "M" | "S" | "XL") | null;
      scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
      agencyIds?: components["schemas"]["AgencyId"][];
    };
    FlexibleVisitEngagementPendingConfirmationTo: {
      caregiverId: components["schemas"]["CaregiverId"];
      pendingConfirmationShifts: components["schemas"]["CaregiverFlexibleVisitRequestParams"][];
      pendingConfirmationUntil: components["schemas"]["Instant"];
      pendingConfirmationConfirmedAt: components["schemas"]["Instant"] | null;
    };
    VisitEngagementPendingConfirmationTo: {
      caregiverId: components["schemas"]["CaregiverId"];
      pendingConfirmationInstances: components["schemas"]["VisitEngagementPendingConfirmationInstances"][];
    };
    VisitEngagementPendingConfirmationInstances: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      pendingConfirmationUntil: components["schemas"]["Instant"];
    };
    VisitDayTimeParams: {
      dayTimes: components["schemas"]["VisitDayTimeDeprecated"][];
      daysPerWeek?: null | string | number;
      daysOfWeek?: string[] | null;
      sessionHours?: null | string | number;
    };
    VisitDayTimeDeprecated: {
      /** @description 0 = sunday, 1 = monday, ... , 6 = saturday */
      day: number;
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
    };
    RNVisitParams: components["schemas"]["IRNVisitParams"] | null;
    IRNVisitParams: {
      /** @description duration in minutes */
      duration: number;
      isFlexible: boolean;
      /**
       * @description Either it exists and consider the value or it doesn't and it's false
       *
       * Basically optional so there won't be a migration on the db
       */
      contactPatient?: boolean;
      category?: string;
    };
    VisitLabelText: {
      text: string;
      color: string;
    };
    SplitShiftParams: {
      availableShifts: components["schemas"]["SplitShiftShift"][];
      /** @description Always between 0:00 and 12:00 (shifts are always 12 hours) */
      shiftChangeTime: components["schemas"]["LocalTime"];
      minShiftsPerCaregiver: number;
      maxShiftsPerCaregiver: number;
    };
    SplitShiftShift: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      /**
       * @description 0 or 1 (0 is morning, 1 is evening)
       * @enum {number}
       */
      shiftNum: 0 | 1;
    };
    /** Format: PatientDocumentTypeId */
    PatientDocumentTypeId: PatientDocumentTypeId;
    OriginalVisitDetails: {
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      startTimeUTC: components["schemas"]["Instant"];
      endTimeUTC: components["schemas"]["Instant"];
      isSingleVisit?: boolean;
      dayTimeParams?: components["schemas"]["VisitDayTimeParams"] | null;
      recurringVisitParams?: components["schemas"]["VisitDayTimeParams"] | null;
      rnVisitParams: components["schemas"]["RNVisitParams"];
      flexibleVisitParams:
        | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
        | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
        | components["schemas"]["PermanentFixedHoursFlexibleDays"]
        | components["schemas"]["SingleFlexible"]
        | null;
      isPreAssigned: boolean;
    };
    /** Format: PlanOfCareTypeId */
    PlanOfCareTypeId: PlanOfCareTypeId;
    VisitInstance: {
      id: components["schemas"]["VisitInstanceId"];
      agencyId: components["schemas"]["AgencyId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      masterWeekId: components["schemas"]["MasterWeekId"] | null;
      patientId: components["schemas"]["PatientId"];
      officeId: components["schemas"]["OfficeId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      clockinUpdatedBy: components["schemas"]["UserId"] | null;
      clockoutUpdatedBy: components["schemas"]["UserId"] | null;
      clockinUpdatedAt: components["schemas"]["Instant"] | null;
      clockoutUpdatedAt: components["schemas"]["Instant"] | null;
      clockinTime: components["schemas"]["LocalDateTime"] | null;
      clockoutTime: components["schemas"]["LocalDateTime"] | null;
      clockinLocation: components["schemas"]["Geo"] | null;
      clockoutLocation: components["schemas"]["Geo"] | null;
      clockinType: null | string;
      clockoutType: null | string;
      patientContractId: components["schemas"]["PatientContractId"] | null;
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      missedVisit: boolean;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddress"];
      address2: null | string;
      addressInstructions: null | string;
      removedAt: components["schemas"]["Instant"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      isVisitDateOnDayBefore: boolean;
      external_id?: null | string;
      travelTimeSeconds: number;
      billingAdjustmentSeconds: null | number;
      manualClockTimeEditApproved: boolean;
      clockDistanceApproved: boolean;
      visitBatchId: components["schemas"]["VisitBatchId"];
      removedVisitNoteId: components["schemas"]["NoteId"] | null;
      manualHoldInvoicing: boolean;
      manualHoldInvoicingNotes: null | string;
      missedVisitNoteId: components["schemas"]["NoteId"] | null;
      isTask: boolean;
    };
    /** Format: MasterWeekId */
    MasterWeekId: MasterWeekId;
    VisitInstanceAddress: {
      address: string;
      timezone: string;
      state: string;
      countyName: string;
      addressComponents?: components["schemas"]["AddressComponents"] | null;
    };
    /** Format: VisitBatchId */
    VisitBatchId: VisitBatchId;
    /** Format: VisitAssignmentId */
    VisitAssignmentId: VisitAssignmentId;
    TreatmentMedicalOrder: {
      id: components["schemas"]["TreatmentMedicalOrderId"];
      physician: components["schemas"]["PhysicianId"];
      order_date: components["schemas"]["LocalDate"];
      type: null | string;
      status: null | string;
      notes: null | string;
    };
    /** Format: TreatmentMedicalOrderId */
    TreatmentMedicalOrderId: TreatmentMedicalOrderId;
    /** Format: PhysicianId */
    PhysicianId: PhysicianId;
    TreatmentDiagnosis: {
      id: components["schemas"]["TreatmentDiagnosisId"];
      diagnosis_icd10: components["schemas"]["ICD10CodeId"] | null;
      diagnosis_icd9: components["schemas"]["ICD9CodeId"] | null;
      is_primary: null | boolean;
    };
    /** Format: TreatmentDiagnosisId */
    TreatmentDiagnosisId: TreatmentDiagnosisId;
    /** Format: ICD9CodeId */
    ICD9CodeId: ICD9CodeId;
    TreatmentAdvanceDirective: {
      id: components["schemas"]["TreatmentAdvanceDirectiveId"];
      physician: components["schemas"]["PhysicianId"];
      on_file: null | boolean;
      date_received: components["schemas"]["LocalDate"];
      effective_date: components["schemas"]["LocalDate"];
      status: null | string;
    };
    /** Format: TreatmentAdvanceDirectiveId */
    TreatmentAdvanceDirectiveId: TreatmentAdvanceDirectiveId;
    HHAPayersByPatientId: {
      contractId: components["schemas"]["PatientContractId"];
      medflytPayerId: components["schemas"]["PayerId"];
      hhaPayerId: components["schemas"]["IntegrationPayerId"];
      hhaPayerCode: string;
      hhaPayerName: string;
    };
    /** Format: IntegrationPayerId */
    IntegrationPayerId: IntegrationPayerId;
    PatientContractFileDetails: {
      id: number;
      fileName: null | string;
      url: null | string;
      fileKey: null | string;
      canDelete: boolean;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      removedAt: components["schemas"]["Instant"] | null;
      removedBy: components["schemas"]["AgencyMemberId"] | null;
    };
    CustomField: {
      id: components["schemas"]["AgencyCustomFieldId"];
      entityName: components["schemas"]["CustomFieldEntity"];
      fieldName: string;
      fieldType: components["schemas"]["CustomFieldType"];
      fieldTypeLabel: string;
      fieldOptions: string[] | null;
      addToSettings: boolean;
      active: boolean;
    };
    /** Format: AgencyCustomFieldId */
    AgencyCustomFieldId: AgencyCustomFieldId;
    /** @enum {string} */
    CustomFieldEntity: "CAREGIVER" | "PATIENT";
    /** @enum {string} */
    CustomFieldType:
      | "ADDRESS"
      | "BOOLEAN"
      | "CAREGIVER"
      | "DATE"
      | "DATE_RANGE"
      | "ENUM"
      | "NUMBER"
      | "PATIENT"
      | "PHONE_NUMBER"
      | "TEXT";
    RequiredDutySheetTask: {
      isRequired: boolean;
      /**
       * @description How many times this duty is due on THIS visit's day.
       *
       * Resolved to the day: a duty stated as a number of times per week is spread
       * over the week, and a count that does not divide evenly is twice on one day
       * and once on the rest. 1 for the ordinary duty, and for every duty on a plan
       * that never said otherwise.
       */
      timesPerDay: number;
      /**
       * @description How many of those the patient's OTHER visits that day have already recorded.
       *
       * `isRequired` is already false once this reaches `timesPerDay`, so a consumer
       * needs neither number to decide whether to demand the duty. They are here so
       * the caregiver can be SHOWN the difference between a duty due once and a duty
       * due twice with one of them done -- which the boolean alone cannot express.
       */
      performedElsewhereToday: number;
      /**
       * @description How many occurrences of this duty THIS visit owes -- the number of rows a
       * caregiver is asked to tick.
       *
       * Not `timesPerDay - performedElsewhereToday`. That difference is the day's
       * remaining budget, and a visit can owe more than its share of it: a duty a
       * coordinator moved here from a visit that missed it is owed on THIS visit
       * without the plan ever scheduling it here, and it is added on top of
       * whatever the day already asked for. A client deriving the count from the
       * two numbers above therefore drops every made-up occurrence -- which is
       * exactly what it looks like when a duty reassigned onto a visit shows up
       * once instead of twice.
       *
       * Resolved server-side by DUTY_OWED_ON_VISIT_SQL, the same expression the
       * coordinator's visit modal renders from, so the app and the office cannot
       * disagree about how many times a duty is due here.
       */
      owedOccurrences: number;
      id: components["schemas"]["PlanOfCareItemId"];
      name: string;
      code: string;
    };
    SelectedDutySheetTask: {
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      /**
       * @description Which occurrence of the duty this record is.
       *
       * A visit may record the same duty several times, so `planOfCareItemId` alone
       * no longer identifies a row: two entries sharing an id and differing only by
       * this index are two separate performances, each with its own note. A client
       * that keys its state by duty id alone silently keeps one of them.
       */
      occurrenceIndex: number;
      notes: null | string;
    };
    VisitInstanceDetailsInvalidClockTimes: {
      id: components["schemas"]["VisitInstanceId"];
      startTimeUtc: components["schemas"]["Instant"];
      endTimeUtc: components["schemas"]["Instant"];
      clockInTimeUtc: components["schemas"]["Instant"] | null;
      clockOutTimeUtc: components["schemas"]["Instant"] | null;
    };
    CaregiverVisitDutyV2: {
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      label: string;
      code: string;
      sectionName: string;
      /** @description The plan's instructions for this duty; null when the plan has none. */
      notes: null | string;
      durationMinutes: null | number;
      justification: null | string;
      schedule: components["schemas"]["CaregiverDutyScheduleV2"];
      /** @description One entry per row the app draws, ordered by occurrenceIndex. Never empty. */
      occurrences: components["schemas"]["CaregiverDutyOccurrenceV2"][];
    };
    CaregiverDutyScheduleV2:
      | {
          /** @enum {string} */
          type: "DAILY";
          timesPerDay: number;
          performedElsewhereToday: number;
        }
      | {
          /** @enum {string} */
          type: "WEEKLY";
          frequency: number;
          performedElsewhereThisWeek: number;
          /** @description Further occurrences this visit may still add; 0 hides "Add another". */
          remainingThisWeek: number;
        }
      | {
          /** @enum {string} */
          type: "AS_NEEDED";
        };
    CaregiverDutyOccurrenceV2: {
      occurrenceIndex: number;
      /** @description Fixed for the visit: does not flip when this visit answers the row. */
      isRequired: boolean;
      makeUp: {
        sourceVisitInstanceId: components["schemas"]["VisitInstanceId"];
        sourceVisitDate: components["schemas"]["LocalDate"];
      } | null;
      answer:
        | {
            /** @enum {string} */
            type: "DONE";
            notes: null | string;
            startTime: components["schemas"]["LocalDateTime"] | null;
            endTime: components["schemas"]["LocalDateTime"] | null;
          }
        | {
            /** @enum {string} */
            type: "NOT_DONE";
            reason: null | string;
          }
        | null;
    };
    CaregiverDutyAnswerV2:
      | {
          /** @enum {string} */
          type: "DONE";
          notes: null | string;
          startTime: components["schemas"]["LocalDateTime"] | null;
          endTime: components["schemas"]["LocalDateTime"] | null;
        }
      | {
          /** @enum {string} */
          type: "NOT_DONE";
          reason: null | string;
        };
    TimeSheetApproval: {
      timesheetId: components["schemas"]["TimesheetId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      submittedAt: components["schemas"]["Instant"];
      visitDate: components["schemas"]["LocalDate"];
      ScheduleStartTime: components["schemas"]["LocalDateTime"];
      ScheduleEndTime: components["schemas"]["LocalDateTime"];
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      selectedDuties: {
        code: string;
        label: string;
      }[];
      patientSignature: null | string;
      caregiverSignature: null | string;
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"];
      /**
       * @description Denormalised so the approval page can label, filter and export a row
       * without holding a dictionary of every caregiver.
       */
      caregiver: components["schemas"]["CaregiverRowDisplay"] | null;
      /** @description Denormalised alongside the caregiver, for the same reason. */
      patient: components["schemas"]["PatientRowDisplay"] | null;
      status: ("APPROVED" | "DECLINED" | "PENDING") | null;
    };
    /** Format: TimesheetId */
    TimesheetId: TimesheetId;
    /**
     * @description The patient fields a list row displays. The counterpart of
     * [[CaregiverRowDisplay]] - endpoints return this so clients do not need a
     * dictionary of every patient.
     */
    PatientRowDisplay: {
      id: components["schemas"]["PatientId"];
      displayName: string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      displayId: null | number;
      status: components["schemas"]["PatientStatus"];
      address: null | string;
      admissionId: null | string;
      currentOfficeId: components["schemas"]["OfficeId"];
      currentOfficeName: null | string;
      agencyTeamId: components["schemas"]["AgencyTeamId"] | null;
      assignedCoordinator: components["schemas"]["AgencyMemberId"] | null;
    };
    TimeSheetForApproval: {
      timesheetId: components["schemas"]["TimesheetId"];
      note: components["schemas"]["AgencyNoteCreateParams"];
    };
    /** Format: ExportBatchId */
    ExportBatchId: ExportBatchId;
    "HRQuestion.TextQuestion": {
      /** @enum {string} */
      type: "Text";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    /** Format: HRQuestionId */
    HRQuestionId: HRQuestionId;
    HRQuestionTranslations: {
      English?: string;
      Albanian?: string;
      Arabic?: string;
      Armenian?: string;
      Bengali?: string;
      Bulgarian?: string;
      Cantonese?: string;
      Chinese?: string;
      Creole?: string;
      Danish?: string;
      Dutch?: string;
      Estonian?: string;
      Farsi?: string;
      Filipino?: string;
      French?: string;
      Fukkianese?: string;
      Fulani?: string;
      "Fula/Fulani"?: string;
      Fuzhounese?: string;
      Georgian?: string;
      German?: string;
      Ghana?: string;
      Greek?: string;
      Hakka?: string;
      Hebrew?: string;
      Hindi?: string;
      Hungarian?: string;
      Italian?: string;
      Japanese?: string;
      Korean?: string;
      Krio?: string;
      Kyrgyz?: string;
      Mandarin?: string;
      Pashto?: string;
      Persian?: string;
      Polish?: string;
      Portuguese?: string;
      Punjabi?: string;
      Romanian?: string;
      Russian?: string;
      Shanghainese?: string;
      Soninke?: string;
      Spanish?: string;
      Swahili?: string;
      Tagalog?: string;
      Taishanese?: string;
      Taiwanese?: string;
      Turkish?: string;
      Twi?: string;
      Ukrainian?: string;
      Urdu?: string;
      Uzbek?: string;
      Vietnamese?: string;
      Yiddish?: string;
    };
    "HRQuestion.AddressQuestion": {
      /** @enum {string} */
      type: "Address";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.EmailQuestion": {
      /** @enum {string} */
      type: "Email";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.NumericQuestion": {
      /** @enum {string} */
      type: "Numeric";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.DollarQuestion": {
      /** @enum {string} */
      type: "Dollar";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.PhoneNumberQuestion": {
      /** @enum {string} */
      type: "PhoneNumber";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.SSNQuestion": {
      /** @enum {string} */
      type: "SSN";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.FullDateQuestion": {
      /** @enum {string} */
      type: "FullDate";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.BirthDateQuestion": {
      /** @enum {string} */
      type: "BirthDate";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.MonthYearDateQuestion": {
      /** @enum {string} */
      type: "MonthYearDate";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.YearDateQuestion": {
      /** @enum {string} */
      type: "YearDate";
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.RadioQuestion": {
      /** @enum {string} */
      type: "Radio";
      possibleAnswers: components["schemas"]["PossibleAnswer"][];
      possibleAnswersTranslations?:
        | components["schemas"]["HRPossibleAnswerTranslations"]
        | null;
      chosenAnswerId: null | number;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    PossibleAnswer: {
      id: number;
      text: string;
    };
    HRPossibleAnswerTranslations: {
      English?: components["schemas"]["PossibleAnswer"][];
      Albanian?: components["schemas"]["PossibleAnswer"][];
      Arabic?: components["schemas"]["PossibleAnswer"][];
      Armenian?: components["schemas"]["PossibleAnswer"][];
      Bengali?: components["schemas"]["PossibleAnswer"][];
      Bulgarian?: components["schemas"]["PossibleAnswer"][];
      Cantonese?: components["schemas"]["PossibleAnswer"][];
      Chinese?: components["schemas"]["PossibleAnswer"][];
      Creole?: components["schemas"]["PossibleAnswer"][];
      Danish?: components["schemas"]["PossibleAnswer"][];
      Dutch?: components["schemas"]["PossibleAnswer"][];
      Estonian?: components["schemas"]["PossibleAnswer"][];
      Farsi?: components["schemas"]["PossibleAnswer"][];
      Filipino?: components["schemas"]["PossibleAnswer"][];
      French?: components["schemas"]["PossibleAnswer"][];
      Fukkianese?: components["schemas"]["PossibleAnswer"][];
      Fulani?: components["schemas"]["PossibleAnswer"][];
      "Fula/Fulani"?: components["schemas"]["PossibleAnswer"][];
      Fuzhounese?: components["schemas"]["PossibleAnswer"][];
      Georgian?: components["schemas"]["PossibleAnswer"][];
      German?: components["schemas"]["PossibleAnswer"][];
      Ghana?: components["schemas"]["PossibleAnswer"][];
      Greek?: components["schemas"]["PossibleAnswer"][];
      Hakka?: components["schemas"]["PossibleAnswer"][];
      Hebrew?: components["schemas"]["PossibleAnswer"][];
      Hindi?: components["schemas"]["PossibleAnswer"][];
      Hungarian?: components["schemas"]["PossibleAnswer"][];
      Italian?: components["schemas"]["PossibleAnswer"][];
      Japanese?: components["schemas"]["PossibleAnswer"][];
      Korean?: components["schemas"]["PossibleAnswer"][];
      Krio?: components["schemas"]["PossibleAnswer"][];
      Kyrgyz?: components["schemas"]["PossibleAnswer"][];
      Mandarin?: components["schemas"]["PossibleAnswer"][];
      Pashto?: components["schemas"]["PossibleAnswer"][];
      Persian?: components["schemas"]["PossibleAnswer"][];
      Polish?: components["schemas"]["PossibleAnswer"][];
      Portuguese?: components["schemas"]["PossibleAnswer"][];
      Punjabi?: components["schemas"]["PossibleAnswer"][];
      Romanian?: components["schemas"]["PossibleAnswer"][];
      Russian?: components["schemas"]["PossibleAnswer"][];
      Shanghainese?: components["schemas"]["PossibleAnswer"][];
      Soninke?: components["schemas"]["PossibleAnswer"][];
      Spanish?: components["schemas"]["PossibleAnswer"][];
      Swahili?: components["schemas"]["PossibleAnswer"][];
      Tagalog?: components["schemas"]["PossibleAnswer"][];
      Taishanese?: components["schemas"]["PossibleAnswer"][];
      Taiwanese?: components["schemas"]["PossibleAnswer"][];
      Turkish?: components["schemas"]["PossibleAnswer"][];
      Twi?: components["schemas"]["PossibleAnswer"][];
      Ukrainian?: components["schemas"]["PossibleAnswer"][];
      Urdu?: components["schemas"]["PossibleAnswer"][];
      Uzbek?: components["schemas"]["PossibleAnswer"][];
      Vietnamese?: components["schemas"]["PossibleAnswer"][];
      Yiddish?: components["schemas"]["PossibleAnswer"][];
    };
    "HRQuestion.DropDownQuestion": {
      /** @enum {string} */
      type: "DropDown";
      possibleAnswers: components["schemas"]["PossibleAnswer"][];
      possibleAnswersTranslations?:
        | components["schemas"]["HRPossibleAnswerTranslations"]
        | null;
      chosenAnswerId: null | number;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.CheckboxQuestion": {
      /** @enum {string} */
      type: "Checkbox";
      possibleAnswers: components["schemas"]["PossibleAnswer"][];
      possibleAnswersTranslations?:
        | components["schemas"]["HRPossibleAnswerTranslations"]
        | null;
      chosenAnswerIds: number[] | null;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.SignatureQuestion": {
      /** @enum {string} */
      type: "Signature";
      /** @description base64 data-url png of signature */
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.GeneralSignatureQuestion": {
      /** @enum {string} */
      type: "GeneralSignature";
      /** @description base64 data-url png of signature */
      answer: components["schemas"]["GeneralSignatureAnswer"] | null;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    GeneralSignatureAnswer: {
      signature: null | string;
      generalSignaturePerson: null | string;
    };
    "HRQuestion.StartAndEndTimeQuestion": {
      /** @enum {string} */
      type: "StartAndEndTime";
      answer: {
        startTime: number;
        endTime: number;
      } | null;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.StarQuestion": {
      /** @enum {string} */
      type: "Star";
      answer: null | number;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.Placeholder": {
      /** @enum {string} */
      type: "Placeholder";
      /** @enum {boolean} */
      isMandatory: false;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.DocumentQuestion": {
      /** @enum {string} */
      type: "Document";
      /** @description data uri */
      answer: null | string;
      documentTypeToUpload:
        | components["schemas"]["CaregiverDocumentTypeId"]
        | null;
      documentTypeNameTranslations?: components["schemas"]["HRDocumentTitleTranslations"];
      complianceRejectionData?:
        | {
            /** @enum {string} */
            type: "Rejected";
            reason: null | string;
          }
        | {
            /** @enum {string} */
            type: "Dismissed";
          }
        | {
            /** @enum {string} */
            type: "Approved";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      canUploadFromGallery: boolean;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    HRDocumentTitleTranslations: {
      English?: string;
      Albanian?: string;
      Arabic?: string;
      Armenian?: string;
      Bengali?: string;
      Bulgarian?: string;
      Cantonese?: string;
      Chinese?: string;
      Creole?: string;
      Danish?: string;
      Dutch?: string;
      Estonian?: string;
      Farsi?: string;
      Filipino?: string;
      French?: string;
      Fukkianese?: string;
      Fulani?: string;
      "Fula/Fulani"?: string;
      Fuzhounese?: string;
      Georgian?: string;
      German?: string;
      Ghana?: string;
      Greek?: string;
      Hakka?: string;
      Hebrew?: string;
      Hindi?: string;
      Hungarian?: string;
      Italian?: string;
      Japanese?: string;
      Korean?: string;
      Krio?: string;
      Kyrgyz?: string;
      Mandarin?: string;
      Pashto?: string;
      Persian?: string;
      Polish?: string;
      Portuguese?: string;
      Punjabi?: string;
      Romanian?: string;
      Russian?: string;
      Shanghainese?: string;
      Soninke?: string;
      Spanish?: string;
      Swahili?: string;
      Tagalog?: string;
      Taishanese?: string;
      Taiwanese?: string;
      Turkish?: string;
      Twi?: string;
      Ukrainian?: string;
      Urdu?: string;
      Uzbek?: string;
      Vietnamese?: string;
      Yiddish?: string;
    };
    "HRQuestion.DocumentWithExpiryQuestion": {
      /** @enum {string} */
      type: "DocumentWithExpiry";
      answer: components["schemas"]["DocumentWithExpiryAnswer"] | null;
      documentTypeToUpload:
        | components["schemas"]["CaregiverDocumentTypeId"]
        | null;
      documentTypeNameTranslations?: components["schemas"]["HRDocumentTitleTranslations"];
      complianceRejectionData?:
        | {
            /** @enum {string} */
            type: "Rejected";
            reason: null | string;
          }
        | {
            /** @enum {string} */
            type: "Dismissed";
          }
        | {
            /** @enum {string} */
            type: "Approved";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    /**
     * @description when getting an answer from HR app:
     * document = the data URI of the document
     *
     * when storing answer in DB (using JSON.stringify on this interface):
     * document = the s3 key of the document
     *
     * when returning an answer to HR app:
     * document = signed url to the s3 file
     */
    DocumentWithExpiryAnswer: {
      document: string;
      expiryDate: null | string;
    };
    "HRQuestion.AmericanTestQuestion": {
      /** @enum {string} */
      type: "AmericanTest";
      possibleAnswers: components["schemas"]["PossibleAnswer"][];
      possibleAnswersTranslations?:
        | components["schemas"]["HRPossibleAnswerTranslations"]
        | null;
      chosenAnswerId: null | number;
      correctAnswer: number;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.FreeTextQuestion": {
      /** @enum {string} */
      type: "FreeText";
      possibleAnswers: components["schemas"]["PossibleAnswer"][];
      possibleAnswersTranslations?:
        | components["schemas"]["HRPossibleAnswerTranslations"]
        | null;
      chosenAnswerIds: number[] | null;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.TitelTextQuestion": {
      /** @enum {string} */
      type: "TitleText";
      /** @enum {boolean} */
      isMandatory: false;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.PlainTextQuestion": {
      /** @enum {string} */
      type: "PlainText";
      /** @enum {boolean} */
      isMandatory: false;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.DownloadableFileQuestion": {
      /** @enum {string} */
      type: "DownloadableFile";
      downloaded: boolean;
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.DocumentWithEffectiveDateQuestion": {
      /** @enum {string} */
      type: "DocumentWithEffectiveDate";
      answer: components["schemas"]["DocumentWithEffectiveDateAnswer"] | null;
      documentTypeToUpload:
        | components["schemas"]["CaregiverDocumentTypeId"]
        | null;
      documentTypeNameTranslations?: components["schemas"]["HRDocumentTitleTranslations"];
      complianceRejectionData?:
        | {
            /** @enum {string} */
            type: "Rejected";
            reason: null | string;
          }
        | {
            /** @enum {string} */
            type: "Dismissed";
          }
        | {
            /** @enum {string} */
            type: "Approved";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    /**
     * @description when getting an answer from HR app:
     * document = the data URI of the document
     *
     * when storing answer in DB (using JSON.stringify on this interface):
     * document = the s3 key of the document
     *
     * when returning an answer to HR app:
     * document = signed url to the s3 file
     */
    DocumentWithEffectiveDateAnswer: {
      document: string;
      effectiveDate: null | string;
    };
    "HRQuestion.Video": {
      /** @enum {string} */
      type: "Video";
      /** @enum {boolean} */
      isMandatory: false;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    "HRQuestion.InterviewQuestion": {
      /** @enum {string} */
      type: "Interview";
      possibleAnswers: components["schemas"]["PossibleAnswer"][];
      possibleAnswersTranslations?:
        | components["schemas"]["HRPossibleAnswerTranslations"]
        | null;
      chosenAnswerId: null | number;
      answer: null | string;
      id: components["schemas"]["HRQuestionId"];
      /**
       * @description If question has no template, this will be the HRQuestionId in text format,
       * because of hr app client reasons.
       */
      textId: components["schemas"]["HRQuestionTemplateId"];
      questionText: string;
      questionTextTranslations?:
        | components["schemas"]["HRQuestionTranslations"]
        | null;
      parentId: components["schemas"]["HRQuestionId"] | null;
      parentAnswer: null | string;
      isHidden: boolean;
      isMandatory: boolean;
      hideOnMobile?: boolean;
      answerRejectionStatus?:
        | {
            /** @enum {string} */
            status: "Rejected";
            rejectedAt: components["schemas"]["Instant"];
            rejectedBy: components["schemas"]["AgencyMemberId"];
            reason: string;
          }
        | {
            /** @enum {string} */
            status: "Not Rejected";
          };
      caregiverProfileParam?: null | string;
      emailVerificationRejectionStatus?:
        | {
            /** @enum {string} */
            type: "Verified";
          }
        | {
            /** @enum {string} */
            type: "Pending";
          }
        | null;
      caregiverPreferenceQuestion?:
        | (
            | "additional_info"
            | "cases_length"
            | "languages"
            | "main_language"
            | "patients_types"
            | "public_transprotation_time_limit"
            | "smoking_caregiver"
            | "studying"
            | "studying_times"
            | "transportation_type"
            | "work_times"
            | "work_with_bedbound"
            | "work_with_halal"
            | "work_with_hoyer_lift"
            | "work_with_kids"
            | "work_with_kosher"
            | "work_with_pets"
            | "work_with_shabat"
            | "work_with_smoking_patient"
            | "work_with_walking_asistant"
          )
        | null;
      linkedQuestionTemplate?: null | string;
      payrollTaxParam?: null | string;
      isComplianceFollowUp?: null | boolean;
      bankInformationParam?: null | string;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      answeredAt?: Instant;
    };
    /** Format: HRSubSectionId */
    HRSubSectionId: HRSubSectionId;
    HRSection: {
      data: components["schemas"]["HRSectionData"];
      subSections: components["schemas"]["HRSubSection"][];
    };
    HRSectionData: {
      id: components["schemas"]["HRSectionId"];
      title: string;
      subtitle: null | string;
      isStop: boolean;
      HRSectionStageId: components["schemas"]["HRSectionStageId"] | null;
      HRSectionStageLabel: null | string;
      secondsToComplete: null | number;
      translations: components["schemas"]["HRSectionTranslations"] | null;
      locked: boolean;
    };
    /** Format: HRSectionId */
    HRSectionId: HRSectionId;
    HRSectionTranslations: {
      English?: {
        title: string;
        subtitle: null | string;
      };
      Albanian?: {
        title: string;
        subtitle: null | string;
      };
      Arabic?: {
        title: string;
        subtitle: null | string;
      };
      Armenian?: {
        title: string;
        subtitle: null | string;
      };
      Bengali?: {
        title: string;
        subtitle: null | string;
      };
      Bulgarian?: {
        title: string;
        subtitle: null | string;
      };
      Cantonese?: {
        title: string;
        subtitle: null | string;
      };
      Chinese?: {
        title: string;
        subtitle: null | string;
      };
      Creole?: {
        title: string;
        subtitle: null | string;
      };
      Danish?: {
        title: string;
        subtitle: null | string;
      };
      Dutch?: {
        title: string;
        subtitle: null | string;
      };
      Estonian?: {
        title: string;
        subtitle: null | string;
      };
      Farsi?: {
        title: string;
        subtitle: null | string;
      };
      Filipino?: {
        title: string;
        subtitle: null | string;
      };
      French?: {
        title: string;
        subtitle: null | string;
      };
      Fukkianese?: {
        title: string;
        subtitle: null | string;
      };
      Fulani?: {
        title: string;
        subtitle: null | string;
      };
      "Fula/Fulani"?: {
        title: string;
        subtitle: null | string;
      };
      Fuzhounese?: {
        title: string;
        subtitle: null | string;
      };
      Georgian?: {
        title: string;
        subtitle: null | string;
      };
      German?: {
        title: string;
        subtitle: null | string;
      };
      Ghana?: {
        title: string;
        subtitle: null | string;
      };
      Greek?: {
        title: string;
        subtitle: null | string;
      };
      Hakka?: {
        title: string;
        subtitle: null | string;
      };
      Hebrew?: {
        title: string;
        subtitle: null | string;
      };
      Hindi?: {
        title: string;
        subtitle: null | string;
      };
      Hungarian?: {
        title: string;
        subtitle: null | string;
      };
      Italian?: {
        title: string;
        subtitle: null | string;
      };
      Japanese?: {
        title: string;
        subtitle: null | string;
      };
      Korean?: {
        title: string;
        subtitle: null | string;
      };
      Krio?: {
        title: string;
        subtitle: null | string;
      };
      Kyrgyz?: {
        title: string;
        subtitle: null | string;
      };
      Mandarin?: {
        title: string;
        subtitle: null | string;
      };
      Pashto?: {
        title: string;
        subtitle: null | string;
      };
      Persian?: {
        title: string;
        subtitle: null | string;
      };
      Polish?: {
        title: string;
        subtitle: null | string;
      };
      Portuguese?: {
        title: string;
        subtitle: null | string;
      };
      Punjabi?: {
        title: string;
        subtitle: null | string;
      };
      Romanian?: {
        title: string;
        subtitle: null | string;
      };
      Russian?: {
        title: string;
        subtitle: null | string;
      };
      Shanghainese?: {
        title: string;
        subtitle: null | string;
      };
      Soninke?: {
        title: string;
        subtitle: null | string;
      };
      Spanish?: {
        title: string;
        subtitle: null | string;
      };
      Swahili?: {
        title: string;
        subtitle: null | string;
      };
      Tagalog?: {
        title: string;
        subtitle: null | string;
      };
      Taishanese?: {
        title: string;
        subtitle: null | string;
      };
      Taiwanese?: {
        title: string;
        subtitle: null | string;
      };
      Turkish?: {
        title: string;
        subtitle: null | string;
      };
      Twi?: {
        title: string;
        subtitle: null | string;
      };
      Ukrainian?: {
        title: string;
        subtitle: null | string;
      };
      Urdu?: {
        title: string;
        subtitle: null | string;
      };
      Uzbek?: {
        title: string;
        subtitle: null | string;
      };
      Vietnamese?: {
        title: string;
        subtitle: null | string;
      };
      Yiddish?: {
        title: string;
        subtitle: null | string;
      };
    };
    HRSubSection: {
      data: components["schemas"]["HRSubSectionData"];
      document: components["schemas"]["SubsectionDocumentData"] | null;
      questionGroups: components["schemas"]["HRQuestionGroup"][];
    };
    HRSubSectionData: {
      id: components["schemas"]["HRSubSectionId"];
      title: string;
      subtitle: null | string;
      settings: components["schemas"]["HRSubSectionSettings"] | null;
      translations: components["schemas"]["HRSubSectionTranslations"] | null;
      shareUrl: null | string;
      isCompliant: null | boolean;
    };
    HRSubSectionSettings: {
      hideOnMobile?: boolean;
      testSettings: components["schemas"]["HRTestSettings"] | null;
      availabilityPlaceholder:
        | components["schemas"]["HRAvailabilityPlaceholderSettings"]
        | null;
      hideOnApplication?: boolean;
      generateWithoutSignature?: boolean;
    };
    HRTestSettings: {
      testFailText: string;
      testSuccessText: string;
      testRetryText: string;
      maxWrongAnswers: number;
      testMaxTries: number;
      shouldShowWrongAnswers: boolean;
    };
    HRAvailabilityPlaceholderSettings: {
      showHoursQuestion: boolean;
      showDistanceQuestion: boolean;
    };
    HRSubSectionTranslations: {
      English?: {
        title: string;
        subtitle: null | string;
      };
      Albanian?: {
        title: string;
        subtitle: null | string;
      };
      Arabic?: {
        title: string;
        subtitle: null | string;
      };
      Armenian?: {
        title: string;
        subtitle: null | string;
      };
      Bengali?: {
        title: string;
        subtitle: null | string;
      };
      Bulgarian?: {
        title: string;
        subtitle: null | string;
      };
      Cantonese?: {
        title: string;
        subtitle: null | string;
      };
      Chinese?: {
        title: string;
        subtitle: null | string;
      };
      Creole?: {
        title: string;
        subtitle: null | string;
      };
      Danish?: {
        title: string;
        subtitle: null | string;
      };
      Dutch?: {
        title: string;
        subtitle: null | string;
      };
      Estonian?: {
        title: string;
        subtitle: null | string;
      };
      Farsi?: {
        title: string;
        subtitle: null | string;
      };
      Filipino?: {
        title: string;
        subtitle: null | string;
      };
      French?: {
        title: string;
        subtitle: null | string;
      };
      Fukkianese?: {
        title: string;
        subtitle: null | string;
      };
      Fulani?: {
        title: string;
        subtitle: null | string;
      };
      "Fula/Fulani"?: {
        title: string;
        subtitle: null | string;
      };
      Fuzhounese?: {
        title: string;
        subtitle: null | string;
      };
      Georgian?: {
        title: string;
        subtitle: null | string;
      };
      German?: {
        title: string;
        subtitle: null | string;
      };
      Ghana?: {
        title: string;
        subtitle: null | string;
      };
      Greek?: {
        title: string;
        subtitle: null | string;
      };
      Hakka?: {
        title: string;
        subtitle: null | string;
      };
      Hebrew?: {
        title: string;
        subtitle: null | string;
      };
      Hindi?: {
        title: string;
        subtitle: null | string;
      };
      Hungarian?: {
        title: string;
        subtitle: null | string;
      };
      Italian?: {
        title: string;
        subtitle: null | string;
      };
      Japanese?: {
        title: string;
        subtitle: null | string;
      };
      Korean?: {
        title: string;
        subtitle: null | string;
      };
      Krio?: {
        title: string;
        subtitle: null | string;
      };
      Kyrgyz?: {
        title: string;
        subtitle: null | string;
      };
      Mandarin?: {
        title: string;
        subtitle: null | string;
      };
      Pashto?: {
        title: string;
        subtitle: null | string;
      };
      Persian?: {
        title: string;
        subtitle: null | string;
      };
      Polish?: {
        title: string;
        subtitle: null | string;
      };
      Portuguese?: {
        title: string;
        subtitle: null | string;
      };
      Punjabi?: {
        title: string;
        subtitle: null | string;
      };
      Romanian?: {
        title: string;
        subtitle: null | string;
      };
      Russian?: {
        title: string;
        subtitle: null | string;
      };
      Shanghainese?: {
        title: string;
        subtitle: null | string;
      };
      Soninke?: {
        title: string;
        subtitle: null | string;
      };
      Spanish?: {
        title: string;
        subtitle: null | string;
      };
      Swahili?: {
        title: string;
        subtitle: null | string;
      };
      Tagalog?: {
        title: string;
        subtitle: null | string;
      };
      Taishanese?: {
        title: string;
        subtitle: null | string;
      };
      Taiwanese?: {
        title: string;
        subtitle: null | string;
      };
      Turkish?: {
        title: string;
        subtitle: null | string;
      };
      Twi?: {
        title: string;
        subtitle: null | string;
      };
      Ukrainian?: {
        title: string;
        subtitle: null | string;
      };
      Urdu?: {
        title: string;
        subtitle: null | string;
      };
      Uzbek?: {
        title: string;
        subtitle: null | string;
      };
      Vietnamese?: {
        title: string;
        subtitle: null | string;
      };
      Yiddish?: {
        title: string;
        subtitle: null | string;
      };
    };
    SubsectionDocumentData: {
      isDocumentGenerated: boolean;
      doc: null | string;
    };
    HRQuestionGroup: {
      data: components["schemas"]["HRQuestionGroupData"];
      questions: components["schemas"]["HRQuestion"][];
    };
    HRQuestionGroupData: {
      id: components["schemas"]["HRQuestionGroupId"];
      title: string;
      subtitle: null | string;
      translations: components["schemas"]["HRQuestionGroupTranslations"] | null;
    };
    /** Format: HRQuestionGroupId */
    HRQuestionGroupId: HRQuestionGroupId;
    HRQuestionGroupTranslations: {
      English?: {
        title: string;
        subtitle: null | string;
      };
      Albanian?: {
        title: string;
        subtitle: null | string;
      };
      Arabic?: {
        title: string;
        subtitle: null | string;
      };
      Armenian?: {
        title: string;
        subtitle: null | string;
      };
      Bengali?: {
        title: string;
        subtitle: null | string;
      };
      Bulgarian?: {
        title: string;
        subtitle: null | string;
      };
      Cantonese?: {
        title: string;
        subtitle: null | string;
      };
      Chinese?: {
        title: string;
        subtitle: null | string;
      };
      Creole?: {
        title: string;
        subtitle: null | string;
      };
      Danish?: {
        title: string;
        subtitle: null | string;
      };
      Dutch?: {
        title: string;
        subtitle: null | string;
      };
      Estonian?: {
        title: string;
        subtitle: null | string;
      };
      Farsi?: {
        title: string;
        subtitle: null | string;
      };
      Filipino?: {
        title: string;
        subtitle: null | string;
      };
      French?: {
        title: string;
        subtitle: null | string;
      };
      Fukkianese?: {
        title: string;
        subtitle: null | string;
      };
      Fulani?: {
        title: string;
        subtitle: null | string;
      };
      "Fula/Fulani"?: {
        title: string;
        subtitle: null | string;
      };
      Fuzhounese?: {
        title: string;
        subtitle: null | string;
      };
      Georgian?: {
        title: string;
        subtitle: null | string;
      };
      German?: {
        title: string;
        subtitle: null | string;
      };
      Ghana?: {
        title: string;
        subtitle: null | string;
      };
      Greek?: {
        title: string;
        subtitle: null | string;
      };
      Hakka?: {
        title: string;
        subtitle: null | string;
      };
      Hebrew?: {
        title: string;
        subtitle: null | string;
      };
      Hindi?: {
        title: string;
        subtitle: null | string;
      };
      Hungarian?: {
        title: string;
        subtitle: null | string;
      };
      Italian?: {
        title: string;
        subtitle: null | string;
      };
      Japanese?: {
        title: string;
        subtitle: null | string;
      };
      Korean?: {
        title: string;
        subtitle: null | string;
      };
      Krio?: {
        title: string;
        subtitle: null | string;
      };
      Kyrgyz?: {
        title: string;
        subtitle: null | string;
      };
      Mandarin?: {
        title: string;
        subtitle: null | string;
      };
      Pashto?: {
        title: string;
        subtitle: null | string;
      };
      Persian?: {
        title: string;
        subtitle: null | string;
      };
      Polish?: {
        title: string;
        subtitle: null | string;
      };
      Portuguese?: {
        title: string;
        subtitle: null | string;
      };
      Punjabi?: {
        title: string;
        subtitle: null | string;
      };
      Romanian?: {
        title: string;
        subtitle: null | string;
      };
      Russian?: {
        title: string;
        subtitle: null | string;
      };
      Shanghainese?: {
        title: string;
        subtitle: null | string;
      };
      Soninke?: {
        title: string;
        subtitle: null | string;
      };
      Spanish?: {
        title: string;
        subtitle: null | string;
      };
      Swahili?: {
        title: string;
        subtitle: null | string;
      };
      Tagalog?: {
        title: string;
        subtitle: null | string;
      };
      Taishanese?: {
        title: string;
        subtitle: null | string;
      };
      Taiwanese?: {
        title: string;
        subtitle: null | string;
      };
      Turkish?: {
        title: string;
        subtitle: null | string;
      };
      Twi?: {
        title: string;
        subtitle: null | string;
      };
      Ukrainian?: {
        title: string;
        subtitle: null | string;
      };
      Urdu?: {
        title: string;
        subtitle: null | string;
      };
      Uzbek?: {
        title: string;
        subtitle: null | string;
      };
      Vietnamese?: {
        title: string;
        subtitle: null | string;
      };
      Yiddish?: {
        title: string;
        subtitle: null | string;
      };
    };
    HRQuestion:
      | components["schemas"]["HRQuestion.TextQuestion"]
      | components["schemas"]["HRQuestion.AddressQuestion"]
      | components["schemas"]["HRQuestion.EmailQuestion"]
      | components["schemas"]["HRQuestion.NumericQuestion"]
      | components["schemas"]["HRQuestion.DollarQuestion"]
      | components["schemas"]["HRQuestion.PhoneNumberQuestion"]
      | components["schemas"]["HRQuestion.SSNQuestion"]
      | components["schemas"]["HRQuestion.FullDateQuestion"]
      | components["schemas"]["HRQuestion.BirthDateQuestion"]
      | components["schemas"]["HRQuestion.MonthYearDateQuestion"]
      | components["schemas"]["HRQuestion.YearDateQuestion"]
      | components["schemas"]["HRQuestion.RadioQuestion"]
      | components["schemas"]["HRQuestion.DropDownQuestion"]
      | components["schemas"]["HRQuestion.CheckboxQuestion"]
      | components["schemas"]["HRQuestion.SignatureQuestion"]
      | components["schemas"]["HRQuestion.GeneralSignatureQuestion"]
      | components["schemas"]["HRQuestion.StartAndEndTimeQuestion"]
      | components["schemas"]["HRQuestion.StarQuestion"]
      | components["schemas"]["HRQuestion.Placeholder"]
      | components["schemas"]["HRQuestion.DocumentQuestion"]
      | components["schemas"]["HRQuestion.DocumentWithExpiryQuestion"]
      | components["schemas"]["HRQuestion.AmericanTestQuestion"]
      | components["schemas"]["HRQuestion.FreeTextQuestion"]
      | components["schemas"]["HRQuestion.TitelTextQuestion"]
      | components["schemas"]["HRQuestion.PlainTextQuestion"]
      | components["schemas"]["HRQuestion.DownloadableFileQuestion"]
      | components["schemas"]["HRQuestion.DocumentWithEffectiveDateQuestion"]
      | components["schemas"]["HRQuestion.Video"]
      | components["schemas"]["HRQuestion.InterviewQuestion"];
    HRApplicationFormSettings: {
      certificationSettings:
        | components["schemas"]["CertificationSettingsForHRApp"]
        | null;
    };
    CertificationSettingsForHRApp: {
      locationPayRates: components["schemas"]["HRCertificationPayRate"][];
    };
    HRCertificationPayRate: {
      locationGroup: string;
      counties: string[];
      rates: {
        hourlyRate: number;
        dailyRate: number;
        overtimeRate: number;
        visitRate: number;
        payRange: null | string;
        baseWage: null | number;
        additionalWage: null | number;
        supplementalWage: null | number;
        workShiftLine1Rate: null | number;
        workShiftLine1Label: null | string;
        workShiftLine2Rate: null | number;
        workShiftLine2Label: null | string;
      };
      supplementals: components["schemas"]["PayRateSupplemental"][];
    };
    PayRateSupplemental: {
      id: components["schemas"]["PayRateSupplementalId"];
      state: string;
      groupName: string;
      hourlyRate: number;
      type: string;
      agencyName: string;
      agencyDescription: string;
    };
    /** Format: PayRateSupplementalId */
    PayRateSupplementalId: PayRateSupplementalId;
    /** Format: TrainingCenterBundleDueDateId */
    TrainingCenterBundleDueDateId: TrainingCenterBundleDueDateId;
    HRDocumentData: {
      id: components["schemas"]["CaregiverDocumentUploadId"];
      /** Format: CaregiverId */
      caregiver?: CaregiverId;
      documentType: components["schemas"]["CaregiverDocumentTypeId"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      creatingAgencyMemberName: null | string;
      expirationDate: components["schemas"]["LocalDate"] | null;
      effectiveDate: components["schemas"]["LocalDate"] | null;
      isGenerated: boolean;
      subsection: components["schemas"]["HRSubSectionId"] | null;
    };
    SectionStagesByCertification: {
      [key: string]: components["schemas"]["HRSectionStage"][];
    };
    I9CaregiverUploadedFiles: {
      url: string;
      name: string;
      fields: components["schemas"]["I9CaregiverUploadedFileField"][];
    };
    I9CaregiverUploadedFileField: {
      name: string;
      value: string;
    };
    Icd10Code: {
      id: components["schemas"]["ICD10CodeId"];
      dxCode: string;
      formattedDxCode: string;
      shortDesc: string;
      longDesc: string;
    };
    CaregiverBankInformationWithEmail: {
      email: null | string;
      routingNumber: string;
      accountNumber: string;
      bankAccountTypeId: components["schemas"]["InstaPayBankAccountTypeId"];
      bankId: components["schemas"]["InstaPayBankId"];
      hasAgreedToTerms: boolean;
    };
    /** Format: InstaPayBankAccountTypeId */
    InstaPayBankAccountTypeId: InstaPayBankAccountTypeId;
    /** Format: InstaPayBankId */
    InstaPayBankId: InstaPayBankId;
    InstaPayVisitData: {
      id: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      payRate: null | number;
      totalAmount: number;
      duration: string;
      status: components["schemas"]["VisitPaymentStatus"];
    };
    VisitPaymentStatus:
      | components["schemas"]["PaidVisitStatus"]
      | components["schemas"]["MissingClockTimesStatus"]
      | components["schemas"]["PendingIssuesVisitStatus"]
      | components["schemas"]["EligibleInstaPayVisitStatus"]
      | components["schemas"]["RegularPayInstaPayVisitStatus"]
      | components["schemas"]["VisitNotCompletedInstaPayVisitStatus"]
      | components["schemas"]["InstaPayInProgressVisitStatus"]
      | components["schemas"]["InstaPayTechnicalIssueStatus"]
      | components["schemas"]["MissedVisitWithTravelTimeStatus"];
    PaidVisitStatus: {
      /** @enum {string} */
      type: "Paid";
      amount: number;
      paidAt: components["schemas"]["LocalDate"];
    };
    MissingClockTimesStatus: {
      /** @enum {string} */
      type: "MissingClockTimes";
    };
    PendingIssuesVisitStatus: {
      /** @enum {string} */
      type: "PendingIssues";
      earlyOrLateClockTimes: boolean;
      clockTimesNotMobile: boolean;
      visitTooShort: boolean;
      missingPersonalCareDuty: boolean;
      insufficientDuties: boolean;
      outOfRange: boolean;
      caregiverOverlap: boolean;
      agencyIssues: boolean;
    };
    EligibleInstaPayVisitStatus: {
      /** @enum {string} */
      type: "EligibleInstaPay";
      eligibleAmount: number;
    };
    RegularPayInstaPayVisitStatus: {
      /** @enum {string} */
      type: "RegularPay";
    };
    VisitNotCompletedInstaPayVisitStatus: {
      /** @enum {string} */
      type: "VisitNotCompleted";
    };
    InstaPayInProgressVisitStatus: {
      /** @enum {string} */
      type: "InstaPayInProgress";
      requestedAt: components["schemas"]["Instant"];
    };
    InstaPayTechnicalIssueStatus: {
      /** @enum {string} */
      type: "TechnicalIssue";
    };
    MissedVisitWithTravelTimeStatus: {
      /** @enum {string} */
      type: "MissedVisitWithTravelTime";
    };
    EligibleInstaPayVisit: components["schemas"]["InstaPayVisitData"] & {
      status: components["schemas"]["EligibleInstaPayVisitStatus"];
    };
    BankAccountType: {
      id: components["schemas"]["InstaPayBankAccountTypeId"];
      type: string;
    };
    BankAccountName: {
      id: components["schemas"]["InstaPayBankId"];
      name: string;
    };
    CaregiverBankInformation: {
      routingNumber: string;
      accountNumber: string;
      bankAccountTypeId: components["schemas"]["InstaPayBankAccountTypeId"];
      bankId: components["schemas"]["InstaPayBankId"];
      hasAgreedToTerms: boolean;
    };
    Paystub: {
      checkDate: components["schemas"]["LocalDate"];
      periodBeginDate: components["schemas"]["LocalDate"];
      periodEndDate: components["schemas"]["LocalDate"];
      totalGross: number;
      totalHours: number;
      totalNet: number;
      totalTaxes: number;
      totalDeductions: number;
      netCheckAmount: number;
      netDirectDepositAmount: number;
      checkOrVoucherNumber: number;
      earnings: components["schemas"]["Earning"][];
      deductions: components["schemas"]["Deduction"][];
      taxes: components["schemas"]["Tax"][];
    };
    Earning: {
      chargeDate: components["schemas"]["LocalDate"] | null;
      amount: number;
      hours: number;
      rate: number;
      earningCode: string;
      earningDescription: string;
    };
    Deduction: {
      amount: number;
      deductionCode: string;
      deductionDescription: string;
    };
    Tax: {
      taxCode: string;
      taxAmount: number;
      taxableWages: number;
      taxDescription: string;
      withholdingType: string;
    };
    PayReceipt: {
      paymentDate: components["schemas"]["LocalDate"];
      periodBeginDate: components["schemas"]["LocalDate"];
      periodEndDate: components["schemas"]["LocalDate"];
      totalGross: number;
      totalHours: number;
      totalNet: number;
      totalDeductions: number;
      deductions: components["schemas"]["Deduction"][];
      payments: components["schemas"]["ServicePayment"][];
    };
    ServicePayment: {
      serviceDate: components["schemas"]["LocalDate"] | null;
      amount: number;
      hours: number;
      rate: number;
      serviceDescription: string;
    };
    PatientClinicalInfo: {
      id: components["schemas"]["PatientClinicalInfoId"];
      type: null | string;
      due_date: components["schemas"]["LocalDate"] | null;
      notes: null | string;
    };
    /** Format: PatientClinicalInfoId */
    PatientClinicalInfoId: PatientClinicalInfoId;
    BasicSocialWorker: {
      id: components["schemas"]["SocialWorkerId"];
      phoneNumber: string;
      firstName: string;
      lastName: string;
      email: string;
    };
    /** Format: SocialWorkerId */
    SocialWorkerId: SocialWorkerId;
    BasicReferralSource: {
      id: components["schemas"]["ReferralSourceId"];
      phoneNumber: string;
      address: string;
      type: string;
      displayName: string;
    };
    /** Format: ReferralSourceId */
    ReferralSourceId: ReferralSourceId;
    PatientAddressComponents: {
      text: string;
      timezone: string;
      components: components["schemas"]["AddressComponents"];
    };
    PatientContact: {
      id: components["schemas"]["PatientContactId"];
      patientId: components["schemas"]["PatientId"];
      firstName: string;
      middleName: null | string;
      lastName: string;
      relationship: string;
      mobilePhoneNumber: string;
      mobilePhoneNumberSmsable: boolean;
      homePhoneNumber: null | string;
      email: null | string;
      address: null | string;
      addressComponents:
        | components["schemas"]["PatientContactAddressComponents"]
        | null;
      address2: null | string;
      isForPortalLogin: boolean;
      isEmergencyContact: boolean;
      livesWithPatient: boolean;
    };
    /** Format: PatientContactId */
    PatientContactId: PatientContactId;
    PatientContactAddressComponents: {
      text: string;
      timezone: string;
      components: components["schemas"]["AddressComponents"];
    };
    PatientEmergencyContact: {
      firstName: string;
      lastName: string;
      relationship: string;
      livesWithPatient: boolean;
      emergencyPhoneNumber1: string;
      emergencyPhoneNumber2: string;
      address: string;
      /** @description Only collected for the MedFlyt agency, whose emergency contacts also live in patient_contact. */
      email?: null | string;
    };
    LinkedPatient: {
      id: components["schemas"]["PatientId"];
      mutualLink: null | boolean;
      linkedWith: components["schemas"]["PatientId"] | null;
      linkedPatientName: null | string;
    };
    PatientPhoneNumber: {
      id: components["schemas"]["PatientPhoneNumberId"];
      patientId: components["schemas"]["PatientId"];
      /** @enum {string} */
      type: "MOBILE" | "OTHER" | "TEL";
      label: null | string;
      description: null | string;
      phonenumber: string;
      isSmsable: boolean;
    };
    PatientPhoneNumberId: number;
    PatientAddress: {
      id: components["schemas"]["PatientAddressId"];
      patientId: components["schemas"]["PatientId"];
      isPrimary: boolean;
      /** @enum {string} */
      evvLocation: "COMMUNITY" | "HOME";
      address: string;
      address2: null | string;
      description: null | string;
      phoneNumberIds: components["schemas"]["PatientPhoneNumberId"][];
    };
    PatientAddressId: number;
    MiniCaregiver: {
      caregiverId: components["schemas"]["CaregiverId"];
      fullName: string;
      photoUrl: null | string;
    };
    PatientEntityCustomField: {
      [key: string]: components["schemas"]["PatientCustomFieldValue"];
    };
    PatientCustomFieldValue:
      | (components["schemas"]["CustomFieldValue.Text"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.Number"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.Date"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.DateRange"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.Address"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.PhoneNumber"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.Caregiver"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.Patient"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.Boolean"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        })
      | (components["schemas"]["CustomFieldValue.Enum"] & {
          label: string;
          /** @enum {string} */
          type:
            | "ADDRESS"
            | "BOOLEAN"
            | "CAREGIVER"
            | "DATE"
            | "DATE_RANGE"
            | "ENUM"
            | "NUMBER"
            | "PATIENT"
            | "PHONE_NUMBER"
            | "TEXT";
          options: string[] | null;
          isVisibleOnPatientProfile: boolean;
        });
    PatientVacation: {
      id: components["schemas"]["PatientVacationId"];
      patientId: components["schemas"]["PatientId"];
      date: components["schemas"]["LocalDate"];
      removedAt?: components["schemas"]["Instant"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
    };
    /** Format: PatientVacationId */
    PatientVacationId: PatientVacationId;
    PatientEligibiltyStatus: {
      isEligible: null | boolean;
      isEligibleOnOtherPayer: boolean;
      eligibilityPayer: null | string;
      createdAt: components["schemas"]["Instant"];
      message: null | string;
    };
    PatientAdvancedDirective: {
      hasDNR: null | boolean;
      hasProxy: null | boolean;
      firstName: null | string;
      lastName: null | string;
      phoneNumber: null | string;
    };
    /** @enum {string} */
    PatientCertificationPeriodTaskStatus: "MISSING_RA" | "MISSING_SOC" | "OK";
    /** Format: InsurerId */
    InsurerId: InsurerId;
    InvoiceDetails: {
      hasOutdatedInvoiceVisits: boolean;
      /**
       * @description Total attributed to this invoice from patient cost share — money already
       * collected from the patient that the payer sent back as their
       * responsibility (MA64). Reported separately from `totalPaid`, which stays
       * strictly what the payer's checks covered. Zero unless the agency has cost
       * share applied to AR.
       */
      totalCostSharePaid: number;
      currentInvoiceVisitDetails: components["schemas"]["InvoiceVisitDetails"][];
      historyInvoiceVisitDetails: components["schemas"]["InvoiceVisitDetails"][];
      deletedInvoiceVisitDetails: components["schemas"]["InvoiceVisitDetails"][];
      memberId: null | string;
      checks: {
        checkId: components["schemas"]["CheckId"];
        checkNumber: string;
      }[];
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      dxCodes: string[] | null;
      invoiceBatchDisplayId: string;
      exportBatchIds: components["schemas"]["ExportBatchId"][] | null;
      exportBatchDisplayIds: string[] | null;
      patientName: string;
      patientDisplayId: null | number;
      contractTypeName: string;
      contractTypeId: components["schemas"]["ContractTypeId"];
      /** @enum {string} */
      contractTypeEBillingProvider?:
        | "Authenticare - Claims"
        | "CMS-1500"
        | "CSV"
        | "EDI - Availity"
        | "EDI - PA Promise"
        | "EDI - eMedNY"
        | "EDI File"
        | "HHAExchange"
        | "IL488"
        | "MSA-1904"
        | "PDF File"
        | "Tellus"
        | "UB04";
      visitCount: number;
      administrativePaymentCount: number;
      serviceCount: number;
      rejectedVisitCount?: number;
      currencySum?: number;
      exportedStatus: string;
      paymentStatus: string;
      patientExternalId?: null | string;
      patientAdmissionId?: null | string;
      patientSSN?: null | string;
      patientMedicareNumber?: null | string;
      patientMedicaidNumber?: null | string;
      patientAddress?: null | string;
      patientGender?: null | string;
      totalBilled: number;
      totalPaid: number;
      totalBilledSeconds: number;
      totalUnitsThousandths: number;
      startDate: components["schemas"]["LocalDate"] | null;
      endDate: components["schemas"]["LocalDate"] | null;
      invoiceVisitIds?: components["schemas"]["InvoiceVisitId"][] | null;
      serviceCodeIds: components["schemas"]["ServiceCodeId"][];
      id: components["schemas"]["InvoiceId"];
      displayId: string;
      invoiceBatchId: components["schemas"]["InvoiceBatchId"];
      agency: components["schemas"]["AgencyId"];
      patientId: components["schemas"]["PatientId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      officeId: components["schemas"]["OfficeId"];
      manualHold: boolean;
      pendingPrebillingIssueResolution: boolean;
    };
    InvoiceVisitDetails: {
      /**
       * @description Denormalised so the shared billing visits table can label a row without a
       * dictionary of every caregiver. Null when no caregiver is assigned.
       */
      caregiverName: null | string;
      caregiverDisplayId: null | number;
      caregiverCode: null | string;
      rateInCents: number;
      isExported: boolean;
      wasExported: boolean;
      visitWasEverExported?: null | boolean;
      paidTotal: number;
      /**
       * @description Cost share attributed to this visit. Kept beside `paidTotal` rather than
       * folded into it: the invoice page shows the two separately, and only the AR
       * view adds them together (and only where the agency switched that on).
       */
      costSharePaidTotal: number;
      billedTotal: number;
      paymentStatus: string;
      waitingExportResponse: boolean;
      exportCode: null | string;
      revenueCode: null | string;
      timelyFilingLimitDaysLeft: number;
      originalDaysFilingLimit: number;
      rejected: boolean;
      checkNumbers: string[] | null;
      claimNumbers: string[] | null;
      lastClaimNumber: null | string;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      clockinTime: components["schemas"]["LocalDateTime"] | null;
      clockoutTime: components["schemas"]["LocalDateTime"] | null;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      isOutdated: boolean;
      travelTime: number;
      exportVisits: components["schemas"]["ExportVisit"][];
      errors: null | string;
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      id: components["schemas"]["InvoiceVisitId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      invoiceId: components["schemas"]["InvoiceId"];
      isDeleted: boolean;
      billingUnitsThousandths: number;
      billingRateCountyId: components["schemas"]["BillingRateCountyId"];
      visitDate: components["schemas"]["LocalDate"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      pendingPrebillingResolution: boolean;
    };
    ExportVisit: {
      id: components["schemas"]["ExportVisitId"];
      exportBatchId: components["schemas"]["ExportBatchId"];
      invoiceVisitId: components["schemas"]["InvoiceVisitId"];
      removedAt: components["schemas"]["Instant"] | null;
      rejected: boolean;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      rejectionReason: null | string;
    };
    /** Format: ExportVisitId */
    ExportVisitId: ExportVisitId;
    /** Format: BillingRateCountyId */
    BillingRateCountyId: BillingRateCountyId;
    /** Format: InvoiceBatchId */
    InvoiceBatchId: InvoiceBatchId;
    PatientMedicationProfileWithDetails: {
      dose: string;
      route: string;
      medicationName: string;
      id: components["schemas"]["PatientMedicationProfileId"];
      patientId: components["schemas"]["PatientId"];
      medicationId: components["schemas"]["MedicationId"];
      from: components["schemas"]["LocalDate"] | null;
      until: components["schemas"]["LocalDate"] | null;
      frequency: null | string;
      status: components["schemas"]["PatientMedicationProfileStatus"];
      notes: null | string;
    };
    /** Format: PatientMedicationProfileId */
    PatientMedicationProfileId: PatientMedicationProfileId;
    /** Format: MedicationId */
    MedicationId: MedicationId;
    /** @enum {string} */
    PatientMedicationProfileStatus: "ACTIVE" | "DISCONTINUED";
    Medication: {
      id: components["schemas"]["MedicationId"];
      fullName: string;
      brandName: null | string;
      displayName: string;
      route: string;
      dose: string;
      agencyId: components["schemas"]["AgencyId"] | null;
    };
    /** @enum {string} */
    CreateAgencyMedicationValidationType: "NAME" | "NAME_AND_ROUTE" | "NONE";
    /** Format: PatientMedicationId */
    PatientMedicationId: PatientMedicationId;
    PatientMedicationDiagnosisCode: {
      code: string;
      description: string;
      removed: boolean;
    };
    DraftMedication: {
      id: components["schemas"]["PatientDraftMedicationId"];
      name: string;
      dosage: null | string;
      frequency: null | string;
      administrationNotes: null | string;
      diagnosisCodes?: {
        code: string;
        type: components["schemas"]["DiagnosisCodeType"];
      }[];
    };
    /** Format: PatientDraftMedicationId */
    PatientDraftMedicationId: PatientDraftMedicationId;
    /** @enum {string} */
    DiagnosisCodeType: "Other" | "Principal" | "Surgical";
    ScannedMedication: {
      name: string;
      dosage: null | string;
      frequency: null | string;
      notes: null | string;
    };
    medicationPhotoUrlResponse: {
      url: string;
      fileLocation: string;
    };
    /** Format: PatientTaskInstanceId */
    PatientTaskInstanceId: PatientTaskInstanceId;
    OfficeExtended: {
      mmis: null | string;
      id: components["schemas"]["OfficeId"];
      name: string;
      agencyId: components["schemas"]["AgencyId"];
      active: boolean;
      address: string;
      address2: null | string;
      addressComponents: components["schemas"]["AddressComponents"] | null;
      timezone: string;
      hhaExternalIds?: null | string;
      phoneNumber: null | string;
      tax_id: null | string;
      npi: null | string;
      provider_id: null | string;
      external_name: null | string;
      pfi: null | string;
      onlyPayBilledVisits: boolean;
      allowBillPendingVisits: boolean;
      requireCaregiverAssignWithOvertimePermission: boolean;
      broadcastBasedOnCaregiverOfficeBranch: boolean;
      showPayratesToCaregivers: boolean;
    };
    OfficeAddress: {
      address: string;
      timezone: string;
      addressComponents: components["schemas"]["AddressComponents"] | null;
    };
    AssocAgencyMemberParams: {
      agencyMemberId: components["schemas"]["AgencyMemberId"];
      officeId: components["schemas"]["OfficeId"];
      /** @enum {string} */
      type: "ASSOCIATE" | "DISSOCIATE";
    };
    AssocCaregiverParams: {
      caregiverId: components["schemas"]["CaregiverId"];
      officeId: components["schemas"]["OfficeId"];
      /** @enum {string} */
      type: "ASSOCIATE" | "DISSOCIATE";
    };
    PatientActiveCertificationPeriod: {
      id: components["schemas"]["CertificationPeriodId"];
      type: components["schemas"]["CertificationPeriodType"];
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      patientId: components["schemas"]["PatientId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      isCompleted: boolean;
      isCompletedManually: boolean;
      patientStartOfCare: components["schemas"]["LocalDate"] | null;
      hasTaskInstance: boolean;
    };
    /** Format: CertificationPeriodId */
    CertificationPeriodId: CertificationPeriodId;
    /** @enum {string} */
    CertificationPeriodType: "REASSESSMENT" | "START_OF_CARE";
    PatientCertificationPeriod: {
      id: components["schemas"]["CertificationPeriodId"];
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      patientId: components["schemas"]["PatientId"];
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      isCompleted: boolean;
      type: components["schemas"]["CertificationPeriodType"];
      hasTaskInstance: boolean;
    };
    "PatientTaskTypes.DraftTask": {
      /** @enum {string} */
      type: "DraftTask";
      /** @enum {string} */
      status: "Unassigned";
      priority: number;
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      patientContractName: string;
      taskId: components["schemas"]["PatientTaskId"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      title: string;
      durationMinutes: null | number;
      repeatMonths: null | number;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      /** @enum {boolean} */
      isDraft: true;
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      removedAt: components["schemas"]["Instant"] | null;
      removedBy: components["schemas"]["AgencyMemberId"] | null;
      documents: components["schemas"]["PatientDocumentTypeId"][];
      taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
      taskCanceledAt: components["schemas"]["Instant"] | null;
      taskCanceledBy: components["schemas"]["AgencyMemberId"] | null;
      allowedCertifications: components["schemas"]["CaregiverCertification"][];
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      patientOfficeId: components["schemas"]["OfficeId"];
      taskTemplateContext: ("REASSESSMENT" | "START_OF_CARE") | null;
      isCertificationPeriodBoundTask: null | boolean;
      certificationPeriodId:
        | components["schemas"]["CertificationPeriodId"]
        | null;
      dayTimeScheduleOverrideParams:
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
        | null;
      taskIssues?: components["schemas"]["DisplayTaskIssue"][];
      price: null | number;
      mainLanguage: null | string;
    };
    /** Format: PatientTaskId */
    PatientTaskId: PatientTaskId;
    /** Format: PatientTaskTemplateId */
    PatientTaskTemplateId: PatientTaskTemplateId;
    TaskDayTimeParams: components["schemas"]["TaskDayTimeParam"][] | null;
    TaskDayTimeParam: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
    };
    "TaskDayTimeScheduleOverrideParams.SpecificDates": {
      /** @enum {string} */
      type: "SpecificDates";
      params: {
        date: components["schemas"]["LocalDate"];
        timeSlots: {
          startTime: components["schemas"]["LocalTime"];
          endTime: components["schemas"]["LocalTime"];
        }[];
      }[];
    };
    "TaskDayTimeScheduleOverrideParams.Pattern": {
      /** @enum {string} */
      type: "Pattern";
      params: {
        dayOfWeek: components["schemas"]["DayOfWeek"];
        timeSlots: {
          startTime: components["schemas"]["LocalTime"];
          endTime: components["schemas"]["LocalTime"];
        }[];
      }[];
    };
    DisplayTaskIssue: {
      taskIssueTypeCode: string;
      taskIssueTypeName: string;
    };
    "PatientTaskTypes.RegularTask": {
      /** @enum {string} */
      type: "RegularTask";
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      patientContractName: string;
      taskId: components["schemas"]["PatientTaskId"];
      title: string;
      durationMinutes: null | number;
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      repeatMonths: null | number;
      patientTaskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientId: components["schemas"]["PatientId"];
      priority: number;
      patientName: string;
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      completionDate: components["schemas"]["LocalDate"] | null;
      originalCompletionDate: components["schemas"]["LocalDate"] | null;
      scheduleDateTime: components["schemas"]["Instant"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      removedAt: components["schemas"]["Instant"] | null;
      removedBy: components["schemas"]["AgencyMemberId"] | null;
      documents: components["schemas"]["PatientDocumentTypeId"][];
      taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
      taskCanceledAt: components["schemas"]["Instant"] | null;
      taskCanceledBy: components["schemas"]["AgencyMemberId"] | null;
      taskInstanceCanceledAt: components["schemas"]["Instant"] | null;
      taskInstanceCanceledBy: components["schemas"]["AgencyMemberId"] | null;
      broadcastDistance: null | number;
      isBroadcasting: boolean;
      allowedCertifications: components["schemas"]["CaregiverCertification"][];
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      patientOfficeId: components["schemas"]["OfficeId"];
      isCertificationPeriodBoundTask: null | boolean;
      certificationPeriodId:
        | components["schemas"]["CertificationPeriodId"]
        | null;
      certificationStartDate: components["schemas"]["LocalDate"] | null;
      certificationEndDate: components["schemas"]["LocalDate"] | null;
      taskTemplateContext: ("REASSESSMENT" | "START_OF_CARE") | null;
      dayTimeScheduleOverrideParams:
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
        | null;
      price: null | number;
      mainLanguage: null | string;
      agencyNote?: null | string;
      status: components["schemas"]["PatientTaskStatus"];
    };
    /** @enum {string} */
    PatientTaskStatus:
      | "Assigned"
      | "Broadcasting"
      | "Canceled"
      | "Completed"
      | "Future"
      | "Incompleted"
      | "Missing"
      | "Scheduled"
      | "Unassigned";
    PatientTaskInstanceEditScheduleDateTime: {
      scheduledDateTime: components["schemas"]["LocalDateTime"];
      duration: number;
      isConfirmed?: boolean;
      stopBroadcasting?: boolean;
      /** Format: CaregiverId */
      caregiverId?: CaregiverId;
    };
    PatientContractDiagnosisCode: {
      id: components["schemas"]["PatientContractDiagnosisCodeId"];
      icdCode: components["schemas"]["ICD10CodeId"];
      formattedDxCode: string;
      shortDesc: string;
      patientContractId: components["schemas"]["PatientContractId"];
      startDate: components["schemas"]["LocalDate"] | null;
      endDate: components["schemas"]["LocalDate"] | null;
      type: ("PRINCIPAL" | "SURGICAL") | null;
      isForBilling: boolean;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      isCreatedByAgency: boolean;
      sections?: string[];
    };
    /** Format: PatientContractDiagnosisCodeId */
    PatientContractDiagnosisCodeId: PatientContractDiagnosisCodeId;
    PatientMedicalDiagnosisCode: {
      id: components["schemas"]["PatientMedicalDiagnosisCodeId"];
      patientId: components["schemas"]["PatientId"];
      icdCode: components["schemas"]["ICD10CodeId"];
      formattedDxCode: string;
      shortDesc: string;
      /** @enum {string} */
      designation: "OTHER" | "PRIMARY";
      /** @description Free text, e.g. "Provider" or "Plan". */
      source: null | string;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
    };
    /** Format: PatientMedicalDiagnosisCodeId */
    PatientMedicalDiagnosisCodeId: PatientMedicalDiagnosisCodeId;
    PatientServicePlanListItem: {
      id: components["schemas"]["PatientServicePlanId"];
      status: components["schemas"]["PatientServicePlanStatus"];
      startDate: components["schemas"]["LocalDate"] | null;
      endDate: components["schemas"]["LocalDate"] | null;
      program: null | string;
      service: null | string;
      caseManagerName: null | string;
      tasksCount: number;
      unmappedTasksCount: number;
      finalizedAt: components["schemas"]["Instant"] | null;
      hasPdf: boolean;
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: PatientServicePlanId */
    PatientServicePlanId: PatientServicePlanId;
    /** @enum {string} */
    PatientServicePlanStatus: "DRAFT" | "FINALIZED";
    PatientServicePlanImportListItem: {
      id: components["schemas"]["PatientServicePlanImportId"];
      fileName: string;
      status: components["schemas"]["PatientServicePlanImportStatus"];
      error: null | string;
      patientServicePlanId:
        | components["schemas"]["PatientServicePlanId"]
        | null;
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: PatientServicePlanImportId */
    PatientServicePlanImportId: PatientServicePlanImportId;
    /** @enum {string} */
    PatientServicePlanImportStatus:
      | "completed"
      | "failed"
      | "pending"
      | "processing";
    /**
     * @description A plan of care item a service plan task may be mapped to — the active items of
     * the plan of care type configured for the patient's current office.
     */
    PatientPlanOfCareItem: {
      id: components["schemas"]["PlanOfCareItemId"];
      code: string;
      label: string;
      section: string;
    };
    PatientServicePlanSignature: {
      name: null | string;
      signedDate: components["schemas"]["LocalDate"] | null;
      signatureData: null | string;
    };
    /**
     * @description A live emailed signing link for one signature role of a plan. Revoked claims
     * stay in the table for audit but are never returned here.
     */
    PatientServicePlanSignatureClaim: {
      id: components["schemas"]["PatientServicePlanSignatureClaimId"];
      role: components["schemas"]["PatientServicePlanSignatureRole"];
      recipientEmail: string;
      status: components["schemas"]["PatientServicePlanSignatureClaimStatus"];
      sentAt: components["schemas"]["Instant"];
      openedAt: components["schemas"]["Instant"] | null;
      claimedAt: components["schemas"]["Instant"] | null;
      expiresAt: components["schemas"]["Instant"];
    };
    /** Format: PatientServicePlanSignatureClaimId */
    PatientServicePlanSignatureClaimId: PatientServicePlanSignatureClaimId;
    /** @enum {string} */
    PatientServicePlanSignatureRole: "ASSESSOR" | "CASE_MANAGER" | "CONSUMER";
    /** @enum {string} */
    PatientServicePlanSignatureClaimStatus:
      | "AWAITING"
      | "CLAIMED"
      | "EXPIRED"
      | "OPENED";
    PatientServicePlanTask: {
      id: components["schemas"]["PatientServicePlanTaskId"];
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"] | null;
      planOfCareItemLabel: null | string;
      planOfCareItemSection: null | string;
      section: components["schemas"]["PatientServicePlanTaskSection"];
      taskName: string;
      minutesPerTask: null | number;
      timesPerWeek: null | number;
      ame: boolean;
      justification: null | string;
      aiCertainty: null | number;
      orderInSection: number;
    };
    /** Format: PatientServicePlanTaskId */
    PatientServicePlanTaskId: PatientServicePlanTaskId;
    /** @enum {string} */
    PatientServicePlanTaskSection: "HMA" | "HOMEMAKER" | "PERSONAL_CARE";
    PatientServicePlanTaskParams: {
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"] | null;
      section: components["schemas"]["PatientServicePlanTaskSection"];
      taskName: string;
      minutesPerTask: null | number;
      timesPerWeek: null | number;
      ame: boolean;
      justification: null | string;
      aiCertainty: null | number;
      orderInSection: number;
    };
    /** @enum {string} */
    ServicePlanSignatureClaimUnavailableReason:
      | "already_claimed"
      | "expired"
      | "not_found"
      | "plan_finalized"
      | "revoked";
    CdscExtractionResult:
      | {
          /** @enum {boolean} */
          ok: true;
          data: components["schemas"]["CdscExtractionData"];
        }
      | {
          /** @enum {boolean} */
          ok: false;
          error: string;
        };
    CdscExtractionData: {
      header: components["schemas"]["CdscExtractionHeader"];
      tasks: components["schemas"]["CdscExtractionTask"][];
      totals: components["schemas"]["CdscExtractionTotals"];
      warnings: string[];
    };
    CdscExtractionHeader: {
      startDate: null | string;
      endDate: null | string;
      program: null | string;
      service: null | string;
      caseManagerName: null | string;
      memberName: null | string;
      medicaidId: null | string;
      dateOfBirth: null | string;
      planStart: ("NEW_CONSUMER" | "RENEWING") | null;
    };
    CdscExtractionTask: {
      section: components["schemas"]["PatientServicePlanTaskSection"];
      taskName: string;
      minutesPerTask: null | number;
      timesPerWeek: null | number;
      ame: boolean;
      justification: null | string;
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"] | null;
      confidence: number;
    };
    CdscExtractionTotals: {
      homemakerHours: null | number;
      personalCareHours: null | number;
      hmaHours: null | number;
      lrpHours: null | number;
    };
    PatientExpectedDocumentObjectTask: {
      /** @enum {string} */
      __typename: "PatientExpectedDocumentObjectTask";
      id: components["schemas"]["PatientDocumentScheduleId"] | null;
      documentType: components["schemas"]["PatientDocumentTypeId"];
      title: string;
      versionId: components["schemas"]["PatientDocumentVersionId"] | null;
      taskId: components["schemas"]["PatientTaskId"];
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      scheduledDate: components["schemas"]["LocalDate"] | null;
      submittedAt: components["schemas"]["LocalDateTime"] | null;
      submittedByName: null | string;
      content: components["schemas"]["PatientDocumentContentItem"][];
      answers: components["schemas"]["PatientDocumentAnswerObject"][];
      pdfUrl: null | string;
      type: components["schemas"]["PatientDocumentTypes"];
      isOpenForResubmission: boolean;
      resubmissionReason: null | string;
      wasSentViaFax: boolean;
      wasSentViaEmail: boolean;
      physicianSignDate: components["schemas"]["LocalDate"] | null;
      approvedDate: components["schemas"]["LocalDate"] | null;
      sentToPhysicianDate: components["schemas"]["LocalDate"] | null;
      copiedFrom: components["schemas"]["PatientDocumentScheduleId"] | null;
      taskRemoved: boolean;
      certificationPeriod?: string;
      hasUnresolvedChangeRequest: boolean;
    };
    /** Format: PatientDocumentScheduleId */
    PatientDocumentScheduleId: PatientDocumentScheduleId;
    /** Format: PatientDocumentVersionId */
    PatientDocumentVersionId: PatientDocumentVersionId;
    PatientDocumentContentItem: {
      id: number;
      mainClass: string;
      title: string;
      itemType: components["schemas"]["DocumentItemQuestionType"];
      label: string;
      /** @description Extra details shown to the RN/Caregiver, not rendered on the PDF */
      subtitle?: string;
      columns?: [components["schemas"]["PatientDocumentContentItem"][]] | null;
      possibleAnswers?: string[];
      htmlTemplateId?: string;
      sectionCode?: string;
      /** @description Used only for document question type "POC" */
      POCItems?: components["schemas"]["PatientDocumentPOCItem"][];
      isRequired?: boolean;
      parentId: null | number;
      showIfParentEquals: null | boolean;
      ifParentEquals?: string;
      showOtherOption?: boolean;
      html?: string;
      url?: null | string;
      days?: components["schemas"]["DayOfWeek"][];
      frequencyPerWeek?: number;
      visitPerWeek?: number;
      notes?: null | string;
      parentType?:
        | (
            | "POC"
            | "RNPlatformPatientPhysician"
            | "bigHeader"
            | "bloodPressure"
            | "bodyDrawing"
            | "chart"
            | "check"
            | "customSignature"
            | "date"
            | "dropDown"
            | "editor"
            | "employeeSignature"
            | "finalIcdCodes"
            | "icd"
            | "icdChart"
            | "icdCodes"
            | "image"
            | "medicalDiagnosis"
            | "medicationProfile"
            | "medicationProfileItem"
            | "number"
            | "patientPhysician"
            | "patientSignature"
            | "radio"
            | "sectionedIcdCodes"
            | "smallHeader"
            | "textLong"
            | "textShort"
            | "time"
            | "vbpItem"
            | "weight"
            | "yesNo"
          )
        | null;
      linkId?: null | number;
      cms485QuestionId?: string;
      oca960questionId?: string;
      medflytPOCFieldName?: string;
      prefilledAnswer?: null | string;
      dynamicPrefilledAnswer?:
        | (
            | "CMS485_PROVIDER_NAME_AND_ETC"
            | "CMS485_PROVIDER_NUMBER"
            | "ORDER_FOR_DISCIPLINE_AND_TREATMENT"
            | "PATIENT_ASSIGNED_CAREGIVER"
            | "PATIENT_VISITS_FREQUENCY"
          )
        | null;
      answerValues?: number[];
      valueGroup?: null | string;
      isInValueGroup?: boolean;
      useInOtherDocs?: boolean;
      copyFromOtherDocs?: boolean;
      allowUnsignedSignature?: boolean;
      hideNameFieldSignature?: boolean;
      useForMedication?: boolean;
      canCopyFromMedication?: boolean;
      useForDisciplinAndTreatment?: boolean;
      canCopyFromDisciplinAndTreatment?: boolean;
      isIcd?: boolean;
      patientMedicationDetails?: components["schemas"]["PatientMedicationProfileWithDetails"];
      blockOnMobile?: boolean;
      blockOnWebapp?: boolean;
      hideOnMobile?: boolean;
      hideOnPDF?: boolean;
      /** Format: NursingQuestionId */
      nursingQuestionLinked?: NursingQuestionId;
      isVital?: boolean;
      vitalMeasuredAt?: components["schemas"]["LocalDateTime"] | null;
      vitalComments?: null | string;
      vitalMethod?:
        | (
            | "ARM"
            | "Axillary"
            | "EAR"
            | "Irregular"
            | "Labored"
            | "Laying"
            | "Left Arm"
            | "MOUTH"
            | "Oral"
            | "Rectal"
            | "Regular"
            | "Remote/Forehead"
            | "Right Arm"
            | "Shallow"
            | "Sitting"
            | "Standing"
            | "WNL"
          )
        | null;
      vitalUnit?:
        | (
            | "Beats Per Minute"
            | "Breaths Per Minute"
            | "CELSIUS"
            | "FAHRENHEIT"
            | "KG"
            | "cm"
            | "mmHg"
          )
        | null;
      isNarrative?: boolean;
      isTeachingProvided?: boolean;
      /**
       * @description When the document is approved and the answer to this question matches one of these
       * values, the approved-document email is not sent at all.
       */
      preventEmailOnApprovalAnswers?: string[];
      /**
       * @description When set, this question replaces its parent in the UI.
       * The child's options will include an exclusiveField option that maps to the parent's answer.
       * The mapping defines how child options map to parent values.
       */
      parentAnswer?: components["schemas"]["ParentAnswerMapping"];
      /**
       * @description This property is used to add a button under a question to help navigate to another question inside a document.
       * e.g when clicking "yes" on "does the current methods helps reduce pain?" it will display a button to
       * navigate to the patient medications question to add some
       */
      directToQuestionTemplateIds?: {
        onAnswer: string;
        htmlTemplateId: string;
        text: string;
      }[];
      /** @description Settings for lambda rendering */
      forceNewLine?: boolean;
      width?: (1 | 2 | 3 | 4) | null;
      answerInline?: boolean;
      showOnlyAnswer?: boolean;
      hideOnPdfIfEmpty?: boolean;
      possibleAnswersInDifferentLines?: boolean;
      /**
       * @description AI text generation settings - only applicable to textShort and textLong question types
       * If specified, determines which AI prompt to use and what logic to run
       * @enum {string}
       */
      aiGenerationType?: "PATIENT_ASSESSMENT_PROGRESS_NOTE";
      vbpId?: components["schemas"]["VBPItemId"] | string;
    };
    /** @enum {string} */
    DocumentItemQuestionType:
      | "POC"
      | "RNPlatformPatientPhysician"
      | "bigHeader"
      | "bloodPressure"
      | "bodyDrawing"
      | "chart"
      | "check"
      | "customSignature"
      | "date"
      | "dropDown"
      | "editor"
      | "employeeSignature"
      | "finalIcdCodes"
      | "icd"
      | "icdChart"
      | "icdCodes"
      | "image"
      | "medicalDiagnosis"
      | "medicationProfile"
      | "medicationProfileItem"
      | "number"
      | "patientPhysician"
      | "patientSignature"
      | "radio"
      | "sectionedIcdCodes"
      | "smallHeader"
      | "textLong"
      | "textShort"
      | "time"
      | "vbpItem"
      | "weight"
      | "yesNo";
    PatientDocumentPOCItem: {
      medflytPOCFieldNames?: [string, string];
      /** @description textual id used in supervisory mapping to link POC items to supervisory questions */
      id?: string;
      name: string;
      isTitle: boolean;
      planOfCareItemCode?: number;
    };
    ParentAnswerMapping: {
      exclusiveField?: {
        label: string;
        value: string;
        /** @enum {string} */
        position?: "first" | "last";
      };
      mapping: components["schemas"]["Record<string,string>"];
      otherOption?: string;
    };
    "Record<string,string>": { [key: string]: unknown };
    /** Format: VBPItemId */
    VBPItemId: VBPItemId;
    PatientDocumentAnswerObject: {
      questionId: number;
      chartRow: number;
      answer: components["schemas"]["PatientDocumentAnswer"];
      answeredAt: components["schemas"]["Instant"] | null;
    };
    PatientDocumentAnswer:
      | string[]
      | components["schemas"]["RNPlatformPatientPhysicianDetails"]
      | components["schemas"]["PatientMedicationProfileWithDetails"][]
      | components["schemas"]["PatientContractDiagnosisCode"][]
      | components["schemas"]["POCItemsDocumentAnswer"][]
      | components["schemas"]["WeightAnswer"]
      | (null | string);
    RNPlatformPatientPhysicianDetails: {
      name: string;
      address: string;
      npi: null | string;
      phoneNumbers: {
        number: string;
        institution: string;
      }[];
      faxNumbers: string[];
    };
    POCItemsDocumentAnswer: {
      item: string;
      attributes: components["schemas"]["TaskWhenToPerformNursing"];
      notes?: null | string;
    };
    TaskWhenToPerformNursing:
      | components["schemas"]["TaskWhenToPerform.AsRequestedByPatient"]
      | components["schemas"]["TaskWhenToPerform.EveryVisit"]
      | {
          /** @enum {string} */
          type: "OnDaysOfWeek";
          frequency: components["schemas"]["FrequencyVisitedInAWeekDetails"];
        }
      | {
          /** @enum {string} */
          type: "Daily";
        }
      | {
          /** @enum {string} */
          type: "Weekly";
        }
      | {
          /** @enum {string} */
          type: "1-2xWeekly";
        }
      | {
          /** @enum {string} */
          type: "DailyAsNeeded";
        }
      | {
          /** @enum {string} */
          type: "WeeklyAsNeeded";
        }
      | {
          /** @enum {string} */
          type: "1-2xWeeklyAsNeeded";
        };
    "TaskWhenToPerform.AsRequestedByPatient": {
      /** @enum {string} */
      type: "AsRequestedByPatient";
    };
    "TaskWhenToPerform.EveryVisit": {
      /** @enum {string} */
      type: "EveryVisit";
    };
    FrequencyVisitedInAWeekDetails: {
      frequency: number;
      visitsInAWeek: number;
    };
    WeightAnswer: {
      /** @enum {string} */
      unit: "KG" | "lbs";
      amount: number;
    };
    /** @enum {string} */
    PatientDocumentTypes:
      | "CMS485"
      | "DUTY_SHEET"
      | "FC_CMS485"
      | "FC_INTERIM_ORDER"
      | "GENERAL"
      | "ISR_NHTD"
      | "ISR_TBI"
      | "MEDFLYT_EMERGENCY_KARDEX_HTML"
      | "MEDFLYT_PARAPROFESSIONAL_SUPERVISORY_HTML"
      | "MEDFLYT_PATIENT_ASSESSMENT_HTML"
      | "MEDFLYT_PLAN_OF_CARE_HTML"
      | "MEDFLYT_POC"
      | "MEDFLYT_WELCOME_PACKAGE_HTML"
      | "MEDICATION_PROFILE"
      | "OCA960"
      | "PATIENT_ASSESSMENT_HTML_TEST"
      | "SRI";
    PatientExpectedDocumentObjectAgencyMember: {
      /** @enum {string} */
      __typename: "PatientExpectedDocumentObjectAgencyMember";
      id: components["schemas"]["PatientDocumentScheduleId"] | null;
      documentType: components["schemas"]["PatientDocumentTypeId"];
      title: string;
      versionId: components["schemas"]["PatientDocumentVersionId"] | null;
      agencyMemberId: components["schemas"]["AgencyMemberId"];
      submittedAt: components["schemas"]["Instant"] | null;
      submittedByName: null | string;
      content: components["schemas"]["PatientDocumentContentItem"][];
      answers: components["schemas"]["PatientDocumentAnswerObject"][];
      pdfUrl: null | string;
      type: components["schemas"]["PatientDocumentTypes"];
      isOpenForResubmission: boolean;
      wasSentViaFax: boolean;
      wasSentViaEmail: boolean;
      physicianSignDate: components["schemas"]["LocalDate"] | null;
      approvedDate: components["schemas"]["LocalDate"] | null;
      sentToPhysicianDate: components["schemas"]["LocalDate"] | null;
      copiedFrom: components["schemas"]["PatientDocumentScheduleId"] | null;
    };
    PatientExpectedDocumentObjectVisit: {
      /** @enum {string} */
      __typename: "PatientExpectedDocumentObjectVisit";
      id: components["schemas"]["PatientDocumentScheduleId"] | null;
      documentType: components["schemas"]["PatientDocumentTypeId"];
      title: string;
      versionId: components["schemas"]["PatientDocumentVersionId"] | null;
      scheduledVisitId: components["schemas"]["VisitInstanceId"];
      scheduledDate: components["schemas"]["LocalDate"];
      submittedAt: components["schemas"]["Instant"] | null;
      submittedByName: null | string;
      content: components["schemas"]["PatientDocumentContentItem"][];
      answers: components["schemas"]["PatientDocumentAnswerObject"][];
      pdfUrl: null | string;
      type: components["schemas"]["PatientDocumentTypes"];
      isOpenForResubmission: boolean;
      wasSentViaFax: boolean;
      wasSentViaEmail: boolean;
      physicianSignDate: components["schemas"]["LocalDate"] | null;
      approvedDate: components["schemas"]["LocalDate"] | null;
      sentToPhysicianDate: components["schemas"]["LocalDate"] | null;
      copiedFrom: components["schemas"]["PatientDocumentScheduleId"] | null;
    };
    PatientExpectedScannedDocumentObjectVisit: {
      /** @enum {string} */
      __typename: "PatientExpectedScannedDocumentObjectVisit";
      id: components["schemas"]["PatientDocumentScheduleId"];
      title: string;
      scheduledDate: components["schemas"]["LocalDate"];
      scheduledVisitId: components["schemas"]["VisitInstanceId"];
      submittedAt: components["schemas"]["Instant"];
      submittedByName: string;
      pdfUrl: null | string;
      documentScanned: boolean;
    };
    PatientExpectedScannedDocumentObjectTask: {
      /** @enum {string} */
      __typename: "PatientExpectedScannedDocumentObjectTask";
      id: components["schemas"]["PatientDocumentScheduleId"];
      title: string;
      scheduledDate: components["schemas"]["LocalDate"];
      taskId: components["schemas"]["PatientTaskId"];
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      submittedAt: components["schemas"]["Instant"];
      submittedByName: string;
      pdfUrl: null | string;
      documentScanned: boolean;
    };
    PatientDocumentQuestionRejection: {
      id: components["schemas"]["PatientDocumentAiReviewProcessQuestionRejectionId"];
      questionId: number;
      rejection: string;
      resolvedAt: components["schemas"]["Instant"] | null;
      declinedAt: components["schemas"]["Instant"] | null;
      markedStaleAtBySystem: components["schemas"]["Instant"] | null;
    };
    /** Format: PatientDocumentAiReviewProcessQuestionRejectionId */
    PatientDocumentAiReviewProcessQuestionRejectionId: PatientDocumentAiReviewProcessQuestionRejectionId;
    PatientTaskDocumentObjectPartial: {
      id: components["schemas"]["PatientDocumentScheduleId"] | null;
      documentType: components["schemas"]["PatientDocumentTypeId"];
      title: string;
      versionId: components["schemas"]["PatientDocumentVersionId"];
      patientTaskId: components["schemas"]["PatientTaskId"];
      patientTaskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      createdAt: components["schemas"]["Instant"];
      submittedAt: components["schemas"]["Instant"] | null;
      content: components["schemas"]["PatientDocumentContentItem"][];
      answers: components["schemas"]["PatientDocumentAnswerObject"][];
      pdfUrl: null | string;
      isScannable: boolean;
      readonly: boolean;
      documentTypeType: components["schemas"]["PatientDocumentTypes"];
      htmlVersionId: null | number;
      resubmissionReason: null | string;
    };
    VitalExtraDetails: {
      measuredAt: components["schemas"]["LocalDateTime"] | null;
      method:
        | (
            | "ARM"
            | "Axillary"
            | "EAR"
            | "Irregular"
            | "Labored"
            | "Laying"
            | "Left Arm"
            | "MOUTH"
            | "Oral"
            | "Rectal"
            | "Regular"
            | "Remote/Forehead"
            | "Right Arm"
            | "Shallow"
            | "Sitting"
            | "Standing"
            | "WNL"
          )
        | null;
      comments: null | string;
      unit:
        | (
            | "Beats Per Minute"
            | "Breaths Per Minute"
            | "CELSIUS"
            | "FAHRENHEIT"
            | "KG"
            | "cm"
            | "mmHg"
          )
        | null;
    };
    PatientTaskDocumentChangeRequest:
      | {
          /** @enum {string} */
          status: "resolved";
          id: components["schemas"]["PatientTaskDocumentChangeRequestId"];
          taskId: components["schemas"]["PatientTaskId"];
          request: string;
          response: null | string;
          createdAt: components["schemas"]["Instant"];
          resolvedAt: components["schemas"]["Instant"];
          requestedBy: {
            id: components["schemas"]["AgencyMemberId"];
            name: string;
            avatar: null | string;
          };
          resolvedBy: {
            id: components["schemas"]["AgencyMemberId"];
            name: string;
            avatar: null | string;
          };
        }
      | {
          /** @enum {string} */
          status: "pending";
          id: components["schemas"]["PatientTaskDocumentChangeRequestId"];
          taskId: components["schemas"]["PatientTaskId"];
          request: string;
          createdAt: components["schemas"]["Instant"];
          requestedBy: {
            id: components["schemas"]["AgencyMemberId"];
            name: string;
            avatar: null | string;
          };
        };
    /** Format: PatientTaskDocumentChangeRequestId */
    PatientTaskDocumentChangeRequestId: PatientTaskDocumentChangeRequestId;
    PatientTaskDocumentRejection: {
      id: components["schemas"]["TaskDocumentRejectionId"];
      rejection: string;
      rejectionType: components["schemas"]["RejectionType"];
      rejectionFlags: string[];
      resolvedAt: components["schemas"]["Instant"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: string;
    } & {
      documentTitle: string;
      documentId: components["schemas"]["PatientDocumentScheduleId"];
    };
    /** Format: TaskDocumentRejectionId */
    TaskDocumentRejectionId: TaskDocumentRejectionId;
    /** @enum {string} */
    RejectionType: "allowed" | "allowed_with_flags" | "blocked";
    AgencyDocumentReviewHeader: {
      agencyName: string;
      agencyAddress: null | string;
      agencyPhone: null | string;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      caregiverName: null | string;
      patientContractId: components["schemas"]["PatientContractId"];
    };
    DocumentQuestionComment: {
      id: components["schemas"]["PatientDocumentAiReviewProcessQuestionRejectionId"];
      questionId: number;
      text: string;
      /** @enum {string} */
      source: "agency" | "ai";
      state: components["schemas"]["DocumentQuestionCommentState"];
      stateReason: null | string;
      createdAt: components["schemas"]["Instant"];
      createdByName: null | string;
    };
    /** @enum {string} */
    DocumentQuestionCommentState: "declined" | "open" | "resolved" | "stale";
    ReopenDocumentQuestionComment: {
      questionId: number;
      comment: string;
    };
    RnPlatformDocumentDeliveryLogEntry:
      | {
          /** @enum {string} */
          status: "pending";
          documentName: string;
          recipient: {
            type: components["schemas"]["DocumentLinkRecipientType"];
            contact: string;
          };
          queuedAt: components["schemas"]["Instant"];
        }
      | {
          /** @enum {string} */
          status: "sent";
          documentName: string;
          recipient: {
            type: components["schemas"]["DocumentLinkRecipientType"];
            contact: string;
          };
          queuedAt: components["schemas"]["Instant"];
          sentAt: components["schemas"]["Instant"];
        }
      | {
          /** @enum {string} */
          status: "failed";
          error: string;
          documentName: string;
          recipient: {
            type: components["schemas"]["DocumentLinkRecipientType"];
            contact: string;
          };
          queuedAt: components["schemas"]["Instant"];
          failedAt: components["schemas"]["Instant"];
        };
    /** @enum {string} */
    DocumentLinkRecipientType: "caregiver" | "patient";
    PatientDocumentRow: {
      id: components["schemas"]["PatientDocumentScheduleId"];
      createdAt: components["schemas"]["Instant"];
      submittedAt: components["schemas"]["Instant"] | null;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientDocumentTypeId:
        | components["schemas"]["PatientDocumentTypeId"]
        | null;
      versionId: components["schemas"]["PatientDocumentVersionId"] | null;
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      fileUrl: null | string;
      documentTitle: null | string;
      documentScanned: boolean;
      removedAt: components["schemas"]["Instant"] | null;
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"] | null;
      submittedBy: components["schemas"]["UserId"];
      agencyMemberId: components["schemas"]["AgencyMemberId"] | null;
      patientId: components["schemas"]["PatientId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      physicianSignDate: components["schemas"]["LocalDate"] | null;
      approvedDate: components["schemas"]["LocalDate"] | null;
      sentToPhysicianDate: components["schemas"]["LocalDate"] | null;
      isOpenForResubmission: boolean;
      resubmissionReason: null | string;
    };
    AgencyPatientDocument: {
      patient: {
        id: components["schemas"]["PatientId"];
        displayId: null | number;
        name: string;
        status: components["schemas"]["PatientStatus"];
      };
      physician: {
        name: null | string;
        phone: null | string;
      };
      document: {
        id: components["schemas"]["PatientDocumentScheduleId"] | null;
        title: null | string;
        type: {
          id: components["schemas"]["PatientDocumentTypeId"];
          title: null | string;
        } | null;
        versionId: components["schemas"]["PatientDocumentVersionId"] | null;
        status: components["schemas"]["PatientDocumentStatus"];
        dueDate: components["schemas"]["LocalDate"] | null;
        latestSentOutDate: components["schemas"]["LocalDate"] | null;
        signedDate: components["schemas"]["LocalDate"] | null;
        sentToPhysicianDate: components["schemas"]["LocalDate"] | null;
        approvedDate: components["schemas"]["LocalDate"] | null;
        createdAt: components["schemas"]["Instant"] | null;
        createdByName: null | string;
        hasFile: boolean;
        isScanned: boolean;
        visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
        taskInstanceId: components["schemas"]["PatientTaskInstanceId"] | null;
        submittedAt: components["schemas"]["Instant"] | null;
        submittedByName: null | string;
        content: components["schemas"]["PatientDocumentContentItem"][];
        answers: components["schemas"]["PatientDocumentAnswerObject"][];
        isOpenForResubmission: boolean;
        wasSentViaFax: boolean;
        wasSentViaEmail: boolean;
      };
      assignedNurse: {
        id: components["schemas"]["CaregiverId"] | null;
        name: null | string;
      };
    };
    /** @enum {string} */
    PatientDocumentStatus:
      | "APPROVED"
      | "COMPLETED"
      | "IN_PROGRESS"
      | "MISSING"
      | "OPEN_FOR_RESUBMISSION"
      | "SENT"
      | "SENT_TO_PHYSICIAN"
      | "SIGNED";
    "Record<string,QuestionGenerationAvailability>": { [key: string]: unknown };
    PatientTaskDocumentSection: {
      code: string;
      name: string;
      status: components["schemas"]["PatientTaskDocumentSectionStatus"];
    };
    PatientTaskDocumentSectionStatus: string;
    PatientStatusChange: {
      status: components["schemas"]["PatientStatus"];
      statusText: components["schemas"]["PatientStatus"];
      statusDisplayName: string;
      statusActive: null | boolean;
      patientContractId: components["schemas"]["PatientContractId"] | null;
      effectiveDate: components["schemas"]["LocalDate"];
      reason: components["schemas"]["StatusChangeReasonId"] | null;
      reasonLabel: null | string;
      statusChangeReasonText: null | string;
      to: components["schemas"]["StatusChangeToId"] | null;
      toLabel: null | string;
      statusChangeToText: null | string;
      notes: null | string;
      predefinedAnswerText: null | string;
    };
    /** Format: StatusChangeReasonId */
    StatusChangeReasonId: StatusChangeReasonId;
    /** Format: StatusChangeToId */
    StatusChangeToId: StatusChangeToId;
    PatientSurplus: {
      id: components["schemas"]["PatientSurplusId"];
      patientContractId: components["schemas"]["PatientContractId"] | null;
      fromDate: components["schemas"]["LocalDate"];
      toDate: components["schemas"]["LocalDate"] | null;
      amountInCents: number;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
    };
    /** Format: PatientSurplusId */
    PatientSurplusId: PatientSurplusId;
    PatientSurplusCheck: {
      id: components["schemas"]["PatientSurplusCheckId"];
      patientId: components["schemas"]["PatientId"];
      receivedAt: components["schemas"]["LocalDate"];
      totalAmountInCents: number;
      allocatedAmountInCents: number;
      outstandingAmountInCents: number;
      outstandingSumInCents: number;
      patientSurplusInvoiceIds:
        | components["schemas"]["PatientSurplusInvoiceId"][]
        | null[]
        | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
    };
    /** Format: PatientSurplusCheckId */
    PatientSurplusCheckId: PatientSurplusCheckId;
    /** Format: PatientSurplusInvoiceId */
    PatientSurplusInvoiceId: PatientSurplusInvoiceId;
    PatientSurplusInvoiceExtended: {
      outstandingAmountInCents: number;
      outstandingSumInCents: number;
      id: components["schemas"]["PatientSurplusInvoiceId"];
      patientSurplusId: components["schemas"]["PatientSurplusId"];
      patientSurplusAmountInCents: number;
      invoiceDate: components["schemas"]["LocalDate"];
      paidAmountInCents: number;
      patientSurplusCheckIds?: components["schemas"]["PatientSurplusCheckId"][];
      totalAmountInCents: number;
      status: components["schemas"]["PatientSurplusInvoiceStatus"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
    };
    /** @enum {string} */
    PatientSurplusInvoiceStatus: "FULLY_PAID" | "NOT_PAID" | "PARTIALLY_PAID";
    PatientSurplusInvoiceCreateResponseRecord: {
      /** @enum {string} */
      result: "CREATED" | "NO_SURPLUS" | "NO_VISITS" | "UPDATED";
      patientSurplusInvoiceId:
        | components["schemas"]["PatientSurplusInvoiceId"]
        | null;
      month: components["schemas"]["LocalDate"];
      totalPaid: number;
    };
    PatientSurplusDashboardRecord: {
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientContractId: components["schemas"]["PatientContractId"];
      patientContractName: string;
      outstandingAmountInCents: number;
      outstandingSumInCents: number;
      id: components["schemas"]["PatientSurplusInvoiceId"];
      patientSurplusId: components["schemas"]["PatientSurplusId"];
      patientSurplusAmountInCents: number;
      invoiceDate: components["schemas"]["LocalDate"];
      paidAmountInCents: number;
      patientSurplusCheckIds?: components["schemas"]["PatientSurplusCheckId"][];
      totalAmountInCents: number;
      status: components["schemas"]["PatientSurplusInvoiceStatus"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
    };
    MessagesPatient: components["schemas"]['Omit<Patient,"address">'] & {
      assignedNurse: components["schemas"]["CaregiverId"] | null;
      medicalNotes: null | string;
      generalNotes: null | string;
      blacklisted: components["schemas"]["CaregiverId"][] | null;
      address:
        | components["schemas"]['Omit<PatientAddressComponents,"components">']
        | null;
    };
    'Omit<Patient,"address">': {
      id: components["schemas"]["PatientId"];
      address2: null | string;
      addressInstructions: null | string;
      gender: null | string;
      ssn: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      homePhoneNumber: null | string;
      mobilePhoneNumber: null | string;
      isMobilePhoneNumberSmsable: boolean;
      phone3: null | string;
      isPhone3Smsable: boolean;
      phone4: null | string;
      isPhone4Smsable: boolean;
      status: components["schemas"]["PatientStatus"];
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["AgencyId"];
      mutualLink: null | boolean;
      linkedWith: components["schemas"]["PatientId"] | null;
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      currentOfficeId: components["schemas"]["OfficeId"];
      agencyTeamId: components["schemas"]["AgencyTeamId"] | null;
      assignedCoordinator: components["schemas"]["AgencyMemberId"] | null;
      timezone: string;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      admissionId: null | string;
      startOfCare: components["schemas"]["LocalDate"] | null;
      state: string;
      countyName: string;
      medicaidNumber: null | string;
      clinicalSeverityLevel:
        | ("HIGHEST_ASSISTANCE" | "MINIMAL_ASSISTANCE" | "WALKING_ASSISTANCE")
        | null;
    };
    'Omit<PatientAddressComponents,"components">': {
      timezone: string;
      text: string;
    };
    MessagesPatients: {
      patients: components["schemas"]["MessagesPatient"][];
    };
    MessagesPatientsLinks: {
      links: string[];
    };
    /** @enum {string} */
    Day:
      | "FRIDAY"
      | "MONDAY"
      | "SATURDAY"
      | "SUNDAY"
      | "THURSDAY"
      | "TUESDAY"
      | "WEDNESDAY";
    /** Format: PatientAvailabilityTimeframeId */
    PatientAvailabilityTimeframeId: PatientAvailabilityTimeframeId;
    /** Format: PortalUserId */
    PortalUserId: PortalUserId;
    PatientSearchItem: {
      id: components["schemas"]["PatientId"];
      externalId: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      status: components["schemas"]["PatientStatus"];
      gender: ("F" | "M") | null;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      address: null | string;
    };
    InsertPatientPhoneNumberParams: {
      patientId: components["schemas"]["PatientId"];
      /** @enum {string} */
      type: "MOBILE" | "OTHER" | "TEL";
      label: null | string;
      description: null | string;
      phonenumber: string;
    };
    InlineCreateContractParams: {
      contractType: components["schemas"]["ContractTypeId"];
      startOfCareDate: components["schemas"]["LocalDate"] | null;
      startDate: components["schemas"]["LocalDate"];
      isPrimary: boolean;
      medicaidNumber: null | string;
      medicareNumber: null | string;
      memberId: null | string;
    };
    Patient: {
      id: components["schemas"]["PatientId"];
      ssn: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      homePhoneNumber: null | string;
      mobilePhoneNumber: null | string;
      isMobilePhoneNumberSmsable: boolean;
      phone3: null | string;
      isPhone3Smsable: boolean;
      phone4: null | string;
      isPhone4Smsable: boolean;
      address: components["schemas"]["PatientAddressComponents"] | null;
      address2: null | string;
      addressInstructions: null | string;
      status: components["schemas"]["PatientStatus"];
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["AgencyId"];
      gender: null | string;
      mutualLink: null | boolean;
      linkedWith: components["schemas"]["PatientId"] | null;
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      currentOfficeId: components["schemas"]["OfficeId"];
      agencyTeamId: components["schemas"]["AgencyTeamId"] | null;
      assignedCoordinator: components["schemas"]["AgencyMemberId"] | null;
      timezone: string;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      admissionId: null | string;
      startOfCare: components["schemas"]["LocalDate"] | null;
      state: string;
      countyName: string;
      medicaidNumber: null | string;
      clinicalSeverityLevel:
        | ("HIGHEST_ASSISTANCE" | "MINIMAL_ASSISTANCE" | "WALKING_ASSISTANCE")
        | null;
    };
    PatientPlanOfCareDutySheets: {
      planOfCare: {
        id: components["schemas"]["PlanOfCareId"];
        planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"];
        startDate: components["schemas"]["LocalDate"] | null;
        endDate: components["schemas"]["LocalDate"] | null;
        submittedAt: components["schemas"]["Instant"];
        duties: {
          id: components["schemas"]["PlanOfCareDutyId"];
          period: components["schemas"]["PlanOfCareDutyPeriod"];
          days: components["schemas"]["DayOfWeek"][] | null;
          frequency: null | number;
          visitsPerWeek: null | number;
          item: {
            id: components["schemas"]["PlanOfCareItemId"];
            label: string;
            code: string;
          };
        }[];
      };
      dutySheets: {
        id: components["schemas"]["DutySheetId"] | null;
        caregiverId: components["schemas"]["CaregiverId"];
        /**
         * @description Denormalised so the duty-sheet view can label and picture a caregiver
         * without holding a dictionary of every caregiver.
         */
        caregiverName: null | string;
        caregiverPhotoUrl: null | string;
        visitInstanceId: components["schemas"]["VisitInstanceId"];
        visitInstanceStartDate: components["schemas"]["LocalDate"];
        selectedItems: {
          planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
          /**
           * @description Which occurrence of the duty on that visit this row is, now that a
           * visit may record the same duty more than once.
           *
           * Null on a duty the plan of care schedules: that row summarises every
           * occurrence of the duty on the visit, so there is no single one to
           * name. Set on an ad-hoc duty, which is listed one row per occurrence.
           */
          occurrenceIndex: null | number;
          isCompleted: boolean;
          type: ("COORDINATOR" | "IVR" | "MOBILE" | "TIME_SHEET") | null;
          notes: null | string;
        }[];
      }[];
    };
    /** Format: PlanOfCareId */
    PlanOfCareId: PlanOfCareId;
    /** Format: PlanOfCareDutyId */
    PlanOfCareDutyId: PlanOfCareDutyId;
    /** @enum {string} */
    PlanOfCareDutyPeriod:
      | "1_2X_WEEKLY"
      | "1_2X_WEEKLY_AS_NEEDED"
      | "AS_REQUESTED"
      | "DAILY"
      | "DAILY_AS_NEEDED"
      | "DAYS_A_WEEK"
      | "EVERY_VISIT"
      | "WEEKLY"
      | "WEEKLY_AS_NEEDED";
    /** Format: DutySheetId */
    DutySheetId: DutySheetId;
    PatientContractBasicData: {
      id: components["schemas"]["PatientContractId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      contractTypeName: string;
      payerId: components["schemas"]["PayerId"];
      payerName: string;
      serviceCodeName: null | string;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"] | null;
      isPrimary: null | boolean;
      isOnHold: null | boolean;
      memberId: string;
      medicaidNumber: null | string;
      medicareNumber: null | string;
      hhaPayer: components["schemas"]["HHAPayersByPatientId"] | null;
      hhaPayerName: null | string;
      treatmentCount: number;
    };
    Agency: {
      id: components["schemas"]["AgencyId"];
      createdAt: components["schemas"]["Instant"];
      name: string;
      logoUrl: null | string;
      website: null | string;
      address: null | string;
      address2: null | string;
      officePhone: null | string;
      organizationType: null | string;
      allowBoost: boolean;
      shouldSendInvoice: boolean;
      ipAddressesOpen?: boolean;
      ipAddressesWhitelist?: string[] | null;
      signaturePerson?: components["schemas"]["AgencyMemberId"] | null;
      clockInFeature: boolean;
      defaultOfficeId: components["schemas"]["OfficeId"];
      notificationAgencyMemberId:
        | components["schemas"]["AgencyMemberId"]
        | null;
      ivrPhoneNumber: null | string;
      ivrPhoneNumbers: components["schemas"]["AgencyIvrPhoneNumber"][] | null;
      isMedflytAgency: boolean;
      isMobileComplianceEnabled: boolean;
    };
    NearFutureCaregiver: {
      id: components["schemas"]["CaregiverId"];
      firstName: string;
      lastName: string;
      phoneNumber: null | string;
    };
    PatientCostShareSchedule: {
      id: components["schemas"]["PatientCostShareScheduleId"];
      patientId: components["schemas"]["PatientId"];
      amountCents: number;
      frequency: components["schemas"]["PatientCostShareFrequency"];
      /** @description When the schedule becomes active. Doubles as the cadence anchor for history. */
      startDate: components["schemas"]["LocalDate"];
      /** @description Day of week the patient pays on (e.g. "FRIDAY"). */
      paymentDate: components["schemas"]["PatientCostSharePaymentDay"];
      /** @description Populated when the schedule has been superseded by a later one. */
      effectiveTo: components["schemas"]["LocalDate"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdByName: null | string;
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      updatedByName: null | string;
    };
    /** Format: PatientCostShareScheduleId */
    PatientCostShareScheduleId: PatientCostShareScheduleId;
    /** @enum {string} */
    PatientCostShareFrequency: "biweekly" | "monthly" | "weekly";
    /** @enum {string} */
    PatientCostSharePaymentDay:
      | "FRIDAY"
      | "MONDAY"
      | "SATURDAY"
      | "SUNDAY"
      | "THURSDAY"
      | "TUESDAY"
      | "WEDNESDAY";
    GetPatientCostShareScheduleResponse: {
      current: components["schemas"]["PatientCostShareSchedule"] | null;
      history: components["schemas"]["PatientCostShareSchedule"][];
    };
    /** @description The saved card we may charge off-session, as far as the UI needs to know. */
    PatientCostShareSavedPaymentMethod: {
      /** @description Stripe's own brand string, e.g. "visa". */
      brand: null | string;
      /** @description Last four digits — enough to name the card without exposing it. */
      last4: null | string;
      savedAt: components["schemas"]["Instant"] | null;
    };
    /**
     * @description Patient-level cost-share settings, independent of any schedule.
     *
     * These used to live on `patient_cost_share_schedule`, which meant superseding a
     * schedule could silently reset them and historical requests disagreed with
     * current intent. They are properties of the patient, so they live on their own
     * row now (V1613). A patient with no row uses the defaults below.
     */
    PatientCostShareConfig: {
      patientId: components["schemas"]["PatientId"];
      collectionMethod: components["schemas"]["PatientCostShareCollectionMethod"];
      /** @description Applies to the pay link AND the charge receipt. */
      linkDeliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
      /**
       * @description The patient's half of the go-live switch, ON by default: when the agency
       * turns production cost share on, everybody moves unless they were
       * deliberately held back. Only meaningful together with the agency switch —
       * on its own it does nothing.
       */
      productionMode: boolean;
      /** @description Null when the patient has no explicit row and is running on defaults. */
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      updatedByName: null | string;
    };
    /**
     * @description How a schedule collects.
     *
     * - "link": the worker sends the patient a Checkout pay link on the due date.
     * - "charge": the worker charges the patient's saved card off-session on the
     *   due date and notifies them afterwards.
     *
     * "charge" only takes effect once the patient actually has a saved card — see
     * {@link PatientCostSharePaymentRequest.effectiveCollectionMethod}, which is
     * what both the UI and the worker act on.
     * @enum {string}
     */
    PatientCostShareCollectionMethod: "charge" | "link";
    /**
     * @description How the pay link reaches the patient.
     * @enum {string}
     */
    PatientCostShareLinkDeliveryMethod: "email" | "sms";
    /**
     * @description Which half of the cost-share Stripe account a patient's money moves through.
     *
     * "test" is the sandbox everyone ran on while the feature was being tested;
     * "live" is real money. A patient is live only when the agency has turned
     * production cost share on AND the patient's own toggle is in production —
     * see {@link PatientCostShareAgencyConfig} and
     * {@link PatientCostShareConfig.productionMode}.
     * @enum {string}
     */
    PatientCostShareStripeMode: "live" | "test";
    /** @description A monthly invoice, billed in arrears, that tracks its own payment. */
    PatientCostShareInvoice: {
      id: components["schemas"]["PatientCostShareInvoiceId"];
      patientId: components["schemas"]["PatientId"];
      scheduleId: components["schemas"]["PatientCostShareScheduleId"];
      /** @description First and last day of the charged (previous) month. */
      periodStart: components["schemas"]["LocalDate"];
      periodEnd: components["schemas"]["LocalDate"];
      /** @description Current month's cost share, before any overrides or past-balance roll-in. */
      baseAmountCents: number;
      /** @description Sum of per-PR overrides applied to this invoice. */
      overrideTotalCents: number;
      /** @description Roll-forward balance from prior uncollectible invoices (Stripe-side line item). */
      pastBalanceCents: number;
      /** @description What our payment requests collectively bill (base + overrideTotal). */
      amountCents: number;
      paidCents: number;
      /** @description amountCents - paidCents — outstanding on the cost-share collection side. */
      balanceCents: number;
      dueDate: components["schemas"]["LocalDate"];
      generatedAt: components["schemas"]["Instant"];
      stripeInvoiceId: null | string;
      /** @description Direct URL to the Stripe-generated PDF, once finalized. */
      invoicePdfUrl: null | string;
      /**
       * @description True when this invoice was inserted by the backfill pass for a month
       * that was missed before cost-share generation started running — no
       * Stripe-side bill ever existed for it. Distinct from "billed but not
       * yet Stripe-finalized" (isBackfilled === false && stripeInvoiceId === null).
       */
      isBackfilled: boolean;
      /**
       * @description Which Stripe account this invoice's ids live in, stamped when it was
       * generated. Everything downstream — its payment requests' PaymentIntents
       * and Checkout Sessions — is read and written against this account, so
       * flipping either go-live switch changes the NEXT invoice and leaves open
       * ones working.
       */
      stripeMode: components["schemas"]["PatientCostShareStripeMode"];
      voidedAt: components["schemas"]["Instant"] | null;
      voidedBy: components["schemas"]["AgencyMemberId"] | null;
      /**
       * @description When the monthly invoice email went out, and where. Null until sent —
       * the worker sends it once the invoice is finalized, for the current month.
       */
      invoiceEmailSentAt: components["schemas"]["Instant"] | null;
      invoiceEmailSentTo: null | string;
      /** @description Every invoice email delivered for this invoice, newest first. */
      notifications: components["schemas"]["PatientCostShareNotification"][];
      paymentRequests: components["schemas"]["PatientCostSharePaymentRequest"][];
    };
    /** Format: PatientCostShareInvoiceId */
    PatientCostShareInvoiceId: PatientCostShareInvoiceId;
    /**
     * @description One delivered message about a payment request. Append-only: resends and the
     * link-then-charge sequence each add a row, which is what the single
     * `lastEmailSentAt` / `lastSentTo` pair on the request cannot express.
     */
    PatientCostShareNotification: {
      id: components["schemas"]["PatientCostShareNotificationId"];
      /** @description Set for pay links and receipts; null for an invoice email. */
      paymentRequestId:
        | components["schemas"]["PatientCostSharePaymentRequestId"]
        | null;
      /** @description Set for an invoice email; null otherwise. */
      invoiceId: components["schemas"]["PatientCostShareInvoiceId"] | null;
      /** @description Whether this was a request to pay, or a receipt for money taken. */
      kind: components["schemas"]["PatientCostShareNotificationKind"];
      /** @description Captured at send time, so it stays true after the patient's config changes. */
      deliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
      /** @description The address or phone number it actually went to. */
      sentTo: string;
      sentAt: components["schemas"]["Instant"];
      cause: components["schemas"]["PatientCostShareNotificationCause"];
      /** @description Null for the unattended daily run; set for both manual causes. */
      causedBy: components["schemas"]["AgencyMemberId"] | null;
      causedByName: null | string;
      /**
       * @description Whether the delivered message itself was captured (V1662 onward). Fetch
       * it with the notification content endpoint.
       */
      hasContent: boolean;
    };
    /** Format: PatientCostShareNotificationId */
    PatientCostShareNotificationId: PatientCostShareNotificationId;
    /** Format: PatientCostSharePaymentRequestId */
    PatientCostSharePaymentRequestId: PatientCostSharePaymentRequestId;
    /**
     * @description What a notification told the patient. The server renders each one and n8n
     * just delivers whatever body it is handed.
     *
     * - "invoice": the month's invoice. Always by email, once per invoice, sent as
     *   soon as the invoice is finalized (generation runs on the 1st).
     * - "pay_link": please pay — here is your link. (Request still unpaid.) By
     *   email or SMS per the patient's config, on the request's due date.
     * - "payment_receipt": we received your payment — by link or by charging the
     *   saved card. Always by email.
     * - "charge_receipt": legacy. The pre-receipt-email wording for an off-session
     *   charge; only appears on history written before "payment_receipt" existed.
     * @enum {string}
     */
    PatientCostShareNotificationKind:
      | "charge_receipt"
      | "invoice"
      | "pay_link"
      | "payment_receipt";
    /**
     * @description What triggered a notification.
     *
     * - "scheduled_worker": the daily n8n run sending an outstanding pay link.
     * - "scheduled_charge": the daily run's receipt for an off-session charge.
     * - "manual_send": an agency member clicked Send/Resend link.
     * - "manual_charge": an agency member clicked Charge now.
     * - "payment_received": a receipt sent because a payment landed.
     * @enum {string}
     */
    PatientCostShareNotificationCause:
      | "manual_charge"
      | "manual_send"
      | "payment_received"
      | "scheduled_charge"
      | "scheduled_worker";
    PatientCostSharePaymentRequest: {
      id: components["schemas"]["PatientCostSharePaymentRequestId"];
      invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
      patientId: components["schemas"]["PatientId"];
      dueDate: components["schemas"]["LocalDate"];
      baseAmountCents: number;
      overrideAmountCents: number;
      amountCents: number;
      status: components["schemas"]["PatientCostSharePaymentRequestStatus"];
      stripePaymentIntentId: null | string;
      /** @description Current Stripe Checkout Session id (rotated lazily by the share-link endpoint). */
      stripeCheckoutSessionId: null | string;
      /**
       * @description Opaque code for the public share URL. Stable for the lifetime of the
       * request — the URL we send the patient never changes; only the Stripe
       * session it redirects to rotates.
       */
      shareCode: string;
      /**
       * @description Fully-qualified URL that resolves the share code on the API server.
       * Suitable for emails, the UI Copy-Link button, etc.
       */
      shareUrl: string;
      /**
       * @description Every message ever delivered about this request, newest first. The
       * lastEmailSentAt / lastSentTo pair below is the latest send only; this is
       * the full history, including resends and a receipt following a pay link.
       */
      notifications: components["schemas"]["PatientCostShareNotification"][];
      /** @description When the pay link was last sent to the patient; null until first send. */
      lastEmailSentAt: components["schemas"]["Instant"] | null;
      /**
       * @description The destination (email address or phone number) the link was last
       * sent to; null until the first send. Captured at send time, so it
       * stays accurate even after the patient's contact details change.
       */
      lastSentTo: null | string;
      /**
       * @description How the NEXT message about this request would be delivered. Read from the
       * patient's config (V1613), so it reflects current intent rather than
       * whatever was in force when the request was created. For what a past send
       * actually used, read {@link notifications} — each entry captures its own
       * delivery method at send time.
       */
      linkDeliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
      /**
       * @description Where the next send would go, per {@link linkDeliveryMethod}: the
       * patient's email for "email", their mobile number for "sms". Null when
       * the patient has no contact detail for that method — the server decides
       * this so the UI never has to guess. Distinct from {@link lastSentTo},
       * which is where a link already went.
       */
      intendedSendTo: null | string;
      /**
       * @description What will ACTUALLY happen to this request on its due date, resolved
       * server-side: "charge" only when its invoice's schedule asks for charging
       * AND the patient has a saved card. A "charge" schedule with no saved card
       * resolves to "link" here, so the UI never promises a charge that cannot
       * happen. Already-paid requests report what they were before payment;
       * {@link collectedVia} is the historical answer.
       */
      effectiveCollectionMethod: components["schemas"]["PatientCostShareCollectionMethod"];
      /**
       * @description How this request was actually collected. Null until it is paid. Set to
       * "charge" for off-session charges and "link" for Checkout payments —
       * including a charge-mode request the patient ended up paying by link
       * because the charge failed.
       */
      collectedVia: ("charge" | "link") | null;
      /** @description When we last tried to charge the saved card; null if never tried. */
      lastChargeAttemptAt: components["schemas"]["Instant"] | null;
      /**
       * @description Why the last off-session charge failed, if it did. Populated for cases
       * the patient has to resolve (most often the card demanding 3DS), which is
       * also when the flow falls back to sending a pay link.
       */
      lastChargeError: null | string;
      paidAt: components["schemas"]["Instant"] | null;
      /** @description When the payment receipt email went out; null until sent. */
      receiptSentAt: components["schemas"]["Instant"] | null;
      createdAt: components["schemas"]["Instant"];
    };
    /** @enum {string} */
    PatientCostSharePaymentRequestStatus:
      | "awaiting_payment"
      | "canceled"
      | "paid"
      | "pending";
    /**
     * @description One STEDI eligibility answer:
     * - `cost_share`    — Medicaid reported a monthly cost share of `amountCents`.
     * - `no_cost_share` — eligible, no cost share.
     * - `error`         — no usable answer; `errorMessage` says why. The schedule
     *                     was left as it was.
     */
    PatientCostShareStediCheck: {
      checkedAt: components["schemas"]["Instant"];
      /** @enum {string} */
      outcome: "cost_share" | "error" | "no_cost_share";
      amountCents: null | number;
      errorMessage: null | string;
    };
    /** Format: PatientCostSharePaymentAllocationId */
    PatientCostSharePaymentAllocationId: PatientCostSharePaymentAllocationId;
    /** Format: PatientCostSharePaymentId */
    PatientCostSharePaymentId: PatientCostSharePaymentId;
    PatientCostShareInvoiceAdjustment: {
      id: components["schemas"]["PatientCostShareInvoiceAdjustmentId"];
      invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
      amountCentsDelta: number;
      reason: string;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdByName: null | string;
    };
    /** Format: PatientCostShareInvoiceAdjustmentId */
    PatientCostShareInvoiceAdjustmentId: PatientCostShareInvoiceAdjustmentId;
    /** @description Per-request outcome of an off-session charge attempt. */
    PatientCostShareChargeOutcome: {
      paymentRequestId: components["schemas"]["PatientCostSharePaymentRequestId"];
      patientId: components["schemas"]["PatientId"];
      amountCents: number;
      /**
       * @description - "charged": the card was charged and the request is now paid.
       * - "skipped": nothing was attempted — not chargeable (already paid or
       *   canceled, no saved card, schedule not set to charge, not due yet).
       * - "failed": Stripe refused the charge. `error` says why and the request
       *   falls back to the pay-link flow.
       * @enum {string}
       */
      result: "charged" | "failed" | "skipped";
      /** @description Why it was skipped or how it failed. Null on success. */
      error: null | string;
    };
    /**
     * @description A manual/offline payment recorded against ONE specific invoice (fallback
     * alongside the Stripe payment-request flow). No cross-invoice cascade.
     */
    PatientCostSharePayment: {
      id: components["schemas"]["PatientCostSharePaymentId"];
      patientId: components["schemas"]["PatientId"];
      invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
      amountCents: number;
      receivedAt: components["schemas"]["Instant"];
      notes: null | string;
      reversedAt: components["schemas"]["Instant"] | null;
      reversedBy: components["schemas"]["AgencyMemberId"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdByName: null | string;
    };
    PatientCostShareInvoiceNote: {
      id: components["schemas"]["PatientCostShareInvoiceNoteId"];
      invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
      note: string;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdByName: null | string;
    };
    /** Format: PatientCostShareInvoiceNoteId */
    PatientCostShareInvoiceNoteId: PatientCostShareInvoiceNoteId;
    /** @description One row per cost-share invoice — the AR "Detailed" view. */
    PatientCostShareArViewItem: {
      invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientDisplayId: null | number;
      officeId: components["schemas"]["OfficeId"] | null;
      officeName: null | string;
      /** @description First and last day of the month the invoice covers. */
      invoicePeriodStart: components["schemas"]["LocalDate"];
      invoicePeriodEnd: components["schemas"]["LocalDate"];
      /** @description Invoice's own due date. */
      dueDate: components["schemas"]["LocalDate"];
      /** @description Cadence of the patient's schedule at the time of invoice generation. */
      scheduleFrequency: components["schemas"]["PatientCostShareFrequency"];
      /** @description Base cost-share for the month (`base_amount_cents`). */
      baseAmountCents: number;
      /** @description Sum of per-PR overrides applied to this invoice. */
      overrideTotalCents: number;
      /** @description Current-month cost share collected via this invoice: base + override. */
      amountCents: number;
      /** @description Rolled-forward balance from prior uncollectible invoices (separate line item on the Stripe invoice). */
      pastBalanceCents: number;
      /** @description How much has actually been paid against the invoice. */
      paidCents: number;
      /**
       * @description Cost-share-side outstanding: `amountCents − paidCents` for open
       * invoices, 0 for paid / voided / uncollectible. Deliberately excludes
       * `pastBalanceCents` so AR aggregates don't double-count amounts that
       * were already represented by the prior (now-uncollectible) invoice.
       */
      outstandingCents: number;
      paymentStatus: components["schemas"]["PatientCostSharePaymentStatus"];
      /** @description True for backfilled (no-Stripe-bill) invoices. */
      isBackfilled: boolean;
      /** @description When the invoice was voided, if applicable. */
      voidedAt: components["schemas"]["Instant"] | null;
      /** @description When the invoice row was generated (DB-side). */
      generatedAt: components["schemas"]["Instant"];
      /**
       * @description When the first payment link for this invoice was emailed (i.e. the
       * earliest `last_email_sent_at` across its payment requests). Null when
       * no PR has been emailed yet.
       */
      firstPaymentSentAt: components["schemas"]["Instant"] | null;
    };
    /**
     * @description Display status for AR rows — matches the values used by the regular AR
     * (`invoice_visit_payment_status.payment_status`):
     *   - `NONE`     — no payment yet
     *   - `PARTIAL`  — paid but not in full (unreachable for cost-share, which is binary)
     *   - `FULL`     — fully paid
     *   - `OVER`     — overpaid (unreachable for cost-share)
     * @enum {string}
     */
    PatientCostSharePaymentStatus: "FULL" | "NONE" | "OVER" | "PARTIAL";
    /** @description One request the next automatic charge run would attempt. */
    PatientCostSharePendingCharge: {
      paymentRequestId: components["schemas"]["PatientCostSharePaymentRequestId"];
      patientId: components["schemas"]["PatientId"];
      /** @description For the team's failed-charges email. */
      patientName: string;
      amountCents: number;
      dueDate: components["schemas"]["LocalDate"];
    };
    PatientCostSharePendingLink: {
      paymentRequestId: components["schemas"]["PatientCostSharePaymentRequestId"];
      agencyId: components["schemas"]["AgencyId"];
      /** @description Which of the two messages the pre-rendered body below actually is. */
      kind: components["schemas"]["PatientCostShareNotificationKind"];
      deliveryMethod: components["schemas"]["PatientCostShareLinkDeliveryMethod"];
      /**
       * @description The patient's IANA timezone. SMS links are only listed Monday-Friday on
       * this clock; n8n re-checks it right before sending as a second guard.
       */
      patientTimezone: string;
      toPhone: null | string;
      smsBody: null | string;
      toEmail: null | string;
      emailSubject: null | string;
      emailHtml: null | string;
    };
    /**
     * @description One monthly invoice email the worker still needs to deliver. Always email,
     * whatever the patient's link delivery method. After delivering, n8n calls
     * /worker/invoices/:invoiceId/mark_email_sent.
     */
    PatientCostSharePendingInvoiceEmail: {
      invoiceId: components["schemas"]["PatientCostShareInvoiceId"];
      agencyId: components["schemas"]["AgencyId"];
      patientId: components["schemas"]["PatientId"];
      toEmail: string;
      emailSubject: string;
      emailHtml: string;
    };
    /**
     * @description One payment receipt email the worker still needs to deliver. After
     * delivering, n8n calls /worker/payment_requests/:id/mark_receipt_sent.
     */
    PatientCostSharePendingReceipt: {
      paymentRequestId: components["schemas"]["PatientCostSharePaymentRequestId"];
      agencyId: components["schemas"]["AgencyId"];
      patientId: components["schemas"]["PatientId"];
      toEmail: string;
      emailSubject: string;
      emailHtml: string;
    };
    /** @description One patient, pre-shaped for a STEDI eligibility subscriber block. */
    EligibilityPatient: {
      patientId: components["schemas"]["PatientId"];
      /** @description Medicaid number → STEDI subscriber.memberId. */
      memberId: string;
      firstName: string;
      lastName: string;
      /** @description DOB as CCYYMMDD (STEDI subscriber.dateOfBirth format). */
      dateOfBirth: string;
    };
    CostShareAttributionFailure: {
      patientId: components["schemas"]["PatientId"];
      costShareMonth: components["schemas"]["LocalDate"];
      error: string;
    };
    number: number;
    PayRateExtended: {
      payrollCodeIsActive: boolean;
      id: components["schemas"]["PayRateId"];
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      payrollCodeId: components["schemas"]["PayrollCodeId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      payRateCounties: components["schemas"]["PayRateCounty"][];
      supplementalRates: components["schemas"]["PayRateSupplemental"][];
      externalId: null | string;
    };
    /** Format: PayRateId */
    PayRateId: PayRateId;
    PayRateCounty: {
      id: components["schemas"]["PayRateCountyId"];
      state: string;
      countyName: string;
      payRateId: components["schemas"]["PayRateId"];
      groupName: string;
      hourlyRate: number;
      dailyRate: number;
      visitRate: number;
      weekendHourlyRate: null | number;
      weekendDailyRate: null | number;
      weekendVisitRate: null | number;
      payRange: null | string;
      minimumWage: number;
      baseWage: null | number;
      additionalWage: null | number;
      supplementalWage: null | number;
      workShiftLine1Rate: null | number;
      workShiftLine1Label: null | string;
      workShiftLine2Rate: null | number;
      workShiftLine2Label: null | string;
    };
    /** Format: PayRateCountyId */
    PayRateCountyId: PayRateCountyId;
    CaregiverPayRate: {
      id: components["schemas"]["CaregiverPayRateId"];
      caregiverId: components["schemas"]["CaregiverId"];
      patientId: components["schemas"]["PatientId"] | null;
      type: components["schemas"]["CaregiverPayRateType"];
      payCodeId: components["schemas"]["PayrollCodeId"];
      daily: number;
      hourly: number;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: CaregiverPayRateId */
    CaregiverPayRateId: CaregiverPayRateId;
    /** @enum {string} */
    CaregiverPayRateType: "FIXED_AMOUNT" | "FIXED_DIFF" | "PERCENTAGE";
    PatientPayRate: {
      id: components["schemas"]["PatientPayRateId"];
      type: components["schemas"]["PatientPayRateType"];
      patientId: components["schemas"]["PatientId"];
      daily: number;
      hourly: number;
      payCodeId: components["schemas"]["PayrollCodeId"];
      basedOnCaregiverRate: boolean;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: PatientPayRateId */
    PatientPayRateId: PatientPayRateId;
    /** @enum {string} */
    PatientPayRateType: "FIXED_DIFF" | "PERCENTAGE";
    DefaultPayRate: {
      visit: number;
      patientId: components["schemas"]["PatientId"];
      daily: number;
      hourly: number;
      payCodeId: components["schemas"]["PayrollCodeId"];
      basedOnCaregiverRate: boolean;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
    };
    PayrollItemExtended: {
      id:
        | components["schemas"]["PayrollVisitId"]
        | components["schemas"]["PayrollTravelTimeId"]
        | components["schemas"]["PayrollPtoId"]
        | components["schemas"]["PayrollOnlineTrainingId"]
        | components["schemas"]["PayrollClassroomTrainingId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverFullName: null | string;
      caregiverDisplayId: null | number;
      patientId: components["schemas"]["PatientId"] | null;
      patientFullName: null | string;
      patientDisplayId: null | number;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      type: components["schemas"]["PayrollVisitType"];
      rate: number;
      billedSeconds: null | number;
      contractTypeId: components["schemas"]["ContractTypeId"] | null;
      oldVisit: boolean;
      overtime: boolean;
      holiday: boolean;
      nannyLaw: boolean;
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      payrollBatchId: components["schemas"]["PayrollBatchId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      total: number;
      seconds: number;
      missingIssuesSettings: boolean;
    };
    /** Format: PayrollVisitId */
    PayrollVisitId: PayrollVisitId;
    /** Format: PayrollTravelTimeId */
    PayrollTravelTimeId: PayrollTravelTimeId;
    /** Format: PayrollPtoId */
    PayrollPtoId: PayrollPtoId;
    /** Format: PayrollOnlineTrainingId */
    PayrollOnlineTrainingId: PayrollOnlineTrainingId;
    /** Format: PayrollClassroomTrainingId */
    PayrollClassroomTrainingId: PayrollClassroomTrainingId;
    /** @enum {string} */
    PayrollVisitType:
      | "IN_CLASS"
      | "ONLINE_TRAINING"
      | "PTO"
      | "SOH"
      | "TRAVEL_TIME"
      | "VISIT";
    /** Format: PayrollBatchId */
    PayrollBatchId: PayrollBatchId;
    PayrollBatchExtended: {
      lastPayrollBatchDate: components["schemas"]["LocalDate"] | null;
      visitsRange: components["schemas"]["PayrollBatchVisitsRange"];
      id: components["schemas"]["PayrollBatchId"];
      displayId: string;
      date: components["schemas"]["LocalDate"];
      agencyId: components["schemas"]["AgencyId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      totalVisits: number;
      totalCaregivers: number;
      totalAmount: number;
      isDraft: boolean;
      payrollSetupId: components["schemas"]["PayrollSetupId"];
      processingPct?: number;
    };
    PayrollBatchVisitsRange: {
      firstVisitDate: components["schemas"]["LocalDateTime"] | null;
      lastVisitDate: components["schemas"]["LocalDateTime"] | null;
    };
    /** Format: PayrollSetupId */
    PayrollSetupId: PayrollSetupId;
    PayrollBatchWithVisits: {
      payrollItems: components["schemas"]["PayrollItemExtended"][];
      payrollBatch: components["schemas"]["PayrollBatchExtended"];
    };
    PayrollVisitsForCSV: {
      coCode: string;
      batchId: components["schemas"]["PayrollBatchId"];
      fileNum: components["schemas"]["CaregiverId"];
      payNum: string;
      taxFreq: string;
      tempDept: string;
      rate: string;
      regHours: string;
      otHours: string;
      hoursCode: string;
      hoursAmount: string;
      externalCaregiverCode: string;
      caregiverName: string;
      caregiverFirstName: string;
      caregiverMiddleName: null | string;
      caregiverLastName: string;
      caregiverId: components["schemas"]["CaregiverId"];
      visitDate: string;
      patientName: string;
      patientNumber: string;
      customer: string;
      duration: string;
      startTime: string;
      endTime: string;
      durationDecimal: string;
      serviceItem: string;
      aideSsn: string;
      wageParity: string;
      contractName: string;
      contractType: string;
      amount: string;
      discipline: components["schemas"]["CaregiverCertification"] | string;
      patientLocation: string;
      patientTeam: string;
      patientBranch: string;
      payNumber: string;
      patientWageParity: string;
      caregiverLocation: string;
      caregiverTeam: string;
      caregiverBranch: string;
      patientFirstName: string;
      patientLastName: string;
      combinedWageParity: string;
      locationAndWageParityFlag: string;
      visitID: string;
      visitInstanceId: string;
      patientId: string;
      payrollWeekStart: string;
      payrollWeekEnd: string;
      evvPoints: string;
      shift: string;
      oldNew: string;
      service: string;
      regularOvertime: string;
      holiday: boolean;
      soh: boolean;
      payrollCodeName: string;
    };
    OldPayrollBatchEditParams: {
      excludedPayrollItems: components["schemas"]["PayrollItemExtended"][];
    };
    NewPayrollBatchEditParams: {
      excludedPayrollItems: {
        visits: components["schemas"]["PayrollVisitId"][];
        travelTime: components["schemas"]["PayrollTravelTimeId"][];
        pto: components["schemas"]["PayrollPtoId"][];
        onlineTraining: components["schemas"]["PayrollOnlineTrainingId"][];
        classroomTraining: components["schemas"]["PayrollClassroomTrainingId"][];
      };
    };
    PayrollVerificationBatch: {
      precedingPayrollOrderNumber: number;
      batchInfo: {
        id: components["schemas"]["PayrollBatchId"];
        displayId: string;
        date: components["schemas"]["LocalDate"];
        createdAt: components["schemas"]["Instant"];
      };
      caregivers: {
        all: components["schemas"]["PayrollVerificationTotalsCount"];
        new: components["schemas"]["PayrollVerificationTotalsCount"];
        dropped: components["schemas"]["PayrollVerificationTotalsCount"];
      };
      breakdowns: {
        rates: [number, number][];
        seconds: [number, number][];
        amounts: [number, number][];
      };
      oldNew: {
        old: components["schemas"]["PayrollVerificationTotalsCount"];
        new: components["schemas"]["PayrollVerificationTotalsCount"];
      };
      totals: {
        overall: components["schemas"]["PayrollVerificationTotals"];
        positive: components["schemas"]["PayrollVerificationTotals"];
        negative: components["schemas"]["PayrollVerificationTotals"];
        newPayment: components["schemas"]["PayrollVerificationTotals"];
        adjustment: components["schemas"]["PayrollVerificationTotals"];
        reversal: components["schemas"]["PayrollVerificationTotals"];
      };
      visits: {
        overall: components["schemas"]["PayrollVerificationTotals"];
        newPayment: components["schemas"]["PayrollVerificationTotals"];
        adjustment: components["schemas"]["PayrollVerificationTotals"];
        reversal: components["schemas"]["PayrollVerificationTotals"];
      };
      overtime: components["schemas"]["PayrollVerificationTotals"];
      holiday: components["schemas"]["PayrollVerificationTotals"];
      soh: components["schemas"]["PayrollVerificationTotals"];
      pto: components["schemas"]["PayrollVerificationTotals"];
      travelTime: components["schemas"]["PayrollVerificationTotals"];
      inservice: components["schemas"]["PayrollVerificationTotals"];
    };
    PayrollVerificationTotalsCount: {
      count: number;
      countPctChange?: number;
    };
    PayrollVerificationTotals: {
      amount: number;
      amountPctChange?: number;
      seconds: number;
      secondsPctChange?: number;
      count: number;
      countPctChange?: number;
    };
    PayrollAuditComparableBatch: {
      payrollBatchId: components["schemas"]["PayrollBatchId"];
      displayId: string;
      date: components["schemas"]["LocalDate"];
    };
    PayrollAuditTotals: {
      amount: number;
      seconds: number;
      visits: number;
      caregivers: number;
    };
    PayrollAuditPayrollCode: {
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollCodeName: string;
      visits: number;
      caregivers: number;
      amount: number;
      seconds: number;
    };
    PayrollAuditCaregiver: {
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverName: string;
      caregiverDisplayId: null | string;
      amount: number;
      seconds: number;
      visits: number;
    };
    PayrollAuditVisit: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverName: string;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      serviceType: components["schemas"]["PayrollAuditServiceType"];
      startTime: components["schemas"]["LocalDateTime"];
      amount: number;
      seconds: number;
    };
    /** @enum {string} */
    PayrollAuditServiceType: "CLUSTER" | "DAILY" | "HOURLY" | "VISIT";
    PayrollAuditRateRange: {
      serviceType: components["schemas"]["PayrollAuditServiceType"];
      lines: number;
      minRate: number;
      maxRate: number;
      avgRate: number;
      /** @description [rate, number of pay lines at that rate], ascending by rate. */
      rates: [number, number][];
    };
    PayrollAuditRepaidVisit: {
      /** @description Sum of the positive amounts paid for this visit in earlier batches (since netted to 0). */
      previouslyPaidAmount: number;
      previousBatchIds: components["schemas"]["PayrollBatchId"][];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverName: string;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      serviceType: components["schemas"]["PayrollAuditServiceType"];
      startTime: components["schemas"]["LocalDateTime"];
      amount: number;
      seconds: number;
    };
    PayrollAuditCaregiverTotal: {
      caregiverId: components["schemas"]["CaregiverId"];
      amount: number;
      seconds: number;
      visits: number;
    };
    PayrollAuditDistributions: {
      caregiverAmounts: number[];
      caregiverSeconds: number[];
      caregiverVisits: number[];
      visitAmounts: number[];
    };
    /** @enum {undefined} */
    PayrollDraftItemType:
      | "VISIT"
      | "TRAVEL_TIME"
      | "PTO"
      | "ONLINE_TRAINING"
      | "IN_CLASS";
    PayrollVerificationInstapayEmployee: {
      employeeId: number;
      caregiverId: components["schemas"]["CaregiverId"];
      data: components["schemas"]["PayrollVerificationInstapayEmployeePeriodData"];
    };
    PayrollVerificationInstapayEmployeePeriodData: {
      latestDeduction: {
        deductionTime: components["schemas"]["Instant"] | null;
        deductionAmount: null | number;
        completed: null | boolean;
        errors: string[];
      };
      accumulated: {
        accumulationTime: components["schemas"]["Instant"] | null;
        accumulationAmount: null | number;
        zeroed: null | boolean;
      };
      totalInstapayCents: number;
      totalInstapayCentsForCurrent: number;
      totalDeductedCents: number;
      totalDeductedPositiveCents: number;
      totalBalanceCents: number;
    };
    /** Format: PhysicianPatientAssocId */
    PhysicianPatientAssocId: PhysicianPatientAssocId;
    /** Format: ExternalPatientServicePlanId */
    ExternalPatientServicePlanId: ExternalPatientServicePlanId;
    /** @enum {string} */
    CoServicePlanKind: "CURRENT" | "PAST";
    /** @enum {string} */
    CoServicePlanImportStatus:
      | "BLOCKED_BY_REVIEW"
      | "COMPLETED"
      | "COMPLETED_WITH_WARNINGS"
      | "DECLINED"
      | "NEEDS_REVIEW"
      | "PENDING_APPROVAL"
      | "PROCESSING"
      | "QUEUED"
      | "RETRYING"
      | "WAITING";
    CoServicePlanImportJob: {
      startedAt: components["schemas"]["Instant"] | null;
      endedAt: components["schemas"]["Instant"] | null;
      retryCount: number;
      maxRetries: number;
      /**
       * @description Warnings on a schedule that was written, or the reason one was not. The
       * column is named for what it holds, not for the failure it is not.
       */
      message: null | string;
      createdAt: components["schemas"]["Instant"];
    };
    CoServicePlanImportCaregiver: {
      caregiverId: components["schemas"]["CaregiverId"];
      firstName: null | string;
      lastName: null | string;
      /**
       * @description The (line, duty) pairs the sender says this caregiver may perform. Empty for a
       * caregiver the sender did not name: on a PAST plan, one staffing the patient's
       * existing visits, listed so their visits can be named and kept.
       */
      validatedDuties: {
        serviceCode: string;
        dutyCode: number;
      }[];
    };
    /** @description One duty as the sender stated it, in the order they sent it. */
    CoServicePlanImportDuty: {
      serviceCode: string;
      dutyCode: number;
      /** @description The agency's catalogue label for the code, null when it matched nothing. */
      label: null | string;
      minutesPerTask: null | number;
      minutesPerDay: null | number;
      minutesPerWeek: null | number;
      timesPerDay: null | number;
      timesPerWeek: null | number;
      /** @description The sender's own 0 = Sunday encoding, as stored. */
      daysOfWeek: number[] | null;
      isRequired: null | boolean;
      notes: null | string;
      justification: null | string;
    };
    CoServicePlanImportSchedule: {
      /** @description True when this is what a refused generation left behind. */
      failed: boolean;
      /** @description Scheduler runs made. */
      attempts: number;
      /**
       * @description Which engine built this week: the LP solver, for a current plan and a past one
       * alike, or -- on a proposal made before either was retired -- the allocation into
       * the patient's existing visits (`past-allocation`) that once built a past plan's
       * week, or the AI schedule builder. Those are kept so old proposals still render;
       * nothing builds a week with them any more.
       *
       * Null for a submission scheduled before either was recorded, and for one that
       * never reached a scheduler at all -- no schedulable authorization, nothing to
       * ask about. The drawer shows no engine badge in both cases, which is honest:
       * nothing built this.
       */
      engine: ("ai" | "past-allocation" | "solver-highs") | null;
      /**
       * @description What that scheduler calls itself -- an engine name, or a model version on an
       * old AI-built week.
       *
       * The detail behind the badge rather than the badge itself; `engine` is what to
       * branch on. Null alongside a null `engine`, and on anything scheduled before
       * this was recorded.
       */
      producedBy: null | string;
      /** @description The scheduler's own account of the week it built. */
      notes: null | string;
      shifts: components["schemas"]["CoServicePlanImportShift"][];
      unstaffed: components["schemas"]["CoServicePlanImportUnstaffed"][];
      violations: components["schemas"]["CoServicePlanImportViolation"][];
      /**
       * @description What was made of the plan's free text, when a solver built the week.
       *
       * Null on a week the retired AI builder made, which read the notes inside its own
       * prompt and has no separate reading to show, and on any submission scheduled
       * before notes were read at all.
       */
      noteRestrictions:
        | components["schemas"]["CoServicePlanImportNoteRestrictions"]
        | null;
      /**
       * @description Every change a past plan's week makes to the patient's existing schedule, and
       * every way it differs from the plan, each with the sentence to show. In the order
       * of the week. Empty for a current plan's week, which is designed rather than changed
       * from anything, and for a week scheduled before changes were recorded.
       */
      proposedChanges: components["schemas"]["CoServicePlanImportProposedChange"][];
    };
    CoServicePlanImportShift: {
      dayOfWeek: string;
      startTime: string;
      endTime: string;
      caregiverId: null | number;
      authorizationId: null | number;
      duties: components["schemas"]["CoServicePlanImportShiftDuty"][];
      rationale: null | string;
    };
    /**
     * @description A duty on a shift, and how many times it is performed there.
     *
     * `occurrences` is 1 for every shift of a submission scheduled before counts were
     * carried: the field was a set of codes then, so a repeat could not be expressed
     * and none was ever stored.
     */
    CoServicePlanImportShiftDuty: {
      dutyCode: number;
      occurrences: number;
    };
    CoServicePlanImportUnstaffed: {
      dutyCode: null | number;
      dayOfWeek: null | string;
      reason: string;
    };
    CoServicePlanImportViolation: {
      code: string;
      /** @description ERROR blocks the schedule; WARNING is a caveat on one that was written. */
      severity: string;
      message: string;
      dayOfWeek: null | string;
      dutyCode: null | number;
      caregiverId: null | number;
    };
    /**
     * @description The plan's prose, as the scheduler understood it.
     *
     * Both halves matter to a coordinator and the second one arguably more: `applied` says
     * why the week looks as it does, and `ignored` says which of their instructions did not
     * survive - a caregiver who is not on the plan, a time nobody could parse, a remark that
     * was never a scheduling rule. A note that vanished silently teaches nobody anything.
     */
    CoServicePlanImportNoteRestrictions: {
      /** @description Which model read the notes, e.g. `nova/nova-lite`. Null when none were read. */
      model: null | string;
      /** @description How long that took. */
      elapsedMs: number;
      applied: components["schemas"]["CoServicePlanImportNoteRestriction"][];
      ignored: components["schemas"]["CoServicePlanImportIgnoredNote"][];
    };
    CoServicePlanImportNoteRestriction: {
      /** @description AVOID_DAY, PREFER_CAREGIVER, AVOID_CAREGIVER or TIME_WINDOW. */
      kind: string;
      /** @description The restriction in words, ready to render. */
      description: string;
      /** @description The words from the notes it was drawn from, verbatim. */
      quote: string;
      dayOfWeek: null | string;
      caregiverId: null | number;
      serviceCode: null | string;
      dutyCode: null | number;
      /** @description 24-hour HH:MM, on TIME_WINDOW only. */
      earliestTime: null | string;
      latestTime: null | string;
    };
    CoServicePlanImportIgnoredNote: {
      /** @description What was read, quoted. */
      text: string;
      /** @description Why it could not be turned into a restriction. */
      reason: string;
    };
    /**
     * @description One change a past plan's week proposes, by kind. `message` is always the sentence to
     * show; the other fields are there to locate and group it.
     *
     * - EXTENDED: an existing visit runs longer, `from` -> `to`, to carry its duties.
     *   `overlaps`: the extension could not be avoided although it overlaps another visit
     *   or runs past midnight.
     * - ADDED: a visit not on the patient's schedule. NO_VISITS: its line had no visit that
     *   week. EXTENSION_BLOCKED: an existing visit could not be extended, so what it cannot
     *   hold moves here.
     * - SNAPPED: the visit's real times were off the 5-minute grid; `to` is what the week uses.
     * - STAFFED: a visit with no caregiver is given the first one the plan validated for its
     *   line.
     * - REMOVED: legacy, no longer produced. An existing visit carried none of the plan's
     *   duties and was left out of the week, so approval deleted it. Such a visit is now
     *   kept, as a shift with no duties; the kind is still read so snapshots staged before
     *   that still show their changes.
     * - UNSCHEDULABLE: an existing visit, or one duties were allocated to, cannot be
     *   written -- nobody can staff it, or its line has no authorization -- so it is left
     *   out of the week and any duties on it are unstaffed instead. An existing one is on one
     *   of the plan's lines, so approval removes it if it is still ahead when the new week
     *   starts, and the message says so.
     * - UNALLOCATED: a duty that could not be allocated at all, with the reason.
     * - SCHEDULE_DIFFERS: a duty whose days or per-day counts differ from what the plan named.
     * - OTHER_LINES_KEPT: the patient has visits or weekly template shifts on a service line
     *   the plan does not name -- `visits` of them that week, `templateShifts` on the
     *   template -- or, with `serviceCode` null, on no service code. Approval replaces only the
     *   plan's own lines, so they are kept as they are.
     * - ONE_OFF_LEFT_OUT: `visits` one-off visits of the week the proposal was read from, on a
     *   line that also has recurring ones, are not part of the recurring schedule, so the week
     *   leaves them out; approval removes them if they are still ahead when the new week starts.
     * - WEEKS_DIFFER: on this line the other week read (`otherWeekStart`) has a different
     *   recurring pattern from the week the proposal follows (`sourceWeekStart`):
     *   `onlyInOtherWeek` visits the proposal does not use, `onlyInSourceWeek` visits the other
     *   week does not have. Dates are YYYY-MM-DD.
     */
    CoServicePlanImportProposedChange:
      | {
          /** @enum {string} */
          kind: "EXTENDED";
          dayOfWeek: string;
          serviceCode: string;
          caregiverId: number;
          from: components["schemas"]["CoServicePlanImportChangeSpan"];
          to: components["schemas"]["CoServicePlanImportChangeSpan"];
          overlaps: boolean;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "ADDED";
          dayOfWeek: string;
          serviceCode: string;
          caregiverId: number;
          start: string;
          end: string;
          /** @enum {string} */
          reason: "EXTENSION_BLOCKED" | "NO_VISITS";
          overlaps: boolean;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "SNAPPED";
          dayOfWeek: string;
          serviceCode: string;
          caregiverId: number;
          to: components["schemas"]["CoServicePlanImportChangeSpan"];
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "STAFFED";
          dayOfWeek: string;
          serviceCode: string;
          caregiverId: number;
          start: string;
          end: string;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "REMOVED";
          dayOfWeek: string;
          serviceCode: string;
          caregiverId: null | number;
          start: string;
          end: string;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "UNSCHEDULABLE";
          dayOfWeek: string;
          serviceCode: string;
          /** @enum {string} */
          reason: "NO_AUTHORIZATION" | "NO_CAREGIVER";
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "UNALLOCATED";
          dutyCode: number;
          serviceCode: string;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "SCHEDULE_DIFFERS";
          dutyCode: number;
          serviceCode: string;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "OTHER_LINES_KEPT";
          serviceCode: null | string;
          visits: number;
          templateShifts: number;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "ONE_OFF_LEFT_OUT";
          serviceCode: string;
          visits: number;
          message: string;
        }
      | {
          /** @enum {string} */
          kind: "WEEKS_DIFFER";
          serviceCode: string;
          sourceWeekStart: string;
          otherWeekStart: string;
          onlyInOtherWeek: number;
          onlyInSourceWeek: number;
          message: string;
        };
    /** @description A visit's times in a proposed change: 24-hour HH:MM; an end of "00:00" is midnight. */
    CoServicePlanImportChangeSpan: {
      start: string;
      end: string;
    };
    /**
     * @description One shift of the schedule that is STAGED for approval, as opposed to the model's
     * original answer in `schedule.shifts`.
     *
     * The two differ once a coordinator has replaced the week, and this is the one
     * that will actually be written — so it is what the review screen shows and edits.
     */
    CoServicePlanImportStagedShift: {
      /**
       * @description Position in the staged schedule — an ordinal for display and ordering, not
       * something server-side matches or addresses a shift by any more.
       *
       * An index rather than a synthetic id because the staged shifts are a JSON
       * array with no identity of their own, and matching on (day, time) stops being
       * unique the moment two shifts share a slot.
       */
      index: number;
      dayOfWeek: string;
      startTime: string;
      endTime: string;
      durationMinutes: number;
      caregiverId: null | number;
      caregiverName: null | string;
      authorizationId: null | number;
      duties: components["schemas"]["CoServicePlanImportShiftDuty"][];
      /** @description The model's one-line reason for this shift, from its original answer. */
      rationale: null | string;
    };
    /**
     * @description One visit the patient has this week, as it stands now.
     *
     * Times are the visit's own wall clock. A visit belongs to the day it starts on, and
     * one running past midnight ends before it starts, as a template shift does.
     */
    CoServicePlanImportWeekVisit: {
      date: components["schemas"]["LocalDate"];
      dayOfWeek: string;
      startTime: string;
      endTime: string;
      durationMinutes: number;
      caregiverId: null | number;
      caregiverName: null | string;
      /** @description Booked but not worked. Shown, but no part of the week's hours. */
      missed: boolean;
    };
    /** @description One shift of the weekly template the patient has RIGHT NOW. */
    CoServicePlanImportTemplateShift: {
      dayOfWeek: string;
      startTime: string;
      endTime: string;
      durationMinutes: number;
      caregiverId: null | number;
      caregiverName: null | string;
      /**
       * @description The submission that created it, when one did. Null for a shift a coordinator
       * authored — which is the distinction that matters here, because approving
       * replaces the former and leaves the latter alone.
       */
      createdByImportId: null | number;
    };
    /**
     * @description The three numbers a coordinator weighs before approving, per service line.
     *
     * Deliberately together in one row: the question is never "how many minutes did the
     * model schedule" on its own, it is whether that figure sits sensibly between what
     * the payer authorized and what the service plan asked for.
     */
    CoServicePlanImportHoursLine: {
      serviceCode: string;
      /**
       * @description The service plan's own code for the line this authorization bills under,
       * which several authorizations can share: the payer names a procedure code and
       * an agency's export codes add billing modifiers to it.
       *
       * The key the line-level figures below belong to, so a reader can be shown
       * them once for the line instead of once per authorization. Null for an
       * authorization the plan never mentions.
       */
      planServiceCode: null | string;
      authorizationId: null | number;
      /**
       * @description The authorization's own cap and the period it caps, exactly as the payer
       * stated them. What governs a visit; kept beside the weekly figure below,
       * which is derived from it.
       */
      authorizedMinutes: null | number;
      periodType: null | string;
      /**
       * @description The same allowance expressed per week, so lines in different units can be
       * read down one column. Exact for a daily or weekly authorization,
       * approximate for a monthly one, and null for an authorization with no cap to
       * spread. See `weeklyAuthorizedMinutes`.
       */
      authorizedWeeklyMinutes: null | number;
      /** @description What the proposed week schedules on this line. Reflects any coordinator edit. */
      suggestedWeeklyMinutes: number;
      /**
       * @description The proposed week against the most it could usefully deliver on this
       * authorization: the LOWER of the authorization's weekly allowance and what
       * the plan asks for. Null when there is no allowance to measure against.
       *
       * Not the allowance alone, which answers "is there room" rather than "is this
       * done". A plan asking 1,000 minutes where the payer allows 1,080 is complete
       * at 1,000, and printing that as 93% sends a coordinator looking for care
       * nobody is owed. Where the plan asks for more than the payer allows, the
       * allowance is still the target -- it is the most that can ever be billed --
       * and the unmet ask shows up in `planUtilizationPercent` below, which is the
       * figure that answers whether the patient is getting what the plan wrote down.
       */
      authorizationUtilizationPercent: null | number;
      /**
       * @description The proposed week against what the service plan asked for, as a whole
       * percent. The one number that says whether the patient is getting the care
       * the payer wrote down; the authorization only says whether there is room for
       * it. Null when the plan quantified nothing on this line.
       *
       * A figure about the LINE, like `planRequiredWeeklyMinutes` beside it, and
       * repeated on every authorization of that line: the plan asks per line, and
       * care billed under one of its authorizations is not care the plan is missing.
       * Which is why it must be DISPLAYED once per line -- printed on a row whose
       * own proposed minutes are zero, it reads as a contradiction. `planServiceCode`
       * is the key to group by.
       */
      planUtilizationPercent: null | number;
      /**
       * @description What the service plan asked for on this line, per week: the sum over its
       * duties of `minutesPerWeek`, or `minutesPerTask x timesPerWeek` when the
       * sender gave the parts instead of the total. Null when no duty on the line
       * said enough to compute one. A past plan's line is what its week was
       * allocated for: each duty's weekly requirement read exactly as sent, nothing
       * for a duty not required this week (`planRequiredWeeklyMinutesByLine`).
       */
      planRequiredWeeklyMinutes: null | number;
    };
    /**
     * @description A service line the plan's duties name, and what a visit on it bills against.
     *
     * `authorizationId` is resolved the same way both schedulers had it resolved, so a
     * shift the editor builds bills under the authorization the line is actually
     * covered by. Null means the line has no current authorization -- the editor offers
     * the code but nothing can be scheduled on it.
     */
    CoServicePlanImportLine: {
      serviceCode: string;
      authorizationId: null | number;
    };
    /** @description Who replaced this submission's week, and what they accepted to do it. */
    CoServicePlanImportCoordinatorEdit: {
      editedAt: components["schemas"]["Instant"];
      /** @description Null where the member has since been removed. */
      editedByName: null | string;
      /**
       * @description The findings shown at submit time and proceeded past.
       *
       * Surfaced on the drawer because the person who APPROVES a week is often not
       * the person who edited it.
       */
      acceptedViolations: components["schemas"]["CoServicePlanImportViolation"][];
    };
    /** @description One shift of a week a coordinator built, as the editor sends it. */
    ReplaceServicePlanScheduleShift: {
      /**
       * @description Serialised as MONDAY..SUNDAY and revived into a real js-joda value by the
       * request layer, so a malformed day is refused before the controller runs.
       * Imported from `./JSJodaJSON`, which is itself a `messages/` file.
       */
      dayOfWeek: components["schemas"]["DayOfWeek"];
      /** @description 24-hour HH:MM. */
      startTime: string;
      /** @description 24-hour HH:MM, after the start and on the same day. */
      endTime: string;
      /**
       * @description One of the caregivers this submission named, or -- for a past plan, whose week is
       * the patient's existing visits -- a caregiver already staffing one of those visits.
       */
      caregiverId: components["schemas"]["CaregiverId"];
      /**
       * @description The service line this visit is for.
       *
       * A code rather than an authorization id: it is the question a coordinator can
       * answer, and it is what filters the duty picker. The server resolves it to the
       * authorization the line bills under, using the same pairing the schedulers got.
       */
      serviceCode: string;
      duties: components["schemas"]["CoServicePlanImportShiftDuty"][];
    };
    VisitDailyNoteReviewOffice: {
      id: components["schemas"]["OfficeId"];
      name: string;
      /** @description Whether a nurse's signature on this office's notes needs a case manager to co-sign. */
      requiresCosignature: boolean;
    };
    VisitDailyNoteListItem: {
      id: components["schemas"]["VisitInstanceDailyNoteId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      /** @description The visit's local civil time; render it with `visitTimezone`. */
      visitStartTime: components["schemas"]["LocalDateTime"];
      visitEndTime: components["schemas"]["LocalDateTime"];
      visitTimezone: string;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverName: null | string;
      /** @description Null until the model answers, and still null if it never does. */
      summary: null | string;
      priority: ("HIGH" | "ROUTINE" | "URGENT") | null;
      flagged: boolean;
      reviewPathways: ("CASE_MANAGEMENT" | "RN")[];
      /** @description Why the classifier reached that priority, in one sentence. */
      primaryReason: null | string;
      /**
       * @description The incident subtype the classifier thinks fits, for the reviewer to confirm or change.
       * Null for a ROUTINE note, or when the model had no good match.
       */
      suggestedIncidentSubtype:
        | (
            | "Abuse"
            | "Criminal Activity / Theft"
            | "Death other than natural cause"
            | "Exploitation"
            | "Fraud / Waste / Abuse"
            | "Legal Involvement"
            | "Medication Errors"
            | "Missing Person / Loss of Contact / Elopement"
            | "Neglect"
            | "Other"
            | "Provider and Staff member misconduct"
            | "Safeguarding Intervention"
            | "Serious injury"
            | "Service Interruption"
            | "Suicide Threat / Suicide Attempt"
            | "Unplanned Hospitalization"
            | "Unsafe Living Environment"
          )
        | null;
      analysisState: components["schemas"]["VisitDailyNoteAnalysisState"];
      /** @description When the note reached us, which is when the caregiver submitted it. */
      noteCreatedAt: components["schemas"]["Instant"];
      status: components["schemas"]["VisitDailyNoteReviewStatus"];
      /** @description The note has waited longer than its office allows, so it is overdue for review. */
      isDue: boolean;
      /** @description The nurse's ruling, once the note has been signed. */
      determination: ("NON_ROUTINE" | "ROUTINE") | null;
      signedAt: components["schemas"]["Instant"] | null;
      signedByName: null | string;
      cosignedAt: components["schemas"]["Instant"] | null;
      cosignedByName: null | string;
      /**
       * @description Null unless this note's review raised a critical incident. Render it in place of
       * `status` where present: it is the more specific thing to say about the note.
       */
      escalationStatus:
        | (
            | "CREATED_IN_SALESFORCE"
            | "FAILED"
            | "NEEDS_REVIEW"
            | "PENDING_ESCALATION"
            | "RESOLVED"
            | "SENDING"
          )
        | null;
      /**
       * @description Where the note's PDF has got to on its way to DoCare. Null for a note nobody has
       * signed yet: the upload is queued at signing, so there is nothing to report before.
       */
      docareStatus: ("FAILED" | "PENDING" | "PUBLISHED" | "SENDING") | null;
    };
    /** Format: VisitInstanceDailyNoteId */
    VisitInstanceDailyNoteId: VisitInstanceDailyNoteId;
    /** @enum {string} */
    VisitDailyNoteAnalysisState:
      | "COMPLETED"
      | "FAILED"
      | "PENDING"
      | "PROCESSING";
    /** @enum {string} */
    VisitDailyNoteReviewStatus:
      | "APPROVED"
      | "AWAITING_COSIGNATURE"
      | "READY_FOR_REVIEW";
    /** @enum {string} */
    VisitDailyNotePageStatusFilter:
      | "ALL"
      | "APPROVED"
      | "AWAITING_COSIGNATURE"
      | "READY_FOR_REVIEW";
    /**
     * @description One patient's unsigned notes, counted (0 when nothing is waiting). The row a nurse clicks to
     * start reviewing them, or to open the patient's history.
     */
    VisitDailyNotePatientGroup: {
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      /** @description FreedomCare's own id for the patient, when we have one. */
      patientExternalId: null | string;
      noteCount: number;
      urgentCount: number;
      highCount: number;
      routineCount: number;
      /** @description Notes whose visit was more than 14 days ago. */
      dueCount: number;
      /** @description Notes the classifier has not answered for yet, so they carry no priority. */
      unclassifiedCount: number;
      /** @description The oldest visit among the counted notes, by its own local date; null when none. */
      oldestVisitDate: components["schemas"]["LocalDate"] | null;
    };
    /**
     * @description Unsigned notes, counted with the same predicates as the patients list so that a tile's number
     * equals what the list shows after the click.
     */
    VisitDailyNoteBacklogStats: {
      total: number;
      patientCount: number;
      /** @description The visit was more than 14 days ago. */
      due: number;
      flagged: number;
      dueAndFlagged: number;
      urgent: number;
      high: number;
      routine: number;
      /** @description No priority yet: still being analysed, or the analysis failed. */
      unclassified: number;
      /** @description By days since the visit, in the visit's own timezone. */
      ageUpTo7Days: number;
      age8To14Days: number;
      age15To30Days: number;
      ageOver30Days: number;
    };
    /**
     * @description Whether signing kept to the 14-day target, over notes whose visit date is in the window and on
     * or after the office went live. Notes from before go-live (the backfill) are left out and
     * counted in `excludedBeforeGoLive`, so signing a large old backlog cannot move the figure.
     */
    VisitDailyNoteComplianceStats: {
      /** @description Signed on or before the 14th day after the visit. */
      signedOnTime: number;
      signedLate: number;
      /** @description Not signed, and the 14 days are over. Not-yet-due unsigned notes are not counted. */
      overdueUnsigned: number;
      /** @description Null when no note has reached its deadline yet. */
      compliancePct: null | number;
      /** @description The latest go-live date among the offices counted: the earliest visit that counts. */
      goLiveDate: components["schemas"]["LocalDate"] | null;
      excludedBeforeGoLive: number;
    };
    VisitDailyNoteIncidentStats: {
      signedRoutine: number;
      signedNonRoutine: number;
      sending: number;
      createdInSalesforce: number;
      resolved: number;
      failed: number;
      needsReview: number;
    };
    /** @description Days from visit to signature, for notes signed in the window. Null where none were. */
    VisitDailyNoteTimeToSign: {
      priority: components["schemas"]["VisitDailyNotePriority"];
      count: number;
      medianDays: null | number;
      slowest10PercentDays: null | number;
    };
    /** @enum {string} */
    VisitDailyNotePriority: "HIGH" | "ROUTINE" | "URGENT";
    VisitDailyNoteAiQualityStats: {
      /** @description Signed notes: the AI's priority against the nurse's ruling. */
      rulings: components["schemas"]["VisitDailyNotePriorityRuling"][];
      /** @description Notes analysed in the window, and how many of them triage closed without the full model. */
      analysedNotes: number;
      closedByTriage: number;
      /** @description Triage's routine calls that were sent to the full model anyway as an audit sample. */
      auditSampled: number;
      /** @description Of those, the ones the full model then rated HIGH or URGENT. */
      auditSampledFlagged: number;
    };
    VisitDailyNotePriorityRuling: {
      priority: ("HIGH" | "ROUTINE" | "URGENT") | null;
      determination: components["schemas"]["VisitDailyNoteDetermination"];
      count: number;
    };
    /** @enum {string} */
    VisitDailyNoteDetermination: "NON_ROUTINE" | "ROUTINE";
    VisitDailyNoteSyncIssueCounts: {
      docareFailed: number;
      salesforceFailed: number;
      salesforceNeedsReview: number;
    };
    /**
     * @description The second signature, for offices that require one.
     *
     * The `awaiting*` figures are what waits right now, whatever the dashboard's dates, like the
     * backlog. The rest cover batches with a visit in the dashboard's window.
     */
    VisitDailyNoteCosignStats: {
      /** @description Signed batches waiting for a co-signature. */
      awaitingBatches: number;
      /** @description The notes in those batches -- also the notes held back from DoCare until co-signed. */
      awaitingNotes: number;
      /** @description Waiting batches with at least one note the nurse confirmed as concerning. */
      awaitingConcerningBatches: number;
      /** @description When the longest-waiting batch was signed. Null when nothing waits. */
      oldestAwaitingSignedAt: components["schemas"]["Instant"] | null;
      cosignedInWindow: number;
      awaitingInWindow: number;
      /** @description From the nurse's signature to the co-signature, over the batches co-signed in the window. */
      medianHoursToCosign: null | number;
      slowest10PercentHoursToCosign: null | number;
    };
    /** @description One note whose publish to DoCare, or whose incident in Salesforce, did not go through. */
    VisitDailyNoteSyncIssue: {
      kind: components["schemas"]["VisitDailyNoteSyncIssueKind"];
      visitInstanceDailyNoteId: components["schemas"]["VisitInstanceDailyNoteId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      visitStartTime: components["schemas"]["LocalDateTime"];
      visitTimezone: string;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverName: null | string;
      /** @description `FAILED` for DoCare; `FAILED` or `NEEDS_REVIEW` for Salesforce. */
      status: string;
      error: null | string;
      retryCount: number;
      maxRetries: number;
      lastAttemptAt: components["schemas"]["Instant"] | null;
      /** @description The incident's subtype, for a Salesforce row. */
      incidentSubtype: null | string;
    };
    /** @enum {string} */
    VisitDailyNoteSyncIssueKind: "DOCARE" | "SALESFORCE";
    VisitDailyNoteSyncIssueResubmitResult: {
      kind: components["schemas"]["VisitDailyNoteSyncIssueKind"];
      visitInstanceDailyNoteId: components["schemas"]["VisitInstanceDailyNoteId"];
      queued: boolean;
      /** @description Why it was not queued, when it was not. */
      reason: null | string;
    };
    VisitDailyNoteSyncIssueResubmitItem: {
      kind: components["schemas"]["VisitDailyNoteSyncIssueKind"];
      visitInstanceDailyNoteId: components["schemas"]["VisitInstanceDailyNoteId"];
      /** @description For a Salesforce row sent back for review: the subtype to send it as. Null keeps it. */
      incidentSubtype:
        | (
            | "Abuse"
            | "Criminal Activity / Theft"
            | "Death other than natural cause"
            | "Exploitation"
            | "Fraud / Waste / Abuse"
            | "Legal Involvement"
            | "Medication Errors"
            | "Missing Person / Loss of Contact / Elopement"
            | "Neglect"
            | "Other"
            | "Provider and Staff member misconduct"
            | "Safeguarding Intervention"
            | "Serious injury"
            | "Service Interruption"
            | "Suicide Threat / Suicide Attempt"
            | "Unplanned Hospitalization"
            | "Unsafe Living Environment"
          )
        | null;
    };
    /**
     * @description One question as the caregiver was asked it, with what they answered.
     *
     * Carries the question text rather than an id: the questionnaire is versioned on the
     * sender's side and we hold no catalog of it, so the text stored with the note is the
     * only rendering of it that will still be accurate later.
     */
    VisitDailyNoteAnswerView: {
      questionId: number;
      question: string;
      category: null | string;
      subCategory: null | string;
      answer: string[];
      comment: null | string;
    };
    /** @description One rule the classifier applied, and the text that triggered it. */
    VisitDailyNoteTriggeredRule: {
      rule: string;
      evidence: string;
    };
    VisitDailyNoteAttestationInfo: {
      id: components["schemas"]["VisitInstanceDailyNoteAttestationId"];
      signedByName: string;
      signedAt: components["schemas"]["Instant"];
      declarationVersion: string;
      /** @description What was signed, as it read at the time. */
      declarationText: string;
      requiresCosignature: boolean;
      cosignedByName: null | string;
      cosignedAt: components["schemas"]["Instant"] | null;
      cosignDeclarationText: null | string;
    };
    /** Format: VisitInstanceDailyNoteAttestationId */
    VisitInstanceDailyNoteAttestationId: VisitInstanceDailyNoteAttestationId;
    VisitDailyNoteDeterminationInput: {
      visitInstanceDailyNoteId: components["schemas"]["VisitInstanceDailyNoteId"];
      determination: components["schemas"]["VisitDailyNoteDetermination"];
      /** @description What was done about the note. Several may apply; none is also an answer. */
      dispositions: (
        | "CAREGIVER_CLARIFICATION"
        | "CAREGIVER_COACHING"
        | "CARE_PLAN_REASSESSMENT"
        | "CONTACT_PCP"
        | "INCIDENT_EVALUATION"
        | "NOTIFY_CASE_MANAGER"
        | "NO_ACTION_REQUIRED"
        | "URGENT_CLINICAL_ESCALATION"
      )[];
      /**
       * @description Whether the reviewer chose to open a Salesforce critical incident. Only a concerning
       * (NON_ROUTINE) ruling can; no incident is ever raised without this.
       */
      createIncident: boolean;
      /**
       * @description The reviewer's confirmed incident subtype, which is what the Salesforce Case is opened
       * as. Required (with at least one disposition) when `createIncident` is true; must be
       * null otherwise.
       */
      incidentSubtype:
        | (
            | "Abuse"
            | "Criminal Activity / Theft"
            | "Death other than natural cause"
            | "Exploitation"
            | "Fraud / Waste / Abuse"
            | "Legal Involvement"
            | "Medication Errors"
            | "Missing Person / Loss of Contact / Elopement"
            | "Neglect"
            | "Other"
            | "Provider and Staff member misconduct"
            | "Safeguarding Intervention"
            | "Serious injury"
            | "Service Interruption"
            | "Suicide Threat / Suicide Attempt"
            | "Unplanned Hospitalization"
            | "Unsafe Living Environment"
          )
        | null;
    };
    VisitDailyNoteFindingsInput: {
      visitInstanceDailyNoteId: components["schemas"]["VisitInstanceDailyNoteId"];
      text: string;
    };
    /**
     * @description A note the caller may not sign, because they hold no license in force that it accepts.
     * `requiredLicenseState` is the state its office's rule demands for this visit date, or null
     * when an active license in any state would do.
     */
    VisitDailyNoteSignOffBlock: {
      visitInstanceDailyNoteId: components["schemas"]["VisitInstanceDailyNoteId"];
      requiredLicenseState: null | string;
    };
    /** @description A professional license an agency member holds, as entered by an admin. */
    AgencyMemberLicense: {
      id: components["schemas"]["AgencyMemberLicenseId"];
      agencyMemberId: components["schemas"]["AgencyMemberId"];
      agencyMemberName: string;
      /** @description Two-letter code of the issuing state. */
      state: string;
      licenseType: components["schemas"]["AgencyMemberLicenseType"];
      licenseNumber: string;
      /** @description The last day the license is valid, or null when no expiry was entered. */
      expiresOn: components["schemas"]["LocalDate"] | null;
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: AgencyMemberLicenseId */
    AgencyMemberLicenseId: AgencyMemberLicenseId;
    /** @enum {string} */
    AgencyMemberLicenseType: "BSN" | "LPN" | "NP" | "RN";
    /** @enum {string} */
    VisitDailyNoteDocareUploadStatus:
      | "FAILED"
      | "PENDING"
      | "PUBLISHED"
      | "SENDING";
    VisitDailyNoteCriticalIncident: {
      status: components["schemas"]["VisitDailyNoteEscalationStatus"];
      /** @description What the Case is opened as. Null only for an incident that predates subtypes. */
      subtype:
        | (
            | "Abuse"
            | "Criminal Activity / Theft"
            | "Death other than natural cause"
            | "Exploitation"
            | "Fraud / Waste / Abuse"
            | "Legal Involvement"
            | "Medication Errors"
            | "Missing Person / Loss of Contact / Elopement"
            | "Neglect"
            | "Other"
            | "Provider and Staff member misconduct"
            | "Safeguarding Intervention"
            | "Serious injury"
            | "Service Interruption"
            | "Suicide Threat / Suicide Attempt"
            | "Unplanned Hospitalization"
            | "Unsafe Living Environment"
          )
        | null;
      salesforceCaseId: null | string;
      salesforceCaseNumber: null | string;
      /** @description Why the last attempt failed, when it did. */
      error: null | string;
      retryCount: number;
      maxRetries: number;
      /** @description Whether sending again can change anything: only a failed or needs-review incident. */
      canResend: boolean;
      events: components["schemas"]["VisitDailyNoteCriticalIncidentEvent"][];
    };
    /** @enum {string} */
    VisitDailyNoteEscalationStatus:
      | "CREATED_IN_SALESFORCE"
      | "FAILED"
      | "NEEDS_REVIEW"
      | "PENDING_ESCALATION"
      | "RESOLVED"
      | "SENDING";
    /** @description One exchange with Salesforce about a critical incident, newest first in the response. */
    VisitDailyNoteCriticalIncidentEvent: {
      id: components["schemas"]["VisitDailyNoteCriticalIncidentEventId"];
      createdAt: components["schemas"]["Instant"];
      /** @description `OUTBOUND` today; reserved for Salesforce telling MedFlyt about a case. */
      direction: string;
      /** @description Null when no response came back at all. */
      httpStatus: null | number;
      decision: null | string;
      reasonCodes: string[];
      error: null | string;
      n8nExecutionId: null | string;
      salesforceCaseNumber: null | string;
    };
    /** Format: VisitDailyNoteCriticalIncidentEventId */
    VisitDailyNoteCriticalIncidentEventId: VisitDailyNoteCriticalIncidentEventId;
    /** @description One signed batch, as it appears in the co-signer's queue. */
    VisitDailyNoteAttestationListItem: {
      id: components["schemas"]["VisitInstanceDailyNoteAttestationId"];
      signedByName: string;
      signedAt: components["schemas"]["Instant"];
      noteCount: number;
      /** @description How many of the notes in the batch the classifier called URGENT / HIGH. */
      urgentCount: number;
      highCount: number;
      /** @description How many the nurse confirmed as concerning. */
      nonRoutineCount: number;
      /** @description How many of those the nurse chose to raise as Salesforce critical incidents. */
      incidentCount: number;
      patientNames: string[];
      /** @description The first and last visit day among the batch's notes, as local dates of the visits. */
      firstVisitDate: components["schemas"]["LocalDate"] | null;
      lastVisitDate: components["schemas"]["LocalDate"] | null;
      /**
       * @description Whether this batch was ever subject to a second signature, frozen at signing.
       *
       * `COMPLETE` covers both "co-signed" and "never needed co-signing", which are the
       * same state for a work queue and different states for a record. This is what lets
       * the row say "Signed" or "Co-signed by X" instead of flattening the two.
       */
      requiresCosignature: boolean;
      status: components["schemas"]["VisitDailyNoteAttestationStatus"];
      cosignedByName: null | string;
      cosignedAt: components["schemas"]["Instant"] | null;
    };
    /** @enum {string} */
    VisitDailyNoteAttestationStatus: "AWAITING_COSIGNATURE" | "COMPLETE";
    /** @enum {string} */
    VisitDailyNoteAttestationFilter:
      | "ALL"
      | "AWAITING_COSIGNATURE"
      | "COSIGNED"
      | "SIGNED";
    /** @description One note inside a batch, as the co-signer reviews it. */
    VisitDailyNoteAttestationManifestItem: {
      visitInstanceDailyNoteId: components["schemas"]["VisitInstanceDailyNoteId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      visitStartTime: components["schemas"]["LocalDateTime"];
      visitTimezone: string;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      summary: null | string;
      priority: ("HIGH" | "ROUTINE" | "URGENT") | null;
      primaryReason: null | string;
      determination: ("NON_ROUTINE" | "ROUTINE") | null;
      /** @description What the reviewer did about the note. Empty where nothing was recorded. */
      dispositions: (
        | "CAREGIVER_CLARIFICATION"
        | "CAREGIVER_COACHING"
        | "CARE_PLAN_REASSESSMENT"
        | "CONTACT_PCP"
        | "INCIDENT_EVALUATION"
        | "NOTIFY_CASE_MANAGER"
        | "NO_ACTION_REQUIRED"
        | "URGENT_CLINICAL_ESCALATION"
      )[];
      /**
       * @description True when a newer revision of this note arrived after the nurse signed.
       *
       * Shown rather than blocking: the attestation records that a review happened at a
       * point in time, and the newer revision separately re-enters the review queue.
       */
      supersededSinceSigning: boolean;
    };
    /** @enum {string} */
    VisitDailyNoteAttestationDocumentState: "PREPARING" | "READY";
    PlanOfCareItemExtended: {
      id: components["schemas"]["PlanOfCareItemId"];
      label: string;
      type: components["schemas"]["POCItemAnswer.POCAnswerType"];
      code: string;
      orderInSection: number;
      section: string;
      hhaxItemsMapping?: {
        hhaxItemId: components["schemas"]["HHAXPocItemId"];
        payerId: components["schemas"]["PayerId"];
      }[];
    };
    /** @enum {string} */
    "POCItemAnswer.POCAnswerType": "Attribute" | "Predefined" | "Task";
    /** Format: HHAXPocItemId */
    HHAXPocItemId: HHAXPocItemId;
    OfficePlanOfCareSettings: {
      officeId: components["schemas"]["OfficeId"];
      officeName: string;
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      showPatientSignature: null | boolean;
      name: null | string;
      columns: {
        id: components["schemas"]["PlanOfCareItemId"];
        /**
         * @description The HHAeXchange items this plan of care item is mapped to, one per payer. Populated by
         * `getOfficesPlanOfCareSettingsOfAgency`; absent on the copy-from-template response.
         */
        hhaxItemsMapping?: {
          hhaxItemId: components["schemas"]["HHAXPocItemId"];
          payerId: components["schemas"]["PayerId"];
        }[];
        label: string;
        type: components["schemas"]["POCItemAnswer.POCAnswerType"];
        code: string;
        orderInSection: number;
        section: string;
      }[];
    };
    CustomPOCItemRequest: {
      code: string;
      section: string;
      order: number;
      isActive: boolean;
      isPersonalCare: boolean;
      label: string;
      type: components["schemas"]["POCItemAnswer.POCAnswerType"];
    };
    CustomPOCItemResponse: {
      code: string;
      section: string;
      order: number;
      isActive: boolean;
      isPersonalCare: boolean;
      label: string;
      type: components["schemas"]["POCItemAnswer.POCAnswerType"];
    };
    "Record<string,number>": { [key: string]: unknown };
    VisitInstanceForDutySheets: {
      id: components["schemas"]["VisitInstanceId"];
      date: components["schemas"]["LocalDate"];
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverName: null | string;
      caregiverPhotoUrl: null | string;
      /**
       * @description Every duty occurrence this visit has a performed record of, one entry per
       * occurrence and ordered by duty then occurrence.
       *
       * NOT a set of duties: a duty recorded twice appears twice, once per
       * occurrence, because the grid round-trips this list straight back into
       * `VisitsOfWeekDetailsEditParams.dutiesDone` and a collapsed list could not
       * express occurrence 2.
       */
      dutiesDone: components["schemas"]["VisitDutyOccurrenceDone"][];
      patientHasPlanOfCare: boolean;
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      clockInType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      clockOutType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      clockInUpdatedByUserType: ("AGENCY_MEMBER" | "CAREGIVER") | null;
      clockOutUpdatedByUserType: ("AGENCY_MEMBER" | "CAREGIVER") | null;
      timesheetStatus: ("APPROVED" | "DECLINED" | "PENDING") | null;
      editPermissions: components["schemas"]["AgencyMemberPermission"][] | null;
      isBilled: boolean;
      isPaid: boolean;
      isOnPayrollDraft: boolean;
    };
    /**
     * @description One duty occurrence recorded as performed on a visit.
     *
     * The duty-sheet week grid shows one checkbox per occurrence, not one checkbox
     * with a count, so both directions name the occurrence explicitly: a duty owed
     * twice on a visit is two entries, and a coordinator unticking the second one
     * sends the first entry back on its own. A count could not say WHICH occurrence
     * was unticked.
     */
    VisitDutyOccurrenceDone: {
      dutyId: components["schemas"]["PlanOfCareItemId"];
      occurrenceIndex: number;
    };
    VisitsOfWeekDetailsEditParams: {
      id: components["schemas"]["VisitInstanceId"];
      date: components["schemas"]["LocalDate"];
      /** Format: yyyy-MM-ddTHH:mm:ss.SSS */
      clockInTime?: LocalDateTime;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSS */
      clockOutTime?: LocalDateTime;
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"];
      /**
       * @description Exactly the duty occurrences that are ticked on this visit, one entry per
       * ticked occurrence.
       *
       * Authoritative for the occurrences it names AND for the ones it does not:
       * an occurrence recorded on the visit and absent from this list is retired.
       * Occurrences of OTHER duties, and other occurrences of the same duty, are
       * left alone -- so a payload is never a licence to wipe the visit.
       *
       * An EMPTY list is the same statement about every occurrence at once:
       * nothing is ticked, so every occurrence recorded on the visit is retired.
       */
      dutiesDone: components["schemas"]["VisitDutyOccurrenceDone"][];
      manualClockNote?: components["schemas"]["AgencyNoteCreateParams"];
      manualClockTimeEditApproved?: boolean;
      approvalNote?: components["schemas"]["AgencyNoteEditParams"];
    };
    /**
     * @description A duty a visit was required to perform and has no record of performing, with
     * the visits it could be made up on.
     */
    VisitInstanceMissedDuty: {
      planOfCareDutyId: components["schemas"]["PlanOfCareDutyId"];
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      code: string;
      label: string;
      sectionName: string;
      /**
       * @description How many occurrences of this duty are still outstanding on the visit and
       * have not themselves been handed to another visit. A duty due twice that
       * performed once and has not made up the rest reports 1, not a flag.
       */
      missedOccurrences: number;
      eligibleTargetVisits: components["schemas"]["VisitInstanceMissedDutyTarget"][];
    };
    VisitInstanceMissedDutyTarget: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverName: null | string;
    };
    /**
     * @description A make-up this visit has already handed to another visit: which duty, how many
     * occurrences of it, and the visit now carrying them.
     *
     * The target visit is how the undo names WHICH make-up to retract, because it is
     * what the coordinator sees ("made up on Tuesday"). That also holds against the
     * table: `visit_instance_duty_reassignment_target_uniq` is UNIQUE on
     * (target visit, duty) among live rows, so a target visit and a duty name at
     * most one make-up.
     */
    VisitInstanceDutyMakeUp: {
      planOfCareDutyId: components["schemas"]["PlanOfCareDutyId"];
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      /**
       * @description The duty's catalogue code and label, so a make-up can name itself.
       *
       * Carried here rather than looked up against the missed-duty list, because a
       * duty whose occurrences are ALL made up is absent from that list -- which is
       * exactly when this one is the only thing naming it.
       */
      code: string;
      label: string;
      /** @description How many occurrences of the duty this make-up moved. At least one. */
      occurrences: number;
      targetVisitInstanceId: components["schemas"]["VisitInstanceId"];
      targetStartTime: components["schemas"]["LocalDateTime"];
      targetEndTime: components["schemas"]["LocalDateTime"];
      targetCaregiverId: components["schemas"]["CaregiverId"] | null;
      targetCaregiverName: null | string;
    };
    /** Format: VisitInstanceDutyReassignmentId */
    VisitInstanceDutyReassignmentId: VisitInstanceDutyReassignmentId;
    PlanOfCareSignature: {
      data: string;
      signedAt: components["schemas"]["Instant"];
      unsignedResaon?: null | string;
    };
    POCItem: {
      id: components["schemas"]["PlanOfCareItemId"];
      label: string;
      section: string;
      code: string;
      type: components["schemas"]["POCItemAnswer.POCAnswerType"];
      orderInSection: number;
    };
    HHAXPlanOfCarePayer: {
      id: components["schemas"]["PayerId"];
      name: string;
    };
    HHAXPlanOfCareItem: {
      id: components["schemas"]["HHAXPocItemId"];
      payerId: components["schemas"]["PayerId"];
      taskCode: string;
      taskName: string;
    };
    SandataPlanOfCareItem: {
      id: components["schemas"]["SandataPlanOfCareItemId"];
      code: string;
      description: string;
      /** @description The state the code belongs to, or null when it applies to every state. */
      state: null | string;
    };
    /** Format: SandataPlanOfCareItemId */
    SandataPlanOfCareItemId: SandataPlanOfCareItemId;
    SandataPlanOfCareItemMapping: {
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"];
      officeId: components["schemas"]["OfficeId"];
      label: string;
      section: string;
      code: string;
      orderInSection: number;
      /**
       * @description A plan of care item may report to several Sandata duty codes; the visit submission then
       * carries one Sandata task per code.
       */
      sandataPlanOfCareItemIds: components["schemas"]["SandataPlanOfCareItemId"][];
    };
    /**
     * @description A plan of care type item as shown in the office POC editor. Unlike `POCItem`, this
     * includes inactive items and the usage signals needed to warn before deactivating.
     */
    PlanOfCareTypeItemDetailed: {
      id: components["schemas"]["PlanOfCareItemId"];
      code: string;
      label: string;
      section: string;
      type: components["schemas"]["POCItemAnswer.POCAnswerType"];
      orderInSection: number;
      isActive: boolean;
      isPersonalCare: boolean;
      /** @description How many patient plan of care duties reference this item */
      dutyCount: number;
      /** @description Whether the item is mapped to an HHAX or Sandata EVV code */
      hasEvvMapping: boolean;
      /**
       * @description The agency service codes this duty applies to, agency-wide. Empty means
       * every service code. A visit billing a service code outside this set does
       * not list the duty.
       */
      serviceCodeIds: components["schemas"]["ServiceCodeId"][];
    };
    StaffingIssue: {
      issue: components["schemas"]["StaffingIssueEnum"];
      issueDisplayText: string;
      /** Format: PatientId */
      patientId?: PatientId;
      patientName?: string;
      /** Format: CaregiverId */
      caregiverId?: CaregiverId;
      patientDisplayId?: number;
      caregvierName?: string;
      /**
       * @description The name parts, so a client can offer the same name orders in its search
       * box without holding a dictionary of every caregiver.
       */
      caregiverFirstName?: null | string;
      caregiverMiddleName?: null | string;
      caregiverLastName?: null | string;
      caregiverDisplayId?: number;
      /** Format: VisitInstanceId */
      visitId?: VisitInstanceId;
      /** Format: yyyy-MM-dd */
      visitDate?: LocalDate;
      notes?: string;
    };
    /** @enum {string} */
    StaffingIssueEnum:
      | "ACTIVE_PATIENTS_WITH_NO_AUTHORIZATION"
      | "ACTIVE_PATIENT_WITH_NO_CONTRACT"
      | "CAREGIVERS_DIFFERENCES_BETWEEN_AUTHORIZED_AND_SCHEDULED_HOURS"
      | "CAREGIVERS_ON_VISIT_WITH_OVERTIME"
      | "CAREGIVER_ASSIGNED_TO_VISITS_BUT_HAS_ABSENCE"
      | "CAREGIVER_NOT_ACTIVE_ON_A_CASE"
      | "CAREGIVER_ON_VISIT_PATIENT_NOT_ACTIVE"
      | "PATIENTS_WITHOUT_WEEKLY_TEMPLATES"
      | "PATIENTS_WITH_DIFFERENCE_BETWEEN_AUTHORIZED_HOURS_SCHEDULED_HOURS"
      | "PATIENTS_WITH_VISITS_CAREGIVER_NOT_ACTIVE"
      | "PATIENTS_WITH_VISITS_WITH_NO_PLAN_OF_CARE"
      | "PATIENT_WITH_AUTHORIZATION_MISSING_ALL_VISITS"
      | "PATIENT_WITH_AUTHORIZATION_MISSING_VISITS"
      | "PATIENT_WITH_NO_POC"
      | "PATIENT_WITH_UNASSIGED_VISITS"
      | "PATIENT_WITH_WEEKLY_TEMPLATE_MISSING_CAREGIVER";
    StaffingIssuesType: {
      id: components["schemas"]["StaffingIssueEnum"];
      displayText: string;
      tooltipText: string;
    };
    HoursUsagePatientData: {
      id: components["schemas"]["PatientId"];
      displayId: null | number;
      firstName: string;
      lastName: string;
      firstFilterValue: components["schemas"]["LocalTimeStringLiteral"];
      secondFilterValue: components["schemas"]["LocalTimeStringLiteral"];
      difference: components["schemas"]["LocalTimeStringLiteral"];
    };
    LocalTimeStringLiteral: string;
    ServiceCodeWithPayrollCodes: {
      payrollCodes: components["schemas"]["PayrollCodeId"][];
      id: components["schemas"]["ServiceCodeId"];
      code: string;
      agency: components["schemas"]["AgencyId"] | null;
      rateType: components["schemas"]["RateType"];
      exportCode: string;
      revenueCode: null | string;
      weekendExportCode: null | string;
      weekendRevenueCode: null | string;
      certification: components["schemas"]["CaregiverCertification"];
      billable: boolean;
      isActive: boolean;
      mutual: boolean;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"] | null;
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      allowVisitOverlap: boolean;
    };
    RateType:
      | components["schemas"]["RateType.Hourly"]
      | components["schemas"]["RateType.Daily"]
      | components["schemas"]["RateType.Visit"]
      | components["schemas"]["RateType.Cluster"];
    "RateType.Hourly": {
      /** @enum {string} */
      type: "Hourly";
      unitMode: components["schemas"]["UnitMode"];
    };
    UnitMode:
      | components["schemas"]["UnitMode.PerHour"]
      | components["schemas"]["UnitMode.Fixed"];
    "UnitMode.PerHour": {
      /** @enum {string} */
      kind: "PerHour";
      unitsPerHour: number;
    };
    "UnitMode.Fixed": {
      /** @enum {string} */
      kind: "Fixed";
      fixedUnits: number;
    };
    "RateType.Daily": {
      /** @enum {string} */
      type: "Daily";
      minimumDailyHours: number;
      fixedUnits: number;
    };
    "RateType.Visit": {
      /** @enum {string} */
      type: "Visit";
      fixedUnits: number;
    };
    "RateType.Cluster": {
      /** @enum {string} */
      type: "Cluster";
      fixedUnits: number;
    };
    CaregiverUploadedPatientDocumentForWebapp: {
      id: components["schemas"]["CaregiverPatientDocumentUploadsId"];
      patient: components["schemas"]["PatientId"];
      visit: components["schemas"]["VisitBroadcastId"];
      docType: {
        id: number;
        name: string;
      };
      /**
       * @description Denormalised: the table names the caregiver who uploaded the document.
       * `caregiver` on the base type is only the id.
       */
      caregiverDisplay: components["schemas"]["CaregiverRowDisplay"] | null;
      createdAt: components["schemas"]["Instant"];
      caregiver: components["schemas"]["CaregiverId"];
      fileUrl: null | string;
    };
    /** Format: CaregiverPatientDocumentUploadsId */
    CaregiverPatientDocumentUploadsId: CaregiverPatientDocumentUploadsId;
    TrainingCenterCaregiverBundle: {
      agencyId: components["schemas"]["AgencyId"];
      bundleId: components["schemas"]["TrainingCenterBundleId"];
      bundleDueDateId: components["schemas"]["TrainingCenterBundleDueDateId"];
      bundleDueDateYear: number;
      bundleDueDateEnforceWatchOrder: boolean;
      visibleDate: components["schemas"]["LocalDate"];
      completionDate: components["schemas"]["LocalDate"];
      complianceDate: components["schemas"]["LocalDate"];
      bundleParams: components["schemas"]["TrainingCenterBundleParams"];
      bundleDisplayData: components["schemas"]["TrainingCenterTranslated<TrainingCenterDisplayData>"][];
      completionCertificate:
        | components["schemas"]["TrainingCenterBundleCertificate"]
        | null;
      bundleItems: components["schemas"]["TrainingCenterBundleItem"][];
      isOrientation: boolean;
      showDuration: boolean;
    };
    /** Format: TrainingCenterBundleId */
    TrainingCenterBundleId: TrainingCenterBundleId;
    TrainingCenterBundleParams: {
      chatAgencyMemberId: components["schemas"]["AgencyMemberId"];
      signingAgencyMemberId: components["schemas"]["AgencyMemberId"];
      signingAgencyMemberTitle: string;
      enforceWatchOrder: boolean;
      requiredForBillingCompliance: boolean;
      canWatchDuringVisitShift: boolean;
      showBundleAfterDueDate: boolean;
      caregiverCertifications: components["schemas"]["TrainingCenterCaregiverCertifications"][];
      caregiverStatuses: (
        | "ACTIVE"
        | "JOIN_REQUEST"
        | "ON_HOLD"
        | "ON_LEAVE"
        | "PENDING"
        | "QUIT"
        | "REJECTED"
        | "SUSPENDED"
        | "TERMINATED"
      )[];
      isOrientation: boolean;
      requireHireDate: boolean;
      payroll: components["schemas"]["TrainingCenterBundleParamsPayroll"];
    };
    TrainingCenterCaregiverCertifications: {
      officeId: components["schemas"]["OfficeId"];
      certifications: components["schemas"]["CaregiverCertification"][];
    };
    TrainingCenterBundleParamsPayroll: {
      paycodePerCertificationMap: components["schemas"]["Record<string,PayrollCodeId>"];
      isOvertime: boolean;
      durationInSeconds: number;
    };
    "Record<string,PayrollCodeId>": { [key: string]: unknown };
    "TrainingCenterTranslated<TrainingCenterDisplayData>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterDisplayData"];
    };
    TrainingCenterDisplayLanguage: string;
    TrainingCenterDisplayData: {
      title?: string;
      thumbnailUrl?: null | string;
    };
    TrainingCenterBundleCertificate: {
      createdAt: components["schemas"]["Instant"];
    };
    TrainingCenterBundleItem: {
      bundleItemId: components["schemas"]["TrainingCenterBundleItemId"];
      active: boolean;
      timeForCertificateMinutes: null | number;
      media: components["schemas"]["TrainingCenterBundleItemMedia"];
      itemCompleted: boolean;
      itemExempt: boolean;
      caregiverSignatureDataURL: null | string;
      /**
       * @description The test becomes unlocked when the caregiver has watched enough of the
       * training material (e.g. Video, PDF...)
       */
      testUnlocked: boolean;
      /**
       * @description How many attempts has this caregiver submitted the test. If this is
       * equal to or greater than `testMaxAttemptsAllowed` then the test
       * questions should be grayed out.
       */
      testNumAttempts: number;
      testParams: components["schemas"]["TrainingCenterTestParams"];
      displayData: components["schemas"]["TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>"][];
      currentTestQuestions: components["schemas"]["TrainingCenterCaregiverTestQuestion"][];
      fullDescriptions: components["schemas"]["TrainingCenterBundleItemFullDescription"][];
    };
    /** Format: TrainingCenterBundleItemId */
    TrainingCenterBundleItemId: TrainingCenterBundleItemId;
    TrainingCenterBundleItemMedia:
      | components["schemas"]["TrainingCenterBundleItemMedia.Video"]
      | components["schemas"]["TrainingCenterBundleItemMedia.PDF"]
      | components["schemas"]["TrainingCenterBundleItemMedia.TestOnly"];
    "TrainingCenterBundleItemMedia.Video": {
      /** @enum {string} */
      type: "Video";
      requiredWatchTimePercent: number;
      source: components["schemas"]["TrainingCenterBundleVideoSource"];
      engagementQuestions: components["schemas"]["TrainingCenterBundleItemVideoEngagementQuestion"][];
      mediaOverlays: components["schemas"]["TrainingCenterBundleItemVideoMediaOverlay"][];
      liveInfo:
        | components["schemas"]["TrainingCenterBundleItemLiveInfo"]
        | null;
      videoInfo: components["schemas"]["TrainingCenterTranslated<TrainingCenterVideoInfo>"][];
      videoSubtitles: components["schemas"]["TrainingCenterTranslated<TrainingCenterVideoSubtitles>"][];
      videoWatchData: components["schemas"]["TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>"][];
    };
    /** @enum {string} */
    TrainingCenterBundleVideoSource: "VIDEO_URL" | "YOUTUBE";
    TrainingCenterBundleItemVideoEngagementQuestion: {
      questionId: components["schemas"]["TrainingCenterBundleItemVideoEngmtQuestionId"];
      atSecond: number;
      duration: number;
      displayData: components["schemas"]["TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>"][];
    };
    /** Format: TrainingCenterBundleItemVideoEngmtQuestionId */
    TrainingCenterBundleItemVideoEngmtQuestionId: TrainingCenterBundleItemVideoEngmtQuestionId;
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterBundleItemVideoEngagementQuestionDisplayData"];
    };
    TrainingCenterBundleItemVideoEngagementQuestionDisplayData: {
      questionText: string;
      questionAnswers: string[];
    };
    TrainingCenterBundleItemVideoMediaOverlay: {
      itemId: components["schemas"]["TrainingCenterBundleItemVideoMediaOverlayId"];
      atSecond: number;
      duration: number;
      position: components["schemas"]["TrainingCenterBundleItemVideoMediaOverlayPosition"];
      overlayData: components["schemas"]["TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>"][];
    };
    /** Format: TrainingCenterBundleItemVideoMediaOverlayId */
    TrainingCenterBundleItemVideoMediaOverlayId: TrainingCenterBundleItemVideoMediaOverlayId;
    /** @enum {string} */
    TrainingCenterBundleItemVideoMediaOverlayPosition:
      | "BOTTOM"
      | "CENTER"
      | "TOP";
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterBundleItemVideoMediaOverlayData"];
    };
    TrainingCenterBundleItemVideoMediaOverlayData: {
      title?: string;
      description?: string;
      imageUrl?: string;
      imageFileKey?: string;
      /** @enum {string} */
      imageType?: "FILE" | "LOGO";
      imageWidth?: number;
    };
    TrainingCenterBundleItemLiveInfo: {
      startDateTime: components["schemas"]["Instant"];
      endDateTime: components["schemas"]["Instant"];
    };
    "TrainingCenterTranslated<TrainingCenterVideoInfo>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterVideoInfo"];
    };
    TrainingCenterVideoInfo: {
      videoUrl: string;
      thumbnailUrl: string;
      videoLengthSeconds: number;
      videoDimensions: components["schemas"]["TrainingCenterVideoDimensions"];
    };
    TrainingCenterVideoDimensions: {
      width: null | number;
      height: null | number;
    };
    "TrainingCenterTranslated<TrainingCenterVideoSubtitles>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterVideoSubtitles"];
    };
    TrainingCenterVideoSubtitles: {
      subtitlesUrl: string;
    };
    "TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterCaregiverVideoWatchData"];
    };
    TrainingCenterCaregiverVideoWatchData: {
      totalSecondsWatched: number;
      /** @description Array of segments that were watched: `[startSecond, endSecond]` */
      watchedSegments: [number, number][];
    };
    "TrainingCenterBundleItemMedia.PDF": {
      /** @enum {string} */
      type: "PDF";
      requiredViewTimeMinutes: number;
      pdfFileDownloadable: boolean;
      pdfInfo: components["schemas"]["TrainingCenterTranslated<TrainingCenterPDFInfo>"][];
      pdfWatchData: components["schemas"]["TrainingCenterCaregiverPDFWatchData"];
    };
    "TrainingCenterTranslated<TrainingCenterPDFInfo>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterPDFInfo"];
    };
    TrainingCenterPDFInfo: {
      pdfUrl: string;
    };
    TrainingCenterCaregiverPDFWatchData: {
      totalSecondsWatched: number;
    };
    "TrainingCenterBundleItemMedia.TestOnly": {
      /** @enum {string} */
      type: "TestOnly";
    };
    TrainingCenterTestParams: {
      versionNum: number;
      /** @description How many wrong answers are allowed to still pass the test */
      maxWrongAnswers: number;
      /**
       * @description If the caregiver failed the test, should we show her which answers she
       * got wrong?
       */
      showWrongAnswers: boolean;
      /** @description How many total attempts are allowed for this test? */
      testMaxAttemptsAllowed: number;
    };
    "TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterBundleItemDisplayData"];
    };
    TrainingCenterBundleItemDisplayData: {
      title: null | string;
      label: null | string;
      description: null | string;
      sectionHeader: null | string;
      sectionDescription: null | string;
      testSuccessMessage: null | string;
      testFailMessage: null | string;
      testRetryMessage: null | string;
      thumbnailUrl: null | string;
    };
    TrainingCenterCaregiverTestQuestion: {
      questionId: components["schemas"]["TrainingCenterBundleItemTestQuestionId"];
      displayData: components["schemas"]["TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>"][];
      /**
       * @description The currently selected answer, or the submitted answer from the last
       * submitted test
       */
      markedAnswer: null | number;
      /**
       * @description The marked answer is known to be the correct answer (its value is 0 and
       * was submitted as a test)
       */
      markedAnswerCorrect: boolean;
      /**
       * @description Submitted answers that were incorrect (from all previous test
       * submissions)
       */
      incorrectlyGuessedAnswers: number[];
    };
    /** Format: TrainingCenterBundleItemTestQuestionId */
    TrainingCenterBundleItemTestQuestionId: TrainingCenterBundleItemTestQuestionId;
    "TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterTestQuestionDisplayData"];
    };
    TrainingCenterTestQuestionDisplayData: {
      questionText: string;
      /** @description The first answer is always the correct answer */
      questionAnswers: string[];
    };
    TrainingCenterBundleItemFullDescription: {
      /** Format: TrainingCenterBundleItemFullDescriptionId */
      itemId?: TrainingCenterBundleItemFullDescriptionId;
      order: number;
      fullDescriptionData: components["schemas"]["TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>"][];
    };
    "TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>": {
      language: components["schemas"]["TrainingCenterDisplayLanguage"];
      data: components["schemas"]["TrainingCenterBundleItemFullDescriptionData"];
    };
    TrainingCenterBundleItemFullDescriptionData: {
      title?: string;
      subtitle?: string;
      text?: string;
      imageUrl?: string;
      imageDescription?: string;
      imageFileKey?: string;
      speechFiles: {
        titleSpeechAudioFileUrl?: string;
        titleSpeechMarksFileUrl?: string;
        subtitleSpeechAudioFileUrl?: string;
        subtitleSpeechMarksFileUrl?: string;
        textSpeechAudioFileUrl?: string;
        textSpeechMarksFileUrl?: string;
      };
    };
    "TrainingCenterCaregiverSubmitTestResult.NotFound": {
      /** @enum {string} */
      type: "NotFound";
    };
    "TrainingCenterCaregiverSubmitTestResult.BundleNotVisibleToCaregiver": {
      /** @enum {string} */
      type: "BundleNotVisibleToCaregiver";
    };
    "TrainingCenterCaregiverSubmitTestResult.OutdatedTestVersion": {
      /** @enum {string} */
      type: "OutdatedTestVersion";
      submittedTestVersionNum: number;
      currentTestVersionNum: number;
    };
    "TrainingCenterCaregiverSubmitTestResult.AlreadyCompletedBundleItem": {
      /** @enum {string} */
      type: "AlreadyCompletedBundleItem";
    };
    "TrainingCenterCaregiverSubmitTestResult.ExemptFromBundleItem": {
      /** @enum {string} */
      type: "ExemptFromBundleItem";
    };
    "TrainingCenterCaregiverSubmitTestResult.TooManyFailedAttempts": {
      /** @enum {string} */
      type: "TooManyFailedAttempts";
    };
    "TrainingCenterCaregiverSubmitTestResult.TestNotUnlocked": {
      /** @enum {string} */
      type: "TestNotUnlocked";
    };
    "TrainingCenterCaregiverSubmitTestResult.QuestionAnswersInvalid": {
      /** @enum {string} */
      type: "QuestionAnswersInvalid";
    };
    "TrainingCenterCaregiverSubmitTestResult.Success": {
      /** @enum {string} */
      type: "Success";
      passedTest: boolean;
      bundle: components["schemas"]["TrainingCenterCaregiverBundle"];
    };
    TrainingCenterCaregiverQuestionAnswer: {
      questionId: components["schemas"]["TrainingCenterBundleItemTestQuestionId"];
      answer: number;
    };
    VisitInstanceBillingWithBroadcast: {
      visitBatchType: components["schemas"]["VisitBatchType"];
      visitBatchMinStartDate: components["schemas"]["LocalDate"];
      visitBatchMaxEndDate: components["schemas"]["LocalDate"];
      visitBroadcast: {
        visitBroadcastId: components["schemas"]["VisitBroadcastId"];
        startDateTime: components["schemas"]["LocalDateTime"];
        type: components["schemas"]["VisitBroadcastType"];
        requests: number;
      } | null;
      isOnWeeklyTemplate: boolean;
      pendingConfirmationUntil: components["schemas"]["Instant"] | null;
      visit: components["schemas"]["VisitInstanceCalendarExtended"];
      visitDate: components["schemas"]["LocalDate"];
      billedSeconds: number;
      isPaid: boolean;
      paidSeconds: number;
      draftPaidSeconds: number;
      outdatedBilledAmount: boolean;
      missingAuth: boolean;
      certification: components["schemas"]["CaregiverCertification"] | null;
      ptoStatus: ("APPROVED" | "DECLINED" | "PENDING") | null;
      isTask: boolean;
      isTaskRemoved: boolean;
      taskDetails: {
        taskName: string;
        taskType: null | string;
      } | null;
      patientConfirmedSchedule: null | boolean;
      issue_has_patient_overlap_issue?: null | string;
      issue_has_caregiver_overlap_issue?: null | string;
      issue_overbilled_day?: null | string;
      issue_missing_dx_codes?: null | string;
      issue_no_billing_rate?: null | string;
      issue_no_billing_rate_county?: null | string;
      issue_daily_minimum_hours_not_met?: null | string;
      issue_missing_clock_times?: null | string;
      issue_missed_visit_no_travel_time?: null | string;
      issue_clockin_time_mismatch?: null | string;
      issue_clockout_time_mismatch?: null | string;
      issue_calendar_day_mismatch?: null | string;
      issue_no_caregiver?: null | string;
      issue_invalid_authorization_assignment?: null | string;
      issue_missing_authorization_hours?: null | string;
      issue_missing_matching_mutual_visit?: null | string;
      issue_zero_billing_units?: null | string;
      issue_authorization_over_allocation?: null | string;
      issue_schedule_auth_allocation_conflict?: null | string;
      issue_no_matching_authorization?: null | string;
      issue_unapproved_manual_clock_time_edit?: null | string;
      issue_caregiver_incompliant?: null | string;
      issue_insufficient_visit_duties?: null | string;
      issue_missing_personal_care_duty?: null | string;
      issue_excessive_clock_distance?: null | string;
      ids_on_same_day_with_issues?: null | string;
      parentSplitVisitInstanceId:
        | components["schemas"]["VisitInstanceId"]
        | null;
      childSplitVisitInstanceId:
        | components["schemas"]["VisitInstanceId"]
        | null;
      effectiveIssuesSettings:
        | components["schemas"]["VisitEffectiveIssuesSettings"]
        | null;
      /**
       * @description Duties this visit was required to perform, clocked out without, and that
       * nobody has made up on another visit yet.
       *
       * Empty for every visit that is not clocked out, and for every visit whose
       * misses have all been reassigned — which is what clears the calendar badge.
       *
       * On `VisitInstanceWithBillingData` rather than only the patient response, so
       * the caregiver calendar gets it from the same field when it wants it.
       */
      missedDuties: components["schemas"]["VisitInstanceMissedDutySummary"][];
    };
    /** @enum {string} */
    VisitBatchType: "PERMANENT" | "SINGLE";
    /** @enum {string} */
    VisitBroadcastType: "PATTERN" | "SINGLES";
    VisitInstanceCalendarExtended: {
      patientDisplayName: null | string;
      /**
       * @description Denormalised beside patientName. Optional because only the endpoints whose
       * tables show the display id populate it.
       */
      patientDisplayId: null | number;
      patientStatus: null | string;
      caregiverDisplayName: null | string;
      caregiverDisplayId: null | number;
      caregiverStatus: null | string;
      caregiverPhotoUrl: null | string;
      patientName: string;
      /**
       * @description The caregiver's display fields, denormalised onto the visit alongside
       * patientName / contractName / officeName. Null when the visit has no
       * caregiver assigned - which is itself one of the issues reported here.
       */
      caregiverName?: null | string;
      caregiverCode?: null | string;
      contractId: components["schemas"]["ContractTypeId"];
      contractName: string;
      officeName: string;
      officeId: components["schemas"]["OfficeId"];
      patientAssignedCoordinator: null | string;
      patientAgencyTeam: null | string;
      timelyFilingLimitDaysLeft: number;
      originalDaysFilingLimit: number;
      patientExternalId?: null | string;
      patientAdmissionId?: null | string;
      patientSSN?: null | string;
      patientMedicareNumber?: null | string;
      patientMedicaidNumber?: null | string;
      patientAddress?: null | string;
      patientGender?: null | string;
      missedVisitNote: components["schemas"]["Note"] | null;
      id: components["schemas"]["VisitInstanceId"];
      agencyId: components["schemas"]["AgencyId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      masterWeekId: components["schemas"]["MasterWeekId"] | null;
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      clockinUpdatedBy: components["schemas"]["UserId"] | null;
      clockoutUpdatedBy: components["schemas"]["UserId"] | null;
      clockinUpdatedAt: components["schemas"]["Instant"] | null;
      clockoutUpdatedAt: components["schemas"]["Instant"] | null;
      clockinTime: components["schemas"]["LocalDateTime"] | null;
      clockoutTime: components["schemas"]["LocalDateTime"] | null;
      clockinLocation: components["schemas"]["Geo"] | null;
      clockoutLocation: components["schemas"]["Geo"] | null;
      clockinType: null | string;
      clockoutType: null | string;
      patientContractId: components["schemas"]["PatientContractId"] | null;
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      missedVisit: boolean;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddress"];
      address2: null | string;
      addressInstructions: null | string;
      removedAt: components["schemas"]["Instant"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
      isVisitDateOnDayBefore: boolean;
      external_id?: null | string;
      travelTimeSeconds: number;
      billingAdjustmentSeconds: null | number;
      manualClockTimeEditApproved: boolean;
      clockDistanceApproved: boolean;
      visitBatchId: components["schemas"]["VisitBatchId"];
      removedVisitNoteId: components["schemas"]["NoteId"] | null;
      manualHoldInvoicing: boolean;
      manualHoldInvoicingNotes: null | string;
      missedVisitNoteId: components["schemas"]["NoteId"] | null;
      isTask: boolean;
    };
    VisitEffectiveIssuesSettings: {
      billing_issue_no_caregiver: boolean;
      billing_issue_clockin_time_mismatch: boolean;
      billing_issue_clockout_time_mismatch: boolean;
      billing_issue_calendar_day_mismatch: boolean;
      billing_issue_daily_minimum_hours_not_met: boolean;
      billing_issue_has_patient_overlap_issue: boolean;
      billing_issue_has_caregiver_overlap_issue: boolean;
      billing_issue_overbilled_day: boolean;
      billing_issue_missing_dx_codes: boolean;
      billing_issue_missed_visit_no_travel_time: boolean;
      billing_issue_no_billing_rate: boolean;
      billing_issue_no_billing_rate_county: boolean;
      billing_issue_missing_clock_times: boolean;
      billing_issue_invalid_authorization_assignment: boolean;
      billing_issue_missing_authorization_hours: boolean;
      billing_issue_missing_matching_mutual_visit: boolean;
      billing_issue_zero_billing_units: boolean;
      billing_issue_authorization_over_allocation: boolean;
      billing_issue_schedule_auth_allocation_conflict: boolean;
      billing_issue_no_matching_authorization: boolean;
      billing_issue_unapproved_manual_clock_time_edit: boolean;
      billing_issue_caregiver_incompliant: boolean;
      billing_issue_insufficient_visit_duties: boolean;
      billing_issue_missing_personal_care_duty: boolean;
      billing_issue_excessive_clock_distance: boolean;
      billing_issue_manual_hold_invoicing: boolean;
      billing_issue_zero_dollar_pay_rate: boolean;
      billing_issue_missing_caregiver_ssn: boolean;
      billing_issue_missing_patient_member_id: boolean;
      billing_issue_missing_address: boolean;
      payroll_issue_no_caregiver: boolean;
      payroll_issue_clockin_time_mismatch: boolean;
      payroll_issue_clockout_time_mismatch: boolean;
      payroll_issue_calendar_day_mismatch: boolean;
      payroll_issue_daily_minimum_hours_not_met: boolean;
      payroll_issue_has_patient_overlap_issue: boolean;
      payroll_issue_has_caregiver_overlap_issue: boolean;
      payroll_issue_overbilled_day: boolean;
      payroll_issue_missing_dx_codes: boolean;
      payroll_issue_missed_visit_no_travel_time: boolean;
      payroll_issue_no_billing_rate: boolean;
      payroll_issue_no_billing_rate_county: boolean;
      payroll_issue_missing_clock_times: boolean;
      payroll_issue_invalid_authorization_assignment: boolean;
      payroll_issue_missing_authorization_hours: boolean;
      payroll_issue_missing_matching_mutual_visit: boolean;
      payroll_issue_zero_billing_units: boolean;
      payroll_issue_authorization_over_allocation: boolean;
      payroll_issue_schedule_auth_allocation_conflict: boolean;
      payroll_issue_no_matching_authorization: boolean;
      payroll_issue_unapproved_manual_clock_time_edit: boolean;
      payroll_issue_caregiver_incompliant: boolean;
      payroll_issue_insufficient_visit_duties: boolean;
      payroll_issue_missing_personal_care_duty: boolean;
      payroll_issue_excessive_clock_distance: boolean;
      payroll_issue_manual_hold_invoicing: boolean;
      payroll_issue_zero_dollar_pay_rate: boolean;
    };
    VisitInstanceMissedDutySummary: {
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      code: string;
      label: string;
    };
    CalendarNote: {
      id: components["schemas"]["NoteId"];
      calendarDate: components["schemas"]["LocalDate"] | null;
      text: null | string;
    };
    CaregiverPtoInstances: {
      caregiverPtos: components["schemas"]["CaregiverPtoInstance"][];
    };
    CaregiverPtoInstance: {
      id: components["schemas"]["CaregiverPtoInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverName: null | string;
      caregiverDisplayId: null | number;
      caregiverHireDate: components["schemas"]["LocalDate"] | null;
      duration: number;
      visitInstance: components["schemas"]["VisitInstance"];
      labelId: components["schemas"]["CaregiverPtoLabelId"];
      status: components["schemas"]["CaregiverPtoInstanceStatus"];
      pastPtoStatus?: components["schemas"]["CaregiverPtoStatus"];
      notesAmount: number;
      originalVisitMinutes: number;
      approvedBy: null | string;
      payrollBatchDetails: components["schemas"]["PayrollBatchDetails"] | null;
      paidSeconds: null | number;
    };
    /** @enum {string} */
    CaregiverPtoInstanceStatus: "APPROVED" | "DECLINED" | "PENDING";
    CaregiverPtoStatus: {
      label: components["schemas"]["CaregiverPtoLabelId"];
      labelText: string;
      isLabelActive: boolean;
      ptoSettingType: components["schemas"]["CaregiverPtoSettingType"];
      currentYearMinutesUsage: number;
      currentYearMinutesPotential: number;
      totalMinutesUsage: number;
      totalMinutesPotential: number;
    };
    PayrollBatchDetails: {
      id: components["schemas"]["PayrollBatchId"];
      displayId: string;
      date: components["schemas"]["LocalDate"];
      isDraft: boolean;
    };
    CaregiverAbsence: {
      id: components["schemas"]["CaregiverAbsenceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      agencyId: components["schemas"]["AgencyId"];
      date: components["schemas"]["LocalDate"];
      noteRichText?: null | string;
      notePredefiendAnswerText: null | string;
    };
    /** Format: CaregiverAbsenceId */
    CaregiverAbsenceId: CaregiverAbsenceId;
    ClockedVisitInstance: {
      id: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"];
      clockinTime: components["schemas"]["LocalDateTime"] | null;
      clockoutTime: components["schemas"]["LocalDateTime"] | null;
      clockinLocation: components["schemas"]["Geo"] | null;
      clockoutLocation: components["schemas"]["Geo"] | null;
      clockinType: null | string;
      clockoutType: null | string;
      patientFullName: string;
      caregiverFullName: string;
      caregiverDisplayId: null | number;
      patientDisplayId: null | number;
      patientContractId: components["schemas"]["PatientContractId"] | null;
      patientContractType: components["schemas"]["ContractTypeId"] | null;
      patientAgencyTeam: components["schemas"]["AgencyTeamId"] | null;
      caregiverBranches: components["schemas"]["AgencyBranchId"][] | null;
      caregiverCertifications: components["schemas"]["CaregiverCertification"][];
      officeId: components["schemas"]["OfficeId"];
      assignedCoordinator: components["schemas"]["AgencyMemberId"] | null;
      patientAddress: components["schemas"]["AddressComponents"] | null;
      filingLimitDays: number;
      filingLimitDaysLeft: number;
      contractName: null | string;
      contractEvvAggregator:
        | (
            | "Emedny"
            | "HHAExchange - API"
            | "HHAExchange - SFTP"
            | "Sandata"
            | "Tellus"
          )
        | null;
      evvSubmissionDetails:
        | components["schemas"]["EvvSubmissionDetails.EmedNy"]
        | components["schemas"]["EvvSubmissionDetails.Tellus"]
        | components["schemas"]["EvvSubmissionDetails.Sandata"]
        | components["schemas"]["EvvSubmissionDetails.HHAExchange"]
        | null;
      clockInSelfieStatus: components["schemas"]["VisitInstanceSelfieResult"];
      clockOutSelfieStatus: components["schemas"]["VisitInstanceSelfieResult"];
    };
    "EvvSubmissionDetails.EmedNy": {
      /** @enum {string} */
      type: "EmedNy";
      submitted: boolean;
      transactionId: components["schemas"]["UUID"];
      processedAt: components["schemas"]["Instant"] | null;
      errorType: ("EMEDNY_API_ERROR" | "VALIDATION") | null;
      errors: string[] | null;
    };
    /** @description To generate a UUID, use the function uuid_generate_v4() (from "Data/UUID.ts") */
    UUID: string;
    "EvvSubmissionDetails.Tellus": {
      /** @enum {string} */
      type: "Tellus";
      submitted: boolean;
      sentAt: components["schemas"]["Instant"];
      errors: string[] | null;
      errorType: ("TELLUS_API_REJECT" | "VALIDATION") | null;
    };
    "EvvSubmissionDetails.Sandata": {
      visitInsatnceId: components["schemas"]["VisitInstanceId"];
      /** @enum {string} */
      type: "Sandata";
      submittedAt: components["schemas"]["Instant"] | null;
      completed: boolean;
      errors?: string[];
    };
    "EvvSubmissionDetails.HHAExchange": {
      /** @enum {string} */
      type: "HHAExchange";
      submitted: boolean;
      sentAt: components["schemas"]["Instant"] | null;
      errorType: ("HHAX_REJECTION" | "VALIDATION") | null;
      errors: string[] | null;
      transactionId: null | string;
    };
    VisitInstanceSelfieResult:
      | components["schemas"]["VisitInstanceSelfieResult.Required"]
      | components["schemas"]["VisitInstanceSelfieResult.NotRequired"];
    "VisitInstanceSelfieResult.Required": {
      /** @enum {string} */
      type: "Required";
      clockType: components["schemas"]["ClocksType"];
      result:
        | ("BELOW_THRESHOLD" | "ERROR" | "INVALID" | "SMALL_IMAGE" | "VALID")
        | null;
      percentage: null | number;
      error: null | string;
      s3Key: null | string;
    };
    "VisitInstanceSelfieResult.NotRequired": {
      /** @enum {string} */
      type: "NotRequired";
    };
    VisitInstanceOverlappingValidation: {
      /** Format: VisitInstanceId */
      id?: VisitInstanceId;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      missedVisit: boolean;
      removedAt: components["schemas"]["Instant"] | null;
    };
    EditVisitsInstancesError: {
      permissions: components["schemas"]["AgencyMemberPermission"][];
      visits: components["schemas"]["VisitInstanceWithLocalDateTime"][];
    };
    VisitInstanceWithLocalDateTime: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      date: components["schemas"]["LocalDateTime"];
    };
    VisitInstanceEditParams: {
      /** Format: yyyy-MM-ddTHH:mm:ss.SSS */
      startTime?: LocalDateTime;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSS */
      endTime?: LocalDateTime;
      /** Format: PatientId */
      patientId?: PatientId;
      /** Format: OfficeId */
      officeId?: OfficeId;
      caregiverId?: components["schemas"]["CaregiverId"] | null;
      clockinTime?: components["schemas"]["LocalDateTime"] | null;
      clockoutTime?: components["schemas"]["LocalDateTime"] | null;
      clockinLocation?: components["schemas"]["Geo"] | null;
      clockoutLocation?: components["schemas"]["Geo"] | null;
      clockinType?: null | string;
      clockoutType?: null | string;
      /** Format: PatientContractId */
      patientContractId?: PatientContractId;
      /** Format: ServiceCodeId */
      serviceCodeId?: ServiceCodeId;
      payrollCodeId?: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds?: null | number;
      missedVisit?: boolean;
      billable?: boolean;
      removedAt?: components["schemas"]["Instant"] | null;
      isOnPreviousDay?: boolean;
      travelTimeSeconds?: number;
      billingAdjustmentSeconds?: number;
      manuallyRemoved?: boolean;
      manualClockTimeEditApproved?: boolean;
      manualClockNote?: components["schemas"]["AgencyNoteCreateParams"];
      manualClockApprovedDutyIds?: components["schemas"]["PlanOfCareItemId"][];
      address?: components["schemas"]["VisitInstanceAddress"];
      address2?: null | string;
      addressInstructions?: null | string;
      clockDistanceApproved?: boolean;
      distanceApprovalNote?: components["schemas"]["AgencyNoteCreateParams"];
      externalId?: null | string;
      manualDeleteVisitNote?:
        | components["schemas"]["AgencyNoteEditParams"]
        | null;
      missedVisitNote?: components["schemas"]["AgencyNoteEditParams"] | null;
      manualHoldInvoicing?: boolean;
      manualHoldInvoicingNotes?: null | string;
      approvalNote?: components["schemas"]["AgencyNoteEditParams"] | null;
      editNote?: components["schemas"]["AgencyNoteCreateParams"];
      shouldUnlinkClockIn?: boolean;
      shouldUnlinkClockOut?: boolean;
      shouldSkipVisitsWithMissingPermission?: boolean;
      showOnCalendarWhenDeleted?: boolean;
      caregiverUnassignedNote?: components["schemas"]["AgencyNoteCreateParams"];
      /**
       * @description I initially used shouldSkipVisitsWithMissingPermission but it doesn't answer my needs since
       * still it checks if the user has permission to edit visit instance. In my case, an HR can't
       * set a caregiver to inactive since it will unassign caregiver from future visits, why this
       * role is unauthorized to "edit" the visit instance. Setting this property to true will bypass
       * any insufficient permissions to edit the visit instance. Use it carefully.
       */
      shouldSkipAllVisitPermissions?: boolean;
      isTask?: boolean;
      patientConfirmedSchedule?: boolean;
      confirmationType?:
        | (
            | "Automation - SMS"
            | "Automation - bot agent"
            | "Automation - robocall"
            | "Caregiver"
            | "Manual"
            | "Nurse call"
          )
        | null;
      confirmedBy?: components["schemas"]["UserId"] | null;
      confirmedByType?: ("AGENCY_MEMBER" | "CAREGIVER" | "PATIENT") | null;
    };
    VisitInstaceModalVisitInfo: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      clockIn: components["schemas"]["LocalDateTime"] | null;
      clockOut: components["schemas"]["LocalDateTime"] | null;
      clockInMethod: null | string;
      clockOutMethod: null | string;
      clockInLocation: components["schemas"]["Geo"] | null;
      clockOutLocation: components["schemas"]["Geo"] | null;
      clockInLocationType: null | string;
      clockOutLocationType: null | string;
      clockInUpdatedByUserType: ("AGENCY_MEMBER" | "CAREGIVER") | null;
      clockOutUpdatedByUserType: ("AGENCY_MEMBER" | "CAREGIVER") | null;
      clockInIVRSourcePhoneNumber: null | string;
      clockOutIVRSourcePhoneNumber: null | string;
      officeId: components["schemas"]["OfficeId"];
      missedVisit: boolean;
      countyName: string;
      isVisitDateOnDayBefore: boolean;
      travelTimeSeconds: number;
      removedAt: components["schemas"]["Instant"] | null;
      manualClockTimeEditApproved: boolean;
      manualClockChanges: components["schemas"]["ManualClockChange"][];
      addressComponents: components["schemas"]["AddressComponents"] | null;
      address: components["schemas"]["VisitInstanceAddress"];
      address2: null | string;
      addressInstructions: null | string;
      clockDistanceApproved: boolean;
      clockDistanceApprovalChanges: components["schemas"]["ClockDistanceApprovalChange"][];
      missedVisitNote: components["schemas"]["Note"] | null;
      manualRemovedVisitNote: components["schemas"]["Note"] | null;
      manualHoldInvoicing: boolean;
      manualHoldInvoicingNotes: null | string;
      certifications: components["schemas"]["CaregiverCertification"][];
      timesheetId: components["schemas"]["TimesheetId"] | null;
      timesheetStatus: ("APPROVED" | "DECLINED" | "PENDING") | null;
      visitInfo: string[] | null;
      patientNotSignReason: null | string;
      caregiverConfirmedAt: components["schemas"]["Instant"] | null;
      instapayRulesExemption?: boolean;
      patientConfirmedSchedule: null | boolean;
      confirmationType:
        | (
            | "Automation - SMS"
            | "Automation - bot agent"
            | "Automation - robocall"
            | "Caregiver"
            | "Manual"
            | "Nurse call"
          )
        | null;
      confirmedBy: null | string;
      isTask: boolean;
    };
    ManualClockChange: {
      predefinedAnswerId:
        | components["schemas"]["NotePredefinedAnswerId"]
        | null;
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      message: null | string;
      clockinTime?: components["schemas"]["LocalDateTime"] | null;
      clockoutTime?: components["schemas"]["LocalDateTime"] | null;
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
      duties: components["schemas"]["ManualClockChangeDuty"][];
    };
    ManualClockChangeDuty: {
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      label: string;
      code: string;
    };
    ClockDistanceApprovalChange: {
      predefinedAnswerId:
        | components["schemas"]["NotePredefinedAnswerId"]
        | null;
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      clockinLocation: components["schemas"]["Geo"] | null;
      clockoutLocation: components["schemas"]["Geo"] | null;
      message: null | string;
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
    };
    VisitInstanceModalCaregiverPlanOfCareVersionDuties: {
      caregiverDuties: components["schemas"]["VisitInstanceModalCaregiverDuty"][];
      planOfCareId: components["schemas"]["PlanOfCareId"] | null;
    };
    VisitInstanceModalCaregiverDuty: {
      sectionTitle: string;
      items: {
        code: string;
        title: string;
        /**
         * @description Which occurrence of the duty on this visit the row is.
         *
         * A duty may be owed and answered more than once on one visit, so this
         * section lists one row per occurrence and a row is addressed by
         * (`planOfCareItemId`, `occurrenceIndex`), not by the duty alone. A duty
         * with nothing recorded yet is one row, occurrence 1.
         */
        occurrenceIndex: number;
        notes: null | string;
        type: ("COORDINATOR" | "IVR" | "MOBILE" | "TIME_SHEET") | null;
        planOfCareItemId: components["schemas"]["PlanOfCareItemId"] | null;
        date: components["schemas"]["Instant"] | null;
        completed: boolean;
        /**
         * @description Why the caregiver reported the duty as not performed, when they said so.
         *
         * Null covers both a duty nobody reported on and one reported as done —
         * "not completed" and "never mentioned" look the same in this section, so
         * the reason is the only thing this field adds.
         */
        notPerformedReason: null | string;
        /**
         * @description The plan-of-care duty row, not just its catalogue item. Reassignment is
         * keyed on it, so the modal needs it to offer the action.
         */
        planOfCareDutyId: components["schemas"]["PlanOfCareDutyId"] | null;
        /**
         * @description Whether this visit still had to perform the duty — the shared rule, so
         * an as-needed duty and one the day's other visits already covered are not
         * reported as owed.
         */
        isRequired: boolean;
        /**
         * @description How many occurrences this visit is asked for today, day budget plus
         * whatever was made up onto it. Additive: a make-up handed AWAY from this
         * visit does not reduce this number — see `madeUpOnVisitInstanceId`
         * below for that half of the story.
         */
        owedOccurrences: number;
        /** @description How many occurrences this visit has recorded, of `owedOccurrences`. */
        performedOccurrences: number;
        /**
         * @description Whether THIS occurrence is still required on this visit, not recorded,
         * and not made up anywhere -- so a coordinator may still hand it to another
         * visit in the week. This is what puts the Reassign action on the row.
         *
         * Per occurrence rather than per duty: of a duty owed twice with one
         * occurrence performed, only the other row has anything to hand away.
         *
         * Not "missed": it is true of a visit that has not been clocked into and of
         * one that has not happened yet, neither of which has missed anything. The
         * patient calendar's missed-duty badge asks the narrower question.
         */
        canBeMadeUp: boolean;
        /**
         * @description The visit THIS occurrence was made up on, or null when it was not handed
         * away. The row's undo retracts that one make-up and no other.
         *
         * A make-up records how many occurrences it moved, not which, so the server
         * chooses the rows -- see `allocateDutyOccurrenceMakeUps`.
         */
        madeUpOnVisitInstanceId:
          | components["schemas"]["VisitInstanceId"]
          | null;
        /**
         * @description Whether THIS occurrence was made up onto this visit from another one.
         * False on every row the plan itself put on this day. Chosen the same way
         * as `madeUpOnVisitInstanceId`.
         */
        isMadeUpFromAnotherVisit: boolean;
        /** @description When the occurrence was performed, visit-local; null when not recorded. */
        startTime: components["schemas"]["LocalDateTime"] | null;
        endTime: components["schemas"]["LocalDateTime"] | null;
      }[];
    };
    VisitInstanceNote: {
      id: components["schemas"]["NoteId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      text: null | string;
      predefinedAnswerId:
        | components["schemas"]["NotePredefinedAnswerId"]
        | null;
      predefinedAnswerText: null | string;
    };
    ClockinClockoutRecordPossibilityByVisitInstance: {
      id: components["schemas"]["ClockinClockoutRecordId"];
      visitPatientId: components["schemas"]["PatientId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      /** @enum {string} */
      callType: "IN" | "OUT";
      clockOffsetInHours: number;
      wasCallMadeFromThePatient: boolean;
      sourcePhone: null | string;
      createdAt: components["schemas"]["Instant"];
      clockTime: components["schemas"]["Instant"];
      reason:
        | (
            | "BLOCKED_CALLER_ID"
            | "CALL_FROM_CAREGIVER_PHONE"
            | "CLOCK_IN_AFTER_CLOCK_OUT"
            | "CLOCK_OUTSIDE_OF_RANGE"
            | "CLOCK_OUT_TOO_SOON"
            | "DUPLICATE_CALL"
            | "MISSING_CAREGIVER"
            | "MISSING_PATIENT"
            | "MISSING_VISIT"
            | "PHONE_WITHOUT_EVV_LOCATION"
            | "UNLINKED_MANUALLY"
          )
        | null;
      caregiver: {
        id: components["schemas"]["CaregiverId"];
        fullName: string;
      };
    };
    VisitInstanceFlattenedData: {
      id: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
    };
    VisitEngagementsDetailsWithInstances: {
      /** @enum {string} */
      type: "VisitEngagementsDetailsWithInstances";
      /**
       * @description The caregivers named by the id lists below, so the broadcast modal can
       * label, picture and place them without a dictionary of every caregiver.
       */
      caregivers: components["schemas"]["CaregiverRowDisplay"][];
      calledAgency: components["schemas"]["CaregiverId"][];
      previewedBy: components["schemas"]["CaregiverId"][];
      moreDetailsViewedBy: {
        caregiverId: components["schemas"]["CaregiverId"];
        rejectedReason: null | string;
      }[];
      acceptedBy: components["schemas"]["VisitEngagementAcceptedByInstances"][];
      pendingConfirmationTo: components["schemas"]["VisitEngagementPendingConfirmationTo"][];
      ignoredRequestsByAgencyMember: {
        caregiverId: components["schemas"]["CaregiverId"];
        ignoredInstances: components["schemas"]["VisitInstanceId"][];
      }[];
    };
    VisitEngagementAcceptedByInstances: {
      requestedInstances: components["schemas"]["VisitInstanceId"][];
      caregiverId: components["schemas"]["CaregiverId"];
    };
    FlexibleVisitEngagementDetails: {
      /** @enum {string} */
      type: "FlexibleVisitEngagementDetails";
      /**
       * @description The caregivers named by the id lists below, so the broadcast modal can
       * label, picture and place them without a dictionary of every caregiver.
       */
      caregivers: components["schemas"]["CaregiverRowDisplay"][];
      calledAgency: components["schemas"]["CaregiverId"][];
      previewedBy: components["schemas"]["CaregiverId"][];
      moreDetailsViewedBy: {
        caregiverId: components["schemas"]["CaregiverId"];
        rejectedReason: null | string;
      }[];
      acceptedBy: components["schemas"]["FlexibleVisitEngagementAccepted"][];
      pendingConfirmationTo: components["schemas"]["FlexibleVisitEngagementPendingConfirmationTo"][];
      ignoredRequestsByAgencyMember: components["schemas"]["CaregiverId"][];
    };
    FlexibleVisitEngagementAccepted: {
      flexibleVisitRequest: components["schemas"]["CaregiverFlexibleVisitRequestParams"][];
      caregiverId: components["schemas"]["CaregiverId"];
    };
    BroadcastedToCaregiver: {
      /**
       * @description The assembled name the dictionary used to add. Included here so the
       * broadcast list and its name filter can use this response directly instead
       * of re-looking every caregiver up.
       */
      displayName: string;
      nearestPatient: {
        geo: components["schemas"]["Geo"];
        distanceInMiles: number;
      } | null;
      id: components["schemas"]["CaregiverId"];
      status: components["schemas"]["CaregiverStatus"];
      caregiverCode: null | string;
      officeIds: components["schemas"]["OfficeId"][];
      officeNames?: string[];
      branchIds: components["schemas"]["AgencyBranchId"][];
      branchNames?: string[];
      caregiverBranch?: null | string;
      workAreaPreference?: null | string;
      createdAt: components["schemas"]["Instant"];
      /** Format: date-time */
      birthDate: null | string;
      birthDateDate: components["schemas"]["LocalDate"] | null;
      phoneNumber: string;
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      homePhone: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      /** @description "M", "F" */
      gender: string;
      /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      address: string;
      address2: null | string;
      isCustomAddress: boolean;
      addressCounty: null | string;
      addressGeoLocation: components["schemas"]["Geo"];
      addressComponents?: components["schemas"]["AddressComponents"] | null;
      missingAddressFields?: string[];
      certifications: components["schemas"]["CaregiverCertification"][];
      certificationNames?: string[];
      agencyAssocCreatedByAgencyMemberName?: null | string;
      agencyAssocCreatedByCaregiverName?: null | string;
      photoUrl: null | string;
      photoUrlOriginal: null | string;
      installedUserAgent: null | string;
      appInstalledDate: components["schemas"]["Instant"] | null;
      appInstalled: boolean;
      appInstalledAt: components["schemas"]["Instant"][];
      appUninstalledAt: components["schemas"]["Instant"][];
      /** @description Is the caregiver's app currently open */
      online: boolean;
      /** @description When was the last time the caregiver was online? */
      lastSeen: components["schemas"]["Instant"] | null;
      notificationSettings?: components["schemas"]["NotificationSettings"];
      email: null | string;
      isFullTime: boolean;
      hireDate: components["schemas"]["LocalDate"] | null;
      rehireDate: components["schemas"]["LocalDate"] | null;
      terminationDate: components["schemas"]["LocalDate"] | null;
      isCompliant: boolean;
      stateRegistryNum: null | number;
      isClockEnabled: boolean;
      ssn: null | string;
      applicationStartDate: components["schemas"]["LocalDate"] | null;
      lastWorkDate: components["schemas"]["LocalDate"] | null;
      firstWorkDate: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      externalId: null | string;
      customFields: components["schemas"]["EntityCustomField"];
      blacklisted: components["schemas"]["PatientId"][] | null;
      emergencyContacts: components["schemas"]["CaregiverEmergencyContact"][];
      nextStatus?:
        | (
            | "ACTIVE"
            | "JOIN_REQUEST"
            | "ON_HOLD"
            | "ON_LEAVE"
            | "PENDING"
            | "QUIT"
            | "REJECTED"
            | "SUSPENDED"
            | "TERMINATED"
          )
        | null;
      nextStatusEffectiveDate?: components["schemas"]["LocalDate"] | null;
      isFromLandingPage: boolean;
      mainLanguage: string;
      glovesSize?: ("L" | "M" | "S" | "XL") | null;
      scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
      agencyIds?: components["schemas"]["AgencyId"][];
    };
    CaregiverWithOvertime: {
      caregiverId: components["schemas"]["CaregiverId"];
      overtime: number;
    };
    CaregiverWithWorkTimeData: {
      caregiverId: components["schemas"]["CaregiverId"];
      workHours: components["schemas"]["CaregiverWorkTimeByWeekData"][];
    };
    CaregiverWorkTimeByWeekData: {
      weekStart: components["schemas"]["LocalDate"];
      weeklyHours: number;
      weeklyOvertimeHoursMark: number;
    };
    /** @description if we move the visit @timeDelta minutes, the chances of assignment will improve in @chancesDifference */
    VisitChangeRecommendation: {
      timeDelta: number;
      chancesDifference: number;
      availableClusterCases: components["schemas"]["ClusterVisitData"][];
      assignedClusterCases: components["schemas"]["AssignedClusterCaseData"][];
    };
    ClusterVisitData: {
      visitId: components["schemas"]["VisitBroadcastId"];
      patientName: string;
      isSingleVisit: boolean;
      dayTimeParams: components["schemas"]["VisitDayTimeParams"] | null;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      address: string;
      geo: components["schemas"]["Geo"];
    };
    AssignedClusterCaseData: {
      caregiverId: components["schemas"]["CaregiverId"];
      case: components["schemas"]["ClusterVisitData"];
    };
    "CaregiverVisitBroadcastTypes.Available": {
      id: components["schemas"]["VisitBroadcastId"];
      /** @enum {string} */
      type: "Available";
      publicVisitBroadcastDetails: components["schemas"]["PublicVisitBroadcastDetails"];
      caregiverVisitEngagementDetails: components["schemas"]["CaregiverVisitBroadcastEngagementDetails"];
    };
    PublicVisitBroadcastDetails:
      | components["schemas"]["PublicVisitBroadcastDetailsTypes.Pattern"]
      | components["schemas"]["PublicVisitBroadcastDetailsTypes.Singles"]
      | components["schemas"]["PublicVisitBroadcastDetailsTypes.FlexiblePattern"];
    "PublicVisitBroadcastDetailsTypes.Pattern": {
      /** @enum {string} */
      type: "Pattern";
      weeklyPattern: components["schemas"]["BroadcastPattern"];
      visitInstances: components["schemas"]["SingleVisitInstanceDetails"][];
      allowMultipleCaregivers: boolean;
      id: components["schemas"]["VisitBroadcastId"];
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["Agency"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      languages: string[];
      generalNotes: string;
      generalNotesTranslations: components["schemas"]["PatientGeneralNotesTranslation"][];
      location: components["schemas"]["AddressComponents"];
      price: null | number;
      payrate: components["schemas"]["CaregiverVisitPayrate"] | null;
      /** @description timezone from the tz database (IANA) */
      timezone: string;
      createdByFirstName: string;
      createdByLastName: string;
      visitLabels: components["schemas"]["VisitLabelText"][];
      patientId: components["schemas"]["PatientId"];
      patientFirstName: string;
      patientInitials: string;
      patientGender: ("F" | "M") | null;
      patientAge: null | number;
      patientIsActive: boolean;
      patientAllergies: components["schemas"]["Allergy"][];
      patientLanguages: string[];
      patientMedicalNotes: null | string;
      createdById: components["schemas"]["AgencyMemberId"];
      certifications: components["schemas"]["CaregiverCertification"][];
      hideEndDateFromCaregiver: boolean;
      staffingPreferences: components["schemas"]["VisitStaffingPreferences"];
      staffingPreferences2: components["schemas"]["VisitStaffingPreferences2"];
      patientAvailability:
        | components["schemas"]["PatientVisitTimeFramesByDay"][]
        | null;
      visitInfo: string[] | null;
      nearLocationDisplay: null | string;
      preferenceMismatchReasons: "days_availability"[];
    };
    BroadcastPattern: {
      excludes: components["schemas"]["VisitDatesParamsExtended"][];
      daysOfWeek: components["schemas"]["VisitBroacastDayOfWeekPattern"];
    };
    VisitDatesParamsExtended: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      startDateTimeUtc: components["schemas"]["Instant"];
      endDateTimeUtc: components["schemas"]["Instant"];
      startLocalDateTime: components["schemas"]["LocalDateTime"];
      /** @description Typo remove in 3 motnhs from this commit */
      endLocalDateime: components["schemas"]["LocalDateTime"];
      endLocalDateTime: components["schemas"]["LocalDateTime"];
    };
    VisitBroacastDayOfWeekPattern: {
      SUNDAY?: {
        startAt: components["schemas"]["LocalTime"];
        endAt: components["schemas"]["LocalTime"];
      }[];
      MONDAY?: {
        startAt: components["schemas"]["LocalTime"];
        endAt: components["schemas"]["LocalTime"];
      }[];
      TUESDAY?: {
        startAt: components["schemas"]["LocalTime"];
        endAt: components["schemas"]["LocalTime"];
      }[];
      WEDNESDAY?: {
        startAt: components["schemas"]["LocalTime"];
        endAt: components["schemas"]["LocalTime"];
      }[];
      THURSDAY?: {
        startAt: components["schemas"]["LocalTime"];
        endAt: components["schemas"]["LocalTime"];
      }[];
      FRIDAY?: {
        startAt: components["schemas"]["LocalTime"];
        endAt: components["schemas"]["LocalTime"];
      }[];
      SATURDAY?: {
        startAt: components["schemas"]["LocalTime"];
        endAt: components["schemas"]["LocalTime"];
      }[];
    };
    SingleVisitInstanceDetails: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      date: components["schemas"]["VisitDatesParams"];
    };
    VisitDatesParams: {
      startDateTime: components["schemas"]["LocalDateTime"];
      endDateTime: components["schemas"]["LocalDateTime"];
    };
    /**
     * @description A single translation of the patient's general notes.
     * Stored as an element of the `patient.general_notes_lng` JSONB array column.
     */
    PatientGeneralNotesTranslation: {
      languageCode: string;
      text: string;
      sourceText: string;
    };
    /**
     * @description The resolved pay rate shown to a caregiver for a visit, gated by
     * office.show_payrates_to_caregivers.
     */
    CaregiverVisitPayrate: {
      /** @description USD, integer cents. "$11.99" equals the value 1199 */
      rate: number;
      type: components["schemas"]["CaregiverVisitPayrateType"];
    };
    /** @enum {string} */
    CaregiverVisitPayrateType: "Daily" | "Hourly" | "Visit";
    VisitStaffingPreferences: {
      smoking: null | boolean;
      bedbound: null | boolean;
      cane: null | boolean;
      wheelchair: null | boolean;
      kosher: null | boolean;
      halal: null | boolean;
      hoyer: null | boolean;
      pets: null | boolean;
    };
    VisitStaffingPreferences2: {
      smoking: null | boolean;
      bedbound: null | boolean;
      cane: null | boolean;
      walker: null | boolean;
      wheelchair: null | boolean;
      kosher: null | boolean;
      halal: null | boolean;
      hoyer: null | boolean;
      pets: null | boolean;
    };
    PatientVisitTimeFramesByDay: {
      day: components["schemas"]["DayOfWeek"];
      timeframes: components["schemas"]["PatientTimeFrames"][];
    };
    PatientTimeFrames: {
      startTime: number;
      endTime: number;
    };
    "PublicVisitBroadcastDetailsTypes.Singles": {
      /** @enum {string} */
      type: "Singles";
      visitInstances: components["schemas"]["SingleVisitInstanceDetails"][];
      allowMultipleCaregivers: boolean;
      id: components["schemas"]["VisitBroadcastId"];
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["Agency"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      languages: string[];
      generalNotes: string;
      generalNotesTranslations: components["schemas"]["PatientGeneralNotesTranslation"][];
      location: components["schemas"]["AddressComponents"];
      price: null | number;
      payrate: components["schemas"]["CaregiverVisitPayrate"] | null;
      /** @description timezone from the tz database (IANA) */
      timezone: string;
      createdByFirstName: string;
      createdByLastName: string;
      visitLabels: components["schemas"]["VisitLabelText"][];
      patientId: components["schemas"]["PatientId"];
      patientFirstName: string;
      patientInitials: string;
      patientGender: ("F" | "M") | null;
      patientAge: null | number;
      patientIsActive: boolean;
      patientAllergies: components["schemas"]["Allergy"][];
      patientLanguages: string[];
      patientMedicalNotes: null | string;
      createdById: components["schemas"]["AgencyMemberId"];
      certifications: components["schemas"]["CaregiverCertification"][];
      hideEndDateFromCaregiver: boolean;
      staffingPreferences: components["schemas"]["VisitStaffingPreferences"];
      staffingPreferences2: components["schemas"]["VisitStaffingPreferences2"];
      patientAvailability:
        | components["schemas"]["PatientVisitTimeFramesByDay"][]
        | null;
      visitInfo: string[] | null;
      nearLocationDisplay: null | string;
      preferenceMismatchReasons: "days_availability"[];
    };
    "PublicVisitBroadcastDetailsTypes.FlexiblePattern": {
      /** @enum {string} */
      type: "FlexiblePattern";
      flexibleVisitParams: components["schemas"]["FlexibleVisitParams"];
      allowMultipleCaregivers: boolean;
      id: components["schemas"]["VisitBroadcastId"];
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["Agency"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      languages: string[];
      generalNotes: string;
      generalNotesTranslations: components["schemas"]["PatientGeneralNotesTranslation"][];
      location: components["schemas"]["AddressComponents"];
      price: null | number;
      payrate: components["schemas"]["CaregiverVisitPayrate"] | null;
      /** @description timezone from the tz database (IANA) */
      timezone: string;
      createdByFirstName: string;
      createdByLastName: string;
      visitLabels: components["schemas"]["VisitLabelText"][];
      patientId: components["schemas"]["PatientId"];
      patientFirstName: string;
      patientInitials: string;
      patientGender: ("F" | "M") | null;
      patientAge: null | number;
      patientIsActive: boolean;
      patientAllergies: components["schemas"]["Allergy"][];
      patientLanguages: string[];
      patientMedicalNotes: null | string;
      createdById: components["schemas"]["AgencyMemberId"];
      certifications: components["schemas"]["CaregiverCertification"][];
      hideEndDateFromCaregiver: boolean;
      staffingPreferences: components["schemas"]["VisitStaffingPreferences"];
      staffingPreferences2: components["schemas"]["VisitStaffingPreferences2"];
      patientAvailability:
        | components["schemas"]["PatientVisitTimeFramesByDay"][]
        | null;
      visitInfo: string[] | null;
      nearLocationDisplay: null | string;
      preferenceMismatchReasons: "days_availability"[];
    };
    FlexibleVisitParams:
      | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
      | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
      | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
      | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
      | components["schemas"]["PermanentFixedHoursFlexibleDays"]
      | components["schemas"]["SingleFlexible"];
    CaregiverVisitBroadcastEngagementDetails: {
      /** @description Has the caregiver viewed this visit yet (or is it new) */
      viewed: boolean;
      /**
       * @description Has the caregiver requested this visit
       * Remove after multishift change and all the caregivers updated the mobile app
       */
      requested?: boolean;
      moreDetailsViewed: boolean;
      flexibleVisitTimeRequest:
        | components["schemas"]["CaregiverFlexibleVisitRequestParams"][]
        | null;
      /** @description For multishift change. */
      requestedInstances: components["schemas"]["VisitInstanceId"][] | null;
      rejectedInstances: components["schemas"]["VisitInstanceId"][] | null;
      pendingConfirmationInstances:
        | components["schemas"]["CaregiverPendingConfirmationInstance"][]
        | null;
      pendingConfirmationShifts:
        | components["schemas"]["CaregiverFlexibleVisitRequestParams"][]
        | null;
      pendingConfirmationUntil: components["schemas"]["Instant"] | null;
      pendingConfirmationConfirmedAt: components["schemas"]["Instant"] | null;
    };
    CaregiverPendingConfirmationInstance: {
      id: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
    };
    CaregiverVisit:
      | components["schemas"]["CaregiverVisitBroadcastTypes.Available"]
      | components["schemas"]["CaregiverVisitBroadcastTypes.Onboarding"];
    "CaregiverVisitBroadcastTypes.Onboarding": {
      id: components["schemas"]["OnboardingVisitId"];
      /** @enum {string} */
      type: "Onboarding";
      publicVisitBroadcastDetails: components["schemas"]["PublicOnboardingVisitDetails"];
      caregiverVisitEngagementDetails: components["schemas"]["CaregiverOboardingVisitEngagementDetails"];
    };
    /** Format: OnboardingVisitId */
    OnboardingVisitId: OnboardingVisitId;
    PublicOnboardingVisitDetails:
      | components["schemas"]["PublicOnboardingVisitDetailsTypes.Pattern"]
      | components["schemas"]["PublicOnboardingVisitDetailsTypes.Singles"];
    "PublicOnboardingVisitDetailsTypes.Pattern": {
      /** @enum {string} */
      type: "Pattern";
      weeklyPattern: components["schemas"]["BroadcastPattern"];
      id: components["schemas"]["OnboardingVisitId"];
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["Agency"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      languages: string[];
      generalNotes: string;
      location: components["schemas"]["AddressComponents"];
      price: null | number;
      /** @description timezone from the tz database (IANA) */
      timezone: string;
      createdByFirstName: string;
      createdByLastName: string;
      visitLabels: components["schemas"]["VisitLabelText"][];
      patientId: components["schemas"]["PatientId"];
      patientInitials: string;
      patientGender: ("F" | "M") | null;
      patientAllergies: components["schemas"]["Allergy"][];
      createdById: components["schemas"]["AgencyMemberId"];
      certifications: components["schemas"]["CaregiverCertification"][];
      hideEndDateFromCaregiver: boolean;
      visitInstances: components["schemas"]["SingleOnboardingVisitInstanceDetails"][];
      patientFirstName: string;
      patientAge: null | number;
      patientIsActive: boolean;
      patientLanguages: string[];
      patientRequests: string[];
      patientMedicalNotes: null | string;
      patientTasks: string[];
      staffingPreferences: components["schemas"]["VisitStaffingPreferences"];
      staffingPreferences2: components["schemas"]["VisitStaffingPreferences2"];
      patientAvailability:
        | components["schemas"]["PatientVisitTimeFramesByDay"][]
        | null;
      visitInfo: string[] | null;
      allowMultipleCaregivers: boolean;
      nearLocationDisplay: null | string;
    };
    SingleOnboardingVisitInstanceDetails: {
      visitInstanceId: components["schemas"]["OnboardingVisitInstanceId"];
      date: components["schemas"]["VisitDatesParams"];
    };
    /** Format: OnboardingVisitInstanceId */
    OnboardingVisitInstanceId: OnboardingVisitInstanceId;
    "PublicOnboardingVisitDetailsTypes.Singles": {
      /** @enum {string} */
      type: "Singles";
      id: components["schemas"]["OnboardingVisitId"];
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["Agency"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      languages: string[];
      generalNotes: string;
      location: components["schemas"]["AddressComponents"];
      price: null | number;
      /** @description timezone from the tz database (IANA) */
      timezone: string;
      createdByFirstName: string;
      createdByLastName: string;
      visitLabels: components["schemas"]["VisitLabelText"][];
      patientId: components["schemas"]["PatientId"];
      patientInitials: string;
      patientGender: ("F" | "M") | null;
      patientAllergies: components["schemas"]["Allergy"][];
      createdById: components["schemas"]["AgencyMemberId"];
      certifications: components["schemas"]["CaregiverCertification"][];
      hideEndDateFromCaregiver: boolean;
      visitInstances: components["schemas"]["SingleOnboardingVisitInstanceDetails"][];
      patientFirstName: string;
      patientAge: null | number;
      patientIsActive: boolean;
      patientLanguages: string[];
      patientRequests: string[];
      patientMedicalNotes: null | string;
      patientTasks: string[];
      staffingPreferences: components["schemas"]["VisitStaffingPreferences"];
      staffingPreferences2: components["schemas"]["VisitStaffingPreferences2"];
      patientAvailability:
        | components["schemas"]["PatientVisitTimeFramesByDay"][]
        | null;
      visitInfo: string[] | null;
      allowMultipleCaregivers: boolean;
      nearLocationDisplay: null | string;
    };
    CaregiverOboardingVisitEngagementDetails: {
      /** @description Has the caregiver viewed this visit yet (or is it new) */
      viewed: boolean;
      /** @description Has the caregiver requested this visit */
      requested: boolean;
      moreDetailsViewed: boolean;
      /** @description For multishift change. */
      requestedInstances:
        | components["schemas"]["OnboardingVisitInstanceId"][]
        | null;
      rejectedInstances:
        | components["schemas"]["OnboardingVisitInstanceId"][]
        | null;
    };
    NotInterestedReason: {
      payload: string;
    };
    VisitInstanceMobileDetails: {
      id: components["schemas"]["VisitInstanceId"];
      startTimeUTC: components["schemas"]["Instant"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeUTC: components["schemas"]["Instant"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      checkInTime: components["schemas"]["Instant"] | null;
      checkOutTime: components["schemas"]["Instant"] | null;
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      dutySheetFillPercentage: null | number;
      confidentialVisitDetails: components["schemas"]["ConfidentialVisitDetails"];
      publicVisitDetails: components["schemas"]["PublicVisitInstanceDetails"];
      isCaregiverClockEnabled: boolean;
      visitDocumentsStatus: components["schemas"]["VisitDocumentsStatus"];
      manualClockTimeEditApproved: boolean;
      isDutySheetCompleted: boolean;
      allowMultipleCaregivers: boolean;
      flexibleVisitParams:
        | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
        | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
        | components["schemas"]["PermanentFixedHoursFlexibleDays"]
        | components["schemas"]["SingleFlexible"]
        | null;
      timeSheetSubmittedAt: components["schemas"]["Instant"] | null;
      timeSheetDeclinedAt: components["schemas"]["Instant"] | null;
      timeSheetApprovedAt: components["schemas"]["Instant"] | null;
      hasPlanOfCare: boolean;
      checkinMaxDistance: null | number;
      requireSelfieOnClockIn: boolean;
      requireSelfieOnClockOut: boolean;
    };
    ConfidentialVisitDetails: {
      patientName: string;
      patientAddress: string;
      patientAddress2: null | string;
      patientAddressInstructions: null | string;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
    };
    PublicVisitInstanceDetails: {
      id: components["schemas"]["VisitBroadcastId"] | null;
      createdAt: components["schemas"]["Instant"];
      agency: components["schemas"]["Agency"];
      isBillingAgency: boolean;
      isMedflytAgency: boolean;
      startTime: components["schemas"]["Instant"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      endTime?: Instant;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSS */
      endTimeLocal?: LocalDateTime;
      /** @description Is this a single visit or recurring visit? */
      isSingleVisit: boolean;
      /** @description Defines the time slots of the visit over a given week. */
      dayTimeParams: components["schemas"]["VisitDayTimeParams"] | null;
      /** @description USD, integer cents. "$10.99" equals the value 1099 */
      price: null | number;
      /**
       * @description The resolved pay rate for this visit, shown only when the visit's
       * office has show_payrates_to_caregivers enabled; null otherwise.
       */
      payrate: components["schemas"]["CaregiverVisitPayrate"] | null;
      /** @description Must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      generalNotes: string;
      location: components["schemas"]["AddressComponents"];
      /** @description timezone from the tz database (IANA) */
      timezone: string;
      createdById: components["schemas"]["AgencyMemberId"];
      createdByFirstName: string;
      createdByLastName: string;
      rnVisitParams: components["schemas"]["RNVisitParams"];
      flexibleVisitParams:
        | components["schemas"]["PermanentFlexibleHoursAndDaysPerWeek"]
        | components["schemas"]["PermanentFlexibleHoursAndDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPattern"]
        | components["schemas"]["PermanentFlexibleHoursFixedDaysPerWeek"]
        | components["schemas"]["PermanentFixedHoursFlexibleDays"]
        | components["schemas"]["SingleFlexible"]
        | null;
      visitLabels: components["schemas"]["VisitLabelText"][];
      certifications: components["schemas"]["CaregiverCertification"][];
      patientId: components["schemas"]["PatientId"];
      patientFirstName: string;
      patientInitials: string;
      patientGender: ("F" | "M") | null;
      patientAge: null | number;
      patientAllergies: components["schemas"]["Allergy"][];
      clockInToleranceMinutes: number;
      clockOutToleranceMinutes: number;
      patientLanguages: string[];
      patientRequests: string[];
      patientTasks: string[];
      patientIsActive: boolean;
      staffingPreferences: components["schemas"]["VisitStaffingPreferences"];
      staffingPreferences2: components["schemas"]["VisitStaffingPreferences2"];
      patientMedicalNotes: null | string;
      visitInfo: string[] | null;
      patientAdvancedDirectives:
        | components["schemas"]["PatientAdvancedDirective"]
        | null;
    };
    VisitDocumentsStatus: {
      total: number;
      submitted: number;
    };
    CaregiverImportedVisitDetails: {
      id: components["schemas"]["ImportedVisitId"];
      agencyName: string;
      patientName: string;
      timezone: string;
      startTimeUTC: components["schemas"]["Instant"];
      endTimeUTC: components["schemas"]["Instant"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      agencyMemberId: components["schemas"]["AgencyMemberId"] | null;
    };
    /** Format: ImportedVisitId */
    ImportedVisitId: ImportedVisitId;
    FlexiblePermanentVisit: {
      /** @enum {string} */
      type: "FlexiblePermanentVisit";
      dayTimeParams: components["schemas"]["VisitDayTime"][];
      startDateTime: components["schemas"]["LocalDateTime"];
      endDateTime: components["schemas"]["LocalDateTime"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddressWithComponents"];
      price: null | number;
      paymentType: components["schemas"]["VisitBatchPaymentType"];
      certifications: components["schemas"]["CaregiverCertification"][];
      gender: ("F" | "M") | null;
      languages: string[];
      generalNotes: string;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
      visitLabels: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: null | boolean;
      allowMultipleCaregivers: boolean;
      flexibleVisitParams: components["schemas"]["PatternFlexibleVisitParamsDb"];
      hourlyPayrateDuration: ("NoEndDate" | "VisitDates") | null;
      visitInfo: string[] | null;
    };
    VisitDayTime: {
      day: components["schemas"]["DayOfWeek"];
      times: {
        startTime: components["schemas"]["LocalTime"];
        endTime: components["schemas"]["LocalTime"];
      }[];
      caregiverId: components["schemas"]["CaregiverId"] | null;
    };
    VisitInstanceAddressWithComponents: {
      address: string;
      address2: null | string;
      addressInstructions?: null | string;
      timezone: string;
      state: string;
      countyName: string;
      addressComponents: components["schemas"]["AddressComponents"];
    };
    VisitBatchPaymentType: ("Hourly" | "Visit") | null;
    PatternFlexibleVisitParamsDb:
      | components["schemas"]["SingleFlexible"]
      | components["schemas"]['Omit<PermanentFlexibleHoursAndDaysPerWeek,"minHoursPerShift"|"maxHoursPerShift"|"excludedDaysFromCaregivers">']
      | components["schemas"]['Omit<PermanentFlexibleHoursAndDaysPattern,"excludedDaysFromCaregivers">']
      | components["schemas"]['Omit<PermanentFlexibleHoursFixedDaysPattern,"excludedDaysFromCaregivers">']
      | components["schemas"]['Omit<PermanentFlexibleHoursFixedDaysPerWeek,"minHoursPerShift"|"maxHoursPerShift"|"excludedDaysFromCaregivers">']
      | components["schemas"]['Omit<PermanentFixedHoursFlexibleDays,"excludedDaysFromCaregivers">'];
    'Omit<PermanentFlexibleHoursAndDaysPerWeek,"minHoursPerShift"|"maxHoursPerShift"|"excludedDaysFromCaregivers">': {
      /** @enum {string} */
      type: "PermanentFlexibleHoursAndDaysPerWeek";
      daysToChooseFrom: components["schemas"]["DayOfWeek"][];
      amountOfHoursPerWeek: number;
    };
    'Omit<PermanentFlexibleHoursAndDaysPattern,"excludedDaysFromCaregivers">': {
      /** @enum {string} */
      type: "PermanentFlexibleHoursAndDaysPattern";
      daysToChooseFrom: components["schemas"]["DayOfWeek"][];
      flexibleDetails: {
        amountOfDays: number;
        amountOfHours: number;
      }[];
    };
    'Omit<PermanentFlexibleHoursFixedDaysPattern,"excludedDaysFromCaregivers">': {
      /** @enum {string} */
      type: "PermanentFlexibleHoursFixedDaysPattern";
      details: {
        day: components["schemas"]["DayOfWeek"];
        amountOfHours: number;
      }[];
    };
    'Omit<PermanentFlexibleHoursFixedDaysPerWeek,"minHoursPerShift"|"maxHoursPerShift"|"excludedDaysFromCaregivers">': {
      /** @enum {string} */
      type: "PermanentFlexibleHoursFixedDaysPerWeek";
      amountOfHoursPerWeek: number;
      days: components["schemas"]["DayOfWeek"][];
    };
    'Omit<PermanentFixedHoursFlexibleDays,"excludedDaysFromCaregivers">': {
      /** @enum {string} */
      type: "PermanentFixedHoursFlexibleDays";
      daysToChooseFrom: {
        day: components["schemas"]["DayOfWeek"];
        startTime: components["schemas"]["LocalTime"];
        endTime: components["schemas"]["LocalTime"];
      }[];
      amountOfDays: number;
    };
    FlexibleSingleVisit: {
      /** @enum {string} */
      type: "FlexibleSingleVisit";
      startDateTime: components["schemas"]["LocalDateTime"];
      endDateTime: components["schemas"]["LocalDateTime"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddressWithComponents"];
      price: null | number;
      paymentType: components["schemas"]["VisitBatchPaymentType"];
      certifications: components["schemas"]["CaregiverCertification"][];
      gender: ("F" | "M") | null;
      languages: string[];
      generalNotes: string;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
      visitLabels: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: null | boolean;
      allowMultipleCaregivers: boolean;
      flexibleVisitParams: components["schemas"]["PatternFlexibleVisitParamsDb"];
      hourlyPayrateDuration: ("NoEndDate" | "VisitDates") | null;
      visitInfo: string[] | null;
    };
    FlexibleMultipleShifts: {
      /** @enum {string} */
      type: "FlexibleMultipleShifts";
      shiftsTimes: components["schemas"]["VisitDatesParams"][];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddressWithComponents"];
      price: null | number;
      paymentType: components["schemas"]["VisitBatchPaymentType"];
      certifications: components["schemas"]["CaregiverCertification"][];
      gender: ("F" | "M") | null;
      languages: string[];
      generalNotes: string;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
      visitLabels: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: null | boolean;
      hourlyPayrateDuration: ("NoEndDate" | "VisitDates") | null;
      visitInfo: string[] | null;
      allowMultipleCaregivers: boolean;
      flexibleVisitParams: components["schemas"]["PatternFlexibleVisitParamsDb"];
    };
    "VisitCreateParamsTypes.SingleVisit": {
      /** @enum {string} */
      type: "SingleVisit";
      startDateTime: components["schemas"]["LocalDateTime"];
      endDateTime: components["schemas"]["LocalDateTime"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddressWithComponents"];
      price: null | number;
      paymentType: components["schemas"]["VisitBatchPaymentType"];
      certifications: components["schemas"]["CaregiverCertification"][];
      gender: ("F" | "M") | null;
      languages: string[];
      generalNotes: string;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
      assignedCoordinatorTeams?: components["schemas"]["AgencyTeamId"][];
      visitLabels: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: null | boolean;
      hourlyPayrateDuration: ("NoEndDate" | "VisitDates") | null;
      visitInfo: string[] | null;
      allowMultipleCaregivers: boolean;
    };
    "VisitCreateParamsTypes.PermanentVisit": {
      /** @enum {string} */
      type: "PermanentVisit";
      dayTimeParams: components["schemas"]["VisitDayTime"][];
      /** @enum {string} */
      weeklyTemplateAction?: "ADD" | "NO_EFFECT" | "REPLACE";
      startDateTime: components["schemas"]["LocalDateTime"];
      endDateTime: components["schemas"]["LocalDateTime"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddressWithComponents"];
      price: null | number;
      paymentType: components["schemas"]["VisitBatchPaymentType"];
      certifications: components["schemas"]["CaregiverCertification"][];
      gender: ("F" | "M") | null;
      languages: string[];
      generalNotes: string;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
      assignedCoordinatorTeams?: components["schemas"]["AgencyTeamId"][];
      visitLabels: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: null | boolean;
      hourlyPayrateDuration: ("NoEndDate" | "VisitDates") | null;
      visitInfo: string[] | null;
      allowMultipleCaregivers: boolean;
    };
    "VisitCreateParamsTypes.MultipleShifts": {
      /** @enum {string} */
      type: "MultipleShifts";
      shiftsTimes: components["schemas"]["VisitDatesParams"][];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      payrollAdjustmentSeconds: null | number;
      billable: boolean;
      address: components["schemas"]["VisitInstanceAddressWithComponents"];
      price: null | number;
      paymentType: components["schemas"]["VisitBatchPaymentType"];
      certifications: components["schemas"]["CaregiverCertification"][];
      gender: ("F" | "M") | null;
      languages: string[];
      generalNotes: string;
      patientPhone: null | string;
      patientAlternativePhone: null | string;
      caseDetails: string;
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
      assignedCoordinatorTeams?: components["schemas"]["AgencyTeamId"][];
      visitLabels: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: null | boolean;
      hourlyPayrateDuration: ("NoEndDate" | "VisitDates") | null;
      visitInfo: string[] | null;
      allowMultipleCaregivers: boolean;
    };
    "VisitEditParamsTypes.SingleVisits": {
      /** @enum {string} */
      editMode: "SingleVisits";
      shifts: components["schemas"]["SingleVisitEditParams"][];
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: boolean;
      allowMultipleCaregivers: boolean;
      /** Format: PatientContractId */
      patientContractId?: PatientContractId;
      serviceCodeId?: components["schemas"]["ServiceCodeId"] | null;
      payrollCodeId?: components["schemas"]["PayrollCodeId"] | null;
      address?: components["schemas"]["VisitInstanceAddressWithComponents"];
      price?: null | number;
      paymentType?: ("Hourly" | "Visit") | null;
      certifications?: components["schemas"]["CaregiverCertification"][];
      gender?: ("F" | "M") | null;
      languages?: string[];
      generalNotes?: string;
      patientPhone?: null | string;
      patientAlternativePhone?: null | string;
      caseDetails?: string;
      assignedCoordinators?: components["schemas"]["AgencyMemberId"][];
      assignedCoordinatorTeams?: components["schemas"]["AgencyTeamId"][];
      visitLabels?: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments?: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId?: components["schemas"]["PlanOfCareTypeId"] | null;
      hourlyPayrateDuration?: ("NoEndDate" | "VisitDates") | null;
      visitInfo?: string[] | null;
      approvalNote?: components["schemas"]["AgencyNoteCreateParams"];
      editNote?: components["schemas"]["AgencyNoteCreateParams"];
      caregiverUnassignedNote?: components["schemas"]["AgencyNoteCreateParams"];
    };
    SingleVisitEditParams: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      startTime: components["schemas"]["LocalTime"];
      endTime: components["schemas"]["LocalTime"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
    };
    "VisitEditParamsTypes.WeeklyPattern": {
      /** @enum {string} */
      editMode: "WeeklyPattern";
      editParams: components["schemas"]["WeeklyPatternEditParams"][];
      shouldUpdateWeeklyTemplate: boolean;
      broadcast: boolean;
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: boolean;
      allowMultipleCaregivers: boolean;
      /** Format: PatientContractId */
      patientContractId?: PatientContractId;
      serviceCodeId?: components["schemas"]["ServiceCodeId"] | null;
      payrollCodeId?: components["schemas"]["PayrollCodeId"] | null;
      address?: components["schemas"]["VisitInstanceAddressWithComponents"];
      price?: null | number;
      paymentType?: ("Hourly" | "Visit") | null;
      certifications?: components["schemas"]["CaregiverCertification"][];
      gender?: ("F" | "M") | null;
      languages?: string[];
      generalNotes?: string;
      patientPhone?: null | string;
      patientAlternativePhone?: null | string;
      caseDetails?: string;
      assignedCoordinators?: components["schemas"]["AgencyMemberId"][];
      assignedCoordinatorTeams?: components["schemas"]["AgencyTeamId"][];
      visitLabels?: components["schemas"]["VisitLabelText"][];
      requiredPatientDocuments?: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId?: components["schemas"]["PlanOfCareTypeId"] | null;
      hourlyPayrateDuration?: ("NoEndDate" | "VisitDates") | null;
      visitInfo?: string[] | null;
      approvalNote?: components["schemas"]["AgencyNoteCreateParams"];
      editNote?: components["schemas"]["AgencyNoteCreateParams"];
      caregiverUnassignedNote?: components["schemas"]["AgencyNoteCreateParams"];
    };
    WeeklyPatternEditParams: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      /** Format: HH:mm:ss.SSS */
      startTime?: LocalTime;
      /** Format: HH:mm:ss.SSS */
      endTime?: LocalTime;
      visitInstanceIds: components["schemas"]["VisitInstanceId"][];
      caregiverId?: components["schemas"]["CaregiverId"] | null;
    };
    "VisitRemoveParamsTypes.SingleVisits": {
      /** @enum {string} */
      removeMode: "SingleVisits";
      visitInstanceIds: components["schemas"]["VisitInstanceId"][];
      manualRemoveNote?: components["schemas"]["AgencyNoteCreateParams"];
      approvalNote?: components["schemas"]["AgencyNoteCreateParams"];
    };
    "VisitRemoveParamsTypes.WeeklyPattern": {
      /** @enum {string} */
      removeMode: "WeeklyPattern";
      visitInstanceIds: components["schemas"]["VisitInstanceId"][];
      shouldUpdateWeeklyTemplate: boolean;
      manualRemoveNote?: components["schemas"]["AgencyNoteCreateParams"];
      approvalNote?: components["schemas"]["AgencyNoteCreateParams"];
    };
    "VisitBroadcastCreateTypes.Pattern": {
      /** @enum {string} */
      type: "Pattern";
      /** Format: yyyy-MM-dd */
      to?: LocalDate;
      visitBatchDetails: components["schemas"]["BroadcastVisitBatchDetailsParams"][];
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: boolean;
      allowMultipleCaregivers: boolean;
      isVisitAssignmentBlocked?: boolean;
      relatedVisitAssignmentId?:
        | components["schemas"]["VisitAssignmentId"]
        | null;
    };
    BroadcastVisitBatchDetailsParams: {
      /** Format: yyyy-MM-dd */
      from?: LocalDate;
      visitBatchId: components["schemas"]["VisitBatchId"];
      dayOfWeek: components["schemas"]["DayOfWeek"];
    };
    "VisitBroadcastCreateTypes.PatternWithInstances": {
      /** @enum {string} */
      type: "PatternWithInstances";
      visitInstances: {
        id: components["schemas"]["VisitInstanceId"];
        startTime: components["schemas"]["LocalDateTime"];
        endTime: components["schemas"]["LocalDateTime"];
        visitBatchId: components["schemas"]["VisitBatchId"];
      }[];
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: boolean;
      allowMultipleCaregivers: boolean;
      isVisitAssignmentBlocked?: boolean;
      relatedVisitAssignmentId?:
        | components["schemas"]["VisitAssignmentId"]
        | null;
    };
    "VisitBroadcastCreateTypes.PermanentWithIds": {
      /** @enum {string} */
      type: "PermanentWithIds";
      visitInstanceIds: components["schemas"]["VisitInstanceId"][];
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: boolean;
      allowMultipleCaregivers: boolean;
      isVisitAssignmentBlocked?: boolean;
      relatedVisitAssignmentId?:
        | components["schemas"]["VisitAssignmentId"]
        | null;
    };
    "VisitBroadcastCreateTypes.Singles": {
      visitInstanceIds: components["schemas"]["VisitInstanceId"][];
      /** @enum {string} */
      type: "Singles";
      assignableCaregiverRadius: null | number;
      hideEndDateFromCaregiver: boolean;
      allowMultipleCaregivers: boolean;
      isVisitAssignmentBlocked?: boolean;
      relatedVisitAssignmentId?:
        | components["schemas"]["VisitAssignmentId"]
        | null;
    };
    "VisitBroadcastStopParams.BroadcastStopParams": {
      /** @enum {string} */
      type: "broadcasts";
      visitBroadcastIds: components["schemas"]["VisitBroadcastId"][];
    };
    "VisitBroadcastStopParams.VisitStopParams": {
      /** @enum {string} */
      type: "visits";
      visitInstanceIds: components["schemas"]["VisitInstanceId"][];
    };
    FlexibleVisitBroadcastCreateParams:
      | components["schemas"]["FlexiblePermanentVisit"]
      | components["schemas"]["FlexibleSingleVisit"]
      | components["schemas"]["FlexibleMultipleShifts"];
    FlexibleVisitBroadcast: {
      id: components["schemas"]["VisitBroadcastId"];
      patientId: components["schemas"]["PatientId"];
      addressComponents: components["schemas"]["AddressComponents"];
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      pendingConfirmationUntil: components["schemas"]["Instant"] | null;
      requestedAmount: number;
      flexibleVisitParams: components["schemas"]["FlexibleVisitParams"];
      assigned: boolean;
      cancelled: boolean;
    };
    CaregiverRequestedHoursPerWeek: {
      caregiverId: components["schemas"]["CaregiverId"];
      weeksHours: { [key: string]: number };
    };
    VisitBroadcastFlattenedData: {
      id: components["schemas"]["VisitBroadcastId"];
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
    };
    DayTimeAssignParams: {
      dayOfWeek: components["schemas"]["DayOfWeek"];
      caregiverId: components["schemas"]["CaregiverId"];
    };
    AssignCaregiverToFlexibleVisitParams: {
      caregiverId: components["schemas"]["CaregiverId"];
      shifts: components["schemas"]["CaregiverFlexibleVisitRequestParams"][];
    };
    NursingQuestionWithSettings: {
      id: components["schemas"]["NursingQuestionId"];
      agencyId: components["schemas"]["AgencyId"] | null;
      questionText: string;
      possibleAnswers:
        | components["schemas"]["NursingQuestionPossibleAnswer"][]
        | null;
      answerType: components["schemas"]["NursingQuestionAnswerType"];
      databaseLink:
        | (
            | "contract_is_primary"
            | "contract_member_id"
            | "contract_start_date"
            | "frequency"
            | "nurse_name"
            | "patent_address"
            | "patient_address2"
            | "patient_allergies"
            | "patient_assigned_caregiver"
            | "patient_assigned_dps"
            | "patient_assigned_intake"
            | "patient_assigned_sales_rep"
            | "patient_assinged_coordinator"
            | "patient_certification_period_from_date"
            | "patient_certification_period_to_date"
            | "patient_critical_information_for_first_responders"
            | "patient_date_of_birth"
            | "patient_discharge_reinstate_discharge_date"
            | "patient_discharge_reinstate_discharge_reason_id"
            | "patient_discharge_reinstate_discharge_to_id"
            | "patient_discharge_reinstate_reinstate_date"
            | "patient_electric_equipment_dependency"
            | "patient_electric_equipment_dependency_check"
            | "patient_electricity_dependent"
            | "patient_email"
            | "patient_emergency_contact"
            | "patient_evacuation_location"
            | "patient_evacuation_zone"
            | "patient_family_information"
            | "patient_first_name"
            | "patient_gender"
            | "patient_general_notes"
            | "patient_home_phone_number"
            | "patient_id"
            | "patient_kids_in_house"
            | "patient_kosher_home"
            | "patient_last_name"
            | "patient_main_language"
            | "patient_medicaid_number"
            | "patient_medical_notes"
            | "patient_medicare_number"
            | "patient_middle_name"
            | "patient_mobile_phone_number"
            | "patient_mobility_status"
            | "patient_patient_hi_claim"
            | "patient_pets"
            | "patient_phone3"
            | "patient_phone4"
            | "patient_priority_code"
            | "patient_secondary_language"
            | "patient_smoking"
            | "patient_social_worker"
            | "patient_source"
            | "patient_ssn"
            | "patient_start_of_care"
            | "patient_status"
            | "patient_ventilator_dependent"
            | "patient_wage_parity_number"
            | "payer_source"
            | "physician_address"
            | "physician_name"
            | "service_type"
            | "task_or_visit_date"
            | "task_type"
          )
        | null;
      isVital: boolean;
      icon: null | string;
      showOnPatient: boolean;
      showOnAgency: boolean;
      isVBP: boolean;
      transferAnswerBetweenTasks: boolean;
    };
    /** Format: NursingQuestionId */
    NursingQuestionId: NursingQuestionId;
    NursingQuestionPossibleAnswer: {
      text: string;
      alertText?: string;
      isTriggeringAlert: boolean;
    };
    /** @enum {string} */
    NursingQuestionAnswerType:
      | "POC"
      | "RNPlatformPatientPhysician"
      | "bloodPressure"
      | "check"
      | "customSignature"
      | "date"
      | "dropDown"
      | "employeeSignature"
      | "number"
      | "patientSignature"
      | "radio"
      | "textLong"
      | "textShort"
      | "time"
      | "yesNo";
    PatientNursingQuestionVitalsWithAnswer: {
      questionId: components["schemas"]["NursingQuestionId"];
      questionText: string;
      answerType: components["schemas"]["NursingQuestionAnswerType"];
      answer: string[] | (null | string);
      vitalMeasuredAt: components["schemas"]["LocalDateTime"] | null;
      vitalMethod:
        | (
            | "ARM"
            | "Axillary"
            | "EAR"
            | "Irregular"
            | "Labored"
            | "Laying"
            | "Left Arm"
            | "MOUTH"
            | "Oral"
            | "Rectal"
            | "Regular"
            | "Remote/Forehead"
            | "Right Arm"
            | "Shallow"
            | "Sitting"
            | "Standing"
            | "WNL"
          )
        | null;
      vitalComments: null | string;
      vitalUnit: null | string;
      reportedCaregiverId: components["schemas"]["CaregiverId"] | null;
      reportedAgencyMember: components["schemas"]["AgencyMemberId"] | null;
      reporterName: null | string;
    };
    NursingQuestionWithAnswers: {
      id: components["schemas"]["NursingQuestionId"];
      agencyId: components["schemas"]["AgencyId"] | null;
      questionText: string;
      possibleAnswers:
        | components["schemas"]["NursingQuestionPossibleAnswer"][]
        | null;
      answerType: components["schemas"]["NursingQuestionAnswerType"];
      databaseLink:
        | (
            | "contract_is_primary"
            | "contract_member_id"
            | "contract_start_date"
            | "frequency"
            | "nurse_name"
            | "patent_address"
            | "patient_address2"
            | "patient_allergies"
            | "patient_assigned_caregiver"
            | "patient_assigned_dps"
            | "patient_assigned_intake"
            | "patient_assigned_sales_rep"
            | "patient_assinged_coordinator"
            | "patient_certification_period_from_date"
            | "patient_certification_period_to_date"
            | "patient_critical_information_for_first_responders"
            | "patient_date_of_birth"
            | "patient_discharge_reinstate_discharge_date"
            | "patient_discharge_reinstate_discharge_reason_id"
            | "patient_discharge_reinstate_discharge_to_id"
            | "patient_discharge_reinstate_reinstate_date"
            | "patient_electric_equipment_dependency"
            | "patient_electric_equipment_dependency_check"
            | "patient_electricity_dependent"
            | "patient_email"
            | "patient_emergency_contact"
            | "patient_evacuation_location"
            | "patient_evacuation_zone"
            | "patient_family_information"
            | "patient_first_name"
            | "patient_gender"
            | "patient_general_notes"
            | "patient_home_phone_number"
            | "patient_id"
            | "patient_kids_in_house"
            | "patient_kosher_home"
            | "patient_last_name"
            | "patient_main_language"
            | "patient_medicaid_number"
            | "patient_medical_notes"
            | "patient_medicare_number"
            | "patient_middle_name"
            | "patient_mobile_phone_number"
            | "patient_mobility_status"
            | "patient_patient_hi_claim"
            | "patient_pets"
            | "patient_phone3"
            | "patient_phone4"
            | "patient_priority_code"
            | "patient_secondary_language"
            | "patient_smoking"
            | "patient_social_worker"
            | "patient_source"
            | "patient_ssn"
            | "patient_start_of_care"
            | "patient_status"
            | "patient_ventilator_dependent"
            | "patient_wage_parity_number"
            | "payer_source"
            | "physician_address"
            | "physician_name"
            | "service_type"
            | "task_or_visit_date"
            | "task_type"
          )
        | null;
      isVital: boolean;
      icon: null | string;
      answers: components["schemas"]["PatientNursingQuestionsAnswer"][];
    };
    PatientNursingQuestionsAnswer: {
      id: components["schemas"]["NursingQuestionAnswerId"];
      questionId: components["schemas"]["NursingQuestionId"];
      answerText:
        | string[]
        | components["schemas"]["RNPlatformPatientPhysicianDetails"]
        | (null | string | number);
      scheduleVisitDocumentId:
        | components["schemas"]["PatientDocumentScheduleId"]
        | null;
      reportedBy: components["schemas"]["UserId"];
      vitalUnit:
        | (
            | "Beats Per Minute"
            | "Breaths Per Minute"
            | "CELSIUS"
            | "FAHRENHEIT"
            | "KG"
            | "cm"
            | "mmHg"
          )
        | null;
      patientId: components["schemas"]["PatientId"] | null;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"] | null;
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
    };
    /** Format: NursingQuestionAnswerId */
    NursingQuestionAnswerId: NursingQuestionAnswerId;
    NursingQuestionVBPAnswer: {
      nursingQuestionId: components["schemas"]["NursingQuestionId"];
      answer: string[] | string;
      notes: null | string;
      riskLevel: null | number;
    };
    PatientNursingQuestionVBPReport: {
      date: components["schemas"]["LocalDate"];
      answers: components["schemas"]["NursingQuestionVBPAnswerWithDate"][];
    };
    NursingQuestionVBPAnswerWithDate: {
      nursingQuestionId: components["schemas"]["NursingQuestionId"];
      answer: null | string;
      notes: null | string;
      riskLevel: null | number;
      date: components["schemas"]["LocalDate"];
    };
    PatientTaskInstances: {
      patientTaskInstances: components["schemas"]["PatientTaskTypesForWebapp"][];
      /**
       * @description The caregivers assigned to these tasks, resolved here so the page does not
       * have to look them up by id. A sibling list rather than a field on the row
       * because `PatientTaskTypesForWebapp` is a union of four task shapes.
       */
      caregivers: components["schemas"]["CaregiverRowDisplay"][];
      /** @description The patients these tasks belong to, resolved for the same reason. */
      patients: components["schemas"]["PatientRowDisplay"][];
    };
    PatientTaskTypesForWebapp:
      | components["schemas"]["PatientTaskInstanceWithDetails"]
      | (components["schemas"]["PatientTaskTypes.FutureTask"] & {
          taskIssues: components["schemas"]["DisplayTaskIssue"][];
        })
      | (components["schemas"]["PatientTaskTypes.DraftTask"] & {
          taskIssues: components["schemas"]["DisplayTaskIssue"][];
        })
      | (components["schemas"]["PatientTaskTypes.Broadcasting"] & {
          taskIssues: components["schemas"]["DisplayTaskIssue"][];
        });
    PatientTaskInstanceWithDetails: {
      documents: {
        documentTypeId: components["schemas"]["PatientDocumentTypeId"];
        documentScheduleId:
          | components["schemas"]["PatientDocumentScheduleId"]
          | null;
        title: string;
        submitted: boolean;
        sentToPhysician: boolean;
        openForResubmission: boolean;
        approved: boolean;
        isScanned: boolean;
        fileUrl: null | string;
      }[];
      planOfCare?: {
        planOfCareId: components["schemas"]["PlanOfCareId"];
        title: string;
        submitted: boolean;
        fileUrl: null | string;
      };
      caregiver: {
        id: components["schemas"]["CaregiverId"];
        fullName: string;
      } | null;
      hasClockedIn: boolean;
      /** @description Denormalised so a caller can label the row without resolving the patient. */
      patientAddress: null | string;
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      patientConfirmedSchedule: boolean;
      taskIssues: components["schemas"]["DisplayTaskIssue"][];
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      price: null | number;
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      /** @enum {string} */
      type: "RegularTask";
      status: components["schemas"]["PatientTaskStatus"];
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      dueDate: components["schemas"]["LocalDate"];
      completionDate: components["schemas"]["LocalDate"] | null;
      repeatMonths: null | number;
      patientContractName: string;
      taskId: components["schemas"]["PatientTaskId"];
      title: string;
      durationMinutes: null | number;
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      patientTaskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      priority: number;
      patientName: string;
      startDate: components["schemas"]["LocalDate"];
      originalCompletionDate: components["schemas"]["LocalDate"] | null;
      scheduleDateTime: components["schemas"]["Instant"] | null;
      createdBy: components["schemas"]["AgencyMemberId"];
      removedAt: components["schemas"]["Instant"] | null;
      removedBy: components["schemas"]["AgencyMemberId"] | null;
      taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
      taskCanceledAt: components["schemas"]["Instant"] | null;
      taskCanceledBy: components["schemas"]["AgencyMemberId"] | null;
      taskInstanceCanceledAt: components["schemas"]["Instant"] | null;
      taskInstanceCanceledBy: components["schemas"]["AgencyMemberId"] | null;
      broadcastDistance: null | number;
      isBroadcasting: boolean;
      allowedCertifications: components["schemas"]["CaregiverCertification"][];
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      patientOfficeId: components["schemas"]["OfficeId"];
      isCertificationPeriodBoundTask: null | boolean;
      certificationPeriodId:
        | components["schemas"]["CertificationPeriodId"]
        | null;
      certificationStartDate: components["schemas"]["LocalDate"] | null;
      certificationEndDate: components["schemas"]["LocalDate"] | null;
      taskTemplateContext: ("REASSESSMENT" | "START_OF_CARE") | null;
      dayTimeScheduleOverrideParams:
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
        | null;
      mainLanguage: null | string;
      agencyNote?: null | string;
    };
    "PatientTaskTypes.FutureTask": {
      /** @enum {string} */
      type: "FutureTask";
      /** @enum {string} */
      status: "Future";
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      taskId: components["schemas"]["PatientTaskId"];
      title: string;
      patientId: components["schemas"]["PatientId"];
      durationMinutes: null | number;
      patientName: string;
      /** @description Denormalised, same as on PatientTaskInstanceWithDetails. */
      patientAddress: null | string;
      repeatMonths: null | number;
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      documents: components["schemas"]["PatientDocumentTypeId"][];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
      allowedCertifications: components["schemas"]["CaregiverCertification"][];
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      patientOfficeId: components["schemas"]["OfficeId"];
      taskTemplateContext: ("REASSESSMENT" | "START_OF_CARE") | null;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiver: {
        id: components["schemas"]["CaregiverId"];
        fullName: string;
      } | null;
      isFutureAssigned: boolean;
      dayTimeScheduleOverrideParams:
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
        | null;
      taskIssues?: components["schemas"]["DisplayTaskIssue"][];
      price: null | number;
      mainLanguage: null | string;
    };
    "PatientTaskTypes.Broadcasting": {
      /** @enum {string} */
      type: "Broadcasting";
      /** @enum {string} */
      status: "Broadcasting";
      serviceCodeId: components["schemas"]["ServiceCodeId"];
      payrollCodeId: components["schemas"]["PayrollCodeId"] | null;
      patientContractId: components["schemas"]["PatientContractId"];
      patientContractName: string;
      taskId: components["schemas"]["PatientTaskId"];
      title: string;
      durationMinutes: null | number;
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      repeatMonths: null | number;
      priority: number;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      planOfCareTypeId: components["schemas"]["PlanOfCareTypeId"] | null;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      documents: components["schemas"]["PatientDocumentTypeId"][];
      taskTemplateId: components["schemas"]["PatientTaskTemplateId"];
      broadcastDistance: null | number;
      allowedCertifications: components["schemas"]["CaregiverCertification"][];
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      patientOfficeId: components["schemas"]["OfficeId"];
      isCertificationPeriodBoundTask: boolean;
      certificationPeriodId:
        | components["schemas"]["CertificationPeriodId"]
        | null;
      certificationStartDate: components["schemas"]["LocalDate"] | null;
      certificationEndDate: components["schemas"]["LocalDate"] | null;
      taskTemplateContext: ("REASSESSMENT" | "START_OF_CARE") | null;
      dayTimeScheduleOverrideParams:
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
        | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"]
        | null;
      price: null | number;
      mainLanguage: null | string;
    };
    PatientTaskBulkScheduledTask: {
      patientId: components["schemas"]["PatientId"];
      taskId: components["schemas"]["PatientTaskId"];
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      scheduledDateTime: components["schemas"]["LocalDateTime"];
    };
    /**
     * @description One patient inside a bulk "schedule task for selected patients" request. The
     * contract and certification period are per patient because both belong to a
     * single patient, while everything else in the request is shared.
     */
    PatientTaskBulkSchedulePatientParams: {
      patientId: components["schemas"]["PatientId"];
      patientContractId: components["schemas"]["PatientContractId"];
      certificationPeriodId:
        | components["schemas"]["CertificationPeriodId"]
        | null;
    };
    TaskDayTimeScheduleOverrideParams:
      | components["schemas"]["TaskDayTimeScheduleOverrideParams.SpecificDates"]
      | components["schemas"]["TaskDayTimeScheduleOverrideParams.Pattern"];
    "PatientAssignedTaskParamsTypes.CurrentTask": {
      /** @enum {string} */
      type: "CurrentTask";
      caregiverId?: components["schemas"]["CaregiverId"] | null;
      title?: string;
      /** Format: yyyy-MM-dd */
      startDate?: LocalDate;
      /** Format: yyyy-MM-dd */
      dueDate?: LocalDate;
      planOfCareTypeId?: components["schemas"]["PlanOfCareTypeId"] | null;
      documents?: components["schemas"]["PatientDocumentTypeId"][];
      broadcastDistance?: null | number;
      isBroadcasting?: boolean;
      priority?: number;
      /** Format: ServiceCodeId */
      serviceCodeId?: ServiceCodeId;
      /** Format: PatientContractId */
      patientContractId?: PatientContractId;
      payrollCodeId?: components["schemas"]["PayrollCodeId"] | null;
      dayTimeParams?: components["schemas"]["TaskDayTimeParam"][] | null;
      scheduledDateTime?:
        | components["schemas"]["PatientTaskInstanceEditScheduleDateTime"]
        | null;
      certificationPeriodId?:
        | components["schemas"]["CertificationPeriodId"]
        | null;
      patientConfirmed?: boolean;
      confirmationType?:
        | (
            | "Automation - SMS"
            | "Automation - bot agent"
            | "Automation - robocall"
            | "Caregiver"
            | "Manual"
            | "Nurse call"
          )
        | null;
      confirmedBy?: components["schemas"]["UserId"] | null;
      confirmedByType?: ("AGENCY_MEMBER" | "CAREGIVER" | "PATIENT") | null;
      dayTimeScheduleOverrideParams?: {
        taskDayTimeScheduleOverrideParams: components["schemas"]["TaskDayTimeScheduleOverrideParams"];
        isAgencyInitialTimeSlots?: boolean;
      } | null;
      caregiverUnassignedNote?: components["schemas"]["AgencyNoteCreateParams"];
      taskIssues?: string[];
      price?: null | number;
      confirmedPhoneNumber?: null | string;
    };
    "PatientAssignedTaskParamsTypes.GoingForward": {
      /** @enum {string} */
      type: "GoingForward";
      repeatMonths?: null | number;
      caregiverId?: components["schemas"]["CaregiverId"] | null;
      title?: string;
      /** Format: yyyy-MM-dd */
      startDate?: LocalDate;
      /** Format: yyyy-MM-dd */
      dueDate?: LocalDate;
      planOfCareTypeId?: components["schemas"]["PlanOfCareTypeId"] | null;
      documents?: components["schemas"]["PatientDocumentTypeId"][];
      broadcastDistance?: null | number;
      isBroadcasting?: boolean;
      priority?: number;
      /** Format: ServiceCodeId */
      serviceCodeId?: ServiceCodeId;
      /** Format: PatientContractId */
      patientContractId?: PatientContractId;
      payrollCodeId?: components["schemas"]["PayrollCodeId"] | null;
      dayTimeParams?: components["schemas"]["TaskDayTimeParam"][] | null;
      scheduledDateTime?:
        | components["schemas"]["PatientTaskInstanceEditScheduleDateTime"]
        | null;
      certificationPeriodId?:
        | components["schemas"]["CertificationPeriodId"]
        | null;
      patientConfirmed?: boolean;
      confirmationType?:
        | (
            | "Automation - SMS"
            | "Automation - bot agent"
            | "Automation - robocall"
            | "Caregiver"
            | "Manual"
            | "Nurse call"
          )
        | null;
      confirmedBy?: components["schemas"]["UserId"] | null;
      confirmedByType?: ("AGENCY_MEMBER" | "CAREGIVER" | "PATIENT") | null;
      dayTimeScheduleOverrideParams?: {
        taskDayTimeScheduleOverrideParams: components["schemas"]["TaskDayTimeScheduleOverrideParams"];
        isAgencyInitialTimeSlots?: boolean;
      } | null;
      caregiverUnassignedNote?: components["schemas"]["AgencyNoteCreateParams"];
      taskIssues?: string[];
      price?: null | number;
      confirmedPhoneNumber?: null | string;
    };
    PatientTaskInstanceMetricTableData: {
      createdAt: components["schemas"]["Instant"];
      caregiver: {
        id: components["schemas"]["CaregiverId"];
        status: components["schemas"]["CaregiverStatus"];
        photoUrl: null | string;
        displayId: null | number;
        name: string;
        addressGeoLocation: components["schemas"]["Geo"];
      };
      distanceInMiles: null | number;
      zipCode: string;
    };
    PatientTaskInstanceMetricsTypeCount: {
      type: components["schemas"]["PatientTaskInstanceMetricType"];
      count: number;
    };
    /** @enum {string} */
    PatientTaskInstanceMetricType:
      | "opened"
      | "received"
      | "scheduled"
      | "unscheduled"
      | "viewed";
    PatientTaskHistorySummaryRecord: {
      updatedAt: components["schemas"]["LocalDateTime"];
      actor:
        | {
            /** @enum {string} */
            type: "AGENCY_MEMBER";
            id: components["schemas"]["AgencyMemberId"];
            name: string;
            avatar: null | string;
          }
        | {
            /** @enum {string} */
            type: "CAREGIVER";
            id: components["schemas"]["CaregiverId"];
            name: string;
            avatar: null | string;
          }
        | {
            /** @enum {string} */
            type: "SYSTEM";
          }
        | null;
      summary: string;
    };
    PatientTaskInstanceType:
      | components["schemas"]["PatientTaskInstanceType.COMPLETED"]
      | components["schemas"]["PatientTaskInstanceType.PENDING"]
      | components["schemas"]["PatientTaskInstanceType.SCHEDULED"]
      | components["schemas"]["PatientTaskInstanceType.UNSCHEDULED"];
    "PatientTaskInstanceType.COMPLETED": {
      /** @enum {string} */
      type: "COMPLETED";
      completionDate: components["schemas"]["LocalDate"];
      originalCompletionDate: components["schemas"]["LocalDate"] | null;
      scheduleDateTime: components["schemas"]["Instant"];
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      visitInstance: components["schemas"]["VisitInstanceMobileDetails"] | null;
      patientConfirmedSchedule: boolean;
      id: components["schemas"]["PatientTaskInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      taskDetails: components["schemas"]["PatientTaskType"];
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      clockInLocation: components["schemas"]["Geo"] | null;
      clockOutLocation: components["schemas"]["Geo"] | null;
      clockInType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      clockOutType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      updatedAt: components["schemas"]["Instant"] | null;
      patientAdditionalDocuments: (
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"]
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"]
      )[];
    };
    PatientTaskType:
      | components["schemas"]["PatientTaskType.RECURRING"]
      | components["schemas"]["PatientTaskType.SINGLE"];
    "PatientTaskType.RECURRING": {
      /** @enum {string} */
      type: "RECURRING";
      id: components["schemas"]["PatientTaskId"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientInitials: string;
      patientMainPhoneNumber: null | string;
      patientMobilePhoneNumber: null | string;
      patientHomePhoneNumber: null | string;
      patientAddress: null | string;
      patientAddress2: null | string;
      patientAddressComponent:
        | components["schemas"]["AddressComponents"]
        | null;
      patientAddressInstructions: null | string;
      patientAge: null | number;
      patientGender: ("F" | "M") | null;
      patientLanguages: string[] | null;
      title: string;
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      durationMinutes: null | number;
      repeatMonths: number;
      hasPlanOfCare: boolean;
      planOfCareCompleted: boolean;
      documents: components["schemas"]["PatientTaskInstanceDocument"][];
      agencyName: string;
      agencyAddress: string;
      agencyPhone: string;
      linkedPatientName: null | string;
      linkedPatientTaskInstanceId:
        | components["schemas"]["PatientTaskInstanceId"]
        | null;
      patientPhoneNumbers: {
        number: string;
        isPrimary: boolean;
        label: string;
        type: ("home" | "mobile") | null;
        kind: string;
      }[];
      agencyNote: null | string;
    };
    PatientTaskInstanceDocument:
      | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"]
      | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"]
      | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular"];
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan": {
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      /** @enum {string} */
      type: "PatientTaskInstanceDocumentScan";
      name: string;
      pdfUrl: string;
    };
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned": {
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      /** @enum {string} */
      type: "PatientTaskInstanceDocumentRegularScanned";
      name: string;
      pdfUrl: string;
      id: components["schemas"]["PatientDocumentTypeId"];
    };
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular": {
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      /** @enum {string} */
      type: "PatientTaskInstanceDocumentRegular";
      name: string;
      completed: boolean;
      status: components["schemas"]["PatientTaskInstanceDocumentStatus"];
      id: components["schemas"]["PatientDocumentTypeId"];
      isOpenForResubmission: boolean;
      isAwaitingAIReview: boolean;
      isRequiredAIReview: boolean;
      activeAIReviewsCount: number;
      aiReviewDependsOn:
        | components["schemas"]["PatientDocumentTypeId"][]
        | null;
      resubmissionReason: null | string;
    };
    /** @enum {string} */
    PatientTaskInstanceDocumentStatus:
      | "completed"
      | "in_progress"
      | "not_started";
    "PatientTaskType.SINGLE": {
      /** @enum {string} */
      type: "SINGLE";
      id: components["schemas"]["PatientTaskId"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientInitials: string;
      patientMainPhoneNumber: null | string;
      patientMobilePhoneNumber: null | string;
      patientHomePhoneNumber: null | string;
      patientAddress: null | string;
      patientAddress2: null | string;
      patientAddressComponent:
        | components["schemas"]["AddressComponents"]
        | null;
      patientAddressInstructions: null | string;
      patientAge: null | number;
      patientGender: ("F" | "M") | null;
      title: string;
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      durationMinutes: null | number;
      repeatMonths: null;
      hasPlanOfCare: boolean;
      planOfCareCompleted: boolean;
      documents: components["schemas"]["PatientTaskInstanceDocument"][];
      patientLanguages: string[] | null;
      agencyName: string;
      agencyAddress: string;
      agencyPhone: string;
      linkedPatientName: null | string;
      linkedPatientTaskInstanceId:
        | components["schemas"]["PatientTaskInstanceId"]
        | null;
      patientPhoneNumbers: {
        number: string;
        isPrimary: boolean;
        label: string;
        type: ("home" | "mobile") | null;
        kind: string;
      }[];
      agencyNote: null | string;
    };
    "PatientTaskInstanceType.PENDING": {
      /** @enum {string} */
      type: "PENDING";
      completionDate: null;
      originalCompletionDate: null;
      scheduleDateTime: null;
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      id: components["schemas"]["PatientTaskInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      taskDetails: components["schemas"]["PatientTaskType"];
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      clockInLocation: components["schemas"]["Geo"] | null;
      clockOutLocation: components["schemas"]["Geo"] | null;
      clockInType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      clockOutType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      updatedAt: components["schemas"]["Instant"] | null;
      patientAdditionalDocuments: (
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"]
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"]
      )[];
    };
    "PatientTaskInstanceType.SCHEDULED": {
      /** @enum {string} */
      type: "SCHEDULED";
      completionDate: null;
      originalCompletionDate: null;
      scheduleDateTime: components["schemas"]["Instant"];
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      visitInstance: components["schemas"]["VisitInstanceMobileDetails"] | null;
      patientConfirmedSchedule: boolean;
      id: components["schemas"]["PatientTaskInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      taskDetails: components["schemas"]["PatientTaskType"];
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      clockInLocation: components["schemas"]["Geo"] | null;
      clockOutLocation: components["schemas"]["Geo"] | null;
      clockInType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      clockOutType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      updatedAt: components["schemas"]["Instant"] | null;
      patientAdditionalDocuments: (
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"]
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"]
      )[];
    };
    "PatientTaskInstanceType.UNSCHEDULED": {
      /** @enum {string} */
      type: "UNSCHEDULED";
      completionDate: null;
      originalCompletionDate: null;
      scheduleDateTime: components["schemas"]["Instant"];
      unassignedAt: components["schemas"]["Instant"];
      unassignedReason: string;
      dayTimeParams: components["schemas"]["TaskDayTimeParams"];
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      visitInstance: components["schemas"]["VisitInstanceMobileDetails"] | null;
      patientConfirmedSchedule: boolean;
      id: components["schemas"]["PatientTaskInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      startDate: components["schemas"]["LocalDate"];
      dueDate: components["schemas"]["LocalDate"];
      taskDetails: components["schemas"]["PatientTaskType"];
      clockInTime: components["schemas"]["LocalDateTime"] | null;
      clockOutTime: components["schemas"]["LocalDateTime"] | null;
      clockInLocation: components["schemas"]["Geo"] | null;
      clockOutLocation: components["schemas"]["Geo"] | null;
      clockInType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      clockOutType: ("IVR" | "MANUAL" | "MOBILE" | "TIME_SHEET") | null;
      updatedAt: components["schemas"]["Instant"] | null;
      patientAdditionalDocuments: (
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"]
        | components["schemas"]["PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"]
      )[];
    };
    "Record<string,boolean>": { [key: string]: unknown };
    PatientTaskBroadcastDetails:
      | {
          /** @enum {string} */
          type: "Available";
          taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
          patientId: components["schemas"]["PatientId"];
          patientInitials: string;
          certifications: components["schemas"]["CaregiverCertification"][];
          dayTimeParams: components["schemas"]["TaskDayTimeParams"];
          durationMinutes: null | number;
          price: null | number;
          title: string;
          priority: number;
          patientAddress: null | string;
          patientAddressComponents:
            | components["schemas"]["AddressComponents"]
            | null;
          patientAge: null | number;
          patientGender: ("F" | "M") | null;
          patientName: string;
          patientPhoneNumber: null | string;
          patientLanguages: string[];
          startDate: components["schemas"]["LocalDate"];
          dueDate: components["schemas"]["LocalDate"];
          documents: components["schemas"]["PatientTaskInstanceDocument"][];
          hasPlanOfCare: boolean;
          createdBy: components["schemas"]["AgencyMemberId"];
          createdAt: components["schemas"]["Instant"];
          agency: components["schemas"]["Agency"];
          viewedAt: components["schemas"]["Instant"] | null;
          linkedPatientName: null | string;
          linkedPatientTaskInstanceId:
            | components["schemas"]["PatientTaskInstanceId"]
            | null;
        }
      | {
          /** @enum {string} */
          type: "Onboarding";
          taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
          patientId: components["schemas"]["PatientId"];
          patientInitials: string;
          certifications: components["schemas"]["CaregiverCertification"][];
          dayTimeParams: components["schemas"]["TaskDayTimeParams"];
          durationMinutes: null | number;
          title: string;
          patientAddress: null | string;
          patientAddressComponents:
            | components["schemas"]["AddressComponents"]
            | null;
          patientAge: null | number;
          patientGender: ("F" | "M") | null;
          patientLanguages: string[];
          startDate: components["schemas"]["LocalDate"];
          dueDate: components["schemas"]["LocalDate"];
          documents: components["schemas"]["PatientTaskInstanceDocument"][];
          hasPlanOfCare: boolean;
          createdBy: components["schemas"]["AgencyMemberId"];
          createdAt: components["schemas"]["Instant"];
          agency: components["schemas"]["Agency"];
          viewedAt: components["schemas"]["Instant"] | null;
          linkedPatientName: null | string;
          linkedPatientTaskInstanceId:
            | components["schemas"]["PatientTaskInstanceId"]
            | null;
          priority: number;
          price: null | number;
        };
    CaregiverPtoStatusWithYear: {
      year: number;
      label: components["schemas"]["CaregiverPtoLabelId"];
      labelText: string;
      isLabelActive: boolean;
      ptoSettingType: components["schemas"]["CaregiverPtoSettingType"];
      currentYearMinutesUsage: number;
      currentYearMinutesPotential: number;
      totalMinutesUsage: number;
      totalMinutesPotential: number;
    };
    ReportRequestTable: {
      tableName: string;
      columns: components["schemas"]["ReportRequestColumn"][];
    };
    ReportRequestColumn: {
      tableName: string;
      columnName: string;
      columnLabel: string;
      path: null | string;
      aggregate:
        | (
            | "ALL"
            | "ANY"
            | "ARRAY"
            | "COUNT"
            | "DAY"
            | "MAX"
            | "MIN"
            | "MONTH"
            | "SUM"
            | "WEEK"
            | "YEAR"
          )
        | null;
      /** @enum {string} */
      order: "ASC" | "DESC" | "NONE";
    };
    ReportRequestFilter: {
      tableName: string;
      tableColumn: string;
      /** @enum {string} */
      logicalRelationshipWithNextFilter: "AND" | "OR";
      aggregate:
        | (
            | "ALL"
            | "ANY"
            | "ARRAY"
            | "COUNT"
            | "DAY"
            | "MAX"
            | "MIN"
            | "MONTH"
            | "SUM"
            | "WEEK"
            | "YEAR"
          )
        | null;
      operator: components["schemas"]["ReportLogicalOperators"];
      /** @enum {string} */
      srcType?:
        | "AGENCY_MEMBER"
        | "CAREGIVER_CERTIFICATION"
        | "CAREGIVER_STATUS"
        | "CONTRACT_TYPE"
        | "COUNTY"
        | "CUSTOM_LIST"
        | "OFFICE"
        | "PATIENT"
        | "PATIENT_STATUS"
        | "PAYER"
        | "PAY_CODE"
        | "SERVICE_CODE"
        | "STATE"
        | "YEAR";
      customOptions?: {
        id: unknown;
        label: string;
      }[];
      value: components["schemas"]["ReportFilterValueConfig"];
      name: string;
      label: string;
      type: components["schemas"]["ReportColumnTypes"];
      array: boolean;
      nullable: boolean;
      path: null | string;
      range: boolean;
      entityName?: string;
    };
    /** @enum {string} */
    ReportLogicalOperators:
      | "!="
      | "<"
      | "<="
      | "="
      | ">"
      | ">="
      | "ILIKE"
      | "IS NULL"
      | "LAST N X"
      | "LAST REL N X"
      | "LAST X"
      | "NEXT N X"
      | "NEXT REL N X"
      | "NEXT X"
      | "NOT ILIKE"
      | "NOT IS NULL"
      | "NOW REL TIME COMPARE"
      | "THIS X";
    ReportFilterValueConfig:
      | components["schemas"]["ReportFilterValueConfig.StringValue"]
      | components["schemas"]["ReportFilterValueConfig.TimePeriod"]
      | components["schemas"]["ReportFilterValueConfig.TimePeriodInterval"]
      | components["schemas"]["ReportFilterValueConfig.TimePeriodNowRelative"]
      | components["schemas"]["ReportFilterValueConfig.MultiselectValue"]
      | components["schemas"]["ReportFilterValueConfig.TimeComparisonNowRelative"]
      | components["schemas"]["ReportFilterValueConfig.RelativeDateValue"];
    "ReportFilterValueConfig.StringValue": {
      /** @enum {string} */
      type: "string";
      value: string;
    };
    "ReportFilterValueConfig.TimePeriod": {
      /** @enum {string} */
      type: "timePeriod";
      /** @enum {string} */
      timePeriod: "DAY" | "MONTH" | "WEEK" | "YEAR";
    };
    "ReportFilterValueConfig.TimePeriodInterval": {
      /** @enum {string} */
      type: "timePeriodInterval";
      value: {
        interval: number;
        /** @enum {string} */
        timePeriod: "DAYS" | "MONTHS" | "WEEKS" | "YEARS";
      };
    };
    "ReportFilterValueConfig.TimePeriodNowRelative": {
      /** @enum {string} */
      type: "timePeriodNowRelative";
      value: {
        negate: boolean;
        interval: number;
        /** @enum {string} */
        timePeriod: "DAYS" | "HOURS" | "MINUTES";
      };
    };
    "ReportFilterValueConfig.MultiselectValue": {
      /** @enum {string} */
      type: "multiselect";
      value?: unknown[] | null;
    };
    "ReportFilterValueConfig.TimeComparisonNowRelative": {
      /** @enum {string} */
      type: "timeComparisonNowRelative";
      value: {
        /** @enum {string} */
        comparison: "!=" | "<" | "<=" | "=" | ">" | ">=";
        interval: number;
        /** @enum {string} */
        timePeriod: "DAYS" | "HOURS" | "MINUTES";
      };
    };
    "ReportFilterValueConfig.RelativeDateValue": {
      /** @enum {string} */
      type: "relativeDate";
      /** @enum {string} */
      base: "RUN_DATE" | "START_OF_MONTH" | "START_OF_WEEK" | "START_OF_YEAR";
      /** @enum {string} */
      offsetUnit: "DAY" | "MONTH" | "WEEK" | "YEAR";
      offsetAmount: number;
    };
    /** @enum {string} */
    ReportColumnTypes:
      | "BOOLEAN"
      | "DATE"
      | "MULTISELECT"
      | "NUMBER"
      | "STRING"
      | "TIME"
      | "TIMESTAMP"
      | "TIMESTAMPTZ";
    ReportRequestFilterWithDisplayAttributes: {
      filterSelected?: boolean;
      isLocked?: boolean;
      /** @enum {string} */
      operator?:
        | "!="
        | "<"
        | "<="
        | "="
        | ">"
        | ">="
        | "ILIKE"
        | "IS NULL"
        | "LAST N X"
        | "LAST REL N X"
        | "LAST X"
        | "NEXT N X"
        | "NEXT REL N X"
        | "NEXT X"
        | "NOT ILIKE"
        | "NOT IS NULL"
        | "NOW REL TIME COMPARE"
        | "THIS X";
      description?: string;
      /** @enum {string} */
      srcType?:
        | "AGENCY_MEMBER"
        | "CAREGIVER_CERTIFICATION"
        | "CAREGIVER_STATUS"
        | "CONTRACT_TYPE"
        | "COUNTY"
        | "CUSTOM_LIST"
        | "OFFICE"
        | "PATIENT"
        | "PATIENT_STATUS"
        | "PAYER"
        | "PAY_CODE"
        | "SERVICE_CODE"
        | "STATE"
        | "YEAR";
      customOptions?: {
        id: unknown;
        label: string;
      }[];
      value: components["schemas"]["ReportFilterValueConfig"];
      name: string;
      label: string;
      type: components["schemas"]["ReportColumnTypes"];
      array: boolean;
      nullable: boolean;
      path: null | string;
      range: boolean;
      entityName?: string;
    };
    /** Format: SavedReportId */
    SavedReportId: SavedReportId;
    StandardReport: {
      id: components["schemas"]["StandardReportId"];
      created_by: components["schemas"]["UserId"] | null;
      created_at: components["schemas"]["Instant"];
      updated_at: components["schemas"]["Instant"] | null;
      name: string;
      category: null | string;
      report_type: null | string;
      report_template: components["schemas"]["CustomReportRequestBase"];
      report_table_def: unknown;
      class_name?: null | string;
      description: null | string;
    };
    /** Format: StandardReportId */
    StandardReportId: StandardReportId;
    CustomReportRequestBase: {
      filters: components["schemas"]["ReportRequestFilterWithDisplayAttributes"][];
      allowEmpty: boolean;
      id?: number;
      /** @enum {string} */
      reportType?: "CUSTOM" | "REPORTING_TOOL";
    };
    StandardReportWithVisabilityAttributes: {
      agency_is_shown: null | boolean;
      is_shown: boolean;
      id: components["schemas"]["StandardReportId"];
      created_by: components["schemas"]["UserId"] | null;
      created_at: components["schemas"]["Instant"];
      updated_at: components["schemas"]["Instant"] | null;
      name: string;
      category: null | string;
      report_type: null | string;
      report_template: components["schemas"]["CustomReportRequestBase"];
      report_table_def: unknown;
      class_name?: null | string;
      description: null | string;
    };
    /** Format: AgencyRoleId */
    AgencyRoleId: AgencyRoleId;
    ScheduledSavedReportWithHistory: {
      scheduledReport: components["schemas"]["ScheduledSavedReport"];
      history: components["schemas"]["ScheduledSavedReportHistory"][];
    };
    ScheduledSavedReport: {
      id: components["schemas"]["ScheduledSavedReportId"];
      periodType: string;
      timeInDay: string;
      interval: null | number;
      dayOfWeek: null | string;
      dayOfMonth: null | number;
      active: boolean;
      recipientEmails: string[];
    };
    /** Format: ScheduledSavedReportId */
    ScheduledSavedReportId: ScheduledSavedReportId;
    ScheduledSavedReportHistory: {
      id: components["schemas"]["ScheduledSavedReportJobHistoryId"];
      scheduledSavedReportId: components["schemas"]["ScheduledSavedReportId"];
      originalRuntime: components["schemas"]["Instant"];
      success: boolean;
      message: string;
    };
    /** Format: ScheduledSavedReportJobHistoryId */
    ScheduledSavedReportJobHistoryId: ScheduledSavedReportJobHistoryId;
    ReportRequest: {
      primaryTable: components["schemas"]["ReportRequestTable"];
      tables: components["schemas"]["ReportRequestTable"][];
      columns: components["schemas"]["ReportRequestColumn"][];
      filters: components["schemas"]["ReportRequestFilter"][];
      allowEmpty: boolean;
      id?: number;
      /** @enum {string} */
      reportType?: "CUSTOM" | "REPORTING_TOOL";
    };
    EntityNote:
      | ({
          /** @enum {string} */
          noteType:
            | "adjustment_approval"
            | "missed_visit_instance"
            | "visit_distance_approval"
            | "visit_instance"
            | "visit_instance_edit"
            | "visit_manual_remove";
          instances: {
            id: components["schemas"]["VisitInstanceId"];
            startTime: components["schemas"]["LocalDateTime"];
            endTime: components["schemas"]["LocalDateTime"];
          }[];
        } & components["schemas"]["BaseNote"])
      | ({
          /** @enum {string} */
          noteType: "caregiver_pto";
          instances: {
            id: components["schemas"]["CaregiverPtoInstanceId"];
          }[];
        } & components["schemas"]["BaseNote"])
      | ({
          /** @enum {string} */
          noteType: "caregiver_absence";
          instances: {
            id: components["schemas"]["CaregiverAbsenceId"];
          }[];
        } & components["schemas"]["BaseNote"])
      | ({
          /** @enum {string} */
          noteType: "visit_assignment_note";
          instances: {
            id: components["schemas"]["VisitInstanceId"];
            startTime: components["schemas"]["LocalDateTime"];
            endTime: components["schemas"]["LocalDateTime"];
          }[];
        } & components["schemas"]["BaseNote"])
      | ({
          /** @enum {string} */
          noteType:
            | "agency_member_remove_task_visit"
            | "bulk"
            | "calendar"
            | "caregiver_exclusion"
            | "caregiver_remove_task_visit"
            | "caregiver_status_change"
            | "patient_authorization"
            | "patient_status"
            | "phone_call"
            | "profile_note"
            | "removed_task"
            | "visit_instance_caregiver_unassign"
            | "visit_manual_clock_time";
        } & components["schemas"]["BaseNote"]);
    BaseNote: {
      id: components["schemas"]["NoteId"];
      noteRichText: null | string;
      subject: {
        id: components["schemas"]["NoteSubjectId"];
        text: string;
      } | null;
      followUp: components["schemas"]["LocalDate"] | null;
      status: string;
      comments: components["schemas"]["NoteComment"][];
      calendarDate: components["schemas"]["LocalDate"] | null;
      author: {
        id: components["schemas"]["AgencyMemberId"];
        firstName: string;
        lastName: string;
        photoUrl: null | string;
      };
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      noteType: components["schemas"]["NoteTypes"];
      notePredefinedAnswerId:
        | components["schemas"]["NotePredefinedAnswerId"]
        | null;
      predefinedAnswerText: null | string;
      files: components["schemas"]["NoteFile"][];
    };
    NoteSubject: {
      id: components["schemas"]["NoteSubjectId"];
      text: string;
      active: boolean;
      showOnCaregiverProfile: boolean;
      showOnPatientProfile: boolean;
      agencyId: components["schemas"]["AgencyId"] | null;
    };
    EntityNoteSetting: {
      id: components["schemas"]["EntityNoteSettingId"];
      agencyId: components["schemas"]["AgencyId"] | null;
      noteType: components["schemas"]["NoteTypes"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"] | null;
      removedAt: components["schemas"]["Instant"] | null;
      hasPredefinedField: boolean;
      isPredefinedMandatory: boolean;
      hasMessageField: boolean;
      isMessageMandatory: boolean;
      showOnPatientProfile: boolean;
      showOnCaregiverProfile: boolean;
      predefinedAnswers: components["schemas"]["NotePredefinedAnswer"][];
    };
    /** Format: EntityNoteSettingId */
    EntityNoteSettingId: EntityNoteSettingId;
    NotePredefinedAnswer: {
      id: components["schemas"]["NotePredefinedAnswerId"];
      entityNoteSettingId: components["schemas"]["EntityNoteSettingId"];
      text: string;
      active: boolean;
    };
    AgencyRolePermissions: {
      id: components["schemas"]["AgencyRoleId"];
      name: string;
      permissions: components["schemas"]["AgencyMemberPermission"][];
    };
    CaregiverExlusionDataNew: {
      exclusionId: components["schemas"]["CaregiverExclusionId"];
      createdAt: components["schemas"]["Instant"];
      id: components["schemas"]["CaregiverId"];
      displayId: null | number;
      ssn: null | string;
      fullName: string;
      nameOfList: string;
      nameInList: null | string;
      originalRow: null | string;
      headers: string[] | null;
      rowJson: unknown;
      dataSourceName: string;
      dataSourceSignedUrl: string;
      rowNum: null | number;
      reviewedAt: components["schemas"]["Instant"] | null;
      reviewedBy: components["schemas"]["AgencyMemberId"] | null;
      reviewedByName: null | string;
      noteText: null | string;
      notePredefinedAnswer: null | string;
      flagged: null | boolean;
      noMatch: boolean;
    };
    /** Format: CaregiverExclusionId */
    CaregiverExclusionId: CaregiverExclusionId;
    HHAIntegrationPatientDemRecord: {
      id: components["schemas"]["HHAIntegrationNonBillingFileRecordId"];
      fileId: components["schemas"]["HHAIntegrationImportedFileId"];
      fileCreationDate: components["schemas"]["LocalDate"];
      payerId: components["schemas"]["PayerId"] | null;
      content: components["schemas"]["HHAExchangePatientDemFileRecord"];
      possibleMfPatientMatches: components["schemas"]["MergeableHHAXPatientFileRecord"][];
      hhaxMedicaidNumber: null | string;
      hhaxMemberId: null | string;
      hhaxPayerCode: null | number;
      officesIds: components["schemas"]["OfficeId"][];
      status: string;
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
    };
    /** Format: HHAIntegrationNonBillingFileRecordId */
    HHAIntegrationNonBillingFileRecordId: HHAIntegrationNonBillingFileRecordId;
    /** Format: HHAIntegrationImportedFileId */
    HHAIntegrationImportedFileId: HHAIntegrationImportedFileId;
    HHAExchangePatientDemFileRecord: {
      payerID?: null | number;
      agencyTaxID?: string;
      PatientID?: null | number;
      admissionID?: string;
      firstName?: string;
      middleName?: string;
      lastName?: string;
      mrNumber?: string;
      gender?: string;
      dob?: components["schemas"]["LocalDate"] | null;
      priorityCode?: null | number;
      medicaidNumber?: string;
      street1?: string;
      street2?: string;
      city?: string;
      state?: string;
      zip?: null | number;
      crossStreet?: string;
      homePhone?: string;
      phone2?: string;
      phone2Description?: string;
      phone3?: string;
      phone3Description?: string;
      emergency1Name?: string;
      emergency1Address?: string;
      emergency1Relationship?: string;
      emergency1Phone1?: string;
      emergency1Phone2?: string;
      emergency2Name?: string;
      emergency2Address?: string;
      emergency2Relationship?: string;
      emergency2Phone1?: string;
      emergency2Phone2?: string;
      status?: string;
      startOfCareDate?: components["schemas"]["LocalDate"] | null;
      dischargeDate?: components["schemas"]["LocalDate"] | null;
      payerCoordinator?: string;
      agencyCoordinator?: string;
      frequency?: string;
      sourceOfAdmission?: string;
      location?: string;
      team?: string;
      branch?: string;
      modifiedDate?: components["schemas"]["LocalDate"] | null;
      isDeletion?: string;
      alternatePatientID?: string;
      userField1?: string;
      userField2?: string;
      userField3?: string;
      userField4?: string;
      userField5?: string;
      userField6?: string;
      userField7?: string;
    };
    MergeableHHAXPatientFileRecord: {
      fileRecordId: components["schemas"]["HHAIntegrationNonBillingFileRecordId"];
      fileRecordFileId: components["schemas"]["HHAIntegrationImportedFileId"];
      fileRecordContent:
        | components["schemas"]["HHAExchangePatientDemFileRecord"]
        | null;
      fileRecordNoteId: components["schemas"]["NoteId"] | null;
      fileRecordUpdatedAt: components["schemas"]["Instant"] | null;
      fileRecordUpdatedBy: components["schemas"]["AgencyMemberId"] | null;
      hhaxMemberNumber: null | string;
      hhaxMedicaidNumber: null | string;
      contractMedicaidNumber: null | string;
      contractMemberId: string;
      agencyId: components["schemas"]["AgencyId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      contractId: components["schemas"]["PatientContractId"];
      patientId: components["schemas"]["PatientId"];
    };
    HHAIntegrationAuthFileRecord: {
      id: components["schemas"]["HHAIntegrationNonBillingFileRecordId"];
      fileId: components["schemas"]["HHAIntegrationImportedFileId"];
      fileCreationDate: components["schemas"]["LocalDate"];
      payerId: components["schemas"]["PayerId"] | null;
      content: components["schemas"]["HHAExchangeAuthorizationFile"];
      dxCodes: string[];
      mergeablePatients: components["schemas"]["MergeableAuthPatient"][];
      mergeableAuthorizations: components["schemas"]["AuthorizationWithDxCodes"][];
      hhaxPatientDetails: components["schemas"]["HHAXPatientDetails"];
      status: string;
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
    };
    HHAExchangeAuthorizationFile: {
      payerID: null | number;
      agencyTaxID: null | string;
      patientID: null | number;
      authorizationID: null | number;
      admissionID: null | string;
      serviceCategory: null | string;
      serviceType: null | string;
      authorizationNumber: null | string;
      billingServiceCode: null | string;
      fromDate: components["schemas"]["LocalDate"] | null;
      toDate: components["schemas"]["LocalDate"] | null;
      authorizationType: null | string;
      hoursPerWeek: null | number;
      hoursPerMonth: null | number;
      hoursPerAuthPeriod: null | number;
      satHours: null | number;
      /** @enum {string} */
      satStartTime?:
        | "AM"
        | "ANY"
        | "BETWEEN"
        | "DAYSHIFT"
        | "NIGHTSHIFT"
        | "PM";
      satBetweenFromTime: null | number;
      satBetweenToTime: null | number;
      sunHours: null | number;
      /** @enum {string} */
      sunStartTime?:
        | "AM"
        | "ANY"
        | "BETWEEN"
        | "DAYSHIFT"
        | "NIGHTSHIFT"
        | "PM";
      sunBetweenFromTime: null | number;
      sunBetweenToTime: null | number;
      monHours: null | number;
      /** @enum {string} */
      monStartTime?:
        | "AM"
        | "ANY"
        | "BETWEEN"
        | "DAYSHIFT"
        | "NIGHTSHIFT"
        | "PM";
      monBetweenFromTime: null | number;
      monBetweenToTime: null | number;
      tueHours: null | number;
      /** @enum {string} */
      tueStartTime?:
        | "AM"
        | "ANY"
        | "BETWEEN"
        | "DAYSHIFT"
        | "NIGHTSHIFT"
        | "PM";
      tueBetweenFromTime: null | number;
      tueBetweenToTime: null | number;
      wedHours: null | number;
      /** @enum {string} */
      wedStartTime?:
        | "AM"
        | "ANY"
        | "BETWEEN"
        | "DAYSHIFT"
        | "NIGHTSHIFT"
        | "PM";
      wedBetweenFromTime: null | number;
      wedBetweenToTime: null | number;
      thuHours: null | number;
      /** @enum {string} */
      thuStartTime?:
        | "AM"
        | "ANY"
        | "BETWEEN"
        | "DAYSHIFT"
        | "NIGHTSHIFT"
        | "PM";
      thuBetweenFromTime: null | number;
      thuBetweenToTime: null | number;
      friHours: null | number;
      /** @enum {string} */
      friStartTime?:
        | "AM"
        | "ANY"
        | "BETWEEN"
        | "DAYSHIFT"
        | "NIGHTSHIFT"
        | "PM";
      friBetweenFromTime: null | number;
      friBetweenToTime: null | number;
      notes: null | string;
      modifiedDate: components["schemas"]["LocalDate"] | null;
      isDeletion: null | string;
      additionalRules: null | string;
      maximumVisits1: null | number;
      per1: null | string;
      ofXHours1: null | number;
      maximumVisits2: null | number;
      per2: null | string;
      ofXHours2: null | number;
      maximumVisits3: null | number;
      per3: null | string;
      ofXHours3: null | number;
      maximumVisits4: null | number;
      per4: null | string;
      ofXHours4: null | number;
      maximumVisits5: null | number;
      per5: null | string;
      ofXHours5: null | number;
      maximumVisits6: null | number;
      per6: null | string;
      ofXHours6: null | number;
      maximumVisits7: null | number;
      per7: null | string;
      ofXHours7: null | number;
      userField1: null | string;
      userField2: null | string;
      userField3: null | string;
      userField4: null | string;
      userField5: null | string;
      userField6: null | string;
      userField7: null | string;
    };
    MergeableAuthPatient: {
      fileRecordId: components["schemas"]["HHAIntegrationNonBillingFileRecordId"];
      patientId: components["schemas"]["PatientId"];
      officeId: components["schemas"]["OfficeId"];
    };
    AuthorizationWithDxCodes: {
      dxCodes: null | string;
      id: components["schemas"]["AuthorizationId"];
      code: null | string;
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      maxMinutes: number;
      minutes: number;
      patientContractId: components["schemas"]["PatientContractId"];
      periodType: components["schemas"]["AuthorizationPeriodType"];
      files: components["schemas"]["PatientAuthorizationFileId"][];
      serviceCode: components["schemas"]["ServiceCodeId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"];
      updatedAt: components["schemas"]["Instant"];
      updatedBy: components["schemas"]["AgencyMemberId"];
      firstDayOfWeek: components["schemas"]["DayOfWeek"];
      mondayMinutes: null | number;
      tuesdayMinutes: null | number;
      wednesdayMinutes: null | number;
      thursdayMinutes: null | number;
      fridayMinutes: null | number;
      saturdayMinutes: null | number;
      sundayMinutes: null | number;
      removedBy?: components["schemas"]["AgencyMemberId"] | null;
      removedAt?: components["schemas"]["Instant"] | null;
      note: components["schemas"]["Note"] | null;
      externalId: null | string;
      createVisitOfficeIdOverride: components["schemas"]["OfficeId"] | null;
      restrictions:
        | components["schemas"]["AuthorizationTimeConfig.WeeklyRestriction"][]
        | null;
      /**
       * @description Illinois DHS/DRS district number, labelled "Caseload" on the authorization
       * document. Printed in the District column of the IL488-2387 monthly billing
       * statement, and unused by every other contract type.
       */
      districtNumber: null | string;
    };
    HHAXPatientDetails: {
      hhaxPatientId: null | number;
      hhaxPatientFirstName: null | string;
      hhaxPatientLastName: null | string;
      hhaxPatientMedicaidNumber: null | string;
      hhaxPatientMemberId: null | string;
    };
    HHAIntegrationPOCFileRecord: {
      id: components["schemas"]["HHAIntegrationNonBillingFileRecordId"];
      fileId: components["schemas"]["HHAIntegrationImportedFileId"];
      fileCreationDate: components["schemas"]["LocalDate"];
      payerId: components["schemas"]["PayerId"] | null;
      content: components["schemas"]["HHAExchangePOCFile"];
      mergeablePatients: components["schemas"]["MergeablePOCPatient"][];
      hhaxPatientDetails: components["schemas"]["HHAXPatientDetails"];
      status: string;
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["AgencyMemberId"] | null;
    };
    HHAExchangePOCFile: {
      payerID?: null | number;
      agencyTaxID?: string;
      patientID?: null | number;
      pocID?: null | number;
      pocStartDate?: components["schemas"]["LocalDate"] | null;
      pocStopDate?: components["schemas"]["LocalDate"] | null;
      pocNote?: string;
      pocTasks?: string;
      createdDate?: components["schemas"]["LocalDate"] | null;
      isDeletion?: string;
      userField1?: string;
      userField2?: string;
      userField3?: string;
      userField4?: string;
      userField5?: string;
      userField6?: string;
      userField7?: string;
    };
    MergeablePOCPatient: {
      fileRecordId: components["schemas"]["HHAIntegrationNonBillingFileRecordId"];
      patientId: components["schemas"]["PatientId"];
      officeId: components["schemas"]["OfficeId"];
      medflytPOCItemIds: components["schemas"]["PlanOfCareItemId"][];
      hhaxPOCTaskNames: string;
      hhaxPOCTasksIdsNotMapped: string[];
    };
    HHAXIntegrationUnlinkedPatient: {
      hhaxPatientId: number;
      medicaidNumber: null | string;
      memberId: null | string;
      firstName: null | string;
      lastName: null | string;
    };
    HHAIntegrationRejectedVisitRecord: {
      patientMedicaidNumber: null | string;
      patientMemberId: string;
      exportBatchId: components["schemas"]["ExportBatchId"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      invoiceVisitId: components["schemas"]["InvoiceVisitId"];
      invoiceId: components["schemas"]["InvoiceId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      officeId: components["schemas"]["OfficeId"];
      scheduledStartTime: components["schemas"]["LocalDateTime"];
      scheduledEndTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
      patientDisplayId: null | number;
      patientFirstName: string;
      patientLastName: string;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverDisplayId: null | number;
      caregiverFirstName: null | string;
      caregiverLastName: null | string;
      issue: string;
      exportedAt: components["schemas"]["Instant"];
      billingAmount: null | number;
    };
    HHAIntegrationBillingExceptionVisitRecord: {
      hhaIntegrationBillingFileRecordId: components["schemas"]["HHAIntegrationBillingFileRecordId"];
      hhaIntegrationBillingFileName: string;
      hhaIntegrationBillingFileDatetime: components["schemas"]["LocalDateTime"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      invoiceVisitId: components["schemas"]["InvoiceVisitId"];
      invoiceId: components["schemas"]["InvoiceId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      officeId: components["schemas"]["OfficeId"];
      scheduledStartTime: components["schemas"]["LocalDateTime"];
      scheduledEndTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
      patientDisplayId: null | number;
      patientFirstName: string;
      patientLastName: string;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverDisplayId: null | number;
      caregiverFirstName: null | string;
      caregiverLastName: null | string;
      issue: string;
      exportedAt: components["schemas"]["Instant"];
      billingAmount: null | number;
    };
    /** Format: HHAIntegrationBillingFileRecordId */
    HHAIntegrationBillingFileRecordId: HHAIntegrationBillingFileRecordId;
    HHAIntegrationPreAdjRejectionsVisitRecord: {
      hhaIntegrationBillingFileRecordId: components["schemas"]["HHAIntegrationBillingFileRecordId"];
      hhaIntegrationBillingFileName: string;
      hhaIntegrationBillingFileDatetime: components["schemas"]["LocalDateTime"];
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      invoiceVisitId: components["schemas"]["InvoiceVisitId"];
      invoiceId: components["schemas"]["InvoiceId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      serviceCodeId: components["schemas"]["ServiceCodeId"] | null;
      officeId: components["schemas"]["OfficeId"];
      scheduledStartTime: components["schemas"]["LocalDateTime"];
      scheduledEndTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
      patientDisplayId: null | number;
      patientFirstName: string;
      patientLastName: string;
      caregiverId: components["schemas"]["CaregiverId"] | null;
      caregiverDisplayId: null | number;
      caregiverFirstName: null | string;
      caregiverLastName: null | string;
      issue: string;
      exportedAt: components["schemas"]["Instant"];
      billingAmount: null | number;
    };
    BillingPayrollApprovalByVisit: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      latestChangeId: components["schemas"]["EntityChangeEventId"];
    };
    /** Format: EntityChangeEventId */
    EntityChangeEventId: EntityChangeEventId;
    /** @enum {string} */
    AdjustmentApprovalStatus: "APPROVED" | "IGNORED" | "REJECTED";
    CaregiverPtoInstancesCreateParams: {
      label: components["schemas"]["CaregiverPtoLabelId"];
      ptos: components["schemas"]["CaregiverPtoInstanceCreateParams"][];
      note?: components["schemas"]["AgencyNoteCreateParams"];
    };
    CaregiverPtoInstanceCreateParams: {
      duration: number;
      visitInstanceId: components["schemas"]["VisitInstanceId"];
    };
    CaregiverTaskTypesForWebapp:
      | components["schemas"]["PatientTaskTypes.FutureTask"]
      | components["schemas"]["PatientTaskInstanceWithDetails"];
    EligibilityCheck: {
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["AgencyMemberId"] | null;
      patientId: components["schemas"]["PatientId"];
      /**
       * @description Denormalised: the page labels each row with the patient's name, display id,
       * status, office, team and coordinator.
       */
      patient: components["schemas"]["PatientRowDisplay"] | null;
      isEligible: null | boolean;
      isEligibleOnDifferentPayer: boolean;
      activeContractTypes: components["schemas"]["ContractTypeId"][] | null;
      responsePayerName: null | string;
      vendorResponse: unknown;
      message: null | string;
    };
    EligibilityCheckForIntakePatient: {
      createdAt: components["schemas"]["Instant"];
      createdBy: null | string;
      isEligible: null | boolean;
      vendorResponse: unknown;
      error: {
        type: components["schemas"]["EligibilityCheckErrors"];
        message: string;
      } | null;
    };
    /** @enum {string} */
    EligibilityCheckErrors:
      | "ACCESS_BLOCKED"
      | "CANT_PARSE_RESULT"
      | "COMBINATION_INVALID"
      | "INACTIVE_MEDICAID_STATUS"
      | "INACTIVE_MEDICAID_STATUS_NO_COVARAGE_EXCESS_INCOME"
      | "NO_CLIENT_ID_IN_RESPONSE"
      | "NO_MEDICAID"
      | "NO_MEDICAID_OR_SSN"
      | "NO_PATIENT_DETAILS"
      | "REMOTE_SERVER_ERROR"
      | "SYSTEM_ERROR"
      | "UNKNOWN_ERROR"
      | "WRONG_MEMBER_ID";
    VoConflictReport: {
      visit1: components["schemas"]["VoConflictReportResultsVisit"];
      visit2: components["schemas"]["VoConflictReportResultsVisit"];
    };
    VoConflictReportResultsVisit: {
      id: components["schemas"]["VisitInstanceId"];
      agencyName: string;
      caregiverName: string;
      patientName: string;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      clockinTime: components["schemas"]["LocalDateTime"] | null;
      clockoutTime: components["schemas"]["LocalDateTime"] | null;
    };
    VoVisitReportResultsVisit: {
      id: components["schemas"]["VisitInstanceId"];
      agencyId: components["schemas"]["AgencyId"];
      patientId: components["schemas"]["PatientId"];
      caregiverName: string;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      clockinTime: components["schemas"]["LocalDateTime"] | null;
      clockinType: null | string;
      clockoutTime: components["schemas"]["LocalDateTime"] | null;
      clockoutType: null | string;
      partial: boolean;
      billed: boolean;
    };
    VoVisitRejectionsReportResultsVisit: components["schemas"]["VoVisitReportResultsVisit"] & {
      rejectionCode: string;
      rejectionResolution: string;
    };
    VoDashboardReasonCount: {
      code: string;
      count: number;
    };
    /** Format: LandingPageToken */
    LandingPageToken: string;
    "Partial<CaregiverStaffingPreferencesResponse>": {
      workWithKids?: null | boolean;
      workWithSmokingPatient?: null | boolean;
      smokingCaregiver?: null | boolean;
      workWithPets?: null | boolean;
      workWithBedbound?: null | boolean;
      workWithWalkingAsistant?: null | boolean;
      workWithKosher?: null | boolean;
      workWithHalal?: null | boolean;
      workWithHoyerLift?: null | boolean;
      workWithShabat?: null | boolean;
      languages?: string[] | null;
      mainLanguage?: null | string;
      transportationType?: null | string;
      publicTransprotationTimeLimit?: null | number;
      casesLength?: string[] | null;
      workTimes?: null | string;
      studying?: null | boolean;
      studyingTimes?: null | string;
      patientsTypes?: string[] | null;
      additionalInfo?: null | string;
    };
    CaregiverPreferencesSettingsSection: {
      layoutOrder: number;
      title: string;
      preferences: components["schemas"]["CaregiverPreferenceForMobile"][];
    };
    CaregiverPreferenceForMobile:
      | components["schemas"]["CaregiverPreferenceMobileSwitch"]
      | components["schemas"]["CaregiverPreferenceMobileSelect"]
      | components["schemas"]["CaregiverPreferenceMobileMultiSelect"]
      | components["schemas"]["CaregiverPreferenceMobileText"];
    CaregiverPreferenceMobileSwitch: {
      /** @enum {string} */
      questionType: "Switch";
      label: string;
      type: components["schemas"]["CaregiverPreferenceBooleanTypes"];
      answer: boolean;
    };
    /** @enum {string} */
    CaregiverPreferenceBooleanTypes:
      | "smoking_caregiver"
      | "studying"
      | "work_with_bedbound"
      | "work_with_halal"
      | "work_with_hoyer_lift"
      | "work_with_kids"
      | "work_with_kosher"
      | "work_with_pets"
      | "work_with_shabat"
      | "work_with_smoking_patient"
      | "work_with_walking_asistant";
    CaregiverPreferenceMobileSelect: {
      /** @enum {string} */
      questionType: "Select";
      label: string;
      type: components["schemas"]["CaregiverPreferenceSelectTypes"];
      options: {
        title: string;
        value: string | number;
      }[];
      answer: null | string | number;
    };
    /** @enum {string} */
    CaregiverPreferenceSelectTypes:
      | "main_language"
      | "public_transprotation_time_limit"
      | "transportation_type"
      | "work_times";
    CaregiverPreferenceMobileMultiSelect: {
      /** @enum {string} */
      questionType: "MultiSelect";
      label: string;
      type: components["schemas"]["CaregiverPreferenceMultiSelectTypes"];
      options: {
        title: string;
        value: string;
      }[];
      answer: string[];
    };
    /** @enum {string} */
    CaregiverPreferenceMultiSelectTypes:
      | "cases_length"
      | "languages"
      | "patients_types";
    CaregiverPreferenceMobileText: {
      /** @enum {string} */
      questionType: "Text";
      label: string;
      type: components["schemas"]["CaregiverPreferenceTextTypes"];
      answer: null | string;
    };
    /** @enum {string} */
    CaregiverPreferenceTextTypes: "additional_info" | "studying_times";
    CommCenterTicketSourceLabel: {
      source: components["schemas"]["CommCenterTicketSource"];
      label: string;
    };
    /** @enum {string} */
    CommCenterTicketSource:
      | "EMAIL"
      | "MANUAL"
      | "MOBILE_CHAT"
      | "PHONE_CALL"
      | "SMS_CONVERSATION"
      | "SYSTEM_TRIGGER";
    CommCenterTicket: {
      id: components["schemas"]["CommCenterTicketId"];
      agencyId: components["schemas"]["AgencyId"];
      status: components["schemas"]["CommCenterTicketStatus"];
      enableAgencyResponse: boolean;
      priority: components["schemas"]["CommCenterLabelPriority"];
      createdAt: components["schemas"]["Instant"];
      source: components["schemas"]["CommCenterTicketSource"];
      topic: components["schemas"]["CommCenterTicketTopic"];
      label: components["schemas"]["CommCenterLabel"] | null;
      createdBy: components["schemas"]["CommCenterTicketCreatedBy"];
      phoneNumber: null | string;
      relatedCaregiver: {
        id: components["schemas"]["CaregiverId"];
        name: string;
        photoUrl: null | string;
        status: components["schemas"]["CaregiverStatus"];
        displayId: null | number;
        onboardingStageDetails: {
          id: components["schemas"]["HRSectionStageId"];
          name: string;
        } | null;
      } | null;
      relatedPatient:
        | components["schemas"]["CommCenterTicketRelatedPatient"]
        | null;
      relatedVisitBroadcast: {
        id: components["schemas"]["VisitBroadcastId"];
        startTime: components["schemas"]["LocalDateTime"];
        endTime: components["schemas"]["LocalDateTime"];
        patient: components["schemas"]["CommCenterTicketRelatedPatient"] | null;
      } | null;
      relatedVisitInstance: {
        id: components["schemas"]["VisitInstanceId"];
        startTime: components["schemas"]["LocalDateTime"];
        endTime: components["schemas"]["LocalDateTime"];
        patient: components["schemas"]["CommCenterTicketRelatedPatient"] | null;
      } | null;
      relatedTeam: {
        id: components["schemas"]["CommCenterTeamId"];
        name: string;
      };
      assignedTo: {
        id: components["schemas"]["CommCenterTeamMemberId"];
        name: string;
      } | null;
      messages: components["schemas"]["CommCenterMessage"][];
      statusChanges: components["schemas"]["CommCenterTicketStatusChange"][];
      assigneeChanges: components["schemas"]["CommCenterTicketAssigneeChange"][];
      callInfo:
        | components["schemas"]["CommCenterTicketTelephonyCallInfo"]
        | null;
      chatSummaryDetails:
        | components["schemas"]["CommCenterChatSummaryDetails"]
        | null;
      agencyReponseMeasureStartTime: components["schemas"]["Instant"] | null;
      relatedNotIdentifiedPhoneNumber: null | string;
      relatedNotIdentifiedPhoneNumberId:
        | components["schemas"]["CallSessionNotIdentifiedCallerCalleeId"]
        | null;
      relatedPhonebookContact: {
        id: components["schemas"]["AgencyPhonebookContactId"];
        name: string;
      } | null;
      emailThread: components["schemas"]["CommCenterEmailThread"] | null;
      relatedNotIdentifiedEmailEntity: null | string;
      relatedTaskInstanceId:
        | components["schemas"]["PatientTaskInstanceId"]
        | null;
    };
    /** @enum {string} */
    CommCenterTicketStatus: "IN PROGRESS" | "NEW" | "RESOLVED";
    /** @enum {string} */
    CommCenterLabelPriority: "HIGH" | "LOW" | "MEDIUM";
    /** @enum {string} */
    CommCenterTicketTopic:
      | "BotAgent"
      | "Caregiver"
      | "NotIdentifiedEmailEntity"
      | "NotIdentifiedPhoneNumber"
      | "Patient"
      | "PhonebookContact";
    CommCenterLabel: {
      id: components["schemas"]["CommCenterLabelId"];
      agencyId: components["schemas"]["AgencyId"];
      name: string;
      active: boolean;
      parent: components["schemas"]["CommCenterLabelId"] | null;
      messageActionId:
        | components["schemas"]["CommCenterMessageActionId"]
        | null;
      priority: components["schemas"]["CommCenterLabelPriority"];
      timeToResolve: number;
      assignedTeamId: components["schemas"]["CommCenterTeamId"];
      iconUrl: null | string;
      code: null | string;
    };
    /** Format: CommCenterLabelId */
    CommCenterLabelId: CommCenterLabelId;
    /** Format: CommCenterMessageActionId */
    CommCenterMessageActionId: CommCenterMessageActionId;
    /** Format: CommCenterTeamId */
    CommCenterTeamId: CommCenterTeamId;
    CommCenterTicketCreatedBy:
      | components["schemas"]["CommCenterTicketCreatedBy.Caregiver"]
      | components["schemas"]["CommCenterTicketCreatedBy.AgencyMember"]
      | components["schemas"]["CommCenterTicketCreatedBy.System"]
      | components["schemas"]["CommCenterTicketCreatedBy.Patient"];
    "CommCenterTicketCreatedBy.Caregiver": {
      /** @enum {string} */
      type: "Caregiver";
      id: components["schemas"]["CaregiverId"];
      name: string;
    };
    "CommCenterTicketCreatedBy.AgencyMember": {
      /** @enum {string} */
      type: "Agency Member";
      id: components["schemas"]["AgencyMemberId"];
      name: string;
    };
    "CommCenterTicketCreatedBy.System": {
      /** @enum {string} */
      type: "System";
    };
    "CommCenterTicketCreatedBy.Patient": {
      /** @enum {string} */
      type: "Patient";
      id: components["schemas"]["PatientId"];
      name: string;
    };
    CommCenterTicketRelatedPatient: {
      id: components["schemas"]["PatientId"];
      name: string;
      status: components["schemas"]["PatientStatus"];
      displayId: null | number;
      gender: null | string;
      clinicalSeverityLevel:
        | ("HIGHEST_ASSISTANCE" | "MINIMAL_ASSISTANCE" | "WALKING_ASSISTANCE")
        | null;
    };
    /** Format: CommCenterTeamMemberId */
    CommCenterTeamMemberId: CommCenterTeamMemberId;
    CommCenterMessage: {
      id: components["schemas"]["CommCenterMessageId"];
      createdAt: components["schemas"]["Instant"];
      ticketId: components["schemas"]["CommCenterTicketId"];
      payload: (
        | components["schemas"]["CommCenterMessagePayloadText"]
        | components["schemas"]["CommCenterMessagePayloadImage"]
        | components["schemas"]["CommCenterMessagePayloadAction"]
        | components["schemas"]["CommCenterMessagePayloadDocument"]
        | components["schemas"]["CommCenterMessagePayloadVideo"]
        | components["schemas"]["CommCenterMessagePayloadOnboardingMessage"]
      )[];
      messageActionId:
        | components["schemas"]["CommCenterMessageActionId"]
        | null;
      createdBy: components["schemas"]["CommCenterMessageCreatedBy"];
      labelId: components["schemas"]["CommCenterLabelId"] | null;
      readAt: components["schemas"]["Instant"] | null;
    };
    /** Format: CommCenterMessageId */
    CommCenterMessageId: CommCenterMessageId;
    CommCenterMessagePayloadText: {
      /** @enum {string} */
      type: "TEXT";
      message: string;
    };
    CommCenterMessagePayloadImage: {
      /** @enum {string} */
      type: "IMAGE";
      url: string;
    };
    CommCenterMessagePayloadAction: {
      /** @enum {string} */
      type: "ACTION";
      id: components["schemas"]["CommCenterMessageActionId"];
      payload:
        | components["schemas"]["CommCenterMessagePayloadActionText"]
        | components["schemas"]["CommCenterMessagePayloadActionImage"]
        | components["schemas"]["CommCenterMessagePayloadActionList"]
        | components["schemas"]["CommCenterMessagePayloadActionDocument"]
        | components["schemas"]["CommCenterMessagePayloadActionVideo"];
    };
    CommCenterMessagePayloadActionText: {
      /** @enum {string} */
      payloadType: "TEXT";
      text: string;
    };
    CommCenterMessagePayloadActionImage: {
      /** @enum {string} */
      payloadType: "IMAGE";
      url: string;
    };
    CommCenterMessagePayloadActionList: {
      /** @enum {string} */
      payloadType: "LIST";
      items: {
        entity: components["schemas"]["CommCenterMessageActionEntity"];
        /**
         * @description Id of the entity
         * can be: Patient/Visit/Label
         */
        id: number;
        /**
         * @description Name or description of the entity
         * For patient it should be name.
         * For label it should be the display text
         */
        text: string;
        icon?: string;
        code?: string;
      }[];
    };
    /** @enum {string} */
    CommCenterMessageActionEntity:
      | "ASSIGNED_VISIT"
      | "CAREGIVER_DOCUMENT_TYPE"
      | "COMM_CENTER_LABEL"
      | "ONBOARDING_QUESTION"
      | "ONBOARDING_SECTION"
      | "ONBOARDING_SUB_SECTION"
      | "PATIENT"
      | "VISIT"
      | "VISIT_BROADCAST"
      | "WORKFLOW_LABEL";
    CommCenterMessagePayloadActionDocument: {
      /** @enum {string} */
      payloadType: "DOCUMENT";
      url: string;
    };
    CommCenterMessagePayloadActionVideo: {
      /** @enum {string} */
      payloadType: "VIDEO";
      url: string;
    };
    CommCenterMessagePayloadDocument: {
      /** @enum {string} */
      type: "DOCUMENT";
      url: string;
    };
    CommCenterMessagePayloadVideo: {
      /** @enum {string} */
      type: "VIDEO";
      url: string;
    };
    CommCenterMessagePayloadOnboardingMessage: {
      /** @enum {string} */
      type: "ONBOARDING_MESSAGE";
      payload:
        | components["schemas"]["RejectedItemOnboardingMessagePayload"]
        | components["schemas"]["ApprovedItemOnboardingMessagePayload"];
    };
    RejectedItemOnboardingMessagePayload: {
      /** @enum {string} */
      type: "REJECTED_ITEM";
      item: {
        entity: components["schemas"]["CommCenterMessageActionEntity"];
        id: number;
        text: string;
      }[];
    };
    ApprovedItemOnboardingMessagePayload: {
      /** @enum {string} */
      type: "APPROVED_ITEM";
      item: {
        entity: components["schemas"]["CommCenterMessageActionEntity"];
        id: number;
        text: string;
      }[];
    };
    CommCenterMessageCreatedBy:
      | components["schemas"]["CommCenterMessageCreatedBy.Caregiver"]
      | components["schemas"]["CommCenterMessageCreatedBy.AgencyMember"]
      | components["schemas"]["CommCenterMessageCreatedBy.System"]
      | components["schemas"]["CommCenterMessageCreatedBy.Patient"]
      | components["schemas"]["CommCenterMessageCreatedBy.NotIdentifiedPhoneNumber"];
    "CommCenterMessageCreatedBy.Caregiver": {
      /** @enum {string} */
      type: "Caregiver";
      id: components["schemas"]["CaregiverId"];
      name: string;
    };
    "CommCenterMessageCreatedBy.AgencyMember": {
      /** @enum {string} */
      type: "Agency Member";
      id: components["schemas"]["AgencyMemberId"];
      name: string;
      photoUrl: null | string;
    };
    "CommCenterMessageCreatedBy.System": {
      /** @enum {string} */
      type: "System";
    };
    "CommCenterMessageCreatedBy.Patient": {
      /** @enum {string} */
      type: "Patient";
      id: components["schemas"]["PatientId"];
      name: string;
    };
    "CommCenterMessageCreatedBy.NotIdentifiedPhoneNumber": {
      /** @enum {string} */
      type: "NotIdentifiedPhoneNumber";
      id: components["schemas"]["CallSessionNotIdentifiedCallerCalleeId"];
      phoneNumber: string;
    };
    /** Format: CallSessionNotIdentifiedCallerCalleeId */
    CallSessionNotIdentifiedCallerCalleeId: CallSessionNotIdentifiedCallerCalleeId;
    CommCenterTicketStatusChange: {
      id: components["schemas"]["CommCenterTicketStatusChangeId"];
      ticketId: components["schemas"]["CommCenterTicketId"];
      status: components["schemas"]["CommCenterTicketStatus"];
      createdAt: components["schemas"]["Instant"];
      createdBy:
        | {
            /** @enum {string} */
            type: "System";
          }
        | {
            /** @enum {string} */
            type: "TeamMember";
            id: components["schemas"]["CommCenterTeamMemberId"];
            name: string;
          }
        | {
            /** @enum {string} */
            type: "Caregiver";
            id: components["schemas"]["CaregiverId"];
            name: string;
          };
    };
    /** Format: CommCenterTicketStatusChangeId */
    CommCenterTicketStatusChangeId: CommCenterTicketStatusChangeId;
    CommCenterTicketAssigneeChange: {
      id: components["schemas"]["CommCenterTicketAssignChangeId"];
      ticketId: components["schemas"]["CommCenterTicketId"];
      createdAt: components["schemas"]["Instant"];
      assignedTo: {
        id: components["schemas"]["CommCenterTeamMemberId"];
        name: string;
      } | null;
      createdBy: {
        id: components["schemas"]["CommCenterTeamMemberId"];
        name: string;
      };
    };
    /** Format: CommCenterTicketAssignChangeId */
    CommCenterTicketAssignChangeId: CommCenterTicketAssignChangeId;
    CommCenterTicketTelephonyCallInfo: {
      id: components["schemas"]["TelephonyCallId"];
      status: components["schemas"]["TelephonyCallStatus"];
      failDescription: null | string;
      direction: components["schemas"]["TelephonyCallDirection"];
      hasRecording: boolean;
      isLive: boolean;
      transcription: null | string;
      summary:
        | components["schemas"]["CommCenterTicketTelephonyCallSummary"]
        | null;
      participants: components["schemas"]["TelephonyCallParticipantInfo"][];
    };
    /** Format: TelephonyCallId */
    TelephonyCallId: TelephonyCallId;
    /** @enum {string} */
    TelephonyCallStatus:
      | "Canceled"
      | "Classifying"
      | "Completed"
      | "Connecting"
      | "Failed"
      | "InProgress"
      | "Initiated"
      | "Missed"
      | "MovedToSMS"
      | "NoAnswer"
      | "Ringing"
      | "VoiceMail";
    /** @enum {string} */
    TelephonyCallDirection: "Inbound" | "Outbound" | "Parallel";
    CommCenterTicketTelephonyCallSummary: {
      text: string;
      satisfaction: {
        rankNumber: number;
        rankDescription: string;
      };
    };
    TelephonyCallParticipantInfo: {
      id: components["schemas"]["TelephonyCallParticipantId"];
      status: components["schemas"]["TelephonyCallParticipantStatus"];
      entity: components["schemas"]["TelephonyCallParticipantEntityInfo"];
      role: components["schemas"]["TelephonyCallParticipantRole"];
      source: string;
      isActiveOnCall: boolean;
    };
    /** Format: TelephonyCallParticipantId */
    TelephonyCallParticipantId: TelephonyCallParticipantId;
    /** @enum {string} */
    TelephonyCallParticipantStatus:
      | "Answered"
      | "BargedIn"
      | "Declined"
      | "EavesDropped"
      | "Hungup"
      | "Initiated"
      | "Invited"
      | "Joined"
      | "Left"
      | "Removed";
    TelephonyCallParticipantEntityInfo:
      | components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"]
      | components["schemas"]["TelephonyCallBotAgentParticipantEntityInfo"]
      | components["schemas"]["TelephonyCallPatientParticipantEntityInfo"]
      | components["schemas"]["TelephonyCallPatientContactParticipantEntityInfo"]
      | components["schemas"]["TelephonyCallPhonebookContactParticipantEntityInfo"]
      | components["schemas"]["TelephonyCallNotIdentifiedParticipantEntityInfo"]
      | components["schemas"]["TelephonyCallCaregiverParticipantEntityInfo"];
    TelephonyCallAgencyMemberParticipantEntityInfo: {
      /** @enum {string} */
      type: "AgencyMember";
      id: components["schemas"]["AgencyMemberId"];
      firstName: string;
      lastName: string;
      photoUrl: null | string;
    };
    TelephonyCallBotAgentParticipantEntityInfo: {
      /** @enum {string} */
      type: "BotAgent";
      id: components["schemas"]["TelephonyBotAgentId"];
      name: string;
    };
    /** Format: TelephonyBotAgentId */
    TelephonyBotAgentId: TelephonyBotAgentId;
    TelephonyCallPatientParticipantEntityInfo: {
      /** @enum {string} */
      type: "Patient";
      id: components["schemas"]["PatientId"];
      firstName: string;
      lastName: string;
      status: components["schemas"]["PatientStatus"];
      clinicalSeverityLevel:
        | ("HIGHEST_ASSISTANCE" | "MINIMAL_ASSISTANCE" | "WALKING_ASSISTANCE")
        | null;
      isUnknown: boolean;
      assignedAgencyMember:
        | components["schemas"]["PatientIntakeAssignedAgencyMember"]
        | null;
      intakeQueue:
        | (
            | "Q1 - High"
            | "Q1 - Initial"
            | "Q1 - Low"
            | "Q2 - Regular"
            | "Q3 - Call To Plan"
          )
        | null;
    };
    PatientIntakeAssignedAgencyMember: {
      id: components["schemas"]["AgencyMemberId"];
      name: string;
    };
    TelephonyCallPatientContactParticipantEntityInfo: {
      /** @enum {string} */
      type: "PatientContact";
      id: components["schemas"]["PatientContactId"];
      firstName: string;
      lastName: string;
      relationship: string;
      patient: components["schemas"]["TelephonyCallPatientParticipantEntityInfo"];
    };
    TelephonyCallPhonebookContactParticipantEntityInfo: {
      /** @enum {string} */
      type: "PhonebookContact";
      id: components["schemas"]["AgencyPhonebookContactId"];
      name: string;
      destinationNumberType: components["schemas"]["AgencyPhonebookContactDestinationType"];
      contactType: components["schemas"]["PhonebookContactType"];
      source: string;
    };
    /** Format: AgencyPhonebookContactId */
    AgencyPhonebookContactId: AgencyPhonebookContactId;
    /** @enum {string} */
    AgencyPhonebookContactDestinationType: "FAX" | "MOBILE" | "TEL";
    /** @enum {string} */
    PhonebookContactType:
      | "GENERAL"
      | "PLAN"
      | "REFERRAL_USER"
      | "RN_PLATFORM_CLIENT";
    TelephonyCallNotIdentifiedParticipantEntityInfo: {
      /** @enum {string} */
      type: "NotIdentified";
      kind: components["schemas"]["TelephonyNotIdentifiedKind"];
      id: components["schemas"]["CallSessionNotIdentifiedCallerCalleeId"];
      source: string;
    };
    /** @enum {string} */
    TelephonyNotIdentifiedKind:
      | "NotIdentifiedCaregiver"
      | "NotIdentifiedInsuranceProvider"
      | "NotIdentifiedPatient"
      | "NotIdentifiedPhoneNumber"
      | "NotIdentifiedReferralUser"
      | "NotIdentifiedRnPlatformClient";
    TelephonyCallCaregiverParticipantEntityInfo: {
      /** @enum {string} */
      type: "Caregiver";
      id: components["schemas"]["CaregiverId"];
      firstName: string;
      lastName: string;
      photoUrl: null | string;
    };
    /** @enum {string} */
    TelephonyCallParticipantRole: "Callee" | "Caller" | "Invitee";
    CommCenterChatSummaryDetails: {
      summary: string;
      satisfactionRankNumber: number;
      satisfactionRankDescription: string;
    };
    CommCenterEmailThread: {
      id: components["schemas"]["CommCenterEmailThreadId"];
      subject: string;
      categories: string[];
      messages: components["schemas"]["CommCenterEmailMessage"][];
      ticketId: components["schemas"]["CommCenterTicketId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      direction: components["schemas"]["CommCenterEmailDirection"];
    };
    /** Format: CommCenterEmailThreadId */
    CommCenterEmailThreadId: CommCenterEmailThreadId;
    CommCenterEmailMessage: {
      id: components["schemas"]["CommCenterEmailMessageId"];
      threadId: components["schemas"]["CommCenterEmailThreadId"];
      direction: components["schemas"]["CommCenterEmailDirection"];
      sender: components["schemas"]["CommCenterEmailAddressObject"];
      recipients: components["schemas"]["CommCenterEmailAddressObject"][];
      replyTo: components["schemas"]["CommCenterEmailAddressObject"][] | null;
      content: string;
      contentPlainText: string;
      s3Url: null | string;
      attachments: components["schemas"]["CommCenterEmailMessageAttachment"][];
      createdAt: components["schemas"]["Instant"];
      cc: components["schemas"]["CommCenterEmailAddressObject"][] | null;
      bcc: components["schemas"]["CommCenterEmailAddressObject"][] | null;
      readAt: components["schemas"]["Instant"] | null;
    };
    /** Format: CommCenterEmailMessageId */
    CommCenterEmailMessageId: CommCenterEmailMessageId;
    /** @enum {string} */
    CommCenterEmailDirection: "INBOUND" | "OUTBOUND";
    CommCenterEmailAddressObject: {
      name: string;
      email: string;
    };
    CommCenterEmailMessageAttachment: {
      id: components["schemas"]["CommCenterEmailMessageAttachmentId"];
      messageId: components["schemas"]["CommCenterEmailMessageId"];
      s3Url: string;
      name: string;
      type: string;
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: CommCenterEmailMessageAttachmentId */
    CommCenterEmailMessageAttachmentId: CommCenterEmailMessageAttachmentId;
    RobocallLogData: {
      id: components["schemas"]["RobocallInstanceId"];
      createdAt: components["schemas"]["Instant"];
      data: components["schemas"]["RobocallData"][];
      status: string;
      type: string;
      customCallName: null | string;
      hasRecording: boolean;
    };
    /** Format: RobocallInstanceId */
    RobocallInstanceId: RobocallInstanceId;
    RobocallData: {
      eventType: string;
      digitPressed: null | string;
      createdAt: components["schemas"]["Instant"];
    };
    "Partial<EditCommCenterTicketParams>": {
      /** Format: CommCenterTeamMemberId */
      assignedToId?: CommCenterTeamMemberId;
      enableAgencyResponse?: boolean;
      /** Format: CommCenterLabelId */
      labelId?: CommCenterLabelId;
      /** Format: CommCenterTeamId */
      teamId?: CommCenterTeamId;
      /** @enum {string} */
      priority?: "HIGH" | "LOW" | "MEDIUM";
      /** @enum {string} */
      status?: "IN PROGRESS" | "NEW" | "RESOLVED";
      caregiverId?: components["schemas"]["CaregiverId"] | null;
      patientId?: components["schemas"]["PatientId"] | null;
      phonebookContactId?:
        | components["schemas"]["AgencyPhonebookContactId"]
        | null;
      relatedVisitInstanceId?: components["schemas"]["VisitInstanceId"] | null;
      relatedVisitBroadcastId?:
        | components["schemas"]["VisitBroadcastId"]
        | null;
      /** Format: TelephonyBotAgentId */
      botAgentId?: TelephonyBotAgentId;
      /** @enum {string} */
      topic?:
        | "BotAgent"
        | "Caregiver"
        | "NotIdentifiedEmailEntity"
        | "NotIdentifiedPhoneNumber"
        | "Patient"
        | "PhonebookContact";
      relatedTaskInstanceId?:
        | components["schemas"]["PatientTaskInstanceId"]
        | null;
    };
    CaregiverTextMessage: {
      /** @enum {string} */
      type: "TEXT";
      message: string;
    };
    CaregiverImageMessage: {
      /** @enum {string} */
      type: "IMAGE";
      url: string;
    };
    CaregiverActionMessage: {
      /** @enum {string} */
      type: "ACTION";
      actionId: components["schemas"]["CommCenterMessageActionId"];
      entitiyType: components["schemas"]["CommCenterMessageActionEntity"];
      entitiyId: number;
      entitiyText: string;
      entitiyIcon?: string;
    };
    CaregiverDocumentMessage: {
      /** @enum {string} */
      type: "DOCUMENT";
      url: string;
    };
    CaregiverVideoMessage: {
      /** @enum {string} */
      type: "VIDEO";
      url: string;
    };
    AgencyMemberTextMessage: {
      /** @enum {string} */
      type: "TEXT";
      message: string;
    };
    AgencyMemberImageMessage: {
      /** @enum {string} */
      type: "IMAGE";
      url: string;
    };
    AgencyMemberDocumentMessage: {
      /** @enum {string} */
      type: "DOCUMENT";
      url: string;
    };
    AgencyMemberVideoMessage: {
      /** @enum {string} */
      type: "VIDEO";
      url: string;
    };
    CommCenterTeamWithMembers: {
      members: components["schemas"]["CommCenterTeamMember"][];
      agencyId: components["schemas"]["AgencyId"];
      name: string;
      id: components["schemas"]["CommCenterTeamId"];
      active: boolean;
    };
    CommCenterTeamMember: {
      agencyMemberId: components["schemas"]["AgencyMemberId"];
      id: components["schemas"]["CommCenterTeamMemberId"];
      active: boolean;
      teamId: components["schemas"]["CommCenterTeamId"];
      firstName: string;
      lastName: string;
    };
    WorkflowTaskDefinition: {
      id: string;
      version: number;
      meta: {
        name: string;
        description: string;
        categories: (
          | "broadcast"
          | "caregiver"
          | "commcenter"
          | "compliance"
          | "fax"
          | "intake"
          | "lead"
          | "note"
          | "notification"
          | "patient"
          | "patient authorization"
          | "patient task"
          | "plan of care"
          | "robocall"
          | "slack"
          | "visit"
        )[];
      };
      input: { [key: string]: components["schemas"]["WorkflowDataFieldType"] };
      output: {
        [key: string]: {
          [key: string]: components["schemas"]["WorkflowDataFieldType"];
        };
      };
    };
    WorkflowDataFieldType:
      | components["schemas"]["WorkflowUnionField"]
      | components["schemas"]["WorkflowOptionField"]
      | components["schemas"]["WorkflowEntityField"]
      | components["schemas"]["WorkflowTextField"]
      | components["schemas"]["WorkflowNumberField"]
      | components["schemas"]["WorkflowBooleanField"]
      | components["schemas"]["WorkflowDateField"]
      | components["schemas"]["WorkflowDateTimeField"]
      | components["schemas"]["WorkflowTimeField"]
      | components["schemas"]["WorkflowFileField"]
      | components["schemas"]["WorkflowUnknownField"];
    WorkflowUnionField: {
      /** @enum {string} */
      type: "union";
      /* replaced manually */
    union: [
      components["schemas"]["WorkflowDataFieldType"],
      components["schemas"]["WorkflowDataFieldType"],
      ...components["schemas"]["WorkflowDataFieldType"][]
    ];
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowOptionField: {
      optionType:
        | components["schemas"]["WorkflowEntityField"]
        | components["schemas"]["WorkflowTextField"]
        | components["schemas"]["WorkflowNumberField"]
        | components["schemas"]["WorkflowDateField"]
        | components["schemas"]["WorkflowDateTimeField"]
        | components["schemas"]["WorkflowTimeField"];
      options: {
        key: unknown;
        value: unknown;
      }[];
      /** @enum {string} */
      type: "option";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowEntityField: {
      /** @enum {string} */
      type: "entity";
      entity: components["schemas"]["WorkflowEntity"];
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowEntity: string;
    WorkflowTextField: {
      /** @enum {string} */
      type: "text" | "textarea";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowNumberField: {
      /** @enum {string} */
      type: "number";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowDateField: {
      /** @enum {string} */
      type: "date";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowDateTimeField: {
      /** @enum {string} */
      type: "datetime";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowTimeField: {
      /** @enum {string} */
      type: "time";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowBooleanField: {
      /** @enum {string} */
      type: "boolean";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowFileField: {
      /** @enum {string} */
      type: "file";
      allowed?: ["image", "pdf"];
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    WorkflowUnknownField: {
      /** @enum {string} */
      type: "unknown";
      array?: boolean;
      optional?: boolean;
      nullable?: boolean;
    };
    ListedWorkflowHumanTaskInstance: {
      id: components["schemas"]["WorkflowTaskInstanceId"];
      workflowDefinition: {
        id: components["schemas"]["WorkflowDefinitionId"];
        name: string;
      };
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
        mandatory: boolean;
        priority: number;
        severity: string;
      };
      skills: components["schemas"]["WorkflowSkillId"][];
      assignmentTimeoutSeconds?: number;
      assignee: {
        id: components["schemas"]["AgencyMemberId"];
        name: string;
      } | null;
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: WorkflowTaskInstanceId */
    WorkflowTaskInstanceId: WorkflowTaskInstanceId;
    /** Format: WorkflowDefinitionId */
    WorkflowDefinitionId: WorkflowDefinitionId;
    XYPosition: {
      x: number;
      y: number;
    };
    /** Format: WorkflowSkillId */
    WorkflowSkillId: WorkflowSkillId;
    HumanTaskAssignmentStrategyOption: {
      type: string;
      input?: { [key: string]: components["schemas"]["WorkflowDataFieldType"] };
    };
    WorkflowHumanTaskInstance: {
      id: components["schemas"]["WorkflowTaskInstanceId"];
      workflow: {
        id: components["schemas"]["WorkflowDefinitionId"];
        name: string;
      };
      skills: components["schemas"]["WorkflowSkillId"][];
      cluster: {
        id: components["schemas"]["WorkflowTaskClusterId"];
        value: string;
      } | null;
      assignmentTimeoutSeconds?: number;
      template: components["schemas"]["WorkflowHumanTaskTemplate"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
        mandatory: boolean;
        priority: number;
        severity: string;
      };
      output: {
        [key: string]: {
          [key: string]: components["schemas"]["WorkflowDataFieldType"];
        };
      };
      data: { [key: string]: unknown };
      assignee: components["schemas"]["AgencyMemberId"] | null;
    };
    /** Format: WorkflowTaskClusterId */
    WorkflowTaskClusterId: WorkflowTaskClusterId;
    WorkflowHumanTaskTemplate:
      | {
          /** @enum {string} */
          layout: "entity";
          data: components["schemas"]['InferWorkflowFieldsRecord<{instructions:{type:"textarea";};caregiver:{type:"entity";entity:"Caregiver";optional:true;};patient:{type:"entity";entity:"Patient";optional:true;};intakePatient:{type:"entity";entity:"Patient";optional:true;};visit:{type:"entity";entity:"VisitInstance";optional:true;};visitBroadcast:{type:"entity";entity:"VisitBroadcast";optional:true;};ticket:{type:"entity";entity:"CommCenterTicket";optional:true;};files:{type:"file";array:true;optional:true;};}>'];
        }
      | {
          /** @enum {string} */
          layout: "manual";
          data: components["schemas"]['InferWorkflowFieldsRecord<{instructions:{type:"textarea";};}>'];
        }
      | {
          /** @enum {string} */
          layout: "document-viewer";
          data: components["schemas"]['InferWorkflowFieldsRecord<{instructions:{type:"textarea";};documents:{type:"file";array:true;};}>'];
        }
      | {
          /** @enum {string} */
          layout: "chat";
          data: components["schemas"]['InferWorkflowFieldsRecord<{instructions:{type:"textarea";};ticket:{type:"entity";entity:"CommCenterTicket";};showTicketLink:{type:"boolean";optional:true;};}>'];
        }
      | {
          /** @enum {string} */
          layout: "intake-call";
          data: components["schemas"]['InferWorkflowFieldsRecord<{patient:{type:"entity";entity:"Patient";};}>'];
        }
      | {
          /** @enum {string} */
          layout: "visit-assignment";
          data: components["schemas"]['InferWorkflowFieldsRecord<{visitAssignment:{type:"entity";entity:"VisitAssignment";};}>'];
        };
    'InferWorkflowFieldsRecord<{instructions:{type:"textarea";};caregiver:{type:"entity";entity:"Caregiver";optional:true;};patient:{type:"entity";entity:"Patient";optional:true;};intakePatient:{type:"entity";entity:"Patient";optional:true;};visit:{type:"entity";entity:"VisitInstance";optional:true;};visitBroadcast:{type:"entity";entity:"VisitBroadcast";optional:true;};ticket:{type:"entity";entity:"CommCenterTicket";optional:true;};files:{type:"file";array:true;optional:true;};}>': {
      instructions: string;
      caregiver?: components["schemas"]["CaregiverId"];
      patient?: components["schemas"]["PatientId"];
      intakePatient?: components["schemas"]["PatientId"];
      visit?: components["schemas"]["VisitInstanceId"];
      visitBroadcast?: components["schemas"]["VisitBroadcastId"];
      ticket?: components["schemas"]["CommCenterTicketId"];
      files?: string[];
    };
    'InferWorkflowFieldsRecord<{instructions:{type:"textarea";};}>': {
      instructions: string;
    };
    'InferWorkflowFieldsRecord<{instructions:{type:"textarea";};documents:{type:"file";array:true;};}>': {
      instructions: string;
      documents: string[];
    };
    'InferWorkflowFieldsRecord<{instructions:{type:"textarea";};ticket:{type:"entity";entity:"CommCenterTicket";};showTicketLink:{type:"boolean";optional:true;};}>': {
      instructions: string;
      ticket: components["schemas"]["CommCenterTicketId"];
      showTicketLink?: boolean;
    };
    'InferWorkflowFieldsRecord<{patient:{type:"entity";entity:"Patient";};}>': {
      patient: components["schemas"]["PatientId"];
    };
    'InferWorkflowFieldsRecord<{visitAssignment:{type:"entity";entity:"VisitAssignment";};}>': {
      visitAssignment: components["schemas"]["VisitAssignmentId"];
    };
    WorkflowTaskQueryDefinition: {
      name: string;
      version: number;
      description: string;
      input: { [key: string]: components["schemas"]["WorkflowDataFieldType"] };
      output: { [key: string]: components["schemas"]["WorkflowDataFieldType"] };
    };
    ListedWorkflow: {
      id: components["schemas"]["WorkflowDefinitionId"];
      meta: {
        owner: components["schemas"]["AgencyMemberId"];
        priority: number;
        severity: string;
        timeout: null | number;
        published: boolean;
        createHumanTaskOnFailure: boolean;
        tags?: components["schemas"]["WorkflowTagReference"][];
        childrenTags?: {
          [key: string]: components["schemas"]["WorkflowTagReference"][];
        };
      };
      name: string;
      input: components["schemas"]["WorkflowInputs"];
      description: string;
      version: number;
    };
    WorkflowTagReference: {
      id: components["schemas"]["WorkflowTagId"];
      name: string;
      input: [string, components["schemas"]["WorkflowDataFieldType"]][];
      bind: components["schemas"]["WorkflowTagReferenceBind"];
    };
    /** Format: WorkflowTagId */
    WorkflowTagId: WorkflowTagId;
    WorkflowTagReferenceBind: {
      [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
    };
    WorkflowChildReferenceBinding:
      | components["schemas"]["WorkflowChildReferenceBinding.Path"]
      | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: string[];
        })
      | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: string;
        })
      | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: string[];
        })
      | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: string;
        })
      | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: number[];
        })
      | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: number;
        })
      | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: boolean[];
        })
      | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: boolean;
        })
      | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: components["schemas"]["LocalDate"][];
        })
      | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: components["schemas"]["LocalDate"];
        })
      | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: components["schemas"]["LocalTime"][];
        })
      | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: components["schemas"]["LocalTime"];
        })
      | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: components["schemas"]["LocalDateTime"][];
        })
      | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: components["schemas"]["LocalDateTime"];
        })
      | components["schemas"]["WorkflowChildReferenceBinding.Now"]
      | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
      | components["schemas"]["WorkflowChildReferenceBinding.Today"]
      | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: string[];
        })
      | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: string;
        });
    "WorkflowChildReferenceBinding.Path": {
      /** @enum {string} */
      type: "path";
      path: /* replaced manually */ ["input" | "queries" | "tasks" | "triggers", ...string[]];
      formatter?:
        | {
            /** @enum {string} */
            valueType: "number";
            /** @enum {string} */
            action:
              | "add"
              | "ceil"
              | "divide"
              | "floor"
              | "multiply"
              | "round"
              | "subtract";
            value: components["schemas"]["WorkflowChildReferenceBinding"];
          }
        | {
            /** @enum {string} */
            valueType: "date";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          }
        | {
            /** @enum {string} */
            valueType: "datetime";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateTimeFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          };
    };
    /** @enum {string} */
    DateFormatterUnit: "days" | "months" | "weeks" | "years";
    /** @enum {string} */
    DateTimeFormatterUnit:
      | "days"
      | "hours"
      | "minutes"
      | "months"
      | "seconds"
      | "weeks"
      | "years";
    'Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">': {
      /** @enum {string} */
      type: "text";
      placeholders?: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
    };
    'Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">': {
      /** @enum {string} */
      type: "textarea";
      placeholders?: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
    };
    'Omit<{type:"number";value:number;},"value">': {
      /** @enum {string} */
      type: "number";
    };
    'Omit<{type:"boolean";value:boolean;},"value">': {
      /** @enum {string} */
      type: "boolean";
    };
    'Omit<{type:"date";value:LocalDate;},"value">': {
      /** @enum {string} */
      type: "date";
    };
    'Omit<{type:"time";value:LocalTime;},"value">': {
      /** @enum {string} */
      type: "time";
    };
    'Omit<{type:"datetime";value:LocalDateTime;},"value">': {
      /** @enum {string} */
      type: "datetime";
    };
    "WorkflowChildReferenceBinding.Now": {
      /** @enum {string} */
      type: "now";
      formatter?:
        | {
            /** @enum {string} */
            valueType: "number";
            /** @enum {string} */
            action:
              | "add"
              | "ceil"
              | "divide"
              | "floor"
              | "multiply"
              | "round"
              | "subtract";
            value: components["schemas"]["WorkflowChildReferenceBinding"];
          }
        | {
            /** @enum {string} */
            valueType: "date";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          }
        | {
            /** @enum {string} */
            valueType: "datetime";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateTimeFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          };
    };
    "WorkflowChildReferenceBinding.NowTime": {
      /** @enum {string} */
      type: "now-time";
      formatter?:
        | {
            /** @enum {string} */
            valueType: "number";
            /** @enum {string} */
            action:
              | "add"
              | "ceil"
              | "divide"
              | "floor"
              | "multiply"
              | "round"
              | "subtract";
            value: components["schemas"]["WorkflowChildReferenceBinding"];
          }
        | {
            /** @enum {string} */
            valueType: "date";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          }
        | {
            /** @enum {string} */
            valueType: "datetime";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateTimeFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          };
    };
    "WorkflowChildReferenceBinding.Today": {
      /** @enum {string} */
      type: "today";
      formatter?:
        | {
            /** @enum {string} */
            valueType: "number";
            /** @enum {string} */
            action:
              | "add"
              | "ceil"
              | "divide"
              | "floor"
              | "multiply"
              | "round"
              | "subtract";
            value: components["schemas"]["WorkflowChildReferenceBinding"];
          }
        | {
            /** @enum {string} */
            valueType: "date";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          }
        | {
            /** @enum {string} */
            valueType: "datetime";
            /** @enum {string} */
            action: "add" | "subtract";
            value: {
              unit: components["schemas"]["DateTimeFormatterUnit"];
              interval: components["schemas"]["WorkflowChildReferenceBinding"];
            };
          };
    };
    'Omit<{type:"file";value:string;},"value">': {
      /** @enum {string} */
      type: "file";
    };
    WorkflowInputs: {
      /** @enum {string} */
      __type: "Map";
      value: [string, components["schemas"]["WorkflowInput"]][];
    };
    WorkflowInput:
      | ({
          name: string;
        } & components["schemas"]["WorkflowUnionField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowOptionField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowEntityField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowTextField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowNumberField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowBooleanField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowDateField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowDateTimeField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowTimeField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowFileField"])
      | ({
          name: string;
        } & components["schemas"]["WorkflowUnknownField"]);
    /** Format: WorkflowDefinitionCorrelationKey */
    WorkflowDefinitionCorrelationKey: WorkflowDefinitionCorrelationKey;
    DesignerListedWorkflowDefinition: {
      correlationKey: components["schemas"]["WorkflowDefinitionCorrelationKey"];
      meta: {
        owner: {
          id: components["schemas"]["AgencyMemberId"];
          name: string;
        };
        priority: number;
        severity: string;
      };
      name: string;
      lastVersion: {
        id: components["schemas"]["WorkflowDefinitionId"];
        number: number;
      };
      lastPublishedVersion: null | number;
      aggregations: {
        last30Days: components["schemas"]["WorkflowInstanceAggregatedExecutionsDatum"][];
        last24Hours: components["schemas"]["WorkflowInstanceAggregatedExecutionsDatum"][];
      };
    };
    WorkflowInstanceAggregatedExecutionsDatum: {
      timeGroup: components["schemas"]["LocalDateTime"];
      totalInvocations: number;
      totalError: number;
      totalCancel: number;
      totalSuccess: number;
      totalInProgress: number;
      averageInSeconds: null | number;
      medianInSeconds: null | number;
    };
    WorkflowDefinition: {
      id: components["schemas"]["WorkflowDefinitionId"];
      name: string;
      description: string;
      correlationKey: components["schemas"]["WorkflowDefinitionCorrelationKey"];
      version: number;
      meta: {
        owner: components["schemas"]["AgencyMemberId"];
        priority: number;
        severity: string;
        timeout: null | number;
        published: boolean;
        createHumanTaskOnFailure: boolean;
        tags?: components["schemas"]["WorkflowTagReference"][];
        childrenTags?: {
          [key: string]: components["schemas"]["WorkflowTagReference"][];
        };
      };
      concurrencyRules: {
        domain: components["schemas"]["WORKFLOW_CONCURRENCY_DOMAIN"];
        rule: components["schemas"]["WORKFLOW_CONCURRENCY_RULE"];
      };
      triggers: components["schemas"]["WorkflowTrigger"][];
      input: components["schemas"]["WorkflowInputs"];
      output: components["schemas"]["WorkflowOutputs"];
      children: components["schemas"]["WorkflowChildren"];
    };
    /** @enum {string} */
    WORKFLOW_CONCURRENCY_DOMAIN: "CORRELATION" | "DEFINITION" | "GLOBAL";
    /** @enum {string} */
    WORKFLOW_CONCURRENCY_RULE:
      | "RUN_ALWAYS"
      | "RUN_FOR_ACTIVE_UNIQUE_INPUT"
      | "RUN_FOR_UNIQUE_INPUT";
    WorkflowTrigger:
      | components["schemas"]["WorkflowEventTrigger"]
      | components["schemas"]["WorkflowJobTrigger"];
    WorkflowEventTrigger: {
      id: components["schemas"]["WorkflowDefinitionTriggerId"];
      /** @enum {string} */
      type: "event";
      event: {
        table: string;
        type: components["schemas"]["WorkflowEventTriggerOptionType"];
      };
      conditions: components["schemas"]["WorkflowEventTriggerConditions"];
      bind: components["schemas"]["WorkflowTriggerBind"];
    };
    /** Format: WorkflowDefinitionTriggerId */
    WorkflowDefinitionTriggerId: WorkflowDefinitionTriggerId;
    /** @enum {string} */
    WorkflowEventTriggerOptionType: "DELETE" | "INSERT" | "UPDATE";
    WorkflowEventTriggerConditions: {
      /** @enum {string} */
      operator: "and" | "or";
      conditions: (
        | components["schemas"]["WorkflowEventTriggerCondition"]
        | components["schemas"]["WorkflowEventTriggerConditions"]
      )[];
    };
    WorkflowEventTriggerCondition: {
      property: components["schemas"]["WorkflowChildReferenceBinding.Path"];
      operator: components["schemas"]["WorkflowValueConditionOperator"];
      bind:
        | components["schemas"]["WorkflowChildReferenceBinding.Path"]
        | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: number[];
          })
        | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: number;
          })
        | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: boolean[];
          })
        | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: boolean;
          })
        | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDate"][];
          })
        | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDate"];
          })
        | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalTime"][];
          })
        | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalTime"];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDateTime"][];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDateTime"];
          })
        | components["schemas"]["WorkflowChildReferenceBinding.Now"]
        | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
        | components["schemas"]["WorkflowChildReferenceBinding.Today"]
        | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | null;
    };
    /** @enum {string} */
    WorkflowValueConditionOperator:
      | "!="
      | "<"
      | "<="
      | "="
      | ">"
      | ">="
      | "contains"
      | "does not contain"
      | "ends with"
      | "in"
      | "is empty"
      | "is not empty"
      | "not in"
      | "starts with";
    WorkflowTriggerBind: { [key: string]: string };
    WorkflowJobTrigger: {
      id: components["schemas"]["WorkflowDefinitionTriggerId"];
      /** @enum {string} */
      type: "job";
      pattern: components["schemas"]["WorkflowJobTriggerPattern"];
      report:
        | {
            /** @enum {string} */
            type: "advanced";
            id: components["schemas"]["SavedReportId"];
            uniqueBy: string[] | null;
          }
        | {
            /** @enum {string} */
            type: "standard";
            id: components["schemas"]["StandardReportId"];
            uniqueBy: string[] | null;
            filterBind: components["schemas"]["WorkflowJobTriggerFilterBind"];
          };
      bind: components["schemas"]["WorkflowTriggerBind"];
    };
    WorkflowJobTriggerPattern:
      | {
          /** @enum {string} */
          type: "cron";
          cron: string;
        }
      | {
          /** @enum {string} */
          type: "interval";
          minutes: number;
        };
    WorkflowJobTriggerFilterBind: {
      [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
    };
    WorkflowOutputs: {
      [key: string]: {
        [key: string]: components["schemas"]["WorkflowDataFieldType"];
      };
    };
    WorkflowChildren: { [key: string]: components["schemas"]["WorkflowChild"] };
    WorkflowChild:
      | components["schemas"]["WorkflowChildHumanTask"]
      | components["schemas"]["WorkflowChildShortCircuitTask"]
      | components["schemas"]["WorkflowChildResetToTask"]
      | components["schemas"]["WorkflowChildSystemTask"]
      | components["schemas"]["WorkflowChildWorkflow"]
      | components["schemas"]["WorkflowChildChoiceTask"]
      | components["schemas"]["WorkflowChildGroup"];
    WorkflowChildHumanTask: {
      dependsOn?: [
        string,
        components["schemas"]["WorkflowChildResultType"],
        string
      ];
      trigger?: components["schemas"]["WorkflowTaskTrigger"];
      logicalId: string;
      /** @enum {string} */
      type: "human-task";
      queries: components["schemas"]["SerializedMap<string,WorkflowChildTaskQuery>"];
      output: {
        [key: string]: {
          [key: string]: components["schemas"]["WorkflowDataFieldType"];
        };
      };
      retry?:
        | components["schemas"]["WorkflowTriggerRetry"]
        | components["schemas"]["WorkflowIntervalRetry"];
      error?: components["schemas"]["SerializedMap<string,WorkflowError>"];
      skills: components["schemas"]["WorkflowSkillId"][];
      assignmentTimeoutSeconds?: number;
      assignmentStrategy?: components["schemas"]["HumanTaskAssignmentStrategy"];
      template: components["schemas"]["WorkflowHumanTaskTemplateReference"];
      cluster?: components["schemas"]["WorkflowTaskClusterReference"];
      scheduling?: components["schemas"]["WorkflowChildScheduling"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
        mandatory: boolean;
        priority: number;
        severity: string;
      };
    };
    /** @enum {string} */
    WorkflowChildResultType: "error" | "output";
    WorkflowTaskTrigger: {
      id: number;
      event: {
        table: string;
        type: components["schemas"]["WorkflowEventTriggerOptionType"];
      };
      conditions: components["schemas"]["WorkflowTaskTriggerConditions"];
      /** @enum {string} */
      triggerInitOn?: "on-task-evaluation" | "on-workflow-creation";
    };
    WorkflowTaskTriggerConditions: {
      /** @enum {string} */
      operator: "and" | "or";
      conditions: (
        | components["schemas"]["WorkflowTaskTriggerCondition"]
        | components["schemas"]["WorkflowTaskTriggerConditions"]
      )[];
    };
    WorkflowTaskTriggerCondition: {
      property: string;
      operator: components["schemas"]["WorkflowValueConditionOperator"];
      bind:
        | components["schemas"]["WorkflowChildReferenceBinding.Path"]
        | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: number[];
          })
        | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: number;
          })
        | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: boolean[];
          })
        | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: boolean;
          })
        | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDate"][];
          })
        | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDate"];
          })
        | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalTime"][];
          })
        | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalTime"];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDateTime"][];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDateTime"];
          })
        | components["schemas"]["WorkflowChildReferenceBinding.Now"]
        | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
        | components["schemas"]["WorkflowChildReferenceBinding.Today"]
        | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | null;
    };
    "SerializedMap<string,WorkflowChildTaskQuery>": {
      /** @enum {string} */
      __type: "Map";
      value: [string, components["schemas"]["WorkflowChildTaskQuery"]][];
    };
    WorkflowChildTaskQuery: {
      name: string;
      version: number;
      bind: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
    };
    WorkflowTriggerRetry: {
      /** @enum {string} */
      type: "trigger";
      maxRetries: number;
      retryPaths: string[];
    };
    WorkflowIntervalRetry: {
      /** @enum {string} */
      type: "interval";
      maxRetries: number;
      interval: number;
      retryPaths: string[];
    };
    "SerializedMap<string,WorkflowError>": {
      /** @enum {string} */
      __type: "Map";
      value: [string, components["schemas"]["WorkflowError"]][];
    };
    WorkflowError: {
      on: components["schemas"]["WorkflowErrorEvent"][];
      handler: components["schemas"]["WorkflowErrorHandler"];
    };
    /** @enum {string} */
    WorkflowErrorEvent:
      | "createBefore"
      | "finishBefore"
      | "retryLimit"
      | "timeout"
      | "unexpected";
    WorkflowErrorHandler:
      | components["schemas"]["WorkflowNewTaskErrorHandler"]
      | components["schemas"]["WorkflowFallbackToManualErrorHandler"]
      | components["schemas"]["WorkflowFallbackToDefaultErrorHandler"];
    WorkflowNewTaskErrorHandler: {
      /** @enum {string} */
      type: "new-task";
    };
    WorkflowFallbackToManualErrorHandler: {
      /** @enum {string} */
      type: "fallback-to-manual";
      queries: components["schemas"]["SerializedMap<string,WorkflowChildTaskQuery>"];
      template: components["schemas"]["WorkflowHumanTaskTemplateReference"];
      skills: components["schemas"]["WorkflowSkillId"][];
      assignmentTimeoutSeconds?: number;
      assignmentStrategy?: components["schemas"]["HumanTaskAssignmentStrategy"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
        mandatory: boolean;
        priority: number;
        severity: string;
      };
      cluster?: components["schemas"]["WorkflowTaskClusterReference"];
      scheduling?: {
        timeout?: number;
        finishBefore?:
          | components["schemas"]["WorkflowChildReferenceBinding.Path"]
          | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
              /** @enum {boolean} */
              array: true;
              value: components["schemas"]["LocalDateTime"][];
            })
          | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
              /** @enum {boolean} */
              array: false;
              value: components["schemas"]["LocalDateTime"];
            })
          | components["schemas"]["WorkflowChildReferenceBinding.Now"]
          | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
          | components["schemas"]["WorkflowChildReferenceBinding.Today"];
      };
    };
    WorkflowHumanTaskTemplateReference: {
      layout: string;
      bind: {
        [
          key: string
        ]: components["schemas"]["WorkflowHumanTaskTemplateReferenceBinding"];
      };
    };
    WorkflowHumanTaskTemplateReferenceBinding:
      | components["schemas"]["WorkflowChildReferenceBinding.Path"]
      | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: string[];
        })
      | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: string;
        })
      | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: string[];
        })
      | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: string;
        })
      | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: number[];
        })
      | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: number;
        })
      | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: boolean[];
        })
      | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: boolean;
        })
      | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: components["schemas"]["LocalDate"][];
        })
      | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: components["schemas"]["LocalDate"];
        })
      | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: components["schemas"]["LocalTime"][];
        })
      | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: components["schemas"]["LocalTime"];
        })
      | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: components["schemas"]["LocalDateTime"][];
        })
      | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: components["schemas"]["LocalDateTime"];
        })
      | components["schemas"]["WorkflowChildReferenceBinding.Now"]
      | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
      | components["schemas"]["WorkflowChildReferenceBinding.Today"]
      | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
          /** @enum {boolean} */
          array: true;
          value: string[];
        })
      | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
          /** @enum {boolean} */
          array: false;
          value: string;
        });
    HumanTaskAssignmentStrategy: {
      optionType: string;
      bind?: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
    };
    WorkflowTaskClusterReference: {
      id: components["schemas"]["WorkflowTaskClusterId"];
      bind: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
    };
    WorkflowFallbackToDefaultErrorHandler: {
      /** @enum {string} */
      type: "fallback-to-default";
      status: string;
      output: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
    };
    WorkflowChildScheduling: {
      timeout?: number;
      createAfter?:
        | components["schemas"]["WorkflowChildReferenceBinding.Path"]
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDateTime"][];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDateTime"];
          })
        | components["schemas"]["WorkflowChildReferenceBinding.Now"]
        | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
        | components["schemas"]["WorkflowChildReferenceBinding.Today"];
      createBefore?:
        | components["schemas"]["WorkflowChildReferenceBinding.Path"]
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDateTime"][];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDateTime"];
          })
        | components["schemas"]["WorkflowChildReferenceBinding.Now"]
        | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
        | components["schemas"]["WorkflowChildReferenceBinding.Today"];
      finishBefore?:
        | components["schemas"]["WorkflowChildReferenceBinding.Path"]
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDateTime"][];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDateTime"];
          })
        | components["schemas"]["WorkflowChildReferenceBinding.Now"]
        | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
        | components["schemas"]["WorkflowChildReferenceBinding.Today"];
    };
    WorkflowChildShortCircuitTask: {
      dependsOn?: [
        string,
        components["schemas"]["WorkflowChildResultType"],
        string
      ];
      trigger?: components["schemas"]["WorkflowTaskTrigger"];
      logicalId: string;
      /** @enum {string} */
      type: "short-circuit-task";
      queries: components["schemas"]["SerializedMap<string,WorkflowChildTaskQuery>"];
      error?: components["schemas"]["SerializedMap<string,WorkflowError>"];
      scheduling?: components["schemas"]["WorkflowChildScheduling"];
      retry?:
        | components["schemas"]["WorkflowTriggerRetry"]
        | components["schemas"]["WorkflowIntervalRetry"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
        mandatory: boolean;
        priority: number;
        severity: string;
      };
    };
    WorkflowChildResetToTask: {
      dependsOn?: [
        string,
        components["schemas"]["WorkflowChildResultType"],
        string
      ];
      trigger?: components["schemas"]["WorkflowTaskTrigger"];
      logicalId: string;
      to: {
        bind: {
          [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
        };
        logicalId: string;
      };
      /** @enum {string} */
      type: "reset-to-task";
      queries: components["schemas"]["SerializedMap<string,WorkflowChildTaskQuery>"];
      scheduling?: components["schemas"]["WorkflowChildScheduling"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
        mandatory: boolean;
        priority: number;
        severity: string;
      };
    };
    WorkflowChildSystemTask: {
      dependsOn?: [
        string,
        components["schemas"]["WorkflowChildResultType"],
        string
      ];
      trigger?: components["schemas"]["WorkflowTaskTrigger"];
      logicalId: string;
      /** @enum {string} */
      type: "system-task";
      task: {
        id: string;
        version: number;
      };
      queries: components["schemas"]["SerializedMap<string,WorkflowChildTaskQuery>"];
      bind: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
      error?: components["schemas"]["SerializedMap<string,WorkflowError>"];
      scheduling?: components["schemas"]["WorkflowChildScheduling"];
      retry?:
        | components["schemas"]["WorkflowTriggerRetry"]
        | components["schemas"]["WorkflowIntervalRetry"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
        mandatory: boolean;
        priority: number;
        severity: string;
      };
    };
    WorkflowChildWorkflow: {
      dependsOn?: [
        string,
        components["schemas"]["WorkflowChildResultType"],
        string
      ];
      trigger?: components["schemas"]["WorkflowTaskTrigger"];
      logicalId: string;
      /** @enum {string} */
      type: "workflow";
      workflow: {
        id: string;
        version: number;
      };
      bind: {
        [key: string]: components["schemas"]["WorkflowChildReferenceBinding"];
      };
      fallbackToManual?: boolean;
      scheduling?: components["schemas"]["WorkflowChildScheduling"];
      error?: components["schemas"]["SerializedMap<string,WorkflowError>"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        waitforResult?: boolean;
      };
    };
    WorkflowChildChoiceTask: {
      dependsOn?: [
        string,
        components["schemas"]["WorkflowChildResultType"],
        string
      ];
      trigger?: components["schemas"]["WorkflowTaskTrigger"];
      logicalId: string;
      /** @enum {string} */
      type: "choice";
      choices: {
        conditions: components["schemas"]["WorkflowTaskEventTriggerConditions"];
        output: string;
      }[];
      default?: {
        output: string;
      };
      queries: components["schemas"]["SerializedMap<string,WorkflowChildTaskQuery>"];
      scheduling?: components["schemas"]["WorkflowChildScheduling"];
      error?: components["schemas"]["SerializedMap<string,WorkflowError>"];
      retry?:
        | components["schemas"]["WorkflowTriggerRetry"]
        | components["schemas"]["WorkflowIntervalRetry"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        description?: string;
      };
    };
    WorkflowTaskEventTriggerConditions: {
      /** @enum {string} */
      operator: "and" | "or";
      conditions: (
        | components["schemas"]["WorkflowTaskEventTriggerConditions"]
        | components["schemas"]["WorkflowTaskEventTriggerCondition"]
      )[];
    };
    WorkflowTaskEventTriggerCondition: {
      operator: components["schemas"]["WorkflowValueConditionOperator"];
      left: components["schemas"]["WorkflowChildReferenceBinding"];
      right:
        | components["schemas"]["WorkflowChildReferenceBinding.Path"]
        | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"text";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"textarea";value:string;placeholders?:{[key:string]:WorkflowChildReferenceBinding;}|undefined;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: number[];
          })
        | (components["schemas"]['Omit<{type:"number";value:number;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: number;
          })
        | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: boolean[];
          })
        | (components["schemas"]['Omit<{type:"boolean";value:boolean;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: boolean;
          })
        | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDate"][];
          })
        | (components["schemas"]['Omit<{type:"date";value:LocalDate;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDate"];
          })
        | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalTime"][];
          })
        | (components["schemas"]['Omit<{type:"time";value:LocalTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalTime"];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: components["schemas"]["LocalDateTime"][];
          })
        | (components["schemas"]['Omit<{type:"datetime";value:LocalDateTime;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: components["schemas"]["LocalDateTime"];
          })
        | components["schemas"]["WorkflowChildReferenceBinding.Now"]
        | components["schemas"]["WorkflowChildReferenceBinding.NowTime"]
        | components["schemas"]["WorkflowChildReferenceBinding.Today"]
        | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
            /** @enum {boolean} */
            array: true;
            value: string[];
          })
        | (components["schemas"]['Omit<{type:"file";value:string;},"value">'] & {
            /** @enum {boolean} */
            array: false;
            value: string;
          })
        | null;
    };
    WorkflowChildGroup: {
      dependsOn?: [
        string,
        components["schemas"]["WorkflowChildResultType"],
        string
      ];
      trigger?: components["schemas"]["WorkflowTaskTrigger"];
      logicalId: string;
      /** @enum {string} */
      type: "group";
      children: components["schemas"]["WorkflowChildren"];
      scheduling?: components["schemas"]["WorkflowChildScheduling"];
      error?: components["schemas"]["SerializedMap<string,WorkflowError>"];
      meta: {
        name: string;
        position?: components["schemas"]["XYPosition"];
        tags?: string[];
      };
    };
    CreateWorkflowDefinition: {
      name: string;
      description: string;
      correlationKey: components["schemas"]["WorkflowDefinitionCorrelationKey"];
      version: number;
      concurrencyRules?: {
        domain: components["schemas"]["WORKFLOW_CONCURRENCY_DOMAIN"];
        rule: components["schemas"]["WORKFLOW_CONCURRENCY_RULE"];
      };
      meta: {
        owner: components["schemas"]["AgencyMemberId"];
        priority: number;
        severity: string;
        timeout: null | number;
        published: boolean;
        createHumanTaskOnFailure: boolean;
        tags?: components["schemas"]["WorkflowTagReference"][];
        childrenTags?: {
          [key: string]: components["schemas"]["WorkflowTagReference"][];
        };
      };
      triggers: components["schemas"]["CreateWorkflowTrigger"][];
      input: components["schemas"]["WorkflowInputs"];
      output: {
        [key: string]: {
          [key: string]: components["schemas"]["WorkflowDataFieldType"];
        };
      };
      children: components["schemas"]["WorkflowChildren"];
    };
    CreateWorkflowTrigger:
      | components["schemas"]["CreateWorkflowEventTrigger"]
      | components["schemas"]["CreateWorkflowJobTrigger"];
    CreateWorkflowEventTrigger: {
      /** @enum {string} */
      type: "event";
      event: {
        table: string;
        type: components["schemas"]["WorkflowEventTriggerOptionType"];
      };
      conditions: components["schemas"]["WorkflowEventTriggerConditions"];
      bind: components["schemas"]["WorkflowTriggerBind"];
    };
    CreateWorkflowJobTrigger: {
      /** @enum {string} */
      type: "job";
      pattern: components["schemas"]["WorkflowJobTriggerPattern"];
      report:
        | {
            /** @enum {string} */
            type: "advanced";
            id: components["schemas"]["SavedReportId"];
            uniqueBy: string[] | null;
          }
        | {
            /** @enum {string} */
            type: "standard";
            id: components["schemas"]["StandardReportId"];
            uniqueBy: string[] | null;
            filterBind: components["schemas"]["WorkflowJobTriggerFilterBind"];
          };
      bind: components["schemas"]["WorkflowTriggerBind"];
    };
    /** Format: WorkflowInstanceId */
    WorkflowInstanceId: WorkflowInstanceId;
    UpdateWorkflowDefinition: {
      id: components["schemas"]["WorkflowDefinitionId"];
      name: string;
      description: string;
      correlationKey: components["schemas"]["WorkflowDefinitionCorrelationKey"];
      version: number;
      concurrencyRules: {
        domain: components["schemas"]["WORKFLOW_CONCURRENCY_DOMAIN"];
        rule: components["schemas"]["WORKFLOW_CONCURRENCY_RULE"];
      };
      meta: {
        owner: components["schemas"]["AgencyMemberId"];
        priority: number;
        severity: string;
        timeout: null | number;
        published: boolean;
        createHumanTaskOnFailure: boolean;
        tags: components["schemas"]["WorkflowTagReference"][];
        childrenTags: {
          [key: string]: components["schemas"]["WorkflowTagReference"][];
        };
      };
      triggers: components["schemas"]["WorkflowTrigger"][];
      input: components["schemas"]["WorkflowInputs"];
      output: {
        [key: string]: {
          [key: string]: components["schemas"]["WorkflowDataFieldType"];
        };
      };
      children: components["schemas"]["WorkflowChildren"];
    };
    WorkflowInstance: {
      id: components["schemas"]["WorkflowInstanceId"];
      origin: components["schemas"]["WorkflowInstanceOrigin"];
      startedAt: components["schemas"]["Instant"];
      finishedAt: components["schemas"]["Instant"] | null;
      status: components["schemas"]["WorkflowCompletionStatus"];
      input: components["schemas"]["WorkflowExecutionValueObjectWithDisplay"];
    };
    WorkflowInstanceOrigin:
      | components["schemas"]["WorkflowInstanceManualOrigin"]
      | components["schemas"]["WorkflowInstanceWorkflowOrigin"]
      | components["schemas"]["WorkflowInstanceEventTriggerOrigin"]
      | components["schemas"]["WorkflowInstanceJobTriggerOrigin"];
    WorkflowInstanceManualOrigin: {
      /** @enum {string} */
      type: "MANUAL";
      id: components["schemas"]["AgencyMemberId"];
      name: string;
    };
    WorkflowInstanceWorkflowOrigin: {
      /** @enum {string} */
      type: "WORKFLOW";
      id: components["schemas"]["WorkflowInstanceId"];
      name: string;
    };
    WorkflowInstanceEventTriggerOrigin: {
      /** @enum {string} */
      type: "EVENT";
      id: components["schemas"]["WorkflowDefinitionTriggerId"];
      name: string;
      eventType: components["schemas"]["WorkflowEventTriggerOptionType"];
      eventTable: string;
    };
    WorkflowInstanceJobTriggerOrigin: {
      /** @enum {string} */
      type: "JOB";
      id: components["schemas"]["WorkflowDefinitionTriggerId"];
      name: string;
    };
    WorkflowCompletionStatus:
      | {
          /** @enum {string} */
          name: "CANCELED" | "IN_PROGRESS" | "SUCCESS";
        }
      | {
          /** @enum {string} */
          name: "ERROR";
          errorMessage: string;
        };
    WorkflowExecutionValueObjectWithDisplay: {
      [key: string]: components["schemas"]["WorkflowExecutionTypedValue"] & {
        displayValue?: string[] | number[] | (null | string | number);
      };
    };
    WorkflowExecutionTypedValue: {
      type: components["schemas"]["WorkflowResolvedDataFieldType"];
      value?: unknown;
    };
    WorkflowResolvedDataFieldType:
      | components["schemas"]["WorkflowOptionField"]
      | components["schemas"]["WorkflowEntityField"]
      | components["schemas"]["WorkflowTextField"]
      | components["schemas"]["WorkflowNumberField"]
      | components["schemas"]["WorkflowBooleanField"]
      | components["schemas"]["WorkflowDateField"]
      | components["schemas"]["WorkflowDateTimeField"]
      | components["schemas"]["WorkflowTimeField"]
      | components["schemas"]["WorkflowFileField"]
      | components["schemas"]["WorkflowUnknownField"];
    WorkflowJobTriggerOption:
      | components["schemas"]["WorkflowAdvancedReportJobTriggerOption"]
      | components["schemas"]["WorkflowStandardReportJobTriggerOption"];
    WorkflowAdvancedReportJobTriggerOption: {
      /** @enum {string} */
      type: "advanced";
      id: components["schemas"]["SavedReportId"];
      name: string;
      fields: components["schemas"]["ExposedNamedField"][];
    };
    ExposedNamedField:
      | (components["schemas"]["WorkflowUnionField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowOptionField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowEntityField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowTextField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowNumberField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowBooleanField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowDateField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowDateTimeField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowTimeField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowFileField"] & {
          name: string;
        })
      | (components["schemas"]["WorkflowUnknownField"] & {
          name: string;
        });
    WorkflowStandardReportJobTriggerOption: {
      /** @enum {string} */
      type: "standard";
      id: components["schemas"]["StandardReportId"];
      name: string;
      fields: components["schemas"]["ExposedNamedField"][];
      filters: components["schemas"]["ExposedNamedField"][];
    };
    WorkflowEventTriggerOption: {
      name: string;
      table: string;
      type: components["schemas"]["WorkflowEventTriggerOptionType"];
      columns: components["schemas"]["ExposedNamedField"][];
    };
    WorkflowHumanTaskTemplateDefinition:
      | {
          /** @enum {string} */
          layout: "manual";
          input: {
            instructions: {
              /** @enum {string} */
              type: "textarea";
            };
          };
        }
      | {
          /** @enum {string} */
          layout: "entity";
          input: {
            instructions: {
              /** @enum {string} */
              type: "textarea";
            };
            caregiver: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Caregiver";
              /** @enum {boolean} */
              optional: true;
            };
            patient: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Patient";
              /** @enum {boolean} */
              optional: true;
            };
            intakePatient: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Patient";
              /** @enum {boolean} */
              optional: true;
            };
            visit: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Visit Instance";
              /** @enum {boolean} */
              optional: true;
            };
            visitBroadcast: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Visit Broadcast";
              /** @enum {boolean} */
              optional: true;
            };
            ticket: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Comm Center Ticket";
              /** @enum {boolean} */
              optional: true;
            };
            files: {
              /** @enum {string} */
              type: "file";
              /** @enum {boolean} */
              array: true;
              /** @enum {boolean} */
              optional: true;
            };
          };
        }
      | {
          /** @enum {string} */
          layout: "document-viewer";
          input: {
            instructions: {
              /** @enum {string} */
              type: "textarea";
            };
            documents: {
              /** @enum {string} */
              type: "file";
              /** @enum {boolean} */
              array: true;
            };
          };
        }
      | {
          /** @enum {string} */
          layout: "chat";
          input: {
            instructions: {
              /** @enum {string} */
              type: "textarea";
            };
            ticket: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Comm Center Ticket";
            };
            showTicketLink: {
              /** @enum {string} */
              type: "boolean";
              /** @enum {boolean} */
              optional: true;
            };
          };
        }
      | {
          /** @enum {string} */
          layout: "intake-call";
          input: {
            patient: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Patient";
            };
          };
        }
      | {
          /** @enum {string} */
          layout: "visit-assignment";
          input: {
            visitAssignment: {
              /** @enum {string} */
              type: "entity";
              /** @enum {string} */
              entity: "Visit Assignment";
            };
          };
        };
    WorkflowEntityLayouts: {
      Caregiver:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Visit Instance":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      Patient:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Authorization":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Agency Member":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      Agency:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Address Info":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Caregiver Certification":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Visit Broadcast":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Caregiver Visit Engagement":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Ticket":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Message":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Label":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Team":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Team Member":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Email Thread":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Email Message":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Compliance Automation":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Caregiver Document":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Caregiver Document Upload":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Compliance Review":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      IntakeStatus:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      User:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Ticket Status":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Ticket Assign":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Workflow Definition":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Intake Status":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Intake Track":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      Note:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Note Subject":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Note Predefined Answer":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      Fax:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Robocall Instance":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Robocall Instance Event":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Intake Call":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Call Session":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Intake Call Time Slot":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Intake Checklist Item":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Medicaid Exception Code":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Medicaid Exception Code Patient Track":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Integration Payer":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Phonebook Contact":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Intake Plan":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Call Session Media":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Intake Track Step":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Slack Channel":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Portal Document":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Caergiver Compliance Instance":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Telephony Call":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Visit Assignment":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Care Moments Adjustment":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Care Moments Adjustment Reason":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Intake Appointment":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Visit Broadcast Boost":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Task Instance":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Task Template":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Service Code":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Contract":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Payroll Code":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Certification Period":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Intake Team":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Outbound SMS Queue Item":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Plan Of Care Type":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Contract Type":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      Office:
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Short Url Token":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Referral User":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Nursing Task":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Authorization File":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Training Center Bundle Due Date":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Training Center Bundle Item":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Telephony Bot Agent":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Task Instance Schedule Override":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Task":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Patient Document AI Review":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Task Issue":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Task Issue Type":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "Comm Center Ticket Bot Agent Result":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
      "HR Question":
        | components["schemas"]["WorkflowEntityListLayout"]
        | components["schemas"]["WorkflowEntityTableLayout"]
        | null;
    };
    WorkflowEntityListLayout: {
      /** @enum {string} */
      type: "list";
      /** @enum {string} */
      width: "fit-content" | "lg" | "md" | "sm";
    };
    WorkflowEntityTableLayout: {
      /** @enum {string} */
      type: "table";
      filters: components["schemas"]["WorkflowEntityFilter"][];
      /* replaced manually */ columns: [["id", components["schemas"]["WorkflowEntityField"]], ...[string, components["schemas"]["WorkflowResolvedDataFieldType"]][]];
    };
    WorkflowEntityFilter:
      | (components["schemas"]["WorkflowEntityBaseFilter"] & {
          /** @enum {string} */
          type: "select";
          multiple: boolean;
          options: {
            value: unknown;
            label: string;
          }[];
        } & {
          /** @enum {boolean} */
          multiple: false;
          defaultValue?: unknown;
        })
      | (components["schemas"]["WorkflowEntityBaseFilter"] & {
          /** @enum {string} */
          type: "select";
          multiple: boolean;
          options: {
            value: unknown;
            label: string;
          }[];
        } & {
          /** @enum {boolean} */
          multiple: true;
          defaultValue?: unknown[] | null;
        })
      | components["schemas"]["WorkflowEntityInputFilter"]
      | components["schemas"]["WorkflowEntityDateRangeFilter"]
      | components["schemas"]["WorkflowEntityHiddenFilter"];
    WorkflowEntityBaseFilter: {
      name: string;
      label: string;
      width?: string[] | ("fit-content" | "lg" | "md" | "sm" | "xl" | "xs");
    };
    WorkflowEntityInputFilter: components["schemas"]["WorkflowEntityBaseFilter"] & {
      /** @enum {string} */
      type: "text";
      defaultValue?: null | string;
    };
    WorkflowEntityDateRangeFilter: components["schemas"]["WorkflowEntityBaseFilter"] & {
      /** @enum {string} */
      type: "date-range";
      defaultValue?:
        | [
            components["schemas"]["LocalDate"],
            components["schemas"]["LocalDate"] | null
          ]
        | ("24h" | "30d" | "365d" | "7d" | "90d");
    };
    WorkflowEntityHiddenFilter: {
      /** @enum {string} */
      type: "hidden";
      name: string;
      fieldType: components["schemas"]["WorkflowDataFieldType"];
    };
    WorkflowEntityTableLayoutResponse: {
      rows: ({
        id: unknown;
        $display: string | number;
      } & { [key: string]: unknown })[];
    };
    WorkflowEntityListLayoutResponse: {
      rows: {
        id: unknown;
        label: string;
        tags: string[];
        terms: string[];
      }[];
    };
    "Record<string,unknown>": { [key: string]: unknown };
    WorkflowEntityWithId: {
      entity: components["schemas"]["WorkflowEntity"];
      id: unknown;
    };
    WorkflowDashboard: {
      correlationKey: components["schemas"]["WorkflowDefinitionCorrelationKey"];
      versions: {
        id: components["schemas"]["WorkflowDefinitionId"];
        name: string;
        input: components["schemas"]["WorkflowInputs"];
        number: number;
        published: boolean;
        owner: {
          id: components["schemas"]["AgencyMemberId"];
          name: string;
        };
        createdAt: components["schemas"]["Instant"];
      }[];
      instances: components["schemas"]["WorkflowInstance"][];
    };
    ListedWorkflowTaskCluster: {
      id: components["schemas"]["WorkflowTaskClusterId"];
      name: string;
      input: [string, components["schemas"]["WorkflowDataFieldType"]][];
      threshold: null | number;
    };
    /** @enum {string} */
    AggregationUnit: "day" | "hour";
    WorkflowExecutionValueObject: {
      [key: string]: components["schemas"]["WorkflowExecutionTypedValue"];
    };
    "SerializedMap<string,WorkflowExecutionNodeResult>": {
      /** @enum {string} */
      __type: "Map";
      value: [string, components["schemas"]["WorkflowExecutionNodeResult"]][];
    };
    WorkflowExecutionNodeResult: {
      id: components["schemas"]["WorkflowTaskInstanceId"] | null;
      status: components["schemas"]["WorkflowTaskCompletionStatus"];
      input: components["schemas"]["WorkflowExecutionValueObjectWithDisplay"];
      output: {
        key: string;
        fields: components["schemas"]["WorkflowExecutionValueObjectWithDisplay"];
      } | null;
      startedAt: components["schemas"]["Instant"] | null;
      finishedAt: components["schemas"]["Instant"] | null;
      executedBy:
        | {
            /** @enum {string} */
            type: "system";
          }
        | {
            /** @enum {string} */
            type: "human";
            agencyMemberId: components["schemas"]["AgencyMemberId"];
            name: string;
          }
        | null;
    };
    WorkflowTaskCompletionStatus:
      | {
          /** @enum {string} */
          name: "CREATED" | "SUCCESS" | "WAITING";
        }
      | {
          /** @enum {string} */
          name: "ERROR";
          errorMessage: string;
        };
    ListedWorkflowTag: {
      id: components["schemas"]["WorkflowTagId"];
      name: string;
      input: [string, components["schemas"]["WorkflowDataFieldType"]][];
    };
    TelephonyParallelCallContactInfo: {
      id: components["schemas"]["PatientId"];
      callOrder: number;
      firstName: string;
      middleName: null | string;
      lastName: string;
      source: string;
      nextCallDate: components["schemas"]["LocalDateTime"] | null;
      hasVoiceMailTemplate: boolean;
      boostType:
        | (
            | "Canceled on Answer"
            | "Email"
            | "Inactive Portal"
            | "Missed Call"
            | "Portal"
            | "SMS"
            | "Self Serve Completed"
            | "Self Serve Help"
            | "Transfer Call to Q2"
          )
        | null;
      isSelfServe: boolean;
      intakeStatusName: string;
    };
    TelephonyCallAssignmentResult:
      | {
          /** @enum {string} */
          status: "OK";
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          reason: "CALL_ALREADY_ASSIGNED";
          to: {
            id: components["schemas"]["AgencyMemberId"];
            name: string;
          };
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          reason: "MEMBER_ALREADY_ASSIGNED";
        };
    TelephonySipEndpointInfo: {
      /** @enum {string} */
      providerName: "plivo";
      username: string;
      password: string;
      endpoint: string;
    };
    TelephonyCallAnswerResult:
      | {
          /** @enum {string} */
          status: "OK";
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          reason: "CALL_ALREADY_ASSIGNED";
          to: {
            id: components["schemas"]["AgencyMemberId"];
            name: string;
          };
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          reason: "MEMBER_ALREADY_ASSIGNED";
        }
      | {
          /** @enum {string} */
          status: "ERROR";
          /** @enum {string} */
          reason: "MEMBER_NOT_INVITED";
        };
    /** @enum {string} */
    TelephonyCallAnswerIntent:
      | "AnswerAnyAgencyMemberInvite"
      | "AnswerInbound"
      | "AnswerInvite"
      | "Auto"
      | "BargeIn";
    TelephonyCallInfo:
      | components["schemas"]["TelephonyInboundCallInfo"]
      | components["schemas"]["TelephonyOutboundCallInfo"]
      | components["schemas"]["TelephonyParallelCallInfo"];
    TelephonyInboundCallInfo: {
      /** @enum {string} */
      direction: "Inbound";
      provider: {
        /** @enum {string} */
        name: "cloudonix" | "plivo";
        callId: string;
      };
      caller: components["schemas"]["TelephonyCallCallerParticipantInfo"];
      callee:
        | (components["schemas"]["TelephonyCallParticipantInfo"] & {
            /** @enum {string} */
            role: "Callee";
            entity:
              | components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"]
              | components["schemas"]["TelephonyCallBotAgentParticipantEntityInfo"]
              | components["schemas"]["TelephonyCallCaregiverParticipantEntityInfo"];
          })
        | null;
      ringingTo: components["schemas"]["TelephonyAgencyMemberRingingTo"][];
      id: components["schemas"]["TelephonyCallId"];
      ticket: components["schemas"]["TelephonyCallTicketInfo"];
      status: components["schemas"]["TelephonyCallStatus"];
      participants: components["schemas"]["TelephonyCallParticipantInfo"][];
      participantEvents: components["schemas"]["TelephonyCallParticipantEvent"][];
      isLive: boolean;
      durationSeconds: null | number;
      notes: components["schemas"]["Note"][];
      rangAt: components["schemas"]["Instant"] | null;
      answeredAt: components["schemas"]["Instant"] | null;
      connectedAt: components["schemas"]["Instant"] | null;
      completedAt: components["schemas"]["Instant"] | null;
      failedAt: components["schemas"]["Instant"] | null;
      failReason:
        | (
            | "CALL_PROCESSED_RETROACTIVELY"
            | "CALL_REJECTED"
            | "INTERNAL"
            | "LOSE_RACE"
            | "MARKED_AS_FAILED_BY_STALE_WORKER"
            | "NORMAL_TEMPORARY_FAILURE"
            | "NO_ANSWER"
            | "NO_USER_RESPONSE"
            | "RECOVERY_ON_TIMER_EXPIRE"
            | "SERVICE_UNAVAILABLE"
            | "SUBSCRIBER_ABSENT"
            | "UNALLOCATED_NUMBER"
            | "UNKNOWN"
            | "UNSPECIFIED"
            | "USER_BUSY"
            | "USER_NOT_REGISTERED"
          )
        | null;
      failDescription: null | string;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      version: number;
      hasRecording: null | boolean;
      transcription: null | string;
      summary: null | string;
      satisfactionRating: null | number;
      satisfactionDescription: null | string;
      markedAsStaleByWorker: boolean;
    };
    TelephonyCallCallerParticipantInfo: components["schemas"]["TelephonyCallParticipantInfo"] & {
      /** @enum {string} */
      role: "Caller";
      entity: components["schemas"]["TelephonyCallParticipantEntityInfo"];
    };
    TelephonyAgencyMemberRingingTo: {
      id: components["schemas"]["AgencyMemberId"];
      firstName: string;
      lastName: string;
      photoUrl: null | string;
    };
    TelephonyCallTicketInfo: {
      id: components["schemas"]["CommCenterTicketId"];
      teamId: components["schemas"]["CommCenterTeamId"];
      teamName: components["schemas"]["CallCenterTeamName"];
    };
    /** Format: CallCenterTeamName */
    CallCenterTeamName: string;
    TelephonyCallParticipantEvent: {
      callId: components["schemas"]["TelephonyCallId"];
      timestamp: components["schemas"]["Instant"];
      data: components["schemas"]["TelephonyCallParticipantEventData"];
    };
    TelephonyCallParticipantEventData:
      | components["schemas"]["TelephonyCallParticipantInitiatedEventData"]
      | components["schemas"]["TelephonyCallParticipantAnsweredEventData"]
      | components["schemas"]["TelephonyCallParticipantHungupEventData"]
      | components["schemas"]["TelephonyCallParticipantLeftEventData"]
      | components["schemas"]["TelephonyCallParticipantRangToEventData"]
      | components["schemas"]["TelephonyCallParticipantInputGatheredEventData"]
      | components["schemas"]["TelephonyCallParticipantInvitedEventData"]
      | components["schemas"]["TelephonyCallParticipantJoinedEventData"]
      | components["schemas"]["TelephonyCallParticipantBargedInEventData"]
      | components["schemas"]["TelephonyCallParticipantEavesDroppedEventData"]
      | components["schemas"]["TelephonyCallParticipantDeclinedEventData"]
      | components["schemas"]["TelephonyCallParticipantRemovedEventData"];
    TelephonyCallParticipantInitiatedEventData: {
      /** @enum {string} */
      name: "Initiated";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantAnsweredEventData: {
      /** @enum {string} */
      name: "Answered";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantHungupEventData: {
      /** @enum {string} */
      name: "Hungup";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantLeftEventData: {
      /** @enum {string} */
      name: "Left";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantRangToEventData: {
      /** @enum {string} */
      name: "RangTo";
      agencyMember: {
        id: components["schemas"]["AgencyMemberId"];
        firstName: string;
        lastName: string;
      };
    };
    TelephonyCallParticipantInputGatheredEventData: {
      /** @enum {string} */
      name: "InputGathered";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
      gatherInputType: components["schemas"]["GatherActionType"];
      digitPressed: string;
      origin: components["schemas"]["TelephonyGatherOrigin"];
    };
    /** @enum {string} */
    GatherActionType:
      | "CaregiverRequestsApplicationSMS"
      | "CaregiverRequestsToLeaveVoiceMail"
      | "HandleInvalidGatherInput"
      | "IdentifyParticipantAsCaregiver"
      | "IdentifyParticipantAsInsuranceProvider"
      | "IdentifyParticipantAsIntakePatient"
      | "IdentifyParticipantAsPatient"
      | "IdentifyParticipantAsReferralUser"
      | "IdentifyParticipantAsRnPlatformClient"
      | "InsuranceProviderRequestsIntakeTeam"
      | "InsuranceProviderRequestsStaffingTeam"
      | "PatientRequestsMoveToSms"
      | "PatientSelectsIntakeTeam"
      | "PatientSelectsStaffingTeam"
      | "PlanSelectsAuthorization"
      | "PlanSelectsNewPatient"
      | "PlanSelectsStaffingTeam";
    /** @enum {string} */
    TelephonyGatherOrigin:
      | "Caregiver"
      | "Patient"
      | "PhonebookContact"
      | "PhonebookContact_Plan"
      | "UnknownCaregiver"
      | "UnknownInsuranceProvider"
      | "UnknownPatient"
      | "UnknownPhoneNumber"
      | "UnknownReferralUser";
    TelephonyCallParticipantInvitedEventData: {
      /** @enum {string} */
      name: "Invited";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantJoinedEventData: {
      /** @enum {string} */
      name: "Joined";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantBargedInEventData: {
      /** @enum {string} */
      name: "BargedIn";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantEavesDroppedEventData: {
      /** @enum {string} */
      name: "EavesDropped";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantDeclinedEventData: {
      /** @enum {string} */
      name: "Declined";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyCallParticipantRemovedEventData: {
      /** @enum {string} */
      name: "Removed";
      participant: components["schemas"]["TelephonyCallParticipantInfo"];
    };
    TelephonyOutboundCallInfo: {
      /** @enum {string} */
      direction: "Outbound";
      provider: {
        /** @enum {string} */
        name: "cloudonix" | "plivo";
        callId: null | string;
      };
      caller: components["schemas"]["TelephonyCallParticipantInfo"] & {
        /** @enum {string} */
        role: "Caller";
        entity:
          | components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallBotAgentParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallCaregiverParticipantEntityInfo"];
      };
      callee: components["schemas"]["TelephonyCallParticipantInfo"] & {
        /** @enum {string} */
        role: "Callee";
        entity:
          | components["schemas"]["TelephonyCallBotAgentParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallPatientParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallPatientContactParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallPhonebookContactParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallNotIdentifiedParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallCaregiverParticipantEntityInfo"];
      };
      ringingTo: components["schemas"]["TelephonyAgencyMemberRingingTo"][];
      id: components["schemas"]["TelephonyCallId"];
      ticket: components["schemas"]["TelephonyCallTicketInfo"];
      status: components["schemas"]["TelephonyCallStatus"];
      participants: components["schemas"]["TelephonyCallParticipantInfo"][];
      participantEvents: components["schemas"]["TelephonyCallParticipantEvent"][];
      isLive: boolean;
      durationSeconds: null | number;
      notes: components["schemas"]["Note"][];
      rangAt: components["schemas"]["Instant"] | null;
      answeredAt: components["schemas"]["Instant"] | null;
      connectedAt: components["schemas"]["Instant"] | null;
      completedAt: components["schemas"]["Instant"] | null;
      failedAt: components["schemas"]["Instant"] | null;
      failReason:
        | (
            | "CALL_PROCESSED_RETROACTIVELY"
            | "CALL_REJECTED"
            | "INTERNAL"
            | "LOSE_RACE"
            | "MARKED_AS_FAILED_BY_STALE_WORKER"
            | "NORMAL_TEMPORARY_FAILURE"
            | "NO_ANSWER"
            | "NO_USER_RESPONSE"
            | "RECOVERY_ON_TIMER_EXPIRE"
            | "SERVICE_UNAVAILABLE"
            | "SUBSCRIBER_ABSENT"
            | "UNALLOCATED_NUMBER"
            | "UNKNOWN"
            | "UNSPECIFIED"
            | "USER_BUSY"
            | "USER_NOT_REGISTERED"
          )
        | null;
      failDescription: null | string;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      version: number;
      hasRecording: null | boolean;
      transcription: null | string;
      summary: null | string;
      satisfactionRating: null | number;
      satisfactionDescription: null | string;
      markedAsStaleByWorker: boolean;
    };
    TelephonyParallelCallInfo: {
      /** @enum {string} */
      direction: "Parallel";
      provider: {
        /** @enum {string} */
        name: "plivo";
        callId: null | string;
      };
      caller:
        | (components["schemas"]["TelephonyCallParticipantInfo"] & {
            /** @enum {string} */
            role: "Caller";
            entity: components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"];
          })
        | null;
      callee: components["schemas"]["TelephonyCallParticipantInfo"] & {
        /** @enum {string} */
        role: "Callee";
        entity:
          | components["schemas"]["TelephonyCallBotAgentParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallPatientParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallPatientContactParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallPhonebookContactParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallNotIdentifiedParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallCaregiverParticipantEntityInfo"];
      };
      hasDetectedVoiceMail: null | boolean;
      classifiedAs: ("Human" | "Unknown" | "VoiceMail") | null;
      id: components["schemas"]["TelephonyCallId"];
      ticket: components["schemas"]["TelephonyCallTicketInfo"];
      status: components["schemas"]["TelephonyCallStatus"];
      participants: components["schemas"]["TelephonyCallParticipantInfo"][];
      participantEvents: components["schemas"]["TelephonyCallParticipantEvent"][];
      isLive: boolean;
      durationSeconds: null | number;
      notes: components["schemas"]["Note"][];
      rangAt: components["schemas"]["Instant"] | null;
      answeredAt: components["schemas"]["Instant"] | null;
      connectedAt: components["schemas"]["Instant"] | null;
      completedAt: components["schemas"]["Instant"] | null;
      failedAt: components["schemas"]["Instant"] | null;
      failReason:
        | (
            | "CALL_PROCESSED_RETROACTIVELY"
            | "CALL_REJECTED"
            | "INTERNAL"
            | "LOSE_RACE"
            | "MARKED_AS_FAILED_BY_STALE_WORKER"
            | "NORMAL_TEMPORARY_FAILURE"
            | "NO_ANSWER"
            | "NO_USER_RESPONSE"
            | "RECOVERY_ON_TIMER_EXPIRE"
            | "SERVICE_UNAVAILABLE"
            | "SUBSCRIBER_ABSENT"
            | "UNALLOCATED_NUMBER"
            | "UNKNOWN"
            | "UNSPECIFIED"
            | "USER_BUSY"
            | "USER_NOT_REGISTERED"
          )
        | null;
      failDescription: null | string;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      version: number;
      hasRecording: null | boolean;
      transcription: null | string;
      summary: null | string;
      satisfactionRating: null | number;
      satisfactionDescription: null | string;
      markedAsStaleByWorker: boolean;
    };
    TelephonyInvitationResult:
      | {
          /** @enum {string} */
          status: "OK";
          endpoint: string;
        }
      | {
          /** @enum {string} */
          status:
            | "AGENCY_MEMBER_NOT_CONNECTED"
            | "ALREADY_INVITED"
            | "ALREADY_IN_CALL"
            | "CALL_NOT_CONNECTED"
            | "NO_SELF_INVITE"
            | "NO_SIP_ENDPOINT";
        }
      | {
          /** @enum {string} */
          status: "OK";
        }
      | {
          /** @enum {string} */
          status:
            | "ALREADY_INVITED"
            | "CALL_NOT_CONNECTED"
            | "CONTACT_ALREADY_IN_THE_CALL"
            | "INVALID_PHONE_NUMBER";
        }
      | {
          /** @enum {string} */
          status: "OK";
        };
    TelephonyUnResolvedInviteToCallInvitee:
      | {
          /** @enum {string} */
          type: "AgencyMember";
          id: components["schemas"]["AgencyMemberId"];
        }
      | {
          /** @enum {string} */
          type:
            | "Caregiver"
            | "NotIdentified"
            | "Patient"
            | "PatientContact"
            | "PhonebookContact";
          phonenumber: string;
        }
      | {
          /** @enum {string} */
          type: "BotAgent";
          botAgent: {
            type: string;
            input: { [key: string]: unknown };
          };
        };
    TelephonyInboundRingingCallInfo: {
      rangAt: components["schemas"]["Instant"];
      /** @enum {string} */
      direction: "Inbound";
      provider: {
        /** @enum {string} */
        name: "cloudonix" | "plivo";
        callId: string;
      };
      caller: components["schemas"]["TelephonyCallCallerParticipantInfo"];
      callee:
        | (components["schemas"]["TelephonyCallParticipantInfo"] & {
            /** @enum {string} */
            role: "Callee";
            entity:
              | components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"]
              | components["schemas"]["TelephonyCallBotAgentParticipantEntityInfo"]
              | components["schemas"]["TelephonyCallCaregiverParticipantEntityInfo"];
          })
        | null;
      ringingTo: components["schemas"]["TelephonyAgencyMemberRingingTo"][];
      id: components["schemas"]["TelephonyCallId"];
      ticket: components["schemas"]["TelephonyCallTicketInfo"];
      status: components["schemas"]["TelephonyCallStatus"];
      participants: components["schemas"]["TelephonyCallParticipantInfo"][];
      participantEvents: components["schemas"]["TelephonyCallParticipantEvent"][];
      isLive: boolean;
      durationSeconds: null | number;
      notes: components["schemas"]["Note"][];
      answeredAt: components["schemas"]["Instant"] | null;
      connectedAt: components["schemas"]["Instant"] | null;
      completedAt: components["schemas"]["Instant"] | null;
      failedAt: components["schemas"]["Instant"] | null;
      failReason:
        | (
            | "CALL_PROCESSED_RETROACTIVELY"
            | "CALL_REJECTED"
            | "INTERNAL"
            | "LOSE_RACE"
            | "MARKED_AS_FAILED_BY_STALE_WORKER"
            | "NORMAL_TEMPORARY_FAILURE"
            | "NO_ANSWER"
            | "NO_USER_RESPONSE"
            | "RECOVERY_ON_TIMER_EXPIRE"
            | "SERVICE_UNAVAILABLE"
            | "SUBSCRIBER_ABSENT"
            | "UNALLOCATED_NUMBER"
            | "UNKNOWN"
            | "UNSPECIFIED"
            | "USER_BUSY"
            | "USER_NOT_REGISTERED"
          )
        | null;
      failDescription: null | string;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      version: number;
      hasRecording: null | boolean;
      transcription: null | string;
      summary: null | string;
      satisfactionRating: null | number;
      satisfactionDescription: null | string;
      markedAsStaleByWorker: boolean;
    };
    InboundCallIdentifiedCallerEntity:
      | {
          /** @enum {string} */
          type: "Caregiver";
          id: components["schemas"]["CaregiverId"];
          displayId: null | number;
          photoUrl: null | string;
          fullName: string;
          status: components["schemas"]["CaregiverStatus"];
        }
      | {
          /** @enum {string} */
          type: "Patient";
          id: components["schemas"]["PatientId"];
          displayId: null | number;
          gender: null | string;
          fullName: string;
          status: components["schemas"]["PatientStatus"];
          selfServe?: boolean;
          wasSelfServe?: boolean;
        }
      | {
          /** @enum {string} */
          type: "PatientContact";
          id: components["schemas"]["PatientContactId"];
          firstName: string;
          lastName: string;
          relationship: string;
          patient: {
            id: components["schemas"]["PatientId"];
            displayId: null | number;
            gender: null | string;
            fullName: string;
            status: components["schemas"]["PatientStatus"];
            selfServe?: boolean;
            wasSelfServe?: boolean;
          };
        }
      | {
          /** @enum {string} */
          type: "PhonebookContact";
          id: components["schemas"]["AgencyPhonebookContactId"];
          contactType: components["schemas"]["PhonebookContactType"];
          name: string;
        };
    TelephonyCallParticipantEntity:
      | {
          /** @enum {string} */
          type: "AgencyMember";
          id: components["schemas"]["AgencyMemberId"];
        }
      | {
          /** @enum {string} */
          type: "Caregiver";
          id: components["schemas"]["CaregiverId"];
        }
      | {
          /** @enum {string} */
          type: "Patient";
          id: components["schemas"]["PatientId"];
        }
      | {
          /** @enum {string} */
          type: "PatientContact";
          id: components["schemas"]["PatientContactId"];
          patientId: components["schemas"]["PatientId"];
        }
      | {
          /** @enum {string} */
          type: "PhonebookContact";
          id: components["schemas"]["AgencyPhonebookContactId"];
          contactType: components["schemas"]["PhonebookContactType"];
        }
      | {
          /** @enum {string} */
          type: "NotIdentified";
          id: components["schemas"]["CallSessionNotIdentifiedCallerCalleeId"];
          kind: components["schemas"]["TelephonyNotIdentifiedKind"];
        }
      | {
          /** @enum {string} */
          type: "BotAgent";
          id: components["schemas"]["TelephonyBotAgentId"];
        };
    IvrDutyOption: {
      code: string;
      name: string;
    };
    IvrPotentialVisit: {
      patientId: components["schemas"]["PatientId"];
      patientFirstName: string;
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverFirstName: string;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      currentTimeInVisitTimezone: components["schemas"]["LocalDateTime"];
      planOfCareDuties: components["schemas"]["IvrPlanOfCareDuty"][];
    };
    IvrPlanOfCareDuty: {
      code: string;
      name: string;
      frequency: string;
      days: string[] | null;
    };
    IvrCaregiverByPhone: {
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverFirstName: string;
    };
    IvrClockVisitResult: {
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      clockinClockoutRecordId: components["schemas"]["ClockinClockoutRecordId"];
      success: boolean;
    };
    IvrClockVisit: {
      patientId: components["schemas"]["PatientId"] | null;
      visitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      dutyCodes?: string[] | null;
      dutyTexts?: string[] | null;
      detectedType?: ("IN" | "OUT") | null;
    };
    IvrCandidateVisit: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      patientId: components["schemas"]["PatientId"];
      patientFirstName: string;
      patientLastName: string;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      duties: components["schemas"]["IvrCandidateDuty"][];
      dutiesRequired: boolean;
    };
    IvrCandidateDuty: {
      planOfCareItemId: components["schemas"]["PlanOfCareItemId"];
      label: string;
    };
    OfficeDutyCatalog: {
      officeId: components["schemas"]["OfficeId"];
      duties: components["schemas"]["OfficeDuty"][];
    };
    OfficeDuty: {
      code: string;
      name: string;
    };
    IntegrationPayer: {
      id: components["schemas"]["IntegrationPayerId"];
      payerName: string;
      state: string;
      description: null | string;
      payerCode: string;
      vendorName: string;
      payerType: null | string;
    };
    IntakeStatus: {
      id: components["schemas"]["IntakeStatusId"];
      code: string;
      status: string;
      parentId: components["schemas"]["IntakeStatusId"] | null;
    };
    /** Format: IntakeStatusId */
    IntakeStatusId: IntakeStatusId;
    IntakeStatusByTrack: {
      trackId: components["schemas"]["IntakeTrackId"];
      statuses: components["schemas"]["IntakeStatus"][];
    };
    /** Format: IntakeTrackId */
    IntakeTrackId: IntakeTrackId;
    MedicaidStatus: {
      id: components["schemas"]["MedicaidStatusId"];
      name: string;
      description: string;
      /** @enum {string} */
      isEligible: "Manual" | "No" | "Yes";
    };
    /** Format: MedicaidStatusId */
    MedicaidStatusId: MedicaidStatusId;
    PatientIntakeTrack: {
      id: components["schemas"]["IntakeTrackId"];
      name: string;
      isPrimary: boolean;
      code: string;
    };
    IntakePatientDashboardDetails: {
      id: components["schemas"]["PatientId"];
      firstName: string;
      middleName: null | string;
      lastName: string;
      email: null | string;
      displayId: null | number;
      plans: string[];
      medicaidStatus: components["schemas"]["MedicaidStatus"] | null;
      medicaidId: null | string;
      medicareStatus: ("Eligible" | "Not Eligible") | null;
      lastCall: components["schemas"]["LocalDateTime"] | null;
      nextCall: components["schemas"]["LocalDateTime"] | null;
      nextCallDetails:
        | components["schemas"]["IntakeCallWithDisplayData"]
        | null;
      leadSource:
        | (
            | "A Place for Mom"
            | "FC"
            | "Facility lead"
            | "Insurance plan"
            | "Marketer - Asher"
            | "Marketer - Omar"
            | "Marketer - Rodel"
            | "Online lead - Bing"
            | "Online lead - Facebook"
            | "Online lead - General"
            | "Online lead - Google"
          )
        | null;
      track: components["schemas"]["PatientIntakeTrack"];
      intakeStatus: components["schemas"]["IntakeStatus"];
      gender: ("F" | "M") | null;
      NYIA1Status: {
        date: components["schemas"]["Instant"] | null;
        completed: boolean;
      };
      NYIA2Status: {
        date: components["schemas"]["Instant"] | null;
        completed: boolean;
      };
      UASStatus: {
        date: components["schemas"]["Instant"] | null;
        completed: boolean;
      };
      lastUpdatedAt: components["schemas"]["Instant"];
      createdAt: components["schemas"]["Instant"];
      patientStatus: components["schemas"]["PatientStatus"];
      activeWorkflows: {
        id: components["schemas"]["WorkflowInstanceId"];
        name: string;
        status: components["schemas"]["WorkflowInstanceStatus"];
      }[];
      contactNames: null | string;
      /**
       * @description If the flow is stuck on a step that is not "isStop" it
       * means some process were stopped in the middle then it will be true
       */
      isIncompleteIntakeFlow: boolean;
      currentCallQueue: string;
      intakeFlowType: components["schemas"]["IntakeFlowType"];
      wasSelfServe: boolean;
      assignedAgencyMember:
        | components["schemas"]["PatientIntakeAssignedAgencyMember"]
        | null;
    };
    IntakeCallWithDisplayData: {
      createdByName: string;
      id: components["schemas"]["PatientIntakeCallId"];
      patientId: components["schemas"]["PatientId"];
      phoneNumber: null | string;
      callDate: components["schemas"]["LocalDateTime"] | null;
      manualLocalDateTime: components["schemas"]["LocalDateTime"] | null;
      intakeStatus: components["schemas"]["IntakeStatus"];
      isLatest: boolean;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      followUpStep: components["schemas"]["NextCallFollowUpStep"];
      burstNum: number;
      burstPrevCall: components["schemas"]["PatientIntakeCallId"] | null;
      actualCallTimeStart: components["schemas"]["Instant"] | null;
      actualCallTimeEnd: components["schemas"]["Instant"] | null;
      createdBy: components["schemas"]["UserId"];
      boost: components["schemas"]["IntakeCallBoost"] | null;
      callId: components["schemas"]["TelephonyCallId"] | null;
      callDirection: ("Inbound" | "Outbound" | "Parallel") | null;
      callStatus:
        | (
            | "Canceled"
            | "Classifying"
            | "Completed"
            | "Connecting"
            | "Failed"
            | "InProgress"
            | "Initiated"
            | "Missed"
            | "MovedToSMS"
            | "NoAnswer"
            | "Ringing"
            | "VoiceMail"
          )
        | null;
    };
    /** Format: PatientIntakeCallId */
    PatientIntakeCallId: PatientIntakeCallId;
    /** @enum {string} */
    NextCallFollowUpStep:
      | "FIRST_CALL"
      | "FOLLOW_UP_1"
      | "FOLLOW_UP_2"
      | "FOLLOW_UP_3";
    IntakeCallBoost: {
      type: components["schemas"]["IntakeCallBoostType"];
      description: string;
      boostedAt: components["schemas"]["Instant"];
    };
    /** @enum {string} */
    IntakeCallBoostType:
      | "Canceled on Answer"
      | "Email"
      | "Inactive Portal"
      | "Missed Call"
      | "Portal"
      | "SMS"
      | "Self Serve Completed"
      | "Self Serve Help"
      | "Transfer Call to Q2";
    /** @enum {string} */
    WorkflowInstanceStatus: "CANCELED" | "ERROR" | "IN_PROGRESS" | "SUCCESS";
    /** @enum {string} */
    IntakeFlowType: "Regular" | "Self Serve";
    IntakePatientProfile: {
      id: components["schemas"]["PatientId"];
      firstName: string;
      email?: null | string;
      lastName: string;
      middleName: null | string;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      intakeStatus: components["schemas"]["IntakeStatus"];
      referralSource:
        | (
            | "A Place for Mom"
            | "FC"
            | "Facility lead"
            | "Insurance plan"
            | "Marketer - Asher"
            | "Marketer - Omar"
            | "Marketer - Rodel"
            | "Online lead - Bing"
            | "Online lead - Facebook"
            | "Online lead - General"
            | "Online lead - Google"
          )
        | null;
      address: null | string;
      address2: null | string;
      addressComponents:
        | components["schemas"]["PatientAddressComponents"]
        | null;
      addressInstructions: null | string;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      phoneNumbers: components["schemas"]["IntakePatientPhoneNumber"][];
      gender: ("F" | "M") | null;
      notes: components["schemas"]["EntityNote"][];
      contacts: components["schemas"]["PatientContact"][] | null;
      plans: components["schemas"]["PatientIntakePlan"][] | null;
      NYIA1AppoitmentDate: components["schemas"]["Instant"] | null;
      NYIA2AppoitmentDate: components["schemas"]["Instant"] | null;
      NYIA1Completed: boolean;
      NYIA2Completed: boolean;
      NYIA1Location: ("Face-to-face" | "via Zoom") | null;
      NYIA1Clinician: null | string;
      NYIA2Location: ("Face-to-face" | "via Zoom") | null;
      NYIA2Clinician: null | string;
      NYIAResults: ("Approved" | "Denied") | null;
      UASAssessmentDate: components["schemas"]["Instant"] | null;
      UASCompleted: boolean;
      UASHoursAmount: null | number;
      track: components["schemas"]["PatientIntakeTrack"];
      exceptionCode: components["schemas"]["MedicaidExceptionCode"][] | null;
      planEnrollmentStatus:
        | (
            | "No plan"
            | "Pending Enrollment agreement"
            | "Pending UAS"
            | "Pending first contact"
            | "Plan chosen - in network"
            | "Plan chosen - not in network"
          )
        | null;
      medicareId: null | string;
      medicaidId: null | string;
      medicaidStatus: components["schemas"]["MedicaidStatus"] | null;
      medicareStatus: ("Eligible" | "Not Eligible") | null;
      planStartDate: components["schemas"]["LocalDate"] | null;
      nextCallDate: components["schemas"]["LocalDateTime"] | null;
      nextCallDetails:
        | components["schemas"]["IntakeCallWithDisplayData"]
        | null;
      lastCallDate: components["schemas"]["LocalDateTime"] | null;
      patientStatus: components["schemas"]["PatientStatus"];
      intakeFlowType: components["schemas"]["IntakeFlowType"];
      isMainContactPatient: boolean;
      planSelectionCompleted: boolean;
      dischargeDate: components["schemas"]["LocalDate"] | null;
      caseManagerName: null | string;
      caseManagerPhoneNumber: null | string;
      caseManagerRouting: null | string;
      currentFlowDisplay: components["schemas"]["IntakeExternalFlowId"] | null;
      essenAssessmentDate: components["schemas"]["Instant"] | null;
      essenAssessmentCompleted: boolean;
      referralDate: components["schemas"]["LocalDate"] | null;
      mainPhoneNumber: null | string;
      wasSelfServe: boolean;
      ssn?: null | string;
      applyToChha: boolean;
      assignedAgencyMember:
        | components["schemas"]["PatientIntakeAssignedAgencyMember"]
        | null;
      referrer: components["schemas"]["ReferralUser"] | null;
      referredAt: components["schemas"]["Instant"] | null;
      hearAboutUs: null | string;
    };
    IntakePatientPhoneNumber: components["schemas"]["PatientPhoneNumber"] & {
      isForPortalLogin: boolean;
    };
    PatientIntakePlan: {
      id: components["schemas"]["PatientIntakePlanId"];
      plan: components["schemas"]["IntegrationPayer"];
      uasHoursAmount: null | number;
      uasAssessmentDate: components["schemas"]["Instant"] | null;
      planStartDate: components["schemas"]["LocalDate"] | null;
      referralDate: components["schemas"]["LocalDate"] | null;
      caseManagerName: null | string;
      caseManagerPhoneNumber: null | string;
      caseManagerRouting: null | string;
      main: boolean;
      selected: boolean;
      current: boolean;
    };
    /** Format: PatientIntakePlanId */
    PatientIntakePlanId: PatientIntakePlanId;
    MedicaidExceptionCode: {
      id: components["schemas"]["MedicaidExceptionCodeId"];
      code: string;
      description: string;
      isEligible: boolean;
    };
    /** Format: MedicaidExceptionCodeId */
    MedicaidExceptionCodeId: MedicaidExceptionCodeId;
    /** Format: IntakeExternalFlowId */
    IntakeExternalFlowId: IntakeExternalFlowId;
    ReferralUser: {
      phonebookContactId: components["schemas"]["AgencyPhonebookContactId"];
      id: components["schemas"]["ReferralUserId"];
      userId: components["schemas"]["UserId"];
      name: string;
      email: string;
      phoneNumber: string;
      role: null | string;
      organization: null | string;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
    };
    /** Format: ReferralUserId */
    ReferralUserId: ReferralUserId;
    EditPatientContact: {
      /** Format: PatientContactId */
      id?: PatientContactId;
      firstName: string;
      middleName?: null | string;
      lastName: string;
      relationship: string;
      mobilePhoneNumber: string;
      homePhoneNumber?: null | string;
      email?: null | string;
      address?: null | string;
      addressComponents?:
        | components["schemas"]["PatientContactAddressComponents"]
        | null;
      address2?: null | string;
      isEmergencyContact?: boolean;
      livesWithPatient?: boolean;
    };
    EditPatientIntakePlan: {
      /** Format: PatientIntakePlanId */
      id?: PatientIntakePlanId;
      plan: components["schemas"]["IntegrationPayer"];
      uasHoursAmount?: null | number;
      uasAssessmentDate?: components["schemas"]["Instant"] | null;
      planStartDate?: components["schemas"]["LocalDate"] | null;
      referralDate?: components["schemas"]["LocalDate"] | null;
      caseManagerName?: null | string;
      caseManagerPhoneNumber?: null | string;
      caseManagerRouting?: null | string;
      main?: boolean;
      selected?: boolean;
      current?: boolean;
    };
    IntakeCallOrder: components["schemas"]["IntakeNextCall"] & {
      assignedAgencyMemberId: components["schemas"]["AgencyMemberId"] | null;
      queueName: components["schemas"]["IntakeQueueName"];
      patientTotalStepsAnswered: number;
    };
    IntakeNextCall: {
      id: components["schemas"]["PatientIntakeCallId"];
      patientId: components["schemas"]["PatientId"];
      phoneNumber: null | string;
      callDate: components["schemas"]["LocalDateTime"] | null;
      manualLocalDateTime: components["schemas"]["LocalDateTime"] | null;
      intakeStatus: components["schemas"]["IntakeStatus"];
      isLatest: boolean;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      followUpStep: components["schemas"]["NextCallFollowUpStep"];
      burstNum: number;
      burstPrevCall: components["schemas"]["PatientIntakeCallId"] | null;
      actualCallTimeStart: components["schemas"]["Instant"] | null;
      actualCallTimeEnd: components["schemas"]["Instant"] | null;
      createdBy: components["schemas"]["UserId"];
      boost: components["schemas"]["IntakeCallBoost"] | null;
      callId: components["schemas"]["TelephonyCallId"] | null;
      callDirection: ("Inbound" | "Outbound" | "Parallel") | null;
      callStatus:
        | (
            | "Canceled"
            | "Classifying"
            | "Completed"
            | "Connecting"
            | "Failed"
            | "InProgress"
            | "Initiated"
            | "Missed"
            | "MovedToSMS"
            | "NoAnswer"
            | "Ringing"
            | "VoiceMail"
          )
        | null;
    };
    IntakeQueueName: string;
    IntakeTeam: {
      id: components["schemas"]["IntakeTeamId"];
      name: string;
      active: boolean;
    };
    /** Format: IntakeTeamId */
    IntakeTeamId: IntakeTeamId;
    IntakePatientPlansDashboardDetails: {
      patientFirstName: string;
      patientLastName: string;
      patientGender: ("F" | "M") | null;
      patientId: components["schemas"]["PatientId"];
      patientDisplayId: null | number;
      patientCurrentPlan: null | string;
      patientReferredPlan: null | string;
      referralDate: components["schemas"]["LocalDate"] | null;
      patientIntakeStatus: string;
      patientStatus: components["schemas"]["PatientStatus"];
      main: boolean;
      selected: boolean;
    };
    IntakePatientParallelCall: {
      patientId: components["schemas"]["PatientId"];
      patientDisplayId: null | number;
      patientStatus: components["schemas"]["PatientStatus"];
      patientGender: null | string;
      patientFirstName: string;
      patientLastName: string;
      patientIntakeStatus: string;
      callOrder: null | number;
      nextCallDetails:
        | components["schemas"]["IntakeCallWithDisplayData"]
        | null;
      phoneNumbers: components["schemas"]["PatientPhoneNumber"][];
      patientContacts: components["schemas"]["PatientContact"][];
    };
    PatientIntakeProcessSummary: {
      patientId: components["schemas"]["PatientId"];
      summary: string;
      nextActionItems: string[];
      isPatientInCorrectStatus: boolean;
      lastUpdatedAt: components["schemas"]["Instant"] | null;
      isPatientInCorrectStatusExplanation: string;
    };
    PatientIntakeHistoryRow: {
      patientId: components["schemas"]["PatientId"];
      changeSource: string;
      changedEntity: components["schemas"]["PatientIntakeHistoryEntity"];
      changedField: {
        title: string;
        type: components["schemas"]["PatientIntakeHistoryChangedFieldType"];
      };
      changeType: components["schemas"]["PatientIntakeHistoryChangeType"];
      changedBy: string;
      oldValue: null | string;
      newValue: null | string;
      changeTime: components["schemas"]["Instant"];
    };
    PatientIntakeHistoryEntity:
      | {
          /** @enum {string} */
          type: "Patient";
          /** @enum {string} */
          name: "";
          patientId: components["schemas"]["PatientId"];
        }
      | {
          /** @enum {string} */
          type: "Patient Contact";
          name: string;
          contactId: components["schemas"]["PatientContactId"];
          relationship: string;
        }
      | {
          /** @enum {string} */
          type: "Plan";
          name: string;
          planId: components["schemas"]["PatientIntakePlanId"];
        }
      | {
          /** @enum {string} */
          type: "Checklist Item";
          name: string;
          checklistItemId: components["schemas"]["IntakeChecklistItemId"];
        }
      | {
          /** @enum {string} */
          type: "Eligibility Check";
          /** @enum {string} */
          name: "Eligibility Check";
          patientId: components["schemas"]["PatientId"];
        }
      | {
          /** @enum {string} */
          type: "Appointment";
          name: string;
          appointmentId: components["schemas"]["PatientIntakeAppointmentId"];
          appointmentType: components["schemas"]["AppointmentTypes"];
          appointmentDateTime: components["schemas"]["Instant"] | null;
          clinician: null | string;
          location: null | string;
        };
    /** Format: IntakeChecklistItemId */
    IntakeChecklistItemId: IntakeChecklistItemId;
    /** Format: PatientIntakeAppointmentId */
    PatientIntakeAppointmentId: PatientIntakeAppointmentId;
    /** @enum {string} */
    AppointmentTypes: "Essen" | "NYIA1" | "NYIA2" | "UAS";
    /** @enum {string} */
    PatientIntakeHistoryChangedFieldType:
      | "boolean"
      | "checkbox"
      | "date"
      | "dateTime"
      | "number"
      | "phoneNumber"
      | "string";
    /** @enum {string} */
    PatientIntakeHistoryChangeType:
      | "Added"
      | "Added Entity"
      | "Checked"
      | "Removed"
      | "Removed Entity"
      | "Unchecked"
      | "Updated";
    DashboardFax: {
      createdByUserName: null | string;
      relatedCaregiver: {
        id: components["schemas"]["CaregiverId"];
        name: string;
        photoUrl: null | string;
        status: components["schemas"]["CaregiverStatus"];
        displayId: null | number;
      } | null;
      relatedPatient: {
        id: components["schemas"]["PatientId"];
        name: string;
        status: components["schemas"]["PatientStatus"];
        displayId: null | number;
        gender: null | string;
      } | null;
      id: components["schemas"]["FaxDetailsId"];
      type: components["schemas"]["FaxType"];
      status: components["schemas"]["FaxStatus"];
      createdAt: components["schemas"]["Instant"];
      sender: string;
      recipient: string;
      isActionStatusDone: boolean;
      actionFailedReason: null | string;
      relatedEntityType: null | string;
    };
    /** Format: FaxDetailsId */
    FaxDetailsId: FaxDetailsId;
    /** @enum {string} */
    FaxType: "Inbound" | "Outbound";
    /** @enum {string} */
    FaxStatus: "failed" | "processing" | "success" | "transmitting";
    PatientTaskDocumentFaxRequest: {
      /** @enum {string} */
      type: "TaskDocument";
      fileUrl: string;
      faxNumber: string;
      relatedEntity: components["schemas"]["FaxRelatedEntity"];
      recipient: string;
      comment: string;
      subject: string;
    };
    FaxRelatedEntity:
      | components["schemas"]["RelatedCaregiver"]
      | components["schemas"]["RelatedPatient"];
    RelatedCaregiver: {
      /** @enum {string} */
      type: "Caregiver";
      caregiverId: components["schemas"]["CaregiverId"];
    };
    RelatedPatient: {
      /** @enum {string} */
      type: "Patient";
      patientId: components["schemas"]["PatientId"];
    };
    PatientScheduledDocumentFaxRequest: {
      /** @enum {string} */
      type: "ScheduledDocument";
      documentId: components["schemas"]["PatientDocumentScheduleId"];
      faxNumber: string;
      relatedEntity: components["schemas"]["FaxRelatedEntity"];
      recipient: string;
      comment: string;
      subject: string;
    };
    MultiplePatientScheduledDocumentsFaxRequest: {
      /** @enum {string} */
      type: "MultipleScheduledDocuments";
      documentIds: components["schemas"]["PatientDocumentScheduleId"][];
      faxNumber: string;
      relatedEntity: components["schemas"]["FaxRelatedEntity"];
      recipient: string;
      comment: string;
      subject: string;
    };
    /** Format: PatientBpDeviceImei */
    PatientBpDeviceImei: string;
    PatientBpHistory: {
      id: components["schemas"]["PatientBpHistoryId"];
      patient_id: components["schemas"]["PatientId"];
      done_at: components["schemas"]["Instant"];
      systolic: number;
      diastolic: number;
      pulse: number;
      irregular_heartbeat: boolean;
      hand_tremor: boolean;
      three_measurement: boolean;
      payload: { [key: string]: unknown };
    };
    /** Format: PatientBpHistoryId */
    PatientBpHistoryId: PatientBpHistoryId;
    CaregiverFlagMap: {
      "No call, no show": boolean;
      "Not answering calls": boolean;
      "Not answering chats": boolean;
      "Not reliable": boolean;
      "Patient complaint": boolean;
      "Not proactive with patient care": boolean;
    };
    /** @enum {string} */
    CaregiverFlagOption:
      | "No call, no show"
      | "Not answering calls"
      | "Not answering chats"
      | "Not proactive with patient care"
      | "Not reliable"
      | "Patient complaint";
    PatientWebsiteFeaturedCaregiver: {
      id: components["schemas"]["CaregiverId"];
      name: string;
      avatar: string;
      address: string;
    };
    PatientWebsiteCaregiverInProximity: {
      id: components["schemas"]["CaregiverId"];
      name: string;
      avatar: string;
      latitude: number;
      longitude: number;
    };
    /** @enum {string} */
    WebsiteVisitorEventType:
      | "cta_click"
      | "form_submission"
      | "page_view"
      | "phone_call";
    PortalPatient: {
      id: components["schemas"]["PatientId"];
      firstName: string;
      middleName: null | string;
      status: components["schemas"]["PatientStatus"];
      lastName: string;
      phoneNumber: null | string;
      email: null | string;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      medicaidId: null | string;
      gender: null | string;
      address: null | string;
      address2: null | string;
      ssn: null | string;
      isActiveSelfServe: boolean;
    };
    PortalNYIAAppointment: {
      type: components["schemas"]["AppointmentTypes"];
      date: components["schemas"]["Instant"] | null;
      completed: null | boolean;
      location: ("Face-to-face" | "via Zoom") | null;
      clinician: null | string;
    };
    CicoIssuesVisit: {
      visitId: components["schemas"]["VisitInstanceId"];
      visitDate: components["schemas"]["LocalDate"];
      visitStartTime: components["schemas"]["LocalDateTime"];
      visitEndTime: components["schemas"]["LocalDateTime"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientStatus: components["schemas"]["PatientStatus"];
      patientClinicalSeverityLevel:
        | ("HIGHEST_ASSISTANCE" | "MINIMAL_ASSISTANCE" | "WALKING_ASSISTANCE")
        | null;
      patientGender: null | string;
      patientDisplayId: null | number;
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverName: string;
      caregiverPhotoUrl: null | string;
      caregiverStatus: components["schemas"]["CaregiverStatus"];
      caregiverDisplayId: null | number;
      contractName: string;
      clockinTime: components["schemas"]["LocalDateTime"] | null;
      clockoutTime: components["schemas"]["LocalDateTime"] | null;
      assignedAgencyMemberId: components["schemas"]["AgencyMemberId"] | null;
      note: null | string;
      attemptedToReachAt: components["schemas"]["LocalDateTime"] | null;
      successfullyReachedAt: components["schemas"]["LocalDateTime"] | null;
      timesheetSentAt: components["schemas"]["LocalDateTime"] | null;
      filingLimitDaysLeft: null | number;
      agencyMemberName: null | string;
      agencyMemberPhotoUrl: null | string;
      visitIssues: components["schemas"]["BillingPayrollVisitIssues"] | null;
    };
    BillingPayrollVisitIssues: {
      missingClockTimes: boolean;
      noCaregiver: boolean;
      caregiverIncompliant: boolean;
      scheduleAuthAllocationConflict: boolean;
      noMatchingAuthorization: boolean;
      invalidAuthAssignment: boolean;
      missingAuthHours: boolean;
      clockinTimeMismatch: boolean;
      clockoutTimeMismatch: boolean;
      calendarDayMismatch: boolean;
      hasSameDayVisitsIssues: boolean;
      patientOverlapIssue: boolean;
      caregiverOverlapIssue: boolean;
      noBillingRate: boolean;
      noBillingRateCounty: boolean;
      noDxCodes: boolean;
      overbilledDay: boolean;
      missedVisit: boolean;
      missingMatchingMutualVisit: boolean;
      zeroBillingUnits: boolean;
      unapprovedManualClockTimesEdit: boolean;
      insufficientVisitDuties: boolean;
      missingPersonalCareDuty: boolean;
      excessiveClockDistance: boolean;
      manualHoldInvoicing: boolean;
      zeroDollarPayRate: boolean;
      missingCaregiversSSNIssue: boolean;
      missingPatientMemberIDIssue: boolean;
      missingAddressIssue: boolean;
    };
    SandataResubmitVisitResult: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      status: components["schemas"]["SandataResubmitVisitStatus"];
      error?: string;
    };
    /** @enum {string} */
    SandataResubmitVisitStatus: "failed" | "rate_limited" | "submitted";
    /** Format: EvvDevHelpRequestId */
    EvvDevHelpRequestId: EvvDevHelpRequestId;
    EvvDevHelpVisitStatusEntry: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      status: components["schemas"]["EvvDevHelpVisitStatus"];
      reasonCategory: components["schemas"]["EvvDevHelpReasonCategory"];
      flaggedAt: components["schemas"]["Instant"];
      handledAt: components["schemas"]["Instant"] | null;
      handledNote: null | string;
    };
    /**
     * @description Derived from `handled_at`, never stored.
     * @enum {string}
     */
    EvvDevHelpVisitStatus: "AWAITING_DEV" | "HANDLED";
    /** @enum {string} */
    EvvDevHelpReasonCategory:
      | "DATA_ISSUE"
      | "OLD_VISIT"
      | "OTHER"
      | "RESUBMIT_KEEPS_FAILING";
    /**
     * @description One request's visits in one office. A request that spans offices appears once per office,
     * so the dashboard can group by office without splitting a request's visits by hand.
     */
    EvvDevHelpDashboardEntry: {
      id: components["schemas"]["EvvDevHelpRequestId"];
      officeId: components["schemas"]["OfficeId"];
      officeName: string;
      reasonCategory: components["schemas"]["EvvDevHelpReasonCategory"];
      reasonText: string;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      /** @description Who asked for help, by name; falls back to the email, then to the user id. */
      createdByName: string;
      /** @description Only the visits that match the filter, so a half-handled request shows what is left. */
      visits: components["schemas"]["EvvDevHelpDashboardVisit"][];
    };
    EvvDevHelpDashboardVisit: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      visitStartTime: components["schemas"]["LocalDateTime"];
      aggregator: string;
      errorSnapshot: string[];
      status: components["schemas"]["EvvDevHelpVisitStatus"];
      handledAt: components["schemas"]["Instant"] | null;
      handledBy: components["schemas"]["UserId"] | null;
      /** @description The developer's name, or their email when they have no agency profile. */
      handledByName: null | string;
      handledNote: null | string;
    };
    EvvDevHelpOfficeOption: {
      id: components["schemas"]["OfficeId"];
      name: string;
    };
    /** @enum {string} */
    EvvDevHelpDashboardStatusFilter: "ALL" | "AWAITING_DEV" | "HANDLED";
    /**
     * @description One POST to Sandata that carried this visit.
     *
     * The batch tables are the only place a submission *history* exists: the
     * per-visit tables (`sandata_visit_instance_submission` and its errors
     * sibling) hold one row per visit and are overwritten by each result, so a
     * visit submitted three times has three of these and exactly one current
     * error.
     *
     * Everything below the payload is batch-level, not visit-level. Sandata's
     * per-visit verdict is not recorded against the attempt it belongs to, so a
     * batch that rejected 3 of 40 visits looks the same here for all 40.
     */
    SandataVisitSubmissionAttempt: {
      batchId: components["schemas"]["SandataVisitSubmissionBatchId"];
      /**
       * @description `null` when Sandata rejected the POST outright — no batch was created on
       * their side, so there is no uuid and no result to poll. Those attempts are
       * stored purely as a record of what was sent.
       */
      batchUuid: null | string;
      status: components["schemas"]["SandataVisitSubmissionBatchStatus"];
      /** @description How the batch was triggered: AUTO, BACKFILL or MANUAL. */
      source: string;
      /** @description The Sandata state the batch was submitted under (payload shape differs by state). */
      sandataState: string;
      submittedAt: components["schemas"]["Instant"];
      /** @description When the result worker last polled; null while still PENDING. */
      resultCheckedAt: components["schemas"]["Instant"] | null;
      /** @description Visits in the whole batch, not just this one. */
      visitCount: number;
      successCount: null | number;
      errorCount: null | number;
      /** @description Null for worker-initiated batches, which have no agency member behind them. */
      submittedByName: null | string;
      /**
       * @description The exact object POSTed for this visit, or `null` for rows written before
       * the payload column existed (V1646) — those genuinely have no record and
       * cannot be backfilled.
       *
       * Deliberately opaque: the NY and AZ (SAZ) payloads have different shapes,
       * and this is a verbatim copy of the wire body, not a modelled type.
       */
      sentPayload: unknown;
    };
    /** Format: SandataVisitSubmissionBatchId */
    SandataVisitSubmissionBatchId: SandataVisitSubmissionBatchId;
    /**
     * @description Status of the batch POST a visit travelled in.
     *
     * Mirrors the CHECK constraint on `sandata_visit_submission_batch.status`.
     * 'ERROR' covers two different things: a batch Sandata rejected outright (no
     * uuid, nothing to poll) and one whose results came back with rejections.
     * @enum {string}
     */
    SandataVisitSubmissionBatchStatus: "COMPLETED" | "ERROR" | "PENDING";
    HHAXResubmitVisitResult: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      status: components["schemas"]["HHAXResubmitVisitStatus"];
      error?: string;
    };
    /** @enum {string} */
    HHAXResubmitVisitStatus: "failed" | "queued" | "rate_limited";
    PatientContactPortalUser: {
      patientContactId: components["schemas"]["PatientContactId"];
      relationship: string;
      patientId: components["schemas"]["PatientId"];
      id: components["schemas"]["PortalUserId"];
      firstName: string;
      lastName: string;
      userId: components["schemas"]["UserId"];
      phoneNumber: string;
    };
    'Omit<PortalUser,"userId">': {
      id: components["schemas"]["PortalUserId"];
      firstName: string;
      lastName: string;
      phoneNumber: string;
    };
    'Omit<PortalUser,"id"|"userId">': {
      firstName: string;
      lastName: string;
      phoneNumber: string;
    };
    /** @enum {string} */
    PatientPortalRedirectUrl:
      | "/"
      | "/documents/auth_rep"
      | "/documents/clinical"
      | "/documents/nyia_request"
      | "/documents/private_pay"
      | "/documents/supplement_a"
      | "/documents/under_18"
      | "/documents/under_18/m11q"
      | "/documents/welcome_package"
      | "/intake-flow"
      | "/nyia"
      | "/profile"
      | "/welcome";
    PatientPortalDocument: {
      id: components["schemas"]["PatientPortalDocumentId"];
      type: components["schemas"]["PatientPortalDocumentType"];
      patientId: components["schemas"]["PatientId"];
      createdBy: components["schemas"]["PortalUserId"];
      createdAt: components["schemas"]["Instant"];
      url: string;
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["PortalUserId"] | null;
    };
    /** Format: PatientPortalDocumentId */
    PatientPortalDocumentId: PatientPortalDocumentId;
    /** @enum {string} */
    PatientPortalDocumentType:
      | "AUTH_REP"
      | "NYIA_REQUEST"
      | "PRIVATE_PAY"
      | "SUPPLEMENT"
      | "UNDER_18"
      | "WELCOME_PACKAGE";
    SupplementSpouseInfo: {
      spouseFirstName: string;
      spouseLastName: string;
      spouseDateOfBirth: string;
      spouseSSN: string;
      address: string;
    };
    SupplementBankAccount: {
      bankName: string;
      accountNumber: string;
      ownerName: string;
      accountBalance: string;
      accountClosed: null | boolean;
      closedDate: null | string;
      closingBalance: null | string;
    };
    SupplementRetirementAccount: {
      instName: string;
      accountNumber: string;
      ownerName: string;
      accountBalance: string;
      payOut: boolean;
      accountClosed: boolean;
      closedDate: null | string;
      closingBalance: null | string;
    };
    SupplementAnnuitie: {
      annuitieName: string;
      annuitieNumber: string;
      annuitieOwnerName: string;
      annuitieBalance: string;
      annuitiePayOut: boolean;
      purchaseDate: string;
      annuitieClosedDate: null | string;
      annuitieClosingBalance: null | string;
    };
    SupplementLifeInsurance: {
      insuranceCompany: string;
      policyNumber: string;
      policyOwnerName: string;
      policyCashValue: string;
      policyFaceValue: string;
      policyCancelled: null | boolean;
      policyCancelledDate: null | string;
      policyCashOutValue: null | string;
    };
    SupplementBurial: {
      burialBankInfo: string;
      burialName: string;
      burialValue: string;
    };
    SupplementTrustAccount: {
      trustName: string;
      trustGrantor: string;
      trustee: string;
      trustAssets: string;
      trustBeneficiary: string;
      trustIncome: string;
    };
    SupplementVehicle: {
      vehicleName: string;
      vehicleDetails: string;
      vehicleValue: string;
      vehicleOwed: string;
      vehicleUsed: null | boolean;
      vehicleSoldDate: null | string;
    };
    SupplementOtherResources: {
      resourceType: string;
      resourceOwner: string;
      resourceValue: string;
    };
    EditPatientContactRequestParams: {
      firstName?: string;
      middleName?: null | string;
      lastName?: string;
      relationship?: string;
      mobilePhoneNumber?: string;
      homePhoneNumber?: null | string;
      email?: null | string;
      address?: null | string;
      addressComponents?:
        | components["schemas"]["PatientContactAddressComponents"]
        | null;
      address2?: null | string;
      isEmergencyContact?: boolean;
      livesWithPatient?: boolean;
    };
    IntakeTrackStepPreview: {
      id: components["schemas"]["IntakeTrackStepId"];
      title: string;
      answers: string[];
      completed: boolean;
      isActive: boolean;
      future: boolean;
      externalFlowId: components["schemas"]["IntakeExternalFlowId"] | null;
    };
    /** Format: IntakeTrackStepId */
    IntakeTrackStepId: IntakeTrackStepId;
    PatientIntakeTrackStep: {
      isFuture: boolean;
      intakeCallSessionId: components["schemas"]["PatientIntakeCallId"] | null;
      id: components["schemas"]["IntakeTrackStepId"];
      trackId: components["schemas"]["IntakeTrackId"];
      title: string;
      script: string;
      outgoingCallScript: null | string;
      incomingCallScript: null | string;
      intakeStatus: components["schemas"]["IntakeStatusId"];
      isStop: boolean;
      isSavepoint: boolean;
      action:
        | (
            | "ADD_ALL_PLANS_TO_SCRIPT_TEXT"
            | "ADD_EXCEPTION_CODE_DESCRIPTION_IF_NECESSARY"
            | "ADD_NOT_ELIGIBLE_EXCEPTION_CODES_TO_SCRIPT"
            | "ADD_SUGGESTED_PLANS_TO_SCRIPT_TEXT"
            | "ADD_SUGGESTED_PLANS_TO_SELF_SERVE"
            | "ASSIGN_REGULAR_FLOW_PATIENT_TO_Q2_TEAM_MEMBER"
            | "AUTO_SELECT_PLAN_SELF_SERVE"
            | "CALCULATE_STATUS_FOR_NYIA_CALL"
            | "CALCULATE_TRACK"
            | "CALCULATE_WHICH_MMC"
            | "CHECK_ELIGIBILITY"
            | "CHECK_ELIGIBILITY_WITH_MEDICAID_ID"
            | "CHECK_ELIGIBILITY_WITH_PATIENT_DETAILS"
            | "CHECK_PORTAL_CALL_AVAILABILITY"
            | "COMPLETE_CHECKLIST_ITEM_NYIA_APPROVED"
            | "EMAIL_PATIENT_WITH_NYIA_APPOINTMENTS"
            | "FAX_AUTH_REP_FORM_TO_NYIA"
            | "HANDLE_EXCEPTION_CODES_EXT_FLOW"
            | "INSERT_PATIENT_INFORMATION_TO_DB"
            | "INSTRUCTIONS_FOR_PLAN_CHOICE_FAMILY_MEMBER_OR_PATIENT"
            | "NH_DISCHARGE_DATE_CHECK"
            | "PRESENT_MOST_AVAIABLE_Q2_AGENCY_MEMBER_ON_SCRIPT"
            | "REQUEST_PORTAL_CALL_MEDICAID_CHOICE_PATIENT"
            | "REQUEST_PORTAL_CALL_NYIA_FAMILY_MEMBER"
            | "REQUEST_PORTAL_CALL_NYIA_PATIENT"
            | "REQUEST_PORTAL_CALL_SWITCH_AGENCIES"
            | "RESCHEDULE_NET_CALL_IN_5_MINUTES"
            | "RETURN_PATIENT_TO_LAST_STEP_BEFORE_CURRENT_INTAKE_STATUS"
            | "RETURN_TO_MAIN_FLOW"
            | "SAVE_ADDITIONAL_CONTACT_DETAILS"
            | "SAVE_CONTACT_DETAILS"
            | "SAVE_PATIENT_PHYSICIAN"
            | "SAVE_SOCIAL_WORKER_CONTACT"
            | "SELF_SERVE_ADD_PATIENT_DETAILS"
            | "SELF_SERVE_ADD_PATIENT_PHONE_NUMBER"
            | "SELF_SERVE_ELIGIBILITY_CHECK"
            | "SELF_SERVE_MOVE_TO_REGULAR_FLOW"
            | "SELF_SERVE_TRANSFER_CALL_TO_Q2_AGENCY_MEMBER"
            | "SEND_LEAD_TO_FC"
            | "SEND_PARIVATE_PAY_AGGREEMENT"
            | "SEND_REFERRAL_FORM"
            | "SEND_REFERRAL_TO_ESSEN"
            | "SEND_SMS_LINK_AUTH_REP_FORM"
            | "SEND_SMS_LINK_NYIA_REQUEST_FORM"
            | "SEND_SMS_LINK_PROFILE"
            | "SEND_UNDER_18_FORM_TO_PATIENT_EMAIL"
            | "SEND_UNDER_18_FORM_TO_PATIENT_SMS"
            | "SEND_WP_FORM_TO_PATIENT_SMS"
            | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_MEDICAID_ELIGIBILITY_VERIFICATION"
            | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_SSN_ELIGIBILITY_VERIFICATION"
            | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_VERIFICATION"
            | "SS_VALIDATE_AND_CALCULATE_TRACK"
            | "SS_VALIDATE_AND_CALCULATE_TRACK_2"
          )
        | null;
      fields: components["schemas"]["IntakeTrackStepField"][];
      nextStepId: components["schemas"]["IntakeTrackStepId"] | null;
      showTitle?: boolean;
      showAssistantButton?: boolean;
      code?:
        | (
            | "AuthFormSignRedirect"
            | "AuthFormSignWaiting"
            | "CantMatchMedicaidInformation"
            | "CantTakeLessThan12Hours"
            | "DisableNextButtonFor45Seconds"
            | "EligibilityErrorStep"
            | "EligibleForHomeCare"
            | "ErrorStep"
            | "ExplainOurAgency"
            | "ExplainPrivatePay"
            | "FinalStep"
            | "InformationProcessing"
            | "MedicaidChoiceCallIsNotAvailable"
            | "NHExplainAboutCHHA"
            | "NHWaitForDischarge"
            | "NYIACallIsNotAvailable"
            | "NotEligible"
            | "OurServices"
            | "PaymentMethods"
            | "PhoneNumberExists"
            | "PrivatePayFinalStep"
            | "PrivatePayWillingTo12HoursAWeek"
            | "ScheduleAssessment"
            | "SelfNew->MAPAutoSelectedPlan"
            | "SelfNew->MAPConfirmNYIAScheduled"
            | "SelfNew->MAPExplainCallNYIA"
            | "SelfNew->MAPExplainNYIA"
            | "SelfNew->MAPExplainNextSteps"
            | "SelfNew->MAPExplainPlans"
            | "SelfNew->MLTCAutoSelectedPlan"
            | "SelfNew->MLTCCOnfirmNYIAScheduled"
            | "SelfNew->MLTCExplainCallNYIA"
            | "SelfNew->MLTCExplainNYIA"
            | "SelfNew->MLTCExplainNextSteps"
            | "SelfNew->MLTCExplainPlans"
            | "SelfNew->MMCAutoSelectedPlan"
            | "SelfNew->MMCConfirmNYIAScheduled"
            | "SelfNew->MMCExplainCallNYIA"
            | "SelfNew->MMCExplainMedicaidChoice"
            | "SelfNew->MMCExplainNYIA"
            | "SelfNew->MMCExplainNextSteps"
            | "SelfNew->MMCExplainPlans"
            | "SelfServeEligibilityCheckError"
            | "SelfServeEnterMedicaidAgain"
            | "SelfStayingOnMMCConfirmNYIAScheduled"
            | "SelfStayingOnMMCExplainCallNYIA"
            | "SelfStayingOnMMCExplainNYIA"
            | "SelfStayingOnMMCExplainNextSteps"
            | "SendToOnboarding"
            | "SwitchAgenciesCallIsNotAvailable"
            | "SwitchAgenciesCallIsNotAvailableAfterCallCheck"
            | "TransferCallToAgencyMember"
            | "WontService"
            | "ZipOutOfRange"
          )
        | null;
      externalFlowId: components["schemas"]["IntakeExternalFlowId"] | null;
    };
    IntakeTrackStepField:
      | components["schemas"]["IntakeTrackFieldNS.PhoneNumber"]
      | components["schemas"]["IntakeTrackFieldNS.DateTime"]
      | components["schemas"]["IntakeTrackFieldNS.Date"]
      | components["schemas"]["IntakeTrackFieldNS.String"]
      | components["schemas"]["IntakeTrackFieldNS.Number"]
      | components["schemas"]["IntakeTrackFieldNS.Options"]
      | components["schemas"]["IntakeTrackFieldNS.Multiselect"]
      | components["schemas"]["IntakeTrackFieldNS.AddressComponents"]
      | components["schemas"]["IntakeTrackFieldNS.PatientAvailability"]
      | components["schemas"]["IntakeTrackFieldNS.PatientStaffingPreferences"]
      | components["schemas"]["IntakeTrackFieldNS.PatientSpecialRequests"]
      | components["schemas"]["IntakeTrackFieldNS.DoublePrecision"]
      | components["schemas"]["IntakeTrackFieldNS.MedicaidId"]
      | components["schemas"]["IntakeTrackFieldNS.SSN"]
      | components["schemas"]["IntakeTrackFieldNS.Checkbox"];
    "IntakeTrackFieldNS.PhoneNumber": {
      /** @enum {string} */
      type: "phonenumber";
      value:
        | components["schemas"]["IntakeTrackFieldAnswerNS.PhoneNumber"]
        | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.PhoneNumber": {
      /** @enum {string} */
      type: "phonenumber";
      value: string;
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    /** Format: IntakeTrackStepFieldId */
    IntakeTrackStepFieldId: IntakeTrackStepFieldId;
    "IntakeTrackFieldNS.DateTime": {
      /** @enum {string} */
      type: "datetime";
      value: components["schemas"]["IntakeTrackFieldAnswerNS.DateTime"] | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.DateTime": {
      /** @enum {string} */
      type: "datetime";
      value: components["schemas"]["LocalDateTime"];
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.Date": {
      /** @enum {string} */
      type: "date";
      value: components["schemas"]["IntakeTrackFieldAnswerNS.Date"] | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.Date": {
      /** @enum {string} */
      type: "date";
      value: components["schemas"]["LocalDate"];
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.String": {
      /** @enum {string} */
      type: "string";
      value: components["schemas"]["IntakeTrackFieldAnswerNS.String"] | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.String": {
      /** @enum {string} */
      type: "string";
      value: string;
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.Number": {
      /** @enum {string} */
      type: "number";
      value: components["schemas"]["IntakeTrackFieldAnswerNS.Number"] | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.Number": {
      /** @enum {string} */
      type: "number";
      value: number;
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.Options": {
      /** @enum {string} */
      type: "options";
      options: components["schemas"]["IntakeTrackFieldValue"][];
      value: components["schemas"]["IntakeTrackFieldAnswerNS.Options"] | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    IntakeTrackFieldValue: {
      id: components["schemas"]["IntakeTrackStepFieldValueId"];
      fieldId: components["schemas"]["IntakeTrackStepFieldId"];
      value: string;
      nextIntakeTrackStepId: components["schemas"]["IntakeTrackStepId"] | null;
      orderInField: number;
      icon?: string;
    };
    /** Format: IntakeTrackStepFieldValueId */
    IntakeTrackStepFieldValueId: IntakeTrackStepFieldValueId;
    "IntakeTrackFieldAnswerNS.Options": {
      /** @enum {string} */
      type: "options";
      value: components["schemas"]["IntakeTrackStepFieldValueId"];
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.Multiselect": {
      /** @enum {string} */
      type: "multiselect";
      options: components["schemas"]["IntakeTrackFieldValue"][];
      value:
        | components["schemas"]["IntakeTrackFieldAnswerNS.Multiselect"]
        | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.Multiselect": {
      /** @enum {string} */
      type: "multiselect";
      value: components["schemas"]["IntakeTrackStepFieldValueId"][];
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.AddressComponents": {
      /** @enum {string} */
      type: "address_components";
      value:
        | components["schemas"]["IntakeTrackFieldAnswerNS.AddressComponents"]
        | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.AddressComponents": {
      /** @enum {string} */
      type: "address_components";
      value: components["schemas"]["AddressComponents"];
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.PatientAvailability": {
      /** @enum {string} */
      type: "patient_availability";
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldNS.PatientStaffingPreferences": {
      /** @enum {string} */
      type: "patient_staffing_preferences";
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldNS.PatientSpecialRequests": {
      /** @enum {string} */
      type: "patient_special_requests";
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldNS.DoublePrecision": {
      /** @enum {string} */
      type: "double_precision";
      value:
        | components["schemas"]["IntakeTrackFieldAnswerNS.DoublePrecision"]
        | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.DoublePrecision": {
      /** @enum {string} */
      type: "double_precision";
      value: number;
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.MedicaidId": {
      /** @enum {string} */
      type: "medicaid_id";
      value:
        | components["schemas"]["IntakeTrackFieldAnswerNS.MedicaidId"]
        | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.MedicaidId": {
      /** @enum {string} */
      type: "medicaid_id";
      value: string;
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.SSN": {
      /** @enum {string} */
      type: "ssn";
      value: components["schemas"]["IntakeTrackFieldAnswerNS.SSN"] | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.SSN": {
      /** @enum {string} */
      type: "ssn";
      value: string;
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    "IntakeTrackFieldNS.Checkbox": {
      /** @enum {string} */
      type: "checkbox";
      value: components["schemas"]["IntakeTrackFieldAnswerNS.Checkbox"] | null;
      id: components["schemas"]["IntakeTrackStepFieldId"];
      trackStepId: components["schemas"]["IntakeTrackStepId"];
      title: string;
      orderInStep: number;
      code:
        | (
            | "APPLY_TO_CHHA"
            | "ASSISTANCE_LEVEL"
            | "CALLER_FIRST_NAME"
            | "CALLER_LAST_NAME"
            | "CALLER_RELATIONSHIP_WITH_PATIENT"
            | "CASE_MANAGER_NAME"
            | "CASE_MANAGER_PHONE_NUMBER"
            | "CASE_MANAGER_ROUTE"
            | "CONFIRM_PHONE_NUMBER"
            | "CONTACT_FIRST_NAME"
            | "CONTACT_LAST_NAME"
            | "CONTACT_PHONE_NUMBER"
            | "CONTACT_RELATIONSHIP"
            | "DISCHARGE_DATE"
            | "ESSEN_ASSESSMENT_DATE"
            | "FAMILY_MEMBER_EMAIL"
            | "GOT_SERVICES_BEFORE"
            | "IS_PATIENT_QUESTION"
            | "MEMBER_PHONE_NUMBER_REGISTERED"
            | "NEXT_CALL_DATE"
            | "NEXT_CALL_DATE_APPROXIMATE"
            | "NURSING_HOME_NAME"
            | "NYIA_1_CLINICIAL_NAME"
            | "NYIA_1_DATE_AND_TIME"
            | "NYIA_1_LCOATION"
            | "NYIA_2_CLINICIAL_NAME"
            | "NYIA_2_DATE_AND_TIME"
            | "NYIA_2_LCOATION"
            | "OUR_SERVICES"
            | "PATIENT_ADDRESS_1"
            | "PATIENT_ADDRESS_2"
            | "PATIENT_DOB"
            | "PATIENT_EMAIL"
            | "PATIENT_FIRST_NAME"
            | "PATIENT_GENDER"
            | "PATIENT_HEAR_ABOUT_US_OPTIONS"
            | "PATIENT_HEAR_ABOUT_US_TEXT"
            | "PATIENT_INTAKE_PLAN"
            | "PATIENT_INTAKE_PLAN_START_DATE"
            | "PATIENT_LAST_NAME"
            | "PATIENT_MEDICAID_ID"
            | "PATIENT_PHONE_NUMBER"
            | "PATIENT_SSN"
            | "PHYSICIAN_ADDRESS"
            | "PHYSICIAN_FAX_NUMBER"
            | "PHYSICIAN_FIRST_NAME"
            | "PHYSICIAN_LAST_NAME"
            | "PHYSICIAN_MOBILE_NUMBER"
            | "PHYSICIAN_NPI"
            | "SELF_SERVE_CONTACT_IS_MAIN_CONTACT"
            | "SELF_SERVE_ELIGIBILITY_CHECK_SAME_PERSON"
            | "SELF_SERVE_PAYMENT_METHOD"
            | "SELF_SERVE_ZIP_CODE"
            | "SOCIAL_WORKER_EXTENSION"
            | "SOCIAL_WORKER_FIRST_NAME"
            | "SOCIAL_WORKER_LAST_NAME"
            | "SOCIAL_WORKER_PHONE_NUMBER"
            | "TEMP_PATIENT_NUMBER"
            | "UAS_DATE_AND_TIME"
            | "UAS_HOURS_AMOUNT"
          )
        | null;
      isOptional: boolean;
    };
    "IntakeTrackFieldAnswerNS.Checkbox": {
      /** @enum {string} */
      type: "checkbox";
      value: boolean;
      id: components["schemas"]["IntakeTrackStepFieldId"];
    };
    IntakeTrackStepFieldWithNewAnswer:
      | components["schemas"]["IntakeTrackFieldAnswerNS.PhoneNumber"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.DateTime"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.Date"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.String"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.Number"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.DoublePrecision"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.Options"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.Multiselect"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.AddressComponents"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.MedicaidId"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.SSN"]
      | components["schemas"]["IntakeTrackFieldAnswerNS.Checkbox"];
    IntakeExternalFlow: {
      id: components["schemas"]["IntakeExternalFlowId"];
      title: string;
      description: string;
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      updatedAt: components["schemas"]["Instant"] | null;
      removedAt: components["schemas"]["Instant"] | null;
    };
    IntakeTrackForFullFlow: {
      id: components["schemas"]["IntakeTrackId"];
      label: string;
    };
    IntakeStatusForFullFlow: {
      id: components["schemas"]["IntakeStatusId"];
      label: string;
    };
    IntakeTrackStepForFullFlow: {
      id: components["schemas"]["IntakeTrackStepId"];
      track: {
        id: components["schemas"]["IntakeTrackId"];
        label: string;
      };
      status: {
        id: components["schemas"]["IntakeStatusId"];
        label: string;
      };
      isStop: boolean;
      action:
        | (
            | "ADD_ALL_PLANS_TO_SCRIPT_TEXT"
            | "ADD_EXCEPTION_CODE_DESCRIPTION_IF_NECESSARY"
            | "ADD_NOT_ELIGIBLE_EXCEPTION_CODES_TO_SCRIPT"
            | "ADD_SUGGESTED_PLANS_TO_SCRIPT_TEXT"
            | "ADD_SUGGESTED_PLANS_TO_SELF_SERVE"
            | "ASSIGN_REGULAR_FLOW_PATIENT_TO_Q2_TEAM_MEMBER"
            | "AUTO_SELECT_PLAN_SELF_SERVE"
            | "CALCULATE_STATUS_FOR_NYIA_CALL"
            | "CALCULATE_TRACK"
            | "CALCULATE_WHICH_MMC"
            | "CHECK_ELIGIBILITY"
            | "CHECK_ELIGIBILITY_WITH_MEDICAID_ID"
            | "CHECK_ELIGIBILITY_WITH_PATIENT_DETAILS"
            | "CHECK_PORTAL_CALL_AVAILABILITY"
            | "COMPLETE_CHECKLIST_ITEM_NYIA_APPROVED"
            | "EMAIL_PATIENT_WITH_NYIA_APPOINTMENTS"
            | "FAX_AUTH_REP_FORM_TO_NYIA"
            | "HANDLE_EXCEPTION_CODES_EXT_FLOW"
            | "INSERT_PATIENT_INFORMATION_TO_DB"
            | "INSTRUCTIONS_FOR_PLAN_CHOICE_FAMILY_MEMBER_OR_PATIENT"
            | "NH_DISCHARGE_DATE_CHECK"
            | "PRESENT_MOST_AVAIABLE_Q2_AGENCY_MEMBER_ON_SCRIPT"
            | "REQUEST_PORTAL_CALL_MEDICAID_CHOICE_PATIENT"
            | "REQUEST_PORTAL_CALL_NYIA_FAMILY_MEMBER"
            | "REQUEST_PORTAL_CALL_NYIA_PATIENT"
            | "REQUEST_PORTAL_CALL_SWITCH_AGENCIES"
            | "RESCHEDULE_NET_CALL_IN_5_MINUTES"
            | "RETURN_PATIENT_TO_LAST_STEP_BEFORE_CURRENT_INTAKE_STATUS"
            | "RETURN_TO_MAIN_FLOW"
            | "SAVE_ADDITIONAL_CONTACT_DETAILS"
            | "SAVE_CONTACT_DETAILS"
            | "SAVE_PATIENT_PHYSICIAN"
            | "SAVE_SOCIAL_WORKER_CONTACT"
            | "SELF_SERVE_ADD_PATIENT_DETAILS"
            | "SELF_SERVE_ADD_PATIENT_PHONE_NUMBER"
            | "SELF_SERVE_ELIGIBILITY_CHECK"
            | "SELF_SERVE_MOVE_TO_REGULAR_FLOW"
            | "SELF_SERVE_TRANSFER_CALL_TO_Q2_AGENCY_MEMBER"
            | "SEND_LEAD_TO_FC"
            | "SEND_PARIVATE_PAY_AGGREEMENT"
            | "SEND_REFERRAL_FORM"
            | "SEND_REFERRAL_TO_ESSEN"
            | "SEND_SMS_LINK_AUTH_REP_FORM"
            | "SEND_SMS_LINK_NYIA_REQUEST_FORM"
            | "SEND_SMS_LINK_PROFILE"
            | "SEND_UNDER_18_FORM_TO_PATIENT_EMAIL"
            | "SEND_UNDER_18_FORM_TO_PATIENT_SMS"
            | "SEND_WP_FORM_TO_PATIENT_SMS"
            | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_MEDICAID_ELIGIBILITY_VERIFICATION"
            | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_SSN_ELIGIBILITY_VERIFICATION"
            | "SS_ADD_PATIENT_DETAILS_TO_SCRIPT_FOR_VERIFICATION"
            | "SS_VALIDATE_AND_CALCULATE_TRACK"
            | "SS_VALIDATE_AND_CALCULATE_TRACK_2"
          )
        | null;
      title: string;
      script: string;
      fields: components["schemas"]["IntakeTrackStepField"][];
      nextStepId: components["schemas"]["IntakeTrackStepId"] | null;
      isMainInStatusAndTrack: boolean;
      flowType: ("Regular" | "Self Serve") | null;
      code:
        | (
            | "AuthFormSignRedirect"
            | "AuthFormSignWaiting"
            | "CantMatchMedicaidInformation"
            | "CantTakeLessThan12Hours"
            | "DisableNextButtonFor45Seconds"
            | "EligibilityErrorStep"
            | "EligibleForHomeCare"
            | "ErrorStep"
            | "ExplainOurAgency"
            | "ExplainPrivatePay"
            | "FinalStep"
            | "InformationProcessing"
            | "MedicaidChoiceCallIsNotAvailable"
            | "NHExplainAboutCHHA"
            | "NHWaitForDischarge"
            | "NYIACallIsNotAvailable"
            | "NotEligible"
            | "OurServices"
            | "PaymentMethods"
            | "PhoneNumberExists"
            | "PrivatePayFinalStep"
            | "PrivatePayWillingTo12HoursAWeek"
            | "ScheduleAssessment"
            | "SelfNew->MAPAutoSelectedPlan"
            | "SelfNew->MAPConfirmNYIAScheduled"
            | "SelfNew->MAPExplainCallNYIA"
            | "SelfNew->MAPExplainNYIA"
            | "SelfNew->MAPExplainNextSteps"
            | "SelfNew->MAPExplainPlans"
            | "SelfNew->MLTCAutoSelectedPlan"
            | "SelfNew->MLTCCOnfirmNYIAScheduled"
            | "SelfNew->MLTCExplainCallNYIA"
            | "SelfNew->MLTCExplainNYIA"
            | "SelfNew->MLTCExplainNextSteps"
            | "SelfNew->MLTCExplainPlans"
            | "SelfNew->MMCAutoSelectedPlan"
            | "SelfNew->MMCConfirmNYIAScheduled"
            | "SelfNew->MMCExplainCallNYIA"
            | "SelfNew->MMCExplainMedicaidChoice"
            | "SelfNew->MMCExplainNYIA"
            | "SelfNew->MMCExplainNextSteps"
            | "SelfNew->MMCExplainPlans"
            | "SelfServeEligibilityCheckError"
            | "SelfServeEnterMedicaidAgain"
            | "SelfStayingOnMMCConfirmNYIAScheduled"
            | "SelfStayingOnMMCExplainCallNYIA"
            | "SelfStayingOnMMCExplainNYIA"
            | "SelfStayingOnMMCExplainNextSteps"
            | "SendToOnboarding"
            | "SwitchAgenciesCallIsNotAvailable"
            | "SwitchAgenciesCallIsNotAvailableAfterCallCheck"
            | "TransferCallToAgencyMember"
            | "WontService"
            | "ZipOutOfRange"
          )
        | null;
      showAssistantButton: boolean;
      showTitle: boolean;
      externalFlowId: components["schemas"]["IntakeExternalFlowId"] | null;
      removedAt: components["schemas"]["Instant"] | null;
      graphPoint: components["schemas"]["GraphPoint"] | null;
    };
    GraphPoint: {
      x: number;
      y: number;
    };
    /** Format: IntakeTrackNoteId */
    IntakeTrackNoteId: IntakeTrackNoteId;
    IntakeTrackNote: {
      id: components["schemas"]["IntakeTrackNoteId"];
      trackId: components["schemas"]["IntakeTrackId"];
      graphPoint: components["schemas"]["GraphPoint"];
      content: string;
    };
    AgencyPhonebookContact: {
      id: components["schemas"]["AgencyPhonebookContactId"];
      phoneNumber: string;
      name: string;
      destinationNumberType: components["schemas"]["AgencyPhonebookContactDestinationType"];
      inboundCommCenterLabelId: components["schemas"]["CommCenterLabelId"];
      outboundCommCenterLabelId: components["schemas"]["CommCenterLabelId"];
      payerId: components["schemas"]["PayerId"] | null;
      type: components["schemas"]["PhonebookContactType"];
    };
    CreateEmailMessageAttachmentParams: {
      s3Url: string;
      name: string;
      type: string;
    };
    CreateEmailThreadRequestEntity:
      | components["schemas"]["CreateEmailThreadRequestPatientEntity"]
      | components["schemas"]["CreateEmailThreadRequestCaregiverEntity"]
      | components["schemas"]["CreateEmailThreadRequestPhonebookContactEntity"];
    CreateEmailThreadRequestPatientEntity: {
      id: components["schemas"]["PatientId"];
      /** @enum {string} */
      type: "Patient";
    };
    CreateEmailThreadRequestCaregiverEntity: {
      id: components["schemas"]["CaregiverId"];
      /** @enum {string} */
      type: "Caregiver";
    };
    CreateEmailThreadRequestPhonebookContactEntity: {
      id: components["schemas"]["AgencyPhonebookContactId"];
      /** @enum {string} */
      type: "PhonebookContact";
    };
    SearchEmailEntity: {
      email: string;
      name: string;
      /** @enum {string} */
      type:
        | "Caregiver"
        | "NotIdentifiedEmailEntity"
        | "Patient"
        | "PatientContact";
    };
    MedflytEmailAddress: {
      id: components["schemas"]["MedflytEmailAddressId"];
      email: string;
      teamId: components["schemas"]["CommCenterTeamId"];
      teamName: string;
    };
    /** Format: MedflytEmailAddressId */
    MedflytEmailAddressId: MedflytEmailAddressId;
    CaregiverSuppliesShipmentRow: {
      id: components["schemas"]["CaregiverSuppliesShipmentId"];
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverFullName: string;
      caregiverDisplayId: null | number;
      caregiverPhotoUrl: null | string;
      shipmentType: components["schemas"]["CaregiverSuppliesShipmentType"];
      arrivalDate: components["schemas"]["Instant"] | null;
      shipmentDate: components["schemas"]["Instant"] | null;
      caregiverConfirmation: boolean;
      glovesSize: ("L" | "M" | "S" | "XL") | null;
      scrubsSize: ("L" | "M" | "S" | "XL" | "XXL") | null;
      caregiverStatus: components["schemas"]["CaregiverStatus"];
      caregiverHireDate: components["schemas"]["LocalDate"] | null;
    };
    /** Format: CaregiverSuppliesShipmentId */
    CaregiverSuppliesShipmentId: CaregiverSuppliesShipmentId;
    /** @enum {string} */
    CaregiverSuppliesShipmentType: "BOTH" | "GLOVES" | "SCRUBS";
    'Omit<CaregiverSuppliesShipmentRow,"caregiverId"|"caregiverFullName"|"caregiverStatus"|"caregiverHireDate"|"caregiverDisplayId"|"caregiverPhotoUrl">': {
      id: components["schemas"]["CaregiverSuppliesShipmentId"];
      shipmentType: components["schemas"]["CaregiverSuppliesShipmentType"];
      arrivalDate: components["schemas"]["Instant"] | null;
      shipmentDate: components["schemas"]["Instant"] | null;
      caregiverConfirmation: boolean;
      glovesSize: ("L" | "M" | "S" | "XL") | null;
      scrubsSize: ("L" | "M" | "S" | "XL" | "XXL") | null;
    };
    "Partial<CaregiverSuppliesShipmentRow>": {
      /** Format: CaregiverSuppliesShipmentId */
      id?: CaregiverSuppliesShipmentId;
      /** Format: CaregiverId */
      caregiverId?: CaregiverId;
      caregiverFullName?: string;
      caregiverDisplayId?: null | number;
      caregiverPhotoUrl?: null | string;
      /** @enum {string} */
      shipmentType?: "BOTH" | "GLOVES" | "SCRUBS";
      arrivalDate?: components["schemas"]["Instant"] | null;
      shipmentDate?: components["schemas"]["Instant"] | null;
      caregiverConfirmation?: boolean;
      glovesSize?: ("L" | "M" | "S" | "XL") | null;
      scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
      /**
       * @description The status of a Caregiver within a specific Agency
       * @enum {string}
       */
      caregiverStatus?:
        | "ACTIVE"
        | "JOIN_REQUEST"
        | "ON_HOLD"
        | "ON_LEAVE"
        | "PENDING"
        | "QUIT"
        | "REJECTED"
        | "SUSPENDED"
        | "TERMINATED";
      caregiverHireDate?: components["schemas"]["LocalDate"] | null;
    };
    'Omit<CaregiverSuppliesShipmentRow,"id"|"caregiverFullName"|"caregiverStatus"|"caregiverHireDate"|"caregiverDisplayId"|"caregiverPhotoUrl"|"glovesSize"|"scrubsSize">': {
      caregiverId: components["schemas"]["CaregiverId"];
      shipmentType: components["schemas"]["CaregiverSuppliesShipmentType"];
      arrivalDate: components["schemas"]["Instant"] | null;
      shipmentDate: components["schemas"]["Instant"] | null;
      caregiverConfirmation: boolean;
    };
    IntakeChecklistItem: {
      id: components["schemas"]["IntakeChecklistItemId"];
      code: components["schemas"]["IntakeChecklistItemCode"];
      name: string;
      isCompleted: boolean;
      createdAt: components["schemas"]["Instant"] | null;
      blockers: components["schemas"]["IntakeChecklistItemBlocker"][];
      hint?: string;
    };
    IntakeChecklistItemCode: string;
    IntakeChecklistItemBlocker:
      | components["schemas"]["IntakeChecklistItemBlockerTypes.DefaultItemBlocker"]
      | components["schemas"]["IntakeChecklistItemBlockerTypes.CustomItemBlocker"];
    "IntakeChecklistItemBlockerTypes.DefaultItemBlocker": {
      id: components["schemas"]["IntakeChecklistItemId"];
      /** @enum {boolean} */
      isCustomBlocker: false;
      name: string;
      isCompleted: boolean;
    };
    "IntakeChecklistItemBlockerTypes.CustomItemBlocker": {
      id: null;
      /** @enum {boolean} */
      isCustomBlocker: true;
      name: string;
      isCompleted: boolean;
    };
    "UpdatePatientIntakeChecklistItem.Manual.ByFieldEdit": {
      /** @enum {string} */
      createdByType: "field_edit";
      /** Format: NoteId */
      noteId?: NoteId;
      isCompleted: boolean;
    };
    'Omit<UpdatePatientIntakeChecklistItem.Manual.ByAgencyMember,"agencyMemberId">': {
      /** @enum {string} */
      createdByType: "agency_member";
      noteId: components["schemas"]["NoteId"];
      isCompleted: boolean;
    };
    UpdatePatientIntakeChecklistItemRequest:
      | components["schemas"]["UpdatePatientIntakeChecklistItem.Manual.ByFieldEdit"]
      | components["schemas"]['Omit<UpdatePatientIntakeChecklistItem.Manual.ByAgencyMember,"agencyMemberId">'];
    PatientCaregiverRelationship: {
      id: components["schemas"]["PatientCaregiverRelationshipId"];
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"];
      patientId: components["schemas"]["PatientId"];
      patientDisplayName: null | string;
      patientDisplayId: null | number;
      patientStatus: null | string;
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverDisplayName: null | string;
      caregiverDisplayId: null | number;
      caregiverStatus: null | string;
      caregiverPhotoUrl: null | string;
      relationshipTypeId: components["schemas"]["PatientCaregiverRelationshipTypeId"];
      relationshipName: string;
    };
    /** Format: PatientCaregiverRelationshipId */
    PatientCaregiverRelationshipId: PatientCaregiverRelationshipId;
    /** Format: PatientCaregiverRelationshipTypeId */
    PatientCaregiverRelationshipTypeId: PatientCaregiverRelationshipTypeId;
    /** @enum {string} */
    VisitAssignmentReason:
      | "CannotAttendFirstVisit"
      | "CannotAttendShift"
      | "CannotAttendShiftChat"
      | "CannotAttendShiftLateClockInRobocall"
      | "CannotAttendShiftRN"
      | "ChatRN"
      | "CoordinatorBroadcastedVisit"
      | "CoordinatorRemovedAllFutureVisits"
      | "CoordinatorRemovedVisits"
      | "Default"
      | "MissingClockIn"
      | "MissingPhysicianInfo"
      | "NoAnswerFirstVisitVerifyChat"
      | "NoReplacementCancelledMoreThanOneShift"
      | "NoReplacementFirstMonthOfServices"
      | "NursingVisitScheduling"
      | "PatientCalled"
      | "PatientMissedCall"
      | "PatientMovedToSMS"
      | "PatientSentSMS"
      | "RNNote"
      | "UnassignedVisit"
      | "WantToStopWorkingWithPatientChat";
    /** @enum {string} */
    VisitAssignmentStatus: "Resolved" | "Unresolved";
    CaregiverRankProgression: {
      id: components["schemas"]["CareMomentsRankId"];
      points: number;
      nextRankPercents: number;
    };
    /** Format: CareMomentsRankId */
    CareMomentsRankId: CareMomentsRankId;
    PatientWebsiteEligibilityCheckResults: {
      medicaidId: string;
      patientName: string;
      exceptionCodes: {
        title: string;
        description: string;
      }[];
      isMedicaidEligible: boolean;
      isMedicareEligible: boolean;
      currentPlanName: null | string;
      isCurrentPlanInNetwork: boolean;
    };
    OfficeCaregiverHoursRestriction: {
      id: components["schemas"]["OfficeCaregiverHoursRestrictionId"];
      officeId: components["schemas"]["OfficeId"];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
      removedAt: components["schemas"]["Instant"] | null;
      removedBy: components["schemas"]["UserId"] | null;
      startTime: components["schemas"]["LocalDate"];
      endTime: components["schemas"]["LocalDate"];
      hoursPerWeek: number;
    };
    /** Format: OfficeCaregiverHoursRestrictionId */
    OfficeCaregiverHoursRestrictionId: OfficeCaregiverHoursRestrictionId;
    OfficeCaregiverHoursOverride: {
      id: components["schemas"]["OfficeCaregiverHoursRestrictionOverrideId"];
      officeId: components["schemas"]["OfficeId"];
      officeName: string;
      caregiverId: components["schemas"]["CaregiverId"];
      startTime: components["schemas"]["LocalDate"];
      endTime: components["schemas"]["LocalDate"];
      hoursPerWeek: number;
    };
    /** Format: OfficeCaregiverHoursRestrictionOverrideId */
    OfficeCaregiverHoursRestrictionOverrideId: OfficeCaregiverHoursRestrictionOverrideId;
    "Validation.Success": {
      /** @enum {string} */
      type: "Success";
    };
    "Validation.Conflict": {
      /** @enum {string} */
      type: "Conflict";
      conflicts: {
        caregiverId: components["schemas"]["CaregiverId"];
        exceededHours: number;
      }[];
    };
    CertificationBroadcastSetting: {
      id: components["schemas"]["CertificationBroadcastSettingsId"];
      agencyId: components["schemas"]["AgencyId"];
      officeId: components["schemas"]["OfficeId"];
      primaryCertification: components["schemas"]["CaregiverCertification"];
      permittedCertifications: components["schemas"]["CaregiverCertification"][];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["UserId"] | null;
    };
    /** Format: CertificationBroadcastSettingsId */
    CertificationBroadcastSettingsId: CertificationBroadcastSettingsId;
    AdministrativePaymentInvoicingData: {
      office: {
        id: components["schemas"]["OfficeId"];
        name: string;
      };
      patient: {
        id: components["schemas"]["PatientId"];
        displayId: null | number;
        name: string;
      };
      contract: {
        id: components["schemas"]["ContractTypeId"];
        name: string;
      };
      month: {
        year: number;
        month: number;
      };
      hours: number;
      rateCents: number;
      hoursBilled: null | number;
      rateCentsBilled: null | number;
      hoursFromTierEdge: null | number;
      authorizationHoursText: null | string;
      authorizationHoursMonthlyEstimate: null | number;
      tierChangeBasedOnAuthHoursMonthlyEstimate: boolean;
    };
    AdministrativePaymentInvoiceData: {
      id: components["schemas"]["InvoiceAdministrativePaymentId"];
      office: {
        id: components["schemas"]["OfficeId"];
        name: string;
      };
      patient: {
        id: components["schemas"]["PatientId"];
        displayId: null | number;
        name: string;
      };
      contract: {
        id: components["schemas"]["ContractTypeId"];
        name: string;
      };
      month: {
        year: number;
        month: number;
      };
      hoursBilled: number;
      amountBilled: number;
      paidAmount: null | number;
      payStatus: string;
      exportStatus: string;
    };
    ExportedFile: {
      exportBatchId: components["schemas"]["ExportBatchId"];
      name: string;
      url: string;
    };
    AdministrativePaymentRate: {
      id: components["schemas"]["AdministrativePaymentRateId"];
      contractTypeId: components["schemas"]["ContractTypeId"];
      startDate: components["schemas"]["LocalDate"];
      endDate: components["schemas"]["LocalDate"] | null;
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
      rates: components["schemas"]["AdministrativePaymentRateTier"][];
    };
    /** Format: AdministrativePaymentRateId */
    AdministrativePaymentRateId: AdministrativePaymentRateId;
    AdministrativePaymentRateTier: {
      id: components["schemas"]["AdministrativePaymentRateTierId"];
      tierHoursMinimum: number;
      tierHoursMaximum: null | number;
      rateCents: number;
      revenueCode: null | string;
      procedureCode: null | string;
      rateCode: null | string;
      serviceUnits: number;
      createdBy: components["schemas"]["AgencyMemberId"];
      createdAt: components["schemas"]["Instant"];
    };
    /** Format: AdministrativePaymentRateTierId */
    AdministrativePaymentRateTierId: AdministrativePaymentRateTierId;
    AdministrativePaymentRateTiersCreateParams: {
      tierHoursMinimum: number;
      tierHoursMaximum: null | number;
      rateCents: number;
      revenueCode: null | string;
      procedureCode: null | string;
      rateCode: null | string;
      serviceUnits: number;
    };
    UpdateExistingInvoiceRatesData: {
      startOfDate: components["schemas"]["LocalDate"];
      endOfDate: components["schemas"]["LocalDate"];
      updateByInvoiceDate: boolean;
    };
    /** Format: ShortUrlToken */
    ShortUrlToken: string;
    FBABenefitsTransaction: {
      id: components["schemas"]["CaregiverFBABenefitsTransactionId"];
      amount: number;
      type: components["schemas"]["FBABenefitsTransactionType"];
      transactionDate: components["schemas"]["LocalDate"];
      settlementDate: components["schemas"]["LocalDate"];
      status: components["schemas"]["FBABenefitsTransactionStatus"];
    };
    /** Format: CaregiverFBABenefitsTransactionId */
    CaregiverFBABenefitsTransactionId: CaregiverFBABenefitsTransactionId;
    /** @enum {string} */
    FBABenefitsTransactionType: "DEPOSITED" | "SPENT";
    /** @enum {string} */
    FBABenefitsTransactionStatus: "APPROVED" | "DENIED" | "NEW";
    ReferralPortalPatientDashboardInfo: {
      id: components["schemas"]["PatientId"];
      firstName: string;
      lastName: string;
      middleName: null | string;
      intakeStatus: components["schemas"]["IntakeStatus"];
      medicaidStatus: components["schemas"]["ReferralPortalPatientMedicaidStatus"];
    };
    /** @enum {string} */
    ReferralPortalPatientMedicaidStatus:
      | "Eligible"
      | "EligibleWithExceptionCodes"
      | "NotEligible"
      | "Unknown";
    ReferralPortalPatientProfile: {
      id: components["schemas"]["PatientId"];
      firstName: string;
      email?: null | string;
      lastName: string;
      middleName: null | string;
      dateOfBirth: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      intakeStatus: components["schemas"]["IntakeStatus"];
      referralSource:
        | (
            | "A Place for Mom"
            | "FC"
            | "Facility lead"
            | "Insurance plan"
            | "Marketer - Asher"
            | "Marketer - Omar"
            | "Marketer - Rodel"
            | "Online lead - Bing"
            | "Online lead - Facebook"
            | "Online lead - General"
            | "Online lead - Google"
          )
        | null;
      address: null | string;
      address2: null | string;
      addressComponents:
        | components["schemas"]["PatientAddressComponents"]
        | null;
      addressInstructions: null | string;
      createdAt: components["schemas"]["Instant"];
      updatedAt: components["schemas"]["Instant"] | null;
      phoneNumbers: components["schemas"]["IntakePatientPhoneNumber"][];
      gender: ("F" | "M") | null;
      contacts: components["schemas"]["PatientContact"][] | null;
      plans: components["schemas"]["PatientIntakePlan"][] | null;
      NYIA1AppoitmentDate: components["schemas"]["Instant"] | null;
      NYIA2AppoitmentDate: components["schemas"]["Instant"] | null;
      NYIA1Completed: boolean;
      NYIA2Completed: boolean;
      NYIA1Location: ("Face-to-face" | "via Zoom") | null;
      NYIA1Clinician: null | string;
      NYIA2Location: ("Face-to-face" | "via Zoom") | null;
      NYIA2Clinician: null | string;
      NYIAResults: ("Approved" | "Denied") | null;
      UASAssessmentDate: components["schemas"]["Instant"] | null;
      UASCompleted: boolean;
      UASHoursAmount: null | number;
      notes: components["schemas"]["EntityNote"][];
      track: components["schemas"]["PatientIntakeTrack"];
      exceptionCode: components["schemas"]["MedicaidExceptionCode"][] | null;
      planEnrollmentStatus:
        | (
            | "No plan"
            | "Pending Enrollment agreement"
            | "Pending UAS"
            | "Pending first contact"
            | "Plan chosen - in network"
            | "Plan chosen - not in network"
          )
        | null;
      medicareId: null | string;
      medicaidId: null | string;
      medicaidStatus: components["schemas"]["ReferralPortalPatientMedicaidStatus"];
      medicareStatus: ("Eligible" | "Not Eligible") | null;
      planStartDate: components["schemas"]["LocalDate"] | null;
      nextCallDate: components["schemas"]["LocalDateTime"] | null;
      nextCallDetails:
        | components["schemas"]["IntakeCallWithDisplayData"]
        | null;
      lastCallDate: components["schemas"]["LocalDateTime"] | null;
      patientStatus: components["schemas"]["PatientStatus"];
      intakeFlowType: components["schemas"]["IntakeFlowType"];
      isMainContactPatient: boolean;
      planSelectionCompleted: boolean;
      dischargeDate: components["schemas"]["LocalDate"] | null;
      caseManagerName: null | string;
      caseManagerPhoneNumber: null | string;
      caseManagerRouting: null | string;
      currentFlowDisplay: components["schemas"]["IntakeExternalFlowId"] | null;
      essenAssessmentDate: components["schemas"]["Instant"] | null;
      essenAssessmentCompleted: boolean;
      referralDate: components["schemas"]["LocalDate"] | null;
      mainPhoneNumber: null | string;
      wasSelfServe: boolean;
      ssn?: null | string;
      applyToChha: boolean;
      assignedAgencyMember:
        | components["schemas"]["PatientIntakeAssignedAgencyMember"]
        | null;
      referrer: components["schemas"]["ReferralUser"];
      referredAt: components["schemas"]["Instant"];
    };
    ReferralPatientPortalDocument: {
      id: components["schemas"]["PatientPortalDocumentId"];
      type: components["schemas"]["PatientPortalDocumentType"];
      name: string;
      patientId: components["schemas"]["PatientId"];
      createdBy: components["schemas"]["PortalUserId"];
      createdAt: components["schemas"]["Instant"];
      url: string;
      updatedAt: components["schemas"]["Instant"] | null;
      updatedBy: components["schemas"]["PortalUserId"] | null;
    };
    /** Format: PatientIssueId */
    PatientIssueId: PatientIssueId;
    /** @enum {string} */
    PatientIssueType: "Complaint" | "Incident";
    /** @enum {string} */
    PatientIssueStatus: "In_Progress" | "Not_Relevant" | "Open" | "Resolved";
    /** Format: MedflytCHRCDataId */
    MedflytCHRCDataId: MedflytCHRCDataId;
    /** Format: MedflytHCRDataId */
    MedflytHCRDataId: MedflytHCRDataId;
    MobileOfflineBundleDocument: {
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      documentTypeId: components["schemas"]["PatientDocumentTypeId"];
      document: components["schemas"]["PatientTaskDocumentObjectPartial"];
    };
    MobileOfflineBundlePatient: {
      patientId: components["schemas"]["PatientId"];
      data: components["schemas"]["PatientDetailDataRes"];
    };
    PatientDetailDataRes: {
      data: components["schemas"]["PatientDetailData"][];
    };
    PatientDetailData: {
      title: string;
      icon?: string;
      data?: unknown;
      sections?: components["schemas"]["PatientDetailData"][];
    };
    MobileOfflineBundlePatientMedications: {
      patientId: components["schemas"]["PatientId"];
      data: components["schemas"]["NurseGetsPatientMedicationsResponse"];
    };
    NurseGetsPatientMedicationsResponse: {
      medications: {
        id: components["schemas"]["PatientMedicationId"];
        name: string;
        dosage: string;
        frequency: null | string;
        administrationNotes: null | string;
        diagnosisCodes: components["schemas"]["PatientMedicationDiagnosisCode"][];
      }[];
      draftMedications: components["schemas"]["DraftMedication"][];
      notTakingMedications: boolean;
    };
    MobileOfflineBundleDiagnosisCodes: {
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      data: components["schemas"]["PatientContractDiagnosisCodes"];
    };
    PatientContractDiagnosisCodes: {
      patientContractDiagnosisCodes: components["schemas"]["PatientContractDiagnosisCode"][];
      /** Format: PatientContractDiagnosisCodeId */
      createdId?: PatientContractDiagnosisCodeId;
    };
    MobileOfflineBundleMedicalDiagnosisCodes: {
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      data: components["schemas"]["PatientMedicalDiagnosisCodes"];
    };
    PatientMedicalDiagnosisCodes: {
      patientMedicalDiagnosisCodes: components["schemas"]["PatientMedicalDiagnosisCode"][];
      /** Format: PatientMedicalDiagnosisCodeId */
      createdId?: PatientMedicalDiagnosisCodeId;
    };
    /**
     * @description Single answer in a batch submission. Same shape as the existing
     * PatientDocumentCreateAnswer, kept independent so the batch type can
     * evolve without disturbing the per-answer flow.
     */
    MobileOfflineAnswerItem: {
      questionId: number;
      answer: components["schemas"]["PatientDocumentAnswer"];
      chartRow?: number;
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      createdAt?: Instant;
      vitalExtraDetails?: components["schemas"]["VitalExtraDetails"];
    };
    MobileOfflineMedicalDiagnosisCodeRow: {
      id: components["schemas"]["ICD10CodeId"];
      display: string;
      dxCode: string;
      formattedDxCode: string;
      shortDesc: string;
      longDesc: string;
    };
    MobileOfflineMedicationRow: {
      id: string;
      display: string;
      doses: string[];
    };
    MobileOfflineMedicationBatchItem:
      | components["schemas"]["MobileOfflineCreateMedicationItem"]
      | components["schemas"]["MobileOfflineUpdateMedicationItem"]
      | components["schemas"]["MobileOfflineRemoveMedicationItem"]
      | components["schemas"]["MobileOfflineSetNotTakingMedicationsItem"];
    MobileOfflineCreateMedicationItem: {
      /** @enum {string} */
      type: "create";
      patientId: components["schemas"]["PatientId"];
      body: components["schemas"]["NurseCreatesPatientMedicationRequest"];
    };
    NurseCreatesPatientMedicationRequest: {
      name: string;
      dosage: string;
      frequency: null | string;
      administrationNotes: null | string;
      /** Format: PatientTaskInstanceId */
      taskInstanceId?: PatientTaskInstanceId;
      diagnosisCodes?: {
        code: string;
        type: components["schemas"]["DiagnosisCodeType"];
      }[];
    };
    MobileOfflineUpdateMedicationItem: {
      /** @enum {string} */
      type: "update";
      patientId: components["schemas"]["PatientId"];
      medicationId: components["schemas"]["PatientMedicationId"];
      body: components["schemas"]["NurseUpdatesPatientMedicationRequest"];
    };
    NurseUpdatesPatientMedicationRequest: {
      name: string;
      dosage: string;
      frequency: null | string;
      administrationNotes: null | string;
    };
    MobileOfflineRemoveMedicationItem: {
      /** @enum {string} */
      type: "remove";
      patientId: components["schemas"]["PatientId"];
      medicationId: components["schemas"]["PatientMedicationId"];
      deleteDiagnosisCodes: boolean;
    };
    MobileOfflineSetNotTakingMedicationsItem: {
      /** @enum {string} */
      type: "set_not_taking_medications";
      patientId: components["schemas"]["PatientId"];
      notTakingMedications: boolean;
    };
    MobileOfflineMedicalDiagnosisCodeBatchItem:
      | components["schemas"]["MobileOfflineAttachMedicalDiagnosisCodeItem"]
      | components["schemas"]["MobileOfflineDetachMedicalDiagnosisCodeItem"];
    MobileOfflineAttachMedicalDiagnosisCodeItem: {
      /** @enum {string} */
      type: "attach";
      params: components["schemas"]["PatientMedicalDiagnosisCodeCreateParams"];
    };
    PatientMedicalDiagnosisCodeCreateParams: {
      patientId: components["schemas"]["PatientId"];
      icdCode: components["schemas"]["ICD10CodeId"];
      /** @enum {string} */
      designation: "OTHER" | "PRIMARY";
      source?: null | string;
    };
    MobileOfflineDetachMedicalDiagnosisCodeItem: {
      /** @enum {string} */
      type: "detach";
      patientMedicalDiagnosisCodeId: components["schemas"]["PatientMedicalDiagnosisCodeId"];
    };
    PatientTaskScheduleOverride: {
      id: components["schemas"]["PatientTaskInstanceScheduleOverrideId"];
      patientId: components["schemas"]["PatientId"];
      taskId: components["schemas"]["PatientTaskId"];
      originalVisitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      newVisitInstanceId: components["schemas"]["VisitInstanceId"] | null;
      timeSlots: {
        day: components["schemas"]["LocalDate"];
        timeSlots: {
          from: components["schemas"]["LocalTime"];
          to: components["schemas"]["LocalTime"];
        }[];
      }[];
      createdAt: components["schemas"]["Instant"];
      createdBy: components["schemas"]["UserId"];
      isAgencyInitialTimeSlots: boolean;
    };
    /** Format: PatientTaskInstanceScheduleOverrideId */
    PatientTaskInstanceScheduleOverrideId: PatientTaskInstanceScheduleOverrideId;
    /** @enum {string} */
    PatientGender: "F" | "M";
    RnPlatformWebsiteSubmissionTask:
      | ({
          /** @enum {string} */
          type: "START_OF_CARE";
        } & {
          certificationPeriod: {
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
          } | null;
          serviceType: null | string;
          payerSource: null | string;
          frequency: null | string;
          agencyNote: null | string;
        })
      | ({
          /** @enum {string} */
          type: "REASSESSMENT";
          startOfCareDate: components["schemas"]["LocalDate"] | null;
        } & {
          certificationPeriod: {
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
          } | null;
          serviceType: null | string;
          payerSource: null | string;
          frequency: null | string;
          agencyNote: null | string;
        })
      | ({
          /** @enum {string} */
          type: "SUPERVISORY";
        } & {
          certificationPeriod: {
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
          } | null;
          serviceType: null | string;
          payerSource: null | string;
          frequency: null | string;
          agencyNote: null | string;
        });
    /** @enum {string} */
    RnPlatformWebsiteTaskStatus:
      | "Cancelled"
      | "Completed"
      | "In Progress"
      | "Needs Attention";
    /** @enum {string} */
    PatientTaskTemplateType: "REASSESSMENT" | "START_OF_CARE" | "SUPERVISORY";
    RnPlatformDuplicateAssessmentInfo: {
      patientName: string;
      taskType: components["schemas"]["PatientTaskTemplateType"];
      taskDate: components["schemas"]["LocalDate"] | null;
      taskId: components["schemas"]["PatientTaskId"];
    };
    RnPlatformWebsitePatientTask:
      | {
          /** @enum {string} */
          status: "Completed" | "In Progress";
          reviewStatus: ("Approved" | "Pending RN changes" | "Resolved") | null;
          documents: {
            type:
              | {
                  /** @enum {string} */
                  kind: "document";
                  id: components["schemas"]["PatientDocumentTypeId"];
                  title: string;
                }
              | {
                  /** @enum {string} */
                  kind: "uploaded";
                  title: string;
                };
            /** @enum {string} */
            status:
              | "Approved"
              | "Completed"
              | "Pending Rn Changes"
              | "Sent to Physician"
              | "Signed";
            submittedAt: components["schemas"]["Instant"] | null;
            approvedAt: components["schemas"]["Instant"] | null;
            url: null | string;
            id: components["schemas"]["PatientDocumentScheduleId"];
            resubmissions: {
              reason: string;
              updatedAt: components["schemas"]["Instant"] | null;
              createdByName: null | string;
              resolvedAt: components["schemas"]["Instant"] | null;
            }[];
            submissionPolicy:
              | {
                  /** @enum {boolean} */
                  allowed: true;
                }
              | {
                  /** @enum {boolean} */
                  allowed: false;
                  message: string;
                };
          }[];
          id: components["schemas"]["PatientTaskId"];
          type: components["schemas"]["PatientTaskTemplateType"];
          scheduledDateTime: components["schemas"]["LocalDateTime"] | null;
          certificationPeriod: {
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
          } | null;
          serviceType: null | string;
          payerSource: null | string;
          frequency: null | string;
          agencyNote: null | string;
          isPatientConfirmed: boolean;
          canEditPatientSchedule: boolean;
        }
      | {
          /** @enum {string} */
          status: "Cancelled" | "Needs Attention";
          id: components["schemas"]["PatientTaskId"];
          type: components["schemas"]["PatientTaskTemplateType"];
          scheduledDateTime: components["schemas"]["LocalDateTime"] | null;
          certificationPeriod: {
            startDate: components["schemas"]["LocalDate"];
            endDate: components["schemas"]["LocalDate"];
          } | null;
          serviceType: null | string;
          payerSource: null | string;
          frequency: null | string;
          taskIssues: components["schemas"]["DisplayTaskIssue"][];
          agencyNote: null | string;
          isPatientConfirmed: boolean;
          canEditPatientSchedule: boolean;
        };
    RnPlatformWebsiteEditPatientParams: {
      firstName?: string;
      middleName?: null | string;
      lastName?: string;
      /** @enum {string} */
      gender?: "F" | "M";
      /** Format: yyyy-MM-dd */
      dateOfBirth?: LocalDate;
      mainLanguage?: string;
      address?: components["schemas"]["AddressComponents"];
      address2?: null | string;
      addressInstructions?: null | string;
      phoneNumbers?: {
        number: string;
        isPrimary: boolean;
        label: string;
        type: ("home" | "mobile") | null;
        kind: string;
      }[];
      startOfCareDate?: components["schemas"]["LocalDate"] | null;
      schedule?: {
        assessmentStartDate: components["schemas"]["LocalDate"];
        assessmentDueDate: components["schemas"]["LocalDate"];
        scheduleFreeText: null | string;
      } | null;
      diagnosisCodes?: {
        id: components["schemas"]["PatientContractDiagnosisCodeId"];
        icdId: components["schemas"]["ICD10CodeId"];
        type: ("PRINCIPAL" | "SURGICAL") | null;
        startDate: components["schemas"]["LocalDate"] | null;
        endDate: components["schemas"]["LocalDate"] | null;
      }[];
      uploadedDocuments?: components["schemas"]["RnPlatformWebsiteUploadedDocumentEdit"][];
    };
    RnPlatformWebsiteUploadedDocumentEdit:
      | {
          title: string;
          /** @description S3 key (not full URL) - obtained from the upload URL endpoint */
          s3Key: string;
        }
      | {
          id: components["schemas"]["PatientDocumentScheduleId"];
          title: string;
        };
    RnPlatformWebsiteEditTaskParams: {
      certificationPeriod?: {
        /** Format: yyyy-MM-dd */
        startDate?: LocalDate;
        /** Format: yyyy-MM-dd */
        endDate?: LocalDate;
      };
      serviceType?: string;
      payerSource?: string;
      frequency?: string;
      agencyNote?: string;
    };
    RnPlatformWebsiteEditCaregiverParams: {
      name: string;
      phoneNumber: string;
      isAbleToTranslate?: boolean;
    };
    RnPlatformWebsiteChangeRequest:
      | {
          /** @enum {string} */
          status: "pending";
          id: components["schemas"]["PatientTaskDocumentChangeRequestId"];
          request: string;
          createdAt: components["schemas"]["Instant"];
        }
      | {
          /** @enum {string} */
          status: "resolved";
          id: components["schemas"]["PatientTaskDocumentChangeRequestId"];
          request: string;
          response: null | string;
          createdAt: components["schemas"]["Instant"];
          resolvedAt: components["schemas"]["Instant"];
        };
    RnPlatformContract: {
      contractId: components["schemas"]["RnPlatformContractId"];
      contractName: string;
      exampleUrl: string;
      agencyContractId:
        | components["schemas"]["RnPlatformAgencyContractId"]
        | null;
      signedAt: components["schemas"]["Instant"] | null;
    };
    /** Format: RnPlatformContractId */
    RnPlatformContractId: RnPlatformContractId;
    /** Format: RnPlatformAgencyContractId */
    RnPlatformAgencyContractId: RnPlatformAgencyContractId;
    RnPlatformAgencyDetails: {
      agencyName: string;
      npiNumber: null | string;
      agencyAddressComponents:
        | components["schemas"]["AddressComponents"]
        | null;
      agencyLogoUrl: null | string;
      agencyPhoneNumber: null | string;
    };
    /** @description * @TJS-format RNPlatformEmailTypeId */
    RNPlatformEmailTypeId: number;
    RnPlatformCreditOrderOption: {
      id: components["schemas"]["TaskCreditOrderOptionId"];
      amountCredit: number;
      priceCents: number;
    };
    /** Format: TaskCreditOrderOptionId */
    TaskCreditOrderOptionId: TaskCreditOrderOptionId;
    RnPlatformCreditOrder: {
      id: components["schemas"]["TaskCreditStripeInvoiceId"];
      credits: number;
      priceCents: number;
      createdAt: components["schemas"]["Instant"];
      /** @enum {string} */
      status: "CANCELLED" | "PAID" | "PLACED";
      paidAt: components["schemas"]["Instant"] | null;
      removedAt: components["schemas"]["Instant"] | null;
      hostedInvoiceUrl: null | string;
      invoicePdfUrl: null | string;
    };
    /** Format: TaskCreditStripeInvoiceId */
    TaskCreditStripeInvoiceId: TaskCreditStripeInvoiceId;
    /** Format: PatientDocumentAIReviewId */
    PatientDocumentAIReviewId: PatientDocumentAIReviewId;
    TaskIssueType: {
      id: components["schemas"]["TaskIssueTypeId"];
      code: components["schemas"]["TaskIssueTypeCode"];
      name: string;
    };
    /** Format: TaskIssueTypeId */
    TaskIssueTypeId: TaskIssueTypeId;
    /** @enum {string} */
    TaskIssueTypeCode:
      | "BOT_CALL_DECLINED_STATUS"
      | "BOT_CALL_NO_SUITABLE_TIME_STATUS"
      | "BOT_CALL_OTHER_STATUS"
      | "COULDNT_SCHEDULE_REQUESTED_TIME"
      | "FAILED_BOT_AGENT_CALL"
      | "HANGING_ACTIVE_TASK"
      | "MAX_FOUR_RESCHEDULING_ATTEMPTS"
      | "MISSING_CICO"
      | "MISSING_NURSE_VISIT_SMS_CONFIRMATION"
      | "OUTSIDE_AGENCY_INITIAL_HOURS"
      | "PATIENT_ASKED_TO_RESCHEDULE"
      | "PATIENT_CALLS_LOW_SATISFACTION"
      | "PATIENT_ISSUES"
      | "PT_NOT_ANSWERING_SYSTEM_CANCELLED_24_HOURS_FIRST_TIME"
      | "PT_NOT_ANSWERING_SYSTEM_CANCELLED_24_HOURS_REPEATEDLY"
      | "PT_NO_ANSWER_5_ATTEMPTS"
      | "PT_REFUSED_VISIT"
      | "PT_RN_LANGUAGE_BARRIER"
      | "RN_CLOCKED_PT_NOT_HOME"
      | "RN_URGENT_ISSUE"
      | "SOC_OVER_72_HOURS"
      | "STALE_TASK_BROADCAST"
      | "TASK_INSTANCE_WITH_A_MISSED_VISIT"
      | "TASK_INSTANCE_WITH_A_MISSED_VISIT_OTHER"
      | "TASK_INSTANCE_WITH_A_MISSED_VISIT_PATIENT_DIDNT_ANSWER"
      | "TASK_INSTANCE_WITH_A_MISSED_VISIT_PATIENT_IS_NOT_HOME"
      | "TASK_INSTANCE_WITH_A_MISSED_VISIT_PATIENT_REFUSED"
      | "TASK_INSTANCE_WITH_A_MISSED_VISIT_WRONG_ADDRESS"
      | "TASK_WITH_MULTIPLE_DELETED_CONFIRMED_VISITS"
      | "UNCLEAR_RN_TO_PATIENT_CALLS"
      | "VISIT_CANCELLED_LAST_24_HOURS_BY_MEMBER"
      | "VISIT_CANCELLED_LAST_24_HOURS_BY_RN"
      | "WRONG_PHONE_NUMBER";
    RnPlatformBulkAssessmentJob: {
      id: components["schemas"]["RnPlatformHhaxBroadcastRequestJobId"];
      createdBy: string;
      createdAt: components["schemas"]["Instant"];
      totalCount: number;
      processedCount: number;
      failedCount: number;
      pendingCount: number;
      isTest?: boolean;
    };
    /** Format: RnPlatformHhaxBroadcastRequestJobId */
    RnPlatformHhaxBroadcastRequestJobId: RnPlatformHhaxBroadcastRequestJobId;
    CreateRnPlatformWebsiteBulkAssessmentQueueJobItem: {
      admissionId: string;
      patientName: string;
      visitDueDate: components["schemas"]["LocalDate"];
      /** @enum {string} */
      taskType?: "REASSESSMENT" | "START_OF_CARE" | "SUPERVISORY";
    };
    RnPlatformBulkAssessmentJobItem:
      | ({
          id: components["schemas"]["RnPlatformHhaxBroadcastRequestJobItemId"];
          jobId: components["schemas"]["RnPlatformHhaxBroadcastRequestJobId"];
          patientName: string;
          admissionId: string;
          dueDate: components["schemas"]["LocalDate"];
        } & {
          /** @enum {string} */
          status: "Broadcasted" | "Failed" | "Processing" | "Queued";
        })
      | ({
          id: components["schemas"]["RnPlatformHhaxBroadcastRequestJobItemId"];
          jobId: components["schemas"]["RnPlatformHhaxBroadcastRequestJobId"];
          patientName: string;
          admissionId: string;
          dueDate: components["schemas"]["LocalDate"];
        } & {
          /** @enum {string} */
          status: "Failed";
          failureReason: string;
        });
    /** Format: RnPlatformHhaxBroadcastRequestJobItemId */
    RnPlatformHhaxBroadcastRequestJobItemId: RnPlatformHhaxBroadcastRequestJobItemId;
    RnPlatformWebsiteHhaxRegistryPatient: {
      admissionId: string;
      agencyId: components["schemas"]["AgencyId"];
      name: string;
      dateOfBirth: components["schemas"]["LocalDate"];
      status: string;
    };
    SchemaInfo: {
      id: string;
      name: string;
      description: string;
      format: { [key: string]: unknown };
    };
    /** @enum {string} */
    GPTVersion:
      | "gpt-4.1"
      | "gpt-4.1-mini"
      | "gpt-4.1-mini-json"
      | "gpt-4o-json"
      | "gpt-4o-mini"
      | "gpt-4o-mini-json"
      | "gpt-4o-text"
      | "gpt-5"
      | "gpt-5-chat-latest"
      | "gpt-5.1"
      | "gpt-5.1-2025-11-13"
      | "gpt-5.1-chat-latest"
      | "gpt-5.2"
      | "gpt-5.2-2025-12-11"
      | "gpt-5.2-chat-latest"
      | "gpt-5.4-nano-2026-03-17"
      | "gpt-5.6-sol"
      | "o1"
      | "o3";
    AiOmnibarPlanStep: {
      capabilityId: string;
      params: components["schemas"]["AiOmnibarPlanStepParam"][];
      /**
       * @description Words the user used that belong in one of this screen's closed lists, when the plan cannot tell
       * which one.
       *
       * The planner is shown no values at all, so "for europe" may be a contract or an office and there
       * is no way for it to know. Rather than making it guess a field, hedge, or drop the filter, it
       * puts the words here and `searchAiOmnibarValues` decides which field they belong to. A word whose
       * field it *is* confident about goes in `params` instead, which is only a stronger hint - the
       * search covers every field either way.
       */
      searchTerms: string[];
      /** @description One short line to show the user while this step runs. */
      narration: string;
    };
    AiOmnibarPlanStepParam: {
      name: string;
      /** @description Always sent as a string; the browser coerces it using the param's declared type. */
      value: string;
    };
    AiOmnibarCapability: {
      id: string;
      title: string;
      /** @description Whether this moves the user somewhere or fills something in. Nothing else is allowed. */
      effect: components["schemas"]["AiOmnibarCapabilityEffect"];
      /** @description What the component can do. */
      description: string;
      /** @description Where this lives in the app, e.g. "inside the patient profile modal". */
      location: string;
      /**
       * @description True while the owning component is mounted, so the capability can be invoked right
       * now. False for capabilities that only become reachable after another one runs.
       */
      isAvailableNow: boolean;
      /**
       * @description Capability ids that make this one reachable; running any one of them is enough.
       *
       * The browser works this out from scopes - a capability says which space it lives in, a host
       * says which spaces it opens - so neither side has to name the other. Empty means it is
       * reachable from anywhere.
       */
      reachableAfter: string[];
      params: components["schemas"]["AiOmnibarCapabilityParam"][];
      /** @description Example phrasings the owning component expects to be asked with. */
      examples: string[];
      /**
       * @description True for a capability that should only be used when the user asked for it by name, or when
       * nothing else on offer can answer them - building a report from scratch, say.
       *
       * The prompt says as much, but the server also drops such a step from any plan that already does
       * something real, so "last resort" is a property of the plan rather than a hope about the model.
       */
      isLastResort: boolean;
    };
    /**
     * @description The only two things a capability may do. There is no third option on purpose: the omnibar moves
     * the user around and fills things in, and never changes stored state - the user still commits the
     * work from the screen it opened. The browser refuses to register anything else, and refuses
     * mutating requests while a capability runs.
     * @enum {string}
     */
    AiOmnibarCapabilityEffect: "navigate" | "prefill";
    AiOmnibarCapabilityParam: {
      name: string;
      type: components["schemas"]["AiOmnibarParamType"];
      required: boolean;
      /** @description What this field means, in the words of the component that consumes it. */
      description: string;
      /**
       * @description Always null on the planning call, and only carried here because the value search reuses this
       * type for the lists it is given.
       *
       * Planning never sees a value. The lists are agency data - every contract, every service code,
       * seventy sidebar destinations - they made up a third of the prompt, they were re-sent whether
       * or not the request was about them, and for anything page-specific they do not exist until that
       * page is open. Planning gets `optionCount` and the user's own words; `searchAiOmnibarValues`
       * turns those words into values afterwards, against the lists the open screen really has.
       */
      options: components["schemas"]["AiOmnibarCapabilityParamOption"][] | null;
      /**
       * @description How many allowed values exist, when the list itself was withheld. Null when `options` is
       * populated, or when the param is not a closed set. The model needs to know a param is a closed
       * list even when it cannot see the list, or it invents free text for a field that has none.
       */
      optionCount: null | number;
    };
    /**
     * @description The AI omnibar (the "AI" mode of the global search bar) sends the server a manifest of
     * what the *currently loaded* UI can do. Every entry in that manifest is written by the
     * component that performs the action, not by this module - the server only frames it into
     * a system prompt and asks the model which capabilities to invoke.
     * @enum {string}
     */
    AiOmnibarParamType:
      | "boolean"
      | "caregiverRef"
      | "date"
      | "enum"
      | "invoiceRef"
      | "number"
      | "patientRef"
      | "text"
      | "time";
    AiOmnibarCapabilityParamOption: {
      /** @description The exact value the model must pass back. */
      value: string;
      /** @description How a person would refer to this option, e.g. "Patients > Patients list". */
      label: string;
    };
    AiOmnibarContext: {
      /** @description ui-router state the user is looking at, e.g. "app.patients.dashboard". */
      currentPage: null | string;
      /** @description Human readable description of what is already open, e.g. "Patient modal: Jane Doe (id 2)". */
      openEntities: string[];
      /** @description The user's today, as ISO yyyy-MM-dd, so the model can resolve "tomorrow". */
      today: string;
    };
    AiOmnibarMessage: {
      /** @enum {string} */
      role: "assistant" | "user";
      text: string;
    };
    AiOmnibarValueSearchMatch: {
      /** @description The term this answers, copied from the request. */
      requested: string;
      /**
       * @description The field it belongs to, and the value that field will accept. Both null when no field on the
       * screen offers anything like it - never a value that was not listed, and never a field that was
       * not sent.
       */
      param: null | string;
      value: null | string;
      label: null | string;
    };
    AiOmnibarValueSearchTerm: {
      /** @description What the plan asked for, in the user's words: "france", "europe", "unpaid". */
      requested: string;
      /**
       * @description The field the plan guessed this belongs to, or null when it did not say. Only a hint - the
       * search is over every field, because a planner that cannot see the values often cannot tell
       * whether "europe" is a contract or an office.
       */
      preferredParam: null | string;
    };
    /**
     * @description A field on the open screen and the values it will accept, as the value search sees it.
     *
     * The lists travel from the browser: they belong to components mounted there, and half of them are
     * contributed by other components at runtime.
     */
    AiOmnibarValueSearchField: {
      param: string;
      /** @description What this field means, from the component that consumes it - the same text planning saw. */
      description: string;
      options: components["schemas"]["AiOmnibarCapabilityParamOption"][];
    };
    AiOmnibarReportColumnChoice: {
      tableName: string;
      name: string;
      /**
       * @description An aggregate to apply, or null to leave the column as it is - which also makes it one of the
       * columns the result is grouped by.
       */
      aggregate?: null | string;
    };
    /**
     * @description A filter on the report, and what it should be set to if the request said.
     *
     * The values are optional on purpose. A filter the person still has to fill in is useful - it is the
     * report offering the right dials - but when the request already says "in the last three months" or
     * "for the Europe office", leaving it blank makes them type what they just asked for.
     */
    AiOmnibarReportFilterChoice: {
      tableName: string;
      name: string;
      /** @description One of that column's own operators, or null to add the filter and leave it unset. */
      operator?: null | string;
      /**
       * @description What to compare against: a yyyy-MM-dd date, a number, or text. Null for the relative operators,
       * which carry `interval` and `timePeriod` instead, and for "IS NULL".
       */
      value?: null | string;
      /**
       * @description For "LAST N X" and its relatives: how many, and of what - 3 and "month" for the last three
       * months. `timePeriod` alone is what "LAST X" and "THIS X" take.
       */
      interval?: null | number;
      timePeriod?: null | string;
    };
    AiOmnibarReportTable: {
      tableName: string;
      /** @description How a person refers to the table, e.g. "Patient Cost Share Invoices". */
      label: string;
      /**
       * @description What this table is, in a sentence, written by the page rather than derived from its name.
       *
       * Column names alone leave a model guessing at what a row means - whether an amount is a total or
       * one instalment, whether a date is when something was due or when it happened. Null when nobody
       * has written one, in which case the prompt falls back to the grain worked out from the
       * identifiers.
       */
      description: null | string;
      columns: components["schemas"]["AiOmnibarReportColumn"][];
      /**
       * @description The columns this view can be joined on - its own key and the keys it carries.
       *
       * Two views can be combined only where their identifiers overlap, which is the report engine's
       * own rule (`getJoinIdentifiers` in ReportsCore).
       */
      identifiers: string[];
      /**
       * @description The identifiers that are unique per row. A join is one-to-one only when these are all part of
       * the overlap; otherwise each row on the left meets many on the right and the rows multiply.
       */
      uniqueIdentifiers: string[];
    };
    /**
     * @description One column of one table, as the report tool describes it to the model.
     *
     * Deliberately thin: a name, how it reads and what type it is. The tool's schema carries more
     * (paths, ranges, nullability, the aggregates each type allows) and none of it helps decide *which*
     * columns answer a question.
     */
    AiOmnibarReportColumn: {
      name: string;
      label: string;
      /** @description NUMBER, TEXT, DATE and so on, as the report schema names them. */
      type: string;
      array: boolean;
    };
    /**
     * @description What a column of one type can be aggregated by and filtered with.
     *
     * Sent once per type rather than on every column: the rules depend only on the type, and a member with
     * every report entity has six hundred columns - repeating both lists on each one was most of the
     * request. Both come from the report schema itself, the same lists the tool's own Aggregate and
     * operator dropdowns are built from.
     */
    AiOmnibarReportTypeRules: {
      /** @description The column type, with "[]" appended when it is an array. */
      type: string;
      /**
       * @description What makes "per patient" or "by month" expressible: the engine emits a GROUP BY over every
       * column that has *no* aggregate as soon as one column has one.
       */
      aggregates: string[];
      /**
       * @description "=", ">=", "ILIKE", and for dates the relative ones like "LAST N X" that express "the last
       * three months".
       */
      operators: string[];
    };
    /** @description Block item for API responses */
    RNPerformanceBlockItem: {
      id: number;
      caregiverId: components["schemas"]["CaregiverId"];
      agencyId: components["schemas"]["AgencyId"];
      blockLevel: number;
      blockedAt: components["schemas"]["Instant"];
      blockedUntil: components["schemas"]["Instant"];
      evaluatedVisitCount: number;
      completedVisitsCount: number;
      cancelledVisitsCount: number;
      lateCancelledVisitsCount: number;
      cancellationRate: number;
      lateCancellationRate: number;
      createdAt: components["schemas"]["Instant"];
      unblockedAt: components["schemas"]["Instant"] | null;
      unblockedReason: ("expired" | "manual") | null;
      manualUnblockNote: null | string;
      isActive: boolean;
    };
    /** @description POC item with code information for API responses */
    RnPlatformPocItemWithCode: {
      id: string;
      label: string;
      section: string;
      defaultCode: string;
      agencyCode: null | string;
    };
    /**
     * @description A single patient pin on the "RN scheduling map" tab of the care and task
     * management screen. Every entry is a patient whose current certification
     * period ends inside the requested date range.
     *
     * `location` is null for patients whose address was never geocoded - those
     * patients cannot be placed on the map, but are still returned so that the
     * coordinator knows they exist.
     */
    RnSchedulingMapPatient: {
      patientId: components["schemas"]["PatientId"];
      displayId: null | number;
      firstName: string;
      middleName: null | string;
      lastName: string;
      status: components["schemas"]["PatientStatus"];
      address: null | string;
      location: components["schemas"]["Geo"] | null;
      phoneNumber: null | string;
      officeId: components["schemas"]["OfficeId"];
      officeName: string;
      /** @description The county of the patient's address (an NYC borough is a county), null when unknown. */
      countyName: null | string;
      contractTypeIds: components["schemas"]["ContractTypeId"][];
      contractTypeNames: string[];
      certificationPeriodId: components["schemas"]["CertificationPeriodId"];
      certificationPeriodType: components["schemas"]["CertificationPeriodType"];
      certificationPeriodStartDate: components["schemas"]["LocalDate"];
      certificationPeriodEndDate: components["schemas"]["LocalDate"];
      schedulingStatus: components["schemas"]["RnSchedulingStatus"];
      /** @description When the soonest future scheduled visit is, null when nothing is scheduled. */
      scheduledVisitDateTime: components["schemas"]["Instant"] | null;
      /** @description The caregiver assigned to that soonest future scheduled visit. */
      scheduledVisitCaregiverName: null | string;
      /** @description When the RN clocked in to the visit for the upcoming period, null when there is none. */
      completedVisitDateTime: components["schemas"]["Instant"] | null;
      /** @description The caregiver who clocked in and out of that visit. */
      completedVisitCaregiverName: null | string;
      assignedRnId: components["schemas"]["CaregiverId"] | null;
      assignedRnName: null | string;
    };
    /** @enum {string} */
    RnSchedulingStatus:
      | "REQUIRE_SCHEDULING"
      | "RN_SCHEDULED"
      | "VISIT_COMPLETED";
    TaskChatUpdatedEventPayload: {
      taskId: components["schemas"]["PatientTaskId"];
    };
    AgencyMemberWasMentionedSocketEventPayload: {
      mentionId: components["schemas"]["AgencyMemberNotesMentionId"];
      noteId: components["schemas"]["NoteId"];
      mentioningAgencyMemberName: string;
      createdAt: components["schemas"]["Instant"];
      seenAt: components["schemas"]["Instant"] | null;
    };
    /** Format: AgencyMemberNotesMentionId */
    AgencyMemberNotesMentionId: AgencyMemberNotesMentionId;
    CaregiversUpdatedEventPayload: {
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverData: components["schemas"]["Caregiver"];
    };
    CaregiverUpdatedEventPayload: {
      caregiverId: components["schemas"]["CaregiverId"];
      caregiverData: components["schemas"]["CaregiverMobile"];
    };
    CaregiverMobile: {
      agenciesCaregiverCertifications: components["schemas"]["AgencyCaregiverCertifications"][];
      agenciesCaregiverHireDates: components["schemas"]["AgencyCaregiverHireDate"][];
      isPendingRegistration: boolean;
      isCaregiverOfMedFlyt: boolean;
      shouldInitLogRocket: boolean;
      shouldShowMyAgencies: boolean;
      shouldShowCaregiverRating: boolean;
      shouldShowNewChat: boolean;
      shouldShowVirtualIdCard: boolean;
      shouldShowComplianceBanner: boolean;
      canChatWithOtherAgencies: boolean;
      shouldShowMyMedflyCompliance: boolean;
      shouldShowMyStaffingPreferences: boolean;
      shouldShowCareMoments: boolean;
      shouldShowRaffle: boolean;
      rnLicenseNumber: null | string;
      shouldShowMainV2Screen: boolean;
      isInstapayVisible: boolean;
      isInstapayAvailable: boolean;
      showContractorPayment: boolean;
      points: number;
      raffle: {
        shiftsPerToken: number;
        shiftsToNextToken: number;
        tokens: number;
        prize: string;
        daysLeft: number;
        progressPercentage: number;
      } | null;
      id: components["schemas"]["CaregiverId"];
      status: components["schemas"]["CaregiverStatus"];
      caregiverCode: null | string;
      officeIds: components["schemas"]["OfficeId"][];
      officeNames?: string[];
      branchIds: components["schemas"]["AgencyBranchId"][];
      branchNames?: string[];
      caregiverBranch?: null | string;
      workAreaPreference?: null | string;
      createdAt: components["schemas"]["Instant"];
      /** Format: date-time */
      birthDate: null | string;
      birthDateDate: components["schemas"]["LocalDate"] | null;
      phoneNumber: string;
      phoneNumbers: components["schemas"]["CaregiverPhoneNumber"][];
      homePhone: null | string;
      firstName: string;
      middleName: null | string;
      lastName: string;
      /** @description "M", "F" */
      gender: string;
      /** @description Each element must be one of 'Caregiver.ALL_LANGUAGES' */
      languages: string[];
      address: string;
      address2: null | string;
      isCustomAddress: boolean;
      addressCounty: null | string;
      addressGeoLocation: components["schemas"]["Geo"];
      addressComponents?: components["schemas"]["AddressComponents"] | null;
      missingAddressFields?: string[];
      certifications: components["schemas"]["CaregiverCertification"][];
      certificationNames?: string[];
      agencyAssocCreatedByAgencyMemberName?: null | string;
      agencyAssocCreatedByCaregiverName?: null | string;
      photoUrl: null | string;
      photoUrlOriginal: null | string;
      installedUserAgent: null | string;
      appInstalledDate: components["schemas"]["Instant"] | null;
      appInstalled: boolean;
      appInstalledAt: components["schemas"]["Instant"][];
      appUninstalledAt: components["schemas"]["Instant"][];
      /** @description Is the caregiver's app currently open */
      online: boolean;
      /** @description When was the last time the caregiver was online? */
      lastSeen: components["schemas"]["Instant"] | null;
      notificationSettings?: components["schemas"]["NotificationSettings"];
      email: null | string;
      isFullTime: boolean;
      hireDate: components["schemas"]["LocalDate"] | null;
      rehireDate: components["schemas"]["LocalDate"] | null;
      terminationDate: components["schemas"]["LocalDate"] | null;
      isCompliant: boolean;
      stateRegistryNum: null | number;
      isClockEnabled: boolean;
      ssn: null | string;
      applicationStartDate: components["schemas"]["LocalDate"] | null;
      lastWorkDate: components["schemas"]["LocalDate"] | null;
      firstWorkDate: components["schemas"]["LocalDate"] | null;
      displayId: null | number;
      externalId: null | string;
      customFields: components["schemas"]["EntityCustomField"];
      blacklisted: components["schemas"]["PatientId"][] | null;
      emergencyContacts: components["schemas"]["CaregiverEmergencyContact"][];
      nextStatus?:
        | (
            | "ACTIVE"
            | "JOIN_REQUEST"
            | "ON_HOLD"
            | "ON_LEAVE"
            | "PENDING"
            | "QUIT"
            | "REJECTED"
            | "SUSPENDED"
            | "TERMINATED"
          )
        | null;
      nextStatusEffectiveDate?: components["schemas"]["LocalDate"] | null;
      isFromLandingPage: boolean;
      mainLanguage: string;
      glovesSize?: ("L" | "M" | "S" | "XL") | null;
      scrubsSize?: ("L" | "M" | "S" | "XL" | "XXL") | null;
      agencyIds?: components["schemas"]["AgencyId"][];
    };
    AgencyCaregiverCertifications: {
      agencyId: components["schemas"]["AgencyId"];
      agencyName: string;
      certifications: components["schemas"]["CaregiverCertification"][];
      isOnboardingAgency: boolean;
    };
    AgencyCaregiverHireDate: {
      agencyId: components["schemas"]["AgencyId"];
      agencyName: string;
      hireDate: components["schemas"]["LocalDate"] | null;
    };
    ChatRoomUpdatedEventPayload: {
      chatRoomId: components["schemas"]["ChatRoomId"];
      chatRoomData: components["schemas"]["ChatRoom"];
    };
    ClusterUpdatedEventPayload: {
      cluster: components["schemas"]["AgencyCluster"];
    };
    AgencyCluster: {
      id: components["schemas"]["ClusterId"];
      visit1: components["schemas"]["VisitInCluster"];
      visit2: components["schemas"]["VisitInCluster"];
      engagements: components["schemas"]["CaregiverClusterEngagementForAgency"][];
      isRelevant: boolean;
    };
    /** Format: ClusterId */
    ClusterId: ClusterId;
    VisitInCluster: {
      id: components["schemas"]["VisitBroadcastId"];
      patientName: string;
      startTime: components["schemas"]["LocalDateTime"];
      endTime: components["schemas"]["LocalDateTime"];
      isSingleVisit: boolean;
      dayTimeParams: components["schemas"]["VisitDayTimeParams"] | null;
      address: string;
      geo: components["schemas"]["Geo"];
      assignedCoordinators: components["schemas"]["AgencyMemberId"][];
    };
    CaregiverClusterEngagementForAgency: {
      id: components["schemas"]["CaregiverClusterEngagementId"];
      createdAt: components["schemas"]["Instant"];
      caregiver: components["schemas"]["CaregiverId"];
      viewedAt: components["schemas"]["Instant"] | null;
      moreDetailsViewedAt: components["schemas"]["Instant"] | null;
      requestedAt: components["schemas"]["Instant"] | null;
      notInterestedAt: components["schemas"]["Instant"] | null;
      notInterestedReason: null | string;
    };
    /** Format: CaregiverClusterEngagementId */
    CaregiverClusterEngagementId: CaregiverClusterEngagementId;
    NotificationsUpdatedEventPayload: {
      pushNotificationInfos: components["schemas"]["PushNotificationInfo"][];
    };
    PushNotificationInfo: {
      id: components["schemas"]["CaregiverNotificationId"];
      pushNotification: components["schemas"]["NotificationData"];
      createdAt: components["schemas"]["Instant"];
      viewed: boolean;
      clicked: boolean;
      notificationText: string;
    };
    /** Format: CaregiverNotificationId */
    CaregiverNotificationId: CaregiverNotificationId;
    NotificationData:
      | components["schemas"]["NotificationData.CaregiverStatusChanged"]
      | components["schemas"]["NotificationData.AgencyMemberChatMessage"]
      | components["schemas"]["NotificationData.VisitChatMessage"]
      | components["schemas"]["NotificationData.VisitStartingSoonReminder"]
      | components["schemas"]["NotificationData.VisitNotification"]
      | components["schemas"]["NotificationData.PatientChatMessage"]
      | components["schemas"]["NotificationData.VisitInstanceNotification"]
      | components["schemas"]["NotificationData.VisitAssignmentNotification"]
      | components["schemas"]["NotificationData.VisitCancelNotification"]
      | components["schemas"]["NotificationData.ClusterNotification"]
      | components["schemas"]["NotificationData.AvailabilityAnomalyNotification"]
      | components["schemas"]["NotificationData.OrientationVideoReminderNotification"]
      | components["schemas"]["NotificationData.ComplianceProblemNotification"]
      | components["schemas"]["NotificationData.VisitAwaitingPatientContact"]
      | components["schemas"]["NotificationData.CaregiverGotRecruited"]
      | components["schemas"]["NotificationData.RecruitmentApplicationReminder"]
      | components["schemas"]["NotificationData.CaregiverMissingDocumentReminder"]
      | components["schemas"]["NotificationData.PatientDocumentUnsubmittedRemainder"]
      | components["schemas"]["NotificationData.Covid19TrainingReminder"]
      | components["schemas"]["NotificationData.Covid19ScreeningReminder"]
      | components["schemas"]["NotificationData.Covid19VisitScreeningReminder"]
      | components["schemas"]["NotificationData.CaregiverPassportDocumentVerificationStatusChanged"]
      | components["schemas"]["NotificationData.ConvertImportedVisitRequestResult"]
      | components["schemas"]["NotificationData.PatientTaskNotification"]
      | components["schemas"]["NotificationData.CaregiverInactiveFor3Weeks"]
      | components["schemas"]["NotificationData.FormsAwaitingSubmissionTask"]
      | components["schemas"]["NotificationData.TaskWasntScheduled"]
      | components["schemas"]["NotificationData.MissedClockIn"]
      | components["schemas"]["NotificationData.MissedClockOut"]
      | components["schemas"]["NotificationData.FormsAwaitingSubmissionVisit"]
      | components["schemas"]["NotificationData.ExpiredComplianceItem"]
      | components["schemas"]["NotificationData.AboutToExpireComplianceItem"]
      | components["schemas"]["NotificationData.CaregiverVisitNotSeen"]
      | components["schemas"]["NotificationData.PatientOnVacation"]
      | components["schemas"]["NotificationData.DutySheetSubmissionReminder"]
      | components["schemas"]["NotificationData.OnboardingReminder"]
      | components["schemas"]["NotificationData.NewOnboardingVisits"]
      | components["schemas"]["NotificationData.OnboardingDocumentNotification"]
      | components["schemas"]["NotificationData.CommCenterTicketMessage"]
      | components["schemas"]["NotificationData.OnboardingCaregiverEngagements"]
      | components["schemas"]["NotificationData.OnboardingCaregiverEngagements2"]
      | components["schemas"]["NotificationData.GeneralVisitAssignmentNotification"]
      | components["schemas"]["NotificationData.InstaPayFailureNotification"]
      | components["schemas"]["NotificationData.VisitBroadcastStoppedByAgencyMember"]
      | components["schemas"]["NotificationData.FlexibleVisitBroadcastDetailsChanged"]
      | components["schemas"]["NotificationData.CareMomentsCaregiverRankAdjusted"]
      | components["schemas"]["NotificationData.RaffleEngagement"]
      | components["schemas"]["NotificationData.PatientTaskDocumentRejected"];
    "NotificationData.CaregiverStatusChanged": {
      /** @enum {string} */
      type: "CAREGIVER_STATUS_CHANGED";
      agencyId: components["schemas"]["AgencyId"];
    };
    "NotificationData.AgencyMemberChatMessage": {
      /** @enum {string} */
      type: "AGENCY_MEMBER_CHAT_MESSAGE";
      chatRoomId: components["schemas"]["ChatRoomId"];
    };
    "NotificationData.VisitChatMessage": {
      /** @enum {string} */
      type: "VISIT_CHAT_MESSAGE";
      visitId: components["schemas"]["VisitBroadcastId"];
    };
    "NotificationData.VisitStartingSoonReminder": {
      /** @enum {string} */
      type: "VISIT_STARTING_SOON_REMINDER";
      visitId: components["schemas"]["VisitBroadcastId"];
    };
    "NotificationData.VisitNotification": {
      /** @enum {string} */
      type: "VISIT_NOTIFICATION";
      visitId: components["schemas"]["VisitBroadcastId"];
      /** Format: yyyy-MM-ddTHH:mm:ss.SSSZ */
      date?: Instant;
    };
    "NotificationData.PatientChatMessage": {
      /** @enum {string} */
      type: "PATIENT_CHAT_MESSAGE";
      chatRoomId: components["schemas"]["ChatRoomId"];
      patientId: components["schemas"]["PatientId"];
    };
    "NotificationData.VisitInstanceNotification": {
      /** @enum {string} */
      type: "VISIT_INSTANCE_NOTIFICATION";
      visitInstanceId: components["schemas"]["VisitInstanceId"];
    };
    "NotificationData.VisitAssignmentNotification": {
      /** @enum {string} */
      type: "VISIT_ASSIGNMENT_NOTIFICATION";
      visitId: components["schemas"]["VisitBroadcastId"];
    };
    "NotificationData.VisitCancelNotification": {
      /** @enum {string} */
      type: "VISIT_CANCEL_NOTIFICATION";
    };
    "NotificationData.ClusterNotification": {
      /** @enum {string} */
      type: "NEW_CLUSTER_NOTIFICATION";
      clusterId: components["schemas"]["ClusterId"];
    };
    "NotificationData.AvailabilityAnomalyNotification": {
      /** @enum {string} */
      type: "AVAILABILITY_ANOMALY_NOTIFICATION";
      agencyId: components["schemas"]["AgencyId"];
    };
    "NotificationData.OrientationVideoReminderNotification": {
      /** @enum {string} */
      type: "ORIENTATION_VIDEO_REMINDER_NOTIFICATION";
      agencyId: components["schemas"]["AgencyId"];
    };
    "NotificationData.ComplianceProblemNotification": {
      /** @enum {string} */
      type: "COMPLIANCE_PROBLEM_NOTIFICATION";
      agencyId: components["schemas"]["AgencyId"];
      complianceItem: components["schemas"]["CaregiverDocumentTypeId"];
    };
    "NotificationData.VisitAwaitingPatientContact": {
      /** @enum {string} */
      type: "VISIT_AWAITING_PATIENT_CONTACT";
      visitId: components["schemas"]["VisitBroadcastId"];
    };
    "NotificationData.CaregiverGotRecruited": {
      /** @enum {string} */
      type: "CAREGIVER_GOT_RECRUITED";
      agencyId: components["schemas"]["AgencyId"];
    };
    "NotificationData.RecruitmentApplicationReminder": {
      /** @enum {string} */
      type: "RECRUITMENT_APPLICATION_REMINDER_NOTIFICATION";
    };
    "NotificationData.CaregiverMissingDocumentReminder": {
      /** @enum {string} */
      type: "CAREGIVER_MISSING_DOCUMENTS_REMINDER";
      scheduledVisitId: components["schemas"]["VisitInstanceId"];
    };
    "NotificationData.PatientDocumentUnsubmittedRemainder": {
      /** @enum {string} */
      type: "PATIENT_DOCUMENT_UNSUBMITTED_REMINDER_NOTIFICATION";
    };
    "NotificationData.Covid19TrainingReminder": {
      /** @enum {string} */
      type: "COVID_19_TRAINING_REMINDER";
    };
    "NotificationData.Covid19ScreeningReminder": {
      /** @enum {string} */
      type: "COVID_19_SCREENING_REMINDER";
    };
    "NotificationData.Covid19VisitScreeningReminder": {
      /** @enum {string} */
      type: "COVID_19_VISIT_SCREENING_REMINDER";
    };
    "NotificationData.CaregiverPassportDocumentVerificationStatusChanged": {
      /** @enum {string} */
      type: "CAREGIVER_PASSPORT_DOCUMENT_VERIFICATION_STATUS_CHANGED";
    };
    "NotificationData.ConvertImportedVisitRequestResult": {
      /** @enum {string} */
      type: "CONVERT_IMPORTED_VISIT_REQUEST_RESULT";
      success: boolean;
      possiblePatients: components["schemas"]["PatientId"][];
      multipleCandidates: boolean;
      noImportedVisit: boolean;
      noCaregiver: boolean;
      agencyId: components["schemas"]["AgencyId"] | null;
    };
    "NotificationData.PatientTaskNotification": {
      /** @enum {string} */
      type: "PATIENT_TASK_NOTIFICATION";
      patientTaskInstanceId: components["schemas"]["PatientTaskInstanceId"];
    };
    "NotificationData.CaregiverInactiveFor3Weeks": {
      /** @enum {string} */
      type: "CAREGIVER_INACTIVE_FOR_3_WEEKS";
    };
    "NotificationData.FormsAwaitingSubmissionTask": {
      /** @enum {string} */
      type: "FORMS_AWAITING_SUBMISSION_TASK";
    };
    "NotificationData.TaskWasntScheduled": {
      /** @enum {string} */
      type: "TASK_WASNT_SCHEDULED";
    };
    "NotificationData.MissedClockIn": {
      /** @enum {string} */
      type: "MISSED_CLOCK_IN";
    };
    "NotificationData.MissedClockOut": {
      /** @enum {string} */
      type: "MISSED_CLOCK_OUT";
    };
    "NotificationData.FormsAwaitingSubmissionVisit": {
      /** @enum {string} */
      type: "FORMS_AWAITING_SUBMISSION_VISIT";
    };
    "NotificationData.ExpiredComplianceItem": {
      /** @enum {string} */
      type: "EXPIRED_COMPLIANCE_ITEM";
    };
    "NotificationData.AboutToExpireComplianceItem": {
      /** @enum {string} */
      type: "ABOUT_TO_EXPIRE_COMPLIANCE_ITEM";
    };
    "NotificationData.CaregiverVisitNotSeen": {
      /** @enum {string} */
      type: "CAREGIVER_VISIT_NOT_SEEN";
    };
    "NotificationData.PatientOnVacation": {
      /** @enum {string} */
      type: "PATIENT_ON_VACATION";
    };
    "NotificationData.DutySheetSubmissionReminder": {
      /** @enum {string} */
      type: "DUTY_SHEET_SUBMISSION_REMINDER";
    };
    "NotificationData.OnboardingReminder": {
      /** @enum {string} */
      type: "ONBOARDING_REMINDER";
    };
    "NotificationData.NewOnboardingVisits": {
      /** @enum {string} */
      type: "NEW_ONBOARDING_VISITS";
    };
    "NotificationData.OnboardingDocumentNotification": {
      /** @enum {string} */
      type: "ONBOARDING_DOCUMENT_NOTIFICATION";
    };
    "NotificationData.CommCenterTicketMessage": {
      /** @enum {string} */
      type: "COMM_CENTER_TICKET_MESSAGE";
      ticketId: components["schemas"]["CommCenterTicketId"];
    };
    "NotificationData.OnboardingCaregiverEngagements": {
      /** @enum {string} */
      type: "ONBOARDING_CAREGIVER_ENGAGEMENTS";
    };
    "NotificationData.OnboardingCaregiverEngagements2": {
      /** @enum {string} */
      type: "ONBOARDING_CAREGIVER_ENGAGEMENTS2";
      payload:
        | {
            /** @enum {string} */
            type: "ACTIVE_NOT_REQUESTED_CASES";
          }
        | {
            /** @enum {string} */
            type: "DID_NOT_COMPLETE_I9_SECTION";
            sectionId: components["schemas"]["HRSectionId"];
            subsectionId: components["schemas"]["HRSubSectionId"];
          }
        | {
            /** @enum {string} */
            type: "DOCUMENTS_APPROVED_MISSING_ORIENTATION";
            bundleDueDateId: components["schemas"]["TrainingCenterBundleDueDateId"];
          }
        | {
            /** @enum {string} */
            type: "DOCUMENTS_PENDING_MISSING_ORIENTATION";
            bundleDueDateId: components["schemas"]["TrainingCenterBundleDueDateId"];
          }
        | {
            /** @enum {string} */
            type: "FILE_APPROVED_MISSING_QUESTIONS";
          }
        | {
            /** @enum {string} */
            type: "FIRST_REQUESTED_CASE_RECURRING";
          }
        | {
            /** @enum {string} */
            type: "FIRST_REQUESTED_CASE_SCHEDULED";
          }
        | {
            /** @enum {string} */
            type: "HAS_MEDICALS_UPLOADED_NONE";
            sectionId: components["schemas"]["HRSectionId"];
            subsectionId: components["schemas"]["HRSubSectionId"];
            questionId: components["schemas"]["HRQuestionId"];
          }
        | {
            /** @enum {string} */
            type: "ITEM_IS_REJECTED";
            sectionId: components["schemas"]["HRSectionId"];
            subsectionId: components["schemas"]["HRSubSectionId"];
            questionId: components["schemas"]["HRQuestionId"];
          }
        | {
            /** @enum {string} */
            type: "PROFILE_CREATED_APP_NOT_INSTALLED";
          }
        | {
            /** @enum {string} */
            type: "PROFILE_CREATED_HAS_ANSWERS_NO_DOCS";
          }
        | {
            /** @enum {string} */
            type: "PROFILE_CREATED_HAS_ANSWERS_SOME_DOCS";
          }
        | {
            /** @enum {string} */
            type: "PROFILE_CREATED_NO_ANSWERS_AND_DOCS";
          }
        | {
            /** @enum {string} */
            type: "NO_PAYLOAD";
          }
        | {
            /** @enum {string} */
            type: "FIRST_REQUESTED_CASE_ACCEPTED_BY_AGENCY";
            visitInstanceId: components["schemas"]["VisitInstanceId"];
          }
        | {
            /** @enum {string} */
            type: "DID_NOT_COMPLETE_ONBOARDING2_SCHEDULED";
          }
        | {
            /** @enum {string} */
            type: "DID_NOT_COMPLETE_ONBOARDING2_RECURRING";
          };
    };
    "NotificationData.GeneralVisitAssignmentNotification": {
      /** @enum {string} */
      type: "GENERAL_VISIT_ASSIGNMENT_NOTIFICATION";
    };
    "NotificationData.InstaPayFailureNotification": {
      /** @enum {string} */
      type: "INSTA_PAY_FAILURE_NOTIFICATION";
    };
    "NotificationData.VisitBroadcastStoppedByAgencyMember": {
      /** @enum {string} */
      type: "VISIT_BROADCAST_STOPPED_BY_AGENCY_MEMBER";
    };
    "NotificationData.FlexibleVisitBroadcastDetailsChanged": {
      /** @enum {string} */
      type: "FLEXIBLE_VISIT_BROADCAST_DETAILS_CHANGED";
      visitId: components["schemas"]["VisitBroadcastId"];
    };
    "NotificationData.CareMomentsCaregiverRankAdjusted": {
      /** @enum {string} */
      type: "CARE_MOMENTS_CAREGIVER_RANK_ADJUSTED";
      payload: components["schemas"]["CareMomentsCaregiverRankAdjustedPayload"];
    };
    CareMomentsCaregiverRankAdjustedPayload: {
      adjustment: {
        id: components["schemas"]["CareMomentsAdjustmentId"];
      };
    };
    /** Format: CareMomentsAdjustmentId */
    CareMomentsAdjustmentId: CareMomentsAdjustmentId;
    "NotificationData.RaffleEngagement": {
      /** @enum {string} */
      type: "RAFFLE_ENGAGEMENT";
    };
    "NotificationData.PatientTaskDocumentRejected": {
      /** @enum {string} */
      type: "PATIENT_TASK_DOCUMENT_REJECTED";
      documentName: string;
      taskInstanceId: components["schemas"]["PatientTaskInstanceId"];
      documentTypeId: components["schemas"]["PatientDocumentTypeId"];
      patientId: components["schemas"]["PatientId"];
    };
    PatientUpdatedEventPayload: {
      PatientId: components["schemas"]["PatientId"];
      patient: components["schemas"]["Patient"];
    };
    ScoreChangedEventPayload: {
      agencyMemberId: components["schemas"]["AgencyMemberId"];
    };
    VisitUpdatedEventPayload: {
      visitId: components["schemas"]["VisitBroadcastId"];
      assignedCoordinators?: components["schemas"]["AgencyMemberId"][];
      visitData?: components["schemas"]["CoordinatorVisitDetails"] | null;
    };
    VisitAssignmentAssigneeUpdatedEventPayload: {
      assignmentId: components["schemas"]["VisitAssignmentId"];
      assignee: {
        id: components["schemas"]["AgencyMemberId"];
        firstName: string;
        lastName: string;
        photoUrl: null | string;
      } | null;
    };
    TelephonyInboundCallRingingEventPayload: {
      call: components["schemas"]["TelephonyInboundCallInfo"];
    };
    TelephonyInboundCallAnsweredEventPayload: {
      call: components["schemas"]["TelephonyInboundCallInfo"];
      by: {
        id: components["schemas"]["AgencyMemberId"];
        firstName: string;
        lastName: string;
        photoUrl: null | string;
      };
    };
    TelephonyOutboundCallAnsweredEventPayload: {
      call: components["schemas"]["TelephonyOutboundCallInfo"];
      by: {
        id: components["schemas"]["AgencyMemberId"];
        firstName: string;
        lastName: string;
        photoUrl: null | string;
      };
    };
    TelephonyOutboundCallInitiatedEventPayload: {
      call: components["schemas"]["TelephonyOutboundCallInfo"];
    };
    TelephonyCallEndedEventPayload:
      | components["schemas"]["TelephonyCallEndedWithSuccessEventPayload"]
      | components["schemas"]["TelephonyCallEndedWithFailureEventPayload"];
    TelephonyCallEndedWithSuccessEventPayload: {
      call: components["schemas"]["TelephonyCallInfo"];
      result: components["schemas"]["TelephonyFinalCallResult"];
      shouldAskForManualCallResult: boolean;
      shouldAskToManuallyEnterNextCallDate: boolean;
    };
    /** @enum {string} */
    TelephonyFinalCallResult:
      | "Canceled"
      | "Completed"
      | "Missed"
      | "MovedToSMS"
      | "NoAnswer"
      | "VoiceMail";
    TelephonyCallEndedWithFailureEventPayload: {
      call: components["schemas"]["TelephonyCallInfo"];
      /** @enum {string} */
      result: "Failed";
      reason: components["schemas"]["TelephonyCallFailedReason"];
      message: string;
    };
    /** @enum {string} */
    TelephonyCallFailedReason:
      | "CALL_PROCESSED_RETROACTIVELY"
      | "CALL_REJECTED"
      | "INTERNAL"
      | "LOSE_RACE"
      | "MARKED_AS_FAILED_BY_STALE_WORKER"
      | "NORMAL_TEMPORARY_FAILURE"
      | "NO_ANSWER"
      | "NO_USER_RESPONSE"
      | "RECOVERY_ON_TIMER_EXPIRE"
      | "SERVICE_UNAVAILABLE"
      | "SUBSCRIBER_ABSENT"
      | "UNALLOCATED_NUMBER"
      | "UNKNOWN"
      | "UNSPECIFIED"
      | "USER_BUSY"
      | "USER_NOT_REGISTERED";
    TelephonyCallConnectedEventPayload: {
      call: components["schemas"]["TelephonyCallInfo"];
    };
    TelephonyOutboundCallStartedEventPayload: {
      call: components["schemas"]["TelephonyOutboundCallInfo"];
    };
    TelephonyCallParticipantCreatedEventPayload: {
      call: components["schemas"]["TelephonyCallInfo"];
      participant: {
        id: components["schemas"]["TelephonyCallParticipantId"];
        role: components["schemas"]["TelephonyCallParticipantEntity"];
        source: string;
        status: components["schemas"]["TelephonyCallParticipantStatus"];
      };
    };
    TelephonyCallParticipantUpdatedEventPayload: {
      call: components["schemas"]["TelephonyCallInfo"];
      participant: {
        id: components["schemas"]["TelephonyCallParticipantId"];
        role?:
          | {
              /** @enum {string} */
              type: "AgencyMember";
              id: components["schemas"]["AgencyMemberId"];
            }
          | {
              /** @enum {string} */
              type: "Caregiver";
              id: components["schemas"]["CaregiverId"];
            }
          | {
              /** @enum {string} */
              type: "Patient";
              id: components["schemas"]["PatientId"];
            }
          | {
              /** @enum {string} */
              type: "PatientContact";
              id: components["schemas"]["PatientContactId"];
              patientId: components["schemas"]["PatientId"];
            }
          | {
              /** @enum {string} */
              type: "PhonebookContact";
              id: components["schemas"]["AgencyPhonebookContactId"];
              contactType: components["schemas"]["PhonebookContactType"];
            }
          | {
              /** @enum {string} */
              type: "NotIdentified";
              id: components["schemas"]["CallSessionNotIdentifiedCallerCalleeId"];
              kind: components["schemas"]["TelephonyNotIdentifiedKind"];
            }
          | {
              /** @enum {string} */
              type: "BotAgent";
              id: components["schemas"]["TelephonyBotAgentId"];
            };
        source?: string;
        /** @enum {string} */
        status?:
          | "Answered"
          | "BargedIn"
          | "Declined"
          | "EavesDropped"
          | "Hungup"
          | "Initiated"
          | "Invited"
          | "Joined"
          | "Left"
          | "Removed";
      };
    };
    TelephonyConferenceInvitationReceivedEventPayload: {
      invitation: components["schemas"]["TelephonyInvitationOfCallInfo"];
    };
    TelephonyInvitationOfCallInfo: {
      call: components["schemas"]["TelephonyCallInfo"];
      inviter: {
        id: components["schemas"]["TelephonyCallParticipantId"];
        entity: components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"];
        source: string;
      };
      invitee: {
        id: components["schemas"]["TelephonyCallParticipantId"];
        entity: components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"];
        source: string;
      };
    };
    TelephonyConferenceInvitationFailedPayload: {
      inviter: components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"];
      invitee:
        | components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"]
        | {
            /** @enum {string} */
            type: "PhoneNumber";
            phoneNumber: string;
          };
      call: components["schemas"]["TelephonyCallInfo"];
    };
    TelephonyPortalCallRequested: {
      call: components["schemas"]["TelephonyPortalRequestCallInfo"];
    };
    TelephonyPortalRequestCallInfo: {
      /** @enum {string} */
      direction: "PortalCallRequest";
      id: components["schemas"]["TelephonyCallId"];
      requester: {
        entity:
          | components["schemas"]["TelephonyCallPatientParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallPatientContactParticipantEntityInfo"];
        phoneNumber: string;
      };
      purpose: components["schemas"]["PortalCallPurpose"];
      ringingTo: components["schemas"]["TelephonyAgencyMemberRingingTo"][];
    };
    /** @enum {string} */
    PortalCallPurpose:
      | "MedicaidChoicePatient"
      | "NYIAFamilyMember"
      | "NYIAPatient"
      | "RequestAssistance"
      | "SwitchAgencies";
    TelephonyParallelCallStartedEventPayload: {
      call: components["schemas"]["TelephonyParallelCallInfo"];
      createdAt: components["schemas"]["Instant"];
    };
    TelephonyParallelCallRingingEventPayload: {
      call: components["schemas"]["TelephonyParallelCallInfo"];
      createdAt: components["schemas"]["Instant"];
    };
    TelephonyParallelCallAnsweredEventPayload: {
      call: components["schemas"]["TelephonyParallelCallInfo"];
      answeredAt: components["schemas"]["Instant"];
    };
    TelephonyParallelCallCalleeClassifiedEventPayload: {
      call: components["schemas"]["TelephonyParallelCallInfo"];
      classification: components["schemas"]["ParallelCallCalleeClassification"];
      classifiedAt: components["schemas"]["Instant"];
    };
    ParallelCallCalleeClassification:
      | {
          /** @enum {string} */
          type: "Unknown";
          /** @enum {string} */
          reason: "NoTemplates" | "Timeout";
        }
      | {
          /** @enum {string} */
          type: "VoiceMail";
          score: number;
        }
      | {
          /** @enum {string} */
          type: "Human";
        };
    TelephonyParallelCallTranscribedEventPayload: {
      callId: components["schemas"]["TelephonyCallId"];
      transcription: string;
      createdAt: components["schemas"]["Instant"];
    };
    TelephonyAnyAgencyMemberInvitedEventPayload: {
      call:
        | components["schemas"]["TelephonyInboundCallInfo"]
        | components["schemas"]["TelephonyOutboundCallInfo"];
      inviter: {
        id: components["schemas"]["TelephonyCallParticipantId"];
        entity:
          | components["schemas"]["TelephonyCallAgencyMemberParticipantEntityInfo"]
          | components["schemas"]["TelephonyCallBotAgentParticipantEntityInfo"];
        source: string;
      };
      invitees: components["schemas"]["AgencyMemberId"][];
    };
    TelephonyConferenceAnsweredEventPayload: {
      call: components["schemas"]["TelephonyCallInfo"];
      by: components["schemas"]["TelephonyCallParticipantInfo"];
      /** @enum {string} */
      source: "AnyAgencyMemberInvitation" | "BargeIn" | "Invite";
    };
    CommCenterTypingEventPayload: {
      ticketId: components["schemas"]["CommCenterTicketId"];
      millis: number;
    };
    CommCenterTicketUpdatedEventPayload: {
      ticketId: components["schemas"]["CommCenterTicketId"];
    };
    CommCenterRedirectEventPayload:
      | {
          /** @enum {string} */
          type: "ComplianceItem";
          documentTypeId: components["schemas"]["CaregiverDocumentTypeId"];
        }
      | {
          /** @enum {string} */
          type: "AvailableTaskScreen";
          taskBroadcastId: components["schemas"]["PatientTaskInstanceId"];
        }
      | {
          /** @enum {string} */
          type: "MyMedflytCompliance";
        };
    CommCenterChatRoomRedirectEventPayload: {
      /** @enum {string} */
      type: "ChatRoom";
      ticketId: components["schemas"]["CommCenterTicketId"];
    };
    CommCenterAgencyMemberNotificationSocketPayload: {
      ticketId: components["schemas"]["CommCenterTicketId"];
      messageTitle: string;
      messageContent?: string;
    };
    OnboardingStageUpdatedPayload: {
      id: components["schemas"]["HRSectionStageId"];
    };
    PortalPatientProfileUpdatePayload: {
      patientId: components["schemas"]["PatientId"];
      messageTitle: string;
      messageContent?: string;
    };
    PortalPatientDocumentUploadPayload: {
      patientId: components["schemas"]["PatientId"];
      messageTitle: string;
      messageContent?: string;
    };
    PatientIntackeChecklistChangedPayload: {
      patientIds: components["schemas"]["PatientId"][];
    };
    OutboundSMSSentSuccessfully: {
      messageId: components["schemas"]["CommCenterMessageId"];
      ticketId: components["schemas"]["CommCenterTicketId"];
      messageText: string;
    };
    OutboundSMSFailed: {
      messageId: components["schemas"]["CommCenterMessageId"];
      ticketId: components["schemas"]["CommCenterTicketId"];
      messageText: string;
      error: string;
    };
    AuthorizationFileDiagnosisCodeFetched: {
      /** @enum {string} */
      type: "AuthorizationFileDiagnosisCodeFetched";
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      authorizationFileId: components["schemas"]["PatientAuthorizationFileId"];
      authorizationId: components["schemas"]["AuthorizationId"];
      authorizationStartDate: components["schemas"]["LocalDate"];
      authorizationEndDate: components["schemas"]["LocalDate"];
      patientContractName: string;
      patientContractId: components["schemas"]["PatientContractId"];
      diagnosisCodes: {
        id: components["schemas"]["ICD10CodeId"];
        code: string;
        formattedCode: string;
        description: string;
      }[];
    };
    BroadcastVisitPostedEventPayload: {
      visitBroadcastId: components["schemas"]["VisitBroadcastId"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientGender: ("F" | "M") | null;
      patientAddress: string;
      patientAddress2: null | string;
      patientAddressInstructions: null | string;
      patientAddressComponents: components["schemas"]["AddressComponents"];
      startTimeUTC: components["schemas"]["Instant"];
      endTimeUTC: components["schemas"]["Instant"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      timezone: string;
      certifications: components["schemas"]["CaregiverCertification"][];
      languages: string[];
      visitLabels: components["schemas"]["VisitLabelText"][];
      requiredCaregiverGender: ("F" | "M") | null;
      price: null | number;
      paymentType: components["schemas"]["VisitBatchPaymentType"];
      hideEndDateFromCaregiver: null | boolean;
    };
    CaregiverAssignedToVisitEventPayload: {
      visitBroadcastId: components["schemas"]["VisitBroadcastId"];
      caregiverId: components["schemas"]["CaregiverId"];
      visitInstanceIds: components["schemas"]["VisitInstanceId"][];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      patientAddress: string;
      patientAddress2: null | string;
      patientAddressComponents: components["schemas"]["AddressComponents"];
      startTimeUTC: components["schemas"]["Instant"];
      endTimeUTC: components["schemas"]["Instant"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      timezone: string;
    };
    BroadcastVisitCancellationConfirmedEventPayload: {
      visitBroadcastId: components["schemas"]["VisitBroadcastId"];
      caregiverId: components["schemas"]["CaregiverId"];
      patientId: components["schemas"]["PatientId"];
      patientName: string;
      startTimeUTC: components["schemas"]["Instant"];
    };
    VisitInstanceDeletedEventPayload: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      visitBroadcastId: components["schemas"]["VisitBroadcastId"] | null;
      agencyId: components["schemas"]["AgencyId"];
      patientId: components["schemas"]["PatientId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
      startTimeUTC: components["schemas"]["Instant"];
      endTimeUTC: components["schemas"]["Instant"];
      startTimeLocal: components["schemas"]["LocalDateTime"];
      endTimeLocal: components["schemas"]["LocalDateTime"];
      timezone: string;
    };
    VisitUnmissedEventPayload: {
      visitInstanceId: components["schemas"]["VisitInstanceId"];
      caregiverId: components["schemas"]["CaregiverId"] | null;
    };
  };
}

export interface operations {}

export interface external {}
